/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

export const rates = {
  'ffun:10:5000:1': 34.33,
  'ffun:10:5000:2': 34.33,
  'ffun:10:5000:3': 34.33,
  'ffun:10:5000:4': 34.33,
  'ffun:10:5000:5': 34.33,
  'ffun:10:5000:6': 34.28,
  'ffun:10:5000:7': 34.28,
  'ffun:10:5000:8': 34.28,
  'ffun:10:5000:9': 34.28,
  'ffun:10:5000:10': 34.28,
  'ffun:10:5000:11': 34.29,
  'ffun:10:5000:12': 34.29,
  'ffun:10:5000:13': 34.29,
  'ffun:10:5000:14': 34.29,
  'ffun:10:5000:15': 34.29,
  'ffun:10:5000:16': 34.32,
  'ffun:10:5000:17': 34.32,
  'ffun:10:5000:18': 34.32,
  'ffun:10:5000:19': 34.32,
  'ffun:10:5000:20': 34.32,
  'ffun:10:5000:21': 34.44,
  'ffun:10:5000:22': 34.44,
  'ffun:10:5000:23': 34.44,
  'ffun:10:5000:24': 34.44,
  'ffun:10:5000:25': 34.44,
  'ffun:10:5000:26': 34.88,
  'ffun:10:5000:27': 34.88,
  'ffun:10:5000:28': 34.88,
  'ffun:10:5000:29': 34.88,
  'ffun:10:5000:30': 34.88,
  'ffun:10:5000:31': 38.14,
  'ffun:10:5000:32': 38.14,
  'ffun:10:5000:33': 38.14,
  'ffun:10:5000:34': 38.14,
  'ffun:10:5000:35': 38.14,
  'ffun:10:5000:36': 41.74,
  'ffun:10:5000:37': 41.74,
  'ffun:10:5000:38': 41.74,
  'ffun:10:5000:39': 41.74,
  'ffun:10:5000:40': 41.74,
  'ffun:10:5000:41': 49.21,
  'ffun:10:5000:42': 49.21,
  'ffun:10:5000:43': 49.21,
  'ffun:10:5000:44': 49.21,
  'ffun:10:5000:45': 49.21,
  'ffun:10:5000:46': 53.28,
  'ffun:10:5000:47': 53.28,
  'ffun:10:5000:48': 53.28,
  'ffun:10:5000:49': 53.28,
  'ffun:10:5000:50': 53.28,
  'ffun:10:5000:51': 69.11,
  'ffun:10:5000:52': 69.11,
  'ffun:10:5000:53': 69.11,
  'ffun:10:5000:54': 69.11,
  'ffun:10:5000:55': 69.11,
  'ffun:10:5000:56': 69.44,
  'ffun:10:5000:57': 69.44,
  'ffun:10:5000:58': 69.44,
  'ffun:10:5000:59': 69.44,
  'ffun:10:5000:60': 69.44,
  'ffun:10:5000:61': 71.38,
  'ffun:10:5000:62': 71.38,
  'ffun:10:5000:63': 71.38,
  'ffun:10:5000:64': 71.38,
  'ffun:10:5000:65': 71.38,
  'ffun:10:5000:66': 81.4,
  'ffun:10:5000:67': 81.4,
  'ffun:10:5000:68': 81.4,
  'ffun:10:5000:69': 81.4,
  'ffun:10:5000:70': 81.4,
  'ffun:10:5000:71': 95.7,
  'ffun:10:5000:72': 95.7,
  'ffun:10:5000:73': 95.7,
  'ffun:10:5000:74': 95.7,
  'ffun:10:5000:75': 95.7,
  'ffun:10:5000:76': 114.4,
  'ffun:10:5000:77': 114.4,
  'ffun:10:5000:78': 114.4,
  'ffun:10:5000:79': 114.4,
  'ffun:10:5000:80': 114.4,
  'ffun:10:5000:81': 166.84,
  'ffun:10:5000:82': 166.84,
  'ffun:10:5000:83': 166.84,
  'ffun:10:5000:84': 166.84,
  'ffun:10:5000:85': 166.84,
  'ffun:10:5000:86': 206.25,
  'ffun:10:5000:87': 206.25,
  'ffun:10:5000:88': 206.25,
  'ffun:10:5000:89': 206.25,
  'ffun:10:5000:90': 206.25,
  'ffun:10:5000:91': 257.49,
  'ffun:10:5000:92': 257.49,
  'ffun:10:5000:93': 257.49,
  'ffun:10:5000:94': 257.49,
  'ffun:10:5000:95': 257.49,
  'ffun:10:5000:96': 385.96,
  'ffun:10:5000:97': 385.96,
  'ffun:10:5000:98': 385.96,
  'ffun:10:5000:99': 385.96,
  'ffun:10:5000:100': 385.96,
  'ffun:10:5000:101': 692.49,
  'ffun:10:5000:102': 692.49,
  'ffun:10:5000:103': 692.49,
  'ffun:10:5000:104': 692.49,
  'ffun:10:5000:105': 692.49,
  'ffun:10:5000:106': 892.97,
  'ffun:10:5000:107': 892.97,
  'ffun:10:5000:108': 892.97,
  'ffun:10:5000:109': 892.97,
  'ffun:10:5000:110': 892.97,
  'ffun:10:5000:111': 893.23,
  'ffun:10:5000:112': 893.23,
  'ffun:10:5000:113': 893.23,
  'ffun:10:5000:114': 893.23,
  'ffun:10:5000:115': 893.23,
  'ffun:10:5000:116': 893.23,
  'ffun:10:5000:117': 893.23,
  'ffun:10:5000:118': 893.23,
  'ffun:10:5000:119': 893.23,
  'ffun:10:5000:120': 893.23,
  'ffun:10:7500:1': 35.41,
  'ffun:10:7500:2': 35.41,
  'ffun:10:7500:3': 35.41,
  'ffun:10:7500:4': 35.41,
  'ffun:10:7500:5': 35.41,
  'ffun:10:7500:6': 35.39,
  'ffun:10:7500:7': 35.39,
  'ffun:10:7500:8': 35.39,
  'ffun:10:7500:9': 35.39,
  'ffun:10:7500:10': 35.39,
  'ffun:10:7500:11': 35.39,
  'ffun:10:7500:12': 35.39,
  'ffun:10:7500:13': 35.39,
  'ffun:10:7500:14': 35.39,
  'ffun:10:7500:15': 35.39,
  'ffun:10:7500:16': 35.44,
  'ffun:10:7500:17': 35.44,
  'ffun:10:7500:18': 35.44,
  'ffun:10:7500:19': 35.44,
  'ffun:10:7500:20': 35.44,
  'ffun:10:7500:21': 35.61,
  'ffun:10:7500:22': 35.61,
  'ffun:10:7500:23': 35.61,
  'ffun:10:7500:24': 35.61,
  'ffun:10:7500:25': 35.61,
  'ffun:10:7500:26': 36.28,
  'ffun:10:7500:27': 36.28,
  'ffun:10:7500:28': 36.28,
  'ffun:10:7500:29': 36.28,
  'ffun:10:7500:30': 36.28,
  'ffun:10:7500:31': 39.88,
  'ffun:10:7500:32': 39.88,
  'ffun:10:7500:33': 39.88,
  'ffun:10:7500:34': 39.88,
  'ffun:10:7500:35': 39.88,
  'ffun:10:7500:36': 44.39,
  'ffun:10:7500:37': 44.39,
  'ffun:10:7500:38': 44.39,
  'ffun:10:7500:39': 44.39,
  'ffun:10:7500:40': 44.39,
  'ffun:10:7500:41': 53.76,
  'ffun:10:7500:42': 53.76,
  'ffun:10:7500:43': 53.76,
  'ffun:10:7500:44': 53.76,
  'ffun:10:7500:45': 53.76,
  'ffun:10:7500:46': 60.22,
  'ffun:10:7500:47': 60.22,
  'ffun:10:7500:48': 60.22,
  'ffun:10:7500:49': 60.22,
  'ffun:10:7500:50': 60.22,
  'ffun:10:7500:51': 81.4,
  'ffun:10:7500:52': 81.4,
  'ffun:10:7500:53': 81.4,
  'ffun:10:7500:54': 81.4,
  'ffun:10:7500:55': 81.4,
  'ffun:10:7500:56': 83.63,
  'ffun:10:7500:57': 83.63,
  'ffun:10:7500:58': 83.63,
  'ffun:10:7500:59': 83.63,
  'ffun:10:7500:60': 83.63,
  'ffun:10:7500:61': 88.75,
  'ffun:10:7500:62': 88.75,
  'ffun:10:7500:63': 88.75,
  'ffun:10:7500:64': 88.75,
  'ffun:10:7500:65': 88.75,
  'ffun:10:7500:66': 102.3,
  'ffun:10:7500:67': 102.3,
  'ffun:10:7500:68': 102.3,
  'ffun:10:7500:69': 102.3,
  'ffun:10:7500:70': 102.3,
  'ffun:10:7500:71': 124.3,
  'ffun:10:7500:72': 124.3,
  'ffun:10:7500:73': 124.3,
  'ffun:10:7500:74': 124.3,
  'ffun:10:7500:75': 124.3,
  'ffun:10:7500:76': 151.8,
  'ffun:10:7500:77': 151.8,
  'ffun:10:7500:78': 151.8,
  'ffun:10:7500:79': 151.8,
  'ffun:10:7500:80': 151.8,
  'ffun:10:7500:81': 227.27,
  'ffun:10:7500:82': 227.27,
  'ffun:10:7500:83': 227.27,
  'ffun:10:7500:84': 227.27,
  'ffun:10:7500:85': 227.27,
  'ffun:10:7500:86': 286.39,
  'ffun:10:7500:87': 286.39,
  'ffun:10:7500:88': 286.39,
  'ffun:10:7500:89': 286.39,
  'ffun:10:7500:90': 286.39,
  'ffun:10:7500:91': 363.9,
  'ffun:10:7500:92': 363.9,
  'ffun:10:7500:93': 363.9,
  'ffun:10:7500:94': 363.9,
  'ffun:10:7500:95': 363.9,
  'ffun:10:7500:96': 559.63,
  'ffun:10:7500:97': 559.63,
  'ffun:10:7500:98': 559.63,
  'ffun:10:7500:99': 559.63,
  'ffun:10:7500:100': 559.63,
  'ffun:10:7500:101': 994.83,
  'ffun:10:7500:102': 994.83,
  'ffun:10:7500:103': 994.83,
  'ffun:10:7500:104': 994.83,
  'ffun:10:7500:105': 994.83,
  'ffun:10:7500:106': 1273.34,
  'ffun:10:7500:107': 1273.34,
  'ffun:10:7500:108': 1273.34,
  'ffun:10:7500:109': 1273.34,
  'ffun:10:7500:110': 1273.34,
  'ffun:10:7500:111': 1273.36,
  'ffun:10:7500:112': 1273.36,
  'ffun:10:7500:113': 1273.36,
  'ffun:10:7500:114': 1273.36,
  'ffun:10:7500:115': 1273.36,
  'ffun:10:7500:116': 1273.36,
  'ffun:10:7500:117': 1273.36,
  'ffun:10:7500:118': 1273.36,
  'ffun:10:7500:119': 1273.36,
  'ffun:10:7500:120': 1273.36,
  'ffun:10:10000:1': 36.54,
  'ffun:10:10000:2': 36.54,
  'ffun:10:10000:3': 36.54,
  'ffun:10:10000:4': 36.54,
  'ffun:10:10000:5': 36.54,
  'ffun:10:10000:6': 36.52,
  'ffun:10:10000:7': 36.52,
  'ffun:10:10000:8': 36.52,
  'ffun:10:10000:9': 36.52,
  'ffun:10:10000:10': 36.52,
  'ffun:10:10000:11': 36.53,
  'ffun:10:10000:12': 36.53,
  'ffun:10:10000:13': 36.53,
  'ffun:10:10000:14': 36.53,
  'ffun:10:10000:15': 36.53,
  'ffun:10:10000:16': 36.59,
  'ffun:10:10000:17': 36.59,
  'ffun:10:10000:18': 36.59,
  'ffun:10:10000:19': 36.59,
  'ffun:10:10000:20': 36.59,
  'ffun:10:10000:21': 37,
  'ffun:10:10000:22': 37,
  'ffun:10:10000:23': 37,
  'ffun:10:10000:24': 37,
  'ffun:10:10000:25': 37,
  'ffun:10:10000:26': 38.05,
  'ffun:10:10000:27': 38.05,
  'ffun:10:10000:28': 38.05,
  'ffun:10:10000:29': 38.05,
  'ffun:10:10000:30': 38.05,
  'ffun:10:10000:31': 41.69,
  'ffun:10:10000:32': 41.69,
  'ffun:10:10000:33': 41.69,
  'ffun:10:10000:34': 41.69,
  'ffun:10:10000:35': 41.69,
  'ffun:10:10000:36': 47.1,
  'ffun:10:10000:37': 47.1,
  'ffun:10:10000:38': 47.1,
  'ffun:10:10000:39': 47.1,
  'ffun:10:10000:40': 47.1,
  'ffun:10:10000:41': 58.36,
  'ffun:10:10000:42': 58.36,
  'ffun:10:10000:43': 58.36,
  'ffun:10:10000:44': 58.36,
  'ffun:10:10000:45': 58.36,
  'ffun:10:10000:46': 67.17,
  'ffun:10:10000:47': 67.17,
  'ffun:10:10000:48': 67.17,
  'ffun:10:10000:49': 67.17,
  'ffun:10:10000:50': 67.17,
  'ffun:10:10000:51': 94.6,
  'ffun:10:10000:52': 94.6,
  'ffun:10:10000:53': 94.6,
  'ffun:10:10000:54': 94.6,
  'ffun:10:10000:55': 94.6,
  'ffun:10:10000:56': 98.06,
  'ffun:10:10000:57': 98.06,
  'ffun:10:10000:58': 98.06,
  'ffun:10:10000:59': 98.06,
  'ffun:10:10000:60': 98.06,
  'ffun:10:10000:61': 106.24,
  'ffun:10:10000:62': 106.24,
  'ffun:10:10000:63': 106.24,
  'ffun:10:10000:64': 106.24,
  'ffun:10:10000:65': 106.24,
  'ffun:10:10000:66': 123.2,
  'ffun:10:10000:67': 123.2,
  'ffun:10:10000:68': 123.2,
  'ffun:10:10000:69': 123.2,
  'ffun:10:10000:70': 123.2,
  'ffun:10:10000:71': 152.9,
  'ffun:10:10000:72': 152.9,
  'ffun:10:10000:73': 152.9,
  'ffun:10:10000:74': 152.9,
  'ffun:10:10000:75': 152.9,
  'ffun:10:10000:76': 189.94,
  'ffun:10:10000:77': 189.94,
  'ffun:10:10000:78': 189.94,
  'ffun:10:10000:79': 189.94,
  'ffun:10:10000:80': 189.94,
  'ffun:10:10000:81': 287.7,
  'ffun:10:10000:82': 287.7,
  'ffun:10:10000:83': 287.7,
  'ffun:10:10000:84': 287.7,
  'ffun:10:10000:85': 287.7,
  'ffun:10:10000:86': 365.21,
  'ffun:10:10000:87': 365.21,
  'ffun:10:10000:88': 365.21,
  'ffun:10:10000:89': 365.21,
  'ffun:10:10000:90': 365.21,
  'ffun:10:10000:91': 469,
  'ffun:10:10000:92': 469,
  'ffun:10:10000:93': 469,
  'ffun:10:10000:94': 469,
  'ffun:10:10000:95': 469,
  'ffun:10:10000:96': 733.39,
  'ffun:10:10000:97': 733.39,
  'ffun:10:10000:98': 733.39,
  'ffun:10:10000:99': 733.39,
  'ffun:10:10000:100': 733.39,
  'ffun:10:10000:101': 1298.48,
  'ffun:10:10000:102': 1298.48,
  'ffun:10:10000:103': 1298.48,
  'ffun:10:10000:104': 1298.48,
  'ffun:10:10000:105': 1298.48,
  'ffun:10:10000:106': 1656.58,
  'ffun:10:10000:107': 1656.58,
  'ffun:10:10000:108': 1656.58,
  'ffun:10:10000:109': 1656.58,
  'ffun:10:10000:110': 1656.58,
  'ffun:10:10000:111': 1656.58,
  'ffun:10:10000:112': 1656.58,
  'ffun:10:10000:113': 1656.58,
  'ffun:10:10000:114': 1656.58,
  'ffun:10:10000:115': 1656.58,
  'ffun:10:10000:116': 1656.58,
  'ffun:10:10000:117': 1656.58,
  'ffun:10:10000:118': 1656.58,
  'ffun:10:10000:119': 1656.58,
  'ffun:10:10000:120': 1656.58,
  'ffun:10:15000:1': 38.84,
  'ffun:10:15000:2': 38.84,
  'ffun:10:15000:3': 38.84,
  'ffun:10:15000:4': 38.84,
  'ffun:10:15000:5': 38.84,
  'ffun:10:15000:6': 38.8,
  'ffun:10:15000:7': 38.8,
  'ffun:10:15000:8': 38.8,
  'ffun:10:15000:9': 38.8,
  'ffun:10:15000:10': 38.8,
  'ffun:10:15000:11': 38.82,
  'ffun:10:15000:12': 38.82,
  'ffun:10:15000:13': 38.82,
  'ffun:10:15000:14': 38.82,
  'ffun:10:15000:15': 38.82,
  'ffun:10:15000:16': 38.91,
  'ffun:10:15000:17': 38.91,
  'ffun:10:15000:18': 38.91,
  'ffun:10:15000:19': 38.91,
  'ffun:10:15000:20': 38.91,
  'ffun:10:15000:21': 39.64,
  'ffun:10:15000:22': 39.64,
  'ffun:10:15000:23': 39.64,
  'ffun:10:15000:24': 39.64,
  'ffun:10:15000:25': 39.64,
  'ffun:10:15000:26': 40.71,
  'ffun:10:15000:27': 40.71,
  'ffun:10:15000:28': 40.71,
  'ffun:10:15000:29': 40.71,
  'ffun:10:15000:30': 40.71,
  'ffun:10:15000:31': 45.37,
  'ffun:10:15000:32': 45.37,
  'ffun:10:15000:33': 45.37,
  'ffun:10:15000:34': 45.37,
  'ffun:10:15000:35': 45.37,
  'ffun:10:15000:36': 52.5,
  'ffun:10:15000:37': 52.5,
  'ffun:10:15000:38': 52.5,
  'ffun:10:15000:39': 52.5,
  'ffun:10:15000:40': 52.5,
  'ffun:10:15000:41': 67.51,
  'ffun:10:15000:42': 67.51,
  'ffun:10:15000:43': 67.51,
  'ffun:10:15000:44': 67.51,
  'ffun:10:15000:45': 67.51,
  'ffun:10:15000:46': 81.2,
  'ffun:10:15000:47': 81.2,
  'ffun:10:15000:48': 81.2,
  'ffun:10:15000:49': 81.2,
  'ffun:10:15000:50': 81.2,
  'ffun:10:15000:51': 122.1,
  'ffun:10:15000:52': 122.1,
  'ffun:10:15000:53': 122.1,
  'ffun:10:15000:54': 122.1,
  'ffun:10:15000:55': 122.1,
  'ffun:10:15000:56': 126.84,
  'ffun:10:15000:57': 126.84,
  'ffun:10:15000:58': 126.84,
  'ffun:10:15000:59': 126.84,
  'ffun:10:15000:60': 126.84,
  'ffun:10:15000:61': 141.41,
  'ffun:10:15000:62': 141.41,
  'ffun:10:15000:63': 141.41,
  'ffun:10:15000:64': 141.41,
  'ffun:10:15000:65': 141.41,
  'ffun:10:15000:66': 168.7,
  'ffun:10:15000:67': 168.7,
  'ffun:10:15000:68': 168.7,
  'ffun:10:15000:69': 168.7,
  'ffun:10:15000:70': 168.7,
  'ffun:10:15000:71': 209,
  'ffun:10:15000:72': 209,
  'ffun:10:15000:73': 209,
  'ffun:10:15000:74': 209,
  'ffun:10:15000:75': 209,
  'ffun:10:15000:76': 270.35,
  'ffun:10:15000:77': 270.35,
  'ffun:10:15000:78': 270.35,
  'ffun:10:15000:79': 270.35,
  'ffun:10:15000:80': 270.35,
  'ffun:10:15000:81': 407.25,
  'ffun:10:15000:82': 407.25,
  'ffun:10:15000:83': 407.25,
  'ffun:10:15000:84': 407.25,
  'ffun:10:15000:85': 407.25,
  'ffun:10:15000:86': 525.49,
  'ffun:10:15000:87': 525.49,
  'ffun:10:15000:88': 525.49,
  'ffun:10:15000:89': 525.49,
  'ffun:10:15000:90': 525.49,
  'ffun:10:15000:91': 680.5,
  'ffun:10:15000:92': 680.5,
  'ffun:10:15000:93': 680.5,
  'ffun:10:15000:94': 680.5,
  'ffun:10:15000:95': 680.5,
  'ffun:10:15000:96': 1081.23,
  'ffun:10:15000:97': 1081.23,
  'ffun:10:15000:98': 1081.23,
  'ffun:10:15000:99': 1081.23,
  'ffun:10:15000:100': 1081.23,
  'ffun:10:15000:101': 1901.2,
  'ffun:10:15000:102': 1901.2,
  'ffun:10:15000:103': 1901.2,
  'ffun:10:15000:104': 1901.2,
  'ffun:10:15000:105': 1901.2,
  'ffun:10:15000:106': 2413.55,
  'ffun:10:15000:107': 2413.55,
  'ffun:10:15000:108': 2413.55,
  'ffun:10:15000:109': 2413.55,
  'ffun:10:15000:110': 2413.55,
  'ffun:10:15000:111': 2413.55,
  'ffun:10:15000:112': 2413.55,
  'ffun:10:15000:113': 2413.55,
  'ffun:10:15000:114': 2413.55,
  'ffun:10:15000:115': 2413.55,
  'ffun:10:15000:116': 2413.55,
  'ffun:10:15000:117': 2413.55,
  'ffun:10:15000:118': 2413.55,
  'ffun:10:15000:119': 2413.55,
  'ffun:10:15000:120': 2413.55,
  'ffun:10:20000:1': 41.01,
  'ffun:10:20000:2': 41.01,
  'ffun:10:20000:3': 41.01,
  'ffun:10:20000:4': 41.01,
  'ffun:10:20000:5': 41.01,
  'ffun:10:20000:6': 40.97,
  'ffun:10:20000:7': 40.97,
  'ffun:10:20000:8': 40.97,
  'ffun:10:20000:9': 40.97,
  'ffun:10:20000:10': 40.97,
  'ffun:10:20000:11': 40.98,
  'ffun:10:20000:12': 40.98,
  'ffun:10:20000:13': 40.98,
  'ffun:10:20000:14': 40.98,
  'ffun:10:20000:15': 40.98,
  'ffun:10:20000:16': 41.17,
  'ffun:10:20000:17': 41.17,
  'ffun:10:20000:18': 41.17,
  'ffun:10:20000:19': 41.17,
  'ffun:10:20000:20': 41.17,
  'ffun:10:20000:21': 41.67,
  'ffun:10:20000:22': 41.67,
  'ffun:10:20000:23': 41.67,
  'ffun:10:20000:24': 41.67,
  'ffun:10:20000:25': 41.67,
  'ffun:10:20000:26': 44.25,
  'ffun:10:20000:27': 44.25,
  'ffun:10:20000:28': 44.25,
  'ffun:10:20000:29': 44.25,
  'ffun:10:20000:30': 44.25,
  'ffun:10:20000:31': 49.01,
  'ffun:10:20000:32': 49.01,
  'ffun:10:20000:33': 49.01,
  'ffun:10:20000:34': 49.01,
  'ffun:10:20000:35': 49.01,
  'ffun:10:20000:36': 57.95,
  'ffun:10:20000:37': 57.95,
  'ffun:10:20000:38': 57.95,
  'ffun:10:20000:39': 57.95,
  'ffun:10:20000:40': 57.95,
  'ffun:10:20000:41': 76.81,
  'ffun:10:20000:42': 76.81,
  'ffun:10:20000:43': 76.81,
  'ffun:10:20000:44': 76.81,
  'ffun:10:20000:45': 76.81,
  'ffun:10:20000:46': 96.57,
  'ffun:10:20000:47': 96.57,
  'ffun:10:20000:48': 96.57,
  'ffun:10:20000:49': 96.57,
  'ffun:10:20000:50': 96.57,
  'ffun:10:20000:51': 149.6,
  'ffun:10:20000:52': 149.6,
  'ffun:10:20000:53': 149.6,
  'ffun:10:20000:54': 149.6,
  'ffun:10:20000:55': 149.6,
  'ffun:10:20000:56': 155.37,
  'ffun:10:20000:57': 155.37,
  'ffun:10:20000:58': 155.37,
  'ffun:10:20000:59': 155.37,
  'ffun:10:20000:60': 155.37,
  'ffun:10:20000:61': 176.42,
  'ffun:10:20000:62': 176.42,
  'ffun:10:20000:63': 176.42,
  'ffun:10:20000:64': 176.42,
  'ffun:10:20000:65': 176.42,
  'ffun:10:20000:66': 214.5,
  'ffun:10:20000:67': 214.5,
  'ffun:10:20000:68': 214.5,
  'ffun:10:20000:69': 214.5,
  'ffun:10:20000:70': 214.5,
  'ffun:10:20000:71': 266.97,
  'ffun:10:20000:72': 266.97,
  'ffun:10:20000:73': 266.97,
  'ffun:10:20000:74': 266.97,
  'ffun:10:20000:75': 266.97,
  'ffun:10:20000:76': 350.97,
  'ffun:10:20000:77': 350.97,
  'ffun:10:20000:78': 350.97,
  'ffun:10:20000:79': 350.97,
  'ffun:10:20000:80': 350.97,
  'ffun:10:20000:81': 526.8,
  'ffun:10:20000:82': 526.8,
  'ffun:10:20000:83': 526.8,
  'ffun:10:20000:84': 526.8,
  'ffun:10:20000:85': 526.8,
  'ffun:10:20000:86': 684.44,
  'ffun:10:20000:87': 684.44,
  'ffun:10:20000:88': 684.44,
  'ffun:10:20000:89': 684.44,
  'ffun:10:20000:90': 684.44,
  'ffun:10:20000:91': 890.7,
  'ffun:10:20000:92': 890.7,
  'ffun:10:20000:93': 890.7,
  'ffun:10:20000:94': 890.7,
  'ffun:10:20000:95': 890.7,
  'ffun:10:20000:96': 1428.75,
  'ffun:10:20000:97': 1428.75,
  'ffun:10:20000:98': 1428.75,
  'ffun:10:20000:99': 1428.75,
  'ffun:10:20000:100': 1428.75,
  'ffun:10:20000:101': 2509.58,
  'ffun:10:20000:102': 2509.58,
  'ffun:10:20000:103': 2509.58,
  'ffun:10:20000:104': 2509.58,
  'ffun:10:20000:105': 2509.58,
  'ffun:10:20000:106': 3182.26,
  'ffun:10:20000:107': 3182.26,
  'ffun:10:20000:108': 3182.26,
  'ffun:10:20000:109': 3182.26,
  'ffun:10:20000:110': 3182.26,
  'ffun:10:20000:111': 3182.26,
  'ffun:10:20000:112': 3182.26,
  'ffun:10:20000:113': 3182.26,
  'ffun:10:20000:114': 3182.26,
  'ffun:10:20000:115': 3182.26,
  'ffun:10:20000:116': 3182.26,
  'ffun:10:20000:117': 3182.26,
  'ffun:10:20000:118': 3182.26,
  'ffun:10:20000:119': 3182.26,
  'ffun:10:20000:120': 3182.26,
  'ffun:10:25000:1': 43.28,
  'ffun:10:25000:2': 43.28,
  'ffun:10:25000:3': 43.28,
  'ffun:10:25000:4': 43.28,
  'ffun:10:25000:5': 43.28,
  'ffun:10:25000:6': 43.23,
  'ffun:10:25000:7': 43.23,
  'ffun:10:25000:8': 43.23,
  'ffun:10:25000:9': 43.23,
  'ffun:10:25000:10': 43.23,
  'ffun:10:25000:11': 43.25,
  'ffun:10:25000:12': 43.25,
  'ffun:10:25000:13': 43.25,
  'ffun:10:25000:14': 43.25,
  'ffun:10:25000:15': 43.25,
  'ffun:10:25000:16': 43.42,
  'ffun:10:25000:17': 43.42,
  'ffun:10:25000:18': 43.42,
  'ffun:10:25000:19': 43.42,
  'ffun:10:25000:20': 43.42,
  'ffun:10:25000:21': 44.05,
  'ffun:10:25000:22': 44.05,
  'ffun:10:25000:23': 44.05,
  'ffun:10:25000:24': 44.05,
  'ffun:10:25000:25': 44.05,
  'ffun:10:25000:26': 46.9,
  'ffun:10:25000:27': 46.9,
  'ffun:10:25000:28': 46.9,
  'ffun:10:25000:29': 46.9,
  'ffun:10:25000:30': 46.9,
  'ffun:10:25000:31': 53.33,
  'ffun:10:25000:32': 53.33,
  'ffun:10:25000:33': 53.33,
  'ffun:10:25000:34': 53.33,
  'ffun:10:25000:35': 53.33,
  'ffun:10:25000:36': 63.9,
  'ffun:10:25000:37': 63.9,
  'ffun:10:25000:38': 63.9,
  'ffun:10:25000:39': 63.9,
  'ffun:10:25000:40': 63.9,
  'ffun:10:25000:41': 87.24,
  'ffun:10:25000:42': 87.24,
  'ffun:10:25000:43': 87.24,
  'ffun:10:25000:44': 87.24,
  'ffun:10:25000:45': 87.24,
  'ffun:10:25000:46': 112.36,
  'ffun:10:25000:47': 112.36,
  'ffun:10:25000:48': 112.36,
  'ffun:10:25000:49': 112.36,
  'ffun:10:25000:50': 112.36,
  'ffun:10:25000:51': 177.1,
  'ffun:10:25000:52': 177.1,
  'ffun:10:25000:53': 177.1,
  'ffun:10:25000:54': 177.1,
  'ffun:10:25000:55': 177.1,
  'ffun:10:25000:56': 184.31,
  'ffun:10:25000:57': 184.31,
  'ffun:10:25000:58': 184.31,
  'ffun:10:25000:59': 184.31,
  'ffun:10:25000:60': 184.31,
  'ffun:10:25000:61': 211.5,
  'ffun:10:25000:62': 211.5,
  'ffun:10:25000:63': 211.5,
  'ffun:10:25000:64': 211.5,
  'ffun:10:25000:65': 211.5,
  'ffun:10:25000:66': 259.89,
  'ffun:10:25000:67': 259.89,
  'ffun:10:25000:68': 259.89,
  'ffun:10:25000:69': 259.89,
  'ffun:10:25000:70': 259.89,
  'ffun:10:25000:71': 325.69,
  'ffun:10:25000:72': 325.69,
  'ffun:10:25000:73': 325.69,
  'ffun:10:25000:74': 325.69,
  'ffun:10:25000:75': 325.69,
  'ffun:10:25000:76': 431.28,
  'ffun:10:25000:77': 431.28,
  'ffun:10:25000:78': 431.28,
  'ffun:10:25000:79': 431.28,
  'ffun:10:25000:80': 431.28,
  'ffun:10:25000:81': 647.66,
  'ffun:10:25000:82': 647.66,
  'ffun:10:25000:83': 647.66,
  'ffun:10:25000:84': 647.66,
  'ffun:10:25000:85': 647.66,
  'ffun:10:25000:86': 843.4,
  'ffun:10:25000:87': 843.4,
  'ffun:10:25000:88': 843.4,
  'ffun:10:25000:89': 843.4,
  'ffun:10:25000:90': 843.4,
  'ffun:10:25000:91': 1102.47,
  'ffun:10:25000:92': 1102.47,
  'ffun:10:25000:93': 1102.47,
  'ffun:10:25000:94': 1102.47,
  'ffun:10:25000:95': 1102.47,
  'ffun:10:25000:96': 1776.82,
  'ffun:10:25000:97': 1776.82,
  'ffun:10:25000:98': 1776.82,
  'ffun:10:25000:99': 1776.82,
  'ffun:10:25000:100': 1776.82,
  'ffun:10:25000:101': 3111.72,
  'ffun:10:25000:102': 3111.72,
  'ffun:10:25000:103': 3111.72,
  'ffun:10:25000:104': 3111.72,
  'ffun:10:25000:105': 3111.72,
  'ffun:10:25000:106': 3937.75,
  'ffun:10:25000:107': 3937.75,
  'ffun:10:25000:108': 3937.75,
  'ffun:10:25000:109': 3937.75,
  'ffun:10:25000:110': 3937.75,
  'ffun:10:25000:111': 3937.75,
  'ffun:10:25000:112': 3937.75,
  'ffun:10:25000:113': 3937.75,
  'ffun:10:25000:114': 3937.75,
  'ffun:10:25000:115': 3937.75,
  'ffun:10:25000:116': 3937.75,
  'ffun:10:25000:117': 3937.75,
  'ffun:10:25000:118': 3937.75,
  'ffun:10:25000:119': 3937.75,
  'ffun:10:25000:120': 3937.75,
  'ffun:10:30000:1': 45.56,
  'ffun:10:30000:2': 45.56,
  'ffun:10:30000:3': 45.56,
  'ffun:10:30000:4': 45.56,
  'ffun:10:30000:5': 45.56,
  'ffun:10:30000:6': 45.5,
  'ffun:10:30000:7': 45.5,
  'ffun:10:30000:8': 45.5,
  'ffun:10:30000:9': 45.5,
  'ffun:10:30000:10': 45.5,
  'ffun:10:30000:11': 45.52,
  'ffun:10:30000:12': 45.52,
  'ffun:10:30000:13': 45.52,
  'ffun:10:30000:14': 45.52,
  'ffun:10:30000:15': 45.52,
  'ffun:10:30000:16': 45.72,
  'ffun:10:30000:17': 45.72,
  'ffun:10:30000:18': 45.72,
  'ffun:10:30000:19': 45.72,
  'ffun:10:30000:20': 45.72,
  'ffun:10:30000:21': 46.69,
  'ffun:10:30000:22': 46.69,
  'ffun:10:30000:23': 46.69,
  'ffun:10:30000:24': 46.69,
  'ffun:10:30000:25': 46.69,
  'ffun:10:30000:26': 50.44,
  'ffun:10:30000:27': 50.44,
  'ffun:10:30000:28': 50.44,
  'ffun:10:30000:29': 50.44,
  'ffun:10:30000:30': 50.44,
  'ffun:10:30000:31': 56.89,
  'ffun:10:30000:32': 56.89,
  'ffun:10:30000:33': 56.89,
  'ffun:10:30000:34': 56.89,
  'ffun:10:30000:35': 56.89,
  'ffun:10:30000:36': 71.1,
  'ffun:10:30000:37': 71.1,
  'ffun:10:30000:38': 71.1,
  'ffun:10:30000:39': 71.1,
  'ffun:10:30000:40': 71.1,
  'ffun:10:30000:41': 97.67,
  'ffun:10:30000:42': 97.67,
  'ffun:10:30000:43': 97.67,
  'ffun:10:30000:44': 97.67,
  'ffun:10:30000:45': 97.67,
  'ffun:10:30000:46': 128.14,
  'ffun:10:30000:47': 128.14,
  'ffun:10:30000:48': 128.14,
  'ffun:10:30000:49': 128.14,
  'ffun:10:30000:50': 128.14,
  'ffun:10:30000:51': 204.6,
  'ffun:10:30000:52': 204.6,
  'ffun:10:30000:53': 204.6,
  'ffun:10:30000:54': 204.6,
  'ffun:10:30000:55': 204.6,
  'ffun:10:30000:56': 213.19,
  'ffun:10:30000:57': 213.19,
  'ffun:10:30000:58': 213.19,
  'ffun:10:30000:59': 213.19,
  'ffun:10:30000:60': 213.19,
  'ffun:10:30000:61': 246.75,
  'ffun:10:30000:62': 246.75,
  'ffun:10:30000:63': 246.75,
  'ffun:10:30000:64': 246.75,
  'ffun:10:30000:65': 246.75,
  'ffun:10:30000:66': 305.81,
  'ffun:10:30000:67': 305.81,
  'ffun:10:30000:68': 305.81,
  'ffun:10:30000:69': 305.81,
  'ffun:10:30000:70': 305.81,
  'ffun:10:30000:71': 385.21,
  'ffun:10:30000:72': 385.21,
  'ffun:10:30000:73': 385.21,
  'ffun:10:30000:74': 385.21,
  'ffun:10:30000:75': 385.21,
  'ffun:10:30000:76': 511.77,
  'ffun:10:30000:77': 511.77,
  'ffun:10:30000:78': 511.77,
  'ffun:10:30000:79': 511.77,
  'ffun:10:30000:80': 511.77,
  'ffun:10:30000:81': 767.21,
  'ffun:10:30000:82': 767.21,
  'ffun:10:30000:83': 767.21,
  'ffun:10:30000:84': 767.21,
  'ffun:10:30000:85': 767.21,
  'ffun:10:30000:86': 1002.36,
  'ffun:10:30000:87': 1002.36,
  'ffun:10:30000:88': 1002.36,
  'ffun:10:30000:89': 1002.36,
  'ffun:10:30000:90': 1002.36,
  'ffun:10:30000:91': 1315.71,
  'ffun:10:30000:92': 1315.71,
  'ffun:10:30000:93': 1315.71,
  'ffun:10:30000:94': 1315.71,
  'ffun:10:30000:95': 1315.71,
  'ffun:10:30000:96': 2122.88,
  'ffun:10:30000:97': 2122.88,
  'ffun:10:30000:98': 2122.88,
  'ffun:10:30000:99': 2122.88,
  'ffun:10:30000:100': 2122.88,
  'ffun:10:30000:101': 3718.51,
  'ffun:10:30000:102': 3718.51,
  'ffun:10:30000:103': 3718.51,
  'ffun:10:30000:104': 3718.51,
  'ffun:10:30000:105': 3718.51,
  'ffun:10:30000:106': 4705.18,
  'ffun:10:30000:107': 4705.18,
  'ffun:10:30000:108': 4705.18,
  'ffun:10:30000:109': 4705.18,
  'ffun:10:30000:110': 4705.18,
  'ffun:10:30000:111': 4705.18,
  'ffun:10:30000:112': 4705.18,
  'ffun:10:30000:113': 4705.18,
  'ffun:10:30000:114': 4705.18,
  'ffun:10:30000:115': 4705.18,
  'ffun:10:30000:116': 4705.18,
  'ffun:10:30000:117': 4705.18,
  'ffun:10:30000:118': 4705.18,
  'ffun:10:30000:119': 4705.18,
  'ffun:10:30000:120': 4705.18,
  'ffun:10:40000:1': 50.18,
  'ffun:10:40000:2': 50.18,
  'ffun:10:40000:3': 50.18,
  'ffun:10:40000:4': 50.18,
  'ffun:10:40000:5': 50.18,
  'ffun:10:40000:6': 50.09,
  'ffun:10:40000:7': 50.09,
  'ffun:10:40000:8': 50.09,
  'ffun:10:40000:9': 50.09,
  'ffun:10:40000:10': 50.09,
  'ffun:10:40000:11': 50.13,
  'ffun:10:40000:12': 50.13,
  'ffun:10:40000:13': 50.13,
  'ffun:10:40000:14': 50.13,
  'ffun:10:40000:15': 50.13,
  'ffun:10:40000:16': 50.4,
  'ffun:10:40000:17': 50.4,
  'ffun:10:40000:18': 50.4,
  'ffun:10:40000:19': 50.4,
  'ffun:10:40000:20': 50.4,
  'ffun:10:40000:21': 51.98,
  'ffun:10:40000:22': 51.98,
  'ffun:10:40000:23': 51.98,
  'ffun:10:40000:24': 51.98,
  'ffun:10:40000:25': 51.98,
  'ffun:10:40000:26': 56.63,
  'ffun:10:40000:27': 56.63,
  'ffun:10:40000:28': 56.63,
  'ffun:10:40000:29': 56.63,
  'ffun:10:40000:30': 56.63,
  'ffun:10:40000:31': 65.78,
  'ffun:10:40000:32': 65.78,
  'ffun:10:40000:33': 65.78,
  'ffun:10:40000:34': 65.78,
  'ffun:10:40000:35': 65.78,
  'ffun:10:40000:36': 83.7,
  'ffun:10:40000:37': 83.7,
  'ffun:10:40000:38': 83.7,
  'ffun:10:40000:39': 83.7,
  'ffun:10:40000:40': 83.7,
  'ffun:10:40000:41': 119.48,
  'ffun:10:40000:42': 119.48,
  'ffun:10:40000:43': 119.48,
  'ffun:10:40000:44': 119.48,
  'ffun:10:40000:45': 119.48,
  'ffun:10:40000:46': 159.71,
  'ffun:10:40000:47': 159.71,
  'ffun:10:40000:48': 159.71,
  'ffun:10:40000:49': 159.71,
  'ffun:10:40000:50': 159.71,
  'ffun:10:40000:51': 260.7,
  'ffun:10:40000:52': 260.7,
  'ffun:10:40000:53': 260.7,
  'ffun:10:40000:54': 260.7,
  'ffun:10:40000:55': 260.7,
  'ffun:10:40000:56': 270.8,
  'ffun:10:40000:57': 270.8,
  'ffun:10:40000:58': 270.8,
  'ffun:10:40000:59': 270.8,
  'ffun:10:40000:60': 270.8,
  'ffun:10:40000:61': 317.07,
  'ffun:10:40000:62': 317.07,
  'ffun:10:40000:63': 317.07,
  'ffun:10:40000:64': 317.07,
  'ffun:10:40000:65': 317.07,
  'ffun:10:40000:66': 397.35,
  'ffun:10:40000:67': 397.35,
  'ffun:10:40000:68': 397.35,
  'ffun:10:40000:69': 397.35,
  'ffun:10:40000:70': 397.35,
  'ffun:10:40000:71': 503.79,
  'ffun:10:40000:72': 503.79,
  'ffun:10:40000:73': 503.79,
  'ffun:10:40000:74': 503.79,
  'ffun:10:40000:75': 503.79,
  'ffun:10:40000:76': 673.1,
  'ffun:10:40000:77': 673.1,
  'ffun:10:40000:78': 673.1,
  'ffun:10:40000:79': 673.1,
  'ffun:10:40000:80': 673.1,
  'ffun:10:40000:81': 1007.62,
  'ffun:10:40000:82': 1007.62,
  'ffun:10:40000:83': 1007.62,
  'ffun:10:40000:84': 1007.62,
  'ffun:10:40000:85': 1007.62,
  'ffun:10:40000:86': 1321.6,
  'ffun:10:40000:87': 1321.6,
  'ffun:10:40000:88': 1321.6,
  'ffun:10:40000:89': 1321.6,
  'ffun:10:40000:90': 1321.6,
  'ffun:10:40000:91': 1744.92,
  'ffun:10:40000:92': 1744.92,
  'ffun:10:40000:93': 1744.92,
  'ffun:10:40000:94': 1744.92,
  'ffun:10:40000:95': 1744.92,
  'ffun:10:40000:96': 2819.45,
  'ffun:10:40000:97': 2819.45,
  'ffun:10:40000:98': 2819.45,
  'ffun:10:40000:99': 2819.45,
  'ffun:10:40000:100': 2819.45,
  'ffun:10:40000:101': 4931.78,
  'ffun:10:40000:102': 4931.78,
  'ffun:10:40000:103': 4931.78,
  'ffun:10:40000:104': 4931.78,
  'ffun:10:40000:105': 4931.78,
  'ffun:10:40000:106': 6233.62,
  'ffun:10:40000:107': 6233.62,
  'ffun:10:40000:108': 6233.62,
  'ffun:10:40000:109': 6233.62,
  'ffun:10:40000:110': 6233.62,
  'ffun:10:40000:111': 6233.62,
  'ffun:10:40000:112': 6233.62,
  'ffun:10:40000:113': 6233.62,
  'ffun:10:40000:114': 6233.62,
  'ffun:10:40000:115': 6233.62,
  'ffun:10:40000:116': 6233.62,
  'ffun:10:40000:117': 6233.62,
  'ffun:10:40000:118': 6233.62,
  'ffun:10:40000:119': 6233.62,
  'ffun:10:40000:120': 6233.62,
  'ffun:10:50000:1': 54.73,
  'ffun:10:50000:2': 54.73,
  'ffun:10:50000:3': 54.73,
  'ffun:10:50000:4': 54.73,
  'ffun:10:50000:5': 54.73,
  'ffun:10:50000:6': 54.63,
  'ffun:10:50000:7': 54.63,
  'ffun:10:50000:8': 54.63,
  'ffun:10:50000:9': 54.63,
  'ffun:10:50000:10': 54.63,
  'ffun:10:50000:11': 54.67,
  'ffun:10:50000:12': 54.67,
  'ffun:10:50000:13': 54.67,
  'ffun:10:50000:14': 54.67,
  'ffun:10:50000:15': 54.67,
  'ffun:10:50000:16': 55.01,
  'ffun:10:50000:17': 55.01,
  'ffun:10:50000:18': 55.01,
  'ffun:10:50000:19': 55.01,
  'ffun:10:50000:20': 55.01,
  'ffun:10:50000:21': 57.26,
  'ffun:10:50000:22': 57.26,
  'ffun:10:50000:23': 57.26,
  'ffun:10:50000:24': 57.26,
  'ffun:10:50000:25': 57.26,
  'ffun:10:50000:26': 62.83,
  'ffun:10:50000:27': 62.83,
  'ffun:10:50000:28': 62.83,
  'ffun:10:50000:29': 62.83,
  'ffun:10:50000:30': 62.83,
  'ffun:10:50000:31': 73.78,
  'ffun:10:50000:32': 73.78,
  'ffun:10:50000:33': 73.78,
  'ffun:10:50000:34': 73.78,
  'ffun:10:50000:35': 73.78,
  'ffun:10:50000:36': 96.3,
  'ffun:10:50000:37': 96.3,
  'ffun:10:50000:38': 96.3,
  'ffun:10:50000:39': 96.3,
  'ffun:10:50000:40': 96.3,
  'ffun:10:50000:41': 140.34,
  'ffun:10:50000:42': 140.34,
  'ffun:10:50000:43': 140.34,
  'ffun:10:50000:44': 140.34,
  'ffun:10:50000:45': 140.34,
  'ffun:10:50000:46': 191.29,
  'ffun:10:50000:47': 191.29,
  'ffun:10:50000:48': 191.29,
  'ffun:10:50000:49': 191.29,
  'ffun:10:50000:50': 191.29,
  'ffun:10:50000:51': 315.7,
  'ffun:10:50000:52': 315.7,
  'ffun:10:50000:53': 315.7,
  'ffun:10:50000:54': 315.7,
  'ffun:10:50000:55': 315.7,
  'ffun:10:50000:56': 327.99,
  'ffun:10:50000:57': 327.99,
  'ffun:10:50000:58': 327.99,
  'ffun:10:50000:59': 327.99,
  'ffun:10:50000:60': 327.99,
  'ffun:10:50000:61': 386.74,
  'ffun:10:50000:62': 386.74,
  'ffun:10:50000:63': 386.74,
  'ffun:10:50000:64': 386.74,
  'ffun:10:50000:65': 386.74,
  'ffun:10:50000:66': 487.9,
  'ffun:10:50000:67': 487.9,
  'ffun:10:50000:68': 487.9,
  'ffun:10:50000:69': 487.9,
  'ffun:10:50000:70': 487.9,
  'ffun:10:50000:71': 621.74,
  'ffun:10:50000:72': 621.74,
  'ffun:10:50000:73': 621.74,
  'ffun:10:50000:74': 621.74,
  'ffun:10:50000:75': 621.74,
  'ffun:10:50000:76': 834.37,
  'ffun:10:50000:77': 834.37,
  'ffun:10:50000:78': 834.37,
  'ffun:10:50000:79': 834.37,
  'ffun:10:50000:80': 834.37,
  'ffun:10:50000:81': 1248.03,
  'ffun:10:50000:82': 1248.03,
  'ffun:10:50000:83': 1248.03,
  'ffun:10:50000:84': 1248.03,
  'ffun:10:50000:85': 1248.03,
  'ffun:10:50000:86': 1640.83,
  'ffun:10:50000:87': 1640.83,
  'ffun:10:50000:88': 1640.83,
  'ffun:10:50000:89': 1640.83,
  'ffun:10:50000:90': 1640.83,
  'ffun:10:50000:91': 2173.92,
  'ffun:10:50000:92': 2173.92,
  'ffun:10:50000:93': 2173.92,
  'ffun:10:50000:94': 2173.92,
  'ffun:10:50000:95': 2173.92,
  'ffun:10:50000:96': 3515.66,
  'ffun:10:50000:97': 3515.66,
  'ffun:10:50000:98': 3515.66,
  'ffun:10:50000:99': 3515.66,
  'ffun:10:50000:100': 3515.66,
  'ffun:10:50000:101': 6135.74,
  'ffun:10:50000:102': 6135.74,
  'ffun:10:50000:103': 6135.74,
  'ffun:10:50000:104': 6135.74,
  'ffun:10:50000:105': 6135.74,
  'ffun:10:50000:106': 7743.92,
  'ffun:10:50000:107': 7743.92,
  'ffun:10:50000:108': 7743.92,
  'ffun:10:50000:109': 7743.92,
  'ffun:10:50000:110': 7743.92,
  'ffun:10:50000:111': 7743.92,
  'ffun:10:50000:112': 7743.92,
  'ffun:10:50000:113': 7743.92,
  'ffun:10:50000:114': 7743.92,
  'ffun:10:50000:115': 7743.92,
  'ffun:10:50000:116': 7743.92,
  'ffun:10:50000:117': 7743.92,
  'ffun:10:50000:118': 7743.92,
  'ffun:10:50000:119': 7743.92,
  'ffun:10:50000:120': 7743.92,
  'ffun:10:60000:1': 59.29,
  'ffun:10:60000:2': 59.29,
  'ffun:10:60000:3': 59.29,
  'ffun:10:60000:4': 59.29,
  'ffun:10:60000:5': 59.29,
  'ffun:10:60000:6': 59.16,
  'ffun:10:60000:7': 59.16,
  'ffun:10:60000:8': 59.16,
  'ffun:10:60000:9': 59.16,
  'ffun:10:60000:10': 59.16,
  'ffun:10:60000:11': 59.21,
  'ffun:10:60000:12': 59.21,
  'ffun:10:60000:13': 59.21,
  'ffun:10:60000:14': 59.21,
  'ffun:10:60000:15': 59.21,
  'ffun:10:60000:16': 59.62,
  'ffun:10:60000:17': 59.62,
  'ffun:10:60000:18': 59.62,
  'ffun:10:60000:19': 59.62,
  'ffun:10:60000:20': 59.62,
  'ffun:10:60000:21': 60.99,
  'ffun:10:60000:22': 60.99,
  'ffun:10:60000:23': 60.99,
  'ffun:10:60000:24': 60.99,
  'ffun:10:60000:25': 60.99,
  'ffun:10:60000:26': 64.73,
  'ffun:10:60000:27': 64.73,
  'ffun:10:60000:28': 64.73,
  'ffun:10:60000:29': 64.73,
  'ffun:10:60000:30': 64.73,
  'ffun:10:60000:31': 78.04,
  'ffun:10:60000:32': 78.04,
  'ffun:10:60000:33': 78.04,
  'ffun:10:60000:34': 78.04,
  'ffun:10:60000:35': 78.04,
  'ffun:10:60000:36': 101.3,
  'ffun:10:60000:37': 101.3,
  'ffun:10:60000:38': 101.3,
  'ffun:10:60000:39': 101.3,
  'ffun:10:60000:40': 101.3,
  'ffun:10:60000:41': 150.48,
  'ffun:10:60000:42': 150.48,
  'ffun:10:60000:43': 150.48,
  'ffun:10:60000:44': 150.48,
  'ffun:10:60000:45': 150.48,
  'ffun:10:60000:46': 207.91,
  'ffun:10:60000:47': 207.91,
  'ffun:10:60000:48': 207.91,
  'ffun:10:60000:49': 207.91,
  'ffun:10:60000:50': 207.91,
  'ffun:10:60000:51': 334.81,
  'ffun:10:60000:52': 334.81,
  'ffun:10:60000:53': 334.81,
  'ffun:10:60000:54': 334.81,
  'ffun:10:60000:55': 334.81,
  'ffun:10:60000:56': 385.84,
  'ffun:10:60000:57': 385.84,
  'ffun:10:60000:58': 385.84,
  'ffun:10:60000:59': 385.84,
  'ffun:10:60000:60': 385.84,
  'ffun:10:60000:61': 457.38,
  'ffun:10:60000:62': 457.38,
  'ffun:10:60000:63': 457.38,
  'ffun:10:60000:64': 457.38,
  'ffun:10:60000:65': 457.38,
  'ffun:10:60000:66': 579.89,
  'ffun:10:60000:67': 579.89,
  'ffun:10:60000:68': 579.89,
  'ffun:10:60000:69': 579.89,
  'ffun:10:60000:70': 579.89,
  'ffun:10:60000:71': 740.23,
  'ffun:10:60000:72': 740.23,
  'ffun:10:60000:73': 740.23,
  'ffun:10:60000:74': 740.23,
  'ffun:10:60000:75': 740.23,
  'ffun:10:60000:76': 994.67,
  'ffun:10:60000:77': 994.67,
  'ffun:10:60000:78': 994.67,
  'ffun:10:60000:79': 994.67,
  'ffun:10:60000:80': 994.67,
  'ffun:10:60000:81': 1452.72,
  'ffun:10:60000:82': 1452.72,
  'ffun:10:60000:83': 1452.72,
  'ffun:10:60000:84': 1452.72,
  'ffun:10:60000:85': 1452.72,
  'ffun:10:60000:86': 1933.82,
  'ffun:10:60000:87': 1933.82,
  'ffun:10:60000:88': 1933.82,
  'ffun:10:60000:89': 1933.82,
  'ffun:10:60000:90': 1933.82,
  'ffun:10:60000:91': 2600.3,
  'ffun:10:60000:92': 2600.3,
  'ffun:10:60000:93': 2600.3,
  'ffun:10:60000:94': 2600.3,
  'ffun:10:60000:95': 2600.3,
  'ffun:10:60000:96': 4207.72,
  'ffun:10:60000:97': 4207.72,
  'ffun:10:60000:98': 4207.72,
  'ffun:10:60000:99': 4207.72,
  'ffun:10:60000:100': 4207.72,
  'ffun:10:60000:101': 7349.52,
  'ffun:10:60000:102': 7349.52,
  'ffun:10:60000:103': 7349.52,
  'ffun:10:60000:104': 7349.52,
  'ffun:10:60000:105': 7349.52,
  'ffun:10:60000:106': 9279.2,
  'ffun:10:60000:107': 9279.2,
  'ffun:10:60000:108': 9279.2,
  'ffun:10:60000:109': 9279.2,
  'ffun:10:60000:110': 9279.2,
  'ffun:10:60000:111': 9279.2,
  'ffun:10:60000:112': 9279.2,
  'ffun:10:60000:113': 9279.2,
  'ffun:10:60000:114': 9279.2,
  'ffun:10:60000:115': 9279.2,
  'ffun:10:60000:116': 9279.2,
  'ffun:10:60000:117': 9279.2,
  'ffun:10:60000:118': 9279.2,
  'ffun:10:60000:119': 9279.2,
  'ffun:10:60000:120': 9279.2,
  'ffun:10:70000:1': 63.84,
  'ffun:10:70000:2': 63.84,
  'ffun:10:70000:3': 63.84,
  'ffun:10:70000:4': 63.84,
  'ffun:10:70000:5': 63.84,
  'ffun:10:70000:6': 63.69,
  'ffun:10:70000:7': 63.69,
  'ffun:10:70000:8': 63.69,
  'ffun:10:70000:9': 63.69,
  'ffun:10:70000:10': 63.69,
  'ffun:10:70000:11': 63.75,
  'ffun:10:70000:12': 63.75,
  'ffun:10:70000:13': 63.75,
  'ffun:10:70000:14': 63.75,
  'ffun:10:70000:15': 63.75,
  'ffun:10:70000:16': 64.23,
  'ffun:10:70000:17': 64.23,
  'ffun:10:70000:18': 64.23,
  'ffun:10:70000:19': 64.23,
  'ffun:10:70000:20': 64.23,
  'ffun:10:70000:21': 65.83,
  'ffun:10:70000:22': 65.83,
  'ffun:10:70000:23': 65.83,
  'ffun:10:70000:24': 65.83,
  'ffun:10:70000:25': 65.83,
  'ffun:10:70000:26': 70.17,
  'ffun:10:70000:27': 70.17,
  'ffun:10:70000:28': 70.17,
  'ffun:10:70000:29': 70.17,
  'ffun:10:70000:30': 70.17,
  'ffun:10:70000:31': 85.32,
  'ffun:10:70000:32': 85.32,
  'ffun:10:70000:33': 85.32,
  'ffun:10:70000:34': 85.32,
  'ffun:10:70000:35': 85.32,
  'ffun:10:70000:36': 112.21,
  'ffun:10:70000:37': 112.21,
  'ffun:10:70000:38': 112.21,
  'ffun:10:70000:39': 112.21,
  'ffun:10:70000:40': 112.21,
  'ffun:10:70000:41': 168.81,
  'ffun:10:70000:42': 168.81,
  'ffun:10:70000:43': 168.81,
  'ffun:10:70000:44': 168.81,
  'ffun:10:70000:45': 168.81,
  'ffun:10:70000:46': 235.92,
  'ffun:10:70000:47': 235.92,
  'ffun:10:70000:48': 235.92,
  'ffun:10:70000:49': 235.92,
  'ffun:10:70000:50': 235.92,
  'ffun:10:70000:51': 383.27,
  'ffun:10:70000:52': 383.27,
  'ffun:10:70000:53': 383.27,
  'ffun:10:70000:54': 383.27,
  'ffun:10:70000:55': 383.27,
  'ffun:10:70000:56': 443.58,
  'ffun:10:70000:57': 443.58,
  'ffun:10:70000:58': 443.58,
  'ffun:10:70000:59': 443.58,
  'ffun:10:70000:60': 443.58,
  'ffun:10:70000:61': 527.84,
  'ffun:10:70000:62': 527.84,
  'ffun:10:70000:63': 527.84,
  'ffun:10:70000:64': 527.84,
  'ffun:10:70000:65': 527.84,
  'ffun:10:70000:66': 671.64,
  'ffun:10:70000:67': 671.64,
  'ffun:10:70000:68': 671.64,
  'ffun:10:70000:69': 671.64,
  'ffun:10:70000:70': 671.64,
  'ffun:10:70000:71': 859.05,
  'ffun:10:70000:72': 859.05,
  'ffun:10:70000:73': 859.05,
  'ffun:10:70000:74': 859.05,
  'ffun:10:70000:75': 859.05,
  'ffun:10:70000:76': 1156.3,
  'ffun:10:70000:77': 1156.3,
  'ffun:10:70000:78': 1156.3,
  'ffun:10:70000:79': 1156.3,
  'ffun:10:70000:80': 1156.3,
  'ffun:10:70000:81': 1690.92,
  'ffun:10:70000:82': 1690.92,
  'ffun:10:70000:83': 1690.92,
  'ffun:10:70000:84': 1690.92,
  'ffun:10:70000:85': 1690.92,
  'ffun:10:70000:86': 2252.5,
  'ffun:10:70000:87': 2252.5,
  'ffun:10:70000:88': 2252.5,
  'ffun:10:70000:89': 2252.5,
  'ffun:10:70000:90': 2252.5,
  'ffun:10:70000:91': 3030.25,
  'ffun:10:70000:92': 3030.25,
  'ffun:10:70000:93': 3030.25,
  'ffun:10:70000:94': 3030.25,
  'ffun:10:70000:95': 3030.25,
  'ffun:10:70000:96': 4905.41,
  'ffun:10:70000:97': 4905.41,
  'ffun:10:70000:98': 4905.41,
  'ffun:10:70000:99': 4905.41,
  'ffun:10:70000:100': 4905.41,
  'ffun:10:70000:101': 8564.8,
  'ffun:10:70000:102': 8564.8,
  'ffun:10:70000:103': 8564.8,
  'ffun:10:70000:104': 8564.8,
  'ffun:10:70000:105': 8564.8,
  'ffun:10:70000:106': 10810.25,
  'ffun:10:70000:107': 10810.25,
  'ffun:10:70000:108': 10810.25,
  'ffun:10:70000:109': 10810.25,
  'ffun:10:70000:110': 10810.25,
  'ffun:10:70000:111': 10810.25,
  'ffun:10:70000:112': 10810.25,
  'ffun:10:70000:113': 10810.25,
  'ffun:10:70000:114': 10810.25,
  'ffun:10:70000:115': 10810.25,
  'ffun:10:70000:116': 10810.25,
  'ffun:10:70000:117': 10810.25,
  'ffun:10:70000:118': 10810.25,
  'ffun:10:70000:119': 10810.25,
  'ffun:10:70000:120': 10810.25,
  'ffun:10:80000:1': 68.39,
  'ffun:10:80000:2': 68.39,
  'ffun:10:80000:3': 68.39,
  'ffun:10:80000:4': 68.39,
  'ffun:10:80000:5': 68.39,
  'ffun:10:80000:6': 68.22,
  'ffun:10:80000:7': 68.22,
  'ffun:10:80000:8': 68.22,
  'ffun:10:80000:9': 68.22,
  'ffun:10:80000:10': 68.22,
  'ffun:10:80000:11': 68.29,
  'ffun:10:80000:12': 68.29,
  'ffun:10:80000:13': 68.29,
  'ffun:10:80000:14': 68.29,
  'ffun:10:80000:15': 68.29,
  'ffun:10:80000:16': 68.83,
  'ffun:10:80000:17': 68.83,
  'ffun:10:80000:18': 68.83,
  'ffun:10:80000:19': 68.83,
  'ffun:10:80000:20': 68.83,
  'ffun:10:80000:21': 70.66,
  'ffun:10:80000:22': 70.66,
  'ffun:10:80000:23': 70.66,
  'ffun:10:80000:24': 70.66,
  'ffun:10:80000:25': 70.66,
  'ffun:10:80000:26': 75.61,
  'ffun:10:80000:27': 75.61,
  'ffun:10:80000:28': 75.61,
  'ffun:10:80000:29': 75.61,
  'ffun:10:80000:30': 75.61,
  'ffun:10:80000:31': 92.61,
  'ffun:10:80000:32': 92.61,
  'ffun:10:80000:33': 92.61,
  'ffun:10:80000:34': 92.61,
  'ffun:10:80000:35': 92.61,
  'ffun:10:80000:36': 123.1,
  'ffun:10:80000:37': 123.1,
  'ffun:10:80000:38': 123.1,
  'ffun:10:80000:39': 123.1,
  'ffun:10:80000:40': 123.1,
  'ffun:10:80000:41': 187.36,
  'ffun:10:80000:42': 187.36,
  'ffun:10:80000:43': 187.36,
  'ffun:10:80000:44': 187.36,
  'ffun:10:80000:45': 187.36,
  'ffun:10:80000:46': 263.98,
  'ffun:10:80000:47': 263.98,
  'ffun:10:80000:48': 263.98,
  'ffun:10:80000:49': 263.98,
  'ffun:10:80000:50': 263.98,
  'ffun:10:80000:51': 431,
  'ffun:10:80000:52': 431,
  'ffun:10:80000:53': 431,
  'ffun:10:80000:54': 431,
  'ffun:10:80000:55': 431,
  'ffun:10:80000:56': 500.26,
  'ffun:10:80000:57': 500.26,
  'ffun:10:80000:58': 500.26,
  'ffun:10:80000:59': 500.26,
  'ffun:10:80000:60': 500.26,
  'ffun:10:80000:61': 597.68,
  'ffun:10:80000:62': 597.68,
  'ffun:10:80000:63': 597.68,
  'ffun:10:80000:64': 597.68,
  'ffun:10:80000:65': 597.68,
  'ffun:10:80000:66': 763.22,
  'ffun:10:80000:67': 763.22,
  'ffun:10:80000:68': 763.22,
  'ffun:10:80000:69': 763.22,
  'ffun:10:80000:70': 763.22,
  'ffun:10:80000:71': 977.68,
  'ffun:10:80000:72': 977.68,
  'ffun:10:80000:73': 977.68,
  'ffun:10:80000:74': 977.68,
  'ffun:10:80000:75': 977.68,
  'ffun:10:80000:76': 1317.69,
  'ffun:10:80000:77': 1317.69,
  'ffun:10:80000:78': 1317.69,
  'ffun:10:80000:79': 1317.69,
  'ffun:10:80000:80': 1317.69,
  'ffun:10:80000:81': 1928.74,
  'ffun:10:80000:82': 1928.74,
  'ffun:10:80000:83': 1928.74,
  'ffun:10:80000:84': 1928.74,
  'ffun:10:80000:85': 1928.74,
  'ffun:10:80000:86': 2570.69,
  'ffun:10:80000:87': 2570.69,
  'ffun:10:80000:88': 2570.69,
  'ffun:10:80000:89': 2570.69,
  'ffun:10:80000:90': 2570.69,
  'ffun:10:80000:91': 3459.53,
  'ffun:10:80000:92': 3459.53,
  'ffun:10:80000:93': 3459.53,
  'ffun:10:80000:94': 3459.53,
  'ffun:10:80000:95': 3459.53,
  'ffun:10:80000:96': 5602.04,
  'ffun:10:80000:97': 5602.04,
  'ffun:10:80000:98': 5602.04,
  'ffun:10:80000:99': 5602.04,
  'ffun:10:80000:100': 5602.04,
  'ffun:10:80000:101': 9758.99,
  'ffun:10:80000:102': 9758.99,
  'ffun:10:80000:103': 9758.99,
  'ffun:10:80000:104': 9758.99,
  'ffun:10:80000:105': 9758.99,
  'ffun:10:80000:106': 12300.47,
  'ffun:10:80000:107': 12300.47,
  'ffun:10:80000:108': 12300.47,
  'ffun:10:80000:109': 12300.47,
  'ffun:10:80000:110': 12300.47,
  'ffun:10:80000:111': 12300.47,
  'ffun:10:80000:112': 12300.47,
  'ffun:10:80000:113': 12300.47,
  'ffun:10:80000:114': 12300.47,
  'ffun:10:80000:115': 12300.47,
  'ffun:10:80000:116': 12300.47,
  'ffun:10:80000:117': 12300.47,
  'ffun:10:80000:118': 12300.47,
  'ffun:10:80000:119': 12300.47,
  'ffun:10:80000:120': 12300.47,
  'ffun:10:90000:1': 72.94,
  'ffun:10:90000:2': 72.94,
  'ffun:10:90000:3': 72.94,
  'ffun:10:90000:4': 72.94,
  'ffun:10:90000:5': 72.94,
  'ffun:10:90000:6': 72.75,
  'ffun:10:90000:7': 72.75,
  'ffun:10:90000:8': 72.75,
  'ffun:10:90000:9': 72.75,
  'ffun:10:90000:10': 72.75,
  'ffun:10:90000:11': 72.83,
  'ffun:10:90000:12': 72.83,
  'ffun:10:90000:13': 72.83,
  'ffun:10:90000:14': 72.83,
  'ffun:10:90000:15': 72.83,
  'ffun:10:90000:16': 73.44,
  'ffun:10:90000:17': 73.44,
  'ffun:10:90000:18': 73.44,
  'ffun:10:90000:19': 73.44,
  'ffun:10:90000:20': 73.44,
  'ffun:10:90000:21': 75.5,
  'ffun:10:90000:22': 75.5,
  'ffun:10:90000:23': 75.5,
  'ffun:10:90000:24': 75.5,
  'ffun:10:90000:25': 75.5,
  'ffun:10:90000:26': 81.05,
  'ffun:10:90000:27': 81.05,
  'ffun:10:90000:28': 81.05,
  'ffun:10:90000:29': 81.05,
  'ffun:10:90000:30': 81.05,
  'ffun:10:90000:31': 99.88,
  'ffun:10:90000:32': 99.88,
  'ffun:10:90000:33': 99.88,
  'ffun:10:90000:34': 99.88,
  'ffun:10:90000:35': 99.88,
  'ffun:10:90000:36': 133.98,
  'ffun:10:90000:37': 133.98,
  'ffun:10:90000:38': 133.98,
  'ffun:10:90000:39': 133.98,
  'ffun:10:90000:40': 133.98,
  'ffun:10:90000:41': 205.86,
  'ffun:10:90000:42': 205.86,
  'ffun:10:90000:43': 205.86,
  'ffun:10:90000:44': 205.86,
  'ffun:10:90000:45': 205.86,
  'ffun:10:90000:46': 292.19,
  'ffun:10:90000:47': 292.19,
  'ffun:10:90000:48': 292.19,
  'ffun:10:90000:49': 292.19,
  'ffun:10:90000:50': 292.19,
  'ffun:10:90000:51': 479.58,
  'ffun:10:90000:52': 479.58,
  'ffun:10:90000:53': 479.58,
  'ffun:10:90000:54': 479.58,
  'ffun:10:90000:55': 479.58,
  'ffun:10:90000:56': 558.26,
  'ffun:10:90000:57': 558.26,
  'ffun:10:90000:58': 558.26,
  'ffun:10:90000:59': 558.26,
  'ffun:10:90000:60': 558.26,
  'ffun:10:90000:61': 667.76,
  'ffun:10:90000:62': 667.76,
  'ffun:10:90000:63': 667.76,
  'ffun:10:90000:64': 667.76,
  'ffun:10:90000:65': 667.76,
  'ffun:10:90000:66': 853.7,
  'ffun:10:90000:67': 853.7,
  'ffun:10:90000:68': 853.7,
  'ffun:10:90000:69': 853.7,
  'ffun:10:90000:70': 853.7,
  'ffun:10:90000:71': 1094.87,
  'ffun:10:90000:72': 1094.87,
  'ffun:10:90000:73': 1094.87,
  'ffun:10:90000:74': 1094.87,
  'ffun:10:90000:75': 1094.87,
  'ffun:10:90000:76': 1477.04,
  'ffun:10:90000:77': 1477.04,
  'ffun:10:90000:78': 1477.04,
  'ffun:10:90000:79': 1477.04,
  'ffun:10:90000:80': 1477.04,
  'ffun:10:90000:81': 2163.49,
  'ffun:10:90000:82': 2163.49,
  'ffun:10:90000:83': 2163.49,
  'ffun:10:90000:84': 2163.49,
  'ffun:10:90000:85': 2163.49,
  'ffun:10:90000:86': 2884.81,
  'ffun:10:90000:87': 2884.81,
  'ffun:10:90000:88': 2884.81,
  'ffun:10:90000:89': 2884.81,
  'ffun:10:90000:90': 2884.81,
  'ffun:10:90000:91': 3883.37,
  'ffun:10:90000:92': 3883.37,
  'ffun:10:90000:93': 3883.37,
  'ffun:10:90000:94': 3883.37,
  'ffun:10:90000:95': 3883.37,
  'ffun:10:90000:96': 6289.9,
  'ffun:10:90000:97': 6289.9,
  'ffun:10:90000:98': 6289.9,
  'ffun:10:90000:99': 6289.9,
  'ffun:10:90000:100': 6289.9,
  'ffun:10:90000:101': 10974.05,
  'ffun:10:90000:102': 10974.05,
  'ffun:10:90000:103': 10974.05,
  'ffun:10:90000:104': 10974.05,
  'ffun:10:90000:105': 10974.05,
  'ffun:10:90000:106': 13843.75,
  'ffun:10:90000:107': 13843.75,
  'ffun:10:90000:108': 13843.75,
  'ffun:10:90000:109': 13843.75,
  'ffun:10:90000:110': 13843.75,
  'ffun:10:90000:111': 13843.75,
  'ffun:10:90000:112': 13843.75,
  'ffun:10:90000:113': 13843.75,
  'ffun:10:90000:114': 13843.75,
  'ffun:10:90000:115': 13843.75,
  'ffun:10:90000:116': 13843.75,
  'ffun:10:90000:117': 13843.75,
  'ffun:10:90000:118': 13843.75,
  'ffun:10:90000:119': 13843.75,
  'ffun:10:90000:120': 13843.75,
  'ffun:10:100000:1': 77.49,
  'ffun:10:100000:2': 77.49,
  'ffun:10:100000:3': 77.49,
  'ffun:10:100000:4': 77.49,
  'ffun:10:100000:5': 77.49,
  'ffun:10:100000:6': 77.28,
  'ffun:10:100000:7': 77.28,
  'ffun:10:100000:8': 77.28,
  'ffun:10:100000:9': 77.28,
  'ffun:10:100000:10': 77.28,
  'ffun:10:100000:11': 77.37,
  'ffun:10:100000:12': 77.37,
  'ffun:10:100000:13': 77.37,
  'ffun:10:100000:14': 77.37,
  'ffun:10:100000:15': 77.37,
  'ffun:10:100000:16': 78.05,
  'ffun:10:100000:17': 78.05,
  'ffun:10:100000:18': 78.05,
  'ffun:10:100000:19': 78.05,
  'ffun:10:100000:20': 78.05,
  'ffun:10:100000:21': 80.34,
  'ffun:10:100000:22': 80.34,
  'ffun:10:100000:23': 80.34,
  'ffun:10:100000:24': 80.34,
  'ffun:10:100000:25': 80.34,
  'ffun:10:100000:26': 86.49,
  'ffun:10:100000:27': 86.49,
  'ffun:10:100000:28': 86.49,
  'ffun:10:100000:29': 86.49,
  'ffun:10:100000:30': 86.49,
  'ffun:10:100000:31': 107.16,
  'ffun:10:100000:32': 107.16,
  'ffun:10:100000:33': 107.16,
  'ffun:10:100000:34': 107.16,
  'ffun:10:100000:35': 107.16,
  'ffun:10:100000:36': 144.86,
  'ffun:10:100000:37': 144.86,
  'ffun:10:100000:38': 144.86,
  'ffun:10:100000:39': 144.86,
  'ffun:10:100000:40': 144.86,
  'ffun:10:100000:41': 224.35,
  'ffun:10:100000:42': 224.35,
  'ffun:10:100000:43': 224.35,
  'ffun:10:100000:44': 224.35,
  'ffun:10:100000:45': 224.35,
  'ffun:10:100000:46': 320.4,
  'ffun:10:100000:47': 320.4,
  'ffun:10:100000:48': 320.4,
  'ffun:10:100000:49': 320.4,
  'ffun:10:100000:50': 320.4,
  'ffun:10:100000:51': 528.06,
  'ffun:10:100000:52': 528.06,
  'ffun:10:100000:53': 528.06,
  'ffun:10:100000:54': 528.06,
  'ffun:10:100000:55': 528.06,
  'ffun:10:100000:56': 616,
  'ffun:10:100000:57': 616,
  'ffun:10:100000:58': 616,
  'ffun:10:100000:59': 616,
  'ffun:10:100000:60': 616,
  'ffun:10:100000:61': 738.18,
  'ffun:10:100000:62': 738.18,
  'ffun:10:100000:63': 738.18,
  'ffun:10:100000:64': 738.18,
  'ffun:10:100000:65': 738.18,
  'ffun:10:100000:66': 945.37,
  'ffun:10:100000:67': 945.37,
  'ffun:10:100000:68': 945.37,
  'ffun:10:100000:69': 945.37,
  'ffun:10:100000:70': 945.37,
  'ffun:10:100000:71': 1213.59,
  'ffun:10:100000:72': 1213.59,
  'ffun:10:100000:73': 1213.59,
  'ffun:10:100000:74': 1213.59,
  'ffun:10:100000:75': 1213.59,
  'ffun:10:100000:76': 1638.49,
  'ffun:10:100000:77': 1638.49,
  'ffun:10:100000:78': 1638.49,
  'ffun:10:100000:79': 1638.49,
  'ffun:10:100000:80': 1638.49,
  'ffun:10:100000:81': 2401.44,
  'ffun:10:100000:82': 2401.44,
  'ffun:10:100000:83': 2401.44,
  'ffun:10:100000:84': 2401.44,
  'ffun:10:100000:85': 2401.44,
  'ffun:10:100000:86': 3203.28,
  'ffun:10:100000:87': 3203.28,
  'ffun:10:100000:88': 3203.28,
  'ffun:10:100000:89': 3203.28,
  'ffun:10:100000:90': 3203.28,
  'ffun:10:100000:91': 4313.15,
  'ffun:10:100000:92': 4313.15,
  'ffun:10:100000:93': 4313.15,
  'ffun:10:100000:94': 4313.15,
  'ffun:10:100000:95': 4313.15,
  'ffun:10:100000:96': 6987.56,
  'ffun:10:100000:97': 6987.56,
  'ffun:10:100000:98': 6987.56,
  'ffun:10:100000:99': 6987.56,
  'ffun:10:100000:100': 6987.56,
  'ffun:10:100000:101': 12191.47,
  'ffun:10:100000:102': 12191.47,
  'ffun:10:100000:103': 12191.47,
  'ffun:10:100000:104': 12191.47,
  'ffun:10:100000:105': 12191.47,
  'ffun:10:100000:106': 15379.02,
  'ffun:10:100000:107': 15379.02,
  'ffun:10:100000:108': 15379.02,
  'ffun:10:100000:109': 15379.02,
  'ffun:10:100000:110': 15379.02,
  'ffun:10:100000:111': 15379.02,
  'ffun:10:100000:112': 15379.02,
  'ffun:10:100000:113': 15379.02,
  'ffun:10:100000:114': 15379.02,
  'ffun:10:100000:115': 15379.02,
  'ffun:10:100000:116': 15379.02,
  'ffun:10:100000:117': 15379.02,
  'ffun:10:100000:118': 15379.02,
  'ffun:10:100000:119': 15379.02,
  'ffun:10:100000:120': 15379.02,
  'ffun:10:120000:1': 97.45,
  'ffun:10:120000:2': 97.45,
  'ffun:10:120000:3': 97.45,
  'ffun:10:120000:4': 97.45,
  'ffun:10:120000:5': 97.45,
  'ffun:10:120000:6': 97.18,
  'ffun:10:120000:7': 97.18,
  'ffun:10:120000:8': 97.18,
  'ffun:10:120000:9': 97.18,
  'ffun:10:120000:10': 97.18,
  'ffun:10:120000:11': 97.28,
  'ffun:10:120000:12': 97.28,
  'ffun:10:120000:13': 97.28,
  'ffun:10:120000:14': 97.28,
  'ffun:10:120000:15': 97.28,
  'ffun:10:120000:16': 98.1,
  'ffun:10:120000:17': 98.1,
  'ffun:10:120000:18': 98.1,
  'ffun:10:120000:19': 98.1,
  'ffun:10:120000:20': 98.1,
  'ffun:10:120000:21': 100.88,
  'ffun:10:120000:22': 100.88,
  'ffun:10:120000:23': 100.88,
  'ffun:10:120000:24': 100.88,
  'ffun:10:120000:25': 100.88,
  'ffun:10:120000:26': 108.25,
  'ffun:10:120000:27': 108.25,
  'ffun:10:120000:28': 108.25,
  'ffun:10:120000:29': 108.25,
  'ffun:10:120000:30': 108.25,
  'ffun:10:120000:31': 133.49,
  'ffun:10:120000:32': 133.49,
  'ffun:10:120000:33': 133.49,
  'ffun:10:120000:34': 133.49,
  'ffun:10:120000:35': 133.49,
  'ffun:10:120000:36': 179.57,
  'ffun:10:120000:37': 179.57,
  'ffun:10:120000:38': 179.57,
  'ffun:10:120000:39': 179.57,
  'ffun:10:120000:40': 179.57,
  'ffun:10:120000:41': 276.74,
  'ffun:10:120000:42': 276.74,
  'ffun:10:120000:43': 276.74,
  'ffun:10:120000:44': 276.74,
  'ffun:10:120000:45': 276.74,
  'ffun:10:120000:46': 395.56,
  'ffun:10:120000:47': 395.56,
  'ffun:10:120000:48': 395.56,
  'ffun:10:120000:49': 395.56,
  'ffun:10:120000:50': 395.56,
  'ffun:10:120000:51': 653.44,
  'ffun:10:120000:52': 653.44,
  'ffun:10:120000:53': 653.44,
  'ffun:10:120000:54': 653.44,
  'ffun:10:120000:55': 653.44,
  'ffun:10:120000:56': 761.76,
  'ffun:10:120000:57': 761.76,
  'ffun:10:120000:58': 761.76,
  'ffun:10:120000:59': 761.76,
  'ffun:10:120000:60': 761.76,
  'ffun:10:120000:61': 912.1,
  'ffun:10:120000:62': 912.1,
  'ffun:10:120000:63': 912.1,
  'ffun:10:120000:64': 912.1,
  'ffun:10:120000:65': 912.1,
  'ffun:10:120000:66': 1169.48,
  'ffun:10:120000:67': 1169.48,
  'ffun:10:120000:68': 1169.48,
  'ffun:10:120000:69': 1169.48,
  'ffun:10:120000:70': 1169.48,
  'ffun:10:120000:71': 1628.82,
  'ffun:10:120000:72': 1628.82,
  'ffun:10:120000:73': 1628.82,
  'ffun:10:120000:74': 1628.82,
  'ffun:10:120000:75': 1628.82,
  'ffun:10:120000:76': 2243.79,
  'ffun:10:120000:77': 2243.79,
  'ffun:10:120000:78': 2243.79,
  'ffun:10:120000:79': 2243.79,
  'ffun:10:120000:80': 2243.79,
  'ffun:10:120000:81': 3222.22,
  'ffun:10:120000:82': 3222.22,
  'ffun:10:120000:83': 3222.22,
  'ffun:10:120000:84': 3222.22,
  'ffun:10:120000:85': 3222.22,
  'ffun:10:120000:86': 4384.62,
  'ffun:10:120000:87': 4384.62,
  'ffun:10:120000:88': 4384.62,
  'ffun:10:120000:89': 4384.62,
  'ffun:10:120000:90': 4384.62,
  'ffun:10:120000:91': 6051.61,
  'ffun:10:120000:92': 6051.61,
  'ffun:10:120000:93': 6051.61,
  'ffun:10:120000:94': 6051.61,
  'ffun:10:120000:95': 6051.61,
  'ffun:10:120000:96': 10305.43,
  'ffun:10:120000:97': 10305.43,
  'ffun:10:120000:98': 10305.43,
  'ffun:10:120000:99': 10305.43,
  'ffun:10:120000:100': 10305.43,
  'ffun:10:120000:101': 23433.96,
  'ffun:10:120000:102': 23433.96,
  'ffun:10:120000:103': 23433.96,
  'ffun:10:120000:104': 23433.96,
  'ffun:10:120000:105': 23433.96,
  'ffun:10:120000:106': 33308.91,
  'ffun:10:120000:107': 33308.91,
  'ffun:10:120000:108': 33308.91,
  'ffun:10:120000:109': 33308.91,
  'ffun:10:120000:110': 33308.91,
  'ffun:10:120000:111': 33308.91,
  'ffun:10:120000:112': 33308.91,
  'ffun:10:120000:113': 33308.91,
  'ffun:10:120000:114': 33308.91,
  'ffun:10:120000:115': 33308.91,
  'ffun:10:120000:116': 33308.91,
  'ffun:10:120000:117': 33308.91,
  'ffun:10:120000:118': 33308.91,
  'ffun:10:120000:119': 33308.91,
  'ffun:10:120000:120': 33308.91,
  'ffun:10:140000:1': 108.28,
  'ffun:10:140000:2': 108.28,
  'ffun:10:140000:3': 108.28,
  'ffun:10:140000:4': 108.28,
  'ffun:10:140000:5': 108.28,
  'ffun:10:140000:6': 107.96,
  'ffun:10:140000:7': 107.96,
  'ffun:10:140000:8': 107.96,
  'ffun:10:140000:9': 107.96,
  'ffun:10:140000:10': 107.96,
  'ffun:10:140000:11': 108.08,
  'ffun:10:140000:12': 108.08,
  'ffun:10:140000:13': 108.08,
  'ffun:10:140000:14': 108.08,
  'ffun:10:140000:15': 108.08,
  'ffun:10:140000:16': 109.03,
  'ffun:10:140000:17': 109.03,
  'ffun:10:140000:18': 109.03,
  'ffun:10:140000:19': 109.03,
  'ffun:10:140000:20': 109.03,
  'ffun:10:140000:21': 112.27,
  'ffun:10:140000:22': 112.27,
  'ffun:10:140000:23': 112.27,
  'ffun:10:140000:24': 112.27,
  'ffun:10:140000:25': 112.27,
  'ffun:10:140000:26': 120.99,
  'ffun:10:140000:27': 120.99,
  'ffun:10:140000:28': 120.99,
  'ffun:10:140000:29': 120.99,
  'ffun:10:140000:30': 120.99,
  'ffun:10:140000:31': 150.15,
  'ffun:10:140000:32': 150.15,
  'ffun:10:140000:33': 150.15,
  'ffun:10:140000:34': 150.15,
  'ffun:10:140000:35': 150.15,
  'ffun:10:140000:36': 203.78,
  'ffun:10:140000:37': 203.78,
  'ffun:10:140000:38': 203.78,
  'ffun:10:140000:39': 203.78,
  'ffun:10:140000:40': 203.78,
  'ffun:10:140000:41': 316.89,
  'ffun:10:140000:42': 316.89,
  'ffun:10:140000:43': 316.89,
  'ffun:10:140000:44': 316.89,
  'ffun:10:140000:45': 316.89,
  'ffun:10:140000:46': 455.9,
  'ffun:10:140000:47': 455.9,
  'ffun:10:140000:48': 455.9,
  'ffun:10:140000:49': 455.9,
  'ffun:10:140000:50': 455.9,
  'ffun:10:140000:51': 756.45,
  'ffun:10:140000:52': 756.45,
  'ffun:10:140000:53': 756.45,
  'ffun:10:140000:54': 756.45,
  'ffun:10:140000:55': 756.45,
  'ffun:10:140000:56': 883.78,
  'ffun:10:140000:57': 883.78,
  'ffun:10:140000:58': 883.78,
  'ffun:10:140000:59': 883.78,
  'ffun:10:140000:60': 883.78,
  'ffun:10:140000:61': 1060.22,
  'ffun:10:140000:62': 1060.22,
  'ffun:10:140000:63': 1060.22,
  'ffun:10:140000:64': 1060.22,
  'ffun:10:140000:65': 1060.22,
  'ffun:10:140000:66': 1360.05,
  'ffun:10:140000:67': 1360.05,
  'ffun:10:140000:68': 1360.05,
  'ffun:10:140000:69': 1360.05,
  'ffun:10:140000:70': 1360.05,
  'ffun:10:140000:71': 1896.75,
  'ffun:10:140000:72': 1896.75,
  'ffun:10:140000:73': 1896.75,
  'ffun:10:140000:74': 1896.75,
  'ffun:10:140000:75': 1896.75,
  'ffun:10:140000:76': 2614.63,
  'ffun:10:140000:77': 2614.63,
  'ffun:10:140000:78': 2614.63,
  'ffun:10:140000:79': 2614.63,
  'ffun:10:140000:80': 2614.63,
  'ffun:10:140000:81': 3754.64,
  'ffun:10:140000:82': 3754.64,
  'ffun:10:140000:83': 3754.64,
  'ffun:10:140000:84': 3754.64,
  'ffun:10:140000:85': 3754.64,
  'ffun:10:140000:86': 5111.94,
  'ffun:10:140000:87': 5111.94,
  'ffun:10:140000:88': 5111.94,
  'ffun:10:140000:89': 5111.94,
  'ffun:10:140000:90': 5111.94,
  'ffun:10:140000:91': 7061.09,
  'ffun:10:140000:92': 7061.09,
  'ffun:10:140000:93': 7061.09,
  'ffun:10:140000:94': 7061.09,
  'ffun:10:140000:95': 7061.09,
  'ffun:10:140000:96': 12020.54,
  'ffun:10:140000:97': 12020.54,
  'ffun:10:140000:98': 12020.54,
  'ffun:10:140000:99': 12020.54,
  'ffun:10:140000:100': 12020.54,
  'ffun:10:140000:101': 27352.27,
  'ffun:10:140000:102': 27352.27,
  'ffun:10:140000:103': 27352.27,
  'ffun:10:140000:104': 27352.27,
  'ffun:10:140000:105': 27352.27,
  'ffun:10:140000:106': 38894.99,
  'ffun:10:140000:107': 38894.99,
  'ffun:10:140000:108': 38894.99,
  'ffun:10:140000:109': 38894.99,
  'ffun:10:140000:110': 38894.99,
  'ffun:10:140000:111': 38894.99,
  'ffun:10:140000:112': 38894.99,
  'ffun:10:140000:113': 38894.99,
  'ffun:10:140000:114': 38894.99,
  'ffun:10:140000:115': 38894.99,
  'ffun:10:140000:116': 38894.99,
  'ffun:10:140000:117': 38894.99,
  'ffun:10:140000:118': 38894.99,
  'ffun:10:140000:119': 38894.99,
  'ffun:10:140000:120': 38894.99,
  'ffun:10:160000:1': 119.21,
  'ffun:10:160000:2': 119.21,
  'ffun:10:160000:3': 119.21,
  'ffun:10:160000:4': 119.21,
  'ffun:10:160000:5': 119.21,
  'ffun:10:160000:6': 118.85,
  'ffun:10:160000:7': 118.85,
  'ffun:10:160000:8': 118.85,
  'ffun:10:160000:9': 118.85,
  'ffun:10:160000:10': 118.85,
  'ffun:10:160000:11': 118.99,
  'ffun:10:160000:12': 118.99,
  'ffun:10:160000:13': 118.99,
  'ffun:10:160000:14': 118.99,
  'ffun:10:160000:15': 118.99,
  'ffun:10:160000:16': 120.07,
  'ffun:10:160000:17': 120.07,
  'ffun:10:160000:18': 120.07,
  'ffun:10:160000:19': 120.07,
  'ffun:10:160000:20': 120.07,
  'ffun:10:160000:21': 123.78,
  'ffun:10:160000:22': 123.78,
  'ffun:10:160000:23': 123.78,
  'ffun:10:160000:24': 123.78,
  'ffun:10:160000:25': 123.78,
  'ffun:10:160000:26': 133.74,
  'ffun:10:160000:27': 133.74,
  'ffun:10:160000:28': 133.74,
  'ffun:10:160000:29': 133.74,
  'ffun:10:160000:30': 133.74,
  'ffun:10:160000:31': 166.81,
  'ffun:10:160000:32': 166.81,
  'ffun:10:160000:33': 166.81,
  'ffun:10:160000:34': 166.81,
  'ffun:10:160000:35': 166.81,
  'ffun:10:160000:36': 227.69,
  'ffun:10:160000:37': 227.69,
  'ffun:10:160000:38': 227.69,
  'ffun:10:160000:39': 227.69,
  'ffun:10:160000:40': 227.69,
  'ffun:10:160000:41': 356.01,
  'ffun:10:160000:42': 356.01,
  'ffun:10:160000:43': 356.01,
  'ffun:10:160000:44': 356.01,
  'ffun:10:160000:45': 356.01,
  'ffun:10:160000:46': 514.51,
  'ffun:10:160000:47': 514.51,
  'ffun:10:160000:48': 514.51,
  'ffun:10:160000:49': 514.51,
  'ffun:10:160000:50': 514.51,
  'ffun:10:160000:51': 857.48,
  'ffun:10:160000:52': 857.48,
  'ffun:10:160000:53': 857.48,
  'ffun:10:160000:54': 857.48,
  'ffun:10:160000:55': 857.48,
  'ffun:10:160000:56': 1004.48,
  'ffun:10:160000:57': 1004.48,
  'ffun:10:160000:58': 1004.48,
  'ffun:10:160000:59': 1004.48,
  'ffun:10:160000:60': 1004.48,
  'ffun:10:160000:61': 1206.83,
  'ffun:10:160000:62': 1206.83,
  'ffun:10:160000:63': 1206.83,
  'ffun:10:160000:64': 1206.83,
  'ffun:10:160000:65': 1206.83,
  'ffun:10:160000:66': 1550.21,
  'ffun:10:160000:67': 1550.21,
  'ffun:10:160000:68': 1550.21,
  'ffun:10:160000:69': 1550.21,
  'ffun:10:160000:70': 1550.21,
  'ffun:10:160000:71': 2163.95,
  'ffun:10:160000:72': 2163.95,
  'ffun:10:160000:73': 2163.95,
  'ffun:10:160000:74': 2163.95,
  'ffun:10:160000:75': 2163.95,
  'ffun:10:160000:76': 2984.76,
  'ffun:10:160000:77': 2984.76,
  'ffun:10:160000:78': 2984.76,
  'ffun:10:160000:79': 2984.76,
  'ffun:10:160000:80': 2984.76,
  'ffun:10:160000:81': 4287.86,
  'ffun:10:160000:82': 4287.86,
  'ffun:10:160000:83': 4287.86,
  'ffun:10:160000:84': 4287.86,
  'ffun:10:160000:85': 4287.86,
  'ffun:10:160000:86': 5839.56,
  'ffun:10:160000:87': 5839.56,
  'ffun:10:160000:88': 5839.56,
  'ffun:10:160000:89': 5839.56,
  'ffun:10:160000:90': 5839.56,
  'ffun:10:160000:91': 8067.66,
  'ffun:10:160000:92': 8067.66,
  'ffun:10:160000:93': 8067.66,
  'ffun:10:160000:94': 8067.66,
  'ffun:10:160000:95': 8067.66,
  'ffun:10:160000:96': 13735.94,
  'ffun:10:160000:97': 13735.94,
  'ffun:10:160000:98': 13735.94,
  'ffun:10:160000:99': 13735.94,
  'ffun:10:160000:100': 13735.94,
  'ffun:10:160000:101': 31258.7,
  'ffun:10:160000:102': 31258.7,
  'ffun:10:160000:103': 31258.7,
  'ffun:10:160000:104': 31258.7,
  'ffun:10:160000:105': 31258.7,
  'ffun:10:160000:106': 44451.05,
  'ffun:10:160000:107': 44451.05,
  'ffun:10:160000:108': 44451.05,
  'ffun:10:160000:109': 44451.05,
  'ffun:10:160000:110': 44451.05,
  'ffun:10:160000:111': 44451.05,
  'ffun:10:160000:112': 44451.05,
  'ffun:10:160000:113': 44451.05,
  'ffun:10:160000:114': 44451.05,
  'ffun:10:160000:115': 44451.05,
  'ffun:10:160000:116': 44451.05,
  'ffun:10:160000:117': 44451.05,
  'ffun:10:160000:118': 44451.05,
  'ffun:10:160000:119': 44451.05,
  'ffun:10:160000:120': 44451.05,
  'ffun:10:180000:1': 130.14,
  'ffun:10:180000:2': 130.14,
  'ffun:10:180000:3': 130.14,
  'ffun:10:180000:4': 130.14,
  'ffun:10:180000:5': 130.14,
  'ffun:10:180000:6': 129.74,
  'ffun:10:180000:7': 129.74,
  'ffun:10:180000:8': 129.74,
  'ffun:10:180000:9': 129.74,
  'ffun:10:180000:10': 129.74,
  'ffun:10:180000:11': 129.89,
  'ffun:10:180000:12': 129.89,
  'ffun:10:180000:13': 129.89,
  'ffun:10:180000:14': 129.89,
  'ffun:10:180000:15': 129.89,
  'ffun:10:180000:16': 131.11,
  'ffun:10:180000:17': 131.11,
  'ffun:10:180000:18': 131.11,
  'ffun:10:180000:19': 131.11,
  'ffun:10:180000:20': 131.11,
  'ffun:10:180000:21': 135.28,
  'ffun:10:180000:22': 135.28,
  'ffun:10:180000:23': 135.28,
  'ffun:10:180000:24': 135.28,
  'ffun:10:180000:25': 135.28,
  'ffun:10:180000:26': 146.48,
  'ffun:10:180000:27': 146.48,
  'ffun:10:180000:28': 146.48,
  'ffun:10:180000:29': 146.48,
  'ffun:10:180000:30': 146.48,
  'ffun:10:180000:31': 183.42,
  'ffun:10:180000:32': 183.42,
  'ffun:10:180000:33': 183.42,
  'ffun:10:180000:34': 183.42,
  'ffun:10:180000:35': 183.42,
  'ffun:10:180000:36': 251.72,
  'ffun:10:180000:37': 251.72,
  'ffun:10:180000:38': 251.72,
  'ffun:10:180000:39': 251.72,
  'ffun:10:180000:40': 251.72,
  'ffun:10:180000:41': 395.79,
  'ffun:10:180000:42': 395.79,
  'ffun:10:180000:43': 395.79,
  'ffun:10:180000:44': 395.79,
  'ffun:10:180000:45': 395.79,
  'ffun:10:180000:46': 574.55,
  'ffun:10:180000:47': 574.55,
  'ffun:10:180000:48': 574.55,
  'ffun:10:180000:49': 574.55,
  'ffun:10:180000:50': 574.55,
  'ffun:10:180000:51': 958.97,
  'ffun:10:180000:52': 958.97,
  'ffun:10:180000:53': 958.97,
  'ffun:10:180000:54': 958.97,
  'ffun:10:180000:55': 958.97,
  'ffun:10:180000:56': 1123.78,
  'ffun:10:180000:57': 1123.78,
  'ffun:10:180000:58': 1123.78,
  'ffun:10:180000:59': 1123.78,
  'ffun:10:180000:60': 1123.78,
  'ffun:10:180000:61': 1351.68,
  'ffun:10:180000:62': 1351.68,
  'ffun:10:180000:63': 1351.68,
  'ffun:10:180000:64': 1351.68,
  'ffun:10:180000:65': 1351.68,
  'ffun:10:180000:66': 1738.05,
  'ffun:10:180000:67': 1738.05,
  'ffun:10:180000:68': 1738.05,
  'ffun:10:180000:69': 1738.05,
  'ffun:10:180000:70': 1738.05,
  'ffun:10:180000:71': 2427.76,
  'ffun:10:180000:72': 2427.76,
  'ffun:10:180000:73': 2427.76,
  'ffun:10:180000:74': 2427.76,
  'ffun:10:180000:75': 2427.76,
  'ffun:10:180000:76': 3350.06,
  'ffun:10:180000:77': 3350.06,
  'ffun:10:180000:78': 3350.06,
  'ffun:10:180000:79': 3350.06,
  'ffun:10:180000:80': 3350.06,
  'ffun:10:180000:81': 4813.92,
  'ffun:10:180000:82': 4813.92,
  'ffun:10:180000:83': 4813.92,
  'ffun:10:180000:84': 4813.92,
  'ffun:10:180000:85': 4813.92,
  'ffun:10:180000:86': 6557.03,
  'ffun:10:180000:87': 6557.03,
  'ffun:10:180000:88': 6557.03,
  'ffun:10:180000:89': 6557.03,
  'ffun:10:180000:90': 6557.03,
  'ffun:10:180000:91': 9059.97,
  'ffun:10:180000:92': 9059.97,
  'ffun:10:180000:93': 9059.97,
  'ffun:10:180000:94': 9059.97,
  'ffun:10:180000:95': 9059.97,
  'ffun:10:180000:96': 15428.28,
  'ffun:10:180000:97': 15428.28,
  'ffun:10:180000:98': 15428.28,
  'ffun:10:180000:99': 15428.28,
  'ffun:10:180000:100': 15428.28,
  'ffun:10:180000:101': 35114.05,
  'ffun:10:180000:102': 35114.05,
  'ffun:10:180000:103': 35114.05,
  'ffun:10:180000:104': 35114.05,
  'ffun:10:180000:105': 35114.05,
  'ffun:10:180000:106': 49934.48,
  'ffun:10:180000:107': 49934.48,
  'ffun:10:180000:108': 49934.48,
  'ffun:10:180000:109': 49934.48,
  'ffun:10:180000:110': 49934.48,
  'ffun:10:180000:111': 49934.48,
  'ffun:10:180000:112': 49934.48,
  'ffun:10:180000:113': 49934.48,
  'ffun:10:180000:114': 49934.48,
  'ffun:10:180000:115': 49934.48,
  'ffun:10:180000:116': 49934.48,
  'ffun:10:180000:117': 49934.48,
  'ffun:10:180000:118': 49934.48,
  'ffun:10:180000:119': 49934.48,
  'ffun:10:180000:120': 49934.48,
  'ffun:10:200000:1': 141.07,
  'ffun:10:200000:2': 141.07,
  'ffun:10:200000:3': 141.07,
  'ffun:10:200000:4': 141.07,
  'ffun:10:200000:5': 141.07,
  'ffun:10:200000:6': 140.62,
  'ffun:10:200000:7': 140.62,
  'ffun:10:200000:8': 140.62,
  'ffun:10:200000:9': 140.62,
  'ffun:10:200000:10': 140.62,
  'ffun:10:200000:11': 140.79,
  'ffun:10:200000:12': 140.79,
  'ffun:10:200000:13': 140.79,
  'ffun:10:200000:14': 140.79,
  'ffun:10:200000:15': 140.79,
  'ffun:10:200000:16': 142.15,
  'ffun:10:200000:17': 142.15,
  'ffun:10:200000:18': 142.15,
  'ffun:10:200000:19': 142.15,
  'ffun:10:200000:20': 142.15,
  'ffun:10:200000:21': 146.79,
  'ffun:10:200000:22': 146.79,
  'ffun:10:200000:23': 146.79,
  'ffun:10:200000:24': 146.79,
  'ffun:10:200000:25': 146.79,
  'ffun:10:200000:26': 159.21,
  'ffun:10:200000:27': 159.21,
  'ffun:10:200000:28': 159.21,
  'ffun:10:200000:29': 159.21,
  'ffun:10:200000:30': 159.21,
  'ffun:10:200000:31': 200.01,
  'ffun:10:200000:32': 200.01,
  'ffun:10:200000:33': 200.01,
  'ffun:10:200000:34': 200.01,
  'ffun:10:200000:35': 200.01,
  'ffun:10:200000:36': 275.73,
  'ffun:10:200000:37': 275.73,
  'ffun:10:200000:38': 275.73,
  'ffun:10:200000:39': 275.73,
  'ffun:10:200000:40': 275.73,
  'ffun:10:200000:41': 435.48,
  'ffun:10:200000:42': 435.48,
  'ffun:10:200000:43': 435.48,
  'ffun:10:200000:44': 435.48,
  'ffun:10:200000:45': 435.48,
  'ffun:10:200000:46': 634.28,
  'ffun:10:200000:47': 634.28,
  'ffun:10:200000:48': 634.28,
  'ffun:10:200000:49': 634.28,
  'ffun:10:200000:50': 634.28,
  'ffun:10:200000:51': 1060.89,
  'ffun:10:200000:52': 1060.89,
  'ffun:10:200000:53': 1060.89,
  'ffun:10:200000:54': 1060.89,
  'ffun:10:200000:55': 1060.89,
  'ffun:10:200000:56': 1244.54,
  'ffun:10:200000:57': 1244.54,
  'ffun:10:200000:58': 1244.54,
  'ffun:10:200000:59': 1244.54,
  'ffun:10:200000:60': 1244.54,
  'ffun:10:200000:61': 1498.35,
  'ffun:10:200000:62': 1498.35,
  'ffun:10:200000:63': 1498.35,
  'ffun:10:200000:64': 1498.35,
  'ffun:10:200000:65': 1498.35,
  'ffun:10:200000:66': 1928.3,
  'ffun:10:200000:67': 1928.3,
  'ffun:10:200000:68': 1928.3,
  'ffun:10:200000:69': 1928.3,
  'ffun:10:200000:70': 1928.3,
  'ffun:10:200000:71': 2695.09,
  'ffun:10:200000:72': 2695.09,
  'ffun:10:200000:73': 2695.09,
  'ffun:10:200000:74': 2695.09,
  'ffun:10:200000:75': 2695.09,
  'ffun:10:200000:76': 3720.47,
  'ffun:10:200000:77': 3720.47,
  'ffun:10:200000:78': 3720.47,
  'ffun:10:200000:79': 3720.47,
  'ffun:10:200000:80': 3720.47,
  'ffun:10:200000:81': 5347.63,
  'ffun:10:200000:82': 5347.63,
  'ffun:10:200000:83': 5347.63,
  'ffun:10:200000:84': 5347.63,
  'ffun:10:200000:85': 5347.63,
  'ffun:10:200000:86': 7285.16,
  'ffun:10:200000:87': 7285.16,
  'ffun:10:200000:88': 7285.16,
  'ffun:10:200000:89': 7285.16,
  'ffun:10:200000:90': 7285.16,
  'ffun:10:200000:91': 10067.34,
  'ffun:10:200000:92': 10067.34,
  'ffun:10:200000:93': 10067.34,
  'ffun:10:200000:94': 10067.34,
  'ffun:10:200000:95': 10067.34,
  'ffun:10:200000:96': 17146.32,
  'ffun:10:200000:97': 17146.32,
  'ffun:10:200000:98': 17146.32,
  'ffun:10:200000:99': 17146.32,
  'ffun:10:200000:100': 17146.32,
  'ffun:10:200000:101': 39028,
  'ffun:10:200000:102': 39028,
  'ffun:10:200000:103': 39028,
  'ffun:10:200000:104': 39028,
  'ffun:10:200000:105': 39028,
  'ffun:10:200000:106': 55501.44,
  'ffun:10:200000:107': 55501.44,
  'ffun:10:200000:108': 55501.44,
  'ffun:10:200000:109': 55501.44,
  'ffun:10:200000:110': 55501.44,
  'ffun:10:200000:111': 55501.44,
  'ffun:10:200000:112': 55501.44,
  'ffun:10:200000:113': 55501.44,
  'ffun:10:200000:114': 55501.44,
  'ffun:10:200000:115': 55501.44,
  'ffun:10:200000:116': 55501.44,
  'ffun:10:200000:117': 55501.44,
  'ffun:10:200000:118': 55501.44,
  'ffun:10:200000:119': 55501.44,
  'ffun:10:200000:120': 55501.44,
  'mem:10:5000:1': 2.4,
  'mem:10:5000:2': 2.4,
  'mem:10:5000:3': 2.4,
  'mem:10:5000:4': 2.4,
  'mem:10:5000:5': 2.4,
  'mem:10:5000:6': 2.4,
  'mem:10:5000:7': 2.4,
  'mem:10:5000:8': 2.4,
  'mem:10:5000:9': 2.4,
  'mem:10:5000:10': 2.4,
  'mem:10:5000:11': 2.4,
  'mem:10:5000:12': 2.4,
  'mem:10:5000:13': 2.4,
  'mem:10:5000:14': 2.4,
  'mem:10:5000:15': 2.4,
  'mem:10:5000:16': 2.4,
  'mem:10:5000:17': 2.4,
  'mem:10:5000:18': 2.4,
  'mem:10:5000:19': 2.4,
  'mem:10:5000:20': 2.4,
  'mem:10:5000:21': 2.4,
  'mem:10:5000:22': 2.4,
  'mem:10:5000:23': 2.4,
  'mem:10:5000:24': 2.4,
  'mem:10:5000:25': 2.4,
  'mem:10:5000:26': 2.4,
  'mem:10:5000:27': 2.4,
  'mem:10:5000:28': 2.4,
  'mem:10:5000:29': 2.4,
  'mem:10:5000:30': 2.4,
  'mem:10:5000:31': 3.6,
  'mem:10:5000:32': 3.6,
  'mem:10:5000:33': 3.6,
  'mem:10:5000:34': 3.6,
  'mem:10:5000:35': 3.6,
  'mem:10:5000:36': 4.8,
  'mem:10:5000:37': 4.8,
  'mem:10:5000:38': 4.8,
  'mem:10:5000:39': 4.8,
  'mem:10:5000:40': 4.8,
  'mem:10:5000:41': 7.2,
  'mem:10:5000:42': 7.2,
  'mem:10:5000:43': 7.2,
  'mem:10:5000:44': 7.2,
  'mem:10:5000:45': 7.2,
  'mem:10:5000:46': 9.6,
  'mem:10:5000:47': 9.6,
  'mem:10:5000:48': 9.6,
  'mem:10:5000:49': 9.6,
  'mem:10:5000:50': 9.6,
  'mem:10:5000:51': 14.4,
  'mem:10:5000:52': 14.4,
  'mem:10:5000:53': 14.4,
  'mem:10:5000:54': 14.4,
  'mem:10:5000:55': 14.4,
  'mem:10:5000:56': 15.6,
  'mem:10:5000:57': 15.6,
  'mem:10:5000:58': 15.6,
  'mem:10:5000:59': 15.6,
  'mem:10:5000:60': 15.6,
  'mem:10:5000:61': 16.8,
  'mem:10:5000:62': 16.8,
  'mem:10:5000:63': 16.8,
  'mem:10:5000:64': 16.8,
  'mem:10:5000:65': 16.8,
  'mem:10:5000:66': 24,
  'mem:10:5000:67': 24,
  'mem:10:5000:68': 24,
  'mem:10:5000:69': 24,
  'mem:10:5000:70': 24,
  'mem:10:5000:71': 31.2,
  'mem:10:5000:72': 31.2,
  'mem:10:5000:73': 31.2,
  'mem:10:5000:74': 31.2,
  'mem:10:5000:75': 31.2,
  'mem:10:5000:76': 42,
  'mem:10:5000:77': 42,
  'mem:10:5000:78': 42,
  'mem:10:5000:79': 42,
  'mem:10:5000:80': 42,
  'mem:10:5000:81': 56.54,
  'mem:10:5000:82': 56.54,
  'mem:10:5000:83': 56.54,
  'mem:10:5000:84': 56.54,
  'mem:10:5000:85': 56.54,
  'mem:10:5000:86': 75.66,
  'mem:10:5000:87': 75.66,
  'mem:10:5000:88': 75.66,
  'mem:10:5000:89': 75.66,
  'mem:10:5000:90': 75.66,
  'mem:10:5000:91': 102.09,
  'mem:10:5000:92': 102.09,
  'mem:10:5000:93': 102.09,
  'mem:10:5000:94': 102.09,
  'mem:10:5000:95': 102.09,
  'mem:10:5000:96': 165.66,
  'mem:10:5000:97': 165.66,
  'mem:10:5000:98': 165.66,
  'mem:10:5000:99': 165.66,
  'mem:10:5000:100': 165.66,
  'mem:10:5000:101': 288.43,
  'mem:10:5000:102': 288.43,
  'mem:10:5000:103': 288.43,
  'mem:10:5000:104': 288.43,
  'mem:10:5000:105': 288.43,
  'mem:10:5000:106': 363.5,
  'mem:10:5000:107': 363.5,
  'mem:10:5000:108': 363.5,
  'mem:10:5000:109': 363.5,
  'mem:10:5000:110': 363.5,
  'mem:10:5000:111': 363.69,
  'mem:10:5000:112': 363.69,
  'mem:10:5000:113': 363.69,
  'mem:10:5000:114': 363.69,
  'mem:10:5000:115': 363.69,
  'mem:10:5000:116': 363.69,
  'mem:10:5000:117': 363.69,
  'mem:10:5000:118': 363.69,
  'mem:10:5000:119': 363.69,
  'mem:10:5000:120': 363.69,
  'mem:10:7500:1': 2.4,
  'mem:10:7500:2': 2.4,
  'mem:10:7500:3': 2.4,
  'mem:10:7500:4': 2.4,
  'mem:10:7500:5': 2.4,
  'mem:10:7500:6': 2.4,
  'mem:10:7500:7': 2.4,
  'mem:10:7500:8': 2.4,
  'mem:10:7500:9': 2.4,
  'mem:10:7500:10': 2.4,
  'mem:10:7500:11': 2.4,
  'mem:10:7500:12': 2.4,
  'mem:10:7500:13': 2.4,
  'mem:10:7500:14': 2.4,
  'mem:10:7500:15': 2.4,
  'mem:10:7500:16': 2.4,
  'mem:10:7500:17': 2.4,
  'mem:10:7500:18': 2.4,
  'mem:10:7500:19': 2.4,
  'mem:10:7500:20': 2.4,
  'mem:10:7500:21': 2.4,
  'mem:10:7500:22': 2.4,
  'mem:10:7500:23': 2.4,
  'mem:10:7500:24': 2.4,
  'mem:10:7500:25': 2.4,
  'mem:10:7500:26': 3.6,
  'mem:10:7500:27': 3.6,
  'mem:10:7500:28': 3.6,
  'mem:10:7500:29': 3.6,
  'mem:10:7500:30': 3.6,
  'mem:10:7500:31': 4.8,
  'mem:10:7500:32': 4.8,
  'mem:10:7500:33': 4.8,
  'mem:10:7500:34': 4.8,
  'mem:10:7500:35': 4.8,
  'mem:10:7500:36': 6,
  'mem:10:7500:37': 6,
  'mem:10:7500:38': 6,
  'mem:10:7500:39': 6,
  'mem:10:7500:40': 6,
  'mem:10:7500:41': 9.6,
  'mem:10:7500:42': 9.6,
  'mem:10:7500:43': 9.6,
  'mem:10:7500:44': 9.6,
  'mem:10:7500:45': 9.6,
  'mem:10:7500:46': 14.4,
  'mem:10:7500:47': 14.4,
  'mem:10:7500:48': 14.4,
  'mem:10:7500:49': 14.4,
  'mem:10:7500:50': 14.4,
  'mem:10:7500:51': 21.6,
  'mem:10:7500:52': 21.6,
  'mem:10:7500:53': 21.6,
  'mem:10:7500:54': 21.6,
  'mem:10:7500:55': 21.6,
  'mem:10:7500:56': 22.8,
  'mem:10:7500:57': 22.8,
  'mem:10:7500:58': 22.8,
  'mem:10:7500:59': 22.8,
  'mem:10:7500:60': 22.8,
  'mem:10:7500:61': 25.2,
  'mem:10:7500:62': 25.2,
  'mem:10:7500:63': 25.2,
  'mem:10:7500:64': 25.2,
  'mem:10:7500:65': 25.2,
  'mem:10:7500:66': 34.8,
  'mem:10:7500:67': 34.8,
  'mem:10:7500:68': 34.8,
  'mem:10:7500:69': 34.8,
  'mem:10:7500:70': 34.8,
  'mem:10:7500:71': 46.8,
  'mem:10:7500:72': 46.8,
  'mem:10:7500:73': 46.8,
  'mem:10:7500:74': 46.8,
  'mem:10:7500:75': 46.8,
  'mem:10:7500:76': 62.4,
  'mem:10:7500:77': 62.4,
  'mem:10:7500:78': 62.4,
  'mem:10:7500:79': 62.4,
  'mem:10:7500:80': 62.4,
  'mem:10:7500:81': 84.78,
  'mem:10:7500:82': 84.78,
  'mem:10:7500:83': 84.78,
  'mem:10:7500:84': 84.78,
  'mem:10:7500:85': 84.78,
  'mem:10:7500:86': 113.44,
  'mem:10:7500:87': 113.44,
  'mem:10:7500:88': 113.44,
  'mem:10:7500:89': 113.44,
  'mem:10:7500:90': 113.44,
  'mem:10:7500:91': 153.05,
  'mem:10:7500:92': 153.05,
  'mem:10:7500:93': 153.05,
  'mem:10:7500:94': 153.05,
  'mem:10:7500:95': 153.05,
  'mem:10:7500:96': 248.39,
  'mem:10:7500:97': 248.39,
  'mem:10:7500:98': 248.39,
  'mem:10:7500:99': 248.39,
  'mem:10:7500:100': 248.39,
  'mem:10:7500:101': 432.61,
  'mem:10:7500:102': 432.61,
  'mem:10:7500:103': 432.61,
  'mem:10:7500:104': 432.61,
  'mem:10:7500:105': 432.61,
  'mem:10:7500:106': 544.99,
  'mem:10:7500:107': 544.99,
  'mem:10:7500:108': 544.99,
  'mem:10:7500:109': 544.99,
  'mem:10:7500:110': 544.99,
  'mem:10:7500:111': 544.99,
  'mem:10:7500:112': 544.99,
  'mem:10:7500:113': 544.99,
  'mem:10:7500:114': 544.99,
  'mem:10:7500:115': 544.99,
  'mem:10:7500:116': 544.99,
  'mem:10:7500:117': 544.99,
  'mem:10:7500:118': 544.99,
  'mem:10:7500:119': 544.99,
  'mem:10:7500:120': 544.99,
  'mem:10:10000:1': 3.6,
  'mem:10:10000:2': 3.6,
  'mem:10:10000:3': 3.6,
  'mem:10:10000:4': 3.6,
  'mem:10:10000:5': 3.6,
  'mem:10:10000:6': 3.6,
  'mem:10:10000:7': 3.6,
  'mem:10:10000:8': 3.6,
  'mem:10:10000:9': 3.6,
  'mem:10:10000:10': 3.6,
  'mem:10:10000:11': 3.6,
  'mem:10:10000:12': 3.6,
  'mem:10:10000:13': 3.6,
  'mem:10:10000:14': 3.6,
  'mem:10:10000:15': 3.6,
  'mem:10:10000:16': 3.6,
  'mem:10:10000:17': 3.6,
  'mem:10:10000:18': 3.6,
  'mem:10:10000:19': 3.6,
  'mem:10:10000:20': 3.6,
  'mem:10:10000:21': 3.6,
  'mem:10:10000:22': 3.6,
  'mem:10:10000:23': 3.6,
  'mem:10:10000:24': 3.6,
  'mem:10:10000:25': 3.6,
  'mem:10:10000:26': 4.8,
  'mem:10:10000:27': 4.8,
  'mem:10:10000:28': 4.8,
  'mem:10:10000:29': 4.8,
  'mem:10:10000:30': 4.8,
  'mem:10:10000:31': 6,
  'mem:10:10000:32': 6,
  'mem:10:10000:33': 6,
  'mem:10:10000:34': 6,
  'mem:10:10000:35': 6,
  'mem:10:10000:36': 8.4,
  'mem:10:10000:37': 8.4,
  'mem:10:10000:38': 8.4,
  'mem:10:10000:39': 8.4,
  'mem:10:10000:40': 8.4,
  'mem:10:10000:41': 13.2,
  'mem:10:10000:42': 13.2,
  'mem:10:10000:43': 13.2,
  'mem:10:10000:44': 13.2,
  'mem:10:10000:45': 13.2,
  'mem:10:10000:46': 19.2,
  'mem:10:10000:47': 19.2,
  'mem:10:10000:48': 19.2,
  'mem:10:10000:49': 19.2,
  'mem:10:10000:50': 19.2,
  'mem:10:10000:51': 28.8,
  'mem:10:10000:52': 28.8,
  'mem:10:10000:53': 28.8,
  'mem:10:10000:54': 28.8,
  'mem:10:10000:55': 28.8,
  'mem:10:10000:56': 30,
  'mem:10:10000:57': 30,
  'mem:10:10000:58': 30,
  'mem:10:10000:59': 30,
  'mem:10:10000:60': 30,
  'mem:10:10000:61': 32.4,
  'mem:10:10000:62': 32.4,
  'mem:10:10000:63': 32.4,
  'mem:10:10000:64': 32.4,
  'mem:10:10000:65': 32.4,
  'mem:10:10000:66': 46.8,
  'mem:10:10000:67': 46.8,
  'mem:10:10000:68': 46.8,
  'mem:10:10000:69': 46.8,
  'mem:10:10000:70': 46.8,
  'mem:10:10000:71': 62.4,
  'mem:10:10000:72': 62.4,
  'mem:10:10000:73': 62.4,
  'mem:10:10000:74': 62.4,
  'mem:10:10000:75': 62.4,
  'mem:10:10000:76': 82.8,
  'mem:10:10000:77': 82.8,
  'mem:10:10000:78': 82.8,
  'mem:10:10000:79': 82.8,
  'mem:10:10000:80': 82.8,
  'mem:10:10000:81': 113.02,
  'mem:10:10000:82': 113.02,
  'mem:10:10000:83': 113.02,
  'mem:10:10000:84': 113.02,
  'mem:10:10000:85': 113.02,
  'mem:10:10000:86': 151.22,
  'mem:10:10000:87': 151.22,
  'mem:10:10000:88': 151.22,
  'mem:10:10000:89': 151.22,
  'mem:10:10000:90': 151.22,
  'mem:10:10000:91': 204.04,
  'mem:10:10000:92': 204.04,
  'mem:10:10000:93': 204.04,
  'mem:10:10000:94': 204.04,
  'mem:10:10000:95': 204.04,
  'mem:10:10000:96': 331.13,
  'mem:10:10000:97': 331.13,
  'mem:10:10000:98': 331.13,
  'mem:10:10000:99': 331.13,
  'mem:10:10000:100': 331.13,
  'mem:10:10000:101': 576.74,
  'mem:10:10000:102': 576.74,
  'mem:10:10000:103': 576.74,
  'mem:10:10000:104': 576.74,
  'mem:10:10000:105': 576.74,
  'mem:10:10000:106': 726.54,
  'mem:10:10000:107': 726.54,
  'mem:10:10000:108': 726.54,
  'mem:10:10000:109': 726.54,
  'mem:10:10000:110': 726.54,
  'mem:10:10000:111': 726.54,
  'mem:10:10000:112': 726.54,
  'mem:10:10000:113': 726.54,
  'mem:10:10000:114': 726.54,
  'mem:10:10000:115': 726.54,
  'mem:10:10000:116': 726.54,
  'mem:10:10000:117': 726.54,
  'mem:10:10000:118': 726.54,
  'mem:10:10000:119': 726.54,
  'mem:10:10000:120': 726.54,
  'mem:10:15000:1': 4.8,
  'mem:10:15000:2': 4.8,
  'mem:10:15000:3': 4.8,
  'mem:10:15000:4': 4.8,
  'mem:10:15000:5': 4.8,
  'mem:10:15000:6': 4.8,
  'mem:10:15000:7': 4.8,
  'mem:10:15000:8': 4.8,
  'mem:10:15000:9': 4.8,
  'mem:10:15000:10': 4.8,
  'mem:10:15000:11': 4.8,
  'mem:10:15000:12': 4.8,
  'mem:10:15000:13': 4.8,
  'mem:10:15000:14': 4.8,
  'mem:10:15000:15': 4.8,
  'mem:10:15000:16': 4.8,
  'mem:10:15000:17': 4.8,
  'mem:10:15000:18': 4.8,
  'mem:10:15000:19': 4.8,
  'mem:10:15000:20': 4.8,
  'mem:10:15000:21': 4.8,
  'mem:10:15000:22': 4.8,
  'mem:10:15000:23': 4.8,
  'mem:10:15000:24': 4.8,
  'mem:10:15000:25': 4.8,
  'mem:10:15000:26': 6,
  'mem:10:15000:27': 6,
  'mem:10:15000:28': 6,
  'mem:10:15000:29': 6,
  'mem:10:15000:30': 6,
  'mem:10:15000:31': 8.4,
  'mem:10:15000:32': 8.4,
  'mem:10:15000:33': 8.4,
  'mem:10:15000:34': 8.4,
  'mem:10:15000:35': 8.4,
  'mem:10:15000:36': 12,
  'mem:10:15000:37': 12,
  'mem:10:15000:38': 12,
  'mem:10:15000:39': 12,
  'mem:10:15000:40': 12,
  'mem:10:15000:41': 19.2,
  'mem:10:15000:42': 19.2,
  'mem:10:15000:43': 19.2,
  'mem:10:15000:44': 19.2,
  'mem:10:15000:45': 19.2,
  'mem:10:15000:46': 28.8,
  'mem:10:15000:47': 28.8,
  'mem:10:15000:48': 28.8,
  'mem:10:15000:49': 28.8,
  'mem:10:15000:50': 28.8,
  'mem:10:15000:51': 42,
  'mem:10:15000:52': 42,
  'mem:10:15000:53': 42,
  'mem:10:15000:54': 42,
  'mem:10:15000:55': 42,
  'mem:10:15000:56': 45.6,
  'mem:10:15000:57': 45.6,
  'mem:10:15000:58': 45.6,
  'mem:10:15000:59': 45.6,
  'mem:10:15000:60': 45.6,
  'mem:10:15000:61': 49.2,
  'mem:10:15000:62': 49.2,
  'mem:10:15000:63': 49.2,
  'mem:10:15000:64': 49.2,
  'mem:10:15000:65': 49.2,
  'mem:10:15000:66': 69.6,
  'mem:10:15000:67': 69.6,
  'mem:10:15000:68': 69.6,
  'mem:10:15000:69': 69.6,
  'mem:10:15000:70': 69.6,
  'mem:10:15000:71': 93.6,
  'mem:10:15000:72': 93.6,
  'mem:10:15000:73': 93.6,
  'mem:10:15000:74': 93.6,
  'mem:10:15000:75': 93.6,
  'mem:10:15000:76': 123.6,
  'mem:10:15000:77': 123.6,
  'mem:10:15000:78': 123.6,
  'mem:10:15000:79': 123.6,
  'mem:10:15000:80': 123.6,
  'mem:10:15000:81': 169.56,
  'mem:10:15000:82': 169.56,
  'mem:10:15000:83': 169.56,
  'mem:10:15000:84': 169.56,
  'mem:10:15000:85': 169.56,
  'mem:10:15000:86': 226.87,
  'mem:10:15000:87': 226.87,
  'mem:10:15000:88': 226.87,
  'mem:10:15000:89': 226.87,
  'mem:10:15000:90': 226.87,
  'mem:10:15000:91': 306.1,
  'mem:10:15000:92': 306.1,
  'mem:10:15000:93': 306.1,
  'mem:10:15000:94': 306.1,
  'mem:10:15000:95': 306.1,
  'mem:10:15000:96': 496.77,
  'mem:10:15000:97': 496.77,
  'mem:10:15000:98': 496.77,
  'mem:10:15000:99': 496.77,
  'mem:10:15000:100': 496.77,
  'mem:10:15000:101': 865.23,
  'mem:10:15000:102': 865.23,
  'mem:10:15000:103': 865.23,
  'mem:10:15000:104': 865.23,
  'mem:10:15000:105': 865.23,
  'mem:10:15000:106': 1089.97,
  'mem:10:15000:107': 1089.97,
  'mem:10:15000:108': 1089.97,
  'mem:10:15000:109': 1089.97,
  'mem:10:15000:110': 1089.97,
  'mem:10:15000:111': 1089.97,
  'mem:10:15000:112': 1089.97,
  'mem:10:15000:113': 1089.97,
  'mem:10:15000:114': 1089.97,
  'mem:10:15000:115': 1089.97,
  'mem:10:15000:116': 1089.97,
  'mem:10:15000:117': 1089.97,
  'mem:10:15000:118': 1089.97,
  'mem:10:15000:119': 1089.97,
  'mem:10:15000:120': 1089.97,
  'mem:10:20000:1': 6,
  'mem:10:20000:2': 6,
  'mem:10:20000:3': 6,
  'mem:10:20000:4': 6,
  'mem:10:20000:5': 6,
  'mem:10:20000:6': 6,
  'mem:10:20000:7': 6,
  'mem:10:20000:8': 6,
  'mem:10:20000:9': 6,
  'mem:10:20000:10': 6,
  'mem:10:20000:11': 6,
  'mem:10:20000:12': 6,
  'mem:10:20000:13': 6,
  'mem:10:20000:14': 6,
  'mem:10:20000:15': 6,
  'mem:10:20000:16': 6,
  'mem:10:20000:17': 6,
  'mem:10:20000:18': 6,
  'mem:10:20000:19': 6,
  'mem:10:20000:20': 6,
  'mem:10:20000:21': 7.2,
  'mem:10:20000:22': 7.2,
  'mem:10:20000:23': 7.2,
  'mem:10:20000:24': 7.2,
  'mem:10:20000:25': 7.2,
  'mem:10:20000:26': 8.4,
  'mem:10:20000:27': 8.4,
  'mem:10:20000:28': 8.4,
  'mem:10:20000:29': 8.4,
  'mem:10:20000:30': 8.4,
  'mem:10:20000:31': 10.8,
  'mem:10:20000:32': 10.8,
  'mem:10:20000:33': 10.8,
  'mem:10:20000:34': 10.8,
  'mem:10:20000:35': 10.8,
  'mem:10:20000:36': 15.6,
  'mem:10:20000:37': 15.6,
  'mem:10:20000:38': 15.6,
  'mem:10:20000:39': 15.6,
  'mem:10:20000:40': 15.6,
  'mem:10:20000:41': 25.2,
  'mem:10:20000:42': 25.2,
  'mem:10:20000:43': 25.2,
  'mem:10:20000:44': 25.2,
  'mem:10:20000:45': 25.2,
  'mem:10:20000:46': 37.2,
  'mem:10:20000:47': 37.2,
  'mem:10:20000:48': 37.2,
  'mem:10:20000:49': 37.2,
  'mem:10:20000:50': 37.2,
  'mem:10:20000:51': 56.4,
  'mem:10:20000:52': 56.4,
  'mem:10:20000:53': 56.4,
  'mem:10:20000:54': 56.4,
  'mem:10:20000:55': 56.4,
  'mem:10:20000:56': 60,
  'mem:10:20000:57': 60,
  'mem:10:20000:58': 60,
  'mem:10:20000:59': 60,
  'mem:10:20000:60': 60,
  'mem:10:20000:61': 64.8,
  'mem:10:20000:62': 64.8,
  'mem:10:20000:63': 64.8,
  'mem:10:20000:64': 64.8,
  'mem:10:20000:65': 64.8,
  'mem:10:20000:66': 92.4,
  'mem:10:20000:67': 92.4,
  'mem:10:20000:68': 92.4,
  'mem:10:20000:69': 92.4,
  'mem:10:20000:70': 92.4,
  'mem:10:20000:71': 123.6,
  'mem:10:20000:72': 123.6,
  'mem:10:20000:73': 123.6,
  'mem:10:20000:74': 123.6,
  'mem:10:20000:75': 123.6,
  'mem:10:20000:76': 164.4,
  'mem:10:20000:77': 164.4,
  'mem:10:20000:78': 164.4,
  'mem:10:20000:79': 164.4,
  'mem:10:20000:80': 164.4,
  'mem:10:20000:81': 226.04,
  'mem:10:20000:82': 226.04,
  'mem:10:20000:83': 226.04,
  'mem:10:20000:84': 226.04,
  'mem:10:20000:85': 226.04,
  'mem:10:20000:86': 302.44,
  'mem:10:20000:87': 302.44,
  'mem:10:20000:88': 302.44,
  'mem:10:20000:89': 302.44,
  'mem:10:20000:90': 302.44,
  'mem:10:20000:91': 408.07,
  'mem:10:20000:92': 408.07,
  'mem:10:20000:93': 408.07,
  'mem:10:20000:94': 408.07,
  'mem:10:20000:95': 408.07,
  'mem:10:20000:96': 662.27,
  'mem:10:20000:97': 662.27,
  'mem:10:20000:98': 662.27,
  'mem:10:20000:99': 662.27,
  'mem:10:20000:100': 662.27,
  'mem:10:20000:101': 1153.47,
  'mem:10:20000:102': 1153.47,
  'mem:10:20000:103': 1153.47,
  'mem:10:20000:104': 1153.47,
  'mem:10:20000:105': 1153.47,
  'mem:10:20000:106': 1453.09,
  'mem:10:20000:107': 1453.09,
  'mem:10:20000:108': 1453.09,
  'mem:10:20000:109': 1453.09,
  'mem:10:20000:110': 1453.09,
  'mem:10:20000:111': 1453.09,
  'mem:10:20000:112': 1453.09,
  'mem:10:20000:113': 1453.09,
  'mem:10:20000:114': 1453.09,
  'mem:10:20000:115': 1453.09,
  'mem:10:20000:116': 1453.09,
  'mem:10:20000:117': 1453.09,
  'mem:10:20000:118': 1453.09,
  'mem:10:20000:119': 1453.09,
  'mem:10:20000:120': 1453.09,
  'mem:10:25000:1': 7.2,
  'mem:10:25000:2': 7.2,
  'mem:10:25000:3': 7.2,
  'mem:10:25000:4': 7.2,
  'mem:10:25000:5': 7.2,
  'mem:10:25000:6': 7.2,
  'mem:10:25000:7': 7.2,
  'mem:10:25000:8': 7.2,
  'mem:10:25000:9': 7.2,
  'mem:10:25000:10': 7.2,
  'mem:10:25000:11': 7.2,
  'mem:10:25000:12': 7.2,
  'mem:10:25000:13': 7.2,
  'mem:10:25000:14': 7.2,
  'mem:10:25000:15': 7.2,
  'mem:10:25000:16': 7.2,
  'mem:10:25000:17': 7.2,
  'mem:10:25000:18': 7.2,
  'mem:10:25000:19': 7.2,
  'mem:10:25000:20': 7.2,
  'mem:10:25000:21': 8.4,
  'mem:10:25000:22': 8.4,
  'mem:10:25000:23': 8.4,
  'mem:10:25000:24': 8.4,
  'mem:10:25000:25': 8.4,
  'mem:10:25000:26': 9.6,
  'mem:10:25000:27': 9.6,
  'mem:10:25000:28': 9.6,
  'mem:10:25000:29': 9.6,
  'mem:10:25000:30': 9.6,
  'mem:10:25000:31': 13.2,
  'mem:10:25000:32': 13.2,
  'mem:10:25000:33': 13.2,
  'mem:10:25000:34': 13.2,
  'mem:10:25000:35': 13.2,
  'mem:10:25000:36': 19.2,
  'mem:10:25000:37': 19.2,
  'mem:10:25000:38': 19.2,
  'mem:10:25000:39': 19.2,
  'mem:10:25000:40': 19.2,
  'mem:10:25000:41': 31.2,
  'mem:10:25000:42': 31.2,
  'mem:10:25000:43': 31.2,
  'mem:10:25000:44': 31.2,
  'mem:10:25000:45': 31.2,
  'mem:10:25000:46': 46.8,
  'mem:10:25000:47': 46.8,
  'mem:10:25000:48': 46.8,
  'mem:10:25000:49': 46.8,
  'mem:10:25000:50': 46.8,
  'mem:10:25000:51': 69.6,
  'mem:10:25000:52': 69.6,
  'mem:10:25000:53': 69.6,
  'mem:10:25000:54': 69.6,
  'mem:10:25000:55': 69.6,
  'mem:10:25000:56': 75.6,
  'mem:10:25000:57': 75.6,
  'mem:10:25000:58': 75.6,
  'mem:10:25000:59': 75.6,
  'mem:10:25000:60': 75.6,
  'mem:10:25000:61': 81.6,
  'mem:10:25000:62': 81.6,
  'mem:10:25000:63': 81.6,
  'mem:10:25000:64': 81.6,
  'mem:10:25000:65': 81.6,
  'mem:10:25000:66': 115.2,
  'mem:10:25000:67': 115.2,
  'mem:10:25000:68': 115.2,
  'mem:10:25000:69': 115.2,
  'mem:10:25000:70': 115.2,
  'mem:10:25000:71': 154.8,
  'mem:10:25000:72': 154.8,
  'mem:10:25000:73': 154.8,
  'mem:10:25000:74': 154.8,
  'mem:10:25000:75': 154.8,
  'mem:10:25000:76': 205.2,
  'mem:10:25000:77': 205.2,
  'mem:10:25000:78': 205.2,
  'mem:10:25000:79': 205.2,
  'mem:10:25000:80': 205.2,
  'mem:10:25000:81': 282.63,
  'mem:10:25000:82': 282.63,
  'mem:10:25000:83': 282.63,
  'mem:10:25000:84': 282.63,
  'mem:10:25000:85': 282.63,
  'mem:10:25000:86': 378.16,
  'mem:10:25000:87': 378.16,
  'mem:10:25000:88': 378.16,
  'mem:10:25000:89': 378.16,
  'mem:10:25000:90': 378.16,
  'mem:10:25000:91': 510.22,
  'mem:10:25000:92': 510.22,
  'mem:10:25000:93': 510.22,
  'mem:10:25000:94': 510.22,
  'mem:10:25000:95': 510.22,
  'mem:10:25000:96': 828.03,
  'mem:10:25000:97': 828.03,
  'mem:10:25000:98': 828.03,
  'mem:10:25000:99': 828.03,
  'mem:10:25000:100': 828.03,
  'mem:10:25000:101': 1440.02,
  'mem:10:25000:102': 1440.02,
  'mem:10:25000:103': 1440.02,
  'mem:10:25000:104': 1440.02,
  'mem:10:25000:105': 1440.02,
  'mem:10:25000:106': 1812.47,
  'mem:10:25000:107': 1812.47,
  'mem:10:25000:108': 1812.47,
  'mem:10:25000:109': 1812.47,
  'mem:10:25000:110': 1812.47,
  'mem:10:25000:111': 1812.47,
  'mem:10:25000:112': 1812.47,
  'mem:10:25000:113': 1812.47,
  'mem:10:25000:114': 1812.47,
  'mem:10:25000:115': 1812.47,
  'mem:10:25000:116': 1812.47,
  'mem:10:25000:117': 1812.47,
  'mem:10:25000:118': 1812.47,
  'mem:10:25000:119': 1812.47,
  'mem:10:25000:120': 1812.47,
  'mem:10:30000:1': 8.4,
  'mem:10:30000:2': 8.4,
  'mem:10:30000:3': 8.4,
  'mem:10:30000:4': 8.4,
  'mem:10:30000:5': 8.4,
  'mem:10:30000:6': 8.4,
  'mem:10:30000:7': 8.4,
  'mem:10:30000:8': 8.4,
  'mem:10:30000:9': 8.4,
  'mem:10:30000:10': 8.4,
  'mem:10:30000:11': 8.4,
  'mem:10:30000:12': 8.4,
  'mem:10:30000:13': 8.4,
  'mem:10:30000:14': 8.4,
  'mem:10:30000:15': 8.4,
  'mem:10:30000:16': 8.4,
  'mem:10:30000:17': 8.4,
  'mem:10:30000:18': 8.4,
  'mem:10:30000:19': 8.4,
  'mem:10:30000:20': 8.4,
  'mem:10:30000:21': 9.6,
  'mem:10:30000:22': 9.6,
  'mem:10:30000:23': 9.6,
  'mem:10:30000:24': 9.6,
  'mem:10:30000:25': 9.6,
  'mem:10:30000:26': 12,
  'mem:10:30000:27': 12,
  'mem:10:30000:28': 12,
  'mem:10:30000:29': 12,
  'mem:10:30000:30': 12,
  'mem:10:30000:31': 15.6,
  'mem:10:30000:32': 15.6,
  'mem:10:30000:33': 15.6,
  'mem:10:30000:34': 15.6,
  'mem:10:30000:35': 15.6,
  'mem:10:30000:36': 24,
  'mem:10:30000:37': 24,
  'mem:10:30000:38': 24,
  'mem:10:30000:39': 24,
  'mem:10:30000:40': 24,
  'mem:10:30000:41': 37.2,
  'mem:10:30000:42': 37.2,
  'mem:10:30000:43': 37.2,
  'mem:10:30000:44': 37.2,
  'mem:10:30000:45': 37.2,
  'mem:10:30000:46': 56.4,
  'mem:10:30000:47': 56.4,
  'mem:10:30000:48': 56.4,
  'mem:10:30000:49': 56.4,
  'mem:10:30000:50': 56.4,
  'mem:10:30000:51': 84,
  'mem:10:30000:52': 84,
  'mem:10:30000:53': 84,
  'mem:10:30000:54': 84,
  'mem:10:30000:55': 84,
  'mem:10:30000:56': 90,
  'mem:10:30000:57': 90,
  'mem:10:30000:58': 90,
  'mem:10:30000:59': 90,
  'mem:10:30000:60': 90,
  'mem:10:30000:61': 97.2,
  'mem:10:30000:62': 97.2,
  'mem:10:30000:63': 97.2,
  'mem:10:30000:64': 97.2,
  'mem:10:30000:65': 97.2,
  'mem:10:30000:66': 138,
  'mem:10:30000:67': 138,
  'mem:10:30000:68': 138,
  'mem:10:30000:69': 138,
  'mem:10:30000:70': 138,
  'mem:10:30000:71': 186,
  'mem:10:30000:72': 186,
  'mem:10:30000:73': 186,
  'mem:10:30000:74': 186,
  'mem:10:30000:75': 186,
  'mem:10:30000:76': 246,
  'mem:10:30000:77': 246,
  'mem:10:30000:78': 246,
  'mem:10:30000:79': 246,
  'mem:10:30000:80': 246,
  'mem:10:30000:81': 338.83,
  'mem:10:30000:82': 338.83,
  'mem:10:30000:83': 338.83,
  'mem:10:30000:84': 338.83,
  'mem:10:30000:85': 338.83,
  'mem:10:30000:86': 453.36,
  'mem:10:30000:87': 453.36,
  'mem:10:30000:88': 453.36,
  'mem:10:30000:89': 453.36,
  'mem:10:30000:90': 453.36,
  'mem:10:30000:91': 611.71,
  'mem:10:30000:92': 611.71,
  'mem:10:30000:93': 611.71,
  'mem:10:30000:94': 611.71,
  'mem:10:30000:95': 611.71,
  'mem:10:30000:96': 992.78,
  'mem:10:30000:97': 992.78,
  'mem:10:30000:98': 992.78,
  'mem:10:30000:99': 992.78,
  'mem:10:30000:100': 992.78,
  'mem:10:30000:101': 1729.07,
  'mem:10:30000:102': 1729.07,
  'mem:10:30000:103': 1729.07,
  'mem:10:30000:104': 1729.07,
  'mem:10:30000:105': 1729.07,
  'mem:10:30000:106': 2178.16,
  'mem:10:30000:107': 2178.16,
  'mem:10:30000:108': 2178.16,
  'mem:10:30000:109': 2178.16,
  'mem:10:30000:110': 2178.16,
  'mem:10:30000:111': 2178.16,
  'mem:10:30000:112': 2178.16,
  'mem:10:30000:113': 2178.16,
  'mem:10:30000:114': 2178.16,
  'mem:10:30000:115': 2178.16,
  'mem:10:30000:116': 2178.16,
  'mem:10:30000:117': 2178.16,
  'mem:10:30000:118': 2178.16,
  'mem:10:30000:119': 2178.16,
  'mem:10:30000:120': 2178.16,
  'mem:10:40000:1': 10.8,
  'mem:10:40000:2': 10.8,
  'mem:10:40000:3': 10.8,
  'mem:10:40000:4': 10.8,
  'mem:10:40000:5': 10.8,
  'mem:10:40000:6': 10.8,
  'mem:10:40000:7': 10.8,
  'mem:10:40000:8': 10.8,
  'mem:10:40000:9': 10.8,
  'mem:10:40000:10': 10.8,
  'mem:10:40000:11': 10.8,
  'mem:10:40000:12': 10.8,
  'mem:10:40000:13': 10.8,
  'mem:10:40000:14': 10.8,
  'mem:10:40000:15': 10.8,
  'mem:10:40000:16': 12,
  'mem:10:40000:17': 12,
  'mem:10:40000:18': 12,
  'mem:10:40000:19': 12,
  'mem:10:40000:20': 12,
  'mem:10:40000:21': 13.2,
  'mem:10:40000:22': 13.2,
  'mem:10:40000:23': 13.2,
  'mem:10:40000:24': 13.2,
  'mem:10:40000:25': 13.2,
  'mem:10:40000:26': 15.6,
  'mem:10:40000:27': 15.6,
  'mem:10:40000:28': 15.6,
  'mem:10:40000:29': 15.6,
  'mem:10:40000:30': 15.6,
  'mem:10:40000:31': 20.4,
  'mem:10:40000:32': 20.4,
  'mem:10:40000:33': 20.4,
  'mem:10:40000:34': 20.4,
  'mem:10:40000:35': 20.4,
  'mem:10:40000:36': 31.2,
  'mem:10:40000:37': 31.2,
  'mem:10:40000:38': 31.2,
  'mem:10:40000:39': 31.2,
  'mem:10:40000:40': 31.2,
  'mem:10:40000:41': 49.2,
  'mem:10:40000:42': 49.2,
  'mem:10:40000:43': 49.2,
  'mem:10:40000:44': 49.2,
  'mem:10:40000:45': 49.2,
  'mem:10:40000:46': 74.4,
  'mem:10:40000:47': 74.4,
  'mem:10:40000:48': 74.4,
  'mem:10:40000:49': 74.4,
  'mem:10:40000:50': 74.4,
  'mem:10:40000:51': 111.6,
  'mem:10:40000:52': 111.6,
  'mem:10:40000:53': 111.6,
  'mem:10:40000:54': 111.6,
  'mem:10:40000:55': 111.6,
  'mem:10:40000:56': 120,
  'mem:10:40000:57': 120,
  'mem:10:40000:58': 120,
  'mem:10:40000:59': 120,
  'mem:10:40000:60': 120,
  'mem:10:40000:61': 129.6,
  'mem:10:40000:62': 129.6,
  'mem:10:40000:63': 129.6,
  'mem:10:40000:64': 129.6,
  'mem:10:40000:65': 129.6,
  'mem:10:40000:66': 183.6,
  'mem:10:40000:67': 183.6,
  'mem:10:40000:68': 183.6,
  'mem:10:40000:69': 183.6,
  'mem:10:40000:70': 183.6,
  'mem:10:40000:71': 247.2,
  'mem:10:40000:72': 247.2,
  'mem:10:40000:73': 247.2,
  'mem:10:40000:74': 247.2,
  'mem:10:40000:75': 247.2,
  'mem:10:40000:76': 327.6,
  'mem:10:40000:77': 327.6,
  'mem:10:40000:78': 327.6,
  'mem:10:40000:79': 327.6,
  'mem:10:40000:80': 327.6,
  'mem:10:40000:81': 452.08,
  'mem:10:40000:82': 452.08,
  'mem:10:40000:83': 452.08,
  'mem:10:40000:84': 452.08,
  'mem:10:40000:85': 452.08,
  'mem:10:40000:86': 604.88,
  'mem:10:40000:87': 604.88,
  'mem:10:40000:88': 604.88,
  'mem:10:40000:89': 604.88,
  'mem:10:40000:90': 604.88,
  'mem:10:40000:91': 816.14,
  'mem:10:40000:92': 816.14,
  'mem:10:40000:93': 816.14,
  'mem:10:40000:94': 816.14,
  'mem:10:40000:95': 816.14,
  'mem:10:40000:96': 1324.53,
  'mem:10:40000:97': 1324.53,
  'mem:10:40000:98': 1324.53,
  'mem:10:40000:99': 1324.53,
  'mem:10:40000:100': 1324.53,
  'mem:10:40000:101': 2306.94,
  'mem:10:40000:102': 2306.94,
  'mem:10:40000:103': 2306.94,
  'mem:10:40000:104': 2306.94,
  'mem:10:40000:105': 2306.94,
  'mem:10:40000:106': 2906.16,
  'mem:10:40000:107': 2906.16,
  'mem:10:40000:108': 2906.16,
  'mem:10:40000:109': 2906.16,
  'mem:10:40000:110': 2906.16,
  'mem:10:40000:111': 2906.16,
  'mem:10:40000:112': 2906.16,
  'mem:10:40000:113': 2906.16,
  'mem:10:40000:114': 2906.16,
  'mem:10:40000:115': 2906.16,
  'mem:10:40000:116': 2906.16,
  'mem:10:40000:117': 2906.16,
  'mem:10:40000:118': 2906.16,
  'mem:10:40000:119': 2906.16,
  'mem:10:40000:120': 2906.16,
  'mem:10:50000:1': 13.2,
  'mem:10:50000:2': 13.2,
  'mem:10:50000:3': 13.2,
  'mem:10:50000:4': 13.2,
  'mem:10:50000:5': 13.2,
  'mem:10:50000:6': 13.2,
  'mem:10:50000:7': 13.2,
  'mem:10:50000:8': 13.2,
  'mem:10:50000:9': 13.2,
  'mem:10:50000:10': 13.2,
  'mem:10:50000:11': 13.2,
  'mem:10:50000:12': 13.2,
  'mem:10:50000:13': 13.2,
  'mem:10:50000:14': 13.2,
  'mem:10:50000:15': 13.2,
  'mem:10:50000:16': 14.4,
  'mem:10:50000:17': 14.4,
  'mem:10:50000:18': 14.4,
  'mem:10:50000:19': 14.4,
  'mem:10:50000:20': 14.4,
  'mem:10:50000:21': 15.6,
  'mem:10:50000:22': 15.6,
  'mem:10:50000:23': 15.6,
  'mem:10:50000:24': 15.6,
  'mem:10:50000:25': 15.6,
  'mem:10:50000:26': 19.2,
  'mem:10:50000:27': 19.2,
  'mem:10:50000:28': 19.2,
  'mem:10:50000:29': 19.2,
  'mem:10:50000:30': 19.2,
  'mem:10:50000:31': 26.4,
  'mem:10:50000:32': 26.4,
  'mem:10:50000:33': 26.4,
  'mem:10:50000:34': 26.4,
  'mem:10:50000:35': 26.4,
  'mem:10:50000:36': 38.4,
  'mem:10:50000:37': 38.4,
  'mem:10:50000:38': 38.4,
  'mem:10:50000:39': 38.4,
  'mem:10:50000:40': 38.4,
  'mem:10:50000:41': 61.2,
  'mem:10:50000:42': 61.2,
  'mem:10:50000:43': 61.2,
  'mem:10:50000:44': 61.2,
  'mem:10:50000:45': 61.2,
  'mem:10:50000:46': 92.4,
  'mem:10:50000:47': 92.4,
  'mem:10:50000:48': 92.4,
  'mem:10:50000:49': 92.4,
  'mem:10:50000:50': 92.4,
  'mem:10:50000:51': 139.2,
  'mem:10:50000:52': 139.2,
  'mem:10:50000:53': 139.2,
  'mem:10:50000:54': 139.2,
  'mem:10:50000:55': 139.2,
  'mem:10:50000:56': 150,
  'mem:10:50000:57': 150,
  'mem:10:50000:58': 150,
  'mem:10:50000:59': 150,
  'mem:10:50000:60': 150,
  'mem:10:50000:61': 162,
  'mem:10:50000:62': 162,
  'mem:10:50000:63': 162,
  'mem:10:50000:64': 162,
  'mem:10:50000:65': 162,
  'mem:10:50000:66': 230.4,
  'mem:10:50000:67': 230.4,
  'mem:10:50000:68': 230.4,
  'mem:10:50000:69': 230.4,
  'mem:10:50000:70': 230.4,
  'mem:10:50000:71': 309.6,
  'mem:10:50000:72': 309.6,
  'mem:10:50000:73': 309.6,
  'mem:10:50000:74': 309.6,
  'mem:10:50000:75': 309.6,
  'mem:10:50000:76': 409.2,
  'mem:10:50000:77': 409.2,
  'mem:10:50000:78': 409.2,
  'mem:10:50000:79': 409.2,
  'mem:10:50000:80': 409.2,
  'mem:10:50000:81': 565.27,
  'mem:10:50000:82': 565.27,
  'mem:10:50000:83': 565.27,
  'mem:10:50000:84': 565.27,
  'mem:10:50000:85': 565.27,
  'mem:10:50000:86': 756.32,
  'mem:10:50000:87': 756.32,
  'mem:10:50000:88': 756.32,
  'mem:10:50000:89': 756.32,
  'mem:10:50000:90': 756.32,
  'mem:10:50000:91': 1020.45,
  'mem:10:50000:92': 1020.45,
  'mem:10:50000:93': 1020.45,
  'mem:10:50000:94': 1020.45,
  'mem:10:50000:95': 1020.45,
  'mem:10:50000:96': 1656.07,
  'mem:10:50000:97': 1656.07,
  'mem:10:50000:98': 1656.07,
  'mem:10:50000:99': 1656.07,
  'mem:10:50000:100': 1656.07,
  'mem:10:50000:101': 2880.05,
  'mem:10:50000:102': 2880.05,
  'mem:10:50000:103': 2880.05,
  'mem:10:50000:104': 2880.05,
  'mem:10:50000:105': 2880.05,
  'mem:10:50000:106': 3624.94,
  'mem:10:50000:107': 3624.94,
  'mem:10:50000:108': 3624.94,
  'mem:10:50000:109': 3624.94,
  'mem:10:50000:110': 3624.94,
  'mem:10:50000:111': 3624.94,
  'mem:10:50000:112': 3624.94,
  'mem:10:50000:113': 3624.94,
  'mem:10:50000:114': 3624.94,
  'mem:10:50000:115': 3624.94,
  'mem:10:50000:116': 3624.94,
  'mem:10:50000:117': 3624.94,
  'mem:10:50000:118': 3624.94,
  'mem:10:50000:119': 3624.94,
  'mem:10:50000:120': 3624.94,
  'mem:10:60000:1': 14.21,
  'mem:10:60000:2': 14.21,
  'mem:10:60000:3': 14.21,
  'mem:10:60000:4': 14.21,
  'mem:10:60000:5': 14.21,
  'mem:10:60000:6': 14.17,
  'mem:10:60000:7': 14.17,
  'mem:10:60000:8': 14.17,
  'mem:10:60000:9': 14.17,
  'mem:10:60000:10': 14.17,
  'mem:10:60000:11': 14.19,
  'mem:10:60000:12': 14.19,
  'mem:10:60000:13': 14.19,
  'mem:10:60000:14': 14.19,
  'mem:10:60000:15': 14.19,
  'mem:10:60000:16': 14.9,
  'mem:10:60000:17': 14.9,
  'mem:10:60000:18': 14.9,
  'mem:10:60000:19': 14.9,
  'mem:10:60000:20': 14.9,
  'mem:10:60000:21': 15.89,
  'mem:10:60000:22': 15.89,
  'mem:10:60000:23': 15.89,
  'mem:10:60000:24': 15.89,
  'mem:10:60000:25': 15.89,
  'mem:10:60000:26': 18.66,
  'mem:10:60000:27': 18.66,
  'mem:10:60000:28': 18.66,
  'mem:10:60000:29': 18.66,
  'mem:10:60000:30': 18.66,
  'mem:10:60000:31': 24.5,
  'mem:10:60000:32': 24.5,
  'mem:10:60000:33': 24.5,
  'mem:10:60000:34': 24.5,
  'mem:10:60000:35': 24.5,
  'mem:10:60000:36': 35.26,
  'mem:10:60000:37': 35.26,
  'mem:10:60000:38': 35.26,
  'mem:10:60000:39': 35.26,
  'mem:10:60000:40': 35.26,
  'mem:10:60000:41': 55.41,
  'mem:10:60000:42': 55.41,
  'mem:10:60000:43': 55.41,
  'mem:10:60000:44': 55.41,
  'mem:10:60000:45': 55.41,
  'mem:10:60000:46': 84.06,
  'mem:10:60000:47': 84.06,
  'mem:10:60000:48': 84.06,
  'mem:10:60000:49': 84.06,
  'mem:10:60000:50': 84.06,
  'mem:10:60000:51': 126.27,
  'mem:10:60000:52': 126.27,
  'mem:10:60000:53': 126.27,
  'mem:10:60000:54': 126.27,
  'mem:10:60000:55': 126.27,
  'mem:10:60000:56': 154.7,
  'mem:10:60000:57': 154.7,
  'mem:10:60000:58': 154.7,
  'mem:10:60000:59': 154.7,
  'mem:10:60000:60': 154.7,
  'mem:10:60000:61': 191.48,
  'mem:10:60000:62': 191.48,
  'mem:10:60000:63': 191.48,
  'mem:10:60000:64': 191.48,
  'mem:10:60000:65': 191.48,
  'mem:10:60000:66': 274.1,
  'mem:10:60000:67': 274.1,
  'mem:10:60000:68': 274.1,
  'mem:10:60000:69': 274.1,
  'mem:10:60000:70': 274.1,
  'mem:10:60000:71': 355.02,
  'mem:10:60000:72': 355.02,
  'mem:10:60000:73': 355.02,
  'mem:10:60000:74': 355.02,
  'mem:10:60000:75': 355.02,
  'mem:10:60000:76': 482.9,
  'mem:10:60000:77': 482.9,
  'mem:10:60000:78': 482.9,
  'mem:10:60000:79': 482.9,
  'mem:10:60000:80': 482.9,
  'mem:10:60000:81': 677.66,
  'mem:10:60000:82': 677.66,
  'mem:10:60000:83': 677.66,
  'mem:10:60000:84': 677.66,
  'mem:10:60000:85': 677.66,
  'mem:10:60000:86': 906.73,
  'mem:10:60000:87': 906.73,
  'mem:10:60000:88': 906.73,
  'mem:10:60000:89': 906.73,
  'mem:10:60000:90': 906.73,
  'mem:10:60000:91': 1223.43,
  'mem:10:60000:92': 1223.43,
  'mem:10:60000:93': 1223.43,
  'mem:10:60000:94': 1223.43,
  'mem:10:60000:95': 1223.43,
  'mem:10:60000:96': 1985.55,
  'mem:10:60000:97': 1985.55,
  'mem:10:60000:98': 1985.55,
  'mem:10:60000:99': 1985.55,
  'mem:10:60000:100': 1985.55,
  'mem:10:60000:101': 3458.15,
  'mem:10:60000:102': 3458.15,
  'mem:10:60000:103': 3458.15,
  'mem:10:60000:104': 3458.15,
  'mem:10:60000:105': 3458.15,
  'mem:10:60000:106': 4356.31,
  'mem:10:60000:107': 4356.31,
  'mem:10:60000:108': 4356.31,
  'mem:10:60000:109': 4356.31,
  'mem:10:60000:110': 4356.31,
  'mem:10:60000:111': 4356.31,
  'mem:10:60000:112': 4356.31,
  'mem:10:60000:113': 4356.31,
  'mem:10:60000:114': 4356.31,
  'mem:10:60000:115': 4356.31,
  'mem:10:60000:116': 4356.31,
  'mem:10:60000:117': 4356.31,
  'mem:10:60000:118': 4356.31,
  'mem:10:60000:119': 4356.31,
  'mem:10:60000:120': 4356.31,
  'mem:10:70000:1': 15.21,
  'mem:10:70000:2': 15.21,
  'mem:10:70000:3': 15.21,
  'mem:10:70000:4': 15.21,
  'mem:10:70000:5': 15.21,
  'mem:10:70000:6': 15.15,
  'mem:10:70000:7': 15.15,
  'mem:10:70000:8': 15.15,
  'mem:10:70000:9': 15.15,
  'mem:10:70000:10': 15.15,
  'mem:10:70000:11': 15.18,
  'mem:10:70000:12': 15.18,
  'mem:10:70000:13': 15.18,
  'mem:10:70000:14': 15.18,
  'mem:10:70000:15': 15.18,
  'mem:10:70000:16': 15.41,
  'mem:10:70000:17': 15.41,
  'mem:10:70000:18': 15.41,
  'mem:10:70000:19': 15.41,
  'mem:10:70000:20': 15.41,
  'mem:10:70000:21': 16.18,
  'mem:10:70000:22': 16.18,
  'mem:10:70000:23': 16.18,
  'mem:10:70000:24': 16.18,
  'mem:10:70000:25': 16.18,
  'mem:10:70000:26': 18.13,
  'mem:10:70000:27': 18.13,
  'mem:10:70000:28': 18.13,
  'mem:10:70000:29': 18.13,
  'mem:10:70000:30': 18.13,
  'mem:10:70000:31': 22.6,
  'mem:10:70000:32': 22.6,
  'mem:10:70000:33': 22.6,
  'mem:10:70000:34': 22.6,
  'mem:10:70000:35': 22.6,
  'mem:10:70000:36': 32.11,
  'mem:10:70000:37': 32.11,
  'mem:10:70000:38': 32.11,
  'mem:10:70000:39': 32.11,
  'mem:10:70000:40': 32.11,
  'mem:10:70000:41': 49.62,
  'mem:10:70000:42': 49.62,
  'mem:10:70000:43': 49.62,
  'mem:10:70000:44': 49.62,
  'mem:10:70000:45': 49.62,
  'mem:10:70000:46': 75.71,
  'mem:10:70000:47': 75.71,
  'mem:10:70000:48': 75.71,
  'mem:10:70000:49': 75.71,
  'mem:10:70000:50': 75.71,
  'mem:10:70000:51': 113.33,
  'mem:10:70000:52': 113.33,
  'mem:10:70000:53': 113.33,
  'mem:10:70000:54': 113.33,
  'mem:10:70000:55': 113.33,
  'mem:10:70000:56': 159.41,
  'mem:10:70000:57': 159.41,
  'mem:10:70000:58': 159.41,
  'mem:10:70000:59': 159.41,
  'mem:10:70000:60': 159.41,
  'mem:10:70000:61': 223.54,
  'mem:10:70000:62': 223.54,
  'mem:10:70000:63': 223.54,
  'mem:10:70000:64': 223.54,
  'mem:10:70000:65': 223.54,
  'mem:10:70000:66': 320,
  'mem:10:70000:67': 320,
  'mem:10:70000:68': 320,
  'mem:10:70000:69': 320,
  'mem:10:70000:70': 320,
  'mem:10:70000:71': 414.46,
  'mem:10:70000:72': 414.46,
  'mem:10:70000:73': 414.46,
  'mem:10:70000:74': 414.46,
  'mem:10:70000:75': 414.46,
  'mem:10:70000:76': 563.74,
  'mem:10:70000:77': 563.74,
  'mem:10:70000:78': 563.74,
  'mem:10:70000:79': 563.74,
  'mem:10:70000:80': 563.74,
  'mem:10:70000:81': 791.12,
  'mem:10:70000:82': 791.12,
  'mem:10:70000:83': 791.12,
  'mem:10:70000:84': 791.12,
  'mem:10:70000:85': 791.12,
  'mem:10:70000:86': 1058.51,
  'mem:10:70000:87': 1058.51,
  'mem:10:70000:88': 1058.51,
  'mem:10:70000:89': 1058.51,
  'mem:10:70000:90': 1058.51,
  'mem:10:70000:91': 1428.2,
  'mem:10:70000:92': 1428.2,
  'mem:10:70000:93': 1428.2,
  'mem:10:70000:94': 1428.2,
  'mem:10:70000:95': 1428.2,
  'mem:10:70000:96': 2317.84,
  'mem:10:70000:97': 2317.84,
  'mem:10:70000:98': 2317.84,
  'mem:10:70000:99': 2317.84,
  'mem:10:70000:100': 2317.84,
  'mem:10:70000:101': 4036.97,
  'mem:10:70000:102': 4036.97,
  'mem:10:70000:103': 4036.97,
  'mem:10:70000:104': 4036.97,
  'mem:10:70000:105': 4036.97,
  'mem:10:70000:106': 5085.55,
  'mem:10:70000:107': 5085.55,
  'mem:10:70000:108': 5085.55,
  'mem:10:70000:109': 5085.55,
  'mem:10:70000:110': 5085.55,
  'mem:10:70000:111': 5085.55,
  'mem:10:70000:112': 5085.55,
  'mem:10:70000:113': 5085.55,
  'mem:10:70000:114': 5085.55,
  'mem:10:70000:115': 5085.55,
  'mem:10:70000:116': 5085.55,
  'mem:10:70000:117': 5085.55,
  'mem:10:70000:118': 5085.55,
  'mem:10:70000:119': 5085.55,
  'mem:10:70000:120': 5085.55,
  'mem:10:80000:1': 17.39,
  'mem:10:80000:2': 17.39,
  'mem:10:80000:3': 17.39,
  'mem:10:80000:4': 17.39,
  'mem:10:80000:5': 17.39,
  'mem:10:80000:6': 17.31,
  'mem:10:80000:7': 17.31,
  'mem:10:80000:8': 17.31,
  'mem:10:80000:9': 17.31,
  'mem:10:80000:10': 17.31,
  'mem:10:80000:11': 17.35,
  'mem:10:80000:12': 17.35,
  'mem:10:80000:13': 17.35,
  'mem:10:80000:14': 17.35,
  'mem:10:80000:15': 17.35,
  'mem:10:80000:16': 17.61,
  'mem:10:80000:17': 17.61,
  'mem:10:80000:18': 17.61,
  'mem:10:80000:19': 17.61,
  'mem:10:80000:20': 17.61,
  'mem:10:80000:21': 18.5,
  'mem:10:80000:22': 18.5,
  'mem:10:80000:23': 18.5,
  'mem:10:80000:24': 18.5,
  'mem:10:80000:25': 18.5,
  'mem:10:80000:26': 20.72,
  'mem:10:80000:27': 20.72,
  'mem:10:80000:28': 20.72,
  'mem:10:80000:29': 20.72,
  'mem:10:80000:30': 20.72,
  'mem:10:80000:31': 25.84,
  'mem:10:80000:32': 25.84,
  'mem:10:80000:33': 25.84,
  'mem:10:80000:34': 25.84,
  'mem:10:80000:35': 25.84,
  'mem:10:80000:36': 36.72,
  'mem:10:80000:37': 36.72,
  'mem:10:80000:38': 36.72,
  'mem:10:80000:39': 36.72,
  'mem:10:80000:40': 36.72,
  'mem:10:80000:41': 56.73,
  'mem:10:80000:42': 56.73,
  'mem:10:80000:43': 56.73,
  'mem:10:80000:44': 56.73,
  'mem:10:80000:45': 56.73,
  'mem:10:80000:46': 86.55,
  'mem:10:80000:47': 86.55,
  'mem:10:80000:48': 86.55,
  'mem:10:80000:49': 86.55,
  'mem:10:80000:50': 86.55,
  'mem:10:80000:51': 129.56,
  'mem:10:80000:52': 129.56,
  'mem:10:80000:53': 129.56,
  'mem:10:80000:54': 129.56,
  'mem:10:80000:55': 129.56,
  'mem:10:80000:56': 182.23,
  'mem:10:80000:57': 182.23,
  'mem:10:80000:58': 182.23,
  'mem:10:80000:59': 182.23,
  'mem:10:80000:60': 182.23,
  'mem:10:80000:61': 255.55,
  'mem:10:80000:62': 255.55,
  'mem:10:80000:63': 255.55,
  'mem:10:80000:64': 255.55,
  'mem:10:80000:65': 255.55,
  'mem:10:80000:66': 365.81,
  'mem:10:80000:67': 365.81,
  'mem:10:80000:68': 365.81,
  'mem:10:80000:69': 365.81,
  'mem:10:80000:70': 365.81,
  'mem:10:80000:71': 473.79,
  'mem:10:80000:72': 473.79,
  'mem:10:80000:73': 473.79,
  'mem:10:80000:74': 473.79,
  'mem:10:80000:75': 473.79,
  'mem:10:80000:76': 644.46,
  'mem:10:80000:77': 644.46,
  'mem:10:80000:78': 644.46,
  'mem:10:80000:79': 644.46,
  'mem:10:80000:80': 644.46,
  'mem:10:80000:81': 904.39,
  'mem:10:80000:82': 904.39,
  'mem:10:80000:83': 904.39,
  'mem:10:80000:84': 904.39,
  'mem:10:80000:85': 904.39,
  'mem:10:80000:86': 1210.05,
  'mem:10:80000:87': 1210.05,
  'mem:10:80000:88': 1210.05,
  'mem:10:80000:89': 1210.05,
  'mem:10:80000:90': 1210.05,
  'mem:10:80000:91': 1632.64,
  'mem:10:80000:92': 1632.64,
  'mem:10:80000:93': 1632.64,
  'mem:10:80000:94': 1632.64,
  'mem:10:80000:95': 1632.64,
  'mem:10:80000:96': 2649.59,
  'mem:10:80000:97': 2649.59,
  'mem:10:80000:98': 2649.59,
  'mem:10:80000:99': 2649.59,
  'mem:10:80000:100': 2649.59,
  'mem:10:80000:101': 4614.75,
  'mem:10:80000:102': 4614.75,
  'mem:10:80000:103': 4614.75,
  'mem:10:80000:104': 4614.75,
  'mem:10:80000:105': 4614.75,
  'mem:10:80000:106': 5813.41,
  'mem:10:80000:107': 5813.41,
  'mem:10:80000:108': 5813.41,
  'mem:10:80000:109': 5813.41,
  'mem:10:80000:110': 5813.41,
  'mem:10:80000:111': 5813.41,
  'mem:10:80000:112': 5813.41,
  'mem:10:80000:113': 5813.41,
  'mem:10:80000:114': 5813.41,
  'mem:10:80000:115': 5813.41,
  'mem:10:80000:116': 5813.41,
  'mem:10:80000:117': 5813.41,
  'mem:10:80000:118': 5813.41,
  'mem:10:80000:119': 5813.41,
  'mem:10:80000:120': 5813.41,
  'mem:10:90000:1': 19.54,
  'mem:10:90000:2': 19.54,
  'mem:10:90000:3': 19.54,
  'mem:10:90000:4': 19.54,
  'mem:10:90000:5': 19.54,
  'mem:10:90000:6': 19.45,
  'mem:10:90000:7': 19.45,
  'mem:10:90000:8': 19.45,
  'mem:10:90000:9': 19.45,
  'mem:10:90000:10': 19.45,
  'mem:10:90000:11': 19.49,
  'mem:10:90000:12': 19.49,
  'mem:10:90000:13': 19.49,
  'mem:10:90000:14': 19.49,
  'mem:10:90000:15': 19.49,
  'mem:10:90000:16': 19.79,
  'mem:10:90000:17': 19.79,
  'mem:10:90000:18': 19.79,
  'mem:10:90000:19': 19.79,
  'mem:10:90000:20': 19.79,
  'mem:10:90000:21': 20.78,
  'mem:10:90000:22': 20.78,
  'mem:10:90000:23': 20.78,
  'mem:10:90000:24': 20.78,
  'mem:10:90000:25': 20.78,
  'mem:10:90000:26': 23.28,
  'mem:10:90000:27': 23.28,
  'mem:10:90000:28': 23.28,
  'mem:10:90000:29': 23.28,
  'mem:10:90000:30': 23.28,
  'mem:10:90000:31': 29.06,
  'mem:10:90000:32': 29.06,
  'mem:10:90000:33': 29.06,
  'mem:10:90000:34': 29.06,
  'mem:10:90000:35': 29.06,
  'mem:10:90000:36': 41.31,
  'mem:10:90000:37': 41.31,
  'mem:10:90000:38': 41.31,
  'mem:10:90000:39': 41.31,
  'mem:10:90000:40': 41.31,
  'mem:10:90000:41': 63.77,
  'mem:10:90000:42': 63.77,
  'mem:10:90000:43': 63.77,
  'mem:10:90000:44': 63.77,
  'mem:10:90000:45': 63.77,
  'mem:10:90000:46': 97.24,
  'mem:10:90000:47': 97.24,
  'mem:10:90000:48': 97.24,
  'mem:10:90000:49': 97.24,
  'mem:10:90000:50': 97.24,
  'mem:10:90000:51': 145.56,
  'mem:10:90000:52': 145.56,
  'mem:10:90000:53': 145.56,
  'mem:10:90000:54': 145.56,
  'mem:10:90000:55': 145.56,
  'mem:10:90000:56': 204.73,
  'mem:10:90000:57': 204.73,
  'mem:10:90000:58': 204.73,
  'mem:10:90000:59': 204.73,
  'mem:10:90000:60': 204.73,
  'mem:10:90000:61': 287.1,
  'mem:10:90000:62': 287.1,
  'mem:10:90000:63': 287.1,
  'mem:10:90000:64': 287.1,
  'mem:10:90000:65': 287.1,
  'mem:10:90000:66': 410.98,
  'mem:10:90000:67': 410.98,
  'mem:10:90000:68': 410.98,
  'mem:10:90000:69': 410.98,
  'mem:10:90000:70': 410.98,
  'mem:10:90000:71': 532.3,
  'mem:10:90000:72': 532.3,
  'mem:10:90000:73': 532.3,
  'mem:10:90000:74': 532.3,
  'mem:10:90000:75': 532.3,
  'mem:10:90000:76': 724.02,
  'mem:10:90000:77': 724.02,
  'mem:10:90000:78': 724.02,
  'mem:10:90000:79': 724.02,
  'mem:10:90000:80': 724.02,
  'mem:10:90000:81': 1016.03,
  'mem:10:90000:82': 1016.03,
  'mem:10:90000:83': 1016.03,
  'mem:10:90000:84': 1016.03,
  'mem:10:90000:85': 1016.03,
  'mem:10:90000:86': 1359.46,
  'mem:10:90000:87': 1359.46,
  'mem:10:90000:88': 1359.46,
  'mem:10:90000:89': 1359.46,
  'mem:10:90000:90': 1359.46,
  'mem:10:90000:91': 1834.28,
  'mem:10:90000:92': 1834.28,
  'mem:10:90000:93': 1834.28,
  'mem:10:90000:94': 1834.28,
  'mem:10:90000:95': 1834.28,
  'mem:10:90000:96': 2976.92,
  'mem:10:90000:97': 2976.92,
  'mem:10:90000:98': 2976.92,
  'mem:10:90000:99': 2976.92,
  'mem:10:90000:100': 2976.92,
  'mem:10:90000:101': 5184.95,
  'mem:10:90000:102': 5184.95,
  'mem:10:90000:103': 5184.95,
  'mem:10:90000:104': 5184.95,
  'mem:10:90000:105': 5184.95,
  'mem:10:90000:106': 6531.74,
  'mem:10:90000:107': 6531.74,
  'mem:10:90000:108': 6531.74,
  'mem:10:90000:109': 6531.74,
  'mem:10:90000:110': 6531.74,
  'mem:10:90000:111': 6531.74,
  'mem:10:90000:112': 6531.74,
  'mem:10:90000:113': 6531.74,
  'mem:10:90000:114': 6531.74,
  'mem:10:90000:115': 6531.74,
  'mem:10:90000:116': 6531.74,
  'mem:10:90000:117': 6531.74,
  'mem:10:90000:118': 6531.74,
  'mem:10:90000:119': 6531.74,
  'mem:10:90000:120': 6531.74,
  'mem:10:100000:1': 21.72,
  'mem:10:100000:2': 21.72,
  'mem:10:100000:3': 21.72,
  'mem:10:100000:4': 21.72,
  'mem:10:100000:5': 21.72,
  'mem:10:100000:6': 21.62,
  'mem:10:100000:7': 21.62,
  'mem:10:100000:8': 21.62,
  'mem:10:100000:9': 21.62,
  'mem:10:100000:10': 21.62,
  'mem:10:100000:11': 21.67,
  'mem:10:100000:12': 21.67,
  'mem:10:100000:13': 21.67,
  'mem:10:100000:14': 21.67,
  'mem:10:100000:15': 21.67,
  'mem:10:100000:16': 22,
  'mem:10:100000:17': 22,
  'mem:10:100000:18': 22,
  'mem:10:100000:19': 22,
  'mem:10:100000:20': 22,
  'mem:10:100000:21': 23.1,
  'mem:10:100000:22': 23.1,
  'mem:10:100000:23': 23.1,
  'mem:10:100000:24': 23.1,
  'mem:10:100000:25': 23.1,
  'mem:10:100000:26': 25.88,
  'mem:10:100000:27': 25.88,
  'mem:10:100000:28': 25.88,
  'mem:10:100000:29': 25.88,
  'mem:10:100000:30': 25.88,
  'mem:10:100000:31': 32.29,
  'mem:10:100000:32': 32.29,
  'mem:10:100000:33': 32.29,
  'mem:10:100000:34': 32.29,
  'mem:10:100000:35': 32.29,
  'mem:10:100000:36': 45.91,
  'mem:10:100000:37': 45.91,
  'mem:10:100000:38': 45.91,
  'mem:10:100000:39': 45.91,
  'mem:10:100000:40': 45.91,
  'mem:10:100000:41': 70.89,
  'mem:10:100000:42': 70.89,
  'mem:10:100000:43': 70.89,
  'mem:10:100000:44': 70.89,
  'mem:10:100000:45': 70.89,
  'mem:10:100000:46': 108.1,
  'mem:10:100000:47': 108.1,
  'mem:10:100000:48': 108.1,
  'mem:10:100000:49': 108.1,
  'mem:10:100000:50': 108.1,
  'mem:10:100000:51': 161.81,
  'mem:10:100000:52': 161.81,
  'mem:10:100000:53': 161.81,
  'mem:10:100000:54': 161.81,
  'mem:10:100000:55': 161.81,
  'mem:10:100000:56': 227.59,
  'mem:10:100000:57': 227.59,
  'mem:10:100000:58': 227.59,
  'mem:10:100000:59': 227.59,
  'mem:10:100000:60': 227.59,
  'mem:10:100000:61': 319.15,
  'mem:10:100000:62': 319.15,
  'mem:10:100000:63': 319.15,
  'mem:10:100000:64': 319.15,
  'mem:10:100000:65': 319.15,
  'mem:10:100000:66': 456.84,
  'mem:10:100000:67': 456.84,
  'mem:10:100000:68': 456.84,
  'mem:10:100000:69': 456.84,
  'mem:10:100000:70': 456.84,
  'mem:10:100000:71': 591.71,
  'mem:10:100000:72': 591.71,
  'mem:10:100000:73': 591.71,
  'mem:10:100000:74': 591.71,
  'mem:10:100000:75': 591.71,
  'mem:10:100000:76': 804.86,
  'mem:10:100000:77': 804.86,
  'mem:10:100000:78': 804.86,
  'mem:10:100000:79': 804.86,
  'mem:10:100000:80': 804.86,
  'mem:10:100000:81': 1129.46,
  'mem:10:100000:82': 1129.46,
  'mem:10:100000:83': 1129.46,
  'mem:10:100000:84': 1129.46,
  'mem:10:100000:85': 1129.46,
  'mem:10:100000:86': 1511.26,
  'mem:10:100000:87': 1511.26,
  'mem:10:100000:88': 1511.26,
  'mem:10:100000:89': 1511.26,
  'mem:10:100000:90': 1511.26,
  'mem:10:100000:91': 2039.11,
  'mem:10:100000:92': 2039.11,
  'mem:10:100000:93': 2039.11,
  'mem:10:100000:94': 2039.11,
  'mem:10:100000:95': 2039.11,
  'mem:10:100000:96': 3309.34,
  'mem:10:100000:97': 3309.34,
  'mem:10:100000:98': 3309.34,
  'mem:10:100000:99': 3309.34,
  'mem:10:100000:100': 3309.34,
  'mem:10:100000:101': 5763.98,
  'mem:10:100000:102': 5763.98,
  'mem:10:100000:103': 5763.98,
  'mem:10:100000:104': 5763.98,
  'mem:10:100000:105': 5763.98,
  'mem:10:100000:106': 7261.22,
  'mem:10:100000:107': 7261.22,
  'mem:10:100000:108': 7261.22,
  'mem:10:100000:109': 7261.22,
  'mem:10:100000:110': 7261.22,
  'mem:10:100000:111': 7261.22,
  'mem:10:100000:112': 7261.22,
  'mem:10:100000:113': 7261.22,
  'mem:10:100000:114': 7261.22,
  'mem:10:100000:115': 7261.22,
  'mem:10:100000:116': 7261.22,
  'mem:10:100000:117': 7261.22,
  'mem:10:100000:118': 7261.22,
  'mem:10:100000:119': 7261.22,
  'mem:10:100000:120': 7261.22,
  'mem:10:120000:1': 26.07,
  'mem:10:120000:2': 26.07,
  'mem:10:120000:3': 26.07,
  'mem:10:120000:4': 26.07,
  'mem:10:120000:5': 26.07,
  'mem:10:120000:6': 25.95,
  'mem:10:120000:7': 25.95,
  'mem:10:120000:8': 25.95,
  'mem:10:120000:9': 25.95,
  'mem:10:120000:10': 25.95,
  'mem:10:120000:11': 26,
  'mem:10:120000:12': 26,
  'mem:10:120000:13': 26,
  'mem:10:120000:14': 26,
  'mem:10:120000:15': 26,
  'mem:10:120000:16': 26.39,
  'mem:10:120000:17': 26.39,
  'mem:10:120000:18': 26.39,
  'mem:10:120000:19': 26.39,
  'mem:10:120000:20': 26.39,
  'mem:10:120000:21': 27.72,
  'mem:10:120000:22': 27.72,
  'mem:10:120000:23': 27.72,
  'mem:10:120000:24': 27.72,
  'mem:10:120000:25': 27.72,
  'mem:10:120000:26': 31.06,
  'mem:10:120000:27': 31.06,
  'mem:10:120000:28': 31.06,
  'mem:10:120000:29': 31.06,
  'mem:10:120000:30': 31.06,
  'mem:10:120000:31': 38.75,
  'mem:10:120000:32': 38.75,
  'mem:10:120000:33': 38.75,
  'mem:10:120000:34': 38.75,
  'mem:10:120000:35': 38.75,
  'mem:10:120000:36': 55.09,
  'mem:10:120000:37': 55.09,
  'mem:10:120000:38': 55.09,
  'mem:10:120000:39': 55.09,
  'mem:10:120000:40': 55.09,
  'mem:10:120000:41': 85.06,
  'mem:10:120000:42': 85.06,
  'mem:10:120000:43': 85.06,
  'mem:10:120000:44': 85.06,
  'mem:10:120000:45': 85.06,
  'mem:10:120000:46': 129.71,
  'mem:10:120000:47': 129.71,
  'mem:10:120000:48': 129.71,
  'mem:10:120000:49': 129.71,
  'mem:10:120000:50': 129.71,
  'mem:10:120000:51': 194.15,
  'mem:10:120000:52': 194.15,
  'mem:10:120000:53': 194.15,
  'mem:10:120000:54': 194.15,
  'mem:10:120000:55': 194.15,
  'mem:10:120000:56': 273.08,
  'mem:10:120000:57': 273.08,
  'mem:10:120000:58': 273.08,
  'mem:10:120000:59': 273.08,
  'mem:10:120000:60': 273.08,
  'mem:10:120000:61': 382.95,
  'mem:10:120000:62': 382.95,
  'mem:10:120000:63': 382.95,
  'mem:10:120000:64': 382.95,
  'mem:10:120000:65': 382.95,
  'mem:10:120000:66': 548.18,
  'mem:10:120000:67': 548.18,
  'mem:10:120000:68': 548.18,
  'mem:10:120000:69': 548.18,
  'mem:10:120000:70': 548.18,
  'mem:10:120000:71': 710.02,
  'mem:10:120000:72': 710.02,
  'mem:10:120000:73': 710.02,
  'mem:10:120000:74': 710.02,
  'mem:10:120000:75': 710.02,
  'mem:10:120000:76': 965.78,
  'mem:10:120000:77': 965.78,
  'mem:10:120000:78': 965.78,
  'mem:10:120000:79': 965.78,
  'mem:10:120000:80': 965.78,
  'mem:10:120000:81': 1355.28,
  'mem:10:120000:82': 1355.28,
  'mem:10:120000:83': 1355.28,
  'mem:10:120000:84': 1355.28,
  'mem:10:120000:85': 1355.28,
  'mem:10:120000:86': 1813.4,
  'mem:10:120000:87': 1813.4,
  'mem:10:120000:88': 1813.4,
  'mem:10:120000:89': 1813.4,
  'mem:10:120000:90': 1813.4,
  'mem:10:120000:91': 2446.79,
  'mem:10:120000:92': 2446.79,
  'mem:10:120000:93': 2446.79,
  'mem:10:120000:94': 2446.79,
  'mem:10:120000:95': 2446.79,
  'mem:10:120000:96': 3971.01,
  'mem:10:120000:97': 3971.01,
  'mem:10:120000:98': 3971.01,
  'mem:10:120000:99': 3971.01,
  'mem:10:120000:100': 3971.01,
  'mem:10:120000:101': 6916.43,
  'mem:10:120000:102': 6916.43,
  'mem:10:120000:103': 6916.43,
  'mem:10:120000:104': 6916.43,
  'mem:10:120000:105': 6916.43,
  'mem:10:120000:106': 8713,
  'mem:10:120000:107': 8713,
  'mem:10:120000:108': 8713,
  'mem:10:120000:109': 8713,
  'mem:10:120000:110': 8713,
  'mem:10:120000:111': 8713,
  'mem:10:120000:112': 8713,
  'mem:10:120000:113': 8713,
  'mem:10:120000:114': 8713,
  'mem:10:120000:115': 8713,
  'mem:10:120000:116': 8713,
  'mem:10:120000:117': 8713,
  'mem:10:120000:118': 8713,
  'mem:10:120000:119': 8713,
  'mem:10:120000:120': 8713,
  'mem:10:140000:1': 30.43,
  'mem:10:140000:2': 30.43,
  'mem:10:140000:3': 30.43,
  'mem:10:140000:4': 30.43,
  'mem:10:140000:5': 30.43,
  'mem:10:140000:6': 30.29,
  'mem:10:140000:7': 30.29,
  'mem:10:140000:8': 30.29,
  'mem:10:140000:9': 30.29,
  'mem:10:140000:10': 30.29,
  'mem:10:140000:11': 30.35,
  'mem:10:140000:12': 30.35,
  'mem:10:140000:13': 30.35,
  'mem:10:140000:14': 30.35,
  'mem:10:140000:15': 30.35,
  'mem:10:140000:16': 30.81,
  'mem:10:140000:17': 30.81,
  'mem:10:140000:18': 30.81,
  'mem:10:140000:19': 30.81,
  'mem:10:140000:20': 30.81,
  'mem:10:140000:21': 32.36,
  'mem:10:140000:22': 32.36,
  'mem:10:140000:23': 32.36,
  'mem:10:140000:24': 32.36,
  'mem:10:140000:25': 32.36,
  'mem:10:140000:26': 36.26,
  'mem:10:140000:27': 36.26,
  'mem:10:140000:28': 36.26,
  'mem:10:140000:29': 36.26,
  'mem:10:140000:30': 36.26,
  'mem:10:140000:31': 45.2,
  'mem:10:140000:32': 45.2,
  'mem:10:140000:33': 45.2,
  'mem:10:140000:34': 45.2,
  'mem:10:140000:35': 45.2,
  'mem:10:140000:36': 64.22,
  'mem:10:140000:37': 64.22,
  'mem:10:140000:38': 64.22,
  'mem:10:140000:39': 64.22,
  'mem:10:140000:40': 64.22,
  'mem:10:140000:41': 99.25,
  'mem:10:140000:42': 99.25,
  'mem:10:140000:43': 99.25,
  'mem:10:140000:44': 99.25,
  'mem:10:140000:45': 99.25,
  'mem:10:140000:46': 151.43,
  'mem:10:140000:47': 151.43,
  'mem:10:140000:48': 151.43,
  'mem:10:140000:49': 151.43,
  'mem:10:140000:50': 151.43,
  'mem:10:140000:51': 226.67,
  'mem:10:140000:52': 226.67,
  'mem:10:140000:53': 226.67,
  'mem:10:140000:54': 226.67,
  'mem:10:140000:55': 226.67,
  'mem:10:140000:56': 318.81,
  'mem:10:140000:57': 318.81,
  'mem:10:140000:58': 318.81,
  'mem:10:140000:59': 318.81,
  'mem:10:140000:60': 318.81,
  'mem:10:140000:61': 447.09,
  'mem:10:140000:62': 447.09,
  'mem:10:140000:63': 447.09,
  'mem:10:140000:64': 447.09,
  'mem:10:140000:65': 447.09,
  'mem:10:140000:66': 640,
  'mem:10:140000:67': 640,
  'mem:10:140000:68': 640,
  'mem:10:140000:69': 640,
  'mem:10:140000:70': 640,
  'mem:10:140000:71': 828.92,
  'mem:10:140000:72': 828.92,
  'mem:10:140000:73': 828.92,
  'mem:10:140000:74': 828.92,
  'mem:10:140000:75': 828.92,
  'mem:10:140000:76': 1127.49,
  'mem:10:140000:77': 1127.49,
  'mem:10:140000:78': 1127.49,
  'mem:10:140000:79': 1127.49,
  'mem:10:140000:80': 1127.49,
  'mem:10:140000:81': 1582.23,
  'mem:10:140000:82': 1582.23,
  'mem:10:140000:83': 1582.23,
  'mem:10:140000:84': 1582.23,
  'mem:10:140000:85': 1582.23,
  'mem:10:140000:86': 2117.03,
  'mem:10:140000:87': 2117.03,
  'mem:10:140000:88': 2117.03,
  'mem:10:140000:89': 2117.03,
  'mem:10:140000:90': 2117.03,
  'mem:10:140000:91': 2856.4,
  'mem:10:140000:92': 2856.4,
  'mem:10:140000:93': 2856.4,
  'mem:10:140000:94': 2856.4,
  'mem:10:140000:95': 2856.4,
  'mem:10:140000:96': 4635.67,
  'mem:10:140000:97': 4635.67,
  'mem:10:140000:98': 4635.67,
  'mem:10:140000:99': 4635.67,
  'mem:10:140000:100': 4635.67,
  'mem:10:140000:101': 8073.93,
  'mem:10:140000:102': 8073.93,
  'mem:10:140000:103': 8073.93,
  'mem:10:140000:104': 8073.93,
  'mem:10:140000:105': 8073.93,
  'mem:10:140000:106': 10171.11,
  'mem:10:140000:107': 10171.11,
  'mem:10:140000:108': 10171.11,
  'mem:10:140000:109': 10171.11,
  'mem:10:140000:110': 10171.11,
  'mem:10:140000:111': 10171.11,
  'mem:10:140000:112': 10171.11,
  'mem:10:140000:113': 10171.11,
  'mem:10:140000:114': 10171.11,
  'mem:10:140000:115': 10171.11,
  'mem:10:140000:116': 10171.11,
  'mem:10:140000:117': 10171.11,
  'mem:10:140000:118': 10171.11,
  'mem:10:140000:119': 10171.11,
  'mem:10:140000:120': 10171.11,
  'mem:10:160000:1': 34.78,
  'mem:10:160000:2': 34.78,
  'mem:10:160000:3': 34.78,
  'mem:10:160000:4': 34.78,
  'mem:10:160000:5': 34.78,
  'mem:10:160000:6': 34.63,
  'mem:10:160000:7': 34.63,
  'mem:10:160000:8': 34.63,
  'mem:10:160000:9': 34.63,
  'mem:10:160000:10': 34.63,
  'mem:10:160000:11': 34.7,
  'mem:10:160000:12': 34.7,
  'mem:10:160000:13': 34.7,
  'mem:10:160000:14': 34.7,
  'mem:10:160000:15': 34.7,
  'mem:10:160000:16': 35.22,
  'mem:10:160000:17': 35.22,
  'mem:10:160000:18': 35.22,
  'mem:10:160000:19': 35.22,
  'mem:10:160000:20': 35.22,
  'mem:10:160000:21': 37,
  'mem:10:160000:22': 37,
  'mem:10:160000:23': 37,
  'mem:10:160000:24': 37,
  'mem:10:160000:25': 37,
  'mem:10:160000:26': 41.45,
  'mem:10:160000:27': 41.45,
  'mem:10:160000:28': 41.45,
  'mem:10:160000:29': 41.45,
  'mem:10:160000:30': 41.45,
  'mem:10:160000:31': 51.68,
  'mem:10:160000:32': 51.68,
  'mem:10:160000:33': 51.68,
  'mem:10:160000:34': 51.68,
  'mem:10:160000:35': 51.68,
  'mem:10:160000:36': 73.43,
  'mem:10:160000:37': 73.43,
  'mem:10:160000:38': 73.43,
  'mem:10:160000:39': 73.43,
  'mem:10:160000:40': 73.43,
  'mem:10:160000:41': 113.46,
  'mem:10:160000:42': 113.46,
  'mem:10:160000:43': 113.46,
  'mem:10:160000:44': 113.46,
  'mem:10:160000:45': 113.46,
  'mem:10:160000:46': 173.1,
  'mem:10:160000:47': 173.1,
  'mem:10:160000:48': 173.1,
  'mem:10:160000:49': 173.1,
  'mem:10:160000:50': 173.1,
  'mem:10:160000:51': 259.12,
  'mem:10:160000:52': 259.12,
  'mem:10:160000:53': 259.12,
  'mem:10:160000:54': 259.12,
  'mem:10:160000:55': 259.12,
  'mem:10:160000:56': 364.46,
  'mem:10:160000:57': 364.46,
  'mem:10:160000:58': 364.46,
  'mem:10:160000:59': 364.46,
  'mem:10:160000:60': 364.46,
  'mem:10:160000:61': 511.1,
  'mem:10:160000:62': 511.1,
  'mem:10:160000:63': 511.1,
  'mem:10:160000:64': 511.1,
  'mem:10:160000:65': 511.1,
  'mem:10:160000:66': 731.63,
  'mem:10:160000:67': 731.63,
  'mem:10:160000:68': 731.63,
  'mem:10:160000:69': 731.63,
  'mem:10:160000:70': 731.63,
  'mem:10:160000:71': 947.59,
  'mem:10:160000:72': 947.59,
  'mem:10:160000:73': 947.59,
  'mem:10:160000:74': 947.59,
  'mem:10:160000:75': 947.59,
  'mem:10:160000:76': 1288.92,
  'mem:10:160000:77': 1288.92,
  'mem:10:160000:78': 1288.92,
  'mem:10:160000:79': 1288.92,
  'mem:10:160000:80': 1288.92,
  'mem:10:160000:81': 1808.77,
  'mem:10:160000:82': 1808.77,
  'mem:10:160000:83': 1808.77,
  'mem:10:160000:84': 1808.77,
  'mem:10:160000:85': 1808.77,
  'mem:10:160000:86': 2420.11,
  'mem:10:160000:87': 2420.11,
  'mem:10:160000:88': 2420.11,
  'mem:10:160000:89': 2420.11,
  'mem:10:160000:90': 2420.11,
  'mem:10:160000:91': 3265.29,
  'mem:10:160000:92': 3265.29,
  'mem:10:160000:93': 3265.29,
  'mem:10:160000:94': 3265.29,
  'mem:10:160000:95': 3265.29,
  'mem:10:160000:96': 5299.18,
  'mem:10:160000:97': 5299.18,
  'mem:10:160000:98': 5299.18,
  'mem:10:160000:99': 5299.18,
  'mem:10:160000:100': 5299.18,
  'mem:10:160000:101': 9229.51,
  'mem:10:160000:102': 9229.51,
  'mem:10:160000:103': 9229.51,
  'mem:10:160000:104': 9229.51,
  'mem:10:160000:105': 9229.51,
  'mem:10:160000:106': 11626.82,
  'mem:10:160000:107': 11626.82,
  'mem:10:160000:108': 11626.82,
  'mem:10:160000:109': 11626.82,
  'mem:10:160000:110': 11626.82,
  'mem:10:160000:111': 11626.82,
  'mem:10:160000:112': 11626.82,
  'mem:10:160000:113': 11626.82,
  'mem:10:160000:114': 11626.82,
  'mem:10:160000:115': 11626.82,
  'mem:10:160000:116': 11626.82,
  'mem:10:160000:117': 11626.82,
  'mem:10:160000:118': 11626.82,
  'mem:10:160000:119': 11626.82,
  'mem:10:160000:120': 11626.82,
  'mem:10:180000:1': 39.08,
  'mem:10:180000:2': 39.08,
  'mem:10:180000:3': 39.08,
  'mem:10:180000:4': 39.08,
  'mem:10:180000:5': 39.08,
  'mem:10:180000:6': 38.9,
  'mem:10:180000:7': 38.9,
  'mem:10:180000:8': 38.9,
  'mem:10:180000:9': 38.9,
  'mem:10:180000:10': 38.9,
  'mem:10:180000:11': 38.98,
  'mem:10:180000:12': 38.98,
  'mem:10:180000:13': 38.98,
  'mem:10:180000:14': 38.98,
  'mem:10:180000:15': 38.98,
  'mem:10:180000:16': 39.57,
  'mem:10:180000:17': 39.57,
  'mem:10:180000:18': 39.57,
  'mem:10:180000:19': 39.57,
  'mem:10:180000:20': 39.57,
  'mem:10:180000:21': 41.57,
  'mem:10:180000:22': 41.57,
  'mem:10:180000:23': 41.57,
  'mem:10:180000:24': 41.57,
  'mem:10:180000:25': 41.57,
  'mem:10:180000:26': 46.56,
  'mem:10:180000:27': 46.56,
  'mem:10:180000:28': 46.56,
  'mem:10:180000:29': 46.56,
  'mem:10:180000:30': 46.56,
  'mem:10:180000:31': 58.11,
  'mem:10:180000:32': 58.11,
  'mem:10:180000:33': 58.11,
  'mem:10:180000:34': 58.11,
  'mem:10:180000:35': 58.11,
  'mem:10:180000:36': 82.62,
  'mem:10:180000:37': 82.62,
  'mem:10:180000:38': 82.62,
  'mem:10:180000:39': 82.62,
  'mem:10:180000:40': 82.62,
  'mem:10:180000:41': 127.55,
  'mem:10:180000:42': 127.55,
  'mem:10:180000:43': 127.55,
  'mem:10:180000:44': 127.55,
  'mem:10:180000:45': 127.55,
  'mem:10:180000:46': 194.48,
  'mem:10:180000:47': 194.48,
  'mem:10:180000:48': 194.48,
  'mem:10:180000:49': 194.48,
  'mem:10:180000:50': 194.48,
  'mem:10:180000:51': 291.11,
  'mem:10:180000:52': 291.11,
  'mem:10:180000:53': 291.11,
  'mem:10:180000:54': 291.11,
  'mem:10:180000:55': 291.11,
  'mem:10:180000:56': 409.46,
  'mem:10:180000:57': 409.46,
  'mem:10:180000:58': 409.46,
  'mem:10:180000:59': 409.46,
  'mem:10:180000:60': 409.46,
  'mem:10:180000:61': 574.2,
  'mem:10:180000:62': 574.2,
  'mem:10:180000:63': 574.2,
  'mem:10:180000:64': 574.2,
  'mem:10:180000:65': 574.2,
  'mem:10:180000:66': 821.95,
  'mem:10:180000:67': 821.95,
  'mem:10:180000:68': 821.95,
  'mem:10:180000:69': 821.95,
  'mem:10:180000:70': 821.95,
  'mem:10:180000:71': 1064.59,
  'mem:10:180000:72': 1064.59,
  'mem:10:180000:73': 1064.59,
  'mem:10:180000:74': 1064.59,
  'mem:10:180000:75': 1064.59,
  'mem:10:180000:76': 1448.04,
  'mem:10:180000:77': 1448.04,
  'mem:10:180000:78': 1448.04,
  'mem:10:180000:79': 1448.04,
  'mem:10:180000:80': 1448.04,
  'mem:10:180000:81': 2032.05,
  'mem:10:180000:82': 2032.05,
  'mem:10:180000:83': 2032.05,
  'mem:10:180000:84': 2032.05,
  'mem:10:180000:85': 2032.05,
  'mem:10:180000:86': 2718.91,
  'mem:10:180000:87': 2718.91,
  'mem:10:180000:88': 2718.91,
  'mem:10:180000:89': 2718.91,
  'mem:10:180000:90': 2718.91,
  'mem:10:180000:91': 3668.56,
  'mem:10:180000:92': 3668.56,
  'mem:10:180000:93': 3668.56,
  'mem:10:180000:94': 3668.56,
  'mem:10:180000:95': 3668.56,
  'mem:10:180000:96': 5953.84,
  'mem:10:180000:97': 5953.84,
  'mem:10:180000:98': 5953.84,
  'mem:10:180000:99': 5953.84,
  'mem:10:180000:100': 5953.84,
  'mem:10:180000:101': 10369.89,
  'mem:10:180000:102': 10369.89,
  'mem:10:180000:103': 10369.89,
  'mem:10:180000:104': 10369.89,
  'mem:10:180000:105': 10369.89,
  'mem:10:180000:106': 13063.49,
  'mem:10:180000:107': 13063.49,
  'mem:10:180000:108': 13063.49,
  'mem:10:180000:109': 13063.49,
  'mem:10:180000:110': 13063.49,
  'mem:10:180000:111': 13063.49,
  'mem:10:180000:112': 13063.49,
  'mem:10:180000:113': 13063.49,
  'mem:10:180000:114': 13063.49,
  'mem:10:180000:115': 13063.49,
  'mem:10:180000:116': 13063.49,
  'mem:10:180000:117': 13063.49,
  'mem:10:180000:118': 13063.49,
  'mem:10:180000:119': 13063.49,
  'mem:10:180000:120': 13063.49,
  'mem:10:200000:1': 43.45,
  'mem:10:200000:2': 43.45,
  'mem:10:200000:3': 43.45,
  'mem:10:200000:4': 43.45,
  'mem:10:200000:5': 43.45,
  'mem:10:200000:6': 43.25,
  'mem:10:200000:7': 43.25,
  'mem:10:200000:8': 43.25,
  'mem:10:200000:9': 43.25,
  'mem:10:200000:10': 43.25,
  'mem:10:200000:11': 43.34,
  'mem:10:200000:12': 43.34,
  'mem:10:200000:13': 43.34,
  'mem:10:200000:14': 43.34,
  'mem:10:200000:15': 43.34,
  'mem:10:200000:16': 43.99,
  'mem:10:200000:17': 43.99,
  'mem:10:200000:18': 43.99,
  'mem:10:200000:19': 43.99,
  'mem:10:200000:20': 43.99,
  'mem:10:200000:21': 46.21,
  'mem:10:200000:22': 46.21,
  'mem:10:200000:23': 46.21,
  'mem:10:200000:24': 46.21,
  'mem:10:200000:25': 46.21,
  'mem:10:200000:26': 51.76,
  'mem:10:200000:27': 51.76,
  'mem:10:200000:28': 51.76,
  'mem:10:200000:29': 51.76,
  'mem:10:200000:30': 51.76,
  'mem:10:200000:31': 64.59,
  'mem:10:200000:32': 64.59,
  'mem:10:200000:33': 64.59,
  'mem:10:200000:34': 64.59,
  'mem:10:200000:35': 64.59,
  'mem:10:200000:36': 91.81,
  'mem:10:200000:37': 91.81,
  'mem:10:200000:38': 91.81,
  'mem:10:200000:39': 91.81,
  'mem:10:200000:40': 91.81,
  'mem:10:200000:41': 141.77,
  'mem:10:200000:42': 141.77,
  'mem:10:200000:43': 141.77,
  'mem:10:200000:44': 141.77,
  'mem:10:200000:45': 141.77,
  'mem:10:200000:46': 216.19,
  'mem:10:200000:47': 216.19,
  'mem:10:200000:48': 216.19,
  'mem:10:200000:49': 216.19,
  'mem:10:200000:50': 216.19,
  'mem:10:200000:51': 323.62,
  'mem:10:200000:52': 323.62,
  'mem:10:200000:53': 323.62,
  'mem:10:200000:54': 323.62,
  'mem:10:200000:55': 323.62,
  'mem:10:200000:56': 455.17,
  'mem:10:200000:57': 455.17,
  'mem:10:200000:58': 455.17,
  'mem:10:200000:59': 455.17,
  'mem:10:200000:60': 455.17,
  'mem:10:200000:61': 638.3,
  'mem:10:200000:62': 638.3,
  'mem:10:200000:63': 638.3,
  'mem:10:200000:64': 638.3,
  'mem:10:200000:65': 638.3,
  'mem:10:200000:66': 913.68,
  'mem:10:200000:67': 913.68,
  'mem:10:200000:68': 913.68,
  'mem:10:200000:69': 913.68,
  'mem:10:200000:70': 913.68,
  'mem:10:200000:71': 1183.43,
  'mem:10:200000:72': 1183.43,
  'mem:10:200000:73': 1183.43,
  'mem:10:200000:74': 1183.43,
  'mem:10:200000:75': 1183.43,
  'mem:10:200000:76': 1609.72,
  'mem:10:200000:77': 1609.72,
  'mem:10:200000:78': 1609.72,
  'mem:10:200000:79': 1609.72,
  'mem:10:200000:80': 1609.72,
  'mem:10:200000:81': 2258.93,
  'mem:10:200000:82': 2258.93,
  'mem:10:200000:83': 2258.93,
  'mem:10:200000:84': 2258.93,
  'mem:10:200000:85': 2258.93,
  'mem:10:200000:86': 3022.52,
  'mem:10:200000:87': 3022.52,
  'mem:10:200000:88': 3022.52,
  'mem:10:200000:89': 3022.52,
  'mem:10:200000:90': 3022.52,
  'mem:10:200000:91': 4078.22,
  'mem:10:200000:92': 4078.22,
  'mem:10:200000:93': 4078.22,
  'mem:10:200000:94': 4078.22,
  'mem:10:200000:95': 4078.22,
  'mem:10:200000:96': 6618.67,
  'mem:10:200000:97': 6618.67,
  'mem:10:200000:98': 6618.67,
  'mem:10:200000:99': 6618.67,
  'mem:10:200000:100': 6618.67,
  'mem:10:200000:101': 11527.96,
  'mem:10:200000:102': 11527.96,
  'mem:10:200000:103': 11527.96,
  'mem:10:200000:104': 11527.96,
  'mem:10:200000:105': 11527.96,
  'mem:10:200000:106': 14522.43,
  'mem:10:200000:107': 14522.43,
  'mem:10:200000:108': 14522.43,
  'mem:10:200000:109': 14522.43,
  'mem:10:200000:110': 14522.43,
  'mem:10:200000:111': 14522.43,
  'mem:10:200000:112': 14522.43,
  'mem:10:200000:113': 14522.43,
  'mem:10:200000:114': 14522.43,
  'mem:10:200000:115': 14522.43,
  'mem:10:200000:116': 14522.43,
  'mem:10:200000:117': 14522.43,
  'mem:10:200000:118': 14522.43,
  'mem:10:200000:119': 14522.43,
  'mem:10:200000:120': 14522.43,
  'mem_40:10:5000:1': 2.4,
  'mem_40:10:5000:2': 2.4,
  'mem_40:10:5000:3': 2.4,
  'mem_40:10:5000:4': 2.4,
  'mem_40:10:5000:5': 2.4,
  'mem_40:10:5000:6': 2.4,
  'mem_40:10:5000:7': 2.4,
  'mem_40:10:5000:8': 2.4,
  'mem_40:10:5000:9': 2.4,
  'mem_40:10:5000:10': 2.4,
  'mem_40:10:5000:11': 2.4,
  'mem_40:10:5000:12': 2.4,
  'mem_40:10:5000:13': 2.4,
  'mem_40:10:5000:14': 2.4,
  'mem_40:10:5000:15': 2.4,
  'mem_40:10:5000:16': 2.4,
  'mem_40:10:5000:17': 2.4,
  'mem_40:10:5000:18': 2.4,
  'mem_40:10:5000:19': 2.4,
  'mem_40:10:5000:20': 2.4,
  'mem_40:10:5000:21': 2.4,
  'mem_40:10:5000:22': 2.4,
  'mem_40:10:5000:23': 2.4,
  'mem_40:10:5000:24': 2.4,
  'mem_40:10:5000:25': 2.4,
  'mem_40:10:5000:26': 2.4,
  'mem_40:10:5000:27': 2.4,
  'mem_40:10:5000:28': 2.4,
  'mem_40:10:5000:29': 2.4,
  'mem_40:10:5000:30': 2.4,
  'mem_40:10:5000:31': 3.6,
  'mem_40:10:5000:32': 3.6,
  'mem_40:10:5000:33': 3.6,
  'mem_40:10:5000:34': 3.6,
  'mem_40:10:5000:35': 3.6,
  'mem_40:10:5000:36': 4.8,
  'mem_40:10:5000:37': 4.8,
  'mem_40:10:5000:38': 4.8,
  'mem_40:10:5000:39': 4.8,
  'mem_40:10:5000:40': 4.8,
  'mem_40:10:5000:41': 7.2,
  'mem_40:10:5000:42': 7.2,
  'mem_40:10:5000:43': 7.2,
  'mem_40:10:5000:44': 7.2,
  'mem_40:10:5000:45': 7.2,
  'mem_40:10:5000:46': 9.6,
  'mem_40:10:5000:47': 9.6,
  'mem_40:10:5000:48': 9.6,
  'mem_40:10:5000:49': 9.6,
  'mem_40:10:5000:50': 9.6,
  'mem_40:10:5000:51': 14.4,
  'mem_40:10:5000:52': 14.4,
  'mem_40:10:5000:53': 14.4,
  'mem_40:10:5000:54': 14.4,
  'mem_40:10:5000:55': 14.4,
  'mem_40:10:5000:56': 15.6,
  'mem_40:10:5000:57': 15.6,
  'mem_40:10:5000:58': 15.6,
  'mem_40:10:5000:59': 15.6,
  'mem_40:10:5000:60': 15.6,
  'mem_40:10:5000:61': 16.8,
  'mem_40:10:5000:62': 16.8,
  'mem_40:10:5000:63': 16.8,
  'mem_40:10:5000:64': 16.8,
  'mem_40:10:5000:65': 16.8,
  'mem_40:10:5000:66': 24,
  'mem_40:10:5000:67': 24,
  'mem_40:10:5000:68': 24,
  'mem_40:10:5000:69': 24,
  'mem_40:10:5000:70': 24,
  'mem_40:10:5000:71': 31.2,
  'mem_40:10:5000:72': 31.2,
  'mem_40:10:5000:73': 31.2,
  'mem_40:10:5000:74': 31.2,
  'mem_40:10:5000:75': 31.2,
  'mem_40:10:5000:76': 42,
  'mem_40:10:5000:77': 42,
  'mem_40:10:5000:78': 42,
  'mem_40:10:5000:79': 42,
  'mem_40:10:5000:80': 42,
  'mem_40:10:5000:81': 56.54,
  'mem_40:10:5000:82': 56.54,
  'mem_40:10:5000:83': 56.54,
  'mem_40:10:5000:84': 56.54,
  'mem_40:10:5000:85': 56.54,
  'mem_40:10:5000:86': 75.66,
  'mem_40:10:5000:87': 75.66,
  'mem_40:10:5000:88': 75.66,
  'mem_40:10:5000:89': 75.66,
  'mem_40:10:5000:90': 75.66,
  'mem_40:10:5000:91': 102.09,
  'mem_40:10:5000:92': 102.09,
  'mem_40:10:5000:93': 102.09,
  'mem_40:10:5000:94': 102.09,
  'mem_40:10:5000:95': 102.09,
  'mem_40:10:5000:96': 165.66,
  'mem_40:10:5000:97': 165.66,
  'mem_40:10:5000:98': 165.66,
  'mem_40:10:5000:99': 165.66,
  'mem_40:10:5000:100': 165.66,
  'mem_40:10:5000:101': 288.43,
  'mem_40:10:5000:102': 288.43,
  'mem_40:10:5000:103': 288.43,
  'mem_40:10:5000:104': 288.43,
  'mem_40:10:5000:105': 288.43,
  'mem_40:10:5000:106': 363.5,
  'mem_40:10:5000:107': 363.5,
  'mem_40:10:5000:108': 363.5,
  'mem_40:10:5000:109': 363.5,
  'mem_40:10:5000:110': 363.5,
  'mem_40:10:5000:111': 363.69,
  'mem_40:10:5000:112': 363.69,
  'mem_40:10:5000:113': 363.69,
  'mem_40:10:5000:114': 363.69,
  'mem_40:10:5000:115': 363.69,
  'mem_40:10:5000:116': 363.69,
  'mem_40:10:5000:117': 363.69,
  'mem_40:10:5000:118': 363.69,
  'mem_40:10:5000:119': 363.69,
  'mem_40:10:5000:120': 363.69,
  'mem_40:10:7500:1': 2.4,
  'mem_40:10:7500:2': 2.4,
  'mem_40:10:7500:3': 2.4,
  'mem_40:10:7500:4': 2.4,
  'mem_40:10:7500:5': 2.4,
  'mem_40:10:7500:6': 2.4,
  'mem_40:10:7500:7': 2.4,
  'mem_40:10:7500:8': 2.4,
  'mem_40:10:7500:9': 2.4,
  'mem_40:10:7500:10': 2.4,
  'mem_40:10:7500:11': 2.4,
  'mem_40:10:7500:12': 2.4,
  'mem_40:10:7500:13': 2.4,
  'mem_40:10:7500:14': 2.4,
  'mem_40:10:7500:15': 2.4,
  'mem_40:10:7500:16': 2.4,
  'mem_40:10:7500:17': 2.4,
  'mem_40:10:7500:18': 2.4,
  'mem_40:10:7500:19': 2.4,
  'mem_40:10:7500:20': 2.4,
  'mem_40:10:7500:21': 2.4,
  'mem_40:10:7500:22': 2.4,
  'mem_40:10:7500:23': 2.4,
  'mem_40:10:7500:24': 2.4,
  'mem_40:10:7500:25': 2.4,
  'mem_40:10:7500:26': 3.6,
  'mem_40:10:7500:27': 3.6,
  'mem_40:10:7500:28': 3.6,
  'mem_40:10:7500:29': 3.6,
  'mem_40:10:7500:30': 3.6,
  'mem_40:10:7500:31': 4.8,
  'mem_40:10:7500:32': 4.8,
  'mem_40:10:7500:33': 4.8,
  'mem_40:10:7500:34': 4.8,
  'mem_40:10:7500:35': 4.8,
  'mem_40:10:7500:36': 6,
  'mem_40:10:7500:37': 6,
  'mem_40:10:7500:38': 6,
  'mem_40:10:7500:39': 6,
  'mem_40:10:7500:40': 6,
  'mem_40:10:7500:41': 9.6,
  'mem_40:10:7500:42': 9.6,
  'mem_40:10:7500:43': 9.6,
  'mem_40:10:7500:44': 9.6,
  'mem_40:10:7500:45': 9.6,
  'mem_40:10:7500:46': 14.4,
  'mem_40:10:7500:47': 14.4,
  'mem_40:10:7500:48': 14.4,
  'mem_40:10:7500:49': 14.4,
  'mem_40:10:7500:50': 14.4,
  'mem_40:10:7500:51': 21.6,
  'mem_40:10:7500:52': 21.6,
  'mem_40:10:7500:53': 21.6,
  'mem_40:10:7500:54': 21.6,
  'mem_40:10:7500:55': 21.6,
  'mem_40:10:7500:56': 22.8,
  'mem_40:10:7500:57': 22.8,
  'mem_40:10:7500:58': 22.8,
  'mem_40:10:7500:59': 22.8,
  'mem_40:10:7500:60': 22.8,
  'mem_40:10:7500:61': 25.2,
  'mem_40:10:7500:62': 25.2,
  'mem_40:10:7500:63': 25.2,
  'mem_40:10:7500:64': 25.2,
  'mem_40:10:7500:65': 25.2,
  'mem_40:10:7500:66': 34.8,
  'mem_40:10:7500:67': 34.8,
  'mem_40:10:7500:68': 34.8,
  'mem_40:10:7500:69': 34.8,
  'mem_40:10:7500:70': 34.8,
  'mem_40:10:7500:71': 46.8,
  'mem_40:10:7500:72': 46.8,
  'mem_40:10:7500:73': 46.8,
  'mem_40:10:7500:74': 46.8,
  'mem_40:10:7500:75': 46.8,
  'mem_40:10:7500:76': 62.4,
  'mem_40:10:7500:77': 62.4,
  'mem_40:10:7500:78': 62.4,
  'mem_40:10:7500:79': 62.4,
  'mem_40:10:7500:80': 62.4,
  'mem_40:10:7500:81': 84.78,
  'mem_40:10:7500:82': 84.78,
  'mem_40:10:7500:83': 84.78,
  'mem_40:10:7500:84': 84.78,
  'mem_40:10:7500:85': 84.78,
  'mem_40:10:7500:86': 113.44,
  'mem_40:10:7500:87': 113.44,
  'mem_40:10:7500:88': 113.44,
  'mem_40:10:7500:89': 113.44,
  'mem_40:10:7500:90': 113.44,
  'mem_40:10:7500:91': 153.05,
  'mem_40:10:7500:92': 153.05,
  'mem_40:10:7500:93': 153.05,
  'mem_40:10:7500:94': 153.05,
  'mem_40:10:7500:95': 153.05,
  'mem_40:10:7500:96': 248.39,
  'mem_40:10:7500:97': 248.39,
  'mem_40:10:7500:98': 248.39,
  'mem_40:10:7500:99': 248.39,
  'mem_40:10:7500:100': 248.39,
  'mem_40:10:7500:101': 432.61,
  'mem_40:10:7500:102': 432.61,
  'mem_40:10:7500:103': 432.61,
  'mem_40:10:7500:104': 432.61,
  'mem_40:10:7500:105': 432.61,
  'mem_40:10:7500:106': 544.99,
  'mem_40:10:7500:107': 544.99,
  'mem_40:10:7500:108': 544.99,
  'mem_40:10:7500:109': 544.99,
  'mem_40:10:7500:110': 544.99,
  'mem_40:10:7500:111': 544.99,
  'mem_40:10:7500:112': 544.99,
  'mem_40:10:7500:113': 544.99,
  'mem_40:10:7500:114': 544.99,
  'mem_40:10:7500:115': 544.99,
  'mem_40:10:7500:116': 544.99,
  'mem_40:10:7500:117': 544.99,
  'mem_40:10:7500:118': 544.99,
  'mem_40:10:7500:119': 544.99,
  'mem_40:10:7500:120': 544.99,
  'mem_40:10:10000:1': 3.6,
  'mem_40:10:10000:2': 3.6,
  'mem_40:10:10000:3': 3.6,
  'mem_40:10:10000:4': 3.6,
  'mem_40:10:10000:5': 3.6,
  'mem_40:10:10000:6': 3.6,
  'mem_40:10:10000:7': 3.6,
  'mem_40:10:10000:8': 3.6,
  'mem_40:10:10000:9': 3.6,
  'mem_40:10:10000:10': 3.6,
  'mem_40:10:10000:11': 3.6,
  'mem_40:10:10000:12': 3.6,
  'mem_40:10:10000:13': 3.6,
  'mem_40:10:10000:14': 3.6,
  'mem_40:10:10000:15': 3.6,
  'mem_40:10:10000:16': 3.6,
  'mem_40:10:10000:17': 3.6,
  'mem_40:10:10000:18': 3.6,
  'mem_40:10:10000:19': 3.6,
  'mem_40:10:10000:20': 3.6,
  'mem_40:10:10000:21': 3.6,
  'mem_40:10:10000:22': 3.6,
  'mem_40:10:10000:23': 3.6,
  'mem_40:10:10000:24': 3.6,
  'mem_40:10:10000:25': 3.6,
  'mem_40:10:10000:26': 4.8,
  'mem_40:10:10000:27': 4.8,
  'mem_40:10:10000:28': 4.8,
  'mem_40:10:10000:29': 4.8,
  'mem_40:10:10000:30': 4.8,
  'mem_40:10:10000:31': 6,
  'mem_40:10:10000:32': 6,
  'mem_40:10:10000:33': 6,
  'mem_40:10:10000:34': 6,
  'mem_40:10:10000:35': 6,
  'mem_40:10:10000:36': 8.4,
  'mem_40:10:10000:37': 8.4,
  'mem_40:10:10000:38': 8.4,
  'mem_40:10:10000:39': 8.4,
  'mem_40:10:10000:40': 8.4,
  'mem_40:10:10000:41': 13.2,
  'mem_40:10:10000:42': 13.2,
  'mem_40:10:10000:43': 13.2,
  'mem_40:10:10000:44': 13.2,
  'mem_40:10:10000:45': 13.2,
  'mem_40:10:10000:46': 19.2,
  'mem_40:10:10000:47': 19.2,
  'mem_40:10:10000:48': 19.2,
  'mem_40:10:10000:49': 19.2,
  'mem_40:10:10000:50': 19.2,
  'mem_40:10:10000:51': 28.8,
  'mem_40:10:10000:52': 28.8,
  'mem_40:10:10000:53': 28.8,
  'mem_40:10:10000:54': 28.8,
  'mem_40:10:10000:55': 28.8,
  'mem_40:10:10000:56': 30,
  'mem_40:10:10000:57': 30,
  'mem_40:10:10000:58': 30,
  'mem_40:10:10000:59': 30,
  'mem_40:10:10000:60': 30,
  'mem_40:10:10000:61': 32.4,
  'mem_40:10:10000:62': 32.4,
  'mem_40:10:10000:63': 32.4,
  'mem_40:10:10000:64': 32.4,
  'mem_40:10:10000:65': 32.4,
  'mem_40:10:10000:66': 46.8,
  'mem_40:10:10000:67': 46.8,
  'mem_40:10:10000:68': 46.8,
  'mem_40:10:10000:69': 46.8,
  'mem_40:10:10000:70': 46.8,
  'mem_40:10:10000:71': 62.4,
  'mem_40:10:10000:72': 62.4,
  'mem_40:10:10000:73': 62.4,
  'mem_40:10:10000:74': 62.4,
  'mem_40:10:10000:75': 62.4,
  'mem_40:10:10000:76': 82.8,
  'mem_40:10:10000:77': 82.8,
  'mem_40:10:10000:78': 82.8,
  'mem_40:10:10000:79': 82.8,
  'mem_40:10:10000:80': 82.8,
  'mem_40:10:10000:81': 113.02,
  'mem_40:10:10000:82': 113.02,
  'mem_40:10:10000:83': 113.02,
  'mem_40:10:10000:84': 113.02,
  'mem_40:10:10000:85': 113.02,
  'mem_40:10:10000:86': 151.22,
  'mem_40:10:10000:87': 151.22,
  'mem_40:10:10000:88': 151.22,
  'mem_40:10:10000:89': 151.22,
  'mem_40:10:10000:90': 151.22,
  'mem_40:10:10000:91': 204.04,
  'mem_40:10:10000:92': 204.04,
  'mem_40:10:10000:93': 204.04,
  'mem_40:10:10000:94': 204.04,
  'mem_40:10:10000:95': 204.04,
  'mem_40:10:10000:96': 331.13,
  'mem_40:10:10000:97': 331.13,
  'mem_40:10:10000:98': 331.13,
  'mem_40:10:10000:99': 331.13,
  'mem_40:10:10000:100': 331.13,
  'mem_40:10:10000:101': 576.74,
  'mem_40:10:10000:102': 576.74,
  'mem_40:10:10000:103': 576.74,
  'mem_40:10:10000:104': 576.74,
  'mem_40:10:10000:105': 576.74,
  'mem_40:10:10000:106': 726.54,
  'mem_40:10:10000:107': 726.54,
  'mem_40:10:10000:108': 726.54,
  'mem_40:10:10000:109': 726.54,
  'mem_40:10:10000:110': 726.54,
  'mem_40:10:10000:111': 726.54,
  'mem_40:10:10000:112': 726.54,
  'mem_40:10:10000:113': 726.54,
  'mem_40:10:10000:114': 726.54,
  'mem_40:10:10000:115': 726.54,
  'mem_40:10:10000:116': 726.54,
  'mem_40:10:10000:117': 726.54,
  'mem_40:10:10000:118': 726.54,
  'mem_40:10:10000:119': 726.54,
  'mem_40:10:10000:120': 726.54,
  'mem_40:10:15000:1': 4.8,
  'mem_40:10:15000:2': 4.8,
  'mem_40:10:15000:3': 4.8,
  'mem_40:10:15000:4': 4.8,
  'mem_40:10:15000:5': 4.8,
  'mem_40:10:15000:6': 4.8,
  'mem_40:10:15000:7': 4.8,
  'mem_40:10:15000:8': 4.8,
  'mem_40:10:15000:9': 4.8,
  'mem_40:10:15000:10': 4.8,
  'mem_40:10:15000:11': 4.8,
  'mem_40:10:15000:12': 4.8,
  'mem_40:10:15000:13': 4.8,
  'mem_40:10:15000:14': 4.8,
  'mem_40:10:15000:15': 4.8,
  'mem_40:10:15000:16': 4.8,
  'mem_40:10:15000:17': 4.8,
  'mem_40:10:15000:18': 4.8,
  'mem_40:10:15000:19': 4.8,
  'mem_40:10:15000:20': 4.8,
  'mem_40:10:15000:21': 4.8,
  'mem_40:10:15000:22': 4.8,
  'mem_40:10:15000:23': 4.8,
  'mem_40:10:15000:24': 4.8,
  'mem_40:10:15000:25': 4.8,
  'mem_40:10:15000:26': 6,
  'mem_40:10:15000:27': 6,
  'mem_40:10:15000:28': 6,
  'mem_40:10:15000:29': 6,
  'mem_40:10:15000:30': 6,
  'mem_40:10:15000:31': 8.4,
  'mem_40:10:15000:32': 8.4,
  'mem_40:10:15000:33': 8.4,
  'mem_40:10:15000:34': 8.4,
  'mem_40:10:15000:35': 8.4,
  'mem_40:10:15000:36': 12,
  'mem_40:10:15000:37': 12,
  'mem_40:10:15000:38': 12,
  'mem_40:10:15000:39': 12,
  'mem_40:10:15000:40': 12,
  'mem_40:10:15000:41': 19.2,
  'mem_40:10:15000:42': 19.2,
  'mem_40:10:15000:43': 19.2,
  'mem_40:10:15000:44': 19.2,
  'mem_40:10:15000:45': 19.2,
  'mem_40:10:15000:46': 28.8,
  'mem_40:10:15000:47': 28.8,
  'mem_40:10:15000:48': 28.8,
  'mem_40:10:15000:49': 28.8,
  'mem_40:10:15000:50': 28.8,
  'mem_40:10:15000:51': 42,
  'mem_40:10:15000:52': 42,
  'mem_40:10:15000:53': 42,
  'mem_40:10:15000:54': 42,
  'mem_40:10:15000:55': 42,
  'mem_40:10:15000:56': 45.6,
  'mem_40:10:15000:57': 45.6,
  'mem_40:10:15000:58': 45.6,
  'mem_40:10:15000:59': 45.6,
  'mem_40:10:15000:60': 45.6,
  'mem_40:10:15000:61': 49.2,
  'mem_40:10:15000:62': 49.2,
  'mem_40:10:15000:63': 49.2,
  'mem_40:10:15000:64': 49.2,
  'mem_40:10:15000:65': 49.2,
  'mem_40:10:15000:66': 69.6,
  'mem_40:10:15000:67': 69.6,
  'mem_40:10:15000:68': 69.6,
  'mem_40:10:15000:69': 69.6,
  'mem_40:10:15000:70': 69.6,
  'mem_40:10:15000:71': 93.6,
  'mem_40:10:15000:72': 93.6,
  'mem_40:10:15000:73': 93.6,
  'mem_40:10:15000:74': 93.6,
  'mem_40:10:15000:75': 93.6,
  'mem_40:10:15000:76': 123.6,
  'mem_40:10:15000:77': 123.6,
  'mem_40:10:15000:78': 123.6,
  'mem_40:10:15000:79': 123.6,
  'mem_40:10:15000:80': 123.6,
  'mem_40:10:15000:81': 169.56,
  'mem_40:10:15000:82': 169.56,
  'mem_40:10:15000:83': 169.56,
  'mem_40:10:15000:84': 169.56,
  'mem_40:10:15000:85': 169.56,
  'mem_40:10:15000:86': 226.87,
  'mem_40:10:15000:87': 226.87,
  'mem_40:10:15000:88': 226.87,
  'mem_40:10:15000:89': 226.87,
  'mem_40:10:15000:90': 226.87,
  'mem_40:10:15000:91': 306.1,
  'mem_40:10:15000:92': 306.1,
  'mem_40:10:15000:93': 306.1,
  'mem_40:10:15000:94': 306.1,
  'mem_40:10:15000:95': 306.1,
  'mem_40:10:15000:96': 496.77,
  'mem_40:10:15000:97': 496.77,
  'mem_40:10:15000:98': 496.77,
  'mem_40:10:15000:99': 496.77,
  'mem_40:10:15000:100': 496.77,
  'mem_40:10:15000:101': 865.23,
  'mem_40:10:15000:102': 865.23,
  'mem_40:10:15000:103': 865.23,
  'mem_40:10:15000:104': 865.23,
  'mem_40:10:15000:105': 865.23,
  'mem_40:10:15000:106': 1089.97,
  'mem_40:10:15000:107': 1089.97,
  'mem_40:10:15000:108': 1089.97,
  'mem_40:10:15000:109': 1089.97,
  'mem_40:10:15000:110': 1089.97,
  'mem_40:10:15000:111': 1089.97,
  'mem_40:10:15000:112': 1089.97,
  'mem_40:10:15000:113': 1089.97,
  'mem_40:10:15000:114': 1089.97,
  'mem_40:10:15000:115': 1089.97,
  'mem_40:10:15000:116': 1089.97,
  'mem_40:10:15000:117': 1089.97,
  'mem_40:10:15000:118': 1089.97,
  'mem_40:10:15000:119': 1089.97,
  'mem_40:10:15000:120': 1089.97,
  'mem_40:10:20000:1': 6,
  'mem_40:10:20000:2': 6,
  'mem_40:10:20000:3': 6,
  'mem_40:10:20000:4': 6,
  'mem_40:10:20000:5': 6,
  'mem_40:10:20000:6': 6,
  'mem_40:10:20000:7': 6,
  'mem_40:10:20000:8': 6,
  'mem_40:10:20000:9': 6,
  'mem_40:10:20000:10': 6,
  'mem_40:10:20000:11': 6,
  'mem_40:10:20000:12': 6,
  'mem_40:10:20000:13': 6,
  'mem_40:10:20000:14': 6,
  'mem_40:10:20000:15': 6,
  'mem_40:10:20000:16': 6,
  'mem_40:10:20000:17': 6,
  'mem_40:10:20000:18': 6,
  'mem_40:10:20000:19': 6,
  'mem_40:10:20000:20': 6,
  'mem_40:10:20000:21': 7.2,
  'mem_40:10:20000:22': 7.2,
  'mem_40:10:20000:23': 7.2,
  'mem_40:10:20000:24': 7.2,
  'mem_40:10:20000:25': 7.2,
  'mem_40:10:20000:26': 8.4,
  'mem_40:10:20000:27': 8.4,
  'mem_40:10:20000:28': 8.4,
  'mem_40:10:20000:29': 8.4,
  'mem_40:10:20000:30': 8.4,
  'mem_40:10:20000:31': 10.8,
  'mem_40:10:20000:32': 10.8,
  'mem_40:10:20000:33': 10.8,
  'mem_40:10:20000:34': 10.8,
  'mem_40:10:20000:35': 10.8,
  'mem_40:10:20000:36': 15.6,
  'mem_40:10:20000:37': 15.6,
  'mem_40:10:20000:38': 15.6,
  'mem_40:10:20000:39': 15.6,
  'mem_40:10:20000:40': 15.6,
  'mem_40:10:20000:41': 25.2,
  'mem_40:10:20000:42': 25.2,
  'mem_40:10:20000:43': 25.2,
  'mem_40:10:20000:44': 25.2,
  'mem_40:10:20000:45': 25.2,
  'mem_40:10:20000:46': 37.2,
  'mem_40:10:20000:47': 37.2,
  'mem_40:10:20000:48': 37.2,
  'mem_40:10:20000:49': 37.2,
  'mem_40:10:20000:50': 37.2,
  'mem_40:10:20000:51': 56.4,
  'mem_40:10:20000:52': 56.4,
  'mem_40:10:20000:53': 56.4,
  'mem_40:10:20000:54': 56.4,
  'mem_40:10:20000:55': 56.4,
  'mem_40:10:20000:56': 60,
  'mem_40:10:20000:57': 60,
  'mem_40:10:20000:58': 60,
  'mem_40:10:20000:59': 60,
  'mem_40:10:20000:60': 60,
  'mem_40:10:20000:61': 64.8,
  'mem_40:10:20000:62': 64.8,
  'mem_40:10:20000:63': 64.8,
  'mem_40:10:20000:64': 64.8,
  'mem_40:10:20000:65': 64.8,
  'mem_40:10:20000:66': 92.4,
  'mem_40:10:20000:67': 92.4,
  'mem_40:10:20000:68': 92.4,
  'mem_40:10:20000:69': 92.4,
  'mem_40:10:20000:70': 92.4,
  'mem_40:10:20000:71': 123.6,
  'mem_40:10:20000:72': 123.6,
  'mem_40:10:20000:73': 123.6,
  'mem_40:10:20000:74': 123.6,
  'mem_40:10:20000:75': 123.6,
  'mem_40:10:20000:76': 164.4,
  'mem_40:10:20000:77': 164.4,
  'mem_40:10:20000:78': 164.4,
  'mem_40:10:20000:79': 164.4,
  'mem_40:10:20000:80': 164.4,
  'mem_40:10:20000:81': 226.04,
  'mem_40:10:20000:82': 226.04,
  'mem_40:10:20000:83': 226.04,
  'mem_40:10:20000:84': 226.04,
  'mem_40:10:20000:85': 226.04,
  'mem_40:10:20000:86': 302.44,
  'mem_40:10:20000:87': 302.44,
  'mem_40:10:20000:88': 302.44,
  'mem_40:10:20000:89': 302.44,
  'mem_40:10:20000:90': 302.44,
  'mem_40:10:20000:91': 408.07,
  'mem_40:10:20000:92': 408.07,
  'mem_40:10:20000:93': 408.07,
  'mem_40:10:20000:94': 408.07,
  'mem_40:10:20000:95': 408.07,
  'mem_40:10:20000:96': 662.27,
  'mem_40:10:20000:97': 662.27,
  'mem_40:10:20000:98': 662.27,
  'mem_40:10:20000:99': 662.27,
  'mem_40:10:20000:100': 662.27,
  'mem_40:10:20000:101': 1153.47,
  'mem_40:10:20000:102': 1153.47,
  'mem_40:10:20000:103': 1153.47,
  'mem_40:10:20000:104': 1153.47,
  'mem_40:10:20000:105': 1153.47,
  'mem_40:10:20000:106': 1453.09,
  'mem_40:10:20000:107': 1453.09,
  'mem_40:10:20000:108': 1453.09,
  'mem_40:10:20000:109': 1453.09,
  'mem_40:10:20000:110': 1453.09,
  'mem_40:10:20000:111': 1453.09,
  'mem_40:10:20000:112': 1453.09,
  'mem_40:10:20000:113': 1453.09,
  'mem_40:10:20000:114': 1453.09,
  'mem_40:10:20000:115': 1453.09,
  'mem_40:10:20000:116': 1453.09,
  'mem_40:10:20000:117': 1453.09,
  'mem_40:10:20000:118': 1453.09,
  'mem_40:10:20000:119': 1453.09,
  'mem_40:10:20000:120': 1453.09,
  'mem_40:10:25000:1': 7.2,
  'mem_40:10:25000:2': 7.2,
  'mem_40:10:25000:3': 7.2,
  'mem_40:10:25000:4': 7.2,
  'mem_40:10:25000:5': 7.2,
  'mem_40:10:25000:6': 7.2,
  'mem_40:10:25000:7': 7.2,
  'mem_40:10:25000:8': 7.2,
  'mem_40:10:25000:9': 7.2,
  'mem_40:10:25000:10': 7.2,
  'mem_40:10:25000:11': 7.2,
  'mem_40:10:25000:12': 7.2,
  'mem_40:10:25000:13': 7.2,
  'mem_40:10:25000:14': 7.2,
  'mem_40:10:25000:15': 7.2,
  'mem_40:10:25000:16': 7.2,
  'mem_40:10:25000:17': 7.2,
  'mem_40:10:25000:18': 7.2,
  'mem_40:10:25000:19': 7.2,
  'mem_40:10:25000:20': 7.2,
  'mem_40:10:25000:21': 8.4,
  'mem_40:10:25000:22': 8.4,
  'mem_40:10:25000:23': 8.4,
  'mem_40:10:25000:24': 8.4,
  'mem_40:10:25000:25': 8.4,
  'mem_40:10:25000:26': 9.6,
  'mem_40:10:25000:27': 9.6,
  'mem_40:10:25000:28': 9.6,
  'mem_40:10:25000:29': 9.6,
  'mem_40:10:25000:30': 9.6,
  'mem_40:10:25000:31': 13.2,
  'mem_40:10:25000:32': 13.2,
  'mem_40:10:25000:33': 13.2,
  'mem_40:10:25000:34': 13.2,
  'mem_40:10:25000:35': 13.2,
  'mem_40:10:25000:36': 19.2,
  'mem_40:10:25000:37': 19.2,
  'mem_40:10:25000:38': 19.2,
  'mem_40:10:25000:39': 19.2,
  'mem_40:10:25000:40': 19.2,
  'mem_40:10:25000:41': 31.2,
  'mem_40:10:25000:42': 31.2,
  'mem_40:10:25000:43': 31.2,
  'mem_40:10:25000:44': 31.2,
  'mem_40:10:25000:45': 31.2,
  'mem_40:10:25000:46': 46.8,
  'mem_40:10:25000:47': 46.8,
  'mem_40:10:25000:48': 46.8,
  'mem_40:10:25000:49': 46.8,
  'mem_40:10:25000:50': 46.8,
  'mem_40:10:25000:51': 69.6,
  'mem_40:10:25000:52': 69.6,
  'mem_40:10:25000:53': 69.6,
  'mem_40:10:25000:54': 69.6,
  'mem_40:10:25000:55': 69.6,
  'mem_40:10:25000:56': 75.6,
  'mem_40:10:25000:57': 75.6,
  'mem_40:10:25000:58': 75.6,
  'mem_40:10:25000:59': 75.6,
  'mem_40:10:25000:60': 75.6,
  'mem_40:10:25000:61': 81.6,
  'mem_40:10:25000:62': 81.6,
  'mem_40:10:25000:63': 81.6,
  'mem_40:10:25000:64': 81.6,
  'mem_40:10:25000:65': 81.6,
  'mem_40:10:25000:66': 115.2,
  'mem_40:10:25000:67': 115.2,
  'mem_40:10:25000:68': 115.2,
  'mem_40:10:25000:69': 115.2,
  'mem_40:10:25000:70': 115.2,
  'mem_40:10:25000:71': 154.8,
  'mem_40:10:25000:72': 154.8,
  'mem_40:10:25000:73': 154.8,
  'mem_40:10:25000:74': 154.8,
  'mem_40:10:25000:75': 154.8,
  'mem_40:10:25000:76': 205.2,
  'mem_40:10:25000:77': 205.2,
  'mem_40:10:25000:78': 205.2,
  'mem_40:10:25000:79': 205.2,
  'mem_40:10:25000:80': 205.2,
  'mem_40:10:25000:81': 282.63,
  'mem_40:10:25000:82': 282.63,
  'mem_40:10:25000:83': 282.63,
  'mem_40:10:25000:84': 282.63,
  'mem_40:10:25000:85': 282.63,
  'mem_40:10:25000:86': 378.16,
  'mem_40:10:25000:87': 378.16,
  'mem_40:10:25000:88': 378.16,
  'mem_40:10:25000:89': 378.16,
  'mem_40:10:25000:90': 378.16,
  'mem_40:10:25000:91': 510.22,
  'mem_40:10:25000:92': 510.22,
  'mem_40:10:25000:93': 510.22,
  'mem_40:10:25000:94': 510.22,
  'mem_40:10:25000:95': 510.22,
  'mem_40:10:25000:96': 828.03,
  'mem_40:10:25000:97': 828.03,
  'mem_40:10:25000:98': 828.03,
  'mem_40:10:25000:99': 828.03,
  'mem_40:10:25000:100': 828.03,
  'mem_40:10:25000:101': 1440.02,
  'mem_40:10:25000:102': 1440.02,
  'mem_40:10:25000:103': 1440.02,
  'mem_40:10:25000:104': 1440.02,
  'mem_40:10:25000:105': 1440.02,
  'mem_40:10:25000:106': 1812.47,
  'mem_40:10:25000:107': 1812.47,
  'mem_40:10:25000:108': 1812.47,
  'mem_40:10:25000:109': 1812.47,
  'mem_40:10:25000:110': 1812.47,
  'mem_40:10:25000:111': 1812.47,
  'mem_40:10:25000:112': 1812.47,
  'mem_40:10:25000:113': 1812.47,
  'mem_40:10:25000:114': 1812.47,
  'mem_40:10:25000:115': 1812.47,
  'mem_40:10:25000:116': 1812.47,
  'mem_40:10:25000:117': 1812.47,
  'mem_40:10:25000:118': 1812.47,
  'mem_40:10:25000:119': 1812.47,
  'mem_40:10:25000:120': 1812.47,
  'mem_40:10:30000:1': 8.4,
  'mem_40:10:30000:2': 8.4,
  'mem_40:10:30000:3': 8.4,
  'mem_40:10:30000:4': 8.4,
  'mem_40:10:30000:5': 8.4,
  'mem_40:10:30000:6': 8.4,
  'mem_40:10:30000:7': 8.4,
  'mem_40:10:30000:8': 8.4,
  'mem_40:10:30000:9': 8.4,
  'mem_40:10:30000:10': 8.4,
  'mem_40:10:30000:11': 8.4,
  'mem_40:10:30000:12': 8.4,
  'mem_40:10:30000:13': 8.4,
  'mem_40:10:30000:14': 8.4,
  'mem_40:10:30000:15': 8.4,
  'mem_40:10:30000:16': 8.4,
  'mem_40:10:30000:17': 8.4,
  'mem_40:10:30000:18': 8.4,
  'mem_40:10:30000:19': 8.4,
  'mem_40:10:30000:20': 8.4,
  'mem_40:10:30000:21': 9.6,
  'mem_40:10:30000:22': 9.6,
  'mem_40:10:30000:23': 9.6,
  'mem_40:10:30000:24': 9.6,
  'mem_40:10:30000:25': 9.6,
  'mem_40:10:30000:26': 12,
  'mem_40:10:30000:27': 12,
  'mem_40:10:30000:28': 12,
  'mem_40:10:30000:29': 12,
  'mem_40:10:30000:30': 12,
  'mem_40:10:30000:31': 15.6,
  'mem_40:10:30000:32': 15.6,
  'mem_40:10:30000:33': 15.6,
  'mem_40:10:30000:34': 15.6,
  'mem_40:10:30000:35': 15.6,
  'mem_40:10:30000:36': 24,
  'mem_40:10:30000:37': 24,
  'mem_40:10:30000:38': 24,
  'mem_40:10:30000:39': 24,
  'mem_40:10:30000:40': 24,
  'mem_40:10:30000:41': 37.2,
  'mem_40:10:30000:42': 37.2,
  'mem_40:10:30000:43': 37.2,
  'mem_40:10:30000:44': 37.2,
  'mem_40:10:30000:45': 37.2,
  'mem_40:10:30000:46': 56.4,
  'mem_40:10:30000:47': 56.4,
  'mem_40:10:30000:48': 56.4,
  'mem_40:10:30000:49': 56.4,
  'mem_40:10:30000:50': 56.4,
  'mem_40:10:30000:51': 84,
  'mem_40:10:30000:52': 84,
  'mem_40:10:30000:53': 84,
  'mem_40:10:30000:54': 84,
  'mem_40:10:30000:55': 84,
  'mem_40:10:30000:56': 90,
  'mem_40:10:30000:57': 90,
  'mem_40:10:30000:58': 90,
  'mem_40:10:30000:59': 90,
  'mem_40:10:30000:60': 90,
  'mem_40:10:30000:61': 97.2,
  'mem_40:10:30000:62': 97.2,
  'mem_40:10:30000:63': 97.2,
  'mem_40:10:30000:64': 97.2,
  'mem_40:10:30000:65': 97.2,
  'mem_40:10:30000:66': 138,
  'mem_40:10:30000:67': 138,
  'mem_40:10:30000:68': 138,
  'mem_40:10:30000:69': 138,
  'mem_40:10:30000:70': 138,
  'mem_40:10:30000:71': 186,
  'mem_40:10:30000:72': 186,
  'mem_40:10:30000:73': 186,
  'mem_40:10:30000:74': 186,
  'mem_40:10:30000:75': 186,
  'mem_40:10:30000:76': 246,
  'mem_40:10:30000:77': 246,
  'mem_40:10:30000:78': 246,
  'mem_40:10:30000:79': 246,
  'mem_40:10:30000:80': 246,
  'mem_40:10:30000:81': 338.83,
  'mem_40:10:30000:82': 338.83,
  'mem_40:10:30000:83': 338.83,
  'mem_40:10:30000:84': 338.83,
  'mem_40:10:30000:85': 338.83,
  'mem_40:10:30000:86': 453.36,
  'mem_40:10:30000:87': 453.36,
  'mem_40:10:30000:88': 453.36,
  'mem_40:10:30000:89': 453.36,
  'mem_40:10:30000:90': 453.36,
  'mem_40:10:30000:91': 611.71,
  'mem_40:10:30000:92': 611.71,
  'mem_40:10:30000:93': 611.71,
  'mem_40:10:30000:94': 611.71,
  'mem_40:10:30000:95': 611.71,
  'mem_40:10:30000:96': 992.78,
  'mem_40:10:30000:97': 992.78,
  'mem_40:10:30000:98': 992.78,
  'mem_40:10:30000:99': 992.78,
  'mem_40:10:30000:100': 992.78,
  'mem_40:10:30000:101': 1729.07,
  'mem_40:10:30000:102': 1729.07,
  'mem_40:10:30000:103': 1729.07,
  'mem_40:10:30000:104': 1729.07,
  'mem_40:10:30000:105': 1729.07,
  'mem_40:10:30000:106': 2178.16,
  'mem_40:10:30000:107': 2178.16,
  'mem_40:10:30000:108': 2178.16,
  'mem_40:10:30000:109': 2178.16,
  'mem_40:10:30000:110': 2178.16,
  'mem_40:10:30000:111': 2178.16,
  'mem_40:10:30000:112': 2178.16,
  'mem_40:10:30000:113': 2178.16,
  'mem_40:10:30000:114': 2178.16,
  'mem_40:10:30000:115': 2178.16,
  'mem_40:10:30000:116': 2178.16,
  'mem_40:10:30000:117': 2178.16,
  'mem_40:10:30000:118': 2178.16,
  'mem_40:10:30000:119': 2178.16,
  'mem_40:10:30000:120': 2178.16,
  'mem_40:10:40000:1': 10.8,
  'mem_40:10:40000:2': 10.8,
  'mem_40:10:40000:3': 10.8,
  'mem_40:10:40000:4': 10.8,
  'mem_40:10:40000:5': 10.8,
  'mem_40:10:40000:6': 10.8,
  'mem_40:10:40000:7': 10.8,
  'mem_40:10:40000:8': 10.8,
  'mem_40:10:40000:9': 10.8,
  'mem_40:10:40000:10': 10.8,
  'mem_40:10:40000:11': 10.8,
  'mem_40:10:40000:12': 10.8,
  'mem_40:10:40000:13': 10.8,
  'mem_40:10:40000:14': 10.8,
  'mem_40:10:40000:15': 10.8,
  'mem_40:10:40000:16': 12,
  'mem_40:10:40000:17': 12,
  'mem_40:10:40000:18': 12,
  'mem_40:10:40000:19': 12,
  'mem_40:10:40000:20': 12,
  'mem_40:10:40000:21': 13.2,
  'mem_40:10:40000:22': 13.2,
  'mem_40:10:40000:23': 13.2,
  'mem_40:10:40000:24': 13.2,
  'mem_40:10:40000:25': 13.2,
  'mem_40:10:40000:26': 15.6,
  'mem_40:10:40000:27': 15.6,
  'mem_40:10:40000:28': 15.6,
  'mem_40:10:40000:29': 15.6,
  'mem_40:10:40000:30': 15.6,
  'mem_40:10:40000:31': 20.4,
  'mem_40:10:40000:32': 20.4,
  'mem_40:10:40000:33': 20.4,
  'mem_40:10:40000:34': 20.4,
  'mem_40:10:40000:35': 20.4,
  'mem_40:10:40000:36': 31.2,
  'mem_40:10:40000:37': 31.2,
  'mem_40:10:40000:38': 31.2,
  'mem_40:10:40000:39': 31.2,
  'mem_40:10:40000:40': 31.2,
  'mem_40:10:40000:41': 49.2,
  'mem_40:10:40000:42': 49.2,
  'mem_40:10:40000:43': 49.2,
  'mem_40:10:40000:44': 49.2,
  'mem_40:10:40000:45': 49.2,
  'mem_40:10:40000:46': 74.4,
  'mem_40:10:40000:47': 74.4,
  'mem_40:10:40000:48': 74.4,
  'mem_40:10:40000:49': 74.4,
  'mem_40:10:40000:50': 74.4,
  'mem_40:10:40000:51': 111.6,
  'mem_40:10:40000:52': 111.6,
  'mem_40:10:40000:53': 111.6,
  'mem_40:10:40000:54': 111.6,
  'mem_40:10:40000:55': 111.6,
  'mem_40:10:40000:56': 120,
  'mem_40:10:40000:57': 120,
  'mem_40:10:40000:58': 120,
  'mem_40:10:40000:59': 120,
  'mem_40:10:40000:60': 120,
  'mem_40:10:40000:61': 129.6,
  'mem_40:10:40000:62': 129.6,
  'mem_40:10:40000:63': 129.6,
  'mem_40:10:40000:64': 129.6,
  'mem_40:10:40000:65': 129.6,
  'mem_40:10:40000:66': 183.6,
  'mem_40:10:40000:67': 183.6,
  'mem_40:10:40000:68': 183.6,
  'mem_40:10:40000:69': 183.6,
  'mem_40:10:40000:70': 183.6,
  'mem_40:10:40000:71': 247.2,
  'mem_40:10:40000:72': 247.2,
  'mem_40:10:40000:73': 247.2,
  'mem_40:10:40000:74': 247.2,
  'mem_40:10:40000:75': 247.2,
  'mem_40:10:40000:76': 327.6,
  'mem_40:10:40000:77': 327.6,
  'mem_40:10:40000:78': 327.6,
  'mem_40:10:40000:79': 327.6,
  'mem_40:10:40000:80': 327.6,
  'mem_40:10:40000:81': 452.08,
  'mem_40:10:40000:82': 452.08,
  'mem_40:10:40000:83': 452.08,
  'mem_40:10:40000:84': 452.08,
  'mem_40:10:40000:85': 452.08,
  'mem_40:10:40000:86': 604.88,
  'mem_40:10:40000:87': 604.88,
  'mem_40:10:40000:88': 604.88,
  'mem_40:10:40000:89': 604.88,
  'mem_40:10:40000:90': 604.88,
  'mem_40:10:40000:91': 816.14,
  'mem_40:10:40000:92': 816.14,
  'mem_40:10:40000:93': 816.14,
  'mem_40:10:40000:94': 816.14,
  'mem_40:10:40000:95': 816.14,
  'mem_40:10:40000:96': 1324.53,
  'mem_40:10:40000:97': 1324.53,
  'mem_40:10:40000:98': 1324.53,
  'mem_40:10:40000:99': 1324.53,
  'mem_40:10:40000:100': 1324.53,
  'mem_40:10:40000:101': 2306.94,
  'mem_40:10:40000:102': 2306.94,
  'mem_40:10:40000:103': 2306.94,
  'mem_40:10:40000:104': 2306.94,
  'mem_40:10:40000:105': 2306.94,
  'mem_40:10:40000:106': 2906.16,
  'mem_40:10:40000:107': 2906.16,
  'mem_40:10:40000:108': 2906.16,
  'mem_40:10:40000:109': 2906.16,
  'mem_40:10:40000:110': 2906.16,
  'mem_40:10:40000:111': 2906.16,
  'mem_40:10:40000:112': 2906.16,
  'mem_40:10:40000:113': 2906.16,
  'mem_40:10:40000:114': 2906.16,
  'mem_40:10:40000:115': 2906.16,
  'mem_40:10:40000:116': 2906.16,
  'mem_40:10:40000:117': 2906.16,
  'mem_40:10:40000:118': 2906.16,
  'mem_40:10:40000:119': 2906.16,
  'mem_40:10:40000:120': 2906.16,
  'mem_40:10:50000:1': 13.2,
  'mem_40:10:50000:2': 13.2,
  'mem_40:10:50000:3': 13.2,
  'mem_40:10:50000:4': 13.2,
  'mem_40:10:50000:5': 13.2,
  'mem_40:10:50000:6': 13.2,
  'mem_40:10:50000:7': 13.2,
  'mem_40:10:50000:8': 13.2,
  'mem_40:10:50000:9': 13.2,
  'mem_40:10:50000:10': 13.2,
  'mem_40:10:50000:11': 13.2,
  'mem_40:10:50000:12': 13.2,
  'mem_40:10:50000:13': 13.2,
  'mem_40:10:50000:14': 13.2,
  'mem_40:10:50000:15': 13.2,
  'mem_40:10:50000:16': 14.4,
  'mem_40:10:50000:17': 14.4,
  'mem_40:10:50000:18': 14.4,
  'mem_40:10:50000:19': 14.4,
  'mem_40:10:50000:20': 14.4,
  'mem_40:10:50000:21': 15.6,
  'mem_40:10:50000:22': 15.6,
  'mem_40:10:50000:23': 15.6,
  'mem_40:10:50000:24': 15.6,
  'mem_40:10:50000:25': 15.6,
  'mem_40:10:50000:26': 19.2,
  'mem_40:10:50000:27': 19.2,
  'mem_40:10:50000:28': 19.2,
  'mem_40:10:50000:29': 19.2,
  'mem_40:10:50000:30': 19.2,
  'mem_40:10:50000:31': 26.4,
  'mem_40:10:50000:32': 26.4,
  'mem_40:10:50000:33': 26.4,
  'mem_40:10:50000:34': 26.4,
  'mem_40:10:50000:35': 26.4,
  'mem_40:10:50000:36': 38.4,
  'mem_40:10:50000:37': 38.4,
  'mem_40:10:50000:38': 38.4,
  'mem_40:10:50000:39': 38.4,
  'mem_40:10:50000:40': 38.4,
  'mem_40:10:50000:41': 61.2,
  'mem_40:10:50000:42': 61.2,
  'mem_40:10:50000:43': 61.2,
  'mem_40:10:50000:44': 61.2,
  'mem_40:10:50000:45': 61.2,
  'mem_40:10:50000:46': 92.4,
  'mem_40:10:50000:47': 92.4,
  'mem_40:10:50000:48': 92.4,
  'mem_40:10:50000:49': 92.4,
  'mem_40:10:50000:50': 92.4,
  'mem_40:10:50000:51': 139.2,
  'mem_40:10:50000:52': 139.2,
  'mem_40:10:50000:53': 139.2,
  'mem_40:10:50000:54': 139.2,
  'mem_40:10:50000:55': 139.2,
  'mem_40:10:50000:56': 150,
  'mem_40:10:50000:57': 150,
  'mem_40:10:50000:58': 150,
  'mem_40:10:50000:59': 150,
  'mem_40:10:50000:60': 150,
  'mem_40:10:50000:61': 162,
  'mem_40:10:50000:62': 162,
  'mem_40:10:50000:63': 162,
  'mem_40:10:50000:64': 162,
  'mem_40:10:50000:65': 162,
  'mem_40:10:50000:66': 230.4,
  'mem_40:10:50000:67': 230.4,
  'mem_40:10:50000:68': 230.4,
  'mem_40:10:50000:69': 230.4,
  'mem_40:10:50000:70': 230.4,
  'mem_40:10:50000:71': 309.6,
  'mem_40:10:50000:72': 309.6,
  'mem_40:10:50000:73': 309.6,
  'mem_40:10:50000:74': 309.6,
  'mem_40:10:50000:75': 309.6,
  'mem_40:10:50000:76': 409.2,
  'mem_40:10:50000:77': 409.2,
  'mem_40:10:50000:78': 409.2,
  'mem_40:10:50000:79': 409.2,
  'mem_40:10:50000:80': 409.2,
  'mem_40:10:50000:81': 565.27,
  'mem_40:10:50000:82': 565.27,
  'mem_40:10:50000:83': 565.27,
  'mem_40:10:50000:84': 565.27,
  'mem_40:10:50000:85': 565.27,
  'mem_40:10:50000:86': 756.32,
  'mem_40:10:50000:87': 756.32,
  'mem_40:10:50000:88': 756.32,
  'mem_40:10:50000:89': 756.32,
  'mem_40:10:50000:90': 756.32,
  'mem_40:10:50000:91': 1020.45,
  'mem_40:10:50000:92': 1020.45,
  'mem_40:10:50000:93': 1020.45,
  'mem_40:10:50000:94': 1020.45,
  'mem_40:10:50000:95': 1020.45,
  'mem_40:10:50000:96': 1656.07,
  'mem_40:10:50000:97': 1656.07,
  'mem_40:10:50000:98': 1656.07,
  'mem_40:10:50000:99': 1656.07,
  'mem_40:10:50000:100': 1656.07,
  'mem_40:10:50000:101': 2880.05,
  'mem_40:10:50000:102': 2880.05,
  'mem_40:10:50000:103': 2880.05,
  'mem_40:10:50000:104': 2880.05,
  'mem_40:10:50000:105': 2880.05,
  'mem_40:10:50000:106': 3624.94,
  'mem_40:10:50000:107': 3624.94,
  'mem_40:10:50000:108': 3624.94,
  'mem_40:10:50000:109': 3624.94,
  'mem_40:10:50000:110': 3624.94,
  'mem_40:10:50000:111': 3624.94,
  'mem_40:10:50000:112': 3624.94,
  'mem_40:10:50000:113': 3624.94,
  'mem_40:10:50000:114': 3624.94,
  'mem_40:10:50000:115': 3624.94,
  'mem_40:10:50000:116': 3624.94,
  'mem_40:10:50000:117': 3624.94,
  'mem_40:10:50000:118': 3624.94,
  'mem_40:10:50000:119': 3624.94,
  'mem_40:10:50000:120': 3624.94,
  'mem_40:10:60000:1': 14.21,
  'mem_40:10:60000:2': 14.21,
  'mem_40:10:60000:3': 14.21,
  'mem_40:10:60000:4': 14.21,
  'mem_40:10:60000:5': 14.21,
  'mem_40:10:60000:6': 14.17,
  'mem_40:10:60000:7': 14.17,
  'mem_40:10:60000:8': 14.17,
  'mem_40:10:60000:9': 14.17,
  'mem_40:10:60000:10': 14.17,
  'mem_40:10:60000:11': 14.19,
  'mem_40:10:60000:12': 14.19,
  'mem_40:10:60000:13': 14.19,
  'mem_40:10:60000:14': 14.19,
  'mem_40:10:60000:15': 14.19,
  'mem_40:10:60000:16': 14.9,
  'mem_40:10:60000:17': 14.9,
  'mem_40:10:60000:18': 14.9,
  'mem_40:10:60000:19': 14.9,
  'mem_40:10:60000:20': 14.9,
  'mem_40:10:60000:21': 15.89,
  'mem_40:10:60000:22': 15.89,
  'mem_40:10:60000:23': 15.89,
  'mem_40:10:60000:24': 15.89,
  'mem_40:10:60000:25': 15.89,
  'mem_40:10:60000:26': 18.66,
  'mem_40:10:60000:27': 18.66,
  'mem_40:10:60000:28': 18.66,
  'mem_40:10:60000:29': 18.66,
  'mem_40:10:60000:30': 18.66,
  'mem_40:10:60000:31': 24.5,
  'mem_40:10:60000:32': 24.5,
  'mem_40:10:60000:33': 24.5,
  'mem_40:10:60000:34': 24.5,
  'mem_40:10:60000:35': 24.5,
  'mem_40:10:60000:36': 35.26,
  'mem_40:10:60000:37': 35.26,
  'mem_40:10:60000:38': 35.26,
  'mem_40:10:60000:39': 35.26,
  'mem_40:10:60000:40': 35.26,
  'mem_40:10:60000:41': 55.41,
  'mem_40:10:60000:42': 55.41,
  'mem_40:10:60000:43': 55.41,
  'mem_40:10:60000:44': 55.41,
  'mem_40:10:60000:45': 55.41,
  'mem_40:10:60000:46': 84.06,
  'mem_40:10:60000:47': 84.06,
  'mem_40:10:60000:48': 84.06,
  'mem_40:10:60000:49': 84.06,
  'mem_40:10:60000:50': 84.06,
  'mem_40:10:60000:51': 126.27,
  'mem_40:10:60000:52': 126.27,
  'mem_40:10:60000:53': 126.27,
  'mem_40:10:60000:54': 126.27,
  'mem_40:10:60000:55': 126.27,
  'mem_40:10:60000:56': 154.7,
  'mem_40:10:60000:57': 154.7,
  'mem_40:10:60000:58': 154.7,
  'mem_40:10:60000:59': 154.7,
  'mem_40:10:60000:60': 154.7,
  'mem_40:10:60000:61': 191.48,
  'mem_40:10:60000:62': 191.48,
  'mem_40:10:60000:63': 191.48,
  'mem_40:10:60000:64': 191.48,
  'mem_40:10:60000:65': 191.48,
  'mem_40:10:60000:66': 274.1,
  'mem_40:10:60000:67': 274.1,
  'mem_40:10:60000:68': 274.1,
  'mem_40:10:60000:69': 274.1,
  'mem_40:10:60000:70': 274.1,
  'mem_40:10:60000:71': 355.02,
  'mem_40:10:60000:72': 355.02,
  'mem_40:10:60000:73': 355.02,
  'mem_40:10:60000:74': 355.02,
  'mem_40:10:60000:75': 355.02,
  'mem_40:10:60000:76': 482.9,
  'mem_40:10:60000:77': 482.9,
  'mem_40:10:60000:78': 482.9,
  'mem_40:10:60000:79': 482.9,
  'mem_40:10:60000:80': 482.9,
  'mem_40:10:60000:81': 677.66,
  'mem_40:10:60000:82': 677.66,
  'mem_40:10:60000:83': 677.66,
  'mem_40:10:60000:84': 677.66,
  'mem_40:10:60000:85': 677.66,
  'mem_40:10:60000:86': 906.73,
  'mem_40:10:60000:87': 906.73,
  'mem_40:10:60000:88': 906.73,
  'mem_40:10:60000:89': 906.73,
  'mem_40:10:60000:90': 906.73,
  'mem_40:10:60000:91': 1223.43,
  'mem_40:10:60000:92': 1223.43,
  'mem_40:10:60000:93': 1223.43,
  'mem_40:10:60000:94': 1223.43,
  'mem_40:10:60000:95': 1223.43,
  'mem_40:10:60000:96': 1985.55,
  'mem_40:10:60000:97': 1985.55,
  'mem_40:10:60000:98': 1985.55,
  'mem_40:10:60000:99': 1985.55,
  'mem_40:10:60000:100': 1985.55,
  'mem_40:10:60000:101': 3458.15,
  'mem_40:10:60000:102': 3458.15,
  'mem_40:10:60000:103': 3458.15,
  'mem_40:10:60000:104': 3458.15,
  'mem_40:10:60000:105': 3458.15,
  'mem_40:10:60000:106': 4356.31,
  'mem_40:10:60000:107': 4356.31,
  'mem_40:10:60000:108': 4356.31,
  'mem_40:10:60000:109': 4356.31,
  'mem_40:10:60000:110': 4356.31,
  'mem_40:10:60000:111': 4356.31,
  'mem_40:10:60000:112': 4356.31,
  'mem_40:10:60000:113': 4356.31,
  'mem_40:10:60000:114': 4356.31,
  'mem_40:10:60000:115': 4356.31,
  'mem_40:10:60000:116': 4356.31,
  'mem_40:10:60000:117': 4356.31,
  'mem_40:10:60000:118': 4356.31,
  'mem_40:10:60000:119': 4356.31,
  'mem_40:10:60000:120': 4356.31,
  'mem_40:10:70000:1': 15.21,
  'mem_40:10:70000:2': 15.21,
  'mem_40:10:70000:3': 15.21,
  'mem_40:10:70000:4': 15.21,
  'mem_40:10:70000:5': 15.21,
  'mem_40:10:70000:6': 15.15,
  'mem_40:10:70000:7': 15.15,
  'mem_40:10:70000:8': 15.15,
  'mem_40:10:70000:9': 15.15,
  'mem_40:10:70000:10': 15.15,
  'mem_40:10:70000:11': 15.18,
  'mem_40:10:70000:12': 15.18,
  'mem_40:10:70000:13': 15.18,
  'mem_40:10:70000:14': 15.18,
  'mem_40:10:70000:15': 15.18,
  'mem_40:10:70000:16': 15.41,
  'mem_40:10:70000:17': 15.41,
  'mem_40:10:70000:18': 15.41,
  'mem_40:10:70000:19': 15.41,
  'mem_40:10:70000:20': 15.41,
  'mem_40:10:70000:21': 16.18,
  'mem_40:10:70000:22': 16.18,
  'mem_40:10:70000:23': 16.18,
  'mem_40:10:70000:24': 16.18,
  'mem_40:10:70000:25': 16.18,
  'mem_40:10:70000:26': 18.13,
  'mem_40:10:70000:27': 18.13,
  'mem_40:10:70000:28': 18.13,
  'mem_40:10:70000:29': 18.13,
  'mem_40:10:70000:30': 18.13,
  'mem_40:10:70000:31': 22.6,
  'mem_40:10:70000:32': 22.6,
  'mem_40:10:70000:33': 22.6,
  'mem_40:10:70000:34': 22.6,
  'mem_40:10:70000:35': 22.6,
  'mem_40:10:70000:36': 32.11,
  'mem_40:10:70000:37': 32.11,
  'mem_40:10:70000:38': 32.11,
  'mem_40:10:70000:39': 32.11,
  'mem_40:10:70000:40': 32.11,
  'mem_40:10:70000:41': 49.62,
  'mem_40:10:70000:42': 49.62,
  'mem_40:10:70000:43': 49.62,
  'mem_40:10:70000:44': 49.62,
  'mem_40:10:70000:45': 49.62,
  'mem_40:10:70000:46': 75.71,
  'mem_40:10:70000:47': 75.71,
  'mem_40:10:70000:48': 75.71,
  'mem_40:10:70000:49': 75.71,
  'mem_40:10:70000:50': 75.71,
  'mem_40:10:70000:51': 113.33,
  'mem_40:10:70000:52': 113.33,
  'mem_40:10:70000:53': 113.33,
  'mem_40:10:70000:54': 113.33,
  'mem_40:10:70000:55': 113.33,
  'mem_40:10:70000:56': 159.41,
  'mem_40:10:70000:57': 159.41,
  'mem_40:10:70000:58': 159.41,
  'mem_40:10:70000:59': 159.41,
  'mem_40:10:70000:60': 159.41,
  'mem_40:10:70000:61': 223.54,
  'mem_40:10:70000:62': 223.54,
  'mem_40:10:70000:63': 223.54,
  'mem_40:10:70000:64': 223.54,
  'mem_40:10:70000:65': 223.54,
  'mem_40:10:70000:66': 320,
  'mem_40:10:70000:67': 320,
  'mem_40:10:70000:68': 320,
  'mem_40:10:70000:69': 320,
  'mem_40:10:70000:70': 320,
  'mem_40:10:70000:71': 414.46,
  'mem_40:10:70000:72': 414.46,
  'mem_40:10:70000:73': 414.46,
  'mem_40:10:70000:74': 414.46,
  'mem_40:10:70000:75': 414.46,
  'mem_40:10:70000:76': 563.74,
  'mem_40:10:70000:77': 563.74,
  'mem_40:10:70000:78': 563.74,
  'mem_40:10:70000:79': 563.74,
  'mem_40:10:70000:80': 563.74,
  'mem_40:10:70000:81': 791.12,
  'mem_40:10:70000:82': 791.12,
  'mem_40:10:70000:83': 791.12,
  'mem_40:10:70000:84': 791.12,
  'mem_40:10:70000:85': 791.12,
  'mem_40:10:70000:86': 1058.51,
  'mem_40:10:70000:87': 1058.51,
  'mem_40:10:70000:88': 1058.51,
  'mem_40:10:70000:89': 1058.51,
  'mem_40:10:70000:90': 1058.51,
  'mem_40:10:70000:91': 1428.2,
  'mem_40:10:70000:92': 1428.2,
  'mem_40:10:70000:93': 1428.2,
  'mem_40:10:70000:94': 1428.2,
  'mem_40:10:70000:95': 1428.2,
  'mem_40:10:70000:96': 2317.84,
  'mem_40:10:70000:97': 2317.84,
  'mem_40:10:70000:98': 2317.84,
  'mem_40:10:70000:99': 2317.84,
  'mem_40:10:70000:100': 2317.84,
  'mem_40:10:70000:101': 4036.97,
  'mem_40:10:70000:102': 4036.97,
  'mem_40:10:70000:103': 4036.97,
  'mem_40:10:70000:104': 4036.97,
  'mem_40:10:70000:105': 4036.97,
  'mem_40:10:70000:106': 5085.55,
  'mem_40:10:70000:107': 5085.55,
  'mem_40:10:70000:108': 5085.55,
  'mem_40:10:70000:109': 5085.55,
  'mem_40:10:70000:110': 5085.55,
  'mem_40:10:70000:111': 5085.55,
  'mem_40:10:70000:112': 5085.55,
  'mem_40:10:70000:113': 5085.55,
  'mem_40:10:70000:114': 5085.55,
  'mem_40:10:70000:115': 5085.55,
  'mem_40:10:70000:116': 5085.55,
  'mem_40:10:70000:117': 5085.55,
  'mem_40:10:70000:118': 5085.55,
  'mem_40:10:70000:119': 5085.55,
  'mem_40:10:70000:120': 5085.55,
  'mem_40:10:80000:1': 17.39,
  'mem_40:10:80000:2': 17.39,
  'mem_40:10:80000:3': 17.39,
  'mem_40:10:80000:4': 17.39,
  'mem_40:10:80000:5': 17.39,
  'mem_40:10:80000:6': 17.31,
  'mem_40:10:80000:7': 17.31,
  'mem_40:10:80000:8': 17.31,
  'mem_40:10:80000:9': 17.31,
  'mem_40:10:80000:10': 17.31,
  'mem_40:10:80000:11': 17.35,
  'mem_40:10:80000:12': 17.35,
  'mem_40:10:80000:13': 17.35,
  'mem_40:10:80000:14': 17.35,
  'mem_40:10:80000:15': 17.35,
  'mem_40:10:80000:16': 17.61,
  'mem_40:10:80000:17': 17.61,
  'mem_40:10:80000:18': 17.61,
  'mem_40:10:80000:19': 17.61,
  'mem_40:10:80000:20': 17.61,
  'mem_40:10:80000:21': 18.5,
  'mem_40:10:80000:22': 18.5,
  'mem_40:10:80000:23': 18.5,
  'mem_40:10:80000:24': 18.5,
  'mem_40:10:80000:25': 18.5,
  'mem_40:10:80000:26': 20.72,
  'mem_40:10:80000:27': 20.72,
  'mem_40:10:80000:28': 20.72,
  'mem_40:10:80000:29': 20.72,
  'mem_40:10:80000:30': 20.72,
  'mem_40:10:80000:31': 25.84,
  'mem_40:10:80000:32': 25.84,
  'mem_40:10:80000:33': 25.84,
  'mem_40:10:80000:34': 25.84,
  'mem_40:10:80000:35': 25.84,
  'mem_40:10:80000:36': 36.72,
  'mem_40:10:80000:37': 36.72,
  'mem_40:10:80000:38': 36.72,
  'mem_40:10:80000:39': 36.72,
  'mem_40:10:80000:40': 36.72,
  'mem_40:10:80000:41': 56.73,
  'mem_40:10:80000:42': 56.73,
  'mem_40:10:80000:43': 56.73,
  'mem_40:10:80000:44': 56.73,
  'mem_40:10:80000:45': 56.73,
  'mem_40:10:80000:46': 86.55,
  'mem_40:10:80000:47': 86.55,
  'mem_40:10:80000:48': 86.55,
  'mem_40:10:80000:49': 86.55,
  'mem_40:10:80000:50': 86.55,
  'mem_40:10:80000:51': 129.56,
  'mem_40:10:80000:52': 129.56,
  'mem_40:10:80000:53': 129.56,
  'mem_40:10:80000:54': 129.56,
  'mem_40:10:80000:55': 129.56,
  'mem_40:10:80000:56': 182.23,
  'mem_40:10:80000:57': 182.23,
  'mem_40:10:80000:58': 182.23,
  'mem_40:10:80000:59': 182.23,
  'mem_40:10:80000:60': 182.23,
  'mem_40:10:80000:61': 255.55,
  'mem_40:10:80000:62': 255.55,
  'mem_40:10:80000:63': 255.55,
  'mem_40:10:80000:64': 255.55,
  'mem_40:10:80000:65': 255.55,
  'mem_40:10:80000:66': 365.81,
  'mem_40:10:80000:67': 365.81,
  'mem_40:10:80000:68': 365.81,
  'mem_40:10:80000:69': 365.81,
  'mem_40:10:80000:70': 365.81,
  'mem_40:10:80000:71': 473.79,
  'mem_40:10:80000:72': 473.79,
  'mem_40:10:80000:73': 473.79,
  'mem_40:10:80000:74': 473.79,
  'mem_40:10:80000:75': 473.79,
  'mem_40:10:80000:76': 644.46,
  'mem_40:10:80000:77': 644.46,
  'mem_40:10:80000:78': 644.46,
  'mem_40:10:80000:79': 644.46,
  'mem_40:10:80000:80': 644.46,
  'mem_40:10:80000:81': 904.39,
  'mem_40:10:80000:82': 904.39,
  'mem_40:10:80000:83': 904.39,
  'mem_40:10:80000:84': 904.39,
  'mem_40:10:80000:85': 904.39,
  'mem_40:10:80000:86': 1210.05,
  'mem_40:10:80000:87': 1210.05,
  'mem_40:10:80000:88': 1210.05,
  'mem_40:10:80000:89': 1210.05,
  'mem_40:10:80000:90': 1210.05,
  'mem_40:10:80000:91': 1632.64,
  'mem_40:10:80000:92': 1632.64,
  'mem_40:10:80000:93': 1632.64,
  'mem_40:10:80000:94': 1632.64,
  'mem_40:10:80000:95': 1632.64,
  'mem_40:10:80000:96': 2649.59,
  'mem_40:10:80000:97': 2649.59,
  'mem_40:10:80000:98': 2649.59,
  'mem_40:10:80000:99': 2649.59,
  'mem_40:10:80000:100': 2649.59,
  'mem_40:10:80000:101': 4614.75,
  'mem_40:10:80000:102': 4614.75,
  'mem_40:10:80000:103': 4614.75,
  'mem_40:10:80000:104': 4614.75,
  'mem_40:10:80000:105': 4614.75,
  'mem_40:10:80000:106': 5813.41,
  'mem_40:10:80000:107': 5813.41,
  'mem_40:10:80000:108': 5813.41,
  'mem_40:10:80000:109': 5813.41,
  'mem_40:10:80000:110': 5813.41,
  'mem_40:10:80000:111': 5813.41,
  'mem_40:10:80000:112': 5813.41,
  'mem_40:10:80000:113': 5813.41,
  'mem_40:10:80000:114': 5813.41,
  'mem_40:10:80000:115': 5813.41,
  'mem_40:10:80000:116': 5813.41,
  'mem_40:10:80000:117': 5813.41,
  'mem_40:10:80000:118': 5813.41,
  'mem_40:10:80000:119': 5813.41,
  'mem_40:10:80000:120': 5813.41,
  'mem_40:10:90000:1': 19.54,
  'mem_40:10:90000:2': 19.54,
  'mem_40:10:90000:3': 19.54,
  'mem_40:10:90000:4': 19.54,
  'mem_40:10:90000:5': 19.54,
  'mem_40:10:90000:6': 19.45,
  'mem_40:10:90000:7': 19.45,
  'mem_40:10:90000:8': 19.45,
  'mem_40:10:90000:9': 19.45,
  'mem_40:10:90000:10': 19.45,
  'mem_40:10:90000:11': 19.49,
  'mem_40:10:90000:12': 19.49,
  'mem_40:10:90000:13': 19.49,
  'mem_40:10:90000:14': 19.49,
  'mem_40:10:90000:15': 19.49,
  'mem_40:10:90000:16': 19.79,
  'mem_40:10:90000:17': 19.79,
  'mem_40:10:90000:18': 19.79,
  'mem_40:10:90000:19': 19.79,
  'mem_40:10:90000:20': 19.79,
  'mem_40:10:90000:21': 20.78,
  'mem_40:10:90000:22': 20.78,
  'mem_40:10:90000:23': 20.78,
  'mem_40:10:90000:24': 20.78,
  'mem_40:10:90000:25': 20.78,
  'mem_40:10:90000:26': 23.28,
  'mem_40:10:90000:27': 23.28,
  'mem_40:10:90000:28': 23.28,
  'mem_40:10:90000:29': 23.28,
  'mem_40:10:90000:30': 23.28,
  'mem_40:10:90000:31': 29.06,
  'mem_40:10:90000:32': 29.06,
  'mem_40:10:90000:33': 29.06,
  'mem_40:10:90000:34': 29.06,
  'mem_40:10:90000:35': 29.06,
  'mem_40:10:90000:36': 41.31,
  'mem_40:10:90000:37': 41.31,
  'mem_40:10:90000:38': 41.31,
  'mem_40:10:90000:39': 41.31,
  'mem_40:10:90000:40': 41.31,
  'mem_40:10:90000:41': 63.77,
  'mem_40:10:90000:42': 63.77,
  'mem_40:10:90000:43': 63.77,
  'mem_40:10:90000:44': 63.77,
  'mem_40:10:90000:45': 63.77,
  'mem_40:10:90000:46': 97.24,
  'mem_40:10:90000:47': 97.24,
  'mem_40:10:90000:48': 97.24,
  'mem_40:10:90000:49': 97.24,
  'mem_40:10:90000:50': 97.24,
  'mem_40:10:90000:51': 145.56,
  'mem_40:10:90000:52': 145.56,
  'mem_40:10:90000:53': 145.56,
  'mem_40:10:90000:54': 145.56,
  'mem_40:10:90000:55': 145.56,
  'mem_40:10:90000:56': 204.73,
  'mem_40:10:90000:57': 204.73,
  'mem_40:10:90000:58': 204.73,
  'mem_40:10:90000:59': 204.73,
  'mem_40:10:90000:60': 204.73,
  'mem_40:10:90000:61': 287.1,
  'mem_40:10:90000:62': 287.1,
  'mem_40:10:90000:63': 287.1,
  'mem_40:10:90000:64': 287.1,
  'mem_40:10:90000:65': 287.1,
  'mem_40:10:90000:66': 410.98,
  'mem_40:10:90000:67': 410.98,
  'mem_40:10:90000:68': 410.98,
  'mem_40:10:90000:69': 410.98,
  'mem_40:10:90000:70': 410.98,
  'mem_40:10:90000:71': 532.3,
  'mem_40:10:90000:72': 532.3,
  'mem_40:10:90000:73': 532.3,
  'mem_40:10:90000:74': 532.3,
  'mem_40:10:90000:75': 532.3,
  'mem_40:10:90000:76': 724.02,
  'mem_40:10:90000:77': 724.02,
  'mem_40:10:90000:78': 724.02,
  'mem_40:10:90000:79': 724.02,
  'mem_40:10:90000:80': 724.02,
  'mem_40:10:90000:81': 1016.03,
  'mem_40:10:90000:82': 1016.03,
  'mem_40:10:90000:83': 1016.03,
  'mem_40:10:90000:84': 1016.03,
  'mem_40:10:90000:85': 1016.03,
  'mem_40:10:90000:86': 1359.46,
  'mem_40:10:90000:87': 1359.46,
  'mem_40:10:90000:88': 1359.46,
  'mem_40:10:90000:89': 1359.46,
  'mem_40:10:90000:90': 1359.46,
  'mem_40:10:90000:91': 1834.28,
  'mem_40:10:90000:92': 1834.28,
  'mem_40:10:90000:93': 1834.28,
  'mem_40:10:90000:94': 1834.28,
  'mem_40:10:90000:95': 1834.28,
  'mem_40:10:90000:96': 2976.92,
  'mem_40:10:90000:97': 2976.92,
  'mem_40:10:90000:98': 2976.92,
  'mem_40:10:90000:99': 2976.92,
  'mem_40:10:90000:100': 2976.92,
  'mem_40:10:90000:101': 5184.95,
  'mem_40:10:90000:102': 5184.95,
  'mem_40:10:90000:103': 5184.95,
  'mem_40:10:90000:104': 5184.95,
  'mem_40:10:90000:105': 5184.95,
  'mem_40:10:90000:106': 6531.74,
  'mem_40:10:90000:107': 6531.74,
  'mem_40:10:90000:108': 6531.74,
  'mem_40:10:90000:109': 6531.74,
  'mem_40:10:90000:110': 6531.74,
  'mem_40:10:90000:111': 6531.74,
  'mem_40:10:90000:112': 6531.74,
  'mem_40:10:90000:113': 6531.74,
  'mem_40:10:90000:114': 6531.74,
  'mem_40:10:90000:115': 6531.74,
  'mem_40:10:90000:116': 6531.74,
  'mem_40:10:90000:117': 6531.74,
  'mem_40:10:90000:118': 6531.74,
  'mem_40:10:90000:119': 6531.74,
  'mem_40:10:90000:120': 6531.74,
  'mem_40:10:100000:1': 21.72,
  'mem_40:10:100000:2': 21.72,
  'mem_40:10:100000:3': 21.72,
  'mem_40:10:100000:4': 21.72,
  'mem_40:10:100000:5': 21.72,
  'mem_40:10:100000:6': 21.62,
  'mem_40:10:100000:7': 21.62,
  'mem_40:10:100000:8': 21.62,
  'mem_40:10:100000:9': 21.62,
  'mem_40:10:100000:10': 21.62,
  'mem_40:10:100000:11': 21.67,
  'mem_40:10:100000:12': 21.67,
  'mem_40:10:100000:13': 21.67,
  'mem_40:10:100000:14': 21.67,
  'mem_40:10:100000:15': 21.67,
  'mem_40:10:100000:16': 22,
  'mem_40:10:100000:17': 22,
  'mem_40:10:100000:18': 22,
  'mem_40:10:100000:19': 22,
  'mem_40:10:100000:20': 22,
  'mem_40:10:100000:21': 23.1,
  'mem_40:10:100000:22': 23.1,
  'mem_40:10:100000:23': 23.1,
  'mem_40:10:100000:24': 23.1,
  'mem_40:10:100000:25': 23.1,
  'mem_40:10:100000:26': 25.88,
  'mem_40:10:100000:27': 25.88,
  'mem_40:10:100000:28': 25.88,
  'mem_40:10:100000:29': 25.88,
  'mem_40:10:100000:30': 25.88,
  'mem_40:10:100000:31': 32.29,
  'mem_40:10:100000:32': 32.29,
  'mem_40:10:100000:33': 32.29,
  'mem_40:10:100000:34': 32.29,
  'mem_40:10:100000:35': 32.29,
  'mem_40:10:100000:36': 45.91,
  'mem_40:10:100000:37': 45.91,
  'mem_40:10:100000:38': 45.91,
  'mem_40:10:100000:39': 45.91,
  'mem_40:10:100000:40': 45.91,
  'mem_40:10:100000:41': 70.89,
  'mem_40:10:100000:42': 70.89,
  'mem_40:10:100000:43': 70.89,
  'mem_40:10:100000:44': 70.89,
  'mem_40:10:100000:45': 70.89,
  'mem_40:10:100000:46': 108.1,
  'mem_40:10:100000:47': 108.1,
  'mem_40:10:100000:48': 108.1,
  'mem_40:10:100000:49': 108.1,
  'mem_40:10:100000:50': 108.1,
  'mem_40:10:100000:51': 161.81,
  'mem_40:10:100000:52': 161.81,
  'mem_40:10:100000:53': 161.81,
  'mem_40:10:100000:54': 161.81,
  'mem_40:10:100000:55': 161.81,
  'mem_40:10:100000:56': 227.59,
  'mem_40:10:100000:57': 227.59,
  'mem_40:10:100000:58': 227.59,
  'mem_40:10:100000:59': 227.59,
  'mem_40:10:100000:60': 227.59,
  'mem_40:10:100000:61': 319.15,
  'mem_40:10:100000:62': 319.15,
  'mem_40:10:100000:63': 319.15,
  'mem_40:10:100000:64': 319.15,
  'mem_40:10:100000:65': 319.15,
  'mem_40:10:100000:66': 456.84,
  'mem_40:10:100000:67': 456.84,
  'mem_40:10:100000:68': 456.84,
  'mem_40:10:100000:69': 456.84,
  'mem_40:10:100000:70': 456.84,
  'mem_40:10:100000:71': 591.71,
  'mem_40:10:100000:72': 591.71,
  'mem_40:10:100000:73': 591.71,
  'mem_40:10:100000:74': 591.71,
  'mem_40:10:100000:75': 591.71,
  'mem_40:10:100000:76': 804.86,
  'mem_40:10:100000:77': 804.86,
  'mem_40:10:100000:78': 804.86,
  'mem_40:10:100000:79': 804.86,
  'mem_40:10:100000:80': 804.86,
  'mem_40:10:100000:81': 1129.46,
  'mem_40:10:100000:82': 1129.46,
  'mem_40:10:100000:83': 1129.46,
  'mem_40:10:100000:84': 1129.46,
  'mem_40:10:100000:85': 1129.46,
  'mem_40:10:100000:86': 1511.26,
  'mem_40:10:100000:87': 1511.26,
  'mem_40:10:100000:88': 1511.26,
  'mem_40:10:100000:89': 1511.26,
  'mem_40:10:100000:90': 1511.26,
  'mem_40:10:100000:91': 2039.11,
  'mem_40:10:100000:92': 2039.11,
  'mem_40:10:100000:93': 2039.11,
  'mem_40:10:100000:94': 2039.11,
  'mem_40:10:100000:95': 2039.11,
  'mem_40:10:100000:96': 3309.34,
  'mem_40:10:100000:97': 3309.34,
  'mem_40:10:100000:98': 3309.34,
  'mem_40:10:100000:99': 3309.34,
  'mem_40:10:100000:100': 3309.34,
  'mem_40:10:100000:101': 5763.98,
  'mem_40:10:100000:102': 5763.98,
  'mem_40:10:100000:103': 5763.98,
  'mem_40:10:100000:104': 5763.98,
  'mem_40:10:100000:105': 5763.98,
  'mem_40:10:100000:106': 7261.22,
  'mem_40:10:100000:107': 7261.22,
  'mem_40:10:100000:108': 7261.22,
  'mem_40:10:100000:109': 7261.22,
  'mem_40:10:100000:110': 7261.22,
  'mem_40:10:100000:111': 7261.22,
  'mem_40:10:100000:112': 7261.22,
  'mem_40:10:100000:113': 7261.22,
  'mem_40:10:100000:114': 7261.22,
  'mem_40:10:100000:115': 7261.22,
  'mem_40:10:100000:116': 7261.22,
  'mem_40:10:100000:117': 7261.22,
  'mem_40:10:100000:118': 7261.22,
  'mem_40:10:100000:119': 7261.22,
  'mem_40:10:100000:120': 7261.22,
  'mem_40:10:120000:1': 26.07,
  'mem_40:10:120000:2': 26.07,
  'mem_40:10:120000:3': 26.07,
  'mem_40:10:120000:4': 26.07,
  'mem_40:10:120000:5': 26.07,
  'mem_40:10:120000:6': 25.95,
  'mem_40:10:120000:7': 25.95,
  'mem_40:10:120000:8': 25.95,
  'mem_40:10:120000:9': 25.95,
  'mem_40:10:120000:10': 25.95,
  'mem_40:10:120000:11': 26,
  'mem_40:10:120000:12': 26,
  'mem_40:10:120000:13': 26,
  'mem_40:10:120000:14': 26,
  'mem_40:10:120000:15': 26,
  'mem_40:10:120000:16': 26.39,
  'mem_40:10:120000:17': 26.39,
  'mem_40:10:120000:18': 26.39,
  'mem_40:10:120000:19': 26.39,
  'mem_40:10:120000:20': 26.39,
  'mem_40:10:120000:21': 27.72,
  'mem_40:10:120000:22': 27.72,
  'mem_40:10:120000:23': 27.72,
  'mem_40:10:120000:24': 27.72,
  'mem_40:10:120000:25': 27.72,
  'mem_40:10:120000:26': 31.06,
  'mem_40:10:120000:27': 31.06,
  'mem_40:10:120000:28': 31.06,
  'mem_40:10:120000:29': 31.06,
  'mem_40:10:120000:30': 31.06,
  'mem_40:10:120000:31': 38.75,
  'mem_40:10:120000:32': 38.75,
  'mem_40:10:120000:33': 38.75,
  'mem_40:10:120000:34': 38.75,
  'mem_40:10:120000:35': 38.75,
  'mem_40:10:120000:36': 55.09,
  'mem_40:10:120000:37': 55.09,
  'mem_40:10:120000:38': 55.09,
  'mem_40:10:120000:39': 55.09,
  'mem_40:10:120000:40': 55.09,
  'mem_40:10:120000:41': 85.06,
  'mem_40:10:120000:42': 85.06,
  'mem_40:10:120000:43': 85.06,
  'mem_40:10:120000:44': 85.06,
  'mem_40:10:120000:45': 85.06,
  'mem_40:10:120000:46': 129.71,
  'mem_40:10:120000:47': 129.71,
  'mem_40:10:120000:48': 129.71,
  'mem_40:10:120000:49': 129.71,
  'mem_40:10:120000:50': 129.71,
  'mem_40:10:120000:51': 194.15,
  'mem_40:10:120000:52': 194.15,
  'mem_40:10:120000:53': 194.15,
  'mem_40:10:120000:54': 194.15,
  'mem_40:10:120000:55': 194.15,
  'mem_40:10:120000:56': 273.08,
  'mem_40:10:120000:57': 273.08,
  'mem_40:10:120000:58': 273.08,
  'mem_40:10:120000:59': 273.08,
  'mem_40:10:120000:60': 273.08,
  'mem_40:10:120000:61': 382.95,
  'mem_40:10:120000:62': 382.95,
  'mem_40:10:120000:63': 382.95,
  'mem_40:10:120000:64': 382.95,
  'mem_40:10:120000:65': 382.95,
  'mem_40:10:120000:66': 548.18,
  'mem_40:10:120000:67': 548.18,
  'mem_40:10:120000:68': 548.18,
  'mem_40:10:120000:69': 548.18,
  'mem_40:10:120000:70': 548.18,
  'mem_40:10:120000:71': 710.02,
  'mem_40:10:120000:72': 710.02,
  'mem_40:10:120000:73': 710.02,
  'mem_40:10:120000:74': 710.02,
  'mem_40:10:120000:75': 710.02,
  'mem_40:10:120000:76': 965.78,
  'mem_40:10:120000:77': 965.78,
  'mem_40:10:120000:78': 965.78,
  'mem_40:10:120000:79': 965.78,
  'mem_40:10:120000:80': 965.78,
  'mem_40:10:120000:81': 1355.28,
  'mem_40:10:120000:82': 1355.28,
  'mem_40:10:120000:83': 1355.28,
  'mem_40:10:120000:84': 1355.28,
  'mem_40:10:120000:85': 1355.28,
  'mem_40:10:120000:86': 1813.4,
  'mem_40:10:120000:87': 1813.4,
  'mem_40:10:120000:88': 1813.4,
  'mem_40:10:120000:89': 1813.4,
  'mem_40:10:120000:90': 1813.4,
  'mem_40:10:120000:91': 2446.79,
  'mem_40:10:120000:92': 2446.79,
  'mem_40:10:120000:93': 2446.79,
  'mem_40:10:120000:94': 2446.79,
  'mem_40:10:120000:95': 2446.79,
  'mem_40:10:120000:96': 3971.01,
  'mem_40:10:120000:97': 3971.01,
  'mem_40:10:120000:98': 3971.01,
  'mem_40:10:120000:99': 3971.01,
  'mem_40:10:120000:100': 3971.01,
  'mem_40:10:120000:101': 6916.43,
  'mem_40:10:120000:102': 6916.43,
  'mem_40:10:120000:103': 6916.43,
  'mem_40:10:120000:104': 6916.43,
  'mem_40:10:120000:105': 6916.43,
  'mem_40:10:120000:106': 8713,
  'mem_40:10:120000:107': 8713,
  'mem_40:10:120000:108': 8713,
  'mem_40:10:120000:109': 8713,
  'mem_40:10:120000:110': 8713,
  'mem_40:10:120000:111': 8713,
  'mem_40:10:120000:112': 8713,
  'mem_40:10:120000:113': 8713,
  'mem_40:10:120000:114': 8713,
  'mem_40:10:120000:115': 8713,
  'mem_40:10:120000:116': 8713,
  'mem_40:10:120000:117': 8713,
  'mem_40:10:120000:118': 8713,
  'mem_40:10:120000:119': 8713,
  'mem_40:10:120000:120': 8713,
  'mem_40:10:140000:1': 30.43,
  'mem_40:10:140000:2': 30.43,
  'mem_40:10:140000:3': 30.43,
  'mem_40:10:140000:4': 30.43,
  'mem_40:10:140000:5': 30.43,
  'mem_40:10:140000:6': 30.29,
  'mem_40:10:140000:7': 30.29,
  'mem_40:10:140000:8': 30.29,
  'mem_40:10:140000:9': 30.29,
  'mem_40:10:140000:10': 30.29,
  'mem_40:10:140000:11': 30.35,
  'mem_40:10:140000:12': 30.35,
  'mem_40:10:140000:13': 30.35,
  'mem_40:10:140000:14': 30.35,
  'mem_40:10:140000:15': 30.35,
  'mem_40:10:140000:16': 30.81,
  'mem_40:10:140000:17': 30.81,
  'mem_40:10:140000:18': 30.81,
  'mem_40:10:140000:19': 30.81,
  'mem_40:10:140000:20': 30.81,
  'mem_40:10:140000:21': 32.36,
  'mem_40:10:140000:22': 32.36,
  'mem_40:10:140000:23': 32.36,
  'mem_40:10:140000:24': 32.36,
  'mem_40:10:140000:25': 32.36,
  'mem_40:10:140000:26': 36.26,
  'mem_40:10:140000:27': 36.26,
  'mem_40:10:140000:28': 36.26,
  'mem_40:10:140000:29': 36.26,
  'mem_40:10:140000:30': 36.26,
  'mem_40:10:140000:31': 45.2,
  'mem_40:10:140000:32': 45.2,
  'mem_40:10:140000:33': 45.2,
  'mem_40:10:140000:34': 45.2,
  'mem_40:10:140000:35': 45.2,
  'mem_40:10:140000:36': 64.22,
  'mem_40:10:140000:37': 64.22,
  'mem_40:10:140000:38': 64.22,
  'mem_40:10:140000:39': 64.22,
  'mem_40:10:140000:40': 64.22,
  'mem_40:10:140000:41': 99.25,
  'mem_40:10:140000:42': 99.25,
  'mem_40:10:140000:43': 99.25,
  'mem_40:10:140000:44': 99.25,
  'mem_40:10:140000:45': 99.25,
  'mem_40:10:140000:46': 151.43,
  'mem_40:10:140000:47': 151.43,
  'mem_40:10:140000:48': 151.43,
  'mem_40:10:140000:49': 151.43,
  'mem_40:10:140000:50': 151.43,
  'mem_40:10:140000:51': 226.67,
  'mem_40:10:140000:52': 226.67,
  'mem_40:10:140000:53': 226.67,
  'mem_40:10:140000:54': 226.67,
  'mem_40:10:140000:55': 226.67,
  'mem_40:10:140000:56': 318.81,
  'mem_40:10:140000:57': 318.81,
  'mem_40:10:140000:58': 318.81,
  'mem_40:10:140000:59': 318.81,
  'mem_40:10:140000:60': 318.81,
  'mem_40:10:140000:61': 447.09,
  'mem_40:10:140000:62': 447.09,
  'mem_40:10:140000:63': 447.09,
  'mem_40:10:140000:64': 447.09,
  'mem_40:10:140000:65': 447.09,
  'mem_40:10:140000:66': 640,
  'mem_40:10:140000:67': 640,
  'mem_40:10:140000:68': 640,
  'mem_40:10:140000:69': 640,
  'mem_40:10:140000:70': 640,
  'mem_40:10:140000:71': 828.92,
  'mem_40:10:140000:72': 828.92,
  'mem_40:10:140000:73': 828.92,
  'mem_40:10:140000:74': 828.92,
  'mem_40:10:140000:75': 828.92,
  'mem_40:10:140000:76': 1127.49,
  'mem_40:10:140000:77': 1127.49,
  'mem_40:10:140000:78': 1127.49,
  'mem_40:10:140000:79': 1127.49,
  'mem_40:10:140000:80': 1127.49,
  'mem_40:10:140000:81': 1582.23,
  'mem_40:10:140000:82': 1582.23,
  'mem_40:10:140000:83': 1582.23,
  'mem_40:10:140000:84': 1582.23,
  'mem_40:10:140000:85': 1582.23,
  'mem_40:10:140000:86': 2117.03,
  'mem_40:10:140000:87': 2117.03,
  'mem_40:10:140000:88': 2117.03,
  'mem_40:10:140000:89': 2117.03,
  'mem_40:10:140000:90': 2117.03,
  'mem_40:10:140000:91': 2856.4,
  'mem_40:10:140000:92': 2856.4,
  'mem_40:10:140000:93': 2856.4,
  'mem_40:10:140000:94': 2856.4,
  'mem_40:10:140000:95': 2856.4,
  'mem_40:10:140000:96': 4635.67,
  'mem_40:10:140000:97': 4635.67,
  'mem_40:10:140000:98': 4635.67,
  'mem_40:10:140000:99': 4635.67,
  'mem_40:10:140000:100': 4635.67,
  'mem_40:10:140000:101': 8073.93,
  'mem_40:10:140000:102': 8073.93,
  'mem_40:10:140000:103': 8073.93,
  'mem_40:10:140000:104': 8073.93,
  'mem_40:10:140000:105': 8073.93,
  'mem_40:10:140000:106': 10171.11,
  'mem_40:10:140000:107': 10171.11,
  'mem_40:10:140000:108': 10171.11,
  'mem_40:10:140000:109': 10171.11,
  'mem_40:10:140000:110': 10171.11,
  'mem_40:10:140000:111': 10171.11,
  'mem_40:10:140000:112': 10171.11,
  'mem_40:10:140000:113': 10171.11,
  'mem_40:10:140000:114': 10171.11,
  'mem_40:10:140000:115': 10171.11,
  'mem_40:10:140000:116': 10171.11,
  'mem_40:10:140000:117': 10171.11,
  'mem_40:10:140000:118': 10171.11,
  'mem_40:10:140000:119': 10171.11,
  'mem_40:10:140000:120': 10171.11,
  'mem_40:10:160000:1': 34.78,
  'mem_40:10:160000:2': 34.78,
  'mem_40:10:160000:3': 34.78,
  'mem_40:10:160000:4': 34.78,
  'mem_40:10:160000:5': 34.78,
  'mem_40:10:160000:6': 34.63,
  'mem_40:10:160000:7': 34.63,
  'mem_40:10:160000:8': 34.63,
  'mem_40:10:160000:9': 34.63,
  'mem_40:10:160000:10': 34.63,
  'mem_40:10:160000:11': 34.7,
  'mem_40:10:160000:12': 34.7,
  'mem_40:10:160000:13': 34.7,
  'mem_40:10:160000:14': 34.7,
  'mem_40:10:160000:15': 34.7,
  'mem_40:10:160000:16': 35.22,
  'mem_40:10:160000:17': 35.22,
  'mem_40:10:160000:18': 35.22,
  'mem_40:10:160000:19': 35.22,
  'mem_40:10:160000:20': 35.22,
  'mem_40:10:160000:21': 37,
  'mem_40:10:160000:22': 37,
  'mem_40:10:160000:23': 37,
  'mem_40:10:160000:24': 37,
  'mem_40:10:160000:25': 37,
  'mem_40:10:160000:26': 41.45,
  'mem_40:10:160000:27': 41.45,
  'mem_40:10:160000:28': 41.45,
  'mem_40:10:160000:29': 41.45,
  'mem_40:10:160000:30': 41.45,
  'mem_40:10:160000:31': 51.68,
  'mem_40:10:160000:32': 51.68,
  'mem_40:10:160000:33': 51.68,
  'mem_40:10:160000:34': 51.68,
  'mem_40:10:160000:35': 51.68,
  'mem_40:10:160000:36': 73.43,
  'mem_40:10:160000:37': 73.43,
  'mem_40:10:160000:38': 73.43,
  'mem_40:10:160000:39': 73.43,
  'mem_40:10:160000:40': 73.43,
  'mem_40:10:160000:41': 113.46,
  'mem_40:10:160000:42': 113.46,
  'mem_40:10:160000:43': 113.46,
  'mem_40:10:160000:44': 113.46,
  'mem_40:10:160000:45': 113.46,
  'mem_40:10:160000:46': 173.1,
  'mem_40:10:160000:47': 173.1,
  'mem_40:10:160000:48': 173.1,
  'mem_40:10:160000:49': 173.1,
  'mem_40:10:160000:50': 173.1,
  'mem_40:10:160000:51': 259.12,
  'mem_40:10:160000:52': 259.12,
  'mem_40:10:160000:53': 259.12,
  'mem_40:10:160000:54': 259.12,
  'mem_40:10:160000:55': 259.12,
  'mem_40:10:160000:56': 364.46,
  'mem_40:10:160000:57': 364.46,
  'mem_40:10:160000:58': 364.46,
  'mem_40:10:160000:59': 364.46,
  'mem_40:10:160000:60': 364.46,
  'mem_40:10:160000:61': 511.1,
  'mem_40:10:160000:62': 511.1,
  'mem_40:10:160000:63': 511.1,
  'mem_40:10:160000:64': 511.1,
  'mem_40:10:160000:65': 511.1,
  'mem_40:10:160000:66': 731.63,
  'mem_40:10:160000:67': 731.63,
  'mem_40:10:160000:68': 731.63,
  'mem_40:10:160000:69': 731.63,
  'mem_40:10:160000:70': 731.63,
  'mem_40:10:160000:71': 947.59,
  'mem_40:10:160000:72': 947.59,
  'mem_40:10:160000:73': 947.59,
  'mem_40:10:160000:74': 947.59,
  'mem_40:10:160000:75': 947.59,
  'mem_40:10:160000:76': 1288.92,
  'mem_40:10:160000:77': 1288.92,
  'mem_40:10:160000:78': 1288.92,
  'mem_40:10:160000:79': 1288.92,
  'mem_40:10:160000:80': 1288.92,
  'mem_40:10:160000:81': 1808.77,
  'mem_40:10:160000:82': 1808.77,
  'mem_40:10:160000:83': 1808.77,
  'mem_40:10:160000:84': 1808.77,
  'mem_40:10:160000:85': 1808.77,
  'mem_40:10:160000:86': 2420.11,
  'mem_40:10:160000:87': 2420.11,
  'mem_40:10:160000:88': 2420.11,
  'mem_40:10:160000:89': 2420.11,
  'mem_40:10:160000:90': 2420.11,
  'mem_40:10:160000:91': 3265.29,
  'mem_40:10:160000:92': 3265.29,
  'mem_40:10:160000:93': 3265.29,
  'mem_40:10:160000:94': 3265.29,
  'mem_40:10:160000:95': 3265.29,
  'mem_40:10:160000:96': 5299.18,
  'mem_40:10:160000:97': 5299.18,
  'mem_40:10:160000:98': 5299.18,
  'mem_40:10:160000:99': 5299.18,
  'mem_40:10:160000:100': 5299.18,
  'mem_40:10:160000:101': 9229.51,
  'mem_40:10:160000:102': 9229.51,
  'mem_40:10:160000:103': 9229.51,
  'mem_40:10:160000:104': 9229.51,
  'mem_40:10:160000:105': 9229.51,
  'mem_40:10:160000:106': 11626.82,
  'mem_40:10:160000:107': 11626.82,
  'mem_40:10:160000:108': 11626.82,
  'mem_40:10:160000:109': 11626.82,
  'mem_40:10:160000:110': 11626.82,
  'mem_40:10:160000:111': 11626.82,
  'mem_40:10:160000:112': 11626.82,
  'mem_40:10:160000:113': 11626.82,
  'mem_40:10:160000:114': 11626.82,
  'mem_40:10:160000:115': 11626.82,
  'mem_40:10:160000:116': 11626.82,
  'mem_40:10:160000:117': 11626.82,
  'mem_40:10:160000:118': 11626.82,
  'mem_40:10:160000:119': 11626.82,
  'mem_40:10:160000:120': 11626.82,
  'mem_40:10:180000:1': 39.08,
  'mem_40:10:180000:2': 39.08,
  'mem_40:10:180000:3': 39.08,
  'mem_40:10:180000:4': 39.08,
  'mem_40:10:180000:5': 39.08,
  'mem_40:10:180000:6': 38.9,
  'mem_40:10:180000:7': 38.9,
  'mem_40:10:180000:8': 38.9,
  'mem_40:10:180000:9': 38.9,
  'mem_40:10:180000:10': 38.9,
  'mem_40:10:180000:11': 38.98,
  'mem_40:10:180000:12': 38.98,
  'mem_40:10:180000:13': 38.98,
  'mem_40:10:180000:14': 38.98,
  'mem_40:10:180000:15': 38.98,
  'mem_40:10:180000:16': 39.57,
  'mem_40:10:180000:17': 39.57,
  'mem_40:10:180000:18': 39.57,
  'mem_40:10:180000:19': 39.57,
  'mem_40:10:180000:20': 39.57,
  'mem_40:10:180000:21': 41.57,
  'mem_40:10:180000:22': 41.57,
  'mem_40:10:180000:23': 41.57,
  'mem_40:10:180000:24': 41.57,
  'mem_40:10:180000:25': 41.57,
  'mem_40:10:180000:26': 46.56,
  'mem_40:10:180000:27': 46.56,
  'mem_40:10:180000:28': 46.56,
  'mem_40:10:180000:29': 46.56,
  'mem_40:10:180000:30': 46.56,
  'mem_40:10:180000:31': 58.11,
  'mem_40:10:180000:32': 58.11,
  'mem_40:10:180000:33': 58.11,
  'mem_40:10:180000:34': 58.11,
  'mem_40:10:180000:35': 58.11,
  'mem_40:10:180000:36': 82.62,
  'mem_40:10:180000:37': 82.62,
  'mem_40:10:180000:38': 82.62,
  'mem_40:10:180000:39': 82.62,
  'mem_40:10:180000:40': 82.62,
  'mem_40:10:180000:41': 127.55,
  'mem_40:10:180000:42': 127.55,
  'mem_40:10:180000:43': 127.55,
  'mem_40:10:180000:44': 127.55,
  'mem_40:10:180000:45': 127.55,
  'mem_40:10:180000:46': 194.48,
  'mem_40:10:180000:47': 194.48,
  'mem_40:10:180000:48': 194.48,
  'mem_40:10:180000:49': 194.48,
  'mem_40:10:180000:50': 194.48,
  'mem_40:10:180000:51': 291.11,
  'mem_40:10:180000:52': 291.11,
  'mem_40:10:180000:53': 291.11,
  'mem_40:10:180000:54': 291.11,
  'mem_40:10:180000:55': 291.11,
  'mem_40:10:180000:56': 409.46,
  'mem_40:10:180000:57': 409.46,
  'mem_40:10:180000:58': 409.46,
  'mem_40:10:180000:59': 409.46,
  'mem_40:10:180000:60': 409.46,
  'mem_40:10:180000:61': 574.2,
  'mem_40:10:180000:62': 574.2,
  'mem_40:10:180000:63': 574.2,
  'mem_40:10:180000:64': 574.2,
  'mem_40:10:180000:65': 574.2,
  'mem_40:10:180000:66': 821.95,
  'mem_40:10:180000:67': 821.95,
  'mem_40:10:180000:68': 821.95,
  'mem_40:10:180000:69': 821.95,
  'mem_40:10:180000:70': 821.95,
  'mem_40:10:180000:71': 1064.59,
  'mem_40:10:180000:72': 1064.59,
  'mem_40:10:180000:73': 1064.59,
  'mem_40:10:180000:74': 1064.59,
  'mem_40:10:180000:75': 1064.59,
  'mem_40:10:180000:76': 1448.04,
  'mem_40:10:180000:77': 1448.04,
  'mem_40:10:180000:78': 1448.04,
  'mem_40:10:180000:79': 1448.04,
  'mem_40:10:180000:80': 1448.04,
  'mem_40:10:180000:81': 2032.05,
  'mem_40:10:180000:82': 2032.05,
  'mem_40:10:180000:83': 2032.05,
  'mem_40:10:180000:84': 2032.05,
  'mem_40:10:180000:85': 2032.05,
  'mem_40:10:180000:86': 2718.91,
  'mem_40:10:180000:87': 2718.91,
  'mem_40:10:180000:88': 2718.91,
  'mem_40:10:180000:89': 2718.91,
  'mem_40:10:180000:90': 2718.91,
  'mem_40:10:180000:91': 3668.56,
  'mem_40:10:180000:92': 3668.56,
  'mem_40:10:180000:93': 3668.56,
  'mem_40:10:180000:94': 3668.56,
  'mem_40:10:180000:95': 3668.56,
  'mem_40:10:180000:96': 5953.84,
  'mem_40:10:180000:97': 5953.84,
  'mem_40:10:180000:98': 5953.84,
  'mem_40:10:180000:99': 5953.84,
  'mem_40:10:180000:100': 5953.84,
  'mem_40:10:180000:101': 10369.89,
  'mem_40:10:180000:102': 10369.89,
  'mem_40:10:180000:103': 10369.89,
  'mem_40:10:180000:104': 10369.89,
  'mem_40:10:180000:105': 10369.89,
  'mem_40:10:180000:106': 13063.49,
  'mem_40:10:180000:107': 13063.49,
  'mem_40:10:180000:108': 13063.49,
  'mem_40:10:180000:109': 13063.49,
  'mem_40:10:180000:110': 13063.49,
  'mem_40:10:180000:111': 13063.49,
  'mem_40:10:180000:112': 13063.49,
  'mem_40:10:180000:113': 13063.49,
  'mem_40:10:180000:114': 13063.49,
  'mem_40:10:180000:115': 13063.49,
  'mem_40:10:180000:116': 13063.49,
  'mem_40:10:180000:117': 13063.49,
  'mem_40:10:180000:118': 13063.49,
  'mem_40:10:180000:119': 13063.49,
  'mem_40:10:180000:120': 13063.49,
  'mem_40:10:200000:1': 43.45,
  'mem_40:10:200000:2': 43.45,
  'mem_40:10:200000:3': 43.45,
  'mem_40:10:200000:4': 43.45,
  'mem_40:10:200000:5': 43.45,
  'mem_40:10:200000:6': 43.25,
  'mem_40:10:200000:7': 43.25,
  'mem_40:10:200000:8': 43.25,
  'mem_40:10:200000:9': 43.25,
  'mem_40:10:200000:10': 43.25,
  'mem_40:10:200000:11': 43.34,
  'mem_40:10:200000:12': 43.34,
  'mem_40:10:200000:13': 43.34,
  'mem_40:10:200000:14': 43.34,
  'mem_40:10:200000:15': 43.34,
  'mem_40:10:200000:16': 43.99,
  'mem_40:10:200000:17': 43.99,
  'mem_40:10:200000:18': 43.99,
  'mem_40:10:200000:19': 43.99,
  'mem_40:10:200000:20': 43.99,
  'mem_40:10:200000:21': 46.21,
  'mem_40:10:200000:22': 46.21,
  'mem_40:10:200000:23': 46.21,
  'mem_40:10:200000:24': 46.21,
  'mem_40:10:200000:25': 46.21,
  'mem_40:10:200000:26': 51.76,
  'mem_40:10:200000:27': 51.76,
  'mem_40:10:200000:28': 51.76,
  'mem_40:10:200000:29': 51.76,
  'mem_40:10:200000:30': 51.76,
  'mem_40:10:200000:31': 64.59,
  'mem_40:10:200000:32': 64.59,
  'mem_40:10:200000:33': 64.59,
  'mem_40:10:200000:34': 64.59,
  'mem_40:10:200000:35': 64.59,
  'mem_40:10:200000:36': 91.81,
  'mem_40:10:200000:37': 91.81,
  'mem_40:10:200000:38': 91.81,
  'mem_40:10:200000:39': 91.81,
  'mem_40:10:200000:40': 91.81,
  'mem_40:10:200000:41': 141.77,
  'mem_40:10:200000:42': 141.77,
  'mem_40:10:200000:43': 141.77,
  'mem_40:10:200000:44': 141.77,
  'mem_40:10:200000:45': 141.77,
  'mem_40:10:200000:46': 216.19,
  'mem_40:10:200000:47': 216.19,
  'mem_40:10:200000:48': 216.19,
  'mem_40:10:200000:49': 216.19,
  'mem_40:10:200000:50': 216.19,
  'mem_40:10:200000:51': 323.62,
  'mem_40:10:200000:52': 323.62,
  'mem_40:10:200000:53': 323.62,
  'mem_40:10:200000:54': 323.62,
  'mem_40:10:200000:55': 323.62,
  'mem_40:10:200000:56': 455.17,
  'mem_40:10:200000:57': 455.17,
  'mem_40:10:200000:58': 455.17,
  'mem_40:10:200000:59': 455.17,
  'mem_40:10:200000:60': 455.17,
  'mem_40:10:200000:61': 638.3,
  'mem_40:10:200000:62': 638.3,
  'mem_40:10:200000:63': 638.3,
  'mem_40:10:200000:64': 638.3,
  'mem_40:10:200000:65': 638.3,
  'mem_40:10:200000:66': 913.68,
  'mem_40:10:200000:67': 913.68,
  'mem_40:10:200000:68': 913.68,
  'mem_40:10:200000:69': 913.68,
  'mem_40:10:200000:70': 913.68,
  'mem_40:10:200000:71': 1183.43,
  'mem_40:10:200000:72': 1183.43,
  'mem_40:10:200000:73': 1183.43,
  'mem_40:10:200000:74': 1183.43,
  'mem_40:10:200000:75': 1183.43,
  'mem_40:10:200000:76': 1609.72,
  'mem_40:10:200000:77': 1609.72,
  'mem_40:10:200000:78': 1609.72,
  'mem_40:10:200000:79': 1609.72,
  'mem_40:10:200000:80': 1609.72,
  'mem_40:10:200000:81': 2258.93,
  'mem_40:10:200000:82': 2258.93,
  'mem_40:10:200000:83': 2258.93,
  'mem_40:10:200000:84': 2258.93,
  'mem_40:10:200000:85': 2258.93,
  'mem_40:10:200000:86': 3022.52,
  'mem_40:10:200000:87': 3022.52,
  'mem_40:10:200000:88': 3022.52,
  'mem_40:10:200000:89': 3022.52,
  'mem_40:10:200000:90': 3022.52,
  'mem_40:10:200000:91': 4078.22,
  'mem_40:10:200000:92': 4078.22,
  'mem_40:10:200000:93': 4078.22,
  'mem_40:10:200000:94': 4078.22,
  'mem_40:10:200000:95': 4078.22,
  'mem_40:10:200000:96': 6618.67,
  'mem_40:10:200000:97': 6618.67,
  'mem_40:10:200000:98': 6618.67,
  'mem_40:10:200000:99': 6618.67,
  'mem_40:10:200000:100': 6618.67,
  'mem_40:10:200000:101': 11527.96,
  'mem_40:10:200000:102': 11527.96,
  'mem_40:10:200000:103': 11527.96,
  'mem_40:10:200000:104': 11527.96,
  'mem_40:10:200000:105': 11527.96,
  'mem_40:10:200000:106': 14522.43,
  'mem_40:10:200000:107': 14522.43,
  'mem_40:10:200000:108': 14522.43,
  'mem_40:10:200000:109': 14522.43,
  'mem_40:10:200000:110': 14522.43,
  'mem_40:10:200000:111': 14522.43,
  'mem_40:10:200000:112': 14522.43,
  'mem_40:10:200000:113': 14522.43,
  'mem_40:10:200000:114': 14522.43,
  'mem_40:10:200000:115': 14522.43,
  'mem_40:10:200000:116': 14522.43,
  'mem_40:10:200000:117': 14522.43,
  'mem_40:10:200000:118': 14522.43,
  'mem_40:10:200000:119': 14522.43,
  'mem_40:10:200000:120': 14522.43,
  'mem_7:10:5000:1': 1.2,
  'mem_7:10:5000:2': 1.2,
  'mem_7:10:5000:3': 1.2,
  'mem_7:10:5000:4': 1.2,
  'mem_7:10:5000:5': 1.2,
  'mem_7:10:5000:6': 1.2,
  'mem_7:10:5000:7': 1.2,
  'mem_7:10:5000:8': 1.2,
  'mem_7:10:5000:9': 1.2,
  'mem_7:10:5000:10': 1.2,
  'mem_7:10:5000:11': 1.2,
  'mem_7:10:5000:12': 1.2,
  'mem_7:10:5000:13': 1.2,
  'mem_7:10:5000:14': 1.2,
  'mem_7:10:5000:15': 1.2,
  'mem_7:10:5000:16': 1.2,
  'mem_7:10:5000:17': 1.2,
  'mem_7:10:5000:18': 1.2,
  'mem_7:10:5000:19': 1.2,
  'mem_7:10:5000:20': 1.2,
  'mem_7:10:5000:21': 1.2,
  'mem_7:10:5000:22': 1.2,
  'mem_7:10:5000:23': 1.2,
  'mem_7:10:5000:24': 1.2,
  'mem_7:10:5000:25': 1.2,
  'mem_7:10:5000:26': 1.2,
  'mem_7:10:5000:27': 1.2,
  'mem_7:10:5000:28': 1.2,
  'mem_7:10:5000:29': 1.2,
  'mem_7:10:5000:30': 1.2,
  'mem_7:10:5000:31': 2.4,
  'mem_7:10:5000:32': 2.4,
  'mem_7:10:5000:33': 2.4,
  'mem_7:10:5000:34': 2.4,
  'mem_7:10:5000:35': 2.4,
  'mem_7:10:5000:36': 2.4,
  'mem_7:10:5000:37': 2.4,
  'mem_7:10:5000:38': 2.4,
  'mem_7:10:5000:39': 2.4,
  'mem_7:10:5000:40': 2.4,
  'mem_7:10:5000:41': 4.8,
  'mem_7:10:5000:42': 4.8,
  'mem_7:10:5000:43': 4.8,
  'mem_7:10:5000:44': 4.8,
  'mem_7:10:5000:45': 4.8,
  'mem_7:10:5000:46': 6,
  'mem_7:10:5000:47': 6,
  'mem_7:10:5000:48': 6,
  'mem_7:10:5000:49': 6,
  'mem_7:10:5000:50': 6,
  'mem_7:10:5000:51': 8.4,
  'mem_7:10:5000:52': 8.4,
  'mem_7:10:5000:53': 8.4,
  'mem_7:10:5000:54': 8.4,
  'mem_7:10:5000:55': 8.4,
  'mem_7:10:5000:56': 9.6,
  'mem_7:10:5000:57': 9.6,
  'mem_7:10:5000:58': 9.6,
  'mem_7:10:5000:59': 9.6,
  'mem_7:10:5000:60': 9.6,
  'mem_7:10:5000:61': 10.8,
  'mem_7:10:5000:62': 10.8,
  'mem_7:10:5000:63': 10.8,
  'mem_7:10:5000:64': 10.8,
  'mem_7:10:5000:65': 10.8,
  'mem_7:10:5000:66': 14.4,
  'mem_7:10:5000:67': 14.4,
  'mem_7:10:5000:68': 14.4,
  'mem_7:10:5000:69': 14.4,
  'mem_7:10:5000:70': 14.4,
  'mem_7:10:5000:71': 19.2,
  'mem_7:10:5000:72': 19.2,
  'mem_7:10:5000:73': 19.2,
  'mem_7:10:5000:74': 19.2,
  'mem_7:10:5000:75': 19.2,
  'mem_7:10:5000:76': 25.2,
  'mem_7:10:5000:77': 25.2,
  'mem_7:10:5000:78': 25.2,
  'mem_7:10:5000:79': 25.2,
  'mem_7:10:5000:80': 25.2,
  'mem_7:10:5000:81': 33.95,
  'mem_7:10:5000:82': 33.95,
  'mem_7:10:5000:83': 33.95,
  'mem_7:10:5000:84': 33.95,
  'mem_7:10:5000:85': 33.95,
  'mem_7:10:5000:86': 45.4,
  'mem_7:10:5000:87': 45.4,
  'mem_7:10:5000:88': 45.4,
  'mem_7:10:5000:89': 45.4,
  'mem_7:10:5000:90': 45.4,
  'mem_7:10:5000:91': 61.23,
  'mem_7:10:5000:92': 61.23,
  'mem_7:10:5000:93': 61.23,
  'mem_7:10:5000:94': 61.23,
  'mem_7:10:5000:95': 61.23,
  'mem_7:10:5000:96': 99.34,
  'mem_7:10:5000:97': 99.34,
  'mem_7:10:5000:98': 99.34,
  'mem_7:10:5000:99': 99.34,
  'mem_7:10:5000:100': 99.34,
  'mem_7:10:5000:101': 173.1,
  'mem_7:10:5000:102': 173.1,
  'mem_7:10:5000:103': 173.1,
  'mem_7:10:5000:104': 173.1,
  'mem_7:10:5000:105': 173.1,
  'mem_7:10:5000:106': 217.84,
  'mem_7:10:5000:107': 217.84,
  'mem_7:10:5000:108': 217.84,
  'mem_7:10:5000:109': 217.84,
  'mem_7:10:5000:110': 217.84,
  'mem_7:10:5000:111': 217.56,
  'mem_7:10:5000:112': 217.56,
  'mem_7:10:5000:113': 217.56,
  'mem_7:10:5000:114': 217.56,
  'mem_7:10:5000:115': 217.56,
  'mem_7:10:5000:116': 217.56,
  'mem_7:10:5000:117': 217.56,
  'mem_7:10:5000:118': 217.56,
  'mem_7:10:5000:119': 217.56,
  'mem_7:10:5000:120': 217.56,
  'mem_7:10:7500:1': 1.2,
  'mem_7:10:7500:2': 1.2,
  'mem_7:10:7500:3': 1.2,
  'mem_7:10:7500:4': 1.2,
  'mem_7:10:7500:5': 1.2,
  'mem_7:10:7500:6': 1.2,
  'mem_7:10:7500:7': 1.2,
  'mem_7:10:7500:8': 1.2,
  'mem_7:10:7500:9': 1.2,
  'mem_7:10:7500:10': 1.2,
  'mem_7:10:7500:11': 1.2,
  'mem_7:10:7500:12': 1.2,
  'mem_7:10:7500:13': 1.2,
  'mem_7:10:7500:14': 1.2,
  'mem_7:10:7500:15': 1.2,
  'mem_7:10:7500:16': 2.4,
  'mem_7:10:7500:17': 2.4,
  'mem_7:10:7500:18': 2.4,
  'mem_7:10:7500:19': 2.4,
  'mem_7:10:7500:20': 2.4,
  'mem_7:10:7500:21': 2.4,
  'mem_7:10:7500:22': 2.4,
  'mem_7:10:7500:23': 2.4,
  'mem_7:10:7500:24': 2.4,
  'mem_7:10:7500:25': 2.4,
  'mem_7:10:7500:26': 2.4,
  'mem_7:10:7500:27': 2.4,
  'mem_7:10:7500:28': 2.4,
  'mem_7:10:7500:29': 2.4,
  'mem_7:10:7500:30': 2.4,
  'mem_7:10:7500:31': 2.4,
  'mem_7:10:7500:32': 2.4,
  'mem_7:10:7500:33': 2.4,
  'mem_7:10:7500:34': 2.4,
  'mem_7:10:7500:35': 2.4,
  'mem_7:10:7500:36': 3.6,
  'mem_7:10:7500:37': 3.6,
  'mem_7:10:7500:38': 3.6,
  'mem_7:10:7500:39': 3.6,
  'mem_7:10:7500:40': 3.6,
  'mem_7:10:7500:41': 6,
  'mem_7:10:7500:42': 6,
  'mem_7:10:7500:43': 6,
  'mem_7:10:7500:44': 6,
  'mem_7:10:7500:45': 6,
  'mem_7:10:7500:46': 8.4,
  'mem_7:10:7500:47': 8.4,
  'mem_7:10:7500:48': 8.4,
  'mem_7:10:7500:49': 8.4,
  'mem_7:10:7500:50': 8.4,
  'mem_7:10:7500:51': 13.2,
  'mem_7:10:7500:52': 13.2,
  'mem_7:10:7500:53': 13.2,
  'mem_7:10:7500:54': 13.2,
  'mem_7:10:7500:55': 13.2,
  'mem_7:10:7500:56': 14.4,
  'mem_7:10:7500:57': 14.4,
  'mem_7:10:7500:58': 14.4,
  'mem_7:10:7500:59': 14.4,
  'mem_7:10:7500:60': 14.4,
  'mem_7:10:7500:61': 15.6,
  'mem_7:10:7500:62': 15.6,
  'mem_7:10:7500:63': 15.6,
  'mem_7:10:7500:64': 15.6,
  'mem_7:10:7500:65': 15.6,
  'mem_7:10:7500:66': 21.6,
  'mem_7:10:7500:67': 21.6,
  'mem_7:10:7500:68': 21.6,
  'mem_7:10:7500:69': 21.6,
  'mem_7:10:7500:70': 21.6,
  'mem_7:10:7500:71': 28.8,
  'mem_7:10:7500:72': 28.8,
  'mem_7:10:7500:73': 28.8,
  'mem_7:10:7500:74': 28.8,
  'mem_7:10:7500:75': 28.8,
  'mem_7:10:7500:76': 37.2,
  'mem_7:10:7500:77': 37.2,
  'mem_7:10:7500:78': 37.2,
  'mem_7:10:7500:79': 37.2,
  'mem_7:10:7500:80': 37.2,
  'mem_7:10:7500:81': 50.87,
  'mem_7:10:7500:82': 50.87,
  'mem_7:10:7500:83': 50.87,
  'mem_7:10:7500:84': 50.87,
  'mem_7:10:7500:85': 50.87,
  'mem_7:10:7500:86': 68.06,
  'mem_7:10:7500:87': 68.06,
  'mem_7:10:7500:88': 68.06,
  'mem_7:10:7500:89': 68.06,
  'mem_7:10:7500:90': 68.06,
  'mem_7:10:7500:91': 91.83,
  'mem_7:10:7500:92': 91.83,
  'mem_7:10:7500:93': 91.83,
  'mem_7:10:7500:94': 91.83,
  'mem_7:10:7500:95': 91.83,
  'mem_7:10:7500:96': 149.03,
  'mem_7:10:7500:97': 149.03,
  'mem_7:10:7500:98': 149.03,
  'mem_7:10:7500:99': 149.03,
  'mem_7:10:7500:100': 149.03,
  'mem_7:10:7500:101': 259.57,
  'mem_7:10:7500:102': 259.57,
  'mem_7:10:7500:103': 259.57,
  'mem_7:10:7500:104': 259.57,
  'mem_7:10:7500:105': 259.57,
  'mem_7:10:7500:106': 326.99,
  'mem_7:10:7500:107': 326.99,
  'mem_7:10:7500:108': 326.99,
  'mem_7:10:7500:109': 326.99,
  'mem_7:10:7500:110': 326.99,
  'mem_7:10:7500:111': 326.99,
  'mem_7:10:7500:112': 326.99,
  'mem_7:10:7500:113': 326.99,
  'mem_7:10:7500:114': 326.99,
  'mem_7:10:7500:115': 326.99,
  'mem_7:10:7500:116': 326.99,
  'mem_7:10:7500:117': 326.99,
  'mem_7:10:7500:118': 326.99,
  'mem_7:10:7500:119': 326.99,
  'mem_7:10:7500:120': 326.99,
  'mem_7:10:10000:1': 2.4,
  'mem_7:10:10000:2': 2.4,
  'mem_7:10:10000:3': 2.4,
  'mem_7:10:10000:4': 2.4,
  'mem_7:10:10000:5': 2.4,
  'mem_7:10:10000:6': 2.4,
  'mem_7:10:10000:7': 2.4,
  'mem_7:10:10000:8': 2.4,
  'mem_7:10:10000:9': 2.4,
  'mem_7:10:10000:10': 2.4,
  'mem_7:10:10000:11': 2.4,
  'mem_7:10:10000:12': 2.4,
  'mem_7:10:10000:13': 2.4,
  'mem_7:10:10000:14': 2.4,
  'mem_7:10:10000:15': 2.4,
  'mem_7:10:10000:16': 2.4,
  'mem_7:10:10000:17': 2.4,
  'mem_7:10:10000:18': 2.4,
  'mem_7:10:10000:19': 2.4,
  'mem_7:10:10000:20': 2.4,
  'mem_7:10:10000:21': 2.4,
  'mem_7:10:10000:22': 2.4,
  'mem_7:10:10000:23': 2.4,
  'mem_7:10:10000:24': 2.4,
  'mem_7:10:10000:25': 2.4,
  'mem_7:10:10000:26': 2.4,
  'mem_7:10:10000:27': 2.4,
  'mem_7:10:10000:28': 2.4,
  'mem_7:10:10000:29': 2.4,
  'mem_7:10:10000:30': 2.4,
  'mem_7:10:10000:31': 3.6,
  'mem_7:10:10000:32': 3.6,
  'mem_7:10:10000:33': 3.6,
  'mem_7:10:10000:34': 3.6,
  'mem_7:10:10000:35': 3.6,
  'mem_7:10:10000:36': 4.8,
  'mem_7:10:10000:37': 4.8,
  'mem_7:10:10000:38': 4.8,
  'mem_7:10:10000:39': 4.8,
  'mem_7:10:10000:40': 4.8,
  'mem_7:10:10000:41': 8.4,
  'mem_7:10:10000:42': 8.4,
  'mem_7:10:10000:43': 8.4,
  'mem_7:10:10000:44': 8.4,
  'mem_7:10:10000:45': 8.4,
  'mem_7:10:10000:46': 12,
  'mem_7:10:10000:47': 12,
  'mem_7:10:10000:48': 12,
  'mem_7:10:10000:49': 12,
  'mem_7:10:10000:50': 12,
  'mem_7:10:10000:51': 16.8,
  'mem_7:10:10000:52': 16.8,
  'mem_7:10:10000:53': 16.8,
  'mem_7:10:10000:54': 16.8,
  'mem_7:10:10000:55': 16.8,
  'mem_7:10:10000:56': 18,
  'mem_7:10:10000:57': 18,
  'mem_7:10:10000:58': 18,
  'mem_7:10:10000:59': 18,
  'mem_7:10:10000:60': 18,
  'mem_7:10:10000:61': 20.4,
  'mem_7:10:10000:62': 20.4,
  'mem_7:10:10000:63': 20.4,
  'mem_7:10:10000:64': 20.4,
  'mem_7:10:10000:65': 20.4,
  'mem_7:10:10000:66': 27.6,
  'mem_7:10:10000:67': 27.6,
  'mem_7:10:10000:68': 27.6,
  'mem_7:10:10000:69': 27.6,
  'mem_7:10:10000:70': 27.6,
  'mem_7:10:10000:71': 37.2,
  'mem_7:10:10000:72': 37.2,
  'mem_7:10:10000:73': 37.2,
  'mem_7:10:10000:74': 37.2,
  'mem_7:10:10000:75': 37.2,
  'mem_7:10:10000:76': 49.2,
  'mem_7:10:10000:77': 49.2,
  'mem_7:10:10000:78': 49.2,
  'mem_7:10:10000:79': 49.2,
  'mem_7:10:10000:80': 49.2,
  'mem_7:10:10000:81': 67.81,
  'mem_7:10:10000:82': 67.81,
  'mem_7:10:10000:83': 67.81,
  'mem_7:10:10000:84': 67.81,
  'mem_7:10:10000:85': 67.81,
  'mem_7:10:10000:86': 90.73,
  'mem_7:10:10000:87': 90.73,
  'mem_7:10:10000:88': 90.73,
  'mem_7:10:10000:89': 90.73,
  'mem_7:10:10000:90': 90.73,
  'mem_7:10:10000:91': 122.42,
  'mem_7:10:10000:92': 122.42,
  'mem_7:10:10000:93': 122.42,
  'mem_7:10:10000:94': 122.42,
  'mem_7:10:10000:95': 122.42,
  'mem_7:10:10000:96': 198.68,
  'mem_7:10:10000:97': 198.68,
  'mem_7:10:10000:98': 198.68,
  'mem_7:10:10000:99': 198.68,
  'mem_7:10:10000:100': 198.68,
  'mem_7:10:10000:101': 346.04,
  'mem_7:10:10000:102': 346.04,
  'mem_7:10:10000:103': 346.04,
  'mem_7:10:10000:104': 346.04,
  'mem_7:10:10000:105': 346.04,
  'mem_7:10:10000:106': 435.93,
  'mem_7:10:10000:107': 435.93,
  'mem_7:10:10000:108': 435.93,
  'mem_7:10:10000:109': 435.93,
  'mem_7:10:10000:110': 435.93,
  'mem_7:10:10000:111': 435.93,
  'mem_7:10:10000:112': 435.93,
  'mem_7:10:10000:113': 435.93,
  'mem_7:10:10000:114': 435.93,
  'mem_7:10:10000:115': 435.93,
  'mem_7:10:10000:116': 435.93,
  'mem_7:10:10000:117': 435.93,
  'mem_7:10:10000:118': 435.93,
  'mem_7:10:10000:119': 435.93,
  'mem_7:10:10000:120': 435.93,
  'mem_7:10:15000:1': 2.4,
  'mem_7:10:15000:2': 2.4,
  'mem_7:10:15000:3': 2.4,
  'mem_7:10:15000:4': 2.4,
  'mem_7:10:15000:5': 2.4,
  'mem_7:10:15000:6': 2.4,
  'mem_7:10:15000:7': 2.4,
  'mem_7:10:15000:8': 2.4,
  'mem_7:10:15000:9': 2.4,
  'mem_7:10:15000:10': 2.4,
  'mem_7:10:15000:11': 2.4,
  'mem_7:10:15000:12': 2.4,
  'mem_7:10:15000:13': 2.4,
  'mem_7:10:15000:14': 2.4,
  'mem_7:10:15000:15': 2.4,
  'mem_7:10:15000:16': 3.6,
  'mem_7:10:15000:17': 3.6,
  'mem_7:10:15000:18': 3.6,
  'mem_7:10:15000:19': 3.6,
  'mem_7:10:15000:20': 3.6,
  'mem_7:10:15000:21': 3.6,
  'mem_7:10:15000:22': 3.6,
  'mem_7:10:15000:23': 3.6,
  'mem_7:10:15000:24': 3.6,
  'mem_7:10:15000:25': 3.6,
  'mem_7:10:15000:26': 3.6,
  'mem_7:10:15000:27': 3.6,
  'mem_7:10:15000:28': 3.6,
  'mem_7:10:15000:29': 3.6,
  'mem_7:10:15000:30': 3.6,
  'mem_7:10:15000:31': 4.8,
  'mem_7:10:15000:32': 4.8,
  'mem_7:10:15000:33': 4.8,
  'mem_7:10:15000:34': 4.8,
  'mem_7:10:15000:35': 4.8,
  'mem_7:10:15000:36': 7.2,
  'mem_7:10:15000:37': 7.2,
  'mem_7:10:15000:38': 7.2,
  'mem_7:10:15000:39': 7.2,
  'mem_7:10:15000:40': 7.2,
  'mem_7:10:15000:41': 12,
  'mem_7:10:15000:42': 12,
  'mem_7:10:15000:43': 12,
  'mem_7:10:15000:44': 12,
  'mem_7:10:15000:45': 12,
  'mem_7:10:15000:46': 16.8,
  'mem_7:10:15000:47': 16.8,
  'mem_7:10:15000:48': 16.8,
  'mem_7:10:15000:49': 16.8,
  'mem_7:10:15000:50': 16.8,
  'mem_7:10:15000:51': 25.2,
  'mem_7:10:15000:52': 25.2,
  'mem_7:10:15000:53': 25.2,
  'mem_7:10:15000:54': 25.2,
  'mem_7:10:15000:55': 25.2,
  'mem_7:10:15000:56': 27.6,
  'mem_7:10:15000:57': 27.6,
  'mem_7:10:15000:58': 27.6,
  'mem_7:10:15000:59': 27.6,
  'mem_7:10:15000:60': 27.6,
  'mem_7:10:15000:61': 30,
  'mem_7:10:15000:62': 30,
  'mem_7:10:15000:63': 30,
  'mem_7:10:15000:64': 30,
  'mem_7:10:15000:65': 30,
  'mem_7:10:15000:66': 42,
  'mem_7:10:15000:67': 42,
  'mem_7:10:15000:68': 42,
  'mem_7:10:15000:69': 42,
  'mem_7:10:15000:70': 42,
  'mem_7:10:15000:71': 56.4,
  'mem_7:10:15000:72': 56.4,
  'mem_7:10:15000:73': 56.4,
  'mem_7:10:15000:74': 56.4,
  'mem_7:10:15000:75': 56.4,
  'mem_7:10:15000:76': 74.4,
  'mem_7:10:15000:77': 74.4,
  'mem_7:10:15000:78': 74.4,
  'mem_7:10:15000:79': 74.4,
  'mem_7:10:15000:80': 74.4,
  'mem_7:10:15000:81': 101.74,
  'mem_7:10:15000:82': 101.74,
  'mem_7:10:15000:83': 101.74,
  'mem_7:10:15000:84': 101.74,
  'mem_7:10:15000:85': 101.74,
  'mem_7:10:15000:86': 136.12,
  'mem_7:10:15000:87': 136.12,
  'mem_7:10:15000:88': 136.12,
  'mem_7:10:15000:89': 136.12,
  'mem_7:10:15000:90': 136.12,
  'mem_7:10:15000:91': 183.66,
  'mem_7:10:15000:92': 183.66,
  'mem_7:10:15000:93': 183.66,
  'mem_7:10:15000:94': 183.66,
  'mem_7:10:15000:95': 183.66,
  'mem_7:10:15000:96': 298.06,
  'mem_7:10:15000:97': 298.06,
  'mem_7:10:15000:98': 298.06,
  'mem_7:10:15000:99': 298.06,
  'mem_7:10:15000:100': 298.06,
  'mem_7:10:15000:101': 519.14,
  'mem_7:10:15000:102': 519.14,
  'mem_7:10:15000:103': 519.14,
  'mem_7:10:15000:104': 519.14,
  'mem_7:10:15000:105': 519.14,
  'mem_7:10:15000:106': 653.98,
  'mem_7:10:15000:107': 653.98,
  'mem_7:10:15000:108': 653.98,
  'mem_7:10:15000:109': 653.98,
  'mem_7:10:15000:110': 653.98,
  'mem_7:10:15000:111': 653.98,
  'mem_7:10:15000:112': 653.98,
  'mem_7:10:15000:113': 653.98,
  'mem_7:10:15000:114': 653.98,
  'mem_7:10:15000:115': 653.98,
  'mem_7:10:15000:116': 653.98,
  'mem_7:10:15000:117': 653.98,
  'mem_7:10:15000:118': 653.98,
  'mem_7:10:15000:119': 653.98,
  'mem_7:10:15000:120': 653.98,
  'mem_7:10:20000:1': 3.6,
  'mem_7:10:20000:2': 3.6,
  'mem_7:10:20000:3': 3.6,
  'mem_7:10:20000:4': 3.6,
  'mem_7:10:20000:5': 3.6,
  'mem_7:10:20000:6': 3.6,
  'mem_7:10:20000:7': 3.6,
  'mem_7:10:20000:8': 3.6,
  'mem_7:10:20000:9': 3.6,
  'mem_7:10:20000:10': 3.6,
  'mem_7:10:20000:11': 3.6,
  'mem_7:10:20000:12': 3.6,
  'mem_7:10:20000:13': 3.6,
  'mem_7:10:20000:14': 3.6,
  'mem_7:10:20000:15': 3.6,
  'mem_7:10:20000:16': 3.6,
  'mem_7:10:20000:17': 3.6,
  'mem_7:10:20000:18': 3.6,
  'mem_7:10:20000:19': 3.6,
  'mem_7:10:20000:20': 3.6,
  'mem_7:10:20000:21': 4.8,
  'mem_7:10:20000:22': 4.8,
  'mem_7:10:20000:23': 4.8,
  'mem_7:10:20000:24': 4.8,
  'mem_7:10:20000:25': 4.8,
  'mem_7:10:20000:26': 4.8,
  'mem_7:10:20000:27': 4.8,
  'mem_7:10:20000:28': 4.8,
  'mem_7:10:20000:29': 4.8,
  'mem_7:10:20000:30': 4.8,
  'mem_7:10:20000:31': 7.2,
  'mem_7:10:20000:32': 7.2,
  'mem_7:10:20000:33': 7.2,
  'mem_7:10:20000:34': 7.2,
  'mem_7:10:20000:35': 7.2,
  'mem_7:10:20000:36': 9.6,
  'mem_7:10:20000:37': 9.6,
  'mem_7:10:20000:38': 9.6,
  'mem_7:10:20000:39': 9.6,
  'mem_7:10:20000:40': 9.6,
  'mem_7:10:20000:41': 15.6,
  'mem_7:10:20000:42': 15.6,
  'mem_7:10:20000:43': 15.6,
  'mem_7:10:20000:44': 15.6,
  'mem_7:10:20000:45': 15.6,
  'mem_7:10:20000:46': 22.8,
  'mem_7:10:20000:47': 22.8,
  'mem_7:10:20000:48': 22.8,
  'mem_7:10:20000:49': 22.8,
  'mem_7:10:20000:50': 22.8,
  'mem_7:10:20000:51': 33.6,
  'mem_7:10:20000:52': 33.6,
  'mem_7:10:20000:53': 33.6,
  'mem_7:10:20000:54': 33.6,
  'mem_7:10:20000:55': 33.6,
  'mem_7:10:20000:56': 36,
  'mem_7:10:20000:57': 36,
  'mem_7:10:20000:58': 36,
  'mem_7:10:20000:59': 36,
  'mem_7:10:20000:60': 36,
  'mem_7:10:20000:61': 39.6,
  'mem_7:10:20000:62': 39.6,
  'mem_7:10:20000:63': 39.6,
  'mem_7:10:20000:64': 39.6,
  'mem_7:10:20000:65': 39.6,
  'mem_7:10:20000:66': 55.2,
  'mem_7:10:20000:67': 55.2,
  'mem_7:10:20000:68': 55.2,
  'mem_7:10:20000:69': 55.2,
  'mem_7:10:20000:70': 55.2,
  'mem_7:10:20000:71': 74.4,
  'mem_7:10:20000:72': 74.4,
  'mem_7:10:20000:73': 74.4,
  'mem_7:10:20000:74': 74.4,
  'mem_7:10:20000:75': 74.4,
  'mem_7:10:20000:76': 98.4,
  'mem_7:10:20000:77': 98.4,
  'mem_7:10:20000:78': 98.4,
  'mem_7:10:20000:79': 98.4,
  'mem_7:10:20000:80': 98.4,
  'mem_7:10:20000:81': 135.62,
  'mem_7:10:20000:82': 135.62,
  'mem_7:10:20000:83': 135.62,
  'mem_7:10:20000:84': 135.62,
  'mem_7:10:20000:85': 135.62,
  'mem_7:10:20000:86': 181.47,
  'mem_7:10:20000:87': 181.47,
  'mem_7:10:20000:88': 181.47,
  'mem_7:10:20000:89': 181.47,
  'mem_7:10:20000:90': 181.47,
  'mem_7:10:20000:91': 244.84,
  'mem_7:10:20000:92': 244.84,
  'mem_7:10:20000:93': 244.84,
  'mem_7:10:20000:94': 244.84,
  'mem_7:10:20000:95': 244.84,
  'mem_7:10:20000:96': 397.36,
  'mem_7:10:20000:97': 397.36,
  'mem_7:10:20000:98': 397.36,
  'mem_7:10:20000:99': 397.36,
  'mem_7:10:20000:100': 397.36,
  'mem_7:10:20000:101': 692.08,
  'mem_7:10:20000:102': 692.08,
  'mem_7:10:20000:103': 692.08,
  'mem_7:10:20000:104': 692.08,
  'mem_7:10:20000:105': 692.08,
  'mem_7:10:20000:106': 871.85,
  'mem_7:10:20000:107': 871.85,
  'mem_7:10:20000:108': 871.85,
  'mem_7:10:20000:109': 871.85,
  'mem_7:10:20000:110': 871.85,
  'mem_7:10:20000:111': 871.85,
  'mem_7:10:20000:112': 871.85,
  'mem_7:10:20000:113': 871.85,
  'mem_7:10:20000:114': 871.85,
  'mem_7:10:20000:115': 871.85,
  'mem_7:10:20000:116': 871.85,
  'mem_7:10:20000:117': 871.85,
  'mem_7:10:20000:118': 871.85,
  'mem_7:10:20000:119': 871.85,
  'mem_7:10:20000:120': 871.85,
  'mem_7:10:25000:1': 4.8,
  'mem_7:10:25000:2': 4.8,
  'mem_7:10:25000:3': 4.8,
  'mem_7:10:25000:4': 4.8,
  'mem_7:10:25000:5': 4.8,
  'mem_7:10:25000:6': 4.8,
  'mem_7:10:25000:7': 4.8,
  'mem_7:10:25000:8': 4.8,
  'mem_7:10:25000:9': 4.8,
  'mem_7:10:25000:10': 4.8,
  'mem_7:10:25000:11': 4.8,
  'mem_7:10:25000:12': 4.8,
  'mem_7:10:25000:13': 4.8,
  'mem_7:10:25000:14': 4.8,
  'mem_7:10:25000:15': 4.8,
  'mem_7:10:25000:16': 4.8,
  'mem_7:10:25000:17': 4.8,
  'mem_7:10:25000:18': 4.8,
  'mem_7:10:25000:19': 4.8,
  'mem_7:10:25000:20': 4.8,
  'mem_7:10:25000:21': 4.8,
  'mem_7:10:25000:22': 4.8,
  'mem_7:10:25000:23': 4.8,
  'mem_7:10:25000:24': 4.8,
  'mem_7:10:25000:25': 4.8,
  'mem_7:10:25000:26': 6,
  'mem_7:10:25000:27': 6,
  'mem_7:10:25000:28': 6,
  'mem_7:10:25000:29': 6,
  'mem_7:10:25000:30': 6,
  'mem_7:10:25000:31': 8.4,
  'mem_7:10:25000:32': 8.4,
  'mem_7:10:25000:33': 8.4,
  'mem_7:10:25000:34': 8.4,
  'mem_7:10:25000:35': 8.4,
  'mem_7:10:25000:36': 12,
  'mem_7:10:25000:37': 12,
  'mem_7:10:25000:38': 12,
  'mem_7:10:25000:39': 12,
  'mem_7:10:25000:40': 12,
  'mem_7:10:25000:41': 19.2,
  'mem_7:10:25000:42': 19.2,
  'mem_7:10:25000:43': 19.2,
  'mem_7:10:25000:44': 19.2,
  'mem_7:10:25000:45': 19.2,
  'mem_7:10:25000:46': 28.8,
  'mem_7:10:25000:47': 28.8,
  'mem_7:10:25000:48': 28.8,
  'mem_7:10:25000:49': 28.8,
  'mem_7:10:25000:50': 28.8,
  'mem_7:10:25000:51': 42,
  'mem_7:10:25000:52': 42,
  'mem_7:10:25000:53': 42,
  'mem_7:10:25000:54': 42,
  'mem_7:10:25000:55': 42,
  'mem_7:10:25000:56': 45.6,
  'mem_7:10:25000:57': 45.6,
  'mem_7:10:25000:58': 45.6,
  'mem_7:10:25000:59': 45.6,
  'mem_7:10:25000:60': 45.6,
  'mem_7:10:25000:61': 49.2,
  'mem_7:10:25000:62': 49.2,
  'mem_7:10:25000:63': 49.2,
  'mem_7:10:25000:64': 49.2,
  'mem_7:10:25000:65': 49.2,
  'mem_7:10:25000:66': 69.6,
  'mem_7:10:25000:67': 69.6,
  'mem_7:10:25000:68': 69.6,
  'mem_7:10:25000:69': 69.6,
  'mem_7:10:25000:70': 69.6,
  'mem_7:10:25000:71': 93.6,
  'mem_7:10:25000:72': 93.6,
  'mem_7:10:25000:73': 93.6,
  'mem_7:10:25000:74': 93.6,
  'mem_7:10:25000:75': 93.6,
  'mem_7:10:25000:76': 123.6,
  'mem_7:10:25000:77': 123.6,
  'mem_7:10:25000:78': 123.6,
  'mem_7:10:25000:79': 123.6,
  'mem_7:10:25000:80': 123.6,
  'mem_7:10:25000:81': 169.58,
  'mem_7:10:25000:82': 169.58,
  'mem_7:10:25000:83': 169.58,
  'mem_7:10:25000:84': 169.58,
  'mem_7:10:25000:85': 169.58,
  'mem_7:10:25000:86': 226.9,
  'mem_7:10:25000:87': 226.9,
  'mem_7:10:25000:88': 226.9,
  'mem_7:10:25000:89': 226.9,
  'mem_7:10:25000:90': 226.9,
  'mem_7:10:25000:91': 306.13,
  'mem_7:10:25000:92': 306.13,
  'mem_7:10:25000:93': 306.13,
  'mem_7:10:25000:94': 306.13,
  'mem_7:10:25000:95': 306.13,
  'mem_7:10:25000:96': 496.82,
  'mem_7:10:25000:97': 496.82,
  'mem_7:10:25000:98': 496.82,
  'mem_7:10:25000:99': 496.82,
  'mem_7:10:25000:100': 496.82,
  'mem_7:10:25000:101': 864.01,
  'mem_7:10:25000:102': 864.01,
  'mem_7:10:25000:103': 864.01,
  'mem_7:10:25000:104': 864.01,
  'mem_7:10:25000:105': 864.01,
  'mem_7:10:25000:106': 1087.48,
  'mem_7:10:25000:107': 1087.48,
  'mem_7:10:25000:108': 1087.48,
  'mem_7:10:25000:109': 1087.48,
  'mem_7:10:25000:110': 1087.48,
  'mem_7:10:25000:111': 1087.48,
  'mem_7:10:25000:112': 1087.48,
  'mem_7:10:25000:113': 1087.48,
  'mem_7:10:25000:114': 1087.48,
  'mem_7:10:25000:115': 1087.48,
  'mem_7:10:25000:116': 1087.48,
  'mem_7:10:25000:117': 1087.48,
  'mem_7:10:25000:118': 1087.48,
  'mem_7:10:25000:119': 1087.48,
  'mem_7:10:25000:120': 1087.48,
  'mem_7:10:30000:1': 4.8,
  'mem_7:10:30000:2': 4.8,
  'mem_7:10:30000:3': 4.8,
  'mem_7:10:30000:4': 4.8,
  'mem_7:10:30000:5': 4.8,
  'mem_7:10:30000:6': 4.8,
  'mem_7:10:30000:7': 4.8,
  'mem_7:10:30000:8': 4.8,
  'mem_7:10:30000:9': 4.8,
  'mem_7:10:30000:10': 4.8,
  'mem_7:10:30000:11': 4.8,
  'mem_7:10:30000:12': 4.8,
  'mem_7:10:30000:13': 4.8,
  'mem_7:10:30000:14': 4.8,
  'mem_7:10:30000:15': 4.8,
  'mem_7:10:30000:16': 6,
  'mem_7:10:30000:17': 6,
  'mem_7:10:30000:18': 6,
  'mem_7:10:30000:19': 6,
  'mem_7:10:30000:20': 6,
  'mem_7:10:30000:21': 6,
  'mem_7:10:30000:22': 6,
  'mem_7:10:30000:23': 6,
  'mem_7:10:30000:24': 6,
  'mem_7:10:30000:25': 6,
  'mem_7:10:30000:26': 7.2,
  'mem_7:10:30000:27': 7.2,
  'mem_7:10:30000:28': 7.2,
  'mem_7:10:30000:29': 7.2,
  'mem_7:10:30000:30': 7.2,
  'mem_7:10:30000:31': 9.6,
  'mem_7:10:30000:32': 9.6,
  'mem_7:10:30000:33': 9.6,
  'mem_7:10:30000:34': 9.6,
  'mem_7:10:30000:35': 9.6,
  'mem_7:10:30000:36': 14.4,
  'mem_7:10:30000:37': 14.4,
  'mem_7:10:30000:38': 14.4,
  'mem_7:10:30000:39': 14.4,
  'mem_7:10:30000:40': 14.4,
  'mem_7:10:30000:41': 22.8,
  'mem_7:10:30000:42': 22.8,
  'mem_7:10:30000:43': 22.8,
  'mem_7:10:30000:44': 22.8,
  'mem_7:10:30000:45': 22.8,
  'mem_7:10:30000:46': 33.6,
  'mem_7:10:30000:47': 33.6,
  'mem_7:10:30000:48': 33.6,
  'mem_7:10:30000:49': 33.6,
  'mem_7:10:30000:50': 33.6,
  'mem_7:10:30000:51': 50.4,
  'mem_7:10:30000:52': 50.4,
  'mem_7:10:30000:53': 50.4,
  'mem_7:10:30000:54': 50.4,
  'mem_7:10:30000:55': 50.4,
  'mem_7:10:30000:56': 54,
  'mem_7:10:30000:57': 54,
  'mem_7:10:30000:58': 54,
  'mem_7:10:30000:59': 54,
  'mem_7:10:30000:60': 54,
  'mem_7:10:30000:61': 58.8,
  'mem_7:10:30000:62': 58.8,
  'mem_7:10:30000:63': 58.8,
  'mem_7:10:30000:64': 58.8,
  'mem_7:10:30000:65': 58.8,
  'mem_7:10:30000:66': 82.8,
  'mem_7:10:30000:67': 82.8,
  'mem_7:10:30000:68': 82.8,
  'mem_7:10:30000:69': 82.8,
  'mem_7:10:30000:70': 82.8,
  'mem_7:10:30000:71': 111.6,
  'mem_7:10:30000:72': 111.6,
  'mem_7:10:30000:73': 111.6,
  'mem_7:10:30000:74': 111.6,
  'mem_7:10:30000:75': 111.6,
  'mem_7:10:30000:76': 147.6,
  'mem_7:10:30000:77': 147.6,
  'mem_7:10:30000:78': 147.6,
  'mem_7:10:30000:79': 147.6,
  'mem_7:10:30000:80': 147.6,
  'mem_7:10:30000:81': 203.3,
  'mem_7:10:30000:82': 203.3,
  'mem_7:10:30000:83': 203.3,
  'mem_7:10:30000:84': 203.3,
  'mem_7:10:30000:85': 203.3,
  'mem_7:10:30000:86': 272.02,
  'mem_7:10:30000:87': 272.02,
  'mem_7:10:30000:88': 272.02,
  'mem_7:10:30000:89': 272.02,
  'mem_7:10:30000:90': 272.02,
  'mem_7:10:30000:91': 367.03,
  'mem_7:10:30000:92': 367.03,
  'mem_7:10:30000:93': 367.03,
  'mem_7:10:30000:94': 367.03,
  'mem_7:10:30000:95': 367.03,
  'mem_7:10:30000:96': 595.67,
  'mem_7:10:30000:97': 595.67,
  'mem_7:10:30000:98': 595.67,
  'mem_7:10:30000:99': 595.67,
  'mem_7:10:30000:100': 595.67,
  'mem_7:10:30000:101': 1037.44,
  'mem_7:10:30000:102': 1037.44,
  'mem_7:10:30000:103': 1037.44,
  'mem_7:10:30000:104': 1037.44,
  'mem_7:10:30000:105': 1037.44,
  'mem_7:10:30000:106': 1306.89,
  'mem_7:10:30000:107': 1306.89,
  'mem_7:10:30000:108': 1306.89,
  'mem_7:10:30000:109': 1306.89,
  'mem_7:10:30000:110': 1306.89,
  'mem_7:10:30000:111': 1306.89,
  'mem_7:10:30000:112': 1306.89,
  'mem_7:10:30000:113': 1306.89,
  'mem_7:10:30000:114': 1306.89,
  'mem_7:10:30000:115': 1306.89,
  'mem_7:10:30000:116': 1306.89,
  'mem_7:10:30000:117': 1306.89,
  'mem_7:10:30000:118': 1306.89,
  'mem_7:10:30000:119': 1306.89,
  'mem_7:10:30000:120': 1306.89,
  'mem_7:10:40000:1': 6,
  'mem_7:10:40000:2': 6,
  'mem_7:10:40000:3': 6,
  'mem_7:10:40000:4': 6,
  'mem_7:10:40000:5': 6,
  'mem_7:10:40000:6': 7.2,
  'mem_7:10:40000:7': 7.2,
  'mem_7:10:40000:8': 7.2,
  'mem_7:10:40000:9': 7.2,
  'mem_7:10:40000:10': 7.2,
  'mem_7:10:40000:11': 7.2,
  'mem_7:10:40000:12': 7.2,
  'mem_7:10:40000:13': 7.2,
  'mem_7:10:40000:14': 7.2,
  'mem_7:10:40000:15': 7.2,
  'mem_7:10:40000:16': 7.2,
  'mem_7:10:40000:17': 7.2,
  'mem_7:10:40000:18': 7.2,
  'mem_7:10:40000:19': 7.2,
  'mem_7:10:40000:20': 7.2,
  'mem_7:10:40000:21': 8.4,
  'mem_7:10:40000:22': 8.4,
  'mem_7:10:40000:23': 8.4,
  'mem_7:10:40000:24': 8.4,
  'mem_7:10:40000:25': 8.4,
  'mem_7:10:40000:26': 9.6,
  'mem_7:10:40000:27': 9.6,
  'mem_7:10:40000:28': 9.6,
  'mem_7:10:40000:29': 9.6,
  'mem_7:10:40000:30': 9.6,
  'mem_7:10:40000:31': 13.2,
  'mem_7:10:40000:32': 13.2,
  'mem_7:10:40000:33': 13.2,
  'mem_7:10:40000:34': 13.2,
  'mem_7:10:40000:35': 13.2,
  'mem_7:10:40000:36': 19.2,
  'mem_7:10:40000:37': 19.2,
  'mem_7:10:40000:38': 19.2,
  'mem_7:10:40000:39': 19.2,
  'mem_7:10:40000:40': 19.2,
  'mem_7:10:40000:41': 30,
  'mem_7:10:40000:42': 30,
  'mem_7:10:40000:43': 30,
  'mem_7:10:40000:44': 30,
  'mem_7:10:40000:45': 30,
  'mem_7:10:40000:46': 44.4,
  'mem_7:10:40000:47': 44.4,
  'mem_7:10:40000:48': 44.4,
  'mem_7:10:40000:49': 44.4,
  'mem_7:10:40000:50': 44.4,
  'mem_7:10:40000:51': 67.2,
  'mem_7:10:40000:52': 67.2,
  'mem_7:10:40000:53': 67.2,
  'mem_7:10:40000:54': 67.2,
  'mem_7:10:40000:55': 67.2,
  'mem_7:10:40000:56': 72,
  'mem_7:10:40000:57': 72,
  'mem_7:10:40000:58': 72,
  'mem_7:10:40000:59': 72,
  'mem_7:10:40000:60': 72,
  'mem_7:10:40000:61': 78,
  'mem_7:10:40000:62': 78,
  'mem_7:10:40000:63': 78,
  'mem_7:10:40000:64': 78,
  'mem_7:10:40000:65': 78,
  'mem_7:10:40000:66': 110.4,
  'mem_7:10:40000:67': 110.4,
  'mem_7:10:40000:68': 110.4,
  'mem_7:10:40000:69': 110.4,
  'mem_7:10:40000:70': 110.4,
  'mem_7:10:40000:71': 148.8,
  'mem_7:10:40000:72': 148.8,
  'mem_7:10:40000:73': 148.8,
  'mem_7:10:40000:74': 148.8,
  'mem_7:10:40000:75': 148.8,
  'mem_7:10:40000:76': 196.8,
  'mem_7:10:40000:77': 196.8,
  'mem_7:10:40000:78': 196.8,
  'mem_7:10:40000:79': 196.8,
  'mem_7:10:40000:80': 196.8,
  'mem_7:10:40000:81': 271.25,
  'mem_7:10:40000:82': 271.25,
  'mem_7:10:40000:83': 271.25,
  'mem_7:10:40000:84': 271.25,
  'mem_7:10:40000:85': 271.25,
  'mem_7:10:40000:86': 362.93,
  'mem_7:10:40000:87': 362.93,
  'mem_7:10:40000:88': 362.93,
  'mem_7:10:40000:89': 362.93,
  'mem_7:10:40000:90': 362.93,
  'mem_7:10:40000:91': 489.69,
  'mem_7:10:40000:92': 489.69,
  'mem_7:10:40000:93': 489.69,
  'mem_7:10:40000:94': 489.69,
  'mem_7:10:40000:95': 489.69,
  'mem_7:10:40000:96': 794.72,
  'mem_7:10:40000:97': 794.72,
  'mem_7:10:40000:98': 794.72,
  'mem_7:10:40000:99': 794.72,
  'mem_7:10:40000:100': 794.72,
  'mem_7:10:40000:101': 1384.16,
  'mem_7:10:40000:102': 1384.16,
  'mem_7:10:40000:103': 1384.16,
  'mem_7:10:40000:104': 1384.16,
  'mem_7:10:40000:105': 1384.16,
  'mem_7:10:40000:106': 1743.7,
  'mem_7:10:40000:107': 1743.7,
  'mem_7:10:40000:108': 1743.7,
  'mem_7:10:40000:109': 1743.7,
  'mem_7:10:40000:110': 1743.7,
  'mem_7:10:40000:111': 1743.7,
  'mem_7:10:40000:112': 1743.7,
  'mem_7:10:40000:113': 1743.7,
  'mem_7:10:40000:114': 1743.7,
  'mem_7:10:40000:115': 1743.7,
  'mem_7:10:40000:116': 1743.7,
  'mem_7:10:40000:117': 1743.7,
  'mem_7:10:40000:118': 1743.7,
  'mem_7:10:40000:119': 1743.7,
  'mem_7:10:40000:120': 1743.7,
  'mem_7:10:50000:1': 8.4,
  'mem_7:10:50000:2': 8.4,
  'mem_7:10:50000:3': 8.4,
  'mem_7:10:50000:4': 8.4,
  'mem_7:10:50000:5': 8.4,
  'mem_7:10:50000:6': 8.4,
  'mem_7:10:50000:7': 8.4,
  'mem_7:10:50000:8': 8.4,
  'mem_7:10:50000:9': 8.4,
  'mem_7:10:50000:10': 8.4,
  'mem_7:10:50000:11': 8.4,
  'mem_7:10:50000:12': 8.4,
  'mem_7:10:50000:13': 8.4,
  'mem_7:10:50000:14': 8.4,
  'mem_7:10:50000:15': 8.4,
  'mem_7:10:50000:16': 8.4,
  'mem_7:10:50000:17': 8.4,
  'mem_7:10:50000:18': 8.4,
  'mem_7:10:50000:19': 8.4,
  'mem_7:10:50000:20': 8.4,
  'mem_7:10:50000:21': 9.6,
  'mem_7:10:50000:22': 9.6,
  'mem_7:10:50000:23': 9.6,
  'mem_7:10:50000:24': 9.6,
  'mem_7:10:50000:25': 9.6,
  'mem_7:10:50000:26': 12,
  'mem_7:10:50000:27': 12,
  'mem_7:10:50000:28': 12,
  'mem_7:10:50000:29': 12,
  'mem_7:10:50000:30': 12,
  'mem_7:10:50000:31': 15.6,
  'mem_7:10:50000:32': 15.6,
  'mem_7:10:50000:33': 15.6,
  'mem_7:10:50000:34': 15.6,
  'mem_7:10:50000:35': 15.6,
  'mem_7:10:50000:36': 24,
  'mem_7:10:50000:37': 24,
  'mem_7:10:50000:38': 24,
  'mem_7:10:50000:39': 24,
  'mem_7:10:50000:40': 24,
  'mem_7:10:50000:41': 37.2,
  'mem_7:10:50000:42': 37.2,
  'mem_7:10:50000:43': 37.2,
  'mem_7:10:50000:44': 37.2,
  'mem_7:10:50000:45': 37.2,
  'mem_7:10:50000:46': 56.4,
  'mem_7:10:50000:47': 56.4,
  'mem_7:10:50000:48': 56.4,
  'mem_7:10:50000:49': 56.4,
  'mem_7:10:50000:50': 56.4,
  'mem_7:10:50000:51': 84,
  'mem_7:10:50000:52': 84,
  'mem_7:10:50000:53': 84,
  'mem_7:10:50000:54': 84,
  'mem_7:10:50000:55': 84,
  'mem_7:10:50000:56': 90,
  'mem_7:10:50000:57': 90,
  'mem_7:10:50000:58': 90,
  'mem_7:10:50000:59': 90,
  'mem_7:10:50000:60': 90,
  'mem_7:10:50000:61': 97.2,
  'mem_7:10:50000:62': 97.2,
  'mem_7:10:50000:63': 97.2,
  'mem_7:10:50000:64': 97.2,
  'mem_7:10:50000:65': 97.2,
  'mem_7:10:50000:66': 138,
  'mem_7:10:50000:67': 138,
  'mem_7:10:50000:68': 138,
  'mem_7:10:50000:69': 138,
  'mem_7:10:50000:70': 138,
  'mem_7:10:50000:71': 186,
  'mem_7:10:50000:72': 186,
  'mem_7:10:50000:73': 186,
  'mem_7:10:50000:74': 186,
  'mem_7:10:50000:75': 186,
  'mem_7:10:50000:76': 246,
  'mem_7:10:50000:77': 246,
  'mem_7:10:50000:78': 246,
  'mem_7:10:50000:79': 246,
  'mem_7:10:50000:80': 246,
  'mem_7:10:50000:81': 339.16,
  'mem_7:10:50000:82': 339.16,
  'mem_7:10:50000:83': 339.16,
  'mem_7:10:50000:84': 339.16,
  'mem_7:10:50000:85': 339.16,
  'mem_7:10:50000:86': 453.79,
  'mem_7:10:50000:87': 453.79,
  'mem_7:10:50000:88': 453.79,
  'mem_7:10:50000:89': 453.79,
  'mem_7:10:50000:90': 453.79,
  'mem_7:10:50000:91': 612.27,
  'mem_7:10:50000:92': 612.27,
  'mem_7:10:50000:93': 612.27,
  'mem_7:10:50000:94': 612.27,
  'mem_7:10:50000:95': 612.27,
  'mem_7:10:50000:96': 993.64,
  'mem_7:10:50000:97': 993.64,
  'mem_7:10:50000:98': 993.64,
  'mem_7:10:50000:99': 993.64,
  'mem_7:10:50000:100': 993.64,
  'mem_7:10:50000:101': 1728.03,
  'mem_7:10:50000:102': 1728.03,
  'mem_7:10:50000:103': 1728.03,
  'mem_7:10:50000:104': 1728.03,
  'mem_7:10:50000:105': 1728.03,
  'mem_7:10:50000:106': 2174.96,
  'mem_7:10:50000:107': 2174.96,
  'mem_7:10:50000:108': 2174.96,
  'mem_7:10:50000:109': 2174.96,
  'mem_7:10:50000:110': 2174.96,
  'mem_7:10:50000:111': 2174.96,
  'mem_7:10:50000:112': 2174.96,
  'mem_7:10:50000:113': 2174.96,
  'mem_7:10:50000:114': 2174.96,
  'mem_7:10:50000:115': 2174.96,
  'mem_7:10:50000:116': 2174.96,
  'mem_7:10:50000:117': 2174.96,
  'mem_7:10:50000:118': 2174.96,
  'mem_7:10:50000:119': 2174.96,
  'mem_7:10:50000:120': 2174.96,
  'mem_7:10:60000:1': 9.81,
  'mem_7:10:60000:2': 9.81,
  'mem_7:10:60000:3': 9.81,
  'mem_7:10:60000:4': 9.81,
  'mem_7:10:60000:5': 9.81,
  'mem_7:10:60000:6': 9.8,
  'mem_7:10:60000:7': 9.8,
  'mem_7:10:60000:8': 9.8,
  'mem_7:10:60000:9': 9.8,
  'mem_7:10:60000:10': 9.8,
  'mem_7:10:60000:11': 9.8,
  'mem_7:10:60000:12': 9.8,
  'mem_7:10:60000:13': 9.8,
  'mem_7:10:60000:14': 9.8,
  'mem_7:10:60000:15': 9.8,
  'mem_7:10:60000:16': 9.84,
  'mem_7:10:60000:17': 9.84,
  'mem_7:10:60000:18': 9.84,
  'mem_7:10:60000:19': 9.84,
  'mem_7:10:60000:20': 9.84,
  'mem_7:10:60000:21': 11,
  'mem_7:10:60000:22': 11,
  'mem_7:10:60000:23': 11,
  'mem_7:10:60000:24': 11,
  'mem_7:10:60000:25': 11,
  'mem_7:10:60000:26': 13.39,
  'mem_7:10:60000:27': 13.39,
  'mem_7:10:60000:28': 13.39,
  'mem_7:10:60000:29': 13.39,
  'mem_7:10:60000:30': 13.39,
  'mem_7:10:60000:31': 17.25,
  'mem_7:10:60000:32': 17.25,
  'mem_7:10:60000:33': 17.25,
  'mem_7:10:60000:34': 17.25,
  'mem_7:10:60000:35': 17.25,
  'mem_7:10:60000:36': 26.08,
  'mem_7:10:60000:37': 26.08,
  'mem_7:10:60000:38': 26.08,
  'mem_7:10:60000:39': 26.08,
  'mem_7:10:60000:40': 26.08,
  'mem_7:10:60000:41': 40.39,
  'mem_7:10:60000:42': 40.39,
  'mem_7:10:60000:43': 40.39,
  'mem_7:10:60000:44': 40.39,
  'mem_7:10:60000:45': 40.39,
  'mem_7:10:60000:46': 61.32,
  'mem_7:10:60000:47': 61.32,
  'mem_7:10:60000:48': 61.32,
  'mem_7:10:60000:49': 61.32,
  'mem_7:10:60000:50': 61.32,
  'mem_7:10:60000:51': 91.43,
  'mem_7:10:60000:52': 91.43,
  'mem_7:10:60000:53': 91.43,
  'mem_7:10:60000:54': 91.43,
  'mem_7:10:60000:55': 91.43,
  'mem_7:10:60000:56': 104.47,
  'mem_7:10:60000:57': 104.47,
  'mem_7:10:60000:58': 104.47,
  'mem_7:10:60000:59': 104.47,
  'mem_7:10:60000:60': 104.47,
  'mem_7:10:60000:61': 121.64,
  'mem_7:10:60000:62': 121.64,
  'mem_7:10:60000:63': 121.64,
  'mem_7:10:60000:64': 121.64,
  'mem_7:10:60000:65': 121.64,
  'mem_7:10:60000:66': 173.14,
  'mem_7:10:60000:67': 173.14,
  'mem_7:10:60000:68': 173.14,
  'mem_7:10:60000:69': 173.14,
  'mem_7:10:60000:70': 173.14,
  'mem_7:10:60000:71': 230.48,
  'mem_7:10:60000:72': 230.48,
  'mem_7:10:60000:73': 230.48,
  'mem_7:10:60000:74': 230.48,
  'mem_7:10:60000:75': 230.48,
  'mem_7:10:60000:76': 307.5,
  'mem_7:10:60000:77': 307.5,
  'mem_7:10:60000:78': 307.5,
  'mem_7:10:60000:79': 307.5,
  'mem_7:10:60000:80': 307.5,
  'mem_7:10:60000:81': 426.33,
  'mem_7:10:60000:82': 426.33,
  'mem_7:10:60000:83': 426.33,
  'mem_7:10:60000:84': 426.33,
  'mem_7:10:60000:85': 426.33,
  'mem_7:10:60000:86': 570.42,
  'mem_7:10:60000:87': 570.42,
  'mem_7:10:60000:88': 570.42,
  'mem_7:10:60000:89': 570.42,
  'mem_7:10:60000:90': 570.42,
  'mem_7:10:60000:91': 769.64,
  'mem_7:10:60000:92': 769.64,
  'mem_7:10:60000:93': 769.64,
  'mem_7:10:60000:94': 769.64,
  'mem_7:10:60000:95': 769.64,
  'mem_7:10:60000:96': 1249.04,
  'mem_7:10:60000:97': 1249.04,
  'mem_7:10:60000:98': 1249.04,
  'mem_7:10:60000:99': 1249.04,
  'mem_7:10:60000:100': 1249.04,
  'mem_7:10:60000:101': 2074.89,
  'mem_7:10:60000:102': 2074.89,
  'mem_7:10:60000:103': 2074.89,
  'mem_7:10:60000:104': 2074.89,
  'mem_7:10:60000:105': 2074.89,
  'mem_7:10:60000:106': 2613.79,
  'mem_7:10:60000:107': 2613.79,
  'mem_7:10:60000:108': 2613.79,
  'mem_7:10:60000:109': 2613.79,
  'mem_7:10:60000:110': 2613.79,
  'mem_7:10:60000:111': 2613.79,
  'mem_7:10:60000:112': 2613.79,
  'mem_7:10:60000:113': 2613.79,
  'mem_7:10:60000:114': 2613.79,
  'mem_7:10:60000:115': 2613.79,
  'mem_7:10:60000:116': 2613.79,
  'mem_7:10:60000:117': 2613.79,
  'mem_7:10:60000:118': 2613.79,
  'mem_7:10:60000:119': 2613.79,
  'mem_7:10:60000:120': 2613.79,
  'mem_7:10:70000:1': 11.22,
  'mem_7:10:70000:2': 11.22,
  'mem_7:10:70000:3': 11.22,
  'mem_7:10:70000:4': 11.22,
  'mem_7:10:70000:5': 11.22,
  'mem_7:10:70000:6': 11.19,
  'mem_7:10:70000:7': 11.19,
  'mem_7:10:70000:8': 11.19,
  'mem_7:10:70000:9': 11.19,
  'mem_7:10:70000:10': 11.19,
  'mem_7:10:70000:11': 11.2,
  'mem_7:10:70000:12': 11.2,
  'mem_7:10:70000:13': 11.2,
  'mem_7:10:70000:14': 11.2,
  'mem_7:10:70000:15': 11.2,
  'mem_7:10:70000:16': 11.28,
  'mem_7:10:70000:17': 11.28,
  'mem_7:10:70000:18': 11.28,
  'mem_7:10:70000:19': 11.28,
  'mem_7:10:70000:20': 11.28,
  'mem_7:10:70000:21': 12.41,
  'mem_7:10:70000:22': 12.41,
  'mem_7:10:70000:23': 12.41,
  'mem_7:10:70000:24': 12.41,
  'mem_7:10:70000:25': 12.41,
  'mem_7:10:70000:26': 14.79,
  'mem_7:10:70000:27': 14.79,
  'mem_7:10:70000:28': 14.79,
  'mem_7:10:70000:29': 14.79,
  'mem_7:10:70000:30': 14.79,
  'mem_7:10:70000:31': 18.89,
  'mem_7:10:70000:32': 18.89,
  'mem_7:10:70000:33': 18.89,
  'mem_7:10:70000:34': 18.89,
  'mem_7:10:70000:35': 18.89,
  'mem_7:10:70000:36': 28.15,
  'mem_7:10:70000:37': 28.15,
  'mem_7:10:70000:38': 28.15,
  'mem_7:10:70000:39': 28.15,
  'mem_7:10:70000:40': 28.15,
  'mem_7:10:70000:41': 43.59,
  'mem_7:10:70000:42': 43.59,
  'mem_7:10:70000:43': 43.59,
  'mem_7:10:70000:44': 43.59,
  'mem_7:10:70000:45': 43.59,
  'mem_7:10:70000:46': 66.24,
  'mem_7:10:70000:47': 66.24,
  'mem_7:10:70000:48': 66.24,
  'mem_7:10:70000:49': 66.24,
  'mem_7:10:70000:50': 66.24,
  'mem_7:10:70000:51': 98.86,
  'mem_7:10:70000:52': 98.86,
  'mem_7:10:70000:53': 98.86,
  'mem_7:10:70000:54': 98.86,
  'mem_7:10:70000:55': 98.86,
  'mem_7:10:70000:56': 118.94,
  'mem_7:10:70000:57': 118.94,
  'mem_7:10:70000:58': 118.94,
  'mem_7:10:70000:59': 118.94,
  'mem_7:10:70000:60': 118.94,
  'mem_7:10:70000:61': 146.07,
  'mem_7:10:70000:62': 146.07,
  'mem_7:10:70000:63': 146.07,
  'mem_7:10:70000:64': 146.07,
  'mem_7:10:70000:65': 146.07,
  'mem_7:10:70000:66': 208.29,
  'mem_7:10:70000:67': 208.29,
  'mem_7:10:70000:68': 208.29,
  'mem_7:10:70000:69': 208.29,
  'mem_7:10:70000:70': 208.29,
  'mem_7:10:70000:71': 274.96,
  'mem_7:10:70000:72': 274.96,
  'mem_7:10:70000:73': 274.96,
  'mem_7:10:70000:74': 274.96,
  'mem_7:10:70000:75': 274.96,
  'mem_7:10:70000:76': 369,
  'mem_7:10:70000:77': 369,
  'mem_7:10:70000:78': 369,
  'mem_7:10:70000:79': 369,
  'mem_7:10:70000:80': 369,
  'mem_7:10:70000:81': 513.5,
  'mem_7:10:70000:82': 513.5,
  'mem_7:10:70000:83': 513.5,
  'mem_7:10:70000:84': 513.5,
  'mem_7:10:70000:85': 513.5,
  'mem_7:10:70000:86': 687.06,
  'mem_7:10:70000:87': 687.06,
  'mem_7:10:70000:88': 687.06,
  'mem_7:10:70000:89': 687.06,
  'mem_7:10:70000:90': 687.06,
  'mem_7:10:70000:91': 927,
  'mem_7:10:70000:92': 927,
  'mem_7:10:70000:93': 927,
  'mem_7:10:70000:94': 927,
  'mem_7:10:70000:95': 927,
  'mem_7:10:70000:96': 1504.43,
  'mem_7:10:70000:97': 1504.43,
  'mem_7:10:70000:98': 1504.43,
  'mem_7:10:70000:99': 1504.43,
  'mem_7:10:70000:100': 1504.43,
  'mem_7:10:70000:101': 2422.18,
  'mem_7:10:70000:102': 2422.18,
  'mem_7:10:70000:103': 2422.18,
  'mem_7:10:70000:104': 2422.18,
  'mem_7:10:70000:105': 2422.18,
  'mem_7:10:70000:106': 3051.33,
  'mem_7:10:70000:107': 3051.33,
  'mem_7:10:70000:108': 3051.33,
  'mem_7:10:70000:109': 3051.33,
  'mem_7:10:70000:110': 3051.33,
  'mem_7:10:70000:111': 3051.33,
  'mem_7:10:70000:112': 3051.33,
  'mem_7:10:70000:113': 3051.33,
  'mem_7:10:70000:114': 3051.33,
  'mem_7:10:70000:115': 3051.33,
  'mem_7:10:70000:116': 3051.33,
  'mem_7:10:70000:117': 3051.33,
  'mem_7:10:70000:118': 3051.33,
  'mem_7:10:70000:119': 3051.33,
  'mem_7:10:70000:120': 3051.33,
  'mem_7:10:80000:1': 12.62,
  'mem_7:10:80000:2': 12.62,
  'mem_7:10:80000:3': 12.62,
  'mem_7:10:80000:4': 12.62,
  'mem_7:10:80000:5': 12.62,
  'mem_7:10:80000:6': 12.59,
  'mem_7:10:80000:7': 12.59,
  'mem_7:10:80000:8': 12.59,
  'mem_7:10:80000:9': 12.59,
  'mem_7:10:80000:10': 12.59,
  'mem_7:10:80000:11': 12.61,
  'mem_7:10:80000:12': 12.61,
  'mem_7:10:80000:13': 12.61,
  'mem_7:10:80000:14': 12.61,
  'mem_7:10:80000:15': 12.61,
  'mem_7:10:80000:16': 12.72,
  'mem_7:10:80000:17': 12.72,
  'mem_7:10:80000:18': 12.72,
  'mem_7:10:80000:19': 12.72,
  'mem_7:10:80000:20': 12.72,
  'mem_7:10:80000:21': 13.81,
  'mem_7:10:80000:22': 13.81,
  'mem_7:10:80000:23': 13.81,
  'mem_7:10:80000:24': 13.81,
  'mem_7:10:80000:25': 13.81,
  'mem_7:10:80000:26': 16.18,
  'mem_7:10:80000:27': 16.18,
  'mem_7:10:80000:28': 16.18,
  'mem_7:10:80000:29': 16.18,
  'mem_7:10:80000:30': 16.18,
  'mem_7:10:80000:31': 20.54,
  'mem_7:10:80000:32': 20.54,
  'mem_7:10:80000:33': 20.54,
  'mem_7:10:80000:34': 20.54,
  'mem_7:10:80000:35': 20.54,
  'mem_7:10:80000:36': 30.23,
  'mem_7:10:80000:37': 30.23,
  'mem_7:10:80000:38': 30.23,
  'mem_7:10:80000:39': 30.23,
  'mem_7:10:80000:40': 30.23,
  'mem_7:10:80000:41': 46.78,
  'mem_7:10:80000:42': 46.78,
  'mem_7:10:80000:43': 46.78,
  'mem_7:10:80000:44': 46.78,
  'mem_7:10:80000:45': 46.78,
  'mem_7:10:80000:46': 71.17,
  'mem_7:10:80000:47': 71.17,
  'mem_7:10:80000:48': 71.17,
  'mem_7:10:80000:49': 71.17,
  'mem_7:10:80000:50': 71.17,
  'mem_7:10:80000:51': 106.29,
  'mem_7:10:80000:52': 106.29,
  'mem_7:10:80000:53': 106.29,
  'mem_7:10:80000:54': 106.29,
  'mem_7:10:80000:55': 106.29,
  'mem_7:10:80000:56': 133.41,
  'mem_7:10:80000:57': 133.41,
  'mem_7:10:80000:58': 133.41,
  'mem_7:10:80000:59': 133.41,
  'mem_7:10:80000:60': 133.41,
  'mem_7:10:80000:61': 170.51,
  'mem_7:10:80000:62': 170.51,
  'mem_7:10:80000:63': 170.51,
  'mem_7:10:80000:64': 170.51,
  'mem_7:10:80000:65': 170.51,
  'mem_7:10:80000:66': 243.43,
  'mem_7:10:80000:67': 243.43,
  'mem_7:10:80000:68': 243.43,
  'mem_7:10:80000:69': 243.43,
  'mem_7:10:80000:70': 243.43,
  'mem_7:10:80000:71': 319.44,
  'mem_7:10:80000:72': 319.44,
  'mem_7:10:80000:73': 319.44,
  'mem_7:10:80000:74': 319.44,
  'mem_7:10:80000:75': 319.44,
  'mem_7:10:80000:76': 430.5,
  'mem_7:10:80000:77': 430.5,
  'mem_7:10:80000:78': 430.5,
  'mem_7:10:80000:79': 430.5,
  'mem_7:10:80000:80': 430.5,
  'mem_7:10:80000:81': 600.67,
  'mem_7:10:80000:82': 600.67,
  'mem_7:10:80000:83': 600.67,
  'mem_7:10:80000:84': 600.67,
  'mem_7:10:80000:85': 600.67,
  'mem_7:10:80000:86': 803.69,
  'mem_7:10:80000:87': 803.69,
  'mem_7:10:80000:88': 803.69,
  'mem_7:10:80000:89': 803.69,
  'mem_7:10:80000:90': 803.69,
  'mem_7:10:80000:91': 1084.37,
  'mem_7:10:80000:92': 1084.37,
  'mem_7:10:80000:93': 1084.37,
  'mem_7:10:80000:94': 1084.37,
  'mem_7:10:80000:95': 1084.37,
  'mem_7:10:80000:96': 1759.82,
  'mem_7:10:80000:97': 1759.82,
  'mem_7:10:80000:98': 1759.82,
  'mem_7:10:80000:99': 1759.82,
  'mem_7:10:80000:100': 1759.82,
  'mem_7:10:80000:101': 2768.85,
  'mem_7:10:80000:102': 2768.85,
  'mem_7:10:80000:103': 2768.85,
  'mem_7:10:80000:104': 2768.85,
  'mem_7:10:80000:105': 2768.85,
  'mem_7:10:80000:106': 3488.05,
  'mem_7:10:80000:107': 3488.05,
  'mem_7:10:80000:108': 3488.05,
  'mem_7:10:80000:109': 3488.05,
  'mem_7:10:80000:110': 3488.05,
  'mem_7:10:80000:111': 3488.05,
  'mem_7:10:80000:112': 3488.05,
  'mem_7:10:80000:113': 3488.05,
  'mem_7:10:80000:114': 3488.05,
  'mem_7:10:80000:115': 3488.05,
  'mem_7:10:80000:116': 3488.05,
  'mem_7:10:80000:117': 3488.05,
  'mem_7:10:80000:118': 3488.05,
  'mem_7:10:80000:119': 3488.05,
  'mem_7:10:80000:120': 3488.05,
  'mem_7:10:90000:1': 14.03,
  'mem_7:10:90000:2': 14.03,
  'mem_7:10:90000:3': 14.03,
  'mem_7:10:90000:4': 14.03,
  'mem_7:10:90000:5': 14.03,
  'mem_7:10:90000:6': 13.99,
  'mem_7:10:90000:7': 13.99,
  'mem_7:10:90000:8': 13.99,
  'mem_7:10:90000:9': 13.99,
  'mem_7:10:90000:10': 13.99,
  'mem_7:10:90000:11': 14.01,
  'mem_7:10:90000:12': 14.01,
  'mem_7:10:90000:13': 14.01,
  'mem_7:10:90000:14': 14.01,
  'mem_7:10:90000:15': 14.01,
  'mem_7:10:90000:16': 14.16,
  'mem_7:10:90000:17': 14.16,
  'mem_7:10:90000:18': 14.16,
  'mem_7:10:90000:19': 14.16,
  'mem_7:10:90000:20': 14.16,
  'mem_7:10:90000:21': 15.21,
  'mem_7:10:90000:22': 15.21,
  'mem_7:10:90000:23': 15.21,
  'mem_7:10:90000:24': 15.21,
  'mem_7:10:90000:25': 15.21,
  'mem_7:10:90000:26': 17.57,
  'mem_7:10:90000:27': 17.57,
  'mem_7:10:90000:28': 17.57,
  'mem_7:10:90000:29': 17.57,
  'mem_7:10:90000:30': 17.57,
  'mem_7:10:90000:31': 22.18,
  'mem_7:10:90000:32': 22.18,
  'mem_7:10:90000:33': 22.18,
  'mem_7:10:90000:34': 22.18,
  'mem_7:10:90000:35': 22.18,
  'mem_7:10:90000:36': 32.3,
  'mem_7:10:90000:37': 32.3,
  'mem_7:10:90000:38': 32.3,
  'mem_7:10:90000:39': 32.3,
  'mem_7:10:90000:40': 32.3,
  'mem_7:10:90000:41': 49.97,
  'mem_7:10:90000:42': 49.97,
  'mem_7:10:90000:43': 49.97,
  'mem_7:10:90000:44': 49.97,
  'mem_7:10:90000:45': 49.97,
  'mem_7:10:90000:46': 76.09,
  'mem_7:10:90000:47': 76.09,
  'mem_7:10:90000:48': 76.09,
  'mem_7:10:90000:49': 76.09,
  'mem_7:10:90000:50': 76.09,
  'mem_7:10:90000:51': 113.71,
  'mem_7:10:90000:52': 113.71,
  'mem_7:10:90000:53': 113.71,
  'mem_7:10:90000:54': 113.71,
  'mem_7:10:90000:55': 113.71,
  'mem_7:10:90000:56': 147.88,
  'mem_7:10:90000:57': 147.88,
  'mem_7:10:90000:58': 147.88,
  'mem_7:10:90000:59': 147.88,
  'mem_7:10:90000:60': 147.88,
  'mem_7:10:90000:61': 194.94,
  'mem_7:10:90000:62': 194.94,
  'mem_7:10:90000:63': 194.94,
  'mem_7:10:90000:64': 194.94,
  'mem_7:10:90000:65': 194.94,
  'mem_7:10:90000:66': 278.57,
  'mem_7:10:90000:67': 278.57,
  'mem_7:10:90000:68': 278.57,
  'mem_7:10:90000:69': 278.57,
  'mem_7:10:90000:70': 278.57,
  'mem_7:10:90000:71': 363.91,
  'mem_7:10:90000:72': 363.91,
  'mem_7:10:90000:73': 363.91,
  'mem_7:10:90000:74': 363.91,
  'mem_7:10:90000:75': 363.91,
  'mem_7:10:90000:76': 492,
  'mem_7:10:90000:77': 492,
  'mem_7:10:90000:78': 492,
  'mem_7:10:90000:79': 492,
  'mem_7:10:90000:80': 492,
  'mem_7:10:90000:81': 687.83,
  'mem_7:10:90000:82': 687.83,
  'mem_7:10:90000:83': 687.83,
  'mem_7:10:90000:84': 687.83,
  'mem_7:10:90000:85': 687.83,
  'mem_7:10:90000:86': 920.32,
  'mem_7:10:90000:87': 920.32,
  'mem_7:10:90000:88': 920.32,
  'mem_7:10:90000:89': 920.32,
  'mem_7:10:90000:90': 920.32,
  'mem_7:10:90000:91': 1241.74,
  'mem_7:10:90000:92': 1241.74,
  'mem_7:10:90000:93': 1241.74,
  'mem_7:10:90000:94': 1241.74,
  'mem_7:10:90000:95': 1241.74,
  'mem_7:10:90000:96': 2015.22,
  'mem_7:10:90000:97': 2015.22,
  'mem_7:10:90000:98': 2015.22,
  'mem_7:10:90000:99': 2015.22,
  'mem_7:10:90000:100': 2015.22,
  'mem_7:10:90000:101': 3110.97,
  'mem_7:10:90000:102': 3110.97,
  'mem_7:10:90000:103': 3110.97,
  'mem_7:10:90000:104': 3110.97,
  'mem_7:10:90000:105': 3110.97,
  'mem_7:10:90000:106': 3919.05,
  'mem_7:10:90000:107': 3919.05,
  'mem_7:10:90000:108': 3919.05,
  'mem_7:10:90000:109': 3919.05,
  'mem_7:10:90000:110': 3919.05,
  'mem_7:10:90000:111': 3919.05,
  'mem_7:10:90000:112': 3919.05,
  'mem_7:10:90000:113': 3919.05,
  'mem_7:10:90000:114': 3919.05,
  'mem_7:10:90000:115': 3919.05,
  'mem_7:10:90000:116': 3919.05,
  'mem_7:10:90000:117': 3919.05,
  'mem_7:10:90000:118': 3919.05,
  'mem_7:10:90000:119': 3919.05,
  'mem_7:10:90000:120': 3919.05,
  'mem_7:10:100000:1': 15.44,
  'mem_7:10:100000:2': 15.44,
  'mem_7:10:100000:3': 15.44,
  'mem_7:10:100000:4': 15.44,
  'mem_7:10:100000:5': 15.44,
  'mem_7:10:100000:6': 15.38,
  'mem_7:10:100000:7': 15.38,
  'mem_7:10:100000:8': 15.38,
  'mem_7:10:100000:9': 15.38,
  'mem_7:10:100000:10': 15.38,
  'mem_7:10:100000:11': 15.41,
  'mem_7:10:100000:12': 15.41,
  'mem_7:10:100000:13': 15.41,
  'mem_7:10:100000:14': 15.41,
  'mem_7:10:100000:15': 15.41,
  'mem_7:10:100000:16': 15.61,
  'mem_7:10:100000:17': 15.61,
  'mem_7:10:100000:18': 15.61,
  'mem_7:10:100000:19': 15.61,
  'mem_7:10:100000:20': 15.61,
  'mem_7:10:100000:21': 16.61,
  'mem_7:10:100000:22': 16.61,
  'mem_7:10:100000:23': 16.61,
  'mem_7:10:100000:24': 16.61,
  'mem_7:10:100000:25': 16.61,
  'mem_7:10:100000:26': 18.97,
  'mem_7:10:100000:27': 18.97,
  'mem_7:10:100000:28': 18.97,
  'mem_7:10:100000:29': 18.97,
  'mem_7:10:100000:30': 18.97,
  'mem_7:10:100000:31': 23.83,
  'mem_7:10:100000:32': 23.83,
  'mem_7:10:100000:33': 23.83,
  'mem_7:10:100000:34': 23.83,
  'mem_7:10:100000:35': 23.83,
  'mem_7:10:100000:36': 34.38,
  'mem_7:10:100000:37': 34.38,
  'mem_7:10:100000:38': 34.38,
  'mem_7:10:100000:39': 34.38,
  'mem_7:10:100000:40': 34.38,
  'mem_7:10:100000:41': 53.16,
  'mem_7:10:100000:42': 53.16,
  'mem_7:10:100000:43': 53.16,
  'mem_7:10:100000:44': 53.16,
  'mem_7:10:100000:45': 53.16,
  'mem_7:10:100000:46': 81.01,
  'mem_7:10:100000:47': 81.01,
  'mem_7:10:100000:48': 81.01,
  'mem_7:10:100000:49': 81.01,
  'mem_7:10:100000:50': 81.01,
  'mem_7:10:100000:51': 121.14,
  'mem_7:10:100000:52': 121.14,
  'mem_7:10:100000:53': 121.14,
  'mem_7:10:100000:54': 121.14,
  'mem_7:10:100000:55': 121.14,
  'mem_7:10:100000:56': 162.35,
  'mem_7:10:100000:57': 162.35,
  'mem_7:10:100000:58': 162.35,
  'mem_7:10:100000:59': 162.35,
  'mem_7:10:100000:60': 162.35,
  'mem_7:10:100000:61': 219.38,
  'mem_7:10:100000:62': 219.38,
  'mem_7:10:100000:63': 219.38,
  'mem_7:10:100000:64': 219.38,
  'mem_7:10:100000:65': 219.38,
  'mem_7:10:100000:66': 313.71,
  'mem_7:10:100000:67': 313.71,
  'mem_7:10:100000:68': 313.71,
  'mem_7:10:100000:69': 313.71,
  'mem_7:10:100000:70': 313.71,
  'mem_7:10:100000:71': 408.39,
  'mem_7:10:100000:72': 408.39,
  'mem_7:10:100000:73': 408.39,
  'mem_7:10:100000:74': 408.39,
  'mem_7:10:100000:75': 408.39,
  'mem_7:10:100000:76': 553.5,
  'mem_7:10:100000:77': 553.5,
  'mem_7:10:100000:78': 553.5,
  'mem_7:10:100000:79': 553.5,
  'mem_7:10:100000:80': 553.5,
  'mem_7:10:100000:81': 775,
  'mem_7:10:100000:82': 775,
  'mem_7:10:100000:83': 775,
  'mem_7:10:100000:84': 775,
  'mem_7:10:100000:85': 775,
  'mem_7:10:100000:86': 1036.95,
  'mem_7:10:100000:87': 1036.95,
  'mem_7:10:100000:88': 1036.95,
  'mem_7:10:100000:89': 1036.95,
  'mem_7:10:100000:90': 1036.95,
  'mem_7:10:100000:91': 1399.11,
  'mem_7:10:100000:92': 1399.11,
  'mem_7:10:100000:93': 1399.11,
  'mem_7:10:100000:94': 1399.11,
  'mem_7:10:100000:95': 1399.11,
  'mem_7:10:100000:96': 2270.61,
  'mem_7:10:100000:97': 2270.61,
  'mem_7:10:100000:98': 2270.61,
  'mem_7:10:100000:99': 2270.61,
  'mem_7:10:100000:100': 2270.61,
  'mem_7:10:100000:101': 3458.39,
  'mem_7:10:100000:102': 3458.39,
  'mem_7:10:100000:103': 3458.39,
  'mem_7:10:100000:104': 3458.39,
  'mem_7:10:100000:105': 3458.39,
  'mem_7:10:100000:106': 4356.73,
  'mem_7:10:100000:107': 4356.73,
  'mem_7:10:100000:108': 4356.73,
  'mem_7:10:100000:109': 4356.73,
  'mem_7:10:100000:110': 4356.73,
  'mem_7:10:100000:111': 4356.73,
  'mem_7:10:100000:112': 4356.73,
  'mem_7:10:100000:113': 4356.73,
  'mem_7:10:100000:114': 4356.73,
  'mem_7:10:100000:115': 4356.73,
  'mem_7:10:100000:116': 4356.73,
  'mem_7:10:100000:117': 4356.73,
  'mem_7:10:100000:118': 4356.73,
  'mem_7:10:100000:119': 4356.73,
  'mem_7:10:100000:120': 4356.73,
  'mem_7:10:120000:1': 16.85,
  'mem_7:10:120000:2': 16.85,
  'mem_7:10:120000:3': 16.85,
  'mem_7:10:120000:4': 16.85,
  'mem_7:10:120000:5': 16.85,
  'mem_7:10:120000:6': 16.78,
  'mem_7:10:120000:7': 16.78,
  'mem_7:10:120000:8': 16.78,
  'mem_7:10:120000:9': 16.78,
  'mem_7:10:120000:10': 16.78,
  'mem_7:10:120000:11': 16.81,
  'mem_7:10:120000:12': 16.81,
  'mem_7:10:120000:13': 16.81,
  'mem_7:10:120000:14': 16.81,
  'mem_7:10:120000:15': 16.81,
  'mem_7:10:120000:16': 17.05,
  'mem_7:10:120000:17': 17.05,
  'mem_7:10:120000:18': 17.05,
  'mem_7:10:120000:19': 17.05,
  'mem_7:10:120000:20': 17.05,
  'mem_7:10:120000:21': 18.02,
  'mem_7:10:120000:22': 18.02,
  'mem_7:10:120000:23': 18.02,
  'mem_7:10:120000:24': 18.02,
  'mem_7:10:120000:25': 18.02,
  'mem_7:10:120000:26': 20.36,
  'mem_7:10:120000:27': 20.36,
  'mem_7:10:120000:28': 20.36,
  'mem_7:10:120000:29': 20.36,
  'mem_7:10:120000:30': 20.36,
  'mem_7:10:120000:31': 25.47,
  'mem_7:10:120000:32': 25.47,
  'mem_7:10:120000:33': 25.47,
  'mem_7:10:120000:34': 25.47,
  'mem_7:10:120000:35': 25.47,
  'mem_7:10:120000:36': 36.46,
  'mem_7:10:120000:37': 36.46,
  'mem_7:10:120000:38': 36.46,
  'mem_7:10:120000:39': 36.46,
  'mem_7:10:120000:40': 36.46,
  'mem_7:10:120000:41': 56.36,
  'mem_7:10:120000:42': 56.36,
  'mem_7:10:120000:43': 56.36,
  'mem_7:10:120000:44': 56.36,
  'mem_7:10:120000:45': 56.36,
  'mem_7:10:120000:46': 85.93,
  'mem_7:10:120000:47': 85.93,
  'mem_7:10:120000:48': 85.93,
  'mem_7:10:120000:49': 85.93,
  'mem_7:10:120000:50': 85.93,
  'mem_7:10:120000:51': 128.57,
  'mem_7:10:120000:52': 128.57,
  'mem_7:10:120000:53': 128.57,
  'mem_7:10:120000:54': 128.57,
  'mem_7:10:120000:55': 128.57,
  'mem_7:10:120000:56': 176.82,
  'mem_7:10:120000:57': 176.82,
  'mem_7:10:120000:58': 176.82,
  'mem_7:10:120000:59': 176.82,
  'mem_7:10:120000:60': 176.82,
  'mem_7:10:120000:61': 243.82,
  'mem_7:10:120000:62': 243.82,
  'mem_7:10:120000:63': 243.82,
  'mem_7:10:120000:64': 243.82,
  'mem_7:10:120000:65': 243.82,
  'mem_7:10:120000:66': 348.86,
  'mem_7:10:120000:67': 348.86,
  'mem_7:10:120000:68': 348.86,
  'mem_7:10:120000:69': 348.86,
  'mem_7:10:120000:70': 348.86,
  'mem_7:10:120000:71': 452.87,
  'mem_7:10:120000:72': 452.87,
  'mem_7:10:120000:73': 452.87,
  'mem_7:10:120000:74': 452.87,
  'mem_7:10:120000:75': 452.87,
  'mem_7:10:120000:76': 614.99,
  'mem_7:10:120000:77': 614.99,
  'mem_7:10:120000:78': 614.99,
  'mem_7:10:120000:79': 614.99,
  'mem_7:10:120000:80': 614.99,
  'mem_7:10:120000:81': 862.17,
  'mem_7:10:120000:82': 862.17,
  'mem_7:10:120000:83': 862.17,
  'mem_7:10:120000:84': 862.17,
  'mem_7:10:120000:85': 862.17,
  'mem_7:10:120000:86': 1153.58,
  'mem_7:10:120000:87': 1153.58,
  'mem_7:10:120000:88': 1153.58,
  'mem_7:10:120000:89': 1153.58,
  'mem_7:10:120000:90': 1153.58,
  'mem_7:10:120000:91': 1556.47,
  'mem_7:10:120000:92': 1556.47,
  'mem_7:10:120000:93': 1556.47,
  'mem_7:10:120000:94': 1556.47,
  'mem_7:10:120000:95': 1556.47,
  'mem_7:10:120000:96': 2526.01,
  'mem_7:10:120000:97': 2526.01,
  'mem_7:10:120000:98': 2526.01,
  'mem_7:10:120000:99': 2526.01,
  'mem_7:10:120000:100': 2526.01,
  'mem_7:10:120000:101': 4149.86,
  'mem_7:10:120000:102': 4149.86,
  'mem_7:10:120000:103': 4149.86,
  'mem_7:10:120000:104': 4149.86,
  'mem_7:10:120000:105': 4149.86,
  'mem_7:10:120000:106': 5227.8,
  'mem_7:10:120000:107': 5227.8,
  'mem_7:10:120000:108': 5227.8,
  'mem_7:10:120000:109': 5227.8,
  'mem_7:10:120000:110': 5227.8,
  'mem_7:10:120000:111': 5227.8,
  'mem_7:10:120000:112': 5227.8,
  'mem_7:10:120000:113': 5227.8,
  'mem_7:10:120000:114': 5227.8,
  'mem_7:10:120000:115': 5227.8,
  'mem_7:10:120000:116': 5227.8,
  'mem_7:10:120000:117': 5227.8,
  'mem_7:10:120000:118': 5227.8,
  'mem_7:10:120000:119': 5227.8,
  'mem_7:10:120000:120': 5227.8,
  'mem_7:10:140000:1': 18.26,
  'mem_7:10:140000:2': 18.26,
  'mem_7:10:140000:3': 18.26,
  'mem_7:10:140000:4': 18.26,
  'mem_7:10:140000:5': 18.26,
  'mem_7:10:140000:6': 18.17,
  'mem_7:10:140000:7': 18.17,
  'mem_7:10:140000:8': 18.17,
  'mem_7:10:140000:9': 18.17,
  'mem_7:10:140000:10': 18.17,
  'mem_7:10:140000:11': 18.21,
  'mem_7:10:140000:12': 18.21,
  'mem_7:10:140000:13': 18.21,
  'mem_7:10:140000:14': 18.21,
  'mem_7:10:140000:15': 18.21,
  'mem_7:10:140000:16': 18.49,
  'mem_7:10:140000:17': 18.49,
  'mem_7:10:140000:18': 18.49,
  'mem_7:10:140000:19': 18.49,
  'mem_7:10:140000:20': 18.49,
  'mem_7:10:140000:21': 19.42,
  'mem_7:10:140000:22': 19.42,
  'mem_7:10:140000:23': 19.42,
  'mem_7:10:140000:24': 19.42,
  'mem_7:10:140000:25': 19.42,
  'mem_7:10:140000:26': 21.75,
  'mem_7:10:140000:27': 21.75,
  'mem_7:10:140000:28': 21.75,
  'mem_7:10:140000:29': 21.75,
  'mem_7:10:140000:30': 21.75,
  'mem_7:10:140000:31': 27.12,
  'mem_7:10:140000:32': 27.12,
  'mem_7:10:140000:33': 27.12,
  'mem_7:10:140000:34': 27.12,
  'mem_7:10:140000:35': 27.12,
  'mem_7:10:140000:36': 38.53,
  'mem_7:10:140000:37': 38.53,
  'mem_7:10:140000:38': 38.53,
  'mem_7:10:140000:39': 38.53,
  'mem_7:10:140000:40': 38.53,
  'mem_7:10:140000:41': 59.55,
  'mem_7:10:140000:42': 59.55,
  'mem_7:10:140000:43': 59.55,
  'mem_7:10:140000:44': 59.55,
  'mem_7:10:140000:45': 59.55,
  'mem_7:10:140000:46': 90.86,
  'mem_7:10:140000:47': 90.86,
  'mem_7:10:140000:48': 90.86,
  'mem_7:10:140000:49': 90.86,
  'mem_7:10:140000:50': 90.86,
  'mem_7:10:140000:51': 136,
  'mem_7:10:140000:52': 136,
  'mem_7:10:140000:53': 136,
  'mem_7:10:140000:54': 136,
  'mem_7:10:140000:55': 136,
  'mem_7:10:140000:56': 191.29,
  'mem_7:10:140000:57': 191.29,
  'mem_7:10:140000:58': 191.29,
  'mem_7:10:140000:59': 191.29,
  'mem_7:10:140000:60': 191.29,
  'mem_7:10:140000:61': 268.25,
  'mem_7:10:140000:62': 268.25,
  'mem_7:10:140000:63': 268.25,
  'mem_7:10:140000:64': 268.25,
  'mem_7:10:140000:65': 268.25,
  'mem_7:10:140000:66': 384,
  'mem_7:10:140000:67': 384,
  'mem_7:10:140000:68': 384,
  'mem_7:10:140000:69': 384,
  'mem_7:10:140000:70': 384,
  'mem_7:10:140000:71': 497.35,
  'mem_7:10:140000:72': 497.35,
  'mem_7:10:140000:73': 497.35,
  'mem_7:10:140000:74': 497.35,
  'mem_7:10:140000:75': 497.35,
  'mem_7:10:140000:76': 676.49,
  'mem_7:10:140000:77': 676.49,
  'mem_7:10:140000:78': 676.49,
  'mem_7:10:140000:79': 676.49,
  'mem_7:10:140000:80': 676.49,
  'mem_7:10:140000:81': 949.34,
  'mem_7:10:140000:82': 949.34,
  'mem_7:10:140000:83': 949.34,
  'mem_7:10:140000:84': 949.34,
  'mem_7:10:140000:85': 949.34,
  'mem_7:10:140000:86': 1270.22,
  'mem_7:10:140000:87': 1270.22,
  'mem_7:10:140000:88': 1270.22,
  'mem_7:10:140000:89': 1270.22,
  'mem_7:10:140000:90': 1270.22,
  'mem_7:10:140000:91': 1713.84,
  'mem_7:10:140000:92': 1713.84,
  'mem_7:10:140000:93': 1713.84,
  'mem_7:10:140000:94': 1713.84,
  'mem_7:10:140000:95': 1713.84,
  'mem_7:10:140000:96': 2781.4,
  'mem_7:10:140000:97': 2781.4,
  'mem_7:10:140000:98': 2781.4,
  'mem_7:10:140000:99': 2781.4,
  'mem_7:10:140000:100': 2781.4,
  'mem_7:10:140000:101': 4844.36,
  'mem_7:10:140000:102': 4844.36,
  'mem_7:10:140000:103': 4844.36,
  'mem_7:10:140000:104': 4844.36,
  'mem_7:10:140000:105': 4844.36,
  'mem_7:10:140000:106': 6102.67,
  'mem_7:10:140000:107': 6102.67,
  'mem_7:10:140000:108': 6102.67,
  'mem_7:10:140000:109': 6102.67,
  'mem_7:10:140000:110': 6102.67,
  'mem_7:10:140000:111': 6102.67,
  'mem_7:10:140000:112': 6102.67,
  'mem_7:10:140000:113': 6102.67,
  'mem_7:10:140000:114': 6102.67,
  'mem_7:10:140000:115': 6102.67,
  'mem_7:10:140000:116': 6102.67,
  'mem_7:10:140000:117': 6102.67,
  'mem_7:10:140000:118': 6102.67,
  'mem_7:10:140000:119': 6102.67,
  'mem_7:10:140000:120': 6102.67,
  'mem_7:10:160000:1': 20.87,
  'mem_7:10:160000:2': 20.87,
  'mem_7:10:160000:3': 20.87,
  'mem_7:10:160000:4': 20.87,
  'mem_7:10:160000:5': 20.87,
  'mem_7:10:160000:6': 20.78,
  'mem_7:10:160000:7': 20.78,
  'mem_7:10:160000:8': 20.78,
  'mem_7:10:160000:9': 20.78,
  'mem_7:10:160000:10': 20.78,
  'mem_7:10:160000:11': 20.82,
  'mem_7:10:160000:12': 20.82,
  'mem_7:10:160000:13': 20.82,
  'mem_7:10:160000:14': 20.82,
  'mem_7:10:160000:15': 20.82,
  'mem_7:10:160000:16': 21.13,
  'mem_7:10:160000:17': 21.13,
  'mem_7:10:160000:18': 21.13,
  'mem_7:10:160000:19': 21.13,
  'mem_7:10:160000:20': 21.13,
  'mem_7:10:160000:21': 22.2,
  'mem_7:10:160000:22': 22.2,
  'mem_7:10:160000:23': 22.2,
  'mem_7:10:160000:24': 22.2,
  'mem_7:10:160000:25': 22.2,
  'mem_7:10:160000:26': 24.87,
  'mem_7:10:160000:27': 24.87,
  'mem_7:10:160000:28': 24.87,
  'mem_7:10:160000:29': 24.87,
  'mem_7:10:160000:30': 24.87,
  'mem_7:10:160000:31': 31.01,
  'mem_7:10:160000:32': 31.01,
  'mem_7:10:160000:33': 31.01,
  'mem_7:10:160000:34': 31.01,
  'mem_7:10:160000:35': 31.01,
  'mem_7:10:160000:36': 44.06,
  'mem_7:10:160000:37': 44.06,
  'mem_7:10:160000:38': 44.06,
  'mem_7:10:160000:39': 44.06,
  'mem_7:10:160000:40': 44.06,
  'mem_7:10:160000:41': 68.08,
  'mem_7:10:160000:42': 68.08,
  'mem_7:10:160000:43': 68.08,
  'mem_7:10:160000:44': 68.08,
  'mem_7:10:160000:45': 68.08,
  'mem_7:10:160000:46': 103.86,
  'mem_7:10:160000:47': 103.86,
  'mem_7:10:160000:48': 103.86,
  'mem_7:10:160000:49': 103.86,
  'mem_7:10:160000:50': 103.86,
  'mem_7:10:160000:51': 155.47,
  'mem_7:10:160000:52': 155.47,
  'mem_7:10:160000:53': 155.47,
  'mem_7:10:160000:54': 155.47,
  'mem_7:10:160000:55': 155.47,
  'mem_7:10:160000:56': 218.67,
  'mem_7:10:160000:57': 218.67,
  'mem_7:10:160000:58': 218.67,
  'mem_7:10:160000:59': 218.67,
  'mem_7:10:160000:60': 218.67,
  'mem_7:10:160000:61': 306.66,
  'mem_7:10:160000:62': 306.66,
  'mem_7:10:160000:63': 306.66,
  'mem_7:10:160000:64': 306.66,
  'mem_7:10:160000:65': 306.66,
  'mem_7:10:160000:66': 438.98,
  'mem_7:10:160000:67': 438.98,
  'mem_7:10:160000:68': 438.98,
  'mem_7:10:160000:69': 438.98,
  'mem_7:10:160000:70': 438.98,
  'mem_7:10:160000:71': 568.55,
  'mem_7:10:160000:72': 568.55,
  'mem_7:10:160000:73': 568.55,
  'mem_7:10:160000:74': 568.55,
  'mem_7:10:160000:75': 568.55,
  'mem_7:10:160000:76': 773.35,
  'mem_7:10:160000:77': 773.35,
  'mem_7:10:160000:78': 773.35,
  'mem_7:10:160000:79': 773.35,
  'mem_7:10:160000:80': 773.35,
  'mem_7:10:160000:81': 1085.26,
  'mem_7:10:160000:82': 1085.26,
  'mem_7:10:160000:83': 1085.26,
  'mem_7:10:160000:84': 1085.26,
  'mem_7:10:160000:85': 1085.26,
  'mem_7:10:160000:86': 1452.07,
  'mem_7:10:160000:87': 1452.07,
  'mem_7:10:160000:88': 1452.07,
  'mem_7:10:160000:89': 1452.07,
  'mem_7:10:160000:90': 1452.07,
  'mem_7:10:160000:91': 1959.17,
  'mem_7:10:160000:92': 1959.17,
  'mem_7:10:160000:93': 1959.17,
  'mem_7:10:160000:94': 1959.17,
  'mem_7:10:160000:95': 1959.17,
  'mem_7:10:160000:96': 3179.51,
  'mem_7:10:160000:97': 3179.51,
  'mem_7:10:160000:98': 3179.51,
  'mem_7:10:160000:99': 3179.51,
  'mem_7:10:160000:100': 3179.51,
  'mem_7:10:160000:101': 5537.7,
  'mem_7:10:160000:102': 5537.7,
  'mem_7:10:160000:103': 5537.7,
  'mem_7:10:160000:104': 5537.7,
  'mem_7:10:160000:105': 5537.7,
  'mem_7:10:160000:106': 6976.09,
  'mem_7:10:160000:107': 6976.09,
  'mem_7:10:160000:108': 6976.09,
  'mem_7:10:160000:109': 6976.09,
  'mem_7:10:160000:110': 6976.09,
  'mem_7:10:160000:111': 6976.09,
  'mem_7:10:160000:112': 6976.09,
  'mem_7:10:160000:113': 6976.09,
  'mem_7:10:160000:114': 6976.09,
  'mem_7:10:160000:115': 6976.09,
  'mem_7:10:160000:116': 6976.09,
  'mem_7:10:160000:117': 6976.09,
  'mem_7:10:160000:118': 6976.09,
  'mem_7:10:160000:119': 6976.09,
  'mem_7:10:160000:120': 6976.09,
  'mem_7:10:180000:1': 23.45,
  'mem_7:10:180000:2': 23.45,
  'mem_7:10:180000:3': 23.45,
  'mem_7:10:180000:4': 23.45,
  'mem_7:10:180000:5': 23.45,
  'mem_7:10:180000:6': 23.34,
  'mem_7:10:180000:7': 23.34,
  'mem_7:10:180000:8': 23.34,
  'mem_7:10:180000:9': 23.34,
  'mem_7:10:180000:10': 23.34,
  'mem_7:10:180000:11': 23.39,
  'mem_7:10:180000:12': 23.39,
  'mem_7:10:180000:13': 23.39,
  'mem_7:10:180000:14': 23.39,
  'mem_7:10:180000:15': 23.39,
  'mem_7:10:180000:16': 23.74,
  'mem_7:10:180000:17': 23.74,
  'mem_7:10:180000:18': 23.74,
  'mem_7:10:180000:19': 23.74,
  'mem_7:10:180000:20': 23.74,
  'mem_7:10:180000:21': 24.94,
  'mem_7:10:180000:22': 24.94,
  'mem_7:10:180000:23': 24.94,
  'mem_7:10:180000:24': 24.94,
  'mem_7:10:180000:25': 24.94,
  'mem_7:10:180000:26': 27.94,
  'mem_7:10:180000:27': 27.94,
  'mem_7:10:180000:28': 27.94,
  'mem_7:10:180000:29': 27.94,
  'mem_7:10:180000:30': 27.94,
  'mem_7:10:180000:31': 34.87,
  'mem_7:10:180000:32': 34.87,
  'mem_7:10:180000:33': 34.87,
  'mem_7:10:180000:34': 34.87,
  'mem_7:10:180000:35': 34.87,
  'mem_7:10:180000:36': 49.57,
  'mem_7:10:180000:37': 49.57,
  'mem_7:10:180000:38': 49.57,
  'mem_7:10:180000:39': 49.57,
  'mem_7:10:180000:40': 49.57,
  'mem_7:10:180000:41': 76.53,
  'mem_7:10:180000:42': 76.53,
  'mem_7:10:180000:43': 76.53,
  'mem_7:10:180000:44': 76.53,
  'mem_7:10:180000:45': 76.53,
  'mem_7:10:180000:46': 116.69,
  'mem_7:10:180000:47': 116.69,
  'mem_7:10:180000:48': 116.69,
  'mem_7:10:180000:49': 116.69,
  'mem_7:10:180000:50': 116.69,
  'mem_7:10:180000:51': 174.67,
  'mem_7:10:180000:52': 174.67,
  'mem_7:10:180000:53': 174.67,
  'mem_7:10:180000:54': 174.67,
  'mem_7:10:180000:55': 174.67,
  'mem_7:10:180000:56': 245.68,
  'mem_7:10:180000:57': 245.68,
  'mem_7:10:180000:58': 245.68,
  'mem_7:10:180000:59': 245.68,
  'mem_7:10:180000:60': 245.68,
  'mem_7:10:180000:61': 344.52,
  'mem_7:10:180000:62': 344.52,
  'mem_7:10:180000:63': 344.52,
  'mem_7:10:180000:64': 344.52,
  'mem_7:10:180000:65': 344.52,
  'mem_7:10:180000:66': 493.17,
  'mem_7:10:180000:67': 493.17,
  'mem_7:10:180000:68': 493.17,
  'mem_7:10:180000:69': 493.17,
  'mem_7:10:180000:70': 493.17,
  'mem_7:10:180000:71': 638.76,
  'mem_7:10:180000:72': 638.76,
  'mem_7:10:180000:73': 638.76,
  'mem_7:10:180000:74': 638.76,
  'mem_7:10:180000:75': 638.76,
  'mem_7:10:180000:76': 868.82,
  'mem_7:10:180000:77': 868.82,
  'mem_7:10:180000:78': 868.82,
  'mem_7:10:180000:79': 868.82,
  'mem_7:10:180000:80': 868.82,
  'mem_7:10:180000:81': 1219.23,
  'mem_7:10:180000:82': 1219.23,
  'mem_7:10:180000:83': 1219.23,
  'mem_7:10:180000:84': 1219.23,
  'mem_7:10:180000:85': 1219.23,
  'mem_7:10:180000:86': 1631.35,
  'mem_7:10:180000:87': 1631.35,
  'mem_7:10:180000:88': 1631.35,
  'mem_7:10:180000:89': 1631.35,
  'mem_7:10:180000:90': 1631.35,
  'mem_7:10:180000:91': 2201.14,
  'mem_7:10:180000:92': 2201.14,
  'mem_7:10:180000:93': 2201.14,
  'mem_7:10:180000:94': 2201.14,
  'mem_7:10:180000:95': 2201.14,
  'mem_7:10:180000:96': 3572.3,
  'mem_7:10:180000:97': 3572.3,
  'mem_7:10:180000:98': 3572.3,
  'mem_7:10:180000:99': 3572.3,
  'mem_7:10:180000:100': 3572.3,
  'mem_7:10:180000:101': 6221.94,
  'mem_7:10:180000:102': 6221.94,
  'mem_7:10:180000:103': 6221.94,
  'mem_7:10:180000:104': 6221.94,
  'mem_7:10:180000:105': 6221.94,
  'mem_7:10:180000:106': 7838.09,
  'mem_7:10:180000:107': 7838.09,
  'mem_7:10:180000:108': 7838.09,
  'mem_7:10:180000:109': 7838.09,
  'mem_7:10:180000:110': 7838.09,
  'mem_7:10:180000:111': 7838.09,
  'mem_7:10:180000:112': 7838.09,
  'mem_7:10:180000:113': 7838.09,
  'mem_7:10:180000:114': 7838.09,
  'mem_7:10:180000:115': 7838.09,
  'mem_7:10:180000:116': 7838.09,
  'mem_7:10:180000:117': 7838.09,
  'mem_7:10:180000:118': 7838.09,
  'mem_7:10:180000:119': 7838.09,
  'mem_7:10:180000:120': 7838.09,
  'mem_7:10:200000:1': 26.07,
  'mem_7:10:200000:2': 26.07,
  'mem_7:10:200000:3': 26.07,
  'mem_7:10:200000:4': 26.07,
  'mem_7:10:200000:5': 26.07,
  'mem_7:10:200000:6': 25.95,
  'mem_7:10:200000:7': 25.95,
  'mem_7:10:200000:8': 25.95,
  'mem_7:10:200000:9': 25.95,
  'mem_7:10:200000:10': 25.95,
  'mem_7:10:200000:11': 26,
  'mem_7:10:200000:12': 26,
  'mem_7:10:200000:13': 26,
  'mem_7:10:200000:14': 26,
  'mem_7:10:200000:15': 26,
  'mem_7:10:200000:16': 26.4,
  'mem_7:10:200000:17': 26.4,
  'mem_7:10:200000:18': 26.4,
  'mem_7:10:200000:19': 26.4,
  'mem_7:10:200000:20': 26.4,
  'mem_7:10:200000:21': 27.72,
  'mem_7:10:200000:22': 27.72,
  'mem_7:10:200000:23': 27.72,
  'mem_7:10:200000:24': 27.72,
  'mem_7:10:200000:25': 27.72,
  'mem_7:10:200000:26': 31.06,
  'mem_7:10:200000:27': 31.06,
  'mem_7:10:200000:28': 31.06,
  'mem_7:10:200000:29': 31.06,
  'mem_7:10:200000:30': 31.06,
  'mem_7:10:200000:31': 38.75,
  'mem_7:10:200000:32': 38.75,
  'mem_7:10:200000:33': 38.75,
  'mem_7:10:200000:34': 38.75,
  'mem_7:10:200000:35': 38.75,
  'mem_7:10:200000:36': 55.09,
  'mem_7:10:200000:37': 55.09,
  'mem_7:10:200000:38': 55.09,
  'mem_7:10:200000:39': 55.09,
  'mem_7:10:200000:40': 55.09,
  'mem_7:10:200000:41': 85.06,
  'mem_7:10:200000:42': 85.06,
  'mem_7:10:200000:43': 85.06,
  'mem_7:10:200000:44': 85.06,
  'mem_7:10:200000:45': 85.06,
  'mem_7:10:200000:46': 129.72,
  'mem_7:10:200000:47': 129.72,
  'mem_7:10:200000:48': 129.72,
  'mem_7:10:200000:49': 129.72,
  'mem_7:10:200000:50': 129.72,
  'mem_7:10:200000:51': 194.17,
  'mem_7:10:200000:52': 194.17,
  'mem_7:10:200000:53': 194.17,
  'mem_7:10:200000:54': 194.17,
  'mem_7:10:200000:55': 194.17,
  'mem_7:10:200000:56': 273.1,
  'mem_7:10:200000:57': 273.1,
  'mem_7:10:200000:58': 273.1,
  'mem_7:10:200000:59': 273.1,
  'mem_7:10:200000:60': 273.1,
  'mem_7:10:200000:61': 382.98,
  'mem_7:10:200000:62': 382.98,
  'mem_7:10:200000:63': 382.98,
  'mem_7:10:200000:64': 382.98,
  'mem_7:10:200000:65': 382.98,
  'mem_7:10:200000:66': 548.21,
  'mem_7:10:200000:67': 548.21,
  'mem_7:10:200000:68': 548.21,
  'mem_7:10:200000:69': 548.21,
  'mem_7:10:200000:70': 548.21,
  'mem_7:10:200000:71': 710.06,
  'mem_7:10:200000:72': 710.06,
  'mem_7:10:200000:73': 710.06,
  'mem_7:10:200000:74': 710.06,
  'mem_7:10:200000:75': 710.06,
  'mem_7:10:200000:76': 965.83,
  'mem_7:10:200000:77': 965.83,
  'mem_7:10:200000:78': 965.83,
  'mem_7:10:200000:79': 965.83,
  'mem_7:10:200000:80': 965.83,
  'mem_7:10:200000:81': 1355.36,
  'mem_7:10:200000:82': 1355.36,
  'mem_7:10:200000:83': 1355.36,
  'mem_7:10:200000:84': 1355.36,
  'mem_7:10:200000:85': 1355.36,
  'mem_7:10:200000:86': 1813.51,
  'mem_7:10:200000:87': 1813.51,
  'mem_7:10:200000:88': 1813.51,
  'mem_7:10:200000:89': 1813.51,
  'mem_7:10:200000:90': 1813.51,
  'mem_7:10:200000:91': 2446.93,
  'mem_7:10:200000:92': 2446.93,
  'mem_7:10:200000:93': 2446.93,
  'mem_7:10:200000:94': 2446.93,
  'mem_7:10:200000:95': 2446.93,
  'mem_7:10:200000:96': 3971.2,
  'mem_7:10:200000:97': 3971.2,
  'mem_7:10:200000:98': 3971.2,
  'mem_7:10:200000:99': 3971.2,
  'mem_7:10:200000:100': 3971.2,
  'mem_7:10:200000:101': 6916.78,
  'mem_7:10:200000:102': 6916.78,
  'mem_7:10:200000:103': 6916.78,
  'mem_7:10:200000:104': 6916.78,
  'mem_7:10:200000:105': 6916.78,
  'mem_7:10:200000:106': 8713.46,
  'mem_7:10:200000:107': 8713.46,
  'mem_7:10:200000:108': 8713.46,
  'mem_7:10:200000:109': 8713.46,
  'mem_7:10:200000:110': 8713.46,
  'mem_7:10:200000:111': 8713.46,
  'mem_7:10:200000:112': 8713.46,
  'mem_7:10:200000:113': 8713.46,
  'mem_7:10:200000:114': 8713.46,
  'mem_7:10:200000:115': 8713.46,
  'mem_7:10:200000:116': 8713.46,
  'mem_7:10:200000:117': 8713.46,
  'mem_7:10:200000:118': 8713.46,
  'mem_7:10:200000:119': 8713.46,
  'mem_7:10:200000:120': 8713.46,
  'adb:10:5000:1': 4.8,
  'adb:10:5000:2': 4.8,
  'adb:10:5000:3': 4.8,
  'adb:10:5000:4': 4.8,
  'adb:10:5000:5': 4.8,
  'adb:10:5000:6': 4.8,
  'adb:10:5000:7': 4.8,
  'adb:10:5000:8': 4.8,
  'adb:10:5000:9': 4.8,
  'adb:10:5000:10': 4.8,
  'adb:10:5000:11': 4.8,
  'adb:10:5000:12': 4.8,
  'adb:10:5000:13': 4.8,
  'adb:10:5000:14': 4.8,
  'adb:10:5000:15': 4.8,
  'adb:10:5000:16': 4.8,
  'adb:10:5000:17': 4.8,
  'adb:10:5000:18': 4.8,
  'adb:10:5000:19': 4.8,
  'adb:10:5000:20': 4.8,
  'adb:10:5000:21': 4.8,
  'adb:10:5000:22': 4.8,
  'adb:10:5000:23': 4.8,
  'adb:10:5000:24': 4.8,
  'adb:10:5000:25': 4.8,
  'adb:10:5000:26': 4.8,
  'adb:10:5000:27': 4.8,
  'adb:10:5000:28': 4.8,
  'adb:10:5000:29': 4.8,
  'adb:10:5000:30': 4.8,
  'adb:10:5000:31': 4.8,
  'adb:10:5000:32': 4.8,
  'adb:10:5000:33': 4.8,
  'adb:10:5000:34': 4.8,
  'adb:10:5000:35': 4.8,
  'adb:10:5000:36': 6,
  'adb:10:5000:37': 6,
  'adb:10:5000:38': 6,
  'adb:10:5000:39': 6,
  'adb:10:5000:40': 6,
  'adb:10:5000:41': 8.4,
  'adb:10:5000:42': 8.4,
  'adb:10:5000:43': 8.4,
  'adb:10:5000:44': 8.4,
  'adb:10:5000:45': 8.4,
  'adb:10:5000:46': 10.8,
  'adb:10:5000:47': 10.8,
  'adb:10:5000:48': 10.8,
  'adb:10:5000:49': 10.8,
  'adb:10:5000:50': 10.8,
  'adb:10:5000:51': 14.4,
  'adb:10:5000:52': 14.4,
  'adb:10:5000:53': 14.4,
  'adb:10:5000:54': 14.4,
  'adb:10:5000:55': 14.4,
  'adb:10:5000:56': 9.6,
  'adb:10:5000:57': 9.6,
  'adb:10:5000:58': 9.6,
  'adb:10:5000:59': 9.6,
  'adb:10:5000:60': 9.6,
  'adb:10:5000:61': 3.6,
  'adb:10:5000:62': 3.6,
  'adb:10:5000:63': 3.6,
  'adb:10:5000:64': 3.6,
  'adb:10:5000:65': 3.6,
  'adb:10:5000:66': 3.6,
  'adb:10:5000:67': 3.6,
  'adb:10:5000:68': 3.6,
  'adb:10:5000:69': 3.6,
  'adb:10:5000:70': 3.6,
  'adb:10:5000:71': 7.2,
  'adb:10:5000:72': 7.2,
  'adb:10:5000:73': 7.2,
  'adb:10:5000:74': 7.2,
  'adb:10:5000:75': 7.2,
  'adb:10:5000:76': 13.2,
  'adb:10:5000:77': 13.2,
  'adb:10:5000:78': 13.2,
  'adb:10:5000:79': 13.2,
  'adb:10:5000:80': 13.2,
  'adb:10:5000:81': 18,
  'adb:10:5000:82': 18,
  'adb:10:5000:83': 18,
  'adb:10:5000:84': 18,
  'adb:10:5000:85': 18,
  'adb:10:5000:86': 25.2,
  'adb:10:5000:87': 25.2,
  'adb:10:5000:88': 25.2,
  'adb:10:5000:89': 25.2,
  'adb:10:5000:90': 25.2,
  'adb:10:5000:91': 38.4,
  'adb:10:5000:92': 38.4,
  'adb:10:5000:93': 38.4,
  'adb:10:5000:94': 38.4,
  'adb:10:5000:95': 38.4,
  'adb:10:5000:96': 70.8,
  'adb:10:5000:97': 70.8,
  'adb:10:5000:98': 70.8,
  'adb:10:5000:99': 70.8,
  'adb:10:5000:100': 70.8,
  'adb:10:5000:101': 2.05,
  'adb:10:5000:102': 2.05,
  'adb:10:5000:103': 2.05,
  'adb:10:5000:104': 2.05,
  'adb:10:5000:105': 2.05,
  'adb:10:5000:106': 2.07,
  'adb:10:5000:107': 2.07,
  'adb:10:5000:108': 2.07,
  'adb:10:5000:109': 2.07,
  'adb:10:5000:110': 2.07,
  'adb:10:5000:111': 2.07,
  'adb:10:5000:112': 2.07,
  'adb:10:5000:113': 2.07,
  'adb:10:5000:114': 2.07,
  'adb:10:5000:115': 2.07,
  'adb:10:5000:116': 2.07,
  'adb:10:5000:117': 2.07,
  'adb:10:5000:118': 2.07,
  'adb:10:5000:119': 2.07,
  'adb:10:5000:120': 2.07,
  'adb:10:7500:1': 6,
  'adb:10:7500:2': 6,
  'adb:10:7500:3': 6,
  'adb:10:7500:4': 6,
  'adb:10:7500:5': 6,
  'adb:10:7500:6': 6,
  'adb:10:7500:7': 6,
  'adb:10:7500:8': 6,
  'adb:10:7500:9': 6,
  'adb:10:7500:10': 6,
  'adb:10:7500:11': 6,
  'adb:10:7500:12': 6,
  'adb:10:7500:13': 6,
  'adb:10:7500:14': 6,
  'adb:10:7500:15': 6,
  'adb:10:7500:16': 6,
  'adb:10:7500:17': 6,
  'adb:10:7500:18': 6,
  'adb:10:7500:19': 6,
  'adb:10:7500:20': 6,
  'adb:10:7500:21': 6,
  'adb:10:7500:22': 6,
  'adb:10:7500:23': 6,
  'adb:10:7500:24': 6,
  'adb:10:7500:25': 6,
  'adb:10:7500:26': 7.2,
  'adb:10:7500:27': 7.2,
  'adb:10:7500:28': 7.2,
  'adb:10:7500:29': 7.2,
  'adb:10:7500:30': 7.2,
  'adb:10:7500:31': 7.2,
  'adb:10:7500:32': 7.2,
  'adb:10:7500:33': 7.2,
  'adb:10:7500:34': 7.2,
  'adb:10:7500:35': 7.2,
  'adb:10:7500:36': 9.6,
  'adb:10:7500:37': 9.6,
  'adb:10:7500:38': 9.6,
  'adb:10:7500:39': 9.6,
  'adb:10:7500:40': 9.6,
  'adb:10:7500:41': 12,
  'adb:10:7500:42': 12,
  'adb:10:7500:43': 12,
  'adb:10:7500:44': 12,
  'adb:10:7500:45': 12,
  'adb:10:7500:46': 15.6,
  'adb:10:7500:47': 15.6,
  'adb:10:7500:48': 15.6,
  'adb:10:7500:49': 15.6,
  'adb:10:7500:50': 15.6,
  'adb:10:7500:51': 21.6,
  'adb:10:7500:52': 21.6,
  'adb:10:7500:53': 21.6,
  'adb:10:7500:54': 21.6,
  'adb:10:7500:55': 21.6,
  'adb:10:7500:56': 14.4,
  'adb:10:7500:57': 14.4,
  'adb:10:7500:58': 14.4,
  'adb:10:7500:59': 14.4,
  'adb:10:7500:60': 14.4,
  'adb:10:7500:61': 4.8,
  'adb:10:7500:62': 4.8,
  'adb:10:7500:63': 4.8,
  'adb:10:7500:64': 4.8,
  'adb:10:7500:65': 4.8,
  'adb:10:7500:66': 4.8,
  'adb:10:7500:67': 4.8,
  'adb:10:7500:68': 4.8,
  'adb:10:7500:69': 4.8,
  'adb:10:7500:70': 4.8,
  'adb:10:7500:71': 10.8,
  'adb:10:7500:72': 10.8,
  'adb:10:7500:73': 10.8,
  'adb:10:7500:74': 10.8,
  'adb:10:7500:75': 10.8,
  'adb:10:7500:76': 19.2,
  'adb:10:7500:77': 19.2,
  'adb:10:7500:78': 19.2,
  'adb:10:7500:79': 19.2,
  'adb:10:7500:80': 19.2,
  'adb:10:7500:81': 26.4,
  'adb:10:7500:82': 26.4,
  'adb:10:7500:83': 26.4,
  'adb:10:7500:84': 26.4,
  'adb:10:7500:85': 26.4,
  'adb:10:7500:86': 38.4,
  'adb:10:7500:87': 38.4,
  'adb:10:7500:88': 38.4,
  'adb:10:7500:89': 38.4,
  'adb:10:7500:90': 38.4,
  'adb:10:7500:91': 56.4,
  'adb:10:7500:92': 56.4,
  'adb:10:7500:93': 56.4,
  'adb:10:7500:94': 56.4,
  'adb:10:7500:95': 56.4,
  'adb:10:7500:96': 106.8,
  'adb:10:7500:97': 106.8,
  'adb:10:7500:98': 106.8,
  'adb:10:7500:99': 106.8,
  'adb:10:7500:100': 106.8,
  'adb:10:7500:101': 3.07,
  'adb:10:7500:102': 3.07,
  'adb:10:7500:103': 3.07,
  'adb:10:7500:104': 3.07,
  'adb:10:7500:105': 3.07,
  'adb:10:7500:106': 3.1,
  'adb:10:7500:107': 3.1,
  'adb:10:7500:108': 3.1,
  'adb:10:7500:109': 3.1,
  'adb:10:7500:110': 3.1,
  'adb:10:7500:111': 3.1,
  'adb:10:7500:112': 3.1,
  'adb:10:7500:113': 3.1,
  'adb:10:7500:114': 3.1,
  'adb:10:7500:115': 3.1,
  'adb:10:7500:116': 3.1,
  'adb:10:7500:117': 3.1,
  'adb:10:7500:118': 3.1,
  'adb:10:7500:119': 3.1,
  'adb:10:7500:120': 3.1,
  'adb:10:10000:1': 8.4,
  'adb:10:10000:2': 8.4,
  'adb:10:10000:3': 8.4,
  'adb:10:10000:4': 8.4,
  'adb:10:10000:5': 8.4,
  'adb:10:10000:6': 8.4,
  'adb:10:10000:7': 8.4,
  'adb:10:10000:8': 8.4,
  'adb:10:10000:9': 8.4,
  'adb:10:10000:10': 8.4,
  'adb:10:10000:11': 8.4,
  'adb:10:10000:12': 8.4,
  'adb:10:10000:13': 8.4,
  'adb:10:10000:14': 8.4,
  'adb:10:10000:15': 8.4,
  'adb:10:10000:16': 8.4,
  'adb:10:10000:17': 8.4,
  'adb:10:10000:18': 8.4,
  'adb:10:10000:19': 8.4,
  'adb:10:10000:20': 8.4,
  'adb:10:10000:21': 8.4,
  'adb:10:10000:22': 8.4,
  'adb:10:10000:23': 8.4,
  'adb:10:10000:24': 8.4,
  'adb:10:10000:25': 8.4,
  'adb:10:10000:26': 8.4,
  'adb:10:10000:27': 8.4,
  'adb:10:10000:28': 8.4,
  'adb:10:10000:29': 8.4,
  'adb:10:10000:30': 8.4,
  'adb:10:10000:31': 9.6,
  'adb:10:10000:32': 9.6,
  'adb:10:10000:33': 9.6,
  'adb:10:10000:34': 9.6,
  'adb:10:10000:35': 9.6,
  'adb:10:10000:36': 12,
  'adb:10:10000:37': 12,
  'adb:10:10000:38': 12,
  'adb:10:10000:39': 12,
  'adb:10:10000:40': 12,
  'adb:10:10000:41': 15.6,
  'adb:10:10000:42': 15.6,
  'adb:10:10000:43': 15.6,
  'adb:10:10000:44': 15.6,
  'adb:10:10000:45': 15.6,
  'adb:10:10000:46': 20.4,
  'adb:10:10000:47': 20.4,
  'adb:10:10000:48': 20.4,
  'adb:10:10000:49': 20.4,
  'adb:10:10000:50': 20.4,
  'adb:10:10000:51': 27.6,
  'adb:10:10000:52': 27.6,
  'adb:10:10000:53': 27.6,
  'adb:10:10000:54': 27.6,
  'adb:10:10000:55': 27.6,
  'adb:10:10000:56': 19.2,
  'adb:10:10000:57': 19.2,
  'adb:10:10000:58': 19.2,
  'adb:10:10000:59': 19.2,
  'adb:10:10000:60': 19.2,
  'adb:10:10000:61': 7.2,
  'adb:10:10000:62': 7.2,
  'adb:10:10000:63': 7.2,
  'adb:10:10000:64': 7.2,
  'adb:10:10000:65': 7.2,
  'adb:10:10000:66': 7.2,
  'adb:10:10000:67': 7.2,
  'adb:10:10000:68': 7.2,
  'adb:10:10000:69': 7.2,
  'adb:10:10000:70': 7.2,
  'adb:10:10000:71': 14.4,
  'adb:10:10000:72': 14.4,
  'adb:10:10000:73': 14.4,
  'adb:10:10000:74': 14.4,
  'adb:10:10000:75': 14.4,
  'adb:10:10000:76': 25.2,
  'adb:10:10000:77': 25.2,
  'adb:10:10000:78': 25.2,
  'adb:10:10000:79': 25.2,
  'adb:10:10000:80': 25.2,
  'adb:10:10000:81': 34.8,
  'adb:10:10000:82': 34.8,
  'adb:10:10000:83': 34.8,
  'adb:10:10000:84': 34.8,
  'adb:10:10000:85': 34.8,
  'adb:10:10000:86': 50.4,
  'adb:10:10000:87': 50.4,
  'adb:10:10000:88': 50.4,
  'adb:10:10000:89': 50.4,
  'adb:10:10000:90': 50.4,
  'adb:10:10000:91': 75.6,
  'adb:10:10000:92': 75.6,
  'adb:10:10000:93': 75.6,
  'adb:10:10000:94': 75.6,
  'adb:10:10000:95': 75.6,
  'adb:10:10000:96': 141.6,
  'adb:10:10000:97': 141.6,
  'adb:10:10000:98': 141.6,
  'adb:10:10000:99': 141.6,
  'adb:10:10000:100': 141.6,
  'adb:10:10000:101': 4.09,
  'adb:10:10000:102': 4.09,
  'adb:10:10000:103': 4.09,
  'adb:10:10000:104': 4.09,
  'adb:10:10000:105': 4.09,
  'adb:10:10000:106': 4.13,
  'adb:10:10000:107': 4.13,
  'adb:10:10000:108': 4.13,
  'adb:10:10000:109': 4.13,
  'adb:10:10000:110': 4.13,
  'adb:10:10000:111': 4.13,
  'adb:10:10000:112': 4.13,
  'adb:10:10000:113': 4.13,
  'adb:10:10000:114': 4.13,
  'adb:10:10000:115': 4.13,
  'adb:10:10000:116': 4.13,
  'adb:10:10000:117': 4.13,
  'adb:10:10000:118': 4.13,
  'adb:10:10000:119': 4.13,
  'adb:10:10000:120': 4.13,
  'adb:10:15000:1': 12,
  'adb:10:15000:2': 12,
  'adb:10:15000:3': 12,
  'adb:10:15000:4': 12,
  'adb:10:15000:5': 12,
  'adb:10:15000:6': 12,
  'adb:10:15000:7': 12,
  'adb:10:15000:8': 12,
  'adb:10:15000:9': 12,
  'adb:10:15000:10': 12,
  'adb:10:15000:11': 12,
  'adb:10:15000:12': 12,
  'adb:10:15000:13': 12,
  'adb:10:15000:14': 12,
  'adb:10:15000:15': 12,
  'adb:10:15000:16': 12,
  'adb:10:15000:17': 12,
  'adb:10:15000:18': 12,
  'adb:10:15000:19': 12,
  'adb:10:15000:20': 12,
  'adb:10:15000:21': 12,
  'adb:10:15000:22': 12,
  'adb:10:15000:23': 12,
  'adb:10:15000:24': 12,
  'adb:10:15000:25': 12,
  'adb:10:15000:26': 13.2,
  'adb:10:15000:27': 13.2,
  'adb:10:15000:28': 13.2,
  'adb:10:15000:29': 13.2,
  'adb:10:15000:30': 13.2,
  'adb:10:15000:31': 14.4,
  'adb:10:15000:32': 14.4,
  'adb:10:15000:33': 14.4,
  'adb:10:15000:34': 14.4,
  'adb:10:15000:35': 14.4,
  'adb:10:15000:36': 18,
  'adb:10:15000:37': 18,
  'adb:10:15000:38': 18,
  'adb:10:15000:39': 18,
  'adb:10:15000:40': 18,
  'adb:10:15000:41': 22.8,
  'adb:10:15000:42': 22.8,
  'adb:10:15000:43': 22.8,
  'adb:10:15000:44': 22.8,
  'adb:10:15000:45': 22.8,
  'adb:10:15000:46': 30,
  'adb:10:15000:47': 30,
  'adb:10:15000:48': 30,
  'adb:10:15000:49': 30,
  'adb:10:15000:50': 30,
  'adb:10:15000:51': 42,
  'adb:10:15000:52': 42,
  'adb:10:15000:53': 42,
  'adb:10:15000:54': 42,
  'adb:10:15000:55': 42,
  'adb:10:15000:56': 28.8,
  'adb:10:15000:57': 28.8,
  'adb:10:15000:58': 28.8,
  'adb:10:15000:59': 28.8,
  'adb:10:15000:60': 28.8,
  'adb:10:15000:61': 9.6,
  'adb:10:15000:62': 9.6,
  'adb:10:15000:63': 9.6,
  'adb:10:15000:64': 9.6,
  'adb:10:15000:65': 9.6,
  'adb:10:15000:66': 9.6,
  'adb:10:15000:67': 9.6,
  'adb:10:15000:68': 9.6,
  'adb:10:15000:69': 9.6,
  'adb:10:15000:70': 9.6,
  'adb:10:15000:71': 20.4,
  'adb:10:15000:72': 20.4,
  'adb:10:15000:73': 20.4,
  'adb:10:15000:74': 20.4,
  'adb:10:15000:75': 20.4,
  'adb:10:15000:76': 37.2,
  'adb:10:15000:77': 37.2,
  'adb:10:15000:78': 37.2,
  'adb:10:15000:79': 37.2,
  'adb:10:15000:80': 37.2,
  'adb:10:15000:81': 51.6,
  'adb:10:15000:82': 51.6,
  'adb:10:15000:83': 51.6,
  'adb:10:15000:84': 51.6,
  'adb:10:15000:85': 51.6,
  'adb:10:15000:86': 75.6,
  'adb:10:15000:87': 75.6,
  'adb:10:15000:88': 75.6,
  'adb:10:15000:89': 75.6,
  'adb:10:15000:90': 75.6,
  'adb:10:15000:91': 112.8,
  'adb:10:15000:92': 112.8,
  'adb:10:15000:93': 112.8,
  'adb:10:15000:94': 112.8,
  'adb:10:15000:95': 112.8,
  'adb:10:15000:96': 212.4,
  'adb:10:15000:97': 212.4,
  'adb:10:15000:98': 212.4,
  'adb:10:15000:99': 212.4,
  'adb:10:15000:100': 212.4,
  'adb:10:15000:101': 6.14,
  'adb:10:15000:102': 6.14,
  'adb:10:15000:103': 6.14,
  'adb:10:15000:104': 6.14,
  'adb:10:15000:105': 6.14,
  'adb:10:15000:106': 6.19,
  'adb:10:15000:107': 6.19,
  'adb:10:15000:108': 6.19,
  'adb:10:15000:109': 6.19,
  'adb:10:15000:110': 6.19,
  'adb:10:15000:111': 6.19,
  'adb:10:15000:112': 6.19,
  'adb:10:15000:113': 6.19,
  'adb:10:15000:114': 6.19,
  'adb:10:15000:115': 6.19,
  'adb:10:15000:116': 6.19,
  'adb:10:15000:117': 6.19,
  'adb:10:15000:118': 6.19,
  'adb:10:15000:119': 6.19,
  'adb:10:15000:120': 6.19,
  'adb:10:20000:1': 15.6,
  'adb:10:20000:2': 15.6,
  'adb:10:20000:3': 15.6,
  'adb:10:20000:4': 15.6,
  'adb:10:20000:5': 15.6,
  'adb:10:20000:6': 15.6,
  'adb:10:20000:7': 15.6,
  'adb:10:20000:8': 15.6,
  'adb:10:20000:9': 15.6,
  'adb:10:20000:10': 15.6,
  'adb:10:20000:11': 15.6,
  'adb:10:20000:12': 15.6,
  'adb:10:20000:13': 15.6,
  'adb:10:20000:14': 15.6,
  'adb:10:20000:15': 15.6,
  'adb:10:20000:16': 15.6,
  'adb:10:20000:17': 15.6,
  'adb:10:20000:18': 15.6,
  'adb:10:20000:19': 15.6,
  'adb:10:20000:20': 15.6,
  'adb:10:20000:21': 15.6,
  'adb:10:20000:22': 15.6,
  'adb:10:20000:23': 15.6,
  'adb:10:20000:24': 15.6,
  'adb:10:20000:25': 15.6,
  'adb:10:20000:26': 16.8,
  'adb:10:20000:27': 16.8,
  'adb:10:20000:28': 16.8,
  'adb:10:20000:29': 16.8,
  'adb:10:20000:30': 16.8,
  'adb:10:20000:31': 19.2,
  'adb:10:20000:32': 19.2,
  'adb:10:20000:33': 19.2,
  'adb:10:20000:34': 19.2,
  'adb:10:20000:35': 19.2,
  'adb:10:20000:36': 22.8,
  'adb:10:20000:37': 22.8,
  'adb:10:20000:38': 22.8,
  'adb:10:20000:39': 22.8,
  'adb:10:20000:40': 22.8,
  'adb:10:20000:41': 30,
  'adb:10:20000:42': 30,
  'adb:10:20000:43': 30,
  'adb:10:20000:44': 30,
  'adb:10:20000:45': 30,
  'adb:10:20000:46': 39.6,
  'adb:10:20000:47': 39.6,
  'adb:10:20000:48': 39.6,
  'adb:10:20000:49': 39.6,
  'adb:10:20000:50': 39.6,
  'adb:10:20000:51': 55.2,
  'adb:10:20000:52': 55.2,
  'adb:10:20000:53': 55.2,
  'adb:10:20000:54': 55.2,
  'adb:10:20000:55': 55.2,
  'adb:10:20000:56': 38.4,
  'adb:10:20000:57': 38.4,
  'adb:10:20000:58': 38.4,
  'adb:10:20000:59': 38.4,
  'adb:10:20000:60': 38.4,
  'adb:10:20000:61': 13.2,
  'adb:10:20000:62': 13.2,
  'adb:10:20000:63': 13.2,
  'adb:10:20000:64': 13.2,
  'adb:10:20000:65': 13.2,
  'adb:10:20000:66': 13.2,
  'adb:10:20000:67': 13.2,
  'adb:10:20000:68': 13.2,
  'adb:10:20000:69': 13.2,
  'adb:10:20000:70': 13.2,
  'adb:10:20000:71': 27.6,
  'adb:10:20000:72': 27.6,
  'adb:10:20000:73': 27.6,
  'adb:10:20000:74': 27.6,
  'adb:10:20000:75': 27.6,
  'adb:10:20000:76': 49.2,
  'adb:10:20000:77': 49.2,
  'adb:10:20000:78': 49.2,
  'adb:10:20000:79': 49.2,
  'adb:10:20000:80': 49.2,
  'adb:10:20000:81': 69.6,
  'adb:10:20000:82': 69.6,
  'adb:10:20000:83': 69.6,
  'adb:10:20000:84': 69.6,
  'adb:10:20000:85': 69.6,
  'adb:10:20000:86': 100.8,
  'adb:10:20000:87': 100.8,
  'adb:10:20000:88': 100.8,
  'adb:10:20000:89': 100.8,
  'adb:10:20000:90': 100.8,
  'adb:10:20000:91': 150,
  'adb:10:20000:92': 150,
  'adb:10:20000:93': 150,
  'adb:10:20000:94': 150,
  'adb:10:20000:95': 150,
  'adb:10:20000:96': 282,
  'adb:10:20000:97': 282,
  'adb:10:20000:98': 282,
  'adb:10:20000:99': 282,
  'adb:10:20000:100': 282,
  'adb:10:20000:101': 8.18,
  'adb:10:20000:102': 8.18,
  'adb:10:20000:103': 8.18,
  'adb:10:20000:104': 8.18,
  'adb:10:20000:105': 8.18,
  'adb:10:20000:106': 8.26,
  'adb:10:20000:107': 8.26,
  'adb:10:20000:108': 8.26,
  'adb:10:20000:109': 8.26,
  'adb:10:20000:110': 8.26,
  'adb:10:20000:111': 8.26,
  'adb:10:20000:112': 8.26,
  'adb:10:20000:113': 8.26,
  'adb:10:20000:114': 8.26,
  'adb:10:20000:115': 8.26,
  'adb:10:20000:116': 8.26,
  'adb:10:20000:117': 8.26,
  'adb:10:20000:118': 8.26,
  'adb:10:20000:119': 8.26,
  'adb:10:20000:120': 8.26,
  'adb:10:25000:1': 19.2,
  'adb:10:25000:2': 19.2,
  'adb:10:25000:3': 19.2,
  'adb:10:25000:4': 19.2,
  'adb:10:25000:5': 19.2,
  'adb:10:25000:6': 19.2,
  'adb:10:25000:7': 19.2,
  'adb:10:25000:8': 19.2,
  'adb:10:25000:9': 19.2,
  'adb:10:25000:10': 19.2,
  'adb:10:25000:11': 19.2,
  'adb:10:25000:12': 19.2,
  'adb:10:25000:13': 19.2,
  'adb:10:25000:14': 19.2,
  'adb:10:25000:15': 19.2,
  'adb:10:25000:16': 19.2,
  'adb:10:25000:17': 19.2,
  'adb:10:25000:18': 19.2,
  'adb:10:25000:19': 19.2,
  'adb:10:25000:20': 19.2,
  'adb:10:25000:21': 20.4,
  'adb:10:25000:22': 20.4,
  'adb:10:25000:23': 20.4,
  'adb:10:25000:24': 20.4,
  'adb:10:25000:25': 20.4,
  'adb:10:25000:26': 20.4,
  'adb:10:25000:27': 20.4,
  'adb:10:25000:28': 20.4,
  'adb:10:25000:29': 20.4,
  'adb:10:25000:30': 20.4,
  'adb:10:25000:31': 24,
  'adb:10:25000:32': 24,
  'adb:10:25000:33': 24,
  'adb:10:25000:34': 24,
  'adb:10:25000:35': 24,
  'adb:10:25000:36': 28.8,
  'adb:10:25000:37': 28.8,
  'adb:10:25000:38': 28.8,
  'adb:10:25000:39': 28.8,
  'adb:10:25000:40': 28.8,
  'adb:10:25000:41': 37.2,
  'adb:10:25000:42': 37.2,
  'adb:10:25000:43': 37.2,
  'adb:10:25000:44': 37.2,
  'adb:10:25000:45': 37.2,
  'adb:10:25000:46': 49.2,
  'adb:10:25000:47': 49.2,
  'adb:10:25000:48': 49.2,
  'adb:10:25000:49': 49.2,
  'adb:10:25000:50': 49.2,
  'adb:10:25000:51': 68.4,
  'adb:10:25000:52': 68.4,
  'adb:10:25000:53': 68.4,
  'adb:10:25000:54': 68.4,
  'adb:10:25000:55': 68.4,
  'adb:10:25000:56': 48,
  'adb:10:25000:57': 48,
  'adb:10:25000:58': 48,
  'adb:10:25000:59': 48,
  'adb:10:25000:60': 48,
  'adb:10:25000:61': 15.6,
  'adb:10:25000:62': 15.6,
  'adb:10:25000:63': 15.6,
  'adb:10:25000:64': 15.6,
  'adb:10:25000:65': 15.6,
  'adb:10:25000:66': 15.6,
  'adb:10:25000:67': 15.6,
  'adb:10:25000:68': 15.6,
  'adb:10:25000:69': 15.6,
  'adb:10:25000:70': 15.6,
  'adb:10:25000:71': 33.6,
  'adb:10:25000:72': 33.6,
  'adb:10:25000:73': 33.6,
  'adb:10:25000:74': 33.6,
  'adb:10:25000:75': 33.6,
  'adb:10:25000:76': 61.2,
  'adb:10:25000:77': 61.2,
  'adb:10:25000:78': 61.2,
  'adb:10:25000:79': 61.2,
  'adb:10:25000:80': 61.2,
  'adb:10:25000:81': 86.4,
  'adb:10:25000:82': 86.4,
  'adb:10:25000:83': 86.4,
  'adb:10:25000:84': 86.4,
  'adb:10:25000:85': 86.4,
  'adb:10:25000:86': 124.8,
  'adb:10:25000:87': 124.8,
  'adb:10:25000:88': 124.8,
  'adb:10:25000:89': 124.8,
  'adb:10:25000:90': 124.8,
  'adb:10:25000:91': 188.4,
  'adb:10:25000:92': 188.4,
  'adb:10:25000:93': 188.4,
  'adb:10:25000:94': 188.4,
  'adb:10:25000:95': 188.4,
  'adb:10:25000:96': 352.8,
  'adb:10:25000:97': 352.8,
  'adb:10:25000:98': 352.8,
  'adb:10:25000:99': 352.8,
  'adb:10:25000:100': 352.8,
  'adb:10:25000:101': 10.23,
  'adb:10:25000:102': 10.23,
  'adb:10:25000:103': 10.23,
  'adb:10:25000:104': 10.23,
  'adb:10:25000:105': 10.23,
  'adb:10:25000:106': 10.33,
  'adb:10:25000:107': 10.33,
  'adb:10:25000:108': 10.33,
  'adb:10:25000:109': 10.33,
  'adb:10:25000:110': 10.33,
  'adb:10:25000:111': 10.33,
  'adb:10:25000:112': 10.33,
  'adb:10:25000:113': 10.33,
  'adb:10:25000:114': 10.33,
  'adb:10:25000:115': 10.33,
  'adb:10:25000:116': 10.33,
  'adb:10:25000:117': 10.33,
  'adb:10:25000:118': 10.33,
  'adb:10:25000:119': 10.33,
  'adb:10:25000:120': 10.33,
  'adb:10:30000:1': 22.8,
  'adb:10:30000:2': 22.8,
  'adb:10:30000:3': 22.8,
  'adb:10:30000:4': 22.8,
  'adb:10:30000:5': 22.8,
  'adb:10:30000:6': 22.8,
  'adb:10:30000:7': 22.8,
  'adb:10:30000:8': 22.8,
  'adb:10:30000:9': 22.8,
  'adb:10:30000:10': 22.8,
  'adb:10:30000:11': 22.8,
  'adb:10:30000:12': 22.8,
  'adb:10:30000:13': 22.8,
  'adb:10:30000:14': 22.8,
  'adb:10:30000:15': 22.8,
  'adb:10:30000:16': 24,
  'adb:10:30000:17': 24,
  'adb:10:30000:18': 24,
  'adb:10:30000:19': 24,
  'adb:10:30000:20': 24,
  'adb:10:30000:21': 24,
  'adb:10:30000:22': 24,
  'adb:10:30000:23': 24,
  'adb:10:30000:24': 24,
  'adb:10:30000:25': 24,
  'adb:10:30000:26': 25.2,
  'adb:10:30000:27': 25.2,
  'adb:10:30000:28': 25.2,
  'adb:10:30000:29': 25.2,
  'adb:10:30000:30': 25.2,
  'adb:10:30000:31': 28.8,
  'adb:10:30000:32': 28.8,
  'adb:10:30000:33': 28.8,
  'adb:10:30000:34': 28.8,
  'adb:10:30000:35': 28.8,
  'adb:10:30000:36': 34.8,
  'adb:10:30000:37': 34.8,
  'adb:10:30000:38': 34.8,
  'adb:10:30000:39': 34.8,
  'adb:10:30000:40': 34.8,
  'adb:10:30000:41': 44.4,
  'adb:10:30000:42': 44.4,
  'adb:10:30000:43': 44.4,
  'adb:10:30000:44': 44.4,
  'adb:10:30000:45': 44.4,
  'adb:10:30000:46': 58.8,
  'adb:10:30000:47': 58.8,
  'adb:10:30000:48': 58.8,
  'adb:10:30000:49': 58.8,
  'adb:10:30000:50': 58.8,
  'adb:10:30000:51': 82.8,
  'adb:10:30000:52': 82.8,
  'adb:10:30000:53': 82.8,
  'adb:10:30000:54': 82.8,
  'adb:10:30000:55': 82.8,
  'adb:10:30000:56': 56.4,
  'adb:10:30000:57': 56.4,
  'adb:10:30000:58': 56.4,
  'adb:10:30000:59': 56.4,
  'adb:10:30000:60': 56.4,
  'adb:10:30000:61': 19.2,
  'adb:10:30000:62': 19.2,
  'adb:10:30000:63': 19.2,
  'adb:10:30000:64': 19.2,
  'adb:10:30000:65': 19.2,
  'adb:10:30000:66': 19.2,
  'adb:10:30000:67': 19.2,
  'adb:10:30000:68': 19.2,
  'adb:10:30000:69': 19.2,
  'adb:10:30000:70': 19.2,
  'adb:10:30000:71': 40.8,
  'adb:10:30000:72': 40.8,
  'adb:10:30000:73': 40.8,
  'adb:10:30000:74': 40.8,
  'adb:10:30000:75': 40.8,
  'adb:10:30000:76': 73.2,
  'adb:10:30000:77': 73.2,
  'adb:10:30000:78': 73.2,
  'adb:10:30000:79': 73.2,
  'adb:10:30000:80': 73.2,
  'adb:10:30000:81': 103.2,
  'adb:10:30000:82': 103.2,
  'adb:10:30000:83': 103.2,
  'adb:10:30000:84': 103.2,
  'adb:10:30000:85': 103.2,
  'adb:10:30000:86': 150,
  'adb:10:30000:87': 150,
  'adb:10:30000:88': 150,
  'adb:10:30000:89': 150,
  'adb:10:30000:90': 150,
  'adb:10:30000:91': 225.6,
  'adb:10:30000:92': 225.6,
  'adb:10:30000:93': 225.6,
  'adb:10:30000:94': 225.6,
  'adb:10:30000:95': 225.6,
  'adb:10:30000:96': 423.6,
  'adb:10:30000:97': 423.6,
  'adb:10:30000:98': 423.6,
  'adb:10:30000:99': 423.6,
  'adb:10:30000:100': 423.6,
  'adb:10:30000:101': 12.26,
  'adb:10:30000:102': 12.26,
  'adb:10:30000:103': 12.26,
  'adb:10:30000:104': 12.26,
  'adb:10:30000:105': 12.26,
  'adb:10:30000:106': 12.38,
  'adb:10:30000:107': 12.38,
  'adb:10:30000:108': 12.38,
  'adb:10:30000:109': 12.38,
  'adb:10:30000:110': 12.38,
  'adb:10:30000:111': 12.38,
  'adb:10:30000:112': 12.38,
  'adb:10:30000:113': 12.38,
  'adb:10:30000:114': 12.38,
  'adb:10:30000:115': 12.38,
  'adb:10:30000:116': 12.38,
  'adb:10:30000:117': 12.38,
  'adb:10:30000:118': 12.38,
  'adb:10:30000:119': 12.38,
  'adb:10:30000:120': 12.38,
  'adb:10:40000:1': 31.2,
  'adb:10:40000:2': 31.2,
  'adb:10:40000:3': 31.2,
  'adb:10:40000:4': 31.2,
  'adb:10:40000:5': 31.2,
  'adb:10:40000:6': 31.2,
  'adb:10:40000:7': 31.2,
  'adb:10:40000:8': 31.2,
  'adb:10:40000:9': 31.2,
  'adb:10:40000:10': 31.2,
  'adb:10:40000:11': 31.2,
  'adb:10:40000:12': 31.2,
  'adb:10:40000:13': 31.2,
  'adb:10:40000:14': 31.2,
  'adb:10:40000:15': 31.2,
  'adb:10:40000:16': 31.2,
  'adb:10:40000:17': 31.2,
  'adb:10:40000:18': 31.2,
  'adb:10:40000:19': 31.2,
  'adb:10:40000:20': 31.2,
  'adb:10:40000:21': 31.2,
  'adb:10:40000:22': 31.2,
  'adb:10:40000:23': 31.2,
  'adb:10:40000:24': 31.2,
  'adb:10:40000:25': 31.2,
  'adb:10:40000:26': 32.4,
  'adb:10:40000:27': 32.4,
  'adb:10:40000:28': 32.4,
  'adb:10:40000:29': 32.4,
  'adb:10:40000:30': 32.4,
  'adb:10:40000:31': 37.2,
  'adb:10:40000:32': 37.2,
  'adb:10:40000:33': 37.2,
  'adb:10:40000:34': 37.2,
  'adb:10:40000:35': 37.2,
  'adb:10:40000:36': 45.6,
  'adb:10:40000:37': 45.6,
  'adb:10:40000:38': 45.6,
  'adb:10:40000:39': 45.6,
  'adb:10:40000:40': 45.6,
  'adb:10:40000:41': 58.8,
  'adb:10:40000:42': 58.8,
  'adb:10:40000:43': 58.8,
  'adb:10:40000:44': 58.8,
  'adb:10:40000:45': 58.8,
  'adb:10:40000:46': 79.2,
  'adb:10:40000:47': 79.2,
  'adb:10:40000:48': 79.2,
  'adb:10:40000:49': 79.2,
  'adb:10:40000:50': 79.2,
  'adb:10:40000:51': 110.4,
  'adb:10:40000:52': 110.4,
  'adb:10:40000:53': 110.4,
  'adb:10:40000:54': 110.4,
  'adb:10:40000:55': 110.4,
  'adb:10:40000:56': 75.6,
  'adb:10:40000:57': 75.6,
  'adb:10:40000:58': 75.6,
  'adb:10:40000:59': 75.6,
  'adb:10:40000:60': 75.6,
  'adb:10:40000:61': 25.2,
  'adb:10:40000:62': 25.2,
  'adb:10:40000:63': 25.2,
  'adb:10:40000:64': 25.2,
  'adb:10:40000:65': 25.2,
  'adb:10:40000:66': 25.2,
  'adb:10:40000:67': 25.2,
  'adb:10:40000:68': 25.2,
  'adb:10:40000:69': 25.2,
  'adb:10:40000:70': 25.2,
  'adb:10:40000:71': 54,
  'adb:10:40000:72': 54,
  'adb:10:40000:73': 54,
  'adb:10:40000:74': 54,
  'adb:10:40000:75': 54,
  'adb:10:40000:76': 97.2,
  'adb:10:40000:77': 97.2,
  'adb:10:40000:78': 97.2,
  'adb:10:40000:79': 97.2,
  'adb:10:40000:80': 97.2,
  'adb:10:40000:81': 138,
  'adb:10:40000:82': 138,
  'adb:10:40000:83': 138,
  'adb:10:40000:84': 138,
  'adb:10:40000:85': 138,
  'adb:10:40000:86': 200.4,
  'adb:10:40000:87': 200.4,
  'adb:10:40000:88': 200.4,
  'adb:10:40000:89': 200.4,
  'adb:10:40000:90': 200.4,
  'adb:10:40000:91': 300,
  'adb:10:40000:92': 300,
  'adb:10:40000:93': 300,
  'adb:10:40000:94': 300,
  'adb:10:40000:95': 300,
  'adb:10:40000:96': 564,
  'adb:10:40000:97': 564,
  'adb:10:40000:98': 564,
  'adb:10:40000:99': 564,
  'adb:10:40000:100': 564,
  'adb:10:40000:101': 16.36,
  'adb:10:40000:102': 16.36,
  'adb:10:40000:103': 16.36,
  'adb:10:40000:104': 16.36,
  'adb:10:40000:105': 16.36,
  'adb:10:40000:106': 16.52,
  'adb:10:40000:107': 16.52,
  'adb:10:40000:108': 16.52,
  'adb:10:40000:109': 16.52,
  'adb:10:40000:110': 16.52,
  'adb:10:40000:111': 16.52,
  'adb:10:40000:112': 16.52,
  'adb:10:40000:113': 16.52,
  'adb:10:40000:114': 16.52,
  'adb:10:40000:115': 16.52,
  'adb:10:40000:116': 16.52,
  'adb:10:40000:117': 16.52,
  'adb:10:40000:118': 16.52,
  'adb:10:40000:119': 16.52,
  'adb:10:40000:120': 16.52,
  'adb:10:50000:1': 38.4,
  'adb:10:50000:2': 38.4,
  'adb:10:50000:3': 38.4,
  'adb:10:50000:4': 38.4,
  'adb:10:50000:5': 38.4,
  'adb:10:50000:6': 38.4,
  'adb:10:50000:7': 38.4,
  'adb:10:50000:8': 38.4,
  'adb:10:50000:9': 38.4,
  'adb:10:50000:10': 38.4,
  'adb:10:50000:11': 38.4,
  'adb:10:50000:12': 38.4,
  'adb:10:50000:13': 38.4,
  'adb:10:50000:14': 38.4,
  'adb:10:50000:15': 38.4,
  'adb:10:50000:16': 38.4,
  'adb:10:50000:17': 38.4,
  'adb:10:50000:18': 38.4,
  'adb:10:50000:19': 38.4,
  'adb:10:50000:20': 38.4,
  'adb:10:50000:21': 39.6,
  'adb:10:50000:22': 39.6,
  'adb:10:50000:23': 39.6,
  'adb:10:50000:24': 39.6,
  'adb:10:50000:25': 39.6,
  'adb:10:50000:26': 40.8,
  'adb:10:50000:27': 40.8,
  'adb:10:50000:28': 40.8,
  'adb:10:50000:29': 40.8,
  'adb:10:50000:30': 40.8,
  'adb:10:50000:31': 46.8,
  'adb:10:50000:32': 46.8,
  'adb:10:50000:33': 46.8,
  'adb:10:50000:34': 46.8,
  'adb:10:50000:35': 46.8,
  'adb:10:50000:36': 57.6,
  'adb:10:50000:37': 57.6,
  'adb:10:50000:38': 57.6,
  'adb:10:50000:39': 57.6,
  'adb:10:50000:40': 57.6,
  'adb:10:50000:41': 73.2,
  'adb:10:50000:42': 73.2,
  'adb:10:50000:43': 73.2,
  'adb:10:50000:44': 73.2,
  'adb:10:50000:45': 73.2,
  'adb:10:50000:46': 98.4,
  'adb:10:50000:47': 98.4,
  'adb:10:50000:48': 98.4,
  'adb:10:50000:49': 98.4,
  'adb:10:50000:50': 98.4,
  'adb:10:50000:51': 136.8,
  'adb:10:50000:52': 136.8,
  'adb:10:50000:53': 136.8,
  'adb:10:50000:54': 136.8,
  'adb:10:50000:55': 136.8,
  'adb:10:50000:56': 94.8,
  'adb:10:50000:57': 94.8,
  'adb:10:50000:58': 94.8,
  'adb:10:50000:59': 94.8,
  'adb:10:50000:60': 94.8,
  'adb:10:50000:61': 31.2,
  'adb:10:50000:62': 31.2,
  'adb:10:50000:63': 31.2,
  'adb:10:50000:64': 31.2,
  'adb:10:50000:65': 31.2,
  'adb:10:50000:66': 31.2,
  'adb:10:50000:67': 31.2,
  'adb:10:50000:68': 31.2,
  'adb:10:50000:69': 31.2,
  'adb:10:50000:70': 31.2,
  'adb:10:50000:71': 67.2,
  'adb:10:50000:72': 67.2,
  'adb:10:50000:73': 67.2,
  'adb:10:50000:74': 67.2,
  'adb:10:50000:75': 67.2,
  'adb:10:50000:76': 122.4,
  'adb:10:50000:77': 122.4,
  'adb:10:50000:78': 122.4,
  'adb:10:50000:79': 122.4,
  'adb:10:50000:80': 122.4,
  'adb:10:50000:81': 171.6,
  'adb:10:50000:82': 171.6,
  'adb:10:50000:83': 171.6,
  'adb:10:50000:84': 171.6,
  'adb:10:50000:85': 171.6,
  'adb:10:50000:86': 249.6,
  'adb:10:50000:87': 249.6,
  'adb:10:50000:88': 249.6,
  'adb:10:50000:89': 249.6,
  'adb:10:50000:90': 249.6,
  'adb:10:50000:91': 375.6,
  'adb:10:50000:92': 375.6,
  'adb:10:50000:93': 375.6,
  'adb:10:50000:94': 375.6,
  'adb:10:50000:95': 375.6,
  'adb:10:50000:96': 705.6,
  'adb:10:50000:97': 705.6,
  'adb:10:50000:98': 705.6,
  'adb:10:50000:99': 705.6,
  'adb:10:50000:100': 705.6,
  'adb:10:50000:101': 20.45,
  'adb:10:50000:102': 20.45,
  'adb:10:50000:103': 20.45,
  'adb:10:50000:104': 20.45,
  'adb:10:50000:105': 20.45,
  'adb:10:50000:106': 20.65,
  'adb:10:50000:107': 20.65,
  'adb:10:50000:108': 20.65,
  'adb:10:50000:109': 20.65,
  'adb:10:50000:110': 20.65,
  'adb:10:50000:111': 20.65,
  'adb:10:50000:112': 20.65,
  'adb:10:50000:113': 20.65,
  'adb:10:50000:114': 20.65,
  'adb:10:50000:115': 20.65,
  'adb:10:50000:116': 20.65,
  'adb:10:50000:117': 20.65,
  'adb:10:50000:118': 20.65,
  'adb:10:50000:119': 20.65,
  'adb:10:50000:120': 20.65,
  'adb:10:60000:1': 46.08,
  'adb:10:60000:2': 46.08,
  'adb:10:60000:3': 46.08,
  'adb:10:60000:4': 46.08,
  'adb:10:60000:5': 46.08,
  'adb:10:60000:6': 46.08,
  'adb:10:60000:7': 46.08,
  'adb:10:60000:8': 46.08,
  'adb:10:60000:9': 46.08,
  'adb:10:60000:10': 46.08,
  'adb:10:60000:11': 46.08,
  'adb:10:60000:12': 46.08,
  'adb:10:60000:13': 46.08,
  'adb:10:60000:14': 46.08,
  'adb:10:60000:15': 46.08,
  'adb:10:60000:16': 46.08,
  'adb:10:60000:17': 46.08,
  'adb:10:60000:18': 46.08,
  'adb:10:60000:19': 46.08,
  'adb:10:60000:20': 46.08,
  'adb:10:60000:21': 47.52,
  'adb:10:60000:22': 47.52,
  'adb:10:60000:23': 47.52,
  'adb:10:60000:24': 47.52,
  'adb:10:60000:25': 47.52,
  'adb:10:60000:26': 48.96,
  'adb:10:60000:27': 48.96,
  'adb:10:60000:28': 48.96,
  'adb:10:60000:29': 48.96,
  'adb:10:60000:30': 48.96,
  'adb:10:60000:31': 56.16,
  'adb:10:60000:32': 56.16,
  'adb:10:60000:33': 56.16,
  'adb:10:60000:34': 56.16,
  'adb:10:60000:35': 56.16,
  'adb:10:60000:36': 69.12,
  'adb:10:60000:37': 69.12,
  'adb:10:60000:38': 69.12,
  'adb:10:60000:39': 69.12,
  'adb:10:60000:40': 69.12,
  'adb:10:60000:41': 87.84,
  'adb:10:60000:42': 87.84,
  'adb:10:60000:43': 87.84,
  'adb:10:60000:44': 87.84,
  'adb:10:60000:45': 87.84,
  'adb:10:60000:46': 118.08,
  'adb:10:60000:47': 118.08,
  'adb:10:60000:48': 118.08,
  'adb:10:60000:49': 118.08,
  'adb:10:60000:50': 118.08,
  'adb:10:60000:51': 164.16,
  'adb:10:60000:52': 164.16,
  'adb:10:60000:53': 164.16,
  'adb:10:60000:54': 164.16,
  'adb:10:60000:55': 164.16,
  'adb:10:60000:56': 113.76,
  'adb:10:60000:57': 113.76,
  'adb:10:60000:58': 113.76,
  'adb:10:60000:59': 113.76,
  'adb:10:60000:60': 113.76,
  'adb:10:60000:61': 37.44,
  'adb:10:60000:62': 37.44,
  'adb:10:60000:63': 37.44,
  'adb:10:60000:64': 37.44,
  'adb:10:60000:65': 37.44,
  'adb:10:60000:66': 37.44,
  'adb:10:60000:67': 37.44,
  'adb:10:60000:68': 37.44,
  'adb:10:60000:69': 37.44,
  'adb:10:60000:70': 37.44,
  'adb:10:60000:71': 80.64,
  'adb:10:60000:72': 80.64,
  'adb:10:60000:73': 80.64,
  'adb:10:60000:74': 80.64,
  'adb:10:60000:75': 80.64,
  'adb:10:60000:76': 146.88,
  'adb:10:60000:77': 146.88,
  'adb:10:60000:78': 146.88,
  'adb:10:60000:79': 146.88,
  'adb:10:60000:80': 146.88,
  'adb:10:60000:81': 205.92,
  'adb:10:60000:82': 205.92,
  'adb:10:60000:83': 205.92,
  'adb:10:60000:84': 205.92,
  'adb:10:60000:85': 205.92,
  'adb:10:60000:86': 299.52,
  'adb:10:60000:87': 299.52,
  'adb:10:60000:88': 299.52,
  'adb:10:60000:89': 299.52,
  'adb:10:60000:90': 299.52,
  'adb:10:60000:91': 450.72,
  'adb:10:60000:92': 450.72,
  'adb:10:60000:93': 450.72,
  'adb:10:60000:94': 450.72,
  'adb:10:60000:95': 450.72,
  'adb:10:60000:96': 846.72,
  'adb:10:60000:97': 846.72,
  'adb:10:60000:98': 846.72,
  'adb:10:60000:99': 846.72,
  'adb:10:60000:100': 846.72,
  'adb:10:60000:101': 24.54,
  'adb:10:60000:102': 24.54,
  'adb:10:60000:103': 24.54,
  'adb:10:60000:104': 24.54,
  'adb:10:60000:105': 24.54,
  'adb:10:60000:106': 24.78,
  'adb:10:60000:107': 24.78,
  'adb:10:60000:108': 24.78,
  'adb:10:60000:109': 24.78,
  'adb:10:60000:110': 24.78,
  'adb:10:60000:111': 24.78,
  'adb:10:60000:112': 24.78,
  'adb:10:60000:113': 24.78,
  'adb:10:60000:114': 24.78,
  'adb:10:60000:115': 24.78,
  'adb:10:60000:116': 24.78,
  'adb:10:60000:117': 24.78,
  'adb:10:60000:118': 24.78,
  'adb:10:60000:119': 24.78,
  'adb:10:60000:120': 24.78,
  'adb:10:70000:1': 53.76,
  'adb:10:70000:2': 53.76,
  'adb:10:70000:3': 53.76,
  'adb:10:70000:4': 53.76,
  'adb:10:70000:5': 53.76,
  'adb:10:70000:6': 53.76,
  'adb:10:70000:7': 53.76,
  'adb:10:70000:8': 53.76,
  'adb:10:70000:9': 53.76,
  'adb:10:70000:10': 53.76,
  'adb:10:70000:11': 53.76,
  'adb:10:70000:12': 53.76,
  'adb:10:70000:13': 53.76,
  'adb:10:70000:14': 53.76,
  'adb:10:70000:15': 53.76,
  'adb:10:70000:16': 53.76,
  'adb:10:70000:17': 53.76,
  'adb:10:70000:18': 53.76,
  'adb:10:70000:19': 53.76,
  'adb:10:70000:20': 53.76,
  'adb:10:70000:21': 55.44,
  'adb:10:70000:22': 55.44,
  'adb:10:70000:23': 55.44,
  'adb:10:70000:24': 55.44,
  'adb:10:70000:25': 55.44,
  'adb:10:70000:26': 57.12,
  'adb:10:70000:27': 57.12,
  'adb:10:70000:28': 57.12,
  'adb:10:70000:29': 57.12,
  'adb:10:70000:30': 57.12,
  'adb:10:70000:31': 65.52,
  'adb:10:70000:32': 65.52,
  'adb:10:70000:33': 65.52,
  'adb:10:70000:34': 65.52,
  'adb:10:70000:35': 65.52,
  'adb:10:70000:36': 80.64,
  'adb:10:70000:37': 80.64,
  'adb:10:70000:38': 80.64,
  'adb:10:70000:39': 80.64,
  'adb:10:70000:40': 80.64,
  'adb:10:70000:41': 102.48,
  'adb:10:70000:42': 102.48,
  'adb:10:70000:43': 102.48,
  'adb:10:70000:44': 102.48,
  'adb:10:70000:45': 102.48,
  'adb:10:70000:46': 137.76,
  'adb:10:70000:47': 137.76,
  'adb:10:70000:48': 137.76,
  'adb:10:70000:49': 137.76,
  'adb:10:70000:50': 137.76,
  'adb:10:70000:51': 191.52,
  'adb:10:70000:52': 191.52,
  'adb:10:70000:53': 191.52,
  'adb:10:70000:54': 191.52,
  'adb:10:70000:55': 191.52,
  'adb:10:70000:56': 132.72,
  'adb:10:70000:57': 132.72,
  'adb:10:70000:58': 132.72,
  'adb:10:70000:59': 132.72,
  'adb:10:70000:60': 132.72,
  'adb:10:70000:61': 43.68,
  'adb:10:70000:62': 43.68,
  'adb:10:70000:63': 43.68,
  'adb:10:70000:64': 43.68,
  'adb:10:70000:65': 43.68,
  'adb:10:70000:66': 43.68,
  'adb:10:70000:67': 43.68,
  'adb:10:70000:68': 43.68,
  'adb:10:70000:69': 43.68,
  'adb:10:70000:70': 43.68,
  'adb:10:70000:71': 94.08,
  'adb:10:70000:72': 94.08,
  'adb:10:70000:73': 94.08,
  'adb:10:70000:74': 94.08,
  'adb:10:70000:75': 94.08,
  'adb:10:70000:76': 171.36,
  'adb:10:70000:77': 171.36,
  'adb:10:70000:78': 171.36,
  'adb:10:70000:79': 171.36,
  'adb:10:70000:80': 171.36,
  'adb:10:70000:81': 240.24,
  'adb:10:70000:82': 240.24,
  'adb:10:70000:83': 240.24,
  'adb:10:70000:84': 240.24,
  'adb:10:70000:85': 240.24,
  'adb:10:70000:86': 349.44,
  'adb:10:70000:87': 349.44,
  'adb:10:70000:88': 349.44,
  'adb:10:70000:89': 349.44,
  'adb:10:70000:90': 349.44,
  'adb:10:70000:91': 525.84,
  'adb:10:70000:92': 525.84,
  'adb:10:70000:93': 525.84,
  'adb:10:70000:94': 525.84,
  'adb:10:70000:95': 525.84,
  'adb:10:70000:96': 987.84,
  'adb:10:70000:97': 987.84,
  'adb:10:70000:98': 987.84,
  'adb:10:70000:99': 987.84,
  'adb:10:70000:100': 987.84,
  'adb:10:70000:101': 28.63,
  'adb:10:70000:102': 28.63,
  'adb:10:70000:103': 28.63,
  'adb:10:70000:104': 28.63,
  'adb:10:70000:105': 28.63,
  'adb:10:70000:106': 28.91,
  'adb:10:70000:107': 28.91,
  'adb:10:70000:108': 28.91,
  'adb:10:70000:109': 28.91,
  'adb:10:70000:110': 28.91,
  'adb:10:70000:111': 28.91,
  'adb:10:70000:112': 28.91,
  'adb:10:70000:113': 28.91,
  'adb:10:70000:114': 28.91,
  'adb:10:70000:115': 28.91,
  'adb:10:70000:116': 28.91,
  'adb:10:70000:117': 28.91,
  'adb:10:70000:118': 28.91,
  'adb:10:70000:119': 28.91,
  'adb:10:70000:120': 28.91,
  'adb:10:80000:1': 61.44,
  'adb:10:80000:2': 61.44,
  'adb:10:80000:3': 61.44,
  'adb:10:80000:4': 61.44,
  'adb:10:80000:5': 61.44,
  'adb:10:80000:6': 61.44,
  'adb:10:80000:7': 61.44,
  'adb:10:80000:8': 61.44,
  'adb:10:80000:9': 61.44,
  'adb:10:80000:10': 61.44,
  'adb:10:80000:11': 61.44,
  'adb:10:80000:12': 61.44,
  'adb:10:80000:13': 61.44,
  'adb:10:80000:14': 61.44,
  'adb:10:80000:15': 61.44,
  'adb:10:80000:16': 61.44,
  'adb:10:80000:17': 61.44,
  'adb:10:80000:18': 61.44,
  'adb:10:80000:19': 61.44,
  'adb:10:80000:20': 61.44,
  'adb:10:80000:21': 63.36,
  'adb:10:80000:22': 63.36,
  'adb:10:80000:23': 63.36,
  'adb:10:80000:24': 63.36,
  'adb:10:80000:25': 63.36,
  'adb:10:80000:26': 65.28,
  'adb:10:80000:27': 65.28,
  'adb:10:80000:28': 65.28,
  'adb:10:80000:29': 65.28,
  'adb:10:80000:30': 65.28,
  'adb:10:80000:31': 74.88,
  'adb:10:80000:32': 74.88,
  'adb:10:80000:33': 74.88,
  'adb:10:80000:34': 74.88,
  'adb:10:80000:35': 74.88,
  'adb:10:80000:36': 92.16,
  'adb:10:80000:37': 92.16,
  'adb:10:80000:38': 92.16,
  'adb:10:80000:39': 92.16,
  'adb:10:80000:40': 92.16,
  'adb:10:80000:41': 117.12,
  'adb:10:80000:42': 117.12,
  'adb:10:80000:43': 117.12,
  'adb:10:80000:44': 117.12,
  'adb:10:80000:45': 117.12,
  'adb:10:80000:46': 157.44,
  'adb:10:80000:47': 157.44,
  'adb:10:80000:48': 157.44,
  'adb:10:80000:49': 157.44,
  'adb:10:80000:50': 157.44,
  'adb:10:80000:51': 218.88,
  'adb:10:80000:52': 218.88,
  'adb:10:80000:53': 218.88,
  'adb:10:80000:54': 218.88,
  'adb:10:80000:55': 218.88,
  'adb:10:80000:56': 151.68,
  'adb:10:80000:57': 151.68,
  'adb:10:80000:58': 151.68,
  'adb:10:80000:59': 151.68,
  'adb:10:80000:60': 151.68,
  'adb:10:80000:61': 49.92,
  'adb:10:80000:62': 49.92,
  'adb:10:80000:63': 49.92,
  'adb:10:80000:64': 49.92,
  'adb:10:80000:65': 49.92,
  'adb:10:80000:66': 49.92,
  'adb:10:80000:67': 49.92,
  'adb:10:80000:68': 49.92,
  'adb:10:80000:69': 49.92,
  'adb:10:80000:70': 49.92,
  'adb:10:80000:71': 107.52,
  'adb:10:80000:72': 107.52,
  'adb:10:80000:73': 107.52,
  'adb:10:80000:74': 107.52,
  'adb:10:80000:75': 107.52,
  'adb:10:80000:76': 195.84,
  'adb:10:80000:77': 195.84,
  'adb:10:80000:78': 195.84,
  'adb:10:80000:79': 195.84,
  'adb:10:80000:80': 195.84,
  'adb:10:80000:81': 274.56,
  'adb:10:80000:82': 274.56,
  'adb:10:80000:83': 274.56,
  'adb:10:80000:84': 274.56,
  'adb:10:80000:85': 274.56,
  'adb:10:80000:86': 399.36,
  'adb:10:80000:87': 399.36,
  'adb:10:80000:88': 399.36,
  'adb:10:80000:89': 399.36,
  'adb:10:80000:90': 399.36,
  'adb:10:80000:91': 600.96,
  'adb:10:80000:92': 600.96,
  'adb:10:80000:93': 600.96,
  'adb:10:80000:94': 600.96,
  'adb:10:80000:95': 600.96,
  'adb:10:80000:96': 1128.96,
  'adb:10:80000:97': 1128.96,
  'adb:10:80000:98': 1128.96,
  'adb:10:80000:99': 1128.96,
  'adb:10:80000:100': 1128.96,
  'adb:10:80000:101': 32.72,
  'adb:10:80000:102': 32.72,
  'adb:10:80000:103': 32.72,
  'adb:10:80000:104': 32.72,
  'adb:10:80000:105': 32.72,
  'adb:10:80000:106': 33.04,
  'adb:10:80000:107': 33.04,
  'adb:10:80000:108': 33.04,
  'adb:10:80000:109': 33.04,
  'adb:10:80000:110': 33.04,
  'adb:10:80000:111': 33.04,
  'adb:10:80000:112': 33.04,
  'adb:10:80000:113': 33.04,
  'adb:10:80000:114': 33.04,
  'adb:10:80000:115': 33.04,
  'adb:10:80000:116': 33.04,
  'adb:10:80000:117': 33.04,
  'adb:10:80000:118': 33.04,
  'adb:10:80000:119': 33.04,
  'adb:10:80000:120': 33.04,
  'adb:10:90000:1': 69.12,
  'adb:10:90000:2': 69.12,
  'adb:10:90000:3': 69.12,
  'adb:10:90000:4': 69.12,
  'adb:10:90000:5': 69.12,
  'adb:10:90000:6': 69.12,
  'adb:10:90000:7': 69.12,
  'adb:10:90000:8': 69.12,
  'adb:10:90000:9': 69.12,
  'adb:10:90000:10': 69.12,
  'adb:10:90000:11': 69.12,
  'adb:10:90000:12': 69.12,
  'adb:10:90000:13': 69.12,
  'adb:10:90000:14': 69.12,
  'adb:10:90000:15': 69.12,
  'adb:10:90000:16': 69.12,
  'adb:10:90000:17': 69.12,
  'adb:10:90000:18': 69.12,
  'adb:10:90000:19': 69.12,
  'adb:10:90000:20': 69.12,
  'adb:10:90000:21': 71.28,
  'adb:10:90000:22': 71.28,
  'adb:10:90000:23': 71.28,
  'adb:10:90000:24': 71.28,
  'adb:10:90000:25': 71.28,
  'adb:10:90000:26': 73.44,
  'adb:10:90000:27': 73.44,
  'adb:10:90000:28': 73.44,
  'adb:10:90000:29': 73.44,
  'adb:10:90000:30': 73.44,
  'adb:10:90000:31': 84.24,
  'adb:10:90000:32': 84.24,
  'adb:10:90000:33': 84.24,
  'adb:10:90000:34': 84.24,
  'adb:10:90000:35': 84.24,
  'adb:10:90000:36': 103.68,
  'adb:10:90000:37': 103.68,
  'adb:10:90000:38': 103.68,
  'adb:10:90000:39': 103.68,
  'adb:10:90000:40': 103.68,
  'adb:10:90000:41': 131.76,
  'adb:10:90000:42': 131.76,
  'adb:10:90000:43': 131.76,
  'adb:10:90000:44': 131.76,
  'adb:10:90000:45': 131.76,
  'adb:10:90000:46': 177.12,
  'adb:10:90000:47': 177.12,
  'adb:10:90000:48': 177.12,
  'adb:10:90000:49': 177.12,
  'adb:10:90000:50': 177.12,
  'adb:10:90000:51': 246.24,
  'adb:10:90000:52': 246.24,
  'adb:10:90000:53': 246.24,
  'adb:10:90000:54': 246.24,
  'adb:10:90000:55': 246.24,
  'adb:10:90000:56': 170.64,
  'adb:10:90000:57': 170.64,
  'adb:10:90000:58': 170.64,
  'adb:10:90000:59': 170.64,
  'adb:10:90000:60': 170.64,
  'adb:10:90000:61': 56.16,
  'adb:10:90000:62': 56.16,
  'adb:10:90000:63': 56.16,
  'adb:10:90000:64': 56.16,
  'adb:10:90000:65': 56.16,
  'adb:10:90000:66': 56.16,
  'adb:10:90000:67': 56.16,
  'adb:10:90000:68': 56.16,
  'adb:10:90000:69': 56.16,
  'adb:10:90000:70': 56.16,
  'adb:10:90000:71': 120.96,
  'adb:10:90000:72': 120.96,
  'adb:10:90000:73': 120.96,
  'adb:10:90000:74': 120.96,
  'adb:10:90000:75': 120.96,
  'adb:10:90000:76': 220.32,
  'adb:10:90000:77': 220.32,
  'adb:10:90000:78': 220.32,
  'adb:10:90000:79': 220.32,
  'adb:10:90000:80': 220.32,
  'adb:10:90000:81': 308.88,
  'adb:10:90000:82': 308.88,
  'adb:10:90000:83': 308.88,
  'adb:10:90000:84': 308.88,
  'adb:10:90000:85': 308.88,
  'adb:10:90000:86': 449.28,
  'adb:10:90000:87': 449.28,
  'adb:10:90000:88': 449.28,
  'adb:10:90000:89': 449.28,
  'adb:10:90000:90': 449.28,
  'adb:10:90000:91': 676.08,
  'adb:10:90000:92': 676.08,
  'adb:10:90000:93': 676.08,
  'adb:10:90000:94': 676.08,
  'adb:10:90000:95': 676.08,
  'adb:10:90000:96': 1270.08,
  'adb:10:90000:97': 1270.08,
  'adb:10:90000:98': 1270.08,
  'adb:10:90000:99': 1270.08,
  'adb:10:90000:100': 1270.08,
  'adb:10:90000:101': 36.81,
  'adb:10:90000:102': 36.81,
  'adb:10:90000:103': 36.81,
  'adb:10:90000:104': 36.81,
  'adb:10:90000:105': 36.81,
  'adb:10:90000:106': 37.17,
  'adb:10:90000:107': 37.17,
  'adb:10:90000:108': 37.17,
  'adb:10:90000:109': 37.17,
  'adb:10:90000:110': 37.17,
  'adb:10:90000:111': 37.17,
  'adb:10:90000:112': 37.17,
  'adb:10:90000:113': 37.17,
  'adb:10:90000:114': 37.17,
  'adb:10:90000:115': 37.17,
  'adb:10:90000:116': 37.17,
  'adb:10:90000:117': 37.17,
  'adb:10:90000:118': 37.17,
  'adb:10:90000:119': 37.17,
  'adb:10:90000:120': 37.17,
  'adb:10:100000:1': 76.8,
  'adb:10:100000:2': 76.8,
  'adb:10:100000:3': 76.8,
  'adb:10:100000:4': 76.8,
  'adb:10:100000:5': 76.8,
  'adb:10:100000:6': 76.8,
  'adb:10:100000:7': 76.8,
  'adb:10:100000:8': 76.8,
  'adb:10:100000:9': 76.8,
  'adb:10:100000:10': 76.8,
  'adb:10:100000:11': 76.8,
  'adb:10:100000:12': 76.8,
  'adb:10:100000:13': 76.8,
  'adb:10:100000:14': 76.8,
  'adb:10:100000:15': 76.8,
  'adb:10:100000:16': 76.8,
  'adb:10:100000:17': 76.8,
  'adb:10:100000:18': 76.8,
  'adb:10:100000:19': 76.8,
  'adb:10:100000:20': 76.8,
  'adb:10:100000:21': 79.2,
  'adb:10:100000:22': 79.2,
  'adb:10:100000:23': 79.2,
  'adb:10:100000:24': 79.2,
  'adb:10:100000:25': 79.2,
  'adb:10:100000:26': 81.6,
  'adb:10:100000:27': 81.6,
  'adb:10:100000:28': 81.6,
  'adb:10:100000:29': 81.6,
  'adb:10:100000:30': 81.6,
  'adb:10:100000:31': 93.6,
  'adb:10:100000:32': 93.6,
  'adb:10:100000:33': 93.6,
  'adb:10:100000:34': 93.6,
  'adb:10:100000:35': 93.6,
  'adb:10:100000:36': 115.2,
  'adb:10:100000:37': 115.2,
  'adb:10:100000:38': 115.2,
  'adb:10:100000:39': 115.2,
  'adb:10:100000:40': 115.2,
  'adb:10:100000:41': 146.4,
  'adb:10:100000:42': 146.4,
  'adb:10:100000:43': 146.4,
  'adb:10:100000:44': 146.4,
  'adb:10:100000:45': 146.4,
  'adb:10:100000:46': 196.8,
  'adb:10:100000:47': 196.8,
  'adb:10:100000:48': 196.8,
  'adb:10:100000:49': 196.8,
  'adb:10:100000:50': 196.8,
  'adb:10:100000:51': 273.6,
  'adb:10:100000:52': 273.6,
  'adb:10:100000:53': 273.6,
  'adb:10:100000:54': 273.6,
  'adb:10:100000:55': 273.6,
  'adb:10:100000:56': 189.6,
  'adb:10:100000:57': 189.6,
  'adb:10:100000:58': 189.6,
  'adb:10:100000:59': 189.6,
  'adb:10:100000:60': 189.6,
  'adb:10:100000:61': 62.4,
  'adb:10:100000:62': 62.4,
  'adb:10:100000:63': 62.4,
  'adb:10:100000:64': 62.4,
  'adb:10:100000:65': 62.4,
  'adb:10:100000:66': 62.4,
  'adb:10:100000:67': 62.4,
  'adb:10:100000:68': 62.4,
  'adb:10:100000:69': 62.4,
  'adb:10:100000:70': 62.4,
  'adb:10:100000:71': 134.4,
  'adb:10:100000:72': 134.4,
  'adb:10:100000:73': 134.4,
  'adb:10:100000:74': 134.4,
  'adb:10:100000:75': 134.4,
  'adb:10:100000:76': 244.8,
  'adb:10:100000:77': 244.8,
  'adb:10:100000:78': 244.8,
  'adb:10:100000:79': 244.8,
  'adb:10:100000:80': 244.8,
  'adb:10:100000:81': 343.2,
  'adb:10:100000:82': 343.2,
  'adb:10:100000:83': 343.2,
  'adb:10:100000:84': 343.2,
  'adb:10:100000:85': 343.2,
  'adb:10:100000:86': 499.2,
  'adb:10:100000:87': 499.2,
  'adb:10:100000:88': 499.2,
  'adb:10:100000:89': 499.2,
  'adb:10:100000:90': 499.2,
  'adb:10:100000:91': 751.2,
  'adb:10:100000:92': 751.2,
  'adb:10:100000:93': 751.2,
  'adb:10:100000:94': 751.2,
  'adb:10:100000:95': 751.2,
  'adb:10:100000:96': 1411.2,
  'adb:10:100000:97': 1411.2,
  'adb:10:100000:98': 1411.2,
  'adb:10:100000:99': 1411.2,
  'adb:10:100000:100': 1411.2,
  'adb:10:100000:101': 40.9,
  'adb:10:100000:102': 40.9,
  'adb:10:100000:103': 40.9,
  'adb:10:100000:104': 40.9,
  'adb:10:100000:105': 40.9,
  'adb:10:100000:106': 41.3,
  'adb:10:100000:107': 41.3,
  'adb:10:100000:108': 41.3,
  'adb:10:100000:109': 41.3,
  'adb:10:100000:110': 41.3,
  'adb:10:100000:111': 41.3,
  'adb:10:100000:112': 41.3,
  'adb:10:100000:113': 41.3,
  'adb:10:100000:114': 41.3,
  'adb:10:100000:115': 41.3,
  'adb:10:100000:116': 41.3,
  'adb:10:100000:117': 41.3,
  'adb:10:100000:118': 41.3,
  'adb:10:100000:119': 41.3,
  'adb:10:100000:120': 41.3,
  'adb:10:120000:1': 92.16,
  'adb:10:120000:2': 92.16,
  'adb:10:120000:3': 92.16,
  'adb:10:120000:4': 92.16,
  'adb:10:120000:5': 92.16,
  'adb:10:120000:6': 92.16,
  'adb:10:120000:7': 92.16,
  'adb:10:120000:8': 92.16,
  'adb:10:120000:9': 92.16,
  'adb:10:120000:10': 92.16,
  'adb:10:120000:11': 92.16,
  'adb:10:120000:12': 92.16,
  'adb:10:120000:13': 92.16,
  'adb:10:120000:14': 92.16,
  'adb:10:120000:15': 92.16,
  'adb:10:120000:16': 92.16,
  'adb:10:120000:17': 92.16,
  'adb:10:120000:18': 92.16,
  'adb:10:120000:19': 92.16,
  'adb:10:120000:20': 92.16,
  'adb:10:120000:21': 95.04,
  'adb:10:120000:22': 95.04,
  'adb:10:120000:23': 95.04,
  'adb:10:120000:24': 95.04,
  'adb:10:120000:25': 95.04,
  'adb:10:120000:26': 97.92,
  'adb:10:120000:27': 97.92,
  'adb:10:120000:28': 97.92,
  'adb:10:120000:29': 97.92,
  'adb:10:120000:30': 97.92,
  'adb:10:120000:31': 112.32,
  'adb:10:120000:32': 112.32,
  'adb:10:120000:33': 112.32,
  'adb:10:120000:34': 112.32,
  'adb:10:120000:35': 112.32,
  'adb:10:120000:36': 138.24,
  'adb:10:120000:37': 138.24,
  'adb:10:120000:38': 138.24,
  'adb:10:120000:39': 138.24,
  'adb:10:120000:40': 138.24,
  'adb:10:120000:41': 175.68,
  'adb:10:120000:42': 175.68,
  'adb:10:120000:43': 175.68,
  'adb:10:120000:44': 175.68,
  'adb:10:120000:45': 175.68,
  'adb:10:120000:46': 236.16,
  'adb:10:120000:47': 236.16,
  'adb:10:120000:48': 236.16,
  'adb:10:120000:49': 236.16,
  'adb:10:120000:50': 236.16,
  'adb:10:120000:51': 328.32,
  'adb:10:120000:52': 328.32,
  'adb:10:120000:53': 328.32,
  'adb:10:120000:54': 328.32,
  'adb:10:120000:55': 328.32,
  'adb:10:120000:56': 227.52,
  'adb:10:120000:57': 227.52,
  'adb:10:120000:58': 227.52,
  'adb:10:120000:59': 227.52,
  'adb:10:120000:60': 227.52,
  'adb:10:120000:61': 74.88,
  'adb:10:120000:62': 74.88,
  'adb:10:120000:63': 74.88,
  'adb:10:120000:64': 74.88,
  'adb:10:120000:65': 74.88,
  'adb:10:120000:66': 74.88,
  'adb:10:120000:67': 74.88,
  'adb:10:120000:68': 74.88,
  'adb:10:120000:69': 74.88,
  'adb:10:120000:70': 74.88,
  'adb:10:120000:71': 161.28,
  'adb:10:120000:72': 161.28,
  'adb:10:120000:73': 161.28,
  'adb:10:120000:74': 161.28,
  'adb:10:120000:75': 161.28,
  'adb:10:120000:76': 293.76,
  'adb:10:120000:77': 293.76,
  'adb:10:120000:78': 293.76,
  'adb:10:120000:79': 293.76,
  'adb:10:120000:80': 293.76,
  'adb:10:120000:81': 411.84,
  'adb:10:120000:82': 411.84,
  'adb:10:120000:83': 411.84,
  'adb:10:120000:84': 411.84,
  'adb:10:120000:85': 411.84,
  'adb:10:120000:86': 599.04,
  'adb:10:120000:87': 599.04,
  'adb:10:120000:88': 599.04,
  'adb:10:120000:89': 599.04,
  'adb:10:120000:90': 599.04,
  'adb:10:120000:91': 901.44,
  'adb:10:120000:92': 901.44,
  'adb:10:120000:93': 901.44,
  'adb:10:120000:94': 901.44,
  'adb:10:120000:95': 901.44,
  'adb:10:120000:96': 1693.44,
  'adb:10:120000:97': 1693.44,
  'adb:10:120000:98': 1693.44,
  'adb:10:120000:99': 1693.44,
  'adb:10:120000:100': 1693.44,
  'adb:10:120000:101': 49.08,
  'adb:10:120000:102': 49.08,
  'adb:10:120000:103': 49.08,
  'adb:10:120000:104': 49.08,
  'adb:10:120000:105': 49.08,
  'adb:10:120000:106': 49.56,
  'adb:10:120000:107': 49.56,
  'adb:10:120000:108': 49.56,
  'adb:10:120000:109': 49.56,
  'adb:10:120000:110': 49.56,
  'adb:10:120000:111': 49.56,
  'adb:10:120000:112': 49.56,
  'adb:10:120000:113': 49.56,
  'adb:10:120000:114': 49.56,
  'adb:10:120000:115': 49.56,
  'adb:10:120000:116': 49.56,
  'adb:10:120000:117': 49.56,
  'adb:10:120000:118': 49.56,
  'adb:10:120000:119': 49.56,
  'adb:10:120000:120': 49.56,
  'adb:10:140000:1': 107.52,
  'adb:10:140000:2': 107.52,
  'adb:10:140000:3': 107.52,
  'adb:10:140000:4': 107.52,
  'adb:10:140000:5': 107.52,
  'adb:10:140000:6': 107.52,
  'adb:10:140000:7': 107.52,
  'adb:10:140000:8': 107.52,
  'adb:10:140000:9': 107.52,
  'adb:10:140000:10': 107.52,
  'adb:10:140000:11': 107.52,
  'adb:10:140000:12': 107.52,
  'adb:10:140000:13': 107.52,
  'adb:10:140000:14': 107.52,
  'adb:10:140000:15': 107.52,
  'adb:10:140000:16': 107.52,
  'adb:10:140000:17': 107.52,
  'adb:10:140000:18': 107.52,
  'adb:10:140000:19': 107.52,
  'adb:10:140000:20': 107.52,
  'adb:10:140000:21': 110.88,
  'adb:10:140000:22': 110.88,
  'adb:10:140000:23': 110.88,
  'adb:10:140000:24': 110.88,
  'adb:10:140000:25': 110.88,
  'adb:10:140000:26': 114.24,
  'adb:10:140000:27': 114.24,
  'adb:10:140000:28': 114.24,
  'adb:10:140000:29': 114.24,
  'adb:10:140000:30': 114.24,
  'adb:10:140000:31': 131.04,
  'adb:10:140000:32': 131.04,
  'adb:10:140000:33': 131.04,
  'adb:10:140000:34': 131.04,
  'adb:10:140000:35': 131.04,
  'adb:10:140000:36': 161.28,
  'adb:10:140000:37': 161.28,
  'adb:10:140000:38': 161.28,
  'adb:10:140000:39': 161.28,
  'adb:10:140000:40': 161.28,
  'adb:10:140000:41': 204.96,
  'adb:10:140000:42': 204.96,
  'adb:10:140000:43': 204.96,
  'adb:10:140000:44': 204.96,
  'adb:10:140000:45': 204.96,
  'adb:10:140000:46': 275.52,
  'adb:10:140000:47': 275.52,
  'adb:10:140000:48': 275.52,
  'adb:10:140000:49': 275.52,
  'adb:10:140000:50': 275.52,
  'adb:10:140000:51': 383.04,
  'adb:10:140000:52': 383.04,
  'adb:10:140000:53': 383.04,
  'adb:10:140000:54': 383.04,
  'adb:10:140000:55': 383.04,
  'adb:10:140000:56': 265.44,
  'adb:10:140000:57': 265.44,
  'adb:10:140000:58': 265.44,
  'adb:10:140000:59': 265.44,
  'adb:10:140000:60': 265.44,
  'adb:10:140000:61': 87.36,
  'adb:10:140000:62': 87.36,
  'adb:10:140000:63': 87.36,
  'adb:10:140000:64': 87.36,
  'adb:10:140000:65': 87.36,
  'adb:10:140000:66': 87.36,
  'adb:10:140000:67': 87.36,
  'adb:10:140000:68': 87.36,
  'adb:10:140000:69': 87.36,
  'adb:10:140000:70': 87.36,
  'adb:10:140000:71': 188.16,
  'adb:10:140000:72': 188.16,
  'adb:10:140000:73': 188.16,
  'adb:10:140000:74': 188.16,
  'adb:10:140000:75': 188.16,
  'adb:10:140000:76': 342.72,
  'adb:10:140000:77': 342.72,
  'adb:10:140000:78': 342.72,
  'adb:10:140000:79': 342.72,
  'adb:10:140000:80': 342.72,
  'adb:10:140000:81': 480.48,
  'adb:10:140000:82': 480.48,
  'adb:10:140000:83': 480.48,
  'adb:10:140000:84': 480.48,
  'adb:10:140000:85': 480.48,
  'adb:10:140000:86': 698.88,
  'adb:10:140000:87': 698.88,
  'adb:10:140000:88': 698.88,
  'adb:10:140000:89': 698.88,
  'adb:10:140000:90': 698.88,
  'adb:10:140000:91': 1051.68,
  'adb:10:140000:92': 1051.68,
  'adb:10:140000:93': 1051.68,
  'adb:10:140000:94': 1051.68,
  'adb:10:140000:95': 1051.68,
  'adb:10:140000:96': 1975.68,
  'adb:10:140000:97': 1975.68,
  'adb:10:140000:98': 1975.68,
  'adb:10:140000:99': 1975.68,
  'adb:10:140000:100': 1975.68,
  'adb:10:140000:101': 57.27,
  'adb:10:140000:102': 57.27,
  'adb:10:140000:103': 57.27,
  'adb:10:140000:104': 57.27,
  'adb:10:140000:105': 57.27,
  'adb:10:140000:106': 57.82,
  'adb:10:140000:107': 57.82,
  'adb:10:140000:108': 57.82,
  'adb:10:140000:109': 57.82,
  'adb:10:140000:110': 57.82,
  'adb:10:140000:111': 57.82,
  'adb:10:140000:112': 57.82,
  'adb:10:140000:113': 57.82,
  'adb:10:140000:114': 57.82,
  'adb:10:140000:115': 57.82,
  'adb:10:140000:116': 57.82,
  'adb:10:140000:117': 57.82,
  'adb:10:140000:118': 57.82,
  'adb:10:140000:119': 57.82,
  'adb:10:140000:120': 57.82,
  'adb:10:160000:1': 122.88,
  'adb:10:160000:2': 122.88,
  'adb:10:160000:3': 122.88,
  'adb:10:160000:4': 122.88,
  'adb:10:160000:5': 122.88,
  'adb:10:160000:6': 122.88,
  'adb:10:160000:7': 122.88,
  'adb:10:160000:8': 122.88,
  'adb:10:160000:9': 122.88,
  'adb:10:160000:10': 122.88,
  'adb:10:160000:11': 122.88,
  'adb:10:160000:12': 122.88,
  'adb:10:160000:13': 122.88,
  'adb:10:160000:14': 122.88,
  'adb:10:160000:15': 122.88,
  'adb:10:160000:16': 122.88,
  'adb:10:160000:17': 122.88,
  'adb:10:160000:18': 122.88,
  'adb:10:160000:19': 122.88,
  'adb:10:160000:20': 122.88,
  'adb:10:160000:21': 126.72,
  'adb:10:160000:22': 126.72,
  'adb:10:160000:23': 126.72,
  'adb:10:160000:24': 126.72,
  'adb:10:160000:25': 126.72,
  'adb:10:160000:26': 130.56,
  'adb:10:160000:27': 130.56,
  'adb:10:160000:28': 130.56,
  'adb:10:160000:29': 130.56,
  'adb:10:160000:30': 130.56,
  'adb:10:160000:31': 149.76,
  'adb:10:160000:32': 149.76,
  'adb:10:160000:33': 149.76,
  'adb:10:160000:34': 149.76,
  'adb:10:160000:35': 149.76,
  'adb:10:160000:36': 184.32,
  'adb:10:160000:37': 184.32,
  'adb:10:160000:38': 184.32,
  'adb:10:160000:39': 184.32,
  'adb:10:160000:40': 184.32,
  'adb:10:160000:41': 234.24,
  'adb:10:160000:42': 234.24,
  'adb:10:160000:43': 234.24,
  'adb:10:160000:44': 234.24,
  'adb:10:160000:45': 234.24,
  'adb:10:160000:46': 314.88,
  'adb:10:160000:47': 314.88,
  'adb:10:160000:48': 314.88,
  'adb:10:160000:49': 314.88,
  'adb:10:160000:50': 314.88,
  'adb:10:160000:51': 437.76,
  'adb:10:160000:52': 437.76,
  'adb:10:160000:53': 437.76,
  'adb:10:160000:54': 437.76,
  'adb:10:160000:55': 437.76,
  'adb:10:160000:56': 303.36,
  'adb:10:160000:57': 303.36,
  'adb:10:160000:58': 303.36,
  'adb:10:160000:59': 303.36,
  'adb:10:160000:60': 303.36,
  'adb:10:160000:61': 99.84,
  'adb:10:160000:62': 99.84,
  'adb:10:160000:63': 99.84,
  'adb:10:160000:64': 99.84,
  'adb:10:160000:65': 99.84,
  'adb:10:160000:66': 99.84,
  'adb:10:160000:67': 99.84,
  'adb:10:160000:68': 99.84,
  'adb:10:160000:69': 99.84,
  'adb:10:160000:70': 99.84,
  'adb:10:160000:71': 215.04,
  'adb:10:160000:72': 215.04,
  'adb:10:160000:73': 215.04,
  'adb:10:160000:74': 215.04,
  'adb:10:160000:75': 215.04,
  'adb:10:160000:76': 391.68,
  'adb:10:160000:77': 391.68,
  'adb:10:160000:78': 391.68,
  'adb:10:160000:79': 391.68,
  'adb:10:160000:80': 391.68,
  'adb:10:160000:81': 549.12,
  'adb:10:160000:82': 549.12,
  'adb:10:160000:83': 549.12,
  'adb:10:160000:84': 549.12,
  'adb:10:160000:85': 549.12,
  'adb:10:160000:86': 798.72,
  'adb:10:160000:87': 798.72,
  'adb:10:160000:88': 798.72,
  'adb:10:160000:89': 798.72,
  'adb:10:160000:90': 798.72,
  'adb:10:160000:91': 1201.92,
  'adb:10:160000:92': 1201.92,
  'adb:10:160000:93': 1201.92,
  'adb:10:160000:94': 1201.92,
  'adb:10:160000:95': 1201.92,
  'adb:10:160000:96': 2257.92,
  'adb:10:160000:97': 2257.92,
  'adb:10:160000:98': 2257.92,
  'adb:10:160000:99': 2257.92,
  'adb:10:160000:100': 2257.92,
  'adb:10:160000:101': 65.45,
  'adb:10:160000:102': 65.45,
  'adb:10:160000:103': 65.45,
  'adb:10:160000:104': 65.45,
  'adb:10:160000:105': 65.45,
  'adb:10:160000:106': 66.08,
  'adb:10:160000:107': 66.08,
  'adb:10:160000:108': 66.08,
  'adb:10:160000:109': 66.08,
  'adb:10:160000:110': 66.08,
  'adb:10:160000:111': 66.08,
  'adb:10:160000:112': 66.08,
  'adb:10:160000:113': 66.08,
  'adb:10:160000:114': 66.08,
  'adb:10:160000:115': 66.08,
  'adb:10:160000:116': 66.08,
  'adb:10:160000:117': 66.08,
  'adb:10:160000:118': 66.08,
  'adb:10:160000:119': 66.08,
  'adb:10:160000:120': 66.08,
  'adb:10:180000:1': 138.24,
  'adb:10:180000:2': 138.24,
  'adb:10:180000:3': 138.24,
  'adb:10:180000:4': 138.24,
  'adb:10:180000:5': 138.24,
  'adb:10:180000:6': 138.24,
  'adb:10:180000:7': 138.24,
  'adb:10:180000:8': 138.24,
  'adb:10:180000:9': 138.24,
  'adb:10:180000:10': 138.24,
  'adb:10:180000:11': 138.24,
  'adb:10:180000:12': 138.24,
  'adb:10:180000:13': 138.24,
  'adb:10:180000:14': 138.24,
  'adb:10:180000:15': 138.24,
  'adb:10:180000:16': 138.24,
  'adb:10:180000:17': 138.24,
  'adb:10:180000:18': 138.24,
  'adb:10:180000:19': 138.24,
  'adb:10:180000:20': 138.24,
  'adb:10:180000:21': 142.56,
  'adb:10:180000:22': 142.56,
  'adb:10:180000:23': 142.56,
  'adb:10:180000:24': 142.56,
  'adb:10:180000:25': 142.56,
  'adb:10:180000:26': 146.88,
  'adb:10:180000:27': 146.88,
  'adb:10:180000:28': 146.88,
  'adb:10:180000:29': 146.88,
  'adb:10:180000:30': 146.88,
  'adb:10:180000:31': 168.48,
  'adb:10:180000:32': 168.48,
  'adb:10:180000:33': 168.48,
  'adb:10:180000:34': 168.48,
  'adb:10:180000:35': 168.48,
  'adb:10:180000:36': 207.36,
  'adb:10:180000:37': 207.36,
  'adb:10:180000:38': 207.36,
  'adb:10:180000:39': 207.36,
  'adb:10:180000:40': 207.36,
  'adb:10:180000:41': 263.52,
  'adb:10:180000:42': 263.52,
  'adb:10:180000:43': 263.52,
  'adb:10:180000:44': 263.52,
  'adb:10:180000:45': 263.52,
  'adb:10:180000:46': 354.24,
  'adb:10:180000:47': 354.24,
  'adb:10:180000:48': 354.24,
  'adb:10:180000:49': 354.24,
  'adb:10:180000:50': 354.24,
  'adb:10:180000:51': 492.48,
  'adb:10:180000:52': 492.48,
  'adb:10:180000:53': 492.48,
  'adb:10:180000:54': 492.48,
  'adb:10:180000:55': 492.48,
  'adb:10:180000:56': 341.28,
  'adb:10:180000:57': 341.28,
  'adb:10:180000:58': 341.28,
  'adb:10:180000:59': 341.28,
  'adb:10:180000:60': 341.28,
  'adb:10:180000:61': 112.32,
  'adb:10:180000:62': 112.32,
  'adb:10:180000:63': 112.32,
  'adb:10:180000:64': 112.32,
  'adb:10:180000:65': 112.32,
  'adb:10:180000:66': 112.32,
  'adb:10:180000:67': 112.32,
  'adb:10:180000:68': 112.32,
  'adb:10:180000:69': 112.32,
  'adb:10:180000:70': 112.32,
  'adb:10:180000:71': 241.92,
  'adb:10:180000:72': 241.92,
  'adb:10:180000:73': 241.92,
  'adb:10:180000:74': 241.92,
  'adb:10:180000:75': 241.92,
  'adb:10:180000:76': 440.64,
  'adb:10:180000:77': 440.64,
  'adb:10:180000:78': 440.64,
  'adb:10:180000:79': 440.64,
  'adb:10:180000:80': 440.64,
  'adb:10:180000:81': 617.76,
  'adb:10:180000:82': 617.76,
  'adb:10:180000:83': 617.76,
  'adb:10:180000:84': 617.76,
  'adb:10:180000:85': 617.76,
  'adb:10:180000:86': 898.56,
  'adb:10:180000:87': 898.56,
  'adb:10:180000:88': 898.56,
  'adb:10:180000:89': 898.56,
  'adb:10:180000:90': 898.56,
  'adb:10:180000:91': 1352.16,
  'adb:10:180000:92': 1352.16,
  'adb:10:180000:93': 1352.16,
  'adb:10:180000:94': 1352.16,
  'adb:10:180000:95': 1352.16,
  'adb:10:180000:96': 2540.16,
  'adb:10:180000:97': 2540.16,
  'adb:10:180000:98': 2540.16,
  'adb:10:180000:99': 2540.16,
  'adb:10:180000:100': 2540.16,
  'adb:10:180000:101': 73.63,
  'adb:10:180000:102': 73.63,
  'adb:10:180000:103': 73.63,
  'adb:10:180000:104': 73.63,
  'adb:10:180000:105': 73.63,
  'adb:10:180000:106': 74.34,
  'adb:10:180000:107': 74.34,
  'adb:10:180000:108': 74.34,
  'adb:10:180000:109': 74.34,
  'adb:10:180000:110': 74.34,
  'adb:10:180000:111': 74.34,
  'adb:10:180000:112': 74.34,
  'adb:10:180000:113': 74.34,
  'adb:10:180000:114': 74.34,
  'adb:10:180000:115': 74.34,
  'adb:10:180000:116': 74.34,
  'adb:10:180000:117': 74.34,
  'adb:10:180000:118': 74.34,
  'adb:10:180000:119': 74.34,
  'adb:10:180000:120': 74.34,
  'adb:10:200000:1': 153.6,
  'adb:10:200000:2': 153.6,
  'adb:10:200000:3': 153.6,
  'adb:10:200000:4': 153.6,
  'adb:10:200000:5': 153.6,
  'adb:10:200000:6': 153.6,
  'adb:10:200000:7': 153.6,
  'adb:10:200000:8': 153.6,
  'adb:10:200000:9': 153.6,
  'adb:10:200000:10': 153.6,
  'adb:10:200000:11': 153.6,
  'adb:10:200000:12': 153.6,
  'adb:10:200000:13': 153.6,
  'adb:10:200000:14': 153.6,
  'adb:10:200000:15': 153.6,
  'adb:10:200000:16': 153.6,
  'adb:10:200000:17': 153.6,
  'adb:10:200000:18': 153.6,
  'adb:10:200000:19': 153.6,
  'adb:10:200000:20': 153.6,
  'adb:10:200000:21': 158.4,
  'adb:10:200000:22': 158.4,
  'adb:10:200000:23': 158.4,
  'adb:10:200000:24': 158.4,
  'adb:10:200000:25': 158.4,
  'adb:10:200000:26': 163.2,
  'adb:10:200000:27': 163.2,
  'adb:10:200000:28': 163.2,
  'adb:10:200000:29': 163.2,
  'adb:10:200000:30': 163.2,
  'adb:10:200000:31': 187.2,
  'adb:10:200000:32': 187.2,
  'adb:10:200000:33': 187.2,
  'adb:10:200000:34': 187.2,
  'adb:10:200000:35': 187.2,
  'adb:10:200000:36': 230.4,
  'adb:10:200000:37': 230.4,
  'adb:10:200000:38': 230.4,
  'adb:10:200000:39': 230.4,
  'adb:10:200000:40': 230.4,
  'adb:10:200000:41': 292.8,
  'adb:10:200000:42': 292.8,
  'adb:10:200000:43': 292.8,
  'adb:10:200000:44': 292.8,
  'adb:10:200000:45': 292.8,
  'adb:10:200000:46': 393.6,
  'adb:10:200000:47': 393.6,
  'adb:10:200000:48': 393.6,
  'adb:10:200000:49': 393.6,
  'adb:10:200000:50': 393.6,
  'adb:10:200000:51': 547.2,
  'adb:10:200000:52': 547.2,
  'adb:10:200000:53': 547.2,
  'adb:10:200000:54': 547.2,
  'adb:10:200000:55': 547.2,
  'adb:10:200000:56': 379.2,
  'adb:10:200000:57': 379.2,
  'adb:10:200000:58': 379.2,
  'adb:10:200000:59': 379.2,
  'adb:10:200000:60': 379.2,
  'adb:10:200000:61': 124.8,
  'adb:10:200000:62': 124.8,
  'adb:10:200000:63': 124.8,
  'adb:10:200000:64': 124.8,
  'adb:10:200000:65': 124.8,
  'adb:10:200000:66': 124.8,
  'adb:10:200000:67': 124.8,
  'adb:10:200000:68': 124.8,
  'adb:10:200000:69': 124.8,
  'adb:10:200000:70': 124.8,
  'adb:10:200000:71': 268.8,
  'adb:10:200000:72': 268.8,
  'adb:10:200000:73': 268.8,
  'adb:10:200000:74': 268.8,
  'adb:10:200000:75': 268.8,
  'adb:10:200000:76': 489.6,
  'adb:10:200000:77': 489.6,
  'adb:10:200000:78': 489.6,
  'adb:10:200000:79': 489.6,
  'adb:10:200000:80': 489.6,
  'adb:10:200000:81': 686.4,
  'adb:10:200000:82': 686.4,
  'adb:10:200000:83': 686.4,
  'adb:10:200000:84': 686.4,
  'adb:10:200000:85': 686.4,
  'adb:10:200000:86': 998.4,
  'adb:10:200000:87': 998.4,
  'adb:10:200000:88': 998.4,
  'adb:10:200000:89': 998.4,
  'adb:10:200000:90': 998.4,
  'adb:10:200000:91': 1502.4,
  'adb:10:200000:92': 1502.4,
  'adb:10:200000:93': 1502.4,
  'adb:10:200000:94': 1502.4,
  'adb:10:200000:95': 1502.4,
  'adb:10:200000:96': 2822.4,
  'adb:10:200000:97': 2822.4,
  'adb:10:200000:98': 2822.4,
  'adb:10:200000:99': 2822.4,
  'adb:10:200000:100': 2822.4,
  'adb:10:200000:101': 81.81,
  'adb:10:200000:102': 81.81,
  'adb:10:200000:103': 81.81,
  'adb:10:200000:104': 81.81,
  'adb:10:200000:105': 81.81,
  'adb:10:200000:106': 82.6,
  'adb:10:200000:107': 82.6,
  'adb:10:200000:108': 82.6,
  'adb:10:200000:109': 82.6,
  'adb:10:200000:110': 82.6,
  'adb:10:200000:111': 82.6,
  'adb:10:200000:112': 82.6,
  'adb:10:200000:113': 82.6,
  'adb:10:200000:114': 82.6,
  'adb:10:200000:115': 82.6,
  'adb:10:200000:116': 82.6,
  'adb:10:200000:117': 82.6,
  'adb:10:200000:118': 82.6,
  'adb:10:200000:119': 82.6,
  'adb:10:200000:120': 82.6,
  'lsb:10:5000:1': 0.15,
  'lsb:10:5000:2': 0.15,
  'lsb:10:5000:3': 0.15,
  'lsb:10:5000:4': 0.15,
  'lsb:10:5000:5': 0.15,
  'lsb:10:5000:5': 0.16,
  'lsb:10:5000:6': 0.16,
  'lsb:10:5000:7': 0.16,
  'lsb:10:5000:8': 0.16,
  'lsb:10:5000:9': 0.16,
  'lsb:10:5000:10': 0.16,
  'lsb:10:5000:10': 0.17,
  'lsb:10:5000:11': 0.17,
  'lsb:10:5000:12': 0.17,
  'lsb:10:5000:13': 0.17,
  'lsb:10:5000:14': 0.17,
  'lsb:10:5000:15': 0.17,
  'lsb:10:5000:15': 0.19,
  'lsb:10:5000:16': 0.19,
  'lsb:10:5000:17': 0.19,
  'lsb:10:5000:18': 0.19,
  'lsb:10:5000:19': 0.19,
  'lsb:10:5000:20': 0.19,
  'lsb:10:5000:20': 0.24,
  'lsb:10:5000:21': 0.24,
  'lsb:10:5000:22': 0.24,
  'lsb:10:5000:23': 0.24,
  'lsb:10:5000:24': 0.24,
  'lsb:10:5000:25': 0.24,
  'lsb:10:5000:25': 0.32,
  'lsb:10:5000:26': 0.32,
  'lsb:10:5000:27': 0.32,
  'lsb:10:5000:28': 0.32,
  'lsb:10:5000:29': 0.32,
  'lsb:10:5000:30': 0.32,
  'lsb:10:5000:30': 0.46,
  'lsb:10:5000:31': 0.46,
  'lsb:10:5000:32': 0.46,
  'lsb:10:5000:33': 0.46,
  'lsb:10:5000:34': 0.46,
  'lsb:10:5000:35': 0.46,
  'lsb:10:5000:35': 0.7,
  'lsb:10:5000:36': 0.7,
  'lsb:10:5000:37': 0.7,
  'lsb:10:5000:38': 0.7,
  'lsb:10:5000:39': 0.7,
  'lsb:10:5000:40': 0.7,
  'lsb:10:5000:40': 1.1,
  'lsb:10:5000:41': 1.1,
  'lsb:10:5000:42': 1.1,
  'lsb:10:5000:43': 1.1,
  'lsb:10:5000:44': 1.1,
  'lsb:10:5000:45': 1.1,
  'lsb:10:5000:45': 1.71,
  'lsb:10:5000:46': 1.71,
  'lsb:10:5000:47': 1.71,
  'lsb:10:5000:48': 1.71,
  'lsb:10:5000:49': 1.71,
  'lsb:10:5000:50': 1.71,
  'lsb:10:5000:50': 2.61,
  'lsb:10:5000:51': 2.61,
  'lsb:10:5000:52': 2.61,
  'lsb:10:5000:53': 2.61,
  'lsb:10:5000:54': 2.61,
  'lsb:10:5000:55': 2.61,
  'lsb:10:5000:55': 3.79,
  'lsb:10:5000:56': 3.79,
  'lsb:10:5000:57': 3.79,
  'lsb:10:5000:58': 3.79,
  'lsb:10:5000:59': 3.79,
  'lsb:10:5000:60': 3.79,
  'lsb:10:5000:60': 5.46,
  'lsb:10:5000:61': 5.46,
  'lsb:10:5000:62': 5.46,
  'lsb:10:5000:63': 5.46,
  'lsb:10:5000:64': 5.46,
  'lsb:10:5000:65': 5.46,
  'lsb:10:5000:65': 7.77,
  'lsb:10:5000:66': 7.77,
  'lsb:10:5000:67': 7.77,
  'lsb:10:5000:68': 7.77,
  'lsb:10:5000:69': 7.77,
  'lsb:10:5000:70': 7.77,
  'lsb:10:7500:1': 0.23,
  'lsb:10:7500:2': 0.23,
  'lsb:10:7500:3': 0.23,
  'lsb:10:7500:4': 0.23,
  'lsb:10:7500:5': 0.23,
  'lsb:10:7500:5': 0.23,
  'lsb:10:7500:6': 0.23,
  'lsb:10:7500:7': 0.23,
  'lsb:10:7500:8': 0.23,
  'lsb:10:7500:9': 0.23,
  'lsb:10:7500:10': 0.23,
  'lsb:10:7500:10': 0.25,
  'lsb:10:7500:11': 0.25,
  'lsb:10:7500:12': 0.25,
  'lsb:10:7500:13': 0.25,
  'lsb:10:7500:14': 0.25,
  'lsb:10:7500:15': 0.25,
  'lsb:10:7500:15': 0.28,
  'lsb:10:7500:16': 0.28,
  'lsb:10:7500:17': 0.28,
  'lsb:10:7500:18': 0.28,
  'lsb:10:7500:19': 0.28,
  'lsb:10:7500:20': 0.28,
  'lsb:10:7500:20': 0.35,
  'lsb:10:7500:21': 0.35,
  'lsb:10:7500:22': 0.35,
  'lsb:10:7500:23': 0.35,
  'lsb:10:7500:24': 0.35,
  'lsb:10:7500:25': 0.35,
  'lsb:10:7500:25': 0.48,
  'lsb:10:7500:26': 0.48,
  'lsb:10:7500:27': 0.48,
  'lsb:10:7500:28': 0.48,
  'lsb:10:7500:29': 0.48,
  'lsb:10:7500:30': 0.48,
  'lsb:10:7500:30': 0.69,
  'lsb:10:7500:31': 0.69,
  'lsb:10:7500:32': 0.69,
  'lsb:10:7500:33': 0.69,
  'lsb:10:7500:34': 0.69,
  'lsb:10:7500:35': 0.69,
  'lsb:10:7500:35': 1.05,
  'lsb:10:7500:36': 1.05,
  'lsb:10:7500:37': 1.05,
  'lsb:10:7500:38': 1.05,
  'lsb:10:7500:39': 1.05,
  'lsb:10:7500:40': 1.05,
  'lsb:10:7500:40': 1.64,
  'lsb:10:7500:41': 1.64,
  'lsb:10:7500:42': 1.64,
  'lsb:10:7500:43': 1.64,
  'lsb:10:7500:44': 1.64,
  'lsb:10:7500:45': 1.64,
  'lsb:10:7500:45': 2.56,
  'lsb:10:7500:46': 2.56,
  'lsb:10:7500:47': 2.56,
  'lsb:10:7500:48': 2.56,
  'lsb:10:7500:49': 2.56,
  'lsb:10:7500:50': 2.56,
  'lsb:10:7500:50': 3.91,
  'lsb:10:7500:51': 3.91,
  'lsb:10:7500:52': 3.91,
  'lsb:10:7500:53': 3.91,
  'lsb:10:7500:54': 3.91,
  'lsb:10:7500:55': 3.91,
  'lsb:10:7500:55': 5.69,
  'lsb:10:7500:56': 5.69,
  'lsb:10:7500:57': 5.69,
  'lsb:10:7500:58': 5.69,
  'lsb:10:7500:59': 5.69,
  'lsb:10:7500:60': 5.69,
  'lsb:10:7500:60': 8.18,
  'lsb:10:7500:61': 8.18,
  'lsb:10:7500:62': 8.18,
  'lsb:10:7500:63': 8.18,
  'lsb:10:7500:64': 8.18,
  'lsb:10:7500:65': 8.18,
  'lsb:10:7500:65': 11.64,
  'lsb:10:7500:66': 11.64,
  'lsb:10:7500:67': 11.64,
  'lsb:10:7500:68': 11.64,
  'lsb:10:7500:69': 11.64,
  'lsb:10:7500:70': 11.64,
  'lsb:10:10000:1': 0.3,
  'lsb:10:10000:2': 0.3,
  'lsb:10:10000:3': 0.3,
  'lsb:10:10000:4': 0.3,
  'lsb:10:10000:5': 0.3,
  'lsb:10:10000:5': 0.31,
  'lsb:10:10000:6': 0.31,
  'lsb:10:10000:7': 0.31,
  'lsb:10:10000:8': 0.31,
  'lsb:10:10000:9': 0.31,
  'lsb:10:10000:10': 0.31,
  'lsb:10:10000:10': 0.33,
  'lsb:10:10000:11': 0.33,
  'lsb:10:10000:12': 0.33,
  'lsb:10:10000:13': 0.33,
  'lsb:10:10000:14': 0.33,
  'lsb:10:10000:15': 0.33,
  'lsb:10:10000:15': 0.38,
  'lsb:10:10000:16': 0.38,
  'lsb:10:10000:17': 0.38,
  'lsb:10:10000:18': 0.38,
  'lsb:10:10000:19': 0.38,
  'lsb:10:10000:20': 0.38,
  'lsb:10:10000:20': 0.47,
  'lsb:10:10000:21': 0.47,
  'lsb:10:10000:22': 0.47,
  'lsb:10:10000:23': 0.47,
  'lsb:10:10000:24': 0.47,
  'lsb:10:10000:25': 0.47,
  'lsb:10:10000:25': 0.64,
  'lsb:10:10000:26': 0.64,
  'lsb:10:10000:27': 0.64,
  'lsb:10:10000:28': 0.64,
  'lsb:10:10000:29': 0.64,
  'lsb:10:10000:30': 0.64,
  'lsb:10:10000:30': 0.92,
  'lsb:10:10000:31': 0.92,
  'lsb:10:10000:32': 0.92,
  'lsb:10:10000:33': 0.92,
  'lsb:10:10000:34': 0.92,
  'lsb:10:10000:35': 0.92,
  'lsb:10:10000:35': 1.4,
  'lsb:10:10000:36': 1.4,
  'lsb:10:10000:37': 1.4,
  'lsb:10:10000:38': 1.4,
  'lsb:10:10000:39': 1.4,
  'lsb:10:10000:40': 1.4,
  'lsb:10:10000:40': 2.19,
  'lsb:10:10000:41': 2.19,
  'lsb:10:10000:42': 2.19,
  'lsb:10:10000:43': 2.19,
  'lsb:10:10000:44': 2.19,
  'lsb:10:10000:45': 2.19,
  'lsb:10:10000:45': 3.42,
  'lsb:10:10000:46': 3.42,
  'lsb:10:10000:47': 3.42,
  'lsb:10:10000:48': 3.42,
  'lsb:10:10000:49': 3.42,
  'lsb:10:10000:50': 3.42,
  'lsb:10:10000:50': 5.21,
  'lsb:10:10000:51': 5.21,
  'lsb:10:10000:52': 5.21,
  'lsb:10:10000:53': 5.21,
  'lsb:10:10000:54': 5.21,
  'lsb:10:10000:55': 5.21,
  'lsb:10:10000:55': 7.58,
  'lsb:10:10000:56': 7.58,
  'lsb:10:10000:57': 7.58,
  'lsb:10:10000:58': 7.58,
  'lsb:10:10000:59': 7.58,
  'lsb:10:10000:60': 7.58,
  'lsb:10:10000:60': 10.9,
  'lsb:10:10000:61': 10.9,
  'lsb:10:10000:62': 10.9,
  'lsb:10:10000:63': 10.9,
  'lsb:10:10000:64': 10.9,
  'lsb:10:10000:65': 10.9,
  'lsb:10:10000:65': 15.52,
  'lsb:10:10000:66': 15.52,
  'lsb:10:10000:67': 15.52,
  'lsb:10:10000:68': 15.52,
  'lsb:10:10000:69': 15.52,
  'lsb:10:10000:70': 15.52,
  'lsb:10:15000:1': 0.46,
  'lsb:10:15000:2': 0.46,
  'lsb:10:15000:3': 0.46,
  'lsb:10:15000:4': 0.46,
  'lsb:10:15000:5': 0.46,
  'lsb:10:15000:5': 0.47,
  'lsb:10:15000:6': 0.47,
  'lsb:10:15000:7': 0.47,
  'lsb:10:15000:8': 0.47,
  'lsb:10:15000:9': 0.47,
  'lsb:10:15000:10': 0.47,
  'lsb:10:15000:10': 0.5,
  'lsb:10:15000:11': 0.5,
  'lsb:10:15000:12': 0.5,
  'lsb:10:15000:13': 0.5,
  'lsb:10:15000:14': 0.5,
  'lsb:10:15000:15': 0.5,
  'lsb:10:15000:15': 0.57,
  'lsb:10:15000:16': 0.57,
  'lsb:10:15000:17': 0.57,
  'lsb:10:15000:18': 0.57,
  'lsb:10:15000:19': 0.57,
  'lsb:10:15000:20': 0.57,
  'lsb:10:15000:20': 0.71,
  'lsb:10:15000:21': 0.71,
  'lsb:10:15000:22': 0.71,
  'lsb:10:15000:23': 0.71,
  'lsb:10:15000:24': 0.71,
  'lsb:10:15000:25': 0.71,
  'lsb:10:15000:25': 0.96,
  'lsb:10:15000:26': 0.96,
  'lsb:10:15000:27': 0.96,
  'lsb:10:15000:28': 0.96,
  'lsb:10:15000:29': 0.96,
  'lsb:10:15000:30': 0.96,
  'lsb:10:15000:30': 1.38,
  'lsb:10:15000:31': 1.38,
  'lsb:10:15000:32': 1.38,
  'lsb:10:15000:33': 1.38,
  'lsb:10:15000:34': 1.38,
  'lsb:10:15000:35': 1.38,
  'lsb:10:15000:35': 2.1,
  'lsb:10:15000:36': 2.1,
  'lsb:10:15000:37': 2.1,
  'lsb:10:15000:38': 2.1,
  'lsb:10:15000:39': 2.1,
  'lsb:10:15000:40': 2.1,
  'lsb:10:15000:40': 3.29,
  'lsb:10:15000:41': 3.29,
  'lsb:10:15000:42': 3.29,
  'lsb:10:15000:43': 3.29,
  'lsb:10:15000:44': 3.29,
  'lsb:10:15000:45': 3.29,
  'lsb:10:15000:45': 5.13,
  'lsb:10:15000:46': 5.13,
  'lsb:10:15000:47': 5.13,
  'lsb:10:15000:48': 5.13,
  'lsb:10:15000:49': 5.13,
  'lsb:10:15000:50': 5.13,
  'lsb:10:15000:50': 7.81,
  'lsb:10:15000:51': 7.81,
  'lsb:10:15000:52': 7.81,
  'lsb:10:15000:53': 7.81,
  'lsb:10:15000:54': 7.81,
  'lsb:10:15000:55': 7.81,
  'lsb:10:15000:55': 11.38,
  'lsb:10:15000:56': 11.38,
  'lsb:10:15000:57': 11.38,
  'lsb:10:15000:58': 11.38,
  'lsb:10:15000:59': 11.38,
  'lsb:10:15000:60': 11.38,
  'lsb:10:15000:60': 16.36,
  'lsb:10:15000:61': 16.36,
  'lsb:10:15000:62': 16.36,
  'lsb:10:15000:63': 16.36,
  'lsb:10:15000:64': 16.36,
  'lsb:10:15000:65': 16.36,
  'lsb:10:15000:65': 23.28,
  'lsb:10:15000:66': 23.28,
  'lsb:10:15000:67': 23.28,
  'lsb:10:15000:68': 23.28,
  'lsb:10:15000:69': 23.28,
  'lsb:10:15000:70': 23.28,
  'lsb:10:20000:1': 0.61,
  'lsb:10:20000:2': 0.61,
  'lsb:10:20000:3': 0.61,
  'lsb:10:20000:4': 0.61,
  'lsb:10:20000:5': 0.61,
  'lsb:10:20000:5': 0.62,
  'lsb:10:20000:6': 0.62,
  'lsb:10:20000:7': 0.62,
  'lsb:10:20000:8': 0.62,
  'lsb:10:20000:9': 0.62,
  'lsb:10:20000:10': 0.62,
  'lsb:10:20000:10': 0.67,
  'lsb:10:20000:11': 0.67,
  'lsb:10:20000:12': 0.67,
  'lsb:10:20000:13': 0.67,
  'lsb:10:20000:14': 0.67,
  'lsb:10:20000:15': 0.67,
  'lsb:10:20000:15': 0.76,
  'lsb:10:20000:16': 0.76,
  'lsb:10:20000:17': 0.76,
  'lsb:10:20000:18': 0.76,
  'lsb:10:20000:19': 0.76,
  'lsb:10:20000:20': 0.76,
  'lsb:10:20000:20': 0.94,
  'lsb:10:20000:21': 0.94,
  'lsb:10:20000:22': 0.94,
  'lsb:10:20000:23': 0.94,
  'lsb:10:20000:24': 0.94,
  'lsb:10:20000:25': 0.94,
  'lsb:10:20000:25': 1.28,
  'lsb:10:20000:26': 1.28,
  'lsb:10:20000:27': 1.28,
  'lsb:10:20000:28': 1.28,
  'lsb:10:20000:29': 1.28,
  'lsb:10:20000:30': 1.28,
  'lsb:10:20000:30': 1.84,
  'lsb:10:20000:31': 1.84,
  'lsb:10:20000:32': 1.84,
  'lsb:10:20000:33': 1.84,
  'lsb:10:20000:34': 1.84,
  'lsb:10:20000:35': 1.84,
  'lsb:10:20000:35': 2.8,
  'lsb:10:20000:36': 2.8,
  'lsb:10:20000:37': 2.8,
  'lsb:10:20000:38': 2.8,
  'lsb:10:20000:39': 2.8,
  'lsb:10:20000:40': 2.8,
  'lsb:10:20000:40': 4.38,
  'lsb:10:20000:41': 4.38,
  'lsb:10:20000:42': 4.38,
  'lsb:10:20000:43': 4.38,
  'lsb:10:20000:44': 4.38,
  'lsb:10:20000:45': 4.38,
  'lsb:10:20000:45': 6.84,
  'lsb:10:20000:46': 6.84,
  'lsb:10:20000:47': 6.84,
  'lsb:10:20000:48': 6.84,
  'lsb:10:20000:49': 6.84,
  'lsb:10:20000:50': 6.84,
  'lsb:10:20000:50': 10.42,
  'lsb:10:20000:51': 10.42,
  'lsb:10:20000:52': 10.42,
  'lsb:10:20000:53': 10.42,
  'lsb:10:20000:54': 10.42,
  'lsb:10:20000:55': 10.42,
  'lsb:10:20000:55': 15.16,
  'lsb:10:20000:56': 15.16,
  'lsb:10:20000:57': 15.16,
  'lsb:10:20000:58': 15.16,
  'lsb:10:20000:59': 15.16,
  'lsb:10:20000:60': 15.16,
  'lsb:10:20000:60': 21.81,
  'lsb:10:20000:61': 21.81,
  'lsb:10:20000:62': 21.81,
  'lsb:10:20000:63': 21.81,
  'lsb:10:20000:64': 21.81,
  'lsb:10:20000:65': 21.81,
  'lsb:10:20000:65': 31.03,
  'lsb:10:20000:66': 31.03,
  'lsb:10:20000:67': 31.03,
  'lsb:10:20000:68': 31.03,
  'lsb:10:20000:69': 31.03,
  'lsb:10:20000:70': 31.03,
  'lsb:10:25000:1': 0.76,
  'lsb:10:25000:2': 0.76,
  'lsb:10:25000:3': 0.76,
  'lsb:10:25000:4': 0.76,
  'lsb:10:25000:5': 0.76,
  'lsb:10:25000:5': 0.78,
  'lsb:10:25000:6': 0.78,
  'lsb:10:25000:7': 0.78,
  'lsb:10:25000:8': 0.78,
  'lsb:10:25000:9': 0.78,
  'lsb:10:25000:10': 0.78,
  'lsb:10:25000:10': 0.83,
  'lsb:10:25000:11': 0.83,
  'lsb:10:25000:12': 0.83,
  'lsb:10:25000:13': 0.83,
  'lsb:10:25000:14': 0.83,
  'lsb:10:25000:15': 0.83,
  'lsb:10:25000:15': 0.95,
  'lsb:10:25000:16': 0.95,
  'lsb:10:25000:17': 0.95,
  'lsb:10:25000:18': 0.95,
  'lsb:10:25000:19': 0.95,
  'lsb:10:25000:20': 0.95,
  'lsb:10:25000:20': 1.18,
  'lsb:10:25000:21': 1.18,
  'lsb:10:25000:22': 1.18,
  'lsb:10:25000:23': 1.18,
  'lsb:10:25000:24': 1.18,
  'lsb:10:25000:25': 1.18,
  'lsb:10:25000:25': 1.6,
  'lsb:10:25000:26': 1.6,
  'lsb:10:25000:27': 1.6,
  'lsb:10:25000:28': 1.6,
  'lsb:10:25000:29': 1.6,
  'lsb:10:25000:30': 1.6,
  'lsb:10:25000:30': 2.31,
  'lsb:10:25000:31': 2.31,
  'lsb:10:25000:32': 2.31,
  'lsb:10:25000:33': 2.31,
  'lsb:10:25000:34': 2.31,
  'lsb:10:25000:35': 2.31,
  'lsb:10:25000:35': 3.5,
  'lsb:10:25000:36': 3.5,
  'lsb:10:25000:37': 3.5,
  'lsb:10:25000:38': 3.5,
  'lsb:10:25000:39': 3.5,
  'lsb:10:25000:40': 3.5,
  'lsb:10:25000:40': 5.48,
  'lsb:10:25000:41': 5.48,
  'lsb:10:25000:42': 5.48,
  'lsb:10:25000:43': 5.48,
  'lsb:10:25000:44': 5.48,
  'lsb:10:25000:45': 5.48,
  'lsb:10:25000:45': 8.55,
  'lsb:10:25000:46': 8.55,
  'lsb:10:25000:47': 8.55,
  'lsb:10:25000:48': 8.55,
  'lsb:10:25000:49': 8.55,
  'lsb:10:25000:50': 8.55,
  'lsb:10:25000:50': 13.02,
  'lsb:10:25000:51': 13.02,
  'lsb:10:25000:52': 13.02,
  'lsb:10:25000:53': 13.02,
  'lsb:10:25000:54': 13.02,
  'lsb:10:25000:55': 13.02,
  'lsb:10:25000:55': 18.96,
  'lsb:10:25000:56': 18.96,
  'lsb:10:25000:57': 18.96,
  'lsb:10:25000:58': 18.96,
  'lsb:10:25000:59': 18.96,
  'lsb:10:25000:60': 18.96,
  'lsb:10:25000:60': 27.27,
  'lsb:10:25000:61': 27.27,
  'lsb:10:25000:62': 27.27,
  'lsb:10:25000:63': 27.27,
  'lsb:10:25000:64': 27.27,
  'lsb:10:25000:65': 27.27,
  'lsb:10:25000:65': 38.8,
  'lsb:10:25000:66': 38.8,
  'lsb:10:25000:67': 38.8,
  'lsb:10:25000:68': 38.8,
  'lsb:10:25000:69': 38.8,
  'lsb:10:25000:70': 38.8,
  'lsb:10:30000:1': 0.91,
  'lsb:10:30000:2': 0.91,
  'lsb:10:30000:3': 0.91,
  'lsb:10:30000:4': 0.91,
  'lsb:10:30000:5': 0.91,
  'lsb:10:30000:5': 0.94,
  'lsb:10:30000:6': 0.94,
  'lsb:10:30000:7': 0.94,
  'lsb:10:30000:8': 0.94,
  'lsb:10:30000:9': 0.94,
  'lsb:10:30000:10': 0.94,
  'lsb:10:30000:10': 1,
  'lsb:10:30000:11': 1,
  'lsb:10:30000:12': 1,
  'lsb:10:30000:13': 1,
  'lsb:10:30000:14': 1,
  'lsb:10:30000:15': 1,
  'lsb:10:30000:15': 1.14,
  'lsb:10:30000:16': 1.14,
  'lsb:10:30000:17': 1.14,
  'lsb:10:30000:18': 1.14,
  'lsb:10:30000:19': 1.14,
  'lsb:10:30000:20': 1.14,
  'lsb:10:30000:20': 1.41,
  'lsb:10:30000:21': 1.41,
  'lsb:10:30000:22': 1.41,
  'lsb:10:30000:23': 1.41,
  'lsb:10:30000:24': 1.41,
  'lsb:10:30000:25': 1.41,
  'lsb:10:30000:25': 1.91,
  'lsb:10:30000:26': 1.91,
  'lsb:10:30000:27': 1.91,
  'lsb:10:30000:28': 1.91,
  'lsb:10:30000:29': 1.91,
  'lsb:10:30000:30': 1.91,
  'lsb:10:30000:30': 2.77,
  'lsb:10:30000:31': 2.77,
  'lsb:10:30000:32': 2.77,
  'lsb:10:30000:33': 2.77,
  'lsb:10:30000:34': 2.77,
  'lsb:10:30000:35': 2.77,
  'lsb:10:30000:35': 4.2,
  'lsb:10:30000:36': 4.2,
  'lsb:10:30000:37': 4.2,
  'lsb:10:30000:38': 4.2,
  'lsb:10:30000:39': 4.2,
  'lsb:10:30000:40': 4.2,
  'lsb:10:30000:40': 6.57,
  'lsb:10:30000:41': 6.57,
  'lsb:10:30000:42': 6.57,
  'lsb:10:30000:43': 6.57,
  'lsb:10:30000:44': 6.57,
  'lsb:10:30000:45': 6.57,
  'lsb:10:30000:45': 10.25,
  'lsb:10:30000:46': 10.25,
  'lsb:10:30000:47': 10.25,
  'lsb:10:30000:48': 10.25,
  'lsb:10:30000:49': 10.25,
  'lsb:10:30000:50': 10.25,
  'lsb:10:30000:50': 15.61,
  'lsb:10:30000:51': 15.61,
  'lsb:10:30000:52': 15.61,
  'lsb:10:30000:53': 15.61,
  'lsb:10:30000:54': 15.61,
  'lsb:10:30000:55': 15.61,
  'lsb:10:30000:55': 22.73,
  'lsb:10:30000:56': 22.73,
  'lsb:10:30000:57': 22.73,
  'lsb:10:30000:58': 22.73,
  'lsb:10:30000:59': 22.73,
  'lsb:10:30000:60': 22.73,
  'lsb:10:30000:60': 32.68,
  'lsb:10:30000:61': 32.68,
  'lsb:10:30000:62': 32.68,
  'lsb:10:30000:63': 32.68,
  'lsb:10:30000:64': 32.68,
  'lsb:10:30000:65': 32.68,
  'lsb:10:30000:65': 46.51,
  'lsb:10:30000:66': 46.51,
  'lsb:10:30000:67': 46.51,
  'lsb:10:30000:68': 46.51,
  'lsb:10:30000:69': 46.51,
  'lsb:10:30000:70': 46.51,
  'lsb:10:40000:1': 1.22,
  'lsb:10:40000:2': 1.22,
  'lsb:10:40000:3': 1.22,
  'lsb:10:40000:4': 1.22,
  'lsb:10:40000:5': 1.22,
  'lsb:10:40000:5': 1.25,
  'lsb:10:40000:6': 1.25,
  'lsb:10:40000:7': 1.25,
  'lsb:10:40000:8': 1.25,
  'lsb:10:40000:9': 1.25,
  'lsb:10:40000:10': 1.25,
  'lsb:10:40000:10': 1.33,
  'lsb:10:40000:11': 1.33,
  'lsb:10:40000:12': 1.33,
  'lsb:10:40000:13': 1.33,
  'lsb:10:40000:14': 1.33,
  'lsb:10:40000:15': 1.33,
  'lsb:10:40000:15': 1.51,
  'lsb:10:40000:16': 1.51,
  'lsb:10:40000:17': 1.51,
  'lsb:10:40000:18': 1.51,
  'lsb:10:40000:19': 1.51,
  'lsb:10:40000:20': 1.51,
  'lsb:10:40000:20': 1.89,
  'lsb:10:40000:21': 1.89,
  'lsb:10:40000:22': 1.89,
  'lsb:10:40000:23': 1.89,
  'lsb:10:40000:24': 1.89,
  'lsb:10:40000:25': 1.89,
  'lsb:10:40000:25': 2.55,
  'lsb:10:40000:26': 2.55,
  'lsb:10:40000:27': 2.55,
  'lsb:10:40000:28': 2.55,
  'lsb:10:40000:29': 2.55,
  'lsb:10:40000:30': 2.55,
  'lsb:10:40000:30': 3.69,
  'lsb:10:40000:31': 3.69,
  'lsb:10:40000:32': 3.69,
  'lsb:10:40000:33': 3.69,
  'lsb:10:40000:34': 3.69,
  'lsb:10:40000:35': 3.69,
  'lsb:10:40000:35': 5.61,
  'lsb:10:40000:36': 5.61,
  'lsb:10:40000:37': 5.61,
  'lsb:10:40000:38': 5.61,
  'lsb:10:40000:39': 5.61,
  'lsb:10:40000:40': 5.61,
  'lsb:10:40000:40': 8.77,
  'lsb:10:40000:41': 8.77,
  'lsb:10:40000:42': 8.77,
  'lsb:10:40000:43': 8.77,
  'lsb:10:40000:44': 8.77,
  'lsb:10:40000:45': 8.77,
  'lsb:10:40000:45': 13.67,
  'lsb:10:40000:46': 13.67,
  'lsb:10:40000:47': 13.67,
  'lsb:10:40000:48': 13.67,
  'lsb:10:40000:49': 13.67,
  'lsb:10:40000:50': 13.67,
  'lsb:10:40000:50': 20.83,
  'lsb:10:40000:51': 20.83,
  'lsb:10:40000:52': 20.83,
  'lsb:10:40000:53': 20.83,
  'lsb:10:40000:54': 20.83,
  'lsb:10:40000:55': 20.83,
  'lsb:10:40000:55': 30.33,
  'lsb:10:40000:56': 30.33,
  'lsb:10:40000:57': 30.33,
  'lsb:10:40000:58': 30.33,
  'lsb:10:40000:59': 30.33,
  'lsb:10:40000:60': 30.33,
  'lsb:10:40000:60': 43.61,
  'lsb:10:40000:61': 43.61,
  'lsb:10:40000:62': 43.61,
  'lsb:10:40000:63': 43.61,
  'lsb:10:40000:64': 43.61,
  'lsb:10:40000:65': 43.61,
  'lsb:10:40000:65': 62.07,
  'lsb:10:40000:66': 62.07,
  'lsb:10:40000:67': 62.07,
  'lsb:10:40000:68': 62.07,
  'lsb:10:40000:69': 62.07,
  'lsb:10:40000:70': 62.07,
  'lsb:10:50000:1': 1.52,
  'lsb:10:50000:2': 1.52,
  'lsb:10:50000:3': 1.52,
  'lsb:10:50000:4': 1.52,
  'lsb:10:50000:5': 1.52,
  'lsb:10:50000:5': 1.56,
  'lsb:10:50000:6': 1.56,
  'lsb:10:50000:7': 1.56,
  'lsb:10:50000:8': 1.56,
  'lsb:10:50000:9': 1.56,
  'lsb:10:50000:10': 1.56,
  'lsb:10:50000:10': 1.67,
  'lsb:10:50000:11': 1.67,
  'lsb:10:50000:12': 1.67,
  'lsb:10:50000:13': 1.67,
  'lsb:10:50000:14': 1.67,
  'lsb:10:50000:15': 1.67,
  'lsb:10:50000:15': 1.89,
  'lsb:10:50000:16': 1.89,
  'lsb:10:50000:17': 1.89,
  'lsb:10:50000:18': 1.89,
  'lsb:10:50000:19': 1.89,
  'lsb:10:50000:20': 1.89,
  'lsb:10:50000:20': 2.36,
  'lsb:10:50000:21': 2.36,
  'lsb:10:50000:22': 2.36,
  'lsb:10:50000:23': 2.36,
  'lsb:10:50000:24': 2.36,
  'lsb:10:50000:25': 2.36,
  'lsb:10:50000:25': 3.19,
  'lsb:10:50000:26': 3.19,
  'lsb:10:50000:27': 3.19,
  'lsb:10:50000:28': 3.19,
  'lsb:10:50000:29': 3.19,
  'lsb:10:50000:30': 3.19,
  'lsb:10:50000:30': 4.61,
  'lsb:10:50000:31': 4.61,
  'lsb:10:50000:32': 4.61,
  'lsb:10:50000:33': 4.61,
  'lsb:10:50000:34': 4.61,
  'lsb:10:50000:35': 4.61,
  'lsb:10:50000:35': 7.01,
  'lsb:10:50000:36': 7.01,
  'lsb:10:50000:37': 7.01,
  'lsb:10:50000:38': 7.01,
  'lsb:10:50000:39': 7.01,
  'lsb:10:50000:40': 7.01,
  'lsb:10:50000:40': 10.96,
  'lsb:10:50000:41': 10.96,
  'lsb:10:50000:42': 10.96,
  'lsb:10:50000:43': 10.96,
  'lsb:10:50000:44': 10.96,
  'lsb:10:50000:45': 10.96,
  'lsb:10:50000:45': 17.1,
  'lsb:10:50000:46': 17.1,
  'lsb:10:50000:47': 17.1,
  'lsb:10:50000:48': 17.1,
  'lsb:10:50000:49': 17.1,
  'lsb:10:50000:50': 17.1,
  'lsb:10:50000:50': 26.05,
  'lsb:10:50000:51': 26.05,
  'lsb:10:50000:52': 26.05,
  'lsb:10:50000:53': 26.05,
  'lsb:10:50000:54': 26.05,
  'lsb:10:50000:55': 26.05,
  'lsb:10:50000:55': 37.92,
  'lsb:10:50000:56': 37.92,
  'lsb:10:50000:57': 37.92,
  'lsb:10:50000:58': 37.92,
  'lsb:10:50000:59': 37.92,
  'lsb:10:50000:60': 37.92,
  'lsb:10:50000:60': 54.53,
  'lsb:10:50000:61': 54.53,
  'lsb:10:50000:62': 54.53,
  'lsb:10:50000:63': 54.53,
  'lsb:10:50000:64': 54.53,
  'lsb:10:50000:65': 54.53,
  'lsb:10:50000:65': 77.61,
  'lsb:10:50000:66': 77.61,
  'lsb:10:50000:67': 77.61,
  'lsb:10:50000:68': 77.61,
  'lsb:10:50000:69': 77.61,
  'lsb:10:50000:70': 77.61,
  'lsb:10:60000:1': 1.82,
  'lsb:10:60000:2': 1.82,
  'lsb:10:60000:3': 1.82,
  'lsb:10:60000:4': 1.82,
  'lsb:10:60000:5': 1.82,
  'lsb:10:60000:5': 1.87,
  'lsb:10:60000:6': 1.87,
  'lsb:10:60000:7': 1.87,
  'lsb:10:60000:8': 1.87,
  'lsb:10:60000:9': 1.87,
  'lsb:10:60000:10': 1.87,
  'lsb:10:60000:10': 2,
  'lsb:10:60000:11': 2,
  'lsb:10:60000:12': 2,
  'lsb:10:60000:13': 2,
  'lsb:10:60000:14': 2,
  'lsb:10:60000:15': 2,
  'lsb:10:60000:15': 2.27,
  'lsb:10:60000:16': 2.27,
  'lsb:10:60000:17': 2.27,
  'lsb:10:60000:18': 2.27,
  'lsb:10:60000:19': 2.27,
  'lsb:10:60000:20': 2.27,
  'lsb:10:60000:20': 2.83,
  'lsb:10:60000:21': 2.83,
  'lsb:10:60000:22': 2.83,
  'lsb:10:60000:23': 2.83,
  'lsb:10:60000:24': 2.83,
  'lsb:10:60000:25': 2.83,
  'lsb:10:60000:25': 3.83,
  'lsb:10:60000:26': 3.83,
  'lsb:10:60000:27': 3.83,
  'lsb:10:60000:28': 3.83,
  'lsb:10:60000:29': 3.83,
  'lsb:10:60000:30': 3.83,
  'lsb:10:60000:30': 5.53,
  'lsb:10:60000:31': 5.53,
  'lsb:10:60000:32': 5.53,
  'lsb:10:60000:33': 5.53,
  'lsb:10:60000:34': 5.53,
  'lsb:10:60000:35': 5.53,
  'lsb:10:60000:35': 8.4,
  'lsb:10:60000:36': 8.4,
  'lsb:10:60000:37': 8.4,
  'lsb:10:60000:38': 8.4,
  'lsb:10:60000:39': 8.4,
  'lsb:10:60000:40': 8.4,
  'lsb:10:60000:40': 13.14,
  'lsb:10:60000:41': 13.14,
  'lsb:10:60000:42': 13.14,
  'lsb:10:60000:43': 13.14,
  'lsb:10:60000:44': 13.14,
  'lsb:10:60000:45': 13.14,
  'lsb:10:60000:45': 20.5,
  'lsb:10:60000:46': 20.5,
  'lsb:10:60000:47': 20.5,
  'lsb:10:60000:48': 20.5,
  'lsb:10:60000:49': 20.5,
  'lsb:10:60000:50': 20.5,
  'lsb:10:60000:50': 31.22,
  'lsb:10:60000:51': 31.22,
  'lsb:10:60000:52': 31.22,
  'lsb:10:60000:53': 31.22,
  'lsb:10:60000:54': 31.22,
  'lsb:10:60000:55': 31.22,
  'lsb:10:60000:55': 45.46,
  'lsb:10:60000:56': 45.46,
  'lsb:10:60000:57': 45.46,
  'lsb:10:60000:58': 45.46,
  'lsb:10:60000:59': 45.46,
  'lsb:10:60000:60': 45.46,
  'lsb:10:60000:60': 65.37,
  'lsb:10:60000:61': 65.37,
  'lsb:10:60000:62': 65.37,
  'lsb:10:60000:63': 65.37,
  'lsb:10:60000:64': 65.37,
  'lsb:10:60000:65': 65.37,
  'lsb:10:60000:65': 93.03,
  'lsb:10:60000:66': 93.03,
  'lsb:10:60000:67': 93.03,
  'lsb:10:60000:68': 93.03,
  'lsb:10:60000:69': 93.03,
  'lsb:10:60000:70': 93.03,
  'lsb:10:70000:1': 2.13,
  'lsb:10:70000:2': 2.13,
  'lsb:10:70000:3': 2.13,
  'lsb:10:70000:4': 2.13,
  'lsb:10:70000:5': 2.13,
  'lsb:10:70000:5': 2.19,
  'lsb:10:70000:6': 2.19,
  'lsb:10:70000:7': 2.19,
  'lsb:10:70000:8': 2.19,
  'lsb:10:70000:9': 2.19,
  'lsb:10:70000:10': 2.19,
  'lsb:10:70000:10': 2.33,
  'lsb:10:70000:11': 2.33,
  'lsb:10:70000:12': 2.33,
  'lsb:10:70000:13': 2.33,
  'lsb:10:70000:14': 2.33,
  'lsb:10:70000:15': 2.33,
  'lsb:10:70000:15': 2.65,
  'lsb:10:70000:16': 2.65,
  'lsb:10:70000:17': 2.65,
  'lsb:10:70000:18': 2.65,
  'lsb:10:70000:19': 2.65,
  'lsb:10:70000:20': 2.65,
  'lsb:10:70000:20': 3.3,
  'lsb:10:70000:21': 3.3,
  'lsb:10:70000:22': 3.3,
  'lsb:10:70000:23': 3.3,
  'lsb:10:70000:24': 3.3,
  'lsb:10:70000:25': 3.3,
  'lsb:10:70000:25': 4.47,
  'lsb:10:70000:26': 4.47,
  'lsb:10:70000:27': 4.47,
  'lsb:10:70000:28': 4.47,
  'lsb:10:70000:29': 4.47,
  'lsb:10:70000:30': 4.47,
  'lsb:10:70000:30': 6.46,
  'lsb:10:70000:31': 6.46,
  'lsb:10:70000:32': 6.46,
  'lsb:10:70000:33': 6.46,
  'lsb:10:70000:34': 6.46,
  'lsb:10:70000:35': 6.46,
  'lsb:10:70000:35': 9.81,
  'lsb:10:70000:36': 9.81,
  'lsb:10:70000:37': 9.81,
  'lsb:10:70000:38': 9.81,
  'lsb:10:70000:39': 9.81,
  'lsb:10:70000:40': 9.81,
  'lsb:10:70000:40': 15.34,
  'lsb:10:70000:41': 15.34,
  'lsb:10:70000:42': 15.34,
  'lsb:10:70000:43': 15.34,
  'lsb:10:70000:44': 15.34,
  'lsb:10:70000:45': 15.34,
  'lsb:10:70000:45': 23.93,
  'lsb:10:70000:46': 23.93,
  'lsb:10:70000:47': 23.93,
  'lsb:10:70000:48': 23.93,
  'lsb:10:70000:49': 23.93,
  'lsb:10:70000:50': 23.93,
  'lsb:10:70000:50': 36.45,
  'lsb:10:70000:51': 36.45,
  'lsb:10:70000:52': 36.45,
  'lsb:10:70000:53': 36.45,
  'lsb:10:70000:54': 36.45,
  'lsb:10:70000:55': 36.45,
  'lsb:10:70000:55': 53.08,
  'lsb:10:70000:56': 53.08,
  'lsb:10:70000:57': 53.08,
  'lsb:10:70000:58': 53.08,
  'lsb:10:70000:59': 53.08,
  'lsb:10:70000:60': 53.08,
  'lsb:10:70000:60': 76.32,
  'lsb:10:70000:61': 76.32,
  'lsb:10:70000:62': 76.32,
  'lsb:10:70000:63': 76.32,
  'lsb:10:70000:64': 76.32,
  'lsb:10:70000:65': 76.32,
  'lsb:10:70000:65': 108.61,
  'lsb:10:70000:66': 108.61,
  'lsb:10:70000:67': 108.61,
  'lsb:10:70000:68': 108.61,
  'lsb:10:70000:69': 108.61,
  'lsb:10:70000:70': 108.61,
  'lsb:10:80000:1': 2.43,
  'lsb:10:80000:2': 2.43,
  'lsb:10:80000:3': 2.43,
  'lsb:10:80000:4': 2.43,
  'lsb:10:80000:5': 2.43,
  'lsb:10:80000:5': 2.5,
  'lsb:10:80000:6': 2.5,
  'lsb:10:80000:7': 2.5,
  'lsb:10:80000:8': 2.5,
  'lsb:10:80000:9': 2.5,
  'lsb:10:80000:10': 2.5,
  'lsb:10:80000:10': 2.66,
  'lsb:10:80000:11': 2.66,
  'lsb:10:80000:12': 2.66,
  'lsb:10:80000:13': 2.66,
  'lsb:10:80000:14': 2.66,
  'lsb:10:80000:15': 2.66,
  'lsb:10:80000:15': 3.03,
  'lsb:10:80000:16': 3.03,
  'lsb:10:80000:17': 3.03,
  'lsb:10:80000:18': 3.03,
  'lsb:10:80000:19': 3.03,
  'lsb:10:80000:20': 3.03,
  'lsb:10:80000:20': 3.78,
  'lsb:10:80000:21': 3.78,
  'lsb:10:80000:22': 3.78,
  'lsb:10:80000:23': 3.78,
  'lsb:10:80000:24': 3.78,
  'lsb:10:80000:25': 3.78,
  'lsb:10:80000:25': 5.11,
  'lsb:10:80000:26': 5.11,
  'lsb:10:80000:27': 5.11,
  'lsb:10:80000:28': 5.11,
  'lsb:10:80000:29': 5.11,
  'lsb:10:80000:30': 5.11,
  'lsb:10:80000:30': 7.38,
  'lsb:10:80000:31': 7.38,
  'lsb:10:80000:32': 7.38,
  'lsb:10:80000:33': 7.38,
  'lsb:10:80000:34': 7.38,
  'lsb:10:80000:35': 7.38,
  'lsb:10:80000:35': 11.21,
  'lsb:10:80000:36': 11.21,
  'lsb:10:80000:37': 11.21,
  'lsb:10:80000:38': 11.21,
  'lsb:10:80000:39': 11.21,
  'lsb:10:80000:40': 11.21,
  'lsb:10:80000:40': 17.54,
  'lsb:10:80000:41': 17.54,
  'lsb:10:80000:42': 17.54,
  'lsb:10:80000:43': 17.54,
  'lsb:10:80000:44': 17.54,
  'lsb:10:80000:45': 17.54,
  'lsb:10:80000:45': 27.36,
  'lsb:10:80000:46': 27.36,
  'lsb:10:80000:47': 27.36,
  'lsb:10:80000:48': 27.36,
  'lsb:10:80000:49': 27.36,
  'lsb:10:80000:50': 27.36,
  'lsb:10:80000:50': 41.67,
  'lsb:10:80000:51': 41.67,
  'lsb:10:80000:52': 41.67,
  'lsb:10:80000:53': 41.67,
  'lsb:10:80000:54': 41.67,
  'lsb:10:80000:55': 41.67,
  'lsb:10:80000:55': 60.68,
  'lsb:10:80000:56': 60.68,
  'lsb:10:80000:57': 60.68,
  'lsb:10:80000:58': 60.68,
  'lsb:10:80000:59': 60.68,
  'lsb:10:80000:60': 60.68,
  'lsb:10:80000:60': 87.25,
  'lsb:10:80000:61': 87.25,
  'lsb:10:80000:62': 87.25,
  'lsb:10:80000:63': 87.25,
  'lsb:10:80000:64': 87.25,
  'lsb:10:80000:65': 87.25,
  'lsb:10:80000:65': 124.17,
  'lsb:10:80000:66': 124.17,
  'lsb:10:80000:67': 124.17,
  'lsb:10:80000:68': 124.17,
  'lsb:10:80000:69': 124.17,
  'lsb:10:80000:70': 124.17,
  'lsb:10:90000:1': 2.74,
  'lsb:10:90000:2': 2.74,
  'lsb:10:90000:3': 2.74,
  'lsb:10:90000:4': 2.74,
  'lsb:10:90000:5': 2.74,
  'lsb:10:90000:5': 2.81,
  'lsb:10:90000:6': 2.81,
  'lsb:10:90000:7': 2.81,
  'lsb:10:90000:8': 2.81,
  'lsb:10:90000:9': 2.81,
  'lsb:10:90000:10': 2.81,
  'lsb:10:90000:10': 3,
  'lsb:10:90000:11': 3,
  'lsb:10:90000:12': 3,
  'lsb:10:90000:13': 3,
  'lsb:10:90000:14': 3,
  'lsb:10:90000:15': 3,
  'lsb:10:90000:15': 3.41,
  'lsb:10:90000:16': 3.41,
  'lsb:10:90000:17': 3.41,
  'lsb:10:90000:18': 3.41,
  'lsb:10:90000:19': 3.41,
  'lsb:10:90000:20': 3.41,
  'lsb:10:90000:20': 4.24,
  'lsb:10:90000:21': 4.24,
  'lsb:10:90000:22': 4.24,
  'lsb:10:90000:23': 4.24,
  'lsb:10:90000:24': 4.24,
  'lsb:10:90000:25': 4.24,
  'lsb:10:90000:25': 5.74,
  'lsb:10:90000:26': 5.74,
  'lsb:10:90000:27': 5.74,
  'lsb:10:90000:28': 5.74,
  'lsb:10:90000:29': 5.74,
  'lsb:10:90000:30': 5.74,
  'lsb:10:90000:30': 8.29,
  'lsb:10:90000:31': 8.29,
  'lsb:10:90000:32': 8.29,
  'lsb:10:90000:33': 8.29,
  'lsb:10:90000:34': 8.29,
  'lsb:10:90000:35': 8.29,
  'lsb:10:90000:35': 12.6,
  'lsb:10:90000:36': 12.6,
  'lsb:10:90000:37': 12.6,
  'lsb:10:90000:38': 12.6,
  'lsb:10:90000:39': 12.6,
  'lsb:10:90000:40': 12.6,
  'lsb:10:90000:40': 19.7,
  'lsb:10:90000:41': 19.7,
  'lsb:10:90000:42': 19.7,
  'lsb:10:90000:43': 19.7,
  'lsb:10:90000:44': 19.7,
  'lsb:10:90000:45': 19.7,
  'lsb:10:90000:45': 30.73,
  'lsb:10:90000:46': 30.73,
  'lsb:10:90000:47': 30.73,
  'lsb:10:90000:48': 30.73,
  'lsb:10:90000:49': 30.73,
  'lsb:10:90000:50': 30.73,
  'lsb:10:90000:50': 46.81,
  'lsb:10:90000:51': 46.81,
  'lsb:10:90000:52': 46.81,
  'lsb:10:90000:53': 46.81,
  'lsb:10:90000:54': 46.81,
  'lsb:10:90000:55': 46.81,
  'lsb:10:90000:55': 68.16,
  'lsb:10:90000:56': 68.16,
  'lsb:10:90000:57': 68.16,
  'lsb:10:90000:58': 68.16,
  'lsb:10:90000:59': 68.16,
  'lsb:10:90000:60': 68.16,
  'lsb:10:90000:60': 98.01,
  'lsb:10:90000:61': 98.01,
  'lsb:10:90000:62': 98.01,
  'lsb:10:90000:63': 98.01,
  'lsb:10:90000:64': 98.01,
  'lsb:10:90000:65': 98.01,
  'lsb:10:90000:65': 139.61,
  'lsb:10:90000:66': 139.61,
  'lsb:10:90000:67': 139.61,
  'lsb:10:90000:68': 139.61,
  'lsb:10:90000:69': 139.61,
  'lsb:10:90000:70': 139.61,
  'lsb:10:100000:1': 3.04,
  'lsb:10:100000:2': 3.04,
  'lsb:10:100000:3': 3.04,
  'lsb:10:100000:4': 3.04,
  'lsb:10:100000:5': 3.04,
  'lsb:10:100000:5': 3.12,
  'lsb:10:100000:6': 3.12,
  'lsb:10:100000:7': 3.12,
  'lsb:10:100000:8': 3.12,
  'lsb:10:100000:9': 3.12,
  'lsb:10:100000:10': 3.12,
  'lsb:10:100000:10': 3.33,
  'lsb:10:100000:11': 3.33,
  'lsb:10:100000:12': 3.33,
  'lsb:10:100000:13': 3.33,
  'lsb:10:100000:14': 3.33,
  'lsb:10:100000:15': 3.33,
  'lsb:10:100000:15': 3.78,
  'lsb:10:100000:16': 3.78,
  'lsb:10:100000:17': 3.78,
  'lsb:10:100000:18': 3.78,
  'lsb:10:100000:19': 3.78,
  'lsb:10:100000:20': 3.78,
  'lsb:10:100000:20': 4.72,
  'lsb:10:100000:21': 4.72,
  'lsb:10:100000:22': 4.72,
  'lsb:10:100000:23': 4.72,
  'lsb:10:100000:24': 4.72,
  'lsb:10:100000:25': 4.72,
  'lsb:10:100000:25': 6.38,
  'lsb:10:100000:26': 6.38,
  'lsb:10:100000:27': 6.38,
  'lsb:10:100000:28': 6.38,
  'lsb:10:100000:29': 6.38,
  'lsb:10:100000:30': 6.38,
  'lsb:10:100000:30': 9.22,
  'lsb:10:100000:31': 9.22,
  'lsb:10:100000:32': 9.22,
  'lsb:10:100000:33': 9.22,
  'lsb:10:100000:34': 9.22,
  'lsb:10:100000:35': 9.22,
  'lsb:10:100000:35': 14,
  'lsb:10:100000:36': 14,
  'lsb:10:100000:37': 14,
  'lsb:10:100000:38': 14,
  'lsb:10:100000:39': 14,
  'lsb:10:100000:40': 14,
  'lsb:10:100000:40': 21.9,
  'lsb:10:100000:41': 21.9,
  'lsb:10:100000:42': 21.9,
  'lsb:10:100000:43': 21.9,
  'lsb:10:100000:44': 21.9,
  'lsb:10:100000:45': 21.9,
  'lsb:10:100000:45': 34.16,
  'lsb:10:100000:46': 34.16,
  'lsb:10:100000:47': 34.16,
  'lsb:10:100000:48': 34.16,
  'lsb:10:100000:49': 34.16,
  'lsb:10:100000:50': 34.16,
  'lsb:10:100000:50': 52.04,
  'lsb:10:100000:51': 52.04,
  'lsb:10:100000:52': 52.04,
  'lsb:10:100000:53': 52.04,
  'lsb:10:100000:54': 52.04,
  'lsb:10:100000:55': 52.04,
  'lsb:10:100000:55': 75.77,
  'lsb:10:100000:56': 75.77,
  'lsb:10:100000:57': 75.77,
  'lsb:10:100000:58': 75.77,
  'lsb:10:100000:59': 75.77,
  'lsb:10:100000:60': 75.77,
  'lsb:10:100000:60': 108.94,
  'lsb:10:100000:61': 108.94,
  'lsb:10:100000:62': 108.94,
  'lsb:10:100000:63': 108.94,
  'lsb:10:100000:64': 108.94,
  'lsb:10:100000:65': 108.94,
  'lsb:10:100000:65': 155.04,
  'lsb:10:100000:66': 155.04,
  'lsb:10:100000:67': 155.04,
  'lsb:10:100000:68': 155.04,
  'lsb:10:100000:69': 155.04,
  'lsb:10:100000:70': 155.04,
  'lsb:10:120000:1': 3.65,
  'lsb:10:120000:2': 3.65,
  'lsb:10:120000:3': 3.65,
  'lsb:10:120000:4': 3.65,
  'lsb:10:120000:5': 3.65,
  'lsb:10:120000:5': 3.75,
  'lsb:10:120000:6': 3.75,
  'lsb:10:120000:7': 3.75,
  'lsb:10:120000:8': 3.75,
  'lsb:10:120000:9': 3.75,
  'lsb:10:120000:10': 3.75,
  'lsb:10:120000:10': 3.99,
  'lsb:10:120000:11': 3.99,
  'lsb:10:120000:12': 3.99,
  'lsb:10:120000:13': 3.99,
  'lsb:10:120000:14': 3.99,
  'lsb:10:120000:15': 3.99,
  'lsb:10:120000:15': 4.54,
  'lsb:10:120000:16': 4.54,
  'lsb:10:120000:17': 4.54,
  'lsb:10:120000:18': 4.54,
  'lsb:10:120000:19': 4.54,
  'lsb:10:120000:20': 4.54,
  'lsb:10:120000:20': 5.66,
  'lsb:10:120000:21': 5.66,
  'lsb:10:120000:22': 5.66,
  'lsb:10:120000:23': 5.66,
  'lsb:10:120000:24': 5.66,
  'lsb:10:120000:25': 5.66,
  'lsb:10:120000:25': 7.66,
  'lsb:10:120000:26': 7.66,
  'lsb:10:120000:27': 7.66,
  'lsb:10:120000:28': 7.66,
  'lsb:10:120000:29': 7.66,
  'lsb:10:120000:30': 7.66,
  'lsb:10:120000:30': 11.06,
  'lsb:10:120000:31': 11.06,
  'lsb:10:120000:32': 11.06,
  'lsb:10:120000:33': 11.06,
  'lsb:10:120000:34': 11.06,
  'lsb:10:120000:35': 11.06,
  'lsb:10:120000:35': 16.8,
  'lsb:10:120000:36': 16.8,
  'lsb:10:120000:37': 16.8,
  'lsb:10:120000:38': 16.8,
  'lsb:10:120000:39': 16.8,
  'lsb:10:120000:40': 16.8,
  'lsb:10:120000:40': 26.28,
  'lsb:10:120000:41': 26.28,
  'lsb:10:120000:42': 26.28,
  'lsb:10:120000:43': 26.28,
  'lsb:10:120000:44': 26.28,
  'lsb:10:120000:45': 26.28,
  'lsb:10:120000:45': 40.99,
  'lsb:10:120000:46': 40.99,
  'lsb:10:120000:47': 40.99,
  'lsb:10:120000:48': 40.99,
  'lsb:10:120000:49': 40.99,
  'lsb:10:120000:50': 40.99,
  'lsb:10:120000:50': 62.44,
  'lsb:10:120000:51': 62.44,
  'lsb:10:120000:52': 62.44,
  'lsb:10:120000:53': 62.44,
  'lsb:10:120000:54': 62.44,
  'lsb:10:120000:55': 62.44,
  'lsb:10:120000:55': 90.92,
  'lsb:10:120000:56': 90.92,
  'lsb:10:120000:57': 90.92,
  'lsb:10:120000:58': 90.92,
  'lsb:10:120000:59': 90.92,
  'lsb:10:120000:60': 90.92,
  'lsb:10:120000:60': 130.73,
  'lsb:10:120000:61': 130.73,
  'lsb:10:120000:62': 130.73,
  'lsb:10:120000:63': 130.73,
  'lsb:10:120000:64': 130.73,
  'lsb:10:120000:65': 130.73,
  'lsb:10:120000:65': 186.04,
  'lsb:10:120000:66': 186.04,
  'lsb:10:120000:67': 186.04,
  'lsb:10:120000:68': 186.04,
  'lsb:10:120000:69': 186.04,
  'lsb:10:120000:70': 186.04,
  'lsb:10:140000:1': 4.26,
  'lsb:10:140000:2': 4.26,
  'lsb:10:140000:3': 4.26,
  'lsb:10:140000:4': 4.26,
  'lsb:10:140000:5': 4.26,
  'lsb:10:140000:5': 4.37,
  'lsb:10:140000:6': 4.37,
  'lsb:10:140000:7': 4.37,
  'lsb:10:140000:8': 4.37,
  'lsb:10:140000:9': 4.37,
  'lsb:10:140000:10': 4.37,
  'lsb:10:140000:10': 4.66,
  'lsb:10:140000:11': 4.66,
  'lsb:10:140000:12': 4.66,
  'lsb:10:140000:13': 4.66,
  'lsb:10:140000:14': 4.66,
  'lsb:10:140000:15': 4.66,
  'lsb:10:140000:15': 5.3,
  'lsb:10:140000:16': 5.3,
  'lsb:10:140000:17': 5.3,
  'lsb:10:140000:18': 5.3,
  'lsb:10:140000:19': 5.3,
  'lsb:10:140000:20': 5.3,
  'lsb:10:140000:20': 6.61,
  'lsb:10:140000:21': 6.61,
  'lsb:10:140000:22': 6.61,
  'lsb:10:140000:23': 6.61,
  'lsb:10:140000:24': 6.61,
  'lsb:10:140000:25': 6.61,
  'lsb:10:140000:25': 8.94,
  'lsb:10:140000:26': 8.94,
  'lsb:10:140000:27': 8.94,
  'lsb:10:140000:28': 8.94,
  'lsb:10:140000:29': 8.94,
  'lsb:10:140000:30': 8.94,
  'lsb:10:140000:30': 12.91,
  'lsb:10:140000:31': 12.91,
  'lsb:10:140000:32': 12.91,
  'lsb:10:140000:33': 12.91,
  'lsb:10:140000:34': 12.91,
  'lsb:10:140000:35': 12.91,
  'lsb:10:140000:35': 19.62,
  'lsb:10:140000:36': 19.62,
  'lsb:10:140000:37': 19.62,
  'lsb:10:140000:38': 19.62,
  'lsb:10:140000:39': 19.62,
  'lsb:10:140000:40': 19.62,
  'lsb:10:140000:40': 30.68,
  'lsb:10:140000:41': 30.68,
  'lsb:10:140000:42': 30.68,
  'lsb:10:140000:43': 30.68,
  'lsb:10:140000:44': 30.68,
  'lsb:10:140000:45': 30.68,
  'lsb:10:140000:45': 47.86,
  'lsb:10:140000:46': 47.86,
  'lsb:10:140000:47': 47.86,
  'lsb:10:140000:48': 47.86,
  'lsb:10:140000:49': 47.86,
  'lsb:10:140000:50': 47.86,
  'lsb:10:140000:50': 72.9,
  'lsb:10:140000:51': 72.9,
  'lsb:10:140000:52': 72.9,
  'lsb:10:140000:53': 72.9,
  'lsb:10:140000:54': 72.9,
  'lsb:10:140000:55': 72.9,
  'lsb:10:140000:55': 106.15,
  'lsb:10:140000:56': 106.15,
  'lsb:10:140000:57': 106.15,
  'lsb:10:140000:58': 106.15,
  'lsb:10:140000:59': 106.15,
  'lsb:10:140000:60': 106.15,
  'lsb:10:140000:60': 152.64,
  'lsb:10:140000:61': 152.64,
  'lsb:10:140000:62': 152.64,
  'lsb:10:140000:63': 152.64,
  'lsb:10:140000:64': 152.64,
  'lsb:10:140000:65': 152.64,
  'lsb:10:140000:65': 217.23,
  'lsb:10:140000:66': 217.23,
  'lsb:10:140000:67': 217.23,
  'lsb:10:140000:68': 217.23,
  'lsb:10:140000:69': 217.23,
  'lsb:10:140000:70': 217.23,
  'lsb:10:160000:1': 4.87,
  'lsb:10:160000:2': 4.87,
  'lsb:10:160000:3': 4.87,
  'lsb:10:160000:4': 4.87,
  'lsb:10:160000:5': 4.87,
  'lsb:10:160000:5': 5,
  'lsb:10:160000:6': 5,
  'lsb:10:160000:7': 5,
  'lsb:10:160000:8': 5,
  'lsb:10:160000:9': 5,
  'lsb:10:160000:10': 5,
  'lsb:10:160000:10': 5.33,
  'lsb:10:160000:11': 5.33,
  'lsb:10:160000:12': 5.33,
  'lsb:10:160000:13': 5.33,
  'lsb:10:160000:14': 5.33,
  'lsb:10:160000:15': 5.33,
  'lsb:10:160000:15': 6.06,
  'lsb:10:160000:16': 6.06,
  'lsb:10:160000:17': 6.06,
  'lsb:10:160000:18': 6.06,
  'lsb:10:160000:19': 6.06,
  'lsb:10:160000:20': 6.06,
  'lsb:10:160000:20': 7.55,
  'lsb:10:160000:21': 7.55,
  'lsb:10:160000:22': 7.55,
  'lsb:10:160000:23': 7.55,
  'lsb:10:160000:24': 7.55,
  'lsb:10:160000:25': 7.55,
  'lsb:10:160000:25': 10.22,
  'lsb:10:160000:26': 10.22,
  'lsb:10:160000:27': 10.22,
  'lsb:10:160000:28': 10.22,
  'lsb:10:160000:29': 10.22,
  'lsb:10:160000:30': 10.22,
  'lsb:10:160000:30': 14.76,
  'lsb:10:160000:31': 14.76,
  'lsb:10:160000:32': 14.76,
  'lsb:10:160000:33': 14.76,
  'lsb:10:160000:34': 14.76,
  'lsb:10:160000:35': 14.76,
  'lsb:10:160000:35': 22.43,
  'lsb:10:160000:36': 22.43,
  'lsb:10:160000:37': 22.43,
  'lsb:10:160000:38': 22.43,
  'lsb:10:160000:39': 22.43,
  'lsb:10:160000:40': 22.43,
  'lsb:10:160000:40': 35.07,
  'lsb:10:160000:41': 35.07,
  'lsb:10:160000:42': 35.07,
  'lsb:10:160000:43': 35.07,
  'lsb:10:160000:44': 35.07,
  'lsb:10:160000:45': 35.07,
  'lsb:10:160000:45': 54.71,
  'lsb:10:160000:46': 54.71,
  'lsb:10:160000:47': 54.71,
  'lsb:10:160000:48': 54.71,
  'lsb:10:160000:49': 54.71,
  'lsb:10:160000:50': 54.71,
  'lsb:10:160000:50': 83.34,
  'lsb:10:160000:51': 83.34,
  'lsb:10:160000:52': 83.34,
  'lsb:10:160000:53': 83.34,
  'lsb:10:160000:54': 83.34,
  'lsb:10:160000:55': 83.34,
  'lsb:10:160000:55': 121.35,
  'lsb:10:160000:56': 121.35,
  'lsb:10:160000:57': 121.35,
  'lsb:10:160000:58': 121.35,
  'lsb:10:160000:59': 121.35,
  'lsb:10:160000:60': 121.35,
  'lsb:10:160000:60': 174.5,
  'lsb:10:160000:61': 174.5,
  'lsb:10:160000:62': 174.5,
  'lsb:10:160000:63': 174.5,
  'lsb:10:160000:64': 174.5,
  'lsb:10:160000:65': 174.5,
  'lsb:10:160000:65': 248.34,
  'lsb:10:160000:66': 248.34,
  'lsb:10:160000:67': 248.34,
  'lsb:10:160000:68': 248.34,
  'lsb:10:160000:69': 248.34,
  'lsb:10:160000:70': 248.34,
  'lsb:10:180000:1': 5.48,
  'lsb:10:180000:2': 5.48,
  'lsb:10:180000:3': 5.48,
  'lsb:10:180000:4': 5.48,
  'lsb:10:180000:5': 5.48,
  'lsb:10:180000:5': 5.63,
  'lsb:10:180000:6': 5.63,
  'lsb:10:180000:7': 5.63,
  'lsb:10:180000:8': 5.63,
  'lsb:10:180000:9': 5.63,
  'lsb:10:180000:10': 5.63,
  'lsb:10:180000:10': 6,
  'lsb:10:180000:11': 6,
  'lsb:10:180000:12': 6,
  'lsb:10:180000:13': 6,
  'lsb:10:180000:14': 6,
  'lsb:10:180000:15': 6,
  'lsb:10:180000:15': 6.81,
  'lsb:10:180000:16': 6.81,
  'lsb:10:180000:17': 6.81,
  'lsb:10:180000:18': 6.81,
  'lsb:10:180000:19': 6.81,
  'lsb:10:180000:20': 6.81,
  'lsb:10:180000:20': 8.49,
  'lsb:10:180000:21': 8.49,
  'lsb:10:180000:22': 8.49,
  'lsb:10:180000:23': 8.49,
  'lsb:10:180000:24': 8.49,
  'lsb:10:180000:25': 8.49,
  'lsb:10:180000:25': 11.48,
  'lsb:10:180000:26': 11.48,
  'lsb:10:180000:27': 11.48,
  'lsb:10:180000:28': 11.48,
  'lsb:10:180000:29': 11.48,
  'lsb:10:180000:30': 11.48,
  'lsb:10:180000:30': 16.58,
  'lsb:10:180000:31': 16.58,
  'lsb:10:180000:32': 16.58,
  'lsb:10:180000:33': 16.58,
  'lsb:10:180000:34': 16.58,
  'lsb:10:180000:35': 16.58,
  'lsb:10:180000:35': 25.2,
  'lsb:10:180000:36': 25.2,
  'lsb:10:180000:37': 25.2,
  'lsb:10:180000:38': 25.2,
  'lsb:10:180000:39': 25.2,
  'lsb:10:180000:40': 25.2,
  'lsb:10:180000:40': 39.4,
  'lsb:10:180000:41': 39.4,
  'lsb:10:180000:42': 39.4,
  'lsb:10:180000:43': 39.4,
  'lsb:10:180000:44': 39.4,
  'lsb:10:180000:45': 39.4,
  'lsb:10:180000:45': 61.46,
  'lsb:10:180000:46': 61.46,
  'lsb:10:180000:47': 61.46,
  'lsb:10:180000:48': 61.46,
  'lsb:10:180000:49': 61.46,
  'lsb:10:180000:50': 61.46,
  'lsb:10:180000:50': 93.63,
  'lsb:10:180000:51': 93.63,
  'lsb:10:180000:52': 93.63,
  'lsb:10:180000:53': 93.63,
  'lsb:10:180000:54': 93.63,
  'lsb:10:180000:55': 93.63,
  'lsb:10:180000:55': 136.32,
  'lsb:10:180000:56': 136.32,
  'lsb:10:180000:57': 136.32,
  'lsb:10:180000:58': 136.32,
  'lsb:10:180000:59': 136.32,
  'lsb:10:180000:60': 136.32,
  'lsb:10:180000:60': 196.02,
  'lsb:10:180000:61': 196.02,
  'lsb:10:180000:62': 196.02,
  'lsb:10:180000:63': 196.02,
  'lsb:10:180000:64': 196.02,
  'lsb:10:180000:65': 196.02,
  'lsb:10:180000:65': 279.22,
  'lsb:10:180000:66': 279.22,
  'lsb:10:180000:67': 279.22,
  'lsb:10:180000:68': 279.22,
  'lsb:10:180000:69': 279.22,
  'lsb:10:180000:70': 279.22,
  'lsb:10:200000:1': 6.08,
  'lsb:10:200000:2': 6.08,
  'lsb:10:200000:3': 6.08,
  'lsb:10:200000:4': 6.08,
  'lsb:10:200000:5': 6.08,
  'lsb:10:200000:5': 6.24,
  'lsb:10:200000:6': 6.24,
  'lsb:10:200000:7': 6.24,
  'lsb:10:200000:8': 6.24,
  'lsb:10:200000:9': 6.24,
  'lsb:10:200000:10': 6.24,
  'lsb:10:200000:10': 6.65,
  'lsb:10:200000:11': 6.65,
  'lsb:10:200000:12': 6.65,
  'lsb:10:200000:13': 6.65,
  'lsb:10:200000:14': 6.65,
  'lsb:10:200000:15': 6.65,
  'lsb:10:200000:15': 7.57,
  'lsb:10:200000:16': 7.57,
  'lsb:10:200000:17': 7.57,
  'lsb:10:200000:18': 7.57,
  'lsb:10:200000:19': 7.57,
  'lsb:10:200000:20': 7.57,
  'lsb:10:200000:20': 9.43,
  'lsb:10:200000:21': 9.43,
  'lsb:10:200000:22': 9.43,
  'lsb:10:200000:23': 9.43,
  'lsb:10:200000:24': 9.43,
  'lsb:10:200000:25': 9.43,
  'lsb:10:200000:25': 12.76,
  'lsb:10:200000:26': 12.76,
  'lsb:10:200000:27': 12.76,
  'lsb:10:200000:28': 12.76,
  'lsb:10:200000:29': 12.76,
  'lsb:10:200000:30': 12.76,
  'lsb:10:200000:30': 18.43,
  'lsb:10:200000:31': 18.43,
  'lsb:10:200000:32': 18.43,
  'lsb:10:200000:33': 18.43,
  'lsb:10:200000:34': 18.43,
  'lsb:10:200000:35': 18.43,
  'lsb:10:200000:35': 28.01,
  'lsb:10:200000:36': 28.01,
  'lsb:10:200000:37': 28.01,
  'lsb:10:200000:38': 28.01,
  'lsb:10:200000:39': 28.01,
  'lsb:10:200000:40': 28.01,
  'lsb:10:200000:40': 43.8,
  'lsb:10:200000:41': 43.8,
  'lsb:10:200000:42': 43.8,
  'lsb:10:200000:43': 43.8,
  'lsb:10:200000:44': 43.8,
  'lsb:10:200000:45': 43.8,
  'lsb:10:200000:45': 68.32,
  'lsb:10:200000:46': 68.32,
  'lsb:10:200000:47': 68.32,
  'lsb:10:200000:48': 68.32,
  'lsb:10:200000:49': 68.32,
  'lsb:10:200000:50': 68.32,
  'lsb:10:200000:50': 104.07,
  'lsb:10:200000:51': 104.07,
  'lsb:10:200000:52': 104.07,
  'lsb:10:200000:53': 104.07,
  'lsb:10:200000:54': 104.07,
  'lsb:10:200000:55': 104.07,
  'lsb:10:200000:55': 151.53,
  'lsb:10:200000:56': 151.53,
  'lsb:10:200000:57': 151.53,
  'lsb:10:200000:58': 151.53,
  'lsb:10:200000:59': 151.53,
  'lsb:10:200000:60': 151.53,
  'lsb:10:200000:60': 217.89,
  'lsb:10:200000:61': 217.89,
  'lsb:10:200000:62': 217.89,
  'lsb:10:200000:63': 217.89,
  'lsb:10:200000:64': 217.89,
  'lsb:10:200000:65': 217.89,
  'lsb:10:200000:65': 310.08,
  'lsb:10:200000:66': 310.08,
  'lsb:10:200000:67': 310.08,
  'lsb:10:200000:68': 310.08,
  'lsb:10:200000:69': 310.08,
  'lsb:10:200000:70': 310.08,
  'pab:10:10000:20': 0.23,
  'pab:10:10000:21': 0.23,
  'pab:10:10000:22': 0.23,
  'pab:10:10000:23': 0.23,
  'pab:10:10000:24': 0.23,
  'pab:10:10000:25': 0.23,
  'pab:10:10000:25': 0.29,
  'pab:10:10000:26': 0.29,
  'pab:10:10000:27': 0.29,
  'pab:10:10000:28': 0.29,
  'pab:10:10000:29': 0.29,
  'pab:10:10000:30': 0.29,
  'pab:10:10000:30': 0.3,
  'pab:10:10000:31': 0.3,
  'pab:10:10000:32': 0.3,
  'pab:10:10000:33': 0.3,
  'pab:10:10000:34': 0.3,
  'pab:10:10000:35': 0.3,
  'pab:10:10000:35': 0.32,
  'pab:10:10000:36': 0.32,
  'pab:10:10000:37': 0.32,
  'pab:10:10000:38': 0.32,
  'pab:10:10000:39': 0.32,
  'pab:10:10000:40': 0.32,
  'pab:10:10000:40': 0.4,
  'pab:10:10000:41': 0.4,
  'pab:10:10000:42': 0.4,
  'pab:10:10000:43': 0.4,
  'pab:10:10000:44': 0.4,
  'pab:10:10000:45': 0.4,
  'pab:10:10000:45': 0.54,
  'pab:10:10000:46': 0.54,
  'pab:10:10000:47': 0.54,
  'pab:10:10000:48': 0.54,
  'pab:10:10000:49': 0.54,
  'pab:10:10000:50': 0.54,
  'pab:10:10000:50': 0.77,
  'pab:10:10000:51': 0.77,
  'pab:10:10000:52': 0.77,
  'pab:10:10000:53': 0.77,
  'pab:10:10000:54': 0.77,
  'pab:10:10000:55': 0.77,
  'pab:10:10000:55': 1.14,
  'pab:10:10000:56': 1.14,
  'pab:10:10000:57': 1.14,
  'pab:10:10000:58': 1.14,
  'pab:10:10000:59': 1.14,
  'pab:10:20000:20': 0.45,
  'pab:10:20000:21': 0.45,
  'pab:10:20000:22': 0.45,
  'pab:10:20000:23': 0.45,
  'pab:10:20000:24': 0.45,
  'pab:10:20000:25': 0.45,
  'pab:10:20000:25': 0.57,
  'pab:10:20000:26': 0.57,
  'pab:10:20000:27': 0.57,
  'pab:10:20000:28': 0.57,
  'pab:10:20000:29': 0.57,
  'pab:10:20000:30': 0.57,
  'pab:10:20000:30': 0.61,
  'pab:10:20000:31': 0.61,
  'pab:10:20000:32': 0.61,
  'pab:10:20000:33': 0.61,
  'pab:10:20000:34': 0.61,
  'pab:10:20000:35': 0.61,
  'pab:10:20000:35': 0.65,
  'pab:10:20000:36': 0.65,
  'pab:10:20000:37': 0.65,
  'pab:10:20000:38': 0.65,
  'pab:10:20000:39': 0.65,
  'pab:10:20000:40': 0.65,
  'pab:10:20000:40': 0.79,
  'pab:10:20000:41': 0.79,
  'pab:10:20000:42': 0.79,
  'pab:10:20000:43': 0.79,
  'pab:10:20000:44': 0.79,
  'pab:10:20000:45': 0.79,
  'pab:10:20000:45': 1.07,
  'pab:10:20000:46': 1.07,
  'pab:10:20000:47': 1.07,
  'pab:10:20000:48': 1.07,
  'pab:10:20000:49': 1.07,
  'pab:10:20000:50': 1.07,
  'pab:10:20000:50': 1.54,
  'pab:10:20000:51': 1.54,
  'pab:10:20000:52': 1.54,
  'pab:10:20000:53': 1.54,
  'pab:10:20000:54': 1.54,
  'pab:10:20000:55': 1.54,
  'pab:10:20000:55': 2.27,
  'pab:10:20000:56': 2.27,
  'pab:10:20000:57': 2.27,
  'pab:10:20000:58': 2.27,
  'pab:10:20000:59': 2.27,
  'pab:10:30000:20': 0.68,
  'pab:10:30000:21': 0.68,
  'pab:10:30000:22': 0.68,
  'pab:10:30000:23': 0.68,
  'pab:10:30000:24': 0.68,
  'pab:10:30000:25': 0.68,
  'pab:10:30000:25': 0.86,
  'pab:10:30000:26': 0.86,
  'pab:10:30000:27': 0.86,
  'pab:10:30000:28': 0.86,
  'pab:10:30000:29': 0.86,
  'pab:10:30000:30': 0.86,
  'pab:10:30000:30': 0.91,
  'pab:10:30000:31': 0.91,
  'pab:10:30000:32': 0.91,
  'pab:10:30000:33': 0.91,
  'pab:10:30000:34': 0.91,
  'pab:10:30000:35': 0.91,
  'pab:10:30000:35': 0.97,
  'pab:10:30000:36': 0.97,
  'pab:10:30000:37': 0.97,
  'pab:10:30000:38': 0.97,
  'pab:10:30000:39': 0.97,
  'pab:10:30000:40': 0.97,
  'pab:10:30000:40': 1.19,
  'pab:10:30000:41': 1.19,
  'pab:10:30000:42': 1.19,
  'pab:10:30000:43': 1.19,
  'pab:10:30000:44': 1.19,
  'pab:10:30000:45': 1.19,
  'pab:10:30000:45': 1.61,
  'pab:10:30000:46': 1.61,
  'pab:10:30000:47': 1.61,
  'pab:10:30000:48': 1.61,
  'pab:10:30000:49': 1.61,
  'pab:10:30000:50': 1.61,
  'pab:10:30000:50': 2.32,
  'pab:10:30000:51': 2.32,
  'pab:10:30000:52': 2.32,
  'pab:10:30000:53': 2.32,
  'pab:10:30000:54': 2.32,
  'pab:10:30000:55': 2.32,
  'pab:10:30000:55': 3.4,
  'pab:10:30000:56': 3.4,
  'pab:10:30000:57': 3.4,
  'pab:10:30000:58': 3.4,
  'pab:10:30000:59': 3.4,
  'pab:10:40000:20': 0.9,
  'pab:10:40000:21': 0.9,
  'pab:10:40000:22': 0.9,
  'pab:10:40000:23': 0.9,
  'pab:10:40000:24': 0.9,
  'pab:10:40000:25': 0.9,
  'pab:10:40000:25': 1.14,
  'pab:10:40000:26': 1.14,
  'pab:10:40000:27': 1.14,
  'pab:10:40000:28': 1.14,
  'pab:10:40000:29': 1.14,
  'pab:10:40000:30': 1.14,
  'pab:10:40000:30': 1.21,
  'pab:10:40000:31': 1.21,
  'pab:10:40000:32': 1.21,
  'pab:10:40000:33': 1.21,
  'pab:10:40000:34': 1.21,
  'pab:10:40000:35': 1.21,
  'pab:10:40000:35': 1.29,
  'pab:10:40000:36': 1.29,
  'pab:10:40000:37': 1.29,
  'pab:10:40000:38': 1.29,
  'pab:10:40000:39': 1.29,
  'pab:10:40000:40': 1.29,
  'pab:10:40000:40': 1.59,
  'pab:10:40000:41': 1.59,
  'pab:10:40000:42': 1.59,
  'pab:10:40000:43': 1.59,
  'pab:10:40000:44': 1.59,
  'pab:10:40000:45': 1.59,
  'pab:10:40000:45': 2.14,
  'pab:10:40000:46': 2.14,
  'pab:10:40000:47': 2.14,
  'pab:10:40000:48': 2.14,
  'pab:10:40000:49': 2.14,
  'pab:10:40000:50': 2.14,
  'pab:10:40000:50': 3.09,
  'pab:10:40000:51': 3.09,
  'pab:10:40000:52': 3.09,
  'pab:10:40000:53': 3.09,
  'pab:10:40000:54': 3.09,
  'pab:10:40000:55': 3.09,
  'pab:10:40000:55': 4.54,
  'pab:10:40000:56': 4.54,
  'pab:10:40000:57': 4.54,
  'pab:10:40000:58': 4.54,
  'pab:10:40000:59': 4.54,
  'pab:10:50000:20': 1.13,
  'pab:10:50000:21': 1.13,
  'pab:10:50000:22': 1.13,
  'pab:10:50000:23': 1.13,
  'pab:10:50000:24': 1.13,
  'pab:10:50000:25': 1.13,
  'pab:10:50000:25': 1.43,
  'pab:10:50000:26': 1.43,
  'pab:10:50000:27': 1.43,
  'pab:10:50000:28': 1.43,
  'pab:10:50000:29': 1.43,
  'pab:10:50000:30': 1.43,
  'pab:10:50000:30': 1.52,
  'pab:10:50000:31': 1.52,
  'pab:10:50000:32': 1.52,
  'pab:10:50000:33': 1.52,
  'pab:10:50000:34': 1.52,
  'pab:10:50000:35': 1.52,
  'pab:10:50000:35': 1.62,
  'pab:10:50000:36': 1.62,
  'pab:10:50000:37': 1.62,
  'pab:10:50000:38': 1.62,
  'pab:10:50000:39': 1.62,
  'pab:10:50000:40': 1.62,
  'pab:10:50000:40': 1.99,
  'pab:10:50000:41': 1.99,
  'pab:10:50000:42': 1.99,
  'pab:10:50000:43': 1.99,
  'pab:10:50000:44': 1.99,
  'pab:10:50000:45': 1.99,
  'pab:10:50000:45': 2.68,
  'pab:10:50000:46': 2.68,
  'pab:10:50000:47': 2.68,
  'pab:10:50000:48': 2.68,
  'pab:10:50000:49': 2.68,
  'pab:10:50000:50': 2.68,
  'pab:10:50000:50': 3.86,
  'pab:10:50000:51': 3.86,
  'pab:10:50000:52': 3.86,
  'pab:10:50000:53': 3.86,
  'pab:10:50000:54': 3.86,
  'pab:10:50000:55': 3.86,
  'pab:10:50000:55': 5.67,
  'pab:10:50000:56': 5.67,
  'pab:10:50000:57': 5.67,
  'pab:10:50000:58': 5.67,
  'pab:10:50000:59': 5.67,
  'ffun:15:5000:1': 32,
  'ffun:15:5000:2': 32,
  'ffun:15:5000:3': 32,
  'ffun:15:5000:4': 32,
  'ffun:15:5000:5': 32,
  'ffun:15:5000:6': 32,
  'ffun:15:5000:7': 32,
  'ffun:15:5000:8': 32,
  'ffun:15:5000:9': 32,
  'ffun:15:5000:10': 32,
  'ffun:15:5000:11': 32,
  'ffun:15:5000:12': 32,
  'ffun:15:5000:13': 32,
  'ffun:15:5000:14': 32,
  'ffun:15:5000:15': 32,
  'ffun:15:5000:16': 32,
  'ffun:15:5000:17': 32,
  'ffun:15:5000:18': 32,
  'ffun:15:5000:19': 32,
  'ffun:15:5000:20': 32,
  'ffun:15:5000:21': 33,
  'ffun:15:5000:22': 33,
  'ffun:15:5000:23': 33,
  'ffun:15:5000:24': 33,
  'ffun:15:5000:25': 33,
  'ffun:15:5000:26': 33,
  'ffun:15:5000:27': 33,
  'ffun:15:5000:28': 33,
  'ffun:15:5000:29': 33,
  'ffun:15:5000:30': 33,
  'ffun:15:5000:31': 34,
  'ffun:15:5000:32': 34,
  'ffun:15:5000:33': 34,
  'ffun:15:5000:34': 34,
  'ffun:15:5000:35': 34,
  'ffun:15:5000:36': 36,
  'ffun:15:5000:37': 36,
  'ffun:15:5000:38': 36,
  'ffun:15:5000:39': 36,
  'ffun:15:5000:40': 36,
  'ffun:15:5000:41': 39,
  'ffun:15:5000:42': 39,
  'ffun:15:5000:43': 39,
  'ffun:15:5000:44': 39,
  'ffun:15:5000:45': 39,
  'ffun:15:5000:46': 44,
  'ffun:15:5000:47': 44,
  'ffun:15:5000:48': 44,
  'ffun:15:5000:49': 44,
  'ffun:15:5000:50': 44,
  'ffun:15:5000:51': 54.33,
  'ffun:15:5000:52': 54.33,
  'ffun:15:5000:53': 54.33,
  'ffun:15:5000:54': 54.33,
  'ffun:15:5000:55': 54.33,
  'ffun:15:5000:56': 55.28,
  'ffun:15:5000:57': 55.28,
  'ffun:15:5000:58': 55.28,
  'ffun:15:5000:59': 55.28,
  'ffun:15:5000:60': 55.28,
  'ffun:15:5000:61': 57.85,
  'ffun:15:5000:62': 57.85,
  'ffun:15:5000:63': 57.85,
  'ffun:15:5000:64': 57.85,
  'ffun:15:5000:65': 57.85,
  'ffun:15:5000:66': 64.17,
  'ffun:15:5000:67': 64.17,
  'ffun:15:5000:68': 64.17,
  'ffun:15:5000:69': 64.17,
  'ffun:15:5000:70': 64.17,
  'ffun:15:5000:71': 76.32,
  'ffun:15:5000:72': 76.32,
  'ffun:15:5000:73': 76.32,
  'ffun:15:5000:74': 76.32,
  'ffun:15:5000:75': 76.32,
  'ffun:15:5000:76': 97.08,
  'ffun:15:5000:77': 97.08,
  'ffun:15:5000:78': 97.08,
  'ffun:15:5000:79': 97.08,
  'ffun:15:5000:80': 97.08,
  'ffun:15:5000:81': 136.73,
  'ffun:15:5000:82': 136.73,
  'ffun:15:5000:83': 136.73,
  'ffun:15:5000:84': 136.73,
  'ffun:15:5000:85': 136.73,
  'ffun:15:5000:86': 180.64,
  'ffun:15:5000:87': 180.64,
  'ffun:15:5000:88': 180.64,
  'ffun:15:5000:89': 180.64,
  'ffun:15:5000:90': 180.64,
  'ffun:15:5000:91': 242.75,
  'ffun:15:5000:92': 242.75,
  'ffun:15:5000:93': 242.75,
  'ffun:15:5000:94': 242.75,
  'ffun:15:5000:95': 242.75,
  'ffun:15:5000:96': 385.91,
  'ffun:15:5000:97': 385.91,
  'ffun:15:5000:98': 385.91,
  'ffun:15:5000:99': 385.91,
  'ffun:15:5000:100': 385.91,
  'ffun:15:7500:1': 33,
  'ffun:15:7500:2': 33,
  'ffun:15:7500:3': 33,
  'ffun:15:7500:4': 33,
  'ffun:15:7500:5': 33,
  'ffun:15:7500:6': 33,
  'ffun:15:7500:7': 33,
  'ffun:15:7500:8': 33,
  'ffun:15:7500:9': 33,
  'ffun:15:7500:10': 33,
  'ffun:15:7500:11': 33,
  'ffun:15:7500:12': 33,
  'ffun:15:7500:13': 33,
  'ffun:15:7500:14': 33,
  'ffun:15:7500:15': 33,
  'ffun:15:7500:16': 33,
  'ffun:15:7500:17': 33,
  'ffun:15:7500:18': 33,
  'ffun:15:7500:19': 33,
  'ffun:15:7500:20': 33,
  'ffun:15:7500:21': 34,
  'ffun:15:7500:22': 34,
  'ffun:15:7500:23': 34,
  'ffun:15:7500:24': 34,
  'ffun:15:7500:25': 34,
  'ffun:15:7500:26': 34,
  'ffun:15:7500:27': 34,
  'ffun:15:7500:28': 34,
  'ffun:15:7500:29': 34,
  'ffun:15:7500:30': 34,
  'ffun:15:7500:31': 36,
  'ffun:15:7500:32': 36,
  'ffun:15:7500:33': 36,
  'ffun:15:7500:34': 36,
  'ffun:15:7500:35': 36,
  'ffun:15:7500:36': 39,
  'ffun:15:7500:37': 39,
  'ffun:15:7500:38': 39,
  'ffun:15:7500:39': 39,
  'ffun:15:7500:40': 39,
  'ffun:15:7500:41': 43,
  'ffun:15:7500:42': 43,
  'ffun:15:7500:43': 43,
  'ffun:15:7500:44': 43,
  'ffun:15:7500:45': 43,
  'ffun:15:7500:46': 50,
  'ffun:15:7500:47': 50,
  'ffun:15:7500:48': 50,
  'ffun:15:7500:49': 50,
  'ffun:15:7500:50': 50,
  'ffun:15:7500:51': 63.87,
  'ffun:15:7500:52': 63.87,
  'ffun:15:7500:53': 63.87,
  'ffun:15:7500:54': 63.87,
  'ffun:15:7500:55': 63.87,
  'ffun:15:7500:56': 66.81,
  'ffun:15:7500:57': 66.81,
  'ffun:15:7500:58': 66.81,
  'ffun:15:7500:59': 66.81,
  'ffun:15:7500:60': 66.81,
  'ffun:15:7500:61': 72.17,
  'ffun:15:7500:62': 72.17,
  'ffun:15:7500:63': 72.17,
  'ffun:15:7500:64': 72.17,
  'ffun:15:7500:65': 72.17,
  'ffun:15:7500:66': 83.2,
  'ffun:15:7500:67': 83.2,
  'ffun:15:7500:68': 83.2,
  'ffun:15:7500:69': 83.2,
  'ffun:15:7500:70': 83.2,
  'ffun:15:7500:71': 101.69,
  'ffun:15:7500:72': 101.69,
  'ffun:15:7500:73': 101.69,
  'ffun:15:7500:74': 101.69,
  'ffun:15:7500:75': 101.69,
  'ffun:15:7500:76': 132.76,
  'ffun:15:7500:77': 132.76,
  'ffun:15:7500:78': 132.76,
  'ffun:15:7500:79': 132.76,
  'ffun:15:7500:80': 132.76,
  'ffun:15:7500:81': 191.17,
  'ffun:15:7500:82': 191.17,
  'ffun:15:7500:83': 191.17,
  'ffun:15:7500:84': 191.17,
  'ffun:15:7500:85': 191.17,
  'ffun:15:7500:86': 256.69,
  'ffun:15:7500:87': 256.69,
  'ffun:15:7500:88': 256.69,
  'ffun:15:7500:89': 256.69,
  'ffun:15:7500:90': 256.69,
  'ffun:15:7500:91': 348.71,
  'ffun:15:7500:92': 348.71,
  'ffun:15:7500:93': 348.71,
  'ffun:15:7500:94': 348.71,
  'ffun:15:7500:95': 348.71,
  'ffun:15:7500:96': 559.62,
  'ffun:15:7500:97': 559.62,
  'ffun:15:7500:98': 559.62,
  'ffun:15:7500:99': 559.62,
  'ffun:15:7500:100': 559.62,
  'ffun:15:10000:1': 34,
  'ffun:15:10000:2': 34,
  'ffun:15:10000:3': 34,
  'ffun:15:10000:4': 34,
  'ffun:15:10000:5': 34,
  'ffun:15:10000:6': 34,
  'ffun:15:10000:7': 34,
  'ffun:15:10000:8': 34,
  'ffun:15:10000:9': 34,
  'ffun:15:10000:10': 34,
  'ffun:15:10000:11': 34,
  'ffun:15:10000:12': 34,
  'ffun:15:10000:13': 34,
  'ffun:15:10000:14': 34,
  'ffun:15:10000:15': 34,
  'ffun:15:10000:16': 34,
  'ffun:15:10000:17': 34,
  'ffun:15:10000:18': 34,
  'ffun:15:10000:19': 34,
  'ffun:15:10000:20': 34,
  'ffun:15:10000:21': 35,
  'ffun:15:10000:22': 35,
  'ffun:15:10000:23': 35,
  'ffun:15:10000:24': 35,
  'ffun:15:10000:25': 35,
  'ffun:15:10000:26': 36,
  'ffun:15:10000:27': 36,
  'ffun:15:10000:28': 36,
  'ffun:15:10000:29': 36,
  'ffun:15:10000:30': 36,
  'ffun:15:10000:31': 38,
  'ffun:15:10000:32': 38,
  'ffun:15:10000:33': 38,
  'ffun:15:10000:34': 38,
  'ffun:15:10000:35': 38,
  'ffun:15:10000:36': 41,
  'ffun:15:10000:37': 41,
  'ffun:15:10000:38': 41,
  'ffun:15:10000:39': 41,
  'ffun:15:10000:40': 41,
  'ffun:15:10000:41': 48,
  'ffun:15:10000:42': 48,
  'ffun:15:10000:43': 48,
  'ffun:15:10000:44': 48,
  'ffun:15:10000:45': 48,
  'ffun:15:10000:46': 57,
  'ffun:15:10000:47': 57,
  'ffun:15:10000:48': 57,
  'ffun:15:10000:49': 57,
  'ffun:15:10000:50': 57,
  'ffun:15:10000:51': 73.5,
  'ffun:15:10000:52': 73.5,
  'ffun:15:10000:53': 73.5,
  'ffun:15:10000:54': 73.5,
  'ffun:15:10000:55': 73.5,
  'ffun:15:10000:56': 78.49,
  'ffun:15:10000:57': 78.49,
  'ffun:15:10000:58': 78.49,
  'ffun:15:10000:59': 78.49,
  'ffun:15:10000:60': 78.49,
  'ffun:15:10000:61': 86.57,
  'ffun:15:10000:62': 86.57,
  'ffun:15:10000:63': 86.57,
  'ffun:15:10000:64': 86.57,
  'ffun:15:10000:65': 86.57,
  'ffun:15:10000:66': 102.26,
  'ffun:15:10000:67': 102.26,
  'ffun:15:10000:68': 102.26,
  'ffun:15:10000:69': 102.26,
  'ffun:15:10000:70': 102.26,
  'ffun:15:10000:71': 127.17,
  'ffun:15:10000:72': 127.17,
  'ffun:15:10000:73': 127.17,
  'ffun:15:10000:74': 127.17,
  'ffun:15:10000:75': 127.17,
  'ffun:15:10000:76': 168.69,
  'ffun:15:10000:77': 168.69,
  'ffun:15:10000:78': 168.69,
  'ffun:15:10000:79': 168.69,
  'ffun:15:10000:80': 168.69,
  'ffun:15:10000:81': 246.08,
  'ffun:15:10000:82': 246.08,
  'ffun:15:10000:83': 246.08,
  'ffun:15:10000:84': 246.08,
  'ffun:15:10000:85': 246.08,
  'ffun:15:10000:86': 332.92,
  'ffun:15:10000:87': 332.92,
  'ffun:15:10000:88': 332.92,
  'ffun:15:10000:89': 332.92,
  'ffun:15:10000:90': 332.92,
  'ffun:15:10000:91': 454.62,
  'ffun:15:10000:92': 454.62,
  'ffun:15:10000:93': 454.62,
  'ffun:15:10000:94': 454.62,
  'ffun:15:10000:95': 454.62,
  'ffun:15:10000:96': 733.38,
  'ffun:15:10000:97': 733.38,
  'ffun:15:10000:98': 733.38,
  'ffun:15:10000:99': 733.38,
  'ffun:15:10000:100': 733.38,
  'ffun:15:15000:1': 36,
  'ffun:15:15000:2': 36,
  'ffun:15:15000:3': 36,
  'ffun:15:15000:4': 36,
  'ffun:15:15000:5': 36,
  'ffun:15:15000:6': 36,
  'ffun:15:15000:7': 36,
  'ffun:15:15000:8': 36,
  'ffun:15:15000:9': 36,
  'ffun:15:15000:10': 36,
  'ffun:15:15000:11': 36,
  'ffun:15:15000:12': 36,
  'ffun:15:15000:13': 36,
  'ffun:15:15000:14': 36,
  'ffun:15:15000:15': 36,
  'ffun:15:15000:16': 36,
  'ffun:15:15000:17': 36,
  'ffun:15:15000:18': 36,
  'ffun:15:15000:19': 36,
  'ffun:15:15000:20': 36,
  'ffun:15:15000:21': 37,
  'ffun:15:15000:22': 37,
  'ffun:15:15000:23': 37,
  'ffun:15:15000:24': 37,
  'ffun:15:15000:25': 37,
  'ffun:15:15000:26': 38,
  'ffun:15:15000:27': 38,
  'ffun:15:15000:28': 38,
  'ffun:15:15000:29': 38,
  'ffun:15:15000:30': 38,
  'ffun:15:15000:31': 41,
  'ffun:15:15000:32': 41,
  'ffun:15:15000:33': 41,
  'ffun:15:15000:34': 41,
  'ffun:15:15000:35': 41,
  'ffun:15:15000:36': 47,
  'ffun:15:15000:37': 47,
  'ffun:15:15000:38': 47,
  'ffun:15:15000:39': 47,
  'ffun:15:15000:40': 47,
  'ffun:15:15000:41': 56,
  'ffun:15:15000:42': 56,
  'ffun:15:15000:43': 56,
  'ffun:15:15000:44': 56,
  'ffun:15:15000:45': 56,
  'ffun:15:15000:46': 70,
  'ffun:15:15000:47': 70,
  'ffun:15:15000:48': 70,
  'ffun:15:15000:49': 70,
  'ffun:15:15000:50': 70,
  'ffun:15:15000:51': 92.72,
  'ffun:15:15000:52': 92.72,
  'ffun:15:15000:53': 92.72,
  'ffun:15:15000:54': 92.72,
  'ffun:15:15000:55': 92.72,
  'ffun:15:15000:56': 101.78,
  'ffun:15:15000:57': 101.78,
  'ffun:15:15000:58': 101.78,
  'ffun:15:15000:59': 101.78,
  'ffun:15:15000:60': 101.78,
  'ffun:15:15000:61': 115.52,
  'ffun:15:15000:62': 115.52,
  'ffun:15:15000:63': 115.52,
  'ffun:15:15000:64': 115.52,
  'ffun:15:15000:65': 115.52,
  'ffun:15:15000:66': 140.46,
  'ffun:15:15000:67': 140.46,
  'ffun:15:15000:68': 140.46,
  'ffun:15:15000:69': 140.46,
  'ffun:15:15000:70': 140.46,
  'ffun:15:15000:71': 177.91,
  'ffun:15:15000:72': 177.91,
  'ffun:15:15000:73': 177.91,
  'ffun:15:15000:74': 177.91,
  'ffun:15:15000:75': 177.91,
  'ffun:15:15000:76': 240.35,
  'ffun:15:15000:77': 240.35,
  'ffun:15:15000:78': 240.35,
  'ffun:15:15000:79': 240.35,
  'ffun:15:15000:80': 240.35,
  'ffun:15:15000:81': 355.62,
  'ffun:15:15000:82': 355.62,
  'ffun:15:15000:83': 355.62,
  'ffun:15:15000:84': 355.62,
  'ffun:15:15000:85': 355.62,
  'ffun:15:15000:86': 485.29,
  'ffun:15:15000:87': 485.29,
  'ffun:15:15000:88': 485.29,
  'ffun:15:15000:89': 485.29,
  'ffun:15:15000:90': 485.29,
  'ffun:15:15000:91': 666.69,
  'ffun:15:15000:92': 666.69,
  'ffun:15:15000:93': 666.69,
  'ffun:15:15000:94': 666.69,
  'ffun:15:15000:95': 666.69,
  'ffun:15:15000:96': 1081.2,
  'ffun:15:15000:97': 1081.2,
  'ffun:15:15000:98': 1081.2,
  'ffun:15:15000:99': 1081.2,
  'ffun:15:15000:100': 1081.2,
  'ffun:15:20000:1': 38,
  'ffun:15:20000:2': 38,
  'ffun:15:20000:3': 38,
  'ffun:15:20000:4': 38,
  'ffun:15:20000:5': 38,
  'ffun:15:20000:6': 38,
  'ffun:15:20000:7': 38,
  'ffun:15:20000:8': 38,
  'ffun:15:20000:9': 38,
  'ffun:15:20000:10': 38,
  'ffun:15:20000:11': 38,
  'ffun:15:20000:12': 38,
  'ffun:15:20000:13': 38,
  'ffun:15:20000:14': 38,
  'ffun:15:20000:15': 38,
  'ffun:15:20000:16': 38,
  'ffun:15:20000:17': 38,
  'ffun:15:20000:18': 38,
  'ffun:15:20000:19': 38,
  'ffun:15:20000:20': 38,
  'ffun:15:20000:21': 39,
  'ffun:15:20000:22': 39,
  'ffun:15:20000:23': 39,
  'ffun:15:20000:24': 39,
  'ffun:15:20000:25': 39,
  'ffun:15:20000:26': 41,
  'ffun:15:20000:27': 41,
  'ffun:15:20000:28': 41,
  'ffun:15:20000:29': 41,
  'ffun:15:20000:30': 41,
  'ffun:15:20000:31': 45,
  'ffun:15:20000:32': 45,
  'ffun:15:20000:33': 45,
  'ffun:15:20000:34': 45,
  'ffun:15:20000:35': 45,
  'ffun:15:20000:36': 52,
  'ffun:15:20000:37': 52,
  'ffun:15:20000:38': 52,
  'ffun:15:20000:39': 52,
  'ffun:15:20000:40': 52,
  'ffun:15:20000:41': 65,
  'ffun:15:20000:42': 65,
  'ffun:15:20000:43': 65,
  'ffun:15:20000:44': 65,
  'ffun:15:20000:45': 65,
  'ffun:15:20000:46': 84,
  'ffun:15:20000:47': 84,
  'ffun:15:20000:48': 84,
  'ffun:15:20000:49': 84,
  'ffun:15:20000:50': 84,
  'ffun:15:20000:51': 111.81,
  'ffun:15:20000:52': 111.81,
  'ffun:15:20000:53': 111.81,
  'ffun:15:20000:54': 111.81,
  'ffun:15:20000:55': 111.81,
  'ffun:15:20000:56': 125,
  'ffun:15:20000:57': 125,
  'ffun:15:20000:58': 125,
  'ffun:15:20000:59': 125,
  'ffun:15:20000:60': 125,
  'ffun:15:20000:61': 144.49,
  'ffun:15:20000:62': 144.49,
  'ffun:15:20000:63': 144.49,
  'ffun:15:20000:64': 144.49,
  'ffun:15:20000:65': 144.49,
  'ffun:15:20000:66': 178.81,
  'ffun:15:20000:67': 178.81,
  'ffun:15:20000:68': 178.81,
  'ffun:15:20000:69': 178.81,
  'ffun:15:20000:70': 178.81,
  'ffun:15:20000:71': 229.04,
  'ffun:15:20000:72': 229.04,
  'ffun:15:20000:73': 229.04,
  'ffun:15:20000:74': 229.04,
  'ffun:15:20000:75': 229.04,
  'ffun:15:20000:76': 312.21,
  'ffun:15:20000:77': 312.21,
  'ffun:15:20000:78': 312.21,
  'ffun:15:20000:79': 312.21,
  'ffun:15:20000:80': 312.21,
  'ffun:15:20000:81': 465.06,
  'ffun:15:20000:82': 465.06,
  'ffun:15:20000:83': 465.06,
  'ffun:15:20000:84': 465.06,
  'ffun:15:20000:85': 465.06,
  'ffun:15:20000:86': 637.52,
  'ffun:15:20000:87': 637.52,
  'ffun:15:20000:88': 637.52,
  'ffun:15:20000:89': 637.52,
  'ffun:15:20000:90': 637.52,
  'ffun:15:20000:91': 878.57,
  'ffun:15:20000:92': 878.57,
  'ffun:15:20000:93': 878.57,
  'ffun:15:20000:94': 878.57,
  'ffun:15:20000:95': 878.57,
  'ffun:15:20000:96': 1428.72,
  'ffun:15:20000:97': 1428.72,
  'ffun:15:20000:98': 1428.72,
  'ffun:15:20000:99': 1428.72,
  'ffun:15:20000:100': 1428.72,
  'ffun:15:25000:1': 40,
  'ffun:15:25000:2': 40,
  'ffun:15:25000:3': 40,
  'ffun:15:25000:4': 40,
  'ffun:15:25000:5': 40,
  'ffun:15:25000:6': 40,
  'ffun:15:25000:7': 40,
  'ffun:15:25000:8': 40,
  'ffun:15:25000:9': 40,
  'ffun:15:25000:10': 40,
  'ffun:15:25000:11': 40,
  'ffun:15:25000:12': 40,
  'ffun:15:25000:13': 40,
  'ffun:15:25000:14': 40,
  'ffun:15:25000:15': 40,
  'ffun:15:25000:16': 40,
  'ffun:15:25000:17': 40,
  'ffun:15:25000:18': 40,
  'ffun:15:25000:19': 40,
  'ffun:15:25000:20': 40,
  'ffun:15:25000:21': 41,
  'ffun:15:25000:22': 41,
  'ffun:15:25000:23': 41,
  'ffun:15:25000:24': 41,
  'ffun:15:25000:25': 41,
  'ffun:15:25000:26': 44,
  'ffun:15:25000:27': 44,
  'ffun:15:25000:28': 44,
  'ffun:15:25000:29': 44,
  'ffun:15:25000:30': 44,
  'ffun:15:25000:31': 49,
  'ffun:15:25000:32': 49,
  'ffun:15:25000:33': 49,
  'ffun:15:25000:34': 49,
  'ffun:15:25000:35': 49,
  'ffun:15:25000:36': 58,
  'ffun:15:25000:37': 58,
  'ffun:15:25000:38': 58,
  'ffun:15:25000:39': 58,
  'ffun:15:25000:40': 58,
  'ffun:15:25000:41': 74,
  'ffun:15:25000:42': 74,
  'ffun:15:25000:43': 74,
  'ffun:15:25000:44': 74,
  'ffun:15:25000:45': 74,
  'ffun:15:25000:46': 97,
  'ffun:15:25000:47': 97,
  'ffun:15:25000:48': 97,
  'ffun:15:25000:49': 97,
  'ffun:15:25000:50': 97,
  'ffun:15:25000:51': 131.14,
  'ffun:15:25000:52': 131.14,
  'ffun:15:25000:53': 131.14,
  'ffun:15:25000:54': 131.14,
  'ffun:15:25000:55': 131.14,
  'ffun:15:25000:56': 148.3,
  'ffun:15:25000:57': 148.3,
  'ffun:15:25000:58': 148.3,
  'ffun:15:25000:59': 148.3,
  'ffun:15:25000:60': 148.3,
  'ffun:15:25000:61': 173.24,
  'ffun:15:25000:62': 173.24,
  'ffun:15:25000:63': 173.24,
  'ffun:15:25000:64': 173.24,
  'ffun:15:25000:65': 173.24,
  'ffun:15:25000:66': 216.98,
  'ffun:15:25000:67': 216.98,
  'ffun:15:25000:68': 216.98,
  'ffun:15:25000:69': 216.98,
  'ffun:15:25000:70': 216.98,
  'ffun:15:25000:71': 280.05,
  'ffun:15:25000:72': 280.05,
  'ffun:15:25000:73': 280.05,
  'ffun:15:25000:74': 280.05,
  'ffun:15:25000:75': 280.05,
  'ffun:15:25000:76': 384.08,
  'ffun:15:25000:77': 384.08,
  'ffun:15:25000:78': 384.08,
  'ffun:15:25000:79': 384.08,
  'ffun:15:25000:80': 384.08,
  'ffun:15:25000:81': 574.71,
  'ffun:15:25000:82': 574.71,
  'ffun:15:25000:83': 574.71,
  'ffun:15:25000:84': 574.71,
  'ffun:15:25000:85': 574.71,
  'ffun:15:25000:86': 790.02,
  'ffun:15:25000:87': 790.02,
  'ffun:15:25000:88': 790.02,
  'ffun:15:25000:89': 790.02,
  'ffun:15:25000:90': 790.02,
  'ffun:15:25000:91': 1090.79,
  'ffun:15:25000:92': 1090.79,
  'ffun:15:25000:93': 1090.79,
  'ffun:15:25000:94': 1090.79,
  'ffun:15:25000:95': 1090.79,
  'ffun:15:25000:96': 1776.78,
  'ffun:15:25000:97': 1776.78,
  'ffun:15:25000:98': 1776.78,
  'ffun:15:25000:99': 1776.78,
  'ffun:15:25000:100': 1776.78,
  'ffun:15:30000:1': 42,
  'ffun:15:30000:2': 42,
  'ffun:15:30000:3': 42,
  'ffun:15:30000:4': 42,
  'ffun:15:30000:5': 42,
  'ffun:15:30000:6': 42,
  'ffun:15:30000:7': 42,
  'ffun:15:30000:8': 42,
  'ffun:15:30000:9': 42,
  'ffun:15:30000:10': 42,
  'ffun:15:30000:11': 42,
  'ffun:15:30000:12': 42,
  'ffun:15:30000:13': 42,
  'ffun:15:30000:14': 42,
  'ffun:15:30000:15': 42,
  'ffun:15:30000:16': 42,
  'ffun:15:30000:17': 42,
  'ffun:15:30000:18': 42,
  'ffun:15:30000:19': 42,
  'ffun:15:30000:20': 42,
  'ffun:15:30000:21': 44,
  'ffun:15:30000:22': 44,
  'ffun:15:30000:23': 44,
  'ffun:15:30000:24': 44,
  'ffun:15:30000:25': 44,
  'ffun:15:30000:26': 47,
  'ffun:15:30000:27': 47,
  'ffun:15:30000:28': 47,
  'ffun:15:30000:29': 47,
  'ffun:15:30000:30': 47,
  'ffun:15:30000:31': 52,
  'ffun:15:30000:32': 52,
  'ffun:15:30000:33': 52,
  'ffun:15:30000:34': 52,
  'ffun:15:30000:35': 52,
  'ffun:15:30000:36': 63,
  'ffun:15:30000:37': 63,
  'ffun:15:30000:38': 63,
  'ffun:15:30000:39': 63,
  'ffun:15:30000:40': 63,
  'ffun:15:30000:41': 82,
  'ffun:15:30000:42': 82,
  'ffun:15:30000:43': 82,
  'ffun:15:30000:44': 82,
  'ffun:15:30000:45': 82,
  'ffun:15:30000:46': 110,
  'ffun:15:30000:47': 110,
  'ffun:15:30000:48': 110,
  'ffun:15:30000:49': 110,
  'ffun:15:30000:50': 110,
  'ffun:15:30000:51': 150.44,
  'ffun:15:30000:52': 150.44,
  'ffun:15:30000:53': 150.44,
  'ffun:15:30000:54': 150.44,
  'ffun:15:30000:55': 150.44,
  'ffun:15:30000:56': 171.68,
  'ffun:15:30000:57': 171.68,
  'ffun:15:30000:58': 171.68,
  'ffun:15:30000:59': 171.68,
  'ffun:15:30000:60': 171.68,
  'ffun:15:30000:61': 202.3,
  'ffun:15:30000:62': 202.3,
  'ffun:15:30000:63': 202.3,
  'ffun:15:30000:64': 202.3,
  'ffun:15:30000:65': 202.3,
  'ffun:15:30000:66': 255.23,
  'ffun:15:30000:67': 255.23,
  'ffun:15:30000:68': 255.23,
  'ffun:15:30000:69': 255.23,
  'ffun:15:30000:70': 255.23,
  'ffun:15:30000:71': 330.82,
  'ffun:15:30000:72': 330.82,
  'ffun:15:30000:73': 330.82,
  'ffun:15:30000:74': 330.82,
  'ffun:15:30000:75': 330.82,
  'ffun:15:30000:76': 455.55,
  'ffun:15:30000:77': 455.55,
  'ffun:15:30000:78': 455.55,
  'ffun:15:30000:79': 455.55,
  'ffun:15:30000:80': 455.55,
  'ffun:15:30000:81': 683.67,
  'ffun:15:30000:82': 683.67,
  'ffun:15:30000:83': 683.67,
  'ffun:15:30000:84': 683.67,
  'ffun:15:30000:85': 683.67,
  'ffun:15:30000:86': 941.59,
  'ffun:15:30000:87': 941.59,
  'ffun:15:30000:88': 941.59,
  'ffun:15:30000:89': 941.59,
  'ffun:15:30000:90': 941.59,
  'ffun:15:30000:91': 1301.79,
  'ffun:15:30000:92': 1301.79,
  'ffun:15:30000:93': 1301.79,
  'ffun:15:30000:94': 1301.79,
  'ffun:15:30000:95': 1301.79,
  'ffun:15:30000:96': 2122.84,
  'ffun:15:30000:97': 2122.84,
  'ffun:15:30000:98': 2122.84,
  'ffun:15:30000:99': 2122.84,
  'ffun:15:30000:100': 2122.84,
  'ffun:15:40000:1': 46,
  'ffun:15:40000:2': 46,
  'ffun:15:40000:3': 46,
  'ffun:15:40000:4': 46,
  'ffun:15:40000:5': 46,
  'ffun:15:40000:6': 45,
  'ffun:15:40000:7': 45,
  'ffun:15:40000:8': 45,
  'ffun:15:40000:9': 45,
  'ffun:15:40000:10': 45,
  'ffun:15:40000:11': 46,
  'ffun:15:40000:12': 46,
  'ffun:15:40000:13': 46,
  'ffun:15:40000:14': 46,
  'ffun:15:40000:15': 46,
  'ffun:15:40000:16': 46,
  'ffun:15:40000:17': 46,
  'ffun:15:40000:18': 46,
  'ffun:15:40000:19': 46,
  'ffun:15:40000:20': 46,
  'ffun:15:40000:21': 48,
  'ffun:15:40000:22': 48,
  'ffun:15:40000:23': 48,
  'ffun:15:40000:24': 48,
  'ffun:15:40000:25': 48,
  'ffun:15:40000:26': 52,
  'ffun:15:40000:27': 52,
  'ffun:15:40000:28': 52,
  'ffun:15:40000:29': 52,
  'ffun:15:40000:30': 52,
  'ffun:15:40000:31': 60,
  'ffun:15:40000:32': 60,
  'ffun:15:40000:33': 60,
  'ffun:15:40000:34': 60,
  'ffun:15:40000:35': 60,
  'ffun:15:40000:36': 74,
  'ffun:15:40000:37': 74,
  'ffun:15:40000:38': 74,
  'ffun:15:40000:39': 74,
  'ffun:15:40000:40': 74,
  'ffun:15:40000:41': 100,
  'ffun:15:40000:42': 100,
  'ffun:15:40000:43': 100,
  'ffun:15:40000:44': 100,
  'ffun:15:40000:45': 100,
  'ffun:15:40000:46': 137,
  'ffun:15:40000:47': 137,
  'ffun:15:40000:48': 137,
  'ffun:15:40000:49': 137,
  'ffun:15:40000:50': 137,
  'ffun:15:40000:51': 189,
  'ffun:15:40000:52': 189,
  'ffun:15:40000:53': 189,
  'ffun:15:40000:54': 189,
  'ffun:15:40000:55': 189,
  'ffun:15:40000:56': 218.33,
  'ffun:15:40000:57': 218.33,
  'ffun:15:40000:58': 218.33,
  'ffun:15:40000:59': 218.33,
  'ffun:15:40000:60': 218.33,
  'ffun:15:40000:61': 260.22,
  'ffun:15:40000:62': 260.22,
  'ffun:15:40000:63': 260.22,
  'ffun:15:40000:64': 260.22,
  'ffun:15:40000:65': 260.22,
  'ffun:15:40000:66': 331.85,
  'ffun:15:40000:67': 331.85,
  'ffun:15:40000:68': 331.85,
  'ffun:15:40000:69': 331.85,
  'ffun:15:40000:70': 331.85,
  'ffun:15:40000:71': 432.89,
  'ffun:15:40000:72': 432.89,
  'ffun:15:40000:73': 432.89,
  'ffun:15:40000:74': 432.89,
  'ffun:15:40000:75': 432.89,
  'ffun:15:40000:76': 599.38,
  'ffun:15:40000:77': 599.38,
  'ffun:15:40000:78': 599.38,
  'ffun:15:40000:79': 599.38,
  'ffun:15:40000:80': 599.38,
  'ffun:15:40000:81': 903.11,
  'ffun:15:40000:82': 903.11,
  'ffun:15:40000:83': 903.11,
  'ffun:15:40000:84': 903.11,
  'ffun:15:40000:85': 903.11,
  'ffun:15:40000:86': 1246.78,
  'ffun:15:40000:87': 1246.78,
  'ffun:15:40000:88': 1246.78,
  'ffun:15:40000:89': 1246.78,
  'ffun:15:40000:90': 1246.78,
  'ffun:15:40000:91': 1726.5,
  'ffun:15:40000:92': 1726.5,
  'ffun:15:40000:93': 1726.5,
  'ffun:15:40000:94': 1726.5,
  'ffun:15:40000:95': 1726.5,
  'ffun:15:40000:96': 2819.39,
  'ffun:15:40000:97': 2819.39,
  'ffun:15:40000:98': 2819.39,
  'ffun:15:40000:99': 2819.39,
  'ffun:15:40000:100': 2819.39,
  'ffun:15:50000:1': 49,
  'ffun:15:50000:2': 49,
  'ffun:15:50000:3': 49,
  'ffun:15:50000:4': 49,
  'ffun:15:50000:5': 49,
  'ffun:15:50000:6': 49,
  'ffun:15:50000:7': 49,
  'ffun:15:50000:8': 49,
  'ffun:15:50000:9': 49,
  'ffun:15:50000:10': 49,
  'ffun:15:50000:11': 50,
  'ffun:15:50000:12': 50,
  'ffun:15:50000:13': 50,
  'ffun:15:50000:14': 50,
  'ffun:15:50000:15': 50,
  'ffun:15:50000:16': 50,
  'ffun:15:50000:17': 50,
  'ffun:15:50000:18': 50,
  'ffun:15:50000:19': 50,
  'ffun:15:50000:20': 50,
  'ffun:15:50000:21': 53,
  'ffun:15:50000:22': 53,
  'ffun:15:50000:23': 53,
  'ffun:15:50000:24': 53,
  'ffun:15:50000:25': 53,
  'ffun:15:50000:26': 57,
  'ffun:15:50000:27': 57,
  'ffun:15:50000:28': 57,
  'ffun:15:50000:29': 57,
  'ffun:15:50000:30': 57,
  'ffun:15:50000:31': 67,
  'ffun:15:50000:32': 67,
  'ffun:15:50000:33': 67,
  'ffun:15:50000:34': 67,
  'ffun:15:50000:35': 67,
  'ffun:15:50000:36': 85,
  'ffun:15:50000:37': 85,
  'ffun:15:50000:38': 85,
  'ffun:15:50000:39': 85,
  'ffun:15:50000:40': 85,
  'ffun:15:50000:41': 117,
  'ffun:15:50000:42': 117,
  'ffun:15:50000:43': 117,
  'ffun:15:50000:44': 117,
  'ffun:15:50000:45': 117,
  'ffun:15:50000:46': 164,
  'ffun:15:50000:47': 164,
  'ffun:15:50000:48': 164,
  'ffun:15:50000:49': 164,
  'ffun:15:50000:50': 164,
  'ffun:15:50000:51': 229,
  'ffun:15:50000:52': 229,
  'ffun:15:50000:53': 229,
  'ffun:15:50000:54': 229,
  'ffun:15:50000:55': 229,
  'ffun:15:50000:56': 264.59,
  'ffun:15:50000:57': 264.59,
  'ffun:15:50000:58': 264.59,
  'ffun:15:50000:59': 264.59,
  'ffun:15:50000:60': 264.59,
  'ffun:15:50000:61': 317.94,
  'ffun:15:50000:62': 317.94,
  'ffun:15:50000:63': 317.94,
  'ffun:15:50000:64': 317.94,
  'ffun:15:50000:65': 317.94,
  'ffun:15:50000:66': 408.48,
  'ffun:15:50000:67': 408.48,
  'ffun:15:50000:68': 408.48,
  'ffun:15:50000:69': 408.48,
  'ffun:15:50000:70': 408.48,
  'ffun:15:50000:71': 534.95,
  'ffun:15:50000:72': 534.95,
  'ffun:15:50000:73': 534.95,
  'ffun:15:50000:74': 534.95,
  'ffun:15:50000:75': 534.95,
  'ffun:15:50000:76': 743.15,
  'ffun:15:50000:77': 743.15,
  'ffun:15:50000:78': 743.15,
  'ffun:15:50000:79': 743.15,
  'ffun:15:50000:80': 743.15,
  'ffun:15:50000:81': 1122.46,
  'ffun:15:50000:82': 1122.46,
  'ffun:15:50000:83': 1122.46,
  'ffun:15:50000:84': 1122.46,
  'ffun:15:50000:85': 1122.46,
  'ffun:15:50000:86': 1551.84,
  'ffun:15:50000:87': 1551.84,
  'ffun:15:50000:88': 1551.84,
  'ffun:15:50000:89': 1551.84,
  'ffun:15:50000:90': 1551.84,
  'ffun:15:50000:91': 2151,
  'ffun:15:50000:92': 2151,
  'ffun:15:50000:93': 2151,
  'ffun:15:50000:94': 2151,
  'ffun:15:50000:95': 2151,
  'ffun:15:50000:96': 3515.59,
  'ffun:15:50000:97': 3515.59,
  'ffun:15:50000:98': 3515.59,
  'ffun:15:50000:99': 3515.59,
  'ffun:15:50000:100': 3515.59,
  'ffun:15:60000:1': 49.94,
  'ffun:15:60000:2': 49.94,
  'ffun:15:60000:3': 49.94,
  'ffun:15:60000:4': 49.94,
  'ffun:15:60000:5': 49.94,
  'ffun:15:60000:6': 49.91,
  'ffun:15:60000:7': 49.91,
  'ffun:15:60000:8': 49.91,
  'ffun:15:60000:9': 49.91,
  'ffun:15:60000:10': 49.91,
  'ffun:15:60000:11': 50.61,
  'ffun:15:60000:12': 50.61,
  'ffun:15:60000:13': 50.61,
  'ffun:15:60000:14': 50.61,
  'ffun:15:60000:15': 50.61,
  'ffun:15:60000:16': 50.79,
  'ffun:15:60000:17': 50.79,
  'ffun:15:60000:18': 50.79,
  'ffun:15:60000:19': 50.79,
  'ffun:15:60000:20': 50.79,
  'ffun:15:60000:21': 53.34,
  'ffun:15:60000:22': 53.34,
  'ffun:15:60000:23': 53.34,
  'ffun:15:60000:24': 53.34,
  'ffun:15:60000:25': 53.34,
  'ffun:15:60000:26': 57.43,
  'ffun:15:60000:27': 57.43,
  'ffun:15:60000:28': 57.43,
  'ffun:15:60000:29': 57.43,
  'ffun:15:60000:30': 57.43,
  'ffun:15:60000:31': 68.79,
  'ffun:15:60000:32': 68.79,
  'ffun:15:60000:33': 68.79,
  'ffun:15:60000:34': 68.79,
  'ffun:15:60000:35': 68.79,
  'ffun:15:60000:36': 89.15,
  'ffun:15:60000:37': 89.15,
  'ffun:15:60000:38': 89.15,
  'ffun:15:60000:39': 89.15,
  'ffun:15:60000:40': 89.15,
  'ffun:15:60000:41': 119.73,
  'ffun:15:60000:42': 119.73,
  'ffun:15:60000:43': 119.73,
  'ffun:15:60000:44': 119.73,
  'ffun:15:60000:45': 119.73,
  'ffun:15:60000:46': 164.71,
  'ffun:15:60000:47': 164.71,
  'ffun:15:60000:48': 164.71,
  'ffun:15:60000:49': 164.71,
  'ffun:15:60000:50': 164.71,
  'ffun:15:60000:51': 265.91,
  'ffun:15:60000:52': 265.91,
  'ffun:15:60000:53': 265.91,
  'ffun:15:60000:54': 265.91,
  'ffun:15:60000:55': 265.91,
  'ffun:15:60000:56': 311.47,
  'ffun:15:60000:57': 311.47,
  'ffun:15:60000:58': 311.47,
  'ffun:15:60000:59': 311.47,
  'ffun:15:60000:60': 311.47,
  'ffun:15:60000:61': 375.79,
  'ffun:15:60000:62': 375.79,
  'ffun:15:60000:63': 375.79,
  'ffun:15:60000:64': 375.79,
  'ffun:15:60000:65': 375.79,
  'ffun:15:60000:66': 484.64,
  'ffun:15:60000:67': 484.64,
  'ffun:15:60000:68': 484.64,
  'ffun:15:60000:69': 484.64,
  'ffun:15:60000:70': 484.64,
  'ffun:15:60000:71': 636.4,
  'ffun:15:60000:72': 636.4,
  'ffun:15:60000:73': 636.4,
  'ffun:15:60000:74': 636.4,
  'ffun:15:60000:75': 636.4,
  'ffun:15:60000:76': 886.01,
  'ffun:15:60000:77': 886.01,
  'ffun:15:60000:78': 886.01,
  'ffun:15:60000:79': 886.01,
  'ffun:15:60000:80': 886.01,
  'ffun:15:60000:81': 1340.34,
  'ffun:15:60000:82': 1340.34,
  'ffun:15:60000:83': 1340.34,
  'ffun:15:60000:84': 1340.34,
  'ffun:15:60000:85': 1340.34,
  'ffun:15:60000:86': 1854.94,
  'ffun:15:60000:87': 1854.94,
  'ffun:15:60000:88': 1854.94,
  'ffun:15:60000:89': 1854.94,
  'ffun:15:60000:90': 1854.94,
  'ffun:15:60000:91': 2572.9,
  'ffun:15:60000:92': 2572.9,
  'ffun:15:60000:93': 2572.9,
  'ffun:15:60000:94': 2572.9,
  'ffun:15:60000:95': 2572.9,
  'ffun:15:60000:96': 4207.63,
  'ffun:15:60000:97': 4207.63,
  'ffun:15:60000:98': 4207.63,
  'ffun:15:60000:99': 4207.63,
  'ffun:15:60000:100': 4207.63,
  'ffun:15:70000:1': 50.88,
  'ffun:15:70000:2': 50.88,
  'ffun:15:70000:3': 50.88,
  'ffun:15:70000:4': 50.88,
  'ffun:15:70000:5': 50.88,
  'ffun:15:70000:6': 50.81,
  'ffun:15:70000:7': 50.81,
  'ffun:15:70000:8': 50.81,
  'ffun:15:70000:9': 50.81,
  'ffun:15:70000:10': 50.81,
  'ffun:15:70000:11': 51.22,
  'ffun:15:70000:12': 51.22,
  'ffun:15:70000:13': 51.22,
  'ffun:15:70000:14': 51.22,
  'ffun:15:70000:15': 51.22,
  'ffun:15:70000:16': 51.57,
  'ffun:15:70000:17': 51.57,
  'ffun:15:70000:18': 51.57,
  'ffun:15:70000:19': 51.57,
  'ffun:15:70000:20': 51.57,
  'ffun:15:70000:21': 53.67,
  'ffun:15:70000:22': 53.67,
  'ffun:15:70000:23': 53.67,
  'ffun:15:70000:24': 53.67,
  'ffun:15:70000:25': 53.67,
  'ffun:15:70000:26': 57.87,
  'ffun:15:70000:27': 57.87,
  'ffun:15:70000:28': 57.87,
  'ffun:15:70000:29': 57.87,
  'ffun:15:70000:30': 57.87,
  'ffun:15:70000:31': 70.58,
  'ffun:15:70000:32': 70.58,
  'ffun:15:70000:33': 70.58,
  'ffun:15:70000:34': 70.58,
  'ffun:15:70000:35': 70.58,
  'ffun:15:70000:36': 93.3,
  'ffun:15:70000:37': 93.3,
  'ffun:15:70000:38': 93.3,
  'ffun:15:70000:39': 93.3,
  'ffun:15:70000:40': 93.3,
  'ffun:15:70000:41': 134.52,
  'ffun:15:70000:42': 134.52,
  'ffun:15:70000:43': 134.52,
  'ffun:15:70000:44': 134.52,
  'ffun:15:70000:45': 134.52,
  'ffun:15:70000:46': 187.17,
  'ffun:15:70000:47': 187.17,
  'ffun:15:70000:48': 187.17,
  'ffun:15:70000:49': 187.17,
  'ffun:15:70000:50': 187.17,
  'ffun:15:70000:51': 304.52,
  'ffun:15:70000:52': 304.52,
  'ffun:15:70000:53': 304.52,
  'ffun:15:70000:54': 304.52,
  'ffun:15:70000:55': 304.52,
  'ffun:15:70000:56': 358.24,
  'ffun:15:70000:57': 358.24,
  'ffun:15:70000:58': 358.24,
  'ffun:15:70000:59': 358.24,
  'ffun:15:70000:60': 358.24,
  'ffun:15:70000:61': 433.86,
  'ffun:15:70000:62': 433.86,
  'ffun:15:70000:63': 433.86,
  'ffun:15:70000:64': 433.86,
  'ffun:15:70000:65': 433.86,
  'ffun:15:70000:66': 561.45,
  'ffun:15:70000:67': 561.45,
  'ffun:15:70000:68': 561.45,
  'ffun:15:70000:69': 561.45,
  'ffun:15:70000:70': 561.45,
  'ffun:15:70000:71': 738.69,
  'ffun:15:70000:72': 738.69,
  'ffun:15:70000:73': 738.69,
  'ffun:15:70000:74': 738.69,
  'ffun:15:70000:75': 738.69,
  'ffun:15:70000:76': 1030.13,
  'ffun:15:70000:77': 1030.13,
  'ffun:15:70000:78': 1030.13,
  'ffun:15:70000:79': 1030.13,
  'ffun:15:70000:80': 1030.13,
  'ffun:15:70000:81': 1560.21,
  'ffun:15:70000:82': 1560.21,
  'ffun:15:70000:83': 1560.21,
  'ffun:15:70000:84': 1560.21,
  'ffun:15:70000:85': 1560.21,
  'ffun:15:70000:86': 2160.68,
  'ffun:15:70000:87': 2160.68,
  'ffun:15:70000:88': 2160.68,
  'ffun:15:70000:89': 2160.68,
  'ffun:15:70000:90': 2160.68,
  'ffun:15:70000:91': 2998.34,
  'ffun:15:70000:92': 2998.34,
  'ffun:15:70000:93': 2998.34,
  'ffun:15:70000:94': 2998.34,
  'ffun:15:70000:95': 2998.34,
  'ffun:15:70000:96': 4905.32,
  'ffun:15:70000:97': 4905.32,
  'ffun:15:70000:98': 4905.32,
  'ffun:15:70000:99': 4905.32,
  'ffun:15:70000:100': 4905.32,
  'ffun:15:80000:1': 51.82,
  'ffun:15:80000:2': 51.82,
  'ffun:15:80000:3': 51.82,
  'ffun:15:80000:4': 51.82,
  'ffun:15:80000:5': 51.82,
  'ffun:15:80000:6': 51.72,
  'ffun:15:80000:7': 51.72,
  'ffun:15:80000:8': 51.72,
  'ffun:15:80000:9': 51.72,
  'ffun:15:80000:10': 51.72,
  'ffun:15:80000:11': 51.82,
  'ffun:15:80000:12': 51.82,
  'ffun:15:80000:13': 51.82,
  'ffun:15:80000:14': 51.82,
  'ffun:15:80000:15': 51.82,
  'ffun:15:80000:16': 52.36,
  'ffun:15:80000:17': 52.36,
  'ffun:15:80000:18': 52.36,
  'ffun:15:80000:19': 52.36,
  'ffun:15:80000:20': 52.36,
  'ffun:15:80000:21': 54.01,
  'ffun:15:80000:22': 54.01,
  'ffun:15:80000:23': 54.01,
  'ffun:15:80000:24': 54.01,
  'ffun:15:80000:25': 54.01,
  'ffun:15:80000:26': 58.3,
  'ffun:15:80000:27': 58.3,
  'ffun:15:80000:28': 58.3,
  'ffun:15:80000:29': 58.3,
  'ffun:15:80000:30': 58.3,
  'ffun:15:80000:31': 72.36,
  'ffun:15:80000:32': 72.36,
  'ffun:15:80000:33': 72.36,
  'ffun:15:80000:34': 72.36,
  'ffun:15:80000:35': 72.36,
  'ffun:15:80000:36': 97.44,
  'ffun:15:80000:37': 97.44,
  'ffun:15:80000:38': 97.44,
  'ffun:15:80000:39': 97.44,
  'ffun:15:80000:40': 97.44,
  'ffun:15:80000:41': 149.28,
  'ffun:15:80000:42': 149.28,
  'ffun:15:80000:43': 149.28,
  'ffun:15:80000:44': 149.28,
  'ffun:15:80000:45': 149.28,
  'ffun:15:80000:46': 209.35,
  'ffun:15:80000:47': 209.35,
  'ffun:15:80000:48': 209.35,
  'ffun:15:80000:49': 209.35,
  'ffun:15:80000:50': 209.35,
  'ffun:15:80000:51': 342.89,
  'ffun:15:80000:52': 342.89,
  'ffun:15:80000:53': 342.89,
  'ffun:15:80000:54': 342.89,
  'ffun:15:80000:55': 342.89,
  'ffun:15:80000:56': 404.94,
  'ffun:15:80000:57': 404.94,
  'ffun:15:80000:58': 404.94,
  'ffun:15:80000:59': 404.94,
  'ffun:15:80000:60': 404.94,
  'ffun:15:80000:61': 491.84,
  'ffun:15:80000:62': 491.84,
  'ffun:15:80000:63': 491.84,
  'ffun:15:80000:64': 491.84,
  'ffun:15:80000:65': 491.84,
  'ffun:15:80000:66': 638.14,
  'ffun:15:80000:67': 638.14,
  'ffun:15:80000:68': 638.14,
  'ffun:15:80000:69': 638.14,
  'ffun:15:80000:70': 638.14,
  'ffun:15:80000:71': 840.82,
  'ffun:15:80000:72': 840.82,
  'ffun:15:80000:73': 840.82,
  'ffun:15:80000:74': 840.82,
  'ffun:15:80000:75': 840.82,
  'ffun:15:80000:76': 1174.02,
  'ffun:15:80000:77': 1174.02,
  'ffun:15:80000:78': 1174.02,
  'ffun:15:80000:79': 1174.02,
  'ffun:15:80000:80': 1174.02,
  'ffun:15:80000:81': 1779.73,
  'ffun:15:80000:82': 1779.73,
  'ffun:15:80000:83': 1779.73,
  'ffun:15:80000:84': 1779.73,
  'ffun:15:80000:85': 1779.73,
  'ffun:15:80000:86': 2465.95,
  'ffun:15:80000:87': 2465.95,
  'ffun:15:80000:88': 2465.95,
  'ffun:15:80000:89': 2465.95,
  'ffun:15:80000:90': 2465.95,
  'ffun:15:80000:91': 3423.13,
  'ffun:15:80000:92': 3423.13,
  'ffun:15:80000:93': 3423.13,
  'ffun:15:80000:94': 3423.13,
  'ffun:15:80000:95': 3423.13,
  'ffun:15:80000:96': 5601.93,
  'ffun:15:80000:97': 5601.93,
  'ffun:15:80000:98': 5601.93,
  'ffun:15:80000:99': 5601.93,
  'ffun:15:80000:100': 5601.93,
  'ffun:15:90000:1': 55.22,
  'ffun:15:90000:2': 55.22,
  'ffun:15:90000:3': 55.22,
  'ffun:15:90000:4': 55.22,
  'ffun:15:90000:5': 55.22,
  'ffun:15:90000:6': 55.1,
  'ffun:15:90000:7': 55.1,
  'ffun:15:90000:8': 55.1,
  'ffun:15:90000:9': 55.1,
  'ffun:15:90000:10': 55.1,
  'ffun:15:90000:11': 55.22,
  'ffun:15:90000:12': 55.22,
  'ffun:15:90000:13': 55.22,
  'ffun:15:90000:14': 55.22,
  'ffun:15:90000:15': 55.22,
  'ffun:15:90000:16': 55.82,
  'ffun:15:90000:17': 55.82,
  'ffun:15:90000:18': 55.82,
  'ffun:15:90000:19': 55.82,
  'ffun:15:90000:20': 55.82,
  'ffun:15:90000:21': 57.68,
  'ffun:15:90000:22': 57.68,
  'ffun:15:90000:23': 57.68,
  'ffun:15:90000:24': 57.68,
  'ffun:15:90000:25': 57.68,
  'ffun:15:90000:26': 62.5,
  'ffun:15:90000:27': 62.5,
  'ffun:15:90000:28': 62.5,
  'ffun:15:90000:29': 62.5,
  'ffun:15:90000:30': 62.5,
  'ffun:15:90000:31': 78.12,
  'ffun:15:90000:32': 78.12,
  'ffun:15:90000:33': 78.12,
  'ffun:15:90000:34': 78.12,
  'ffun:15:90000:35': 78.12,
  'ffun:15:90000:36': 106.17,
  'ffun:15:90000:37': 106.17,
  'ffun:15:90000:38': 106.17,
  'ffun:15:90000:39': 106.17,
  'ffun:15:90000:40': 106.17,
  'ffun:15:90000:41': 164.15,
  'ffun:15:90000:42': 164.15,
  'ffun:15:90000:43': 164.15,
  'ffun:15:90000:44': 164.15,
  'ffun:15:90000:45': 164.15,
  'ffun:15:90000:46': 231.83,
  'ffun:15:90000:47': 231.83,
  'ffun:15:90000:48': 231.83,
  'ffun:15:90000:49': 231.83,
  'ffun:15:90000:50': 231.83,
  'ffun:15:90000:51': 381.21,
  'ffun:15:90000:52': 381.21,
  'ffun:15:90000:53': 381.21,
  'ffun:15:90000:54': 381.21,
  'ffun:15:90000:55': 381.21,
  'ffun:15:90000:56': 451.08,
  'ffun:15:90000:57': 451.08,
  'ffun:15:90000:58': 451.08,
  'ffun:15:90000:59': 451.08,
  'ffun:15:90000:60': 451.08,
  'ffun:15:90000:61': 549.07,
  'ffun:15:90000:62': 549.07,
  'ffun:15:90000:63': 549.07,
  'ffun:15:90000:64': 549.07,
  'ffun:15:90000:65': 549.07,
  'ffun:15:90000:66': 713.76,
  'ffun:15:90000:67': 713.76,
  'ffun:15:90000:68': 713.76,
  'ffun:15:90000:69': 713.76,
  'ffun:15:90000:70': 713.76,
  'ffun:15:90000:71': 941.63,
  'ffun:15:90000:72': 941.63,
  'ffun:15:90000:73': 941.63,
  'ffun:15:90000:74': 941.63,
  'ffun:15:90000:75': 941.63,
  'ffun:15:90000:76': 1316.02,
  'ffun:15:90000:77': 1316.02,
  'ffun:15:90000:78': 1316.02,
  'ffun:15:90000:79': 1316.02,
  'ffun:15:90000:80': 1316.02,
  'ffun:15:90000:81': 1996.32,
  'ffun:15:90000:82': 1996.32,
  'ffun:15:90000:83': 1996.32,
  'ffun:15:90000:84': 1996.32,
  'ffun:15:90000:85': 1996.32,
  'ffun:15:90000:86': 2767.29,
  'ffun:15:90000:87': 2767.29,
  'ffun:15:90000:88': 2767.29,
  'ffun:15:90000:89': 2767.29,
  'ffun:15:90000:90': 2767.29,
  'ffun:15:90000:91': 3842.5,
  'ffun:15:90000:92': 3842.5,
  'ffun:15:90000:93': 3842.5,
  'ffun:15:90000:94': 3842.5,
  'ffun:15:90000:95': 3842.5,
  'ffun:15:90000:96': 6289.78,
  'ffun:15:90000:97': 6289.78,
  'ffun:15:90000:98': 6289.78,
  'ffun:15:90000:99': 6289.78,
  'ffun:15:90000:100': 6289.78,
  'ffun:15:100000:1': 58.61,
  'ffun:15:100000:2': 58.61,
  'ffun:15:100000:3': 58.61,
  'ffun:15:100000:4': 58.61,
  'ffun:15:100000:5': 58.61,
  'ffun:15:100000:6': 58.48,
  'ffun:15:100000:7': 58.48,
  'ffun:15:100000:8': 58.48,
  'ffun:15:100000:9': 58.48,
  'ffun:15:100000:10': 58.48,
  'ffun:15:100000:11': 58.61,
  'ffun:15:100000:12': 58.61,
  'ffun:15:100000:13': 58.61,
  'ffun:15:100000:14': 58.61,
  'ffun:15:100000:15': 58.61,
  'ffun:15:100000:16': 59.28,
  'ffun:15:100000:17': 59.28,
  'ffun:15:100000:18': 59.28,
  'ffun:15:100000:19': 59.28,
  'ffun:15:100000:20': 59.28,
  'ffun:15:100000:21': 61.35,
  'ffun:15:100000:22': 61.35,
  'ffun:15:100000:23': 61.35,
  'ffun:15:100000:24': 61.35,
  'ffun:15:100000:25': 61.35,
  'ffun:15:100000:26': 66.71,
  'ffun:15:100000:27': 66.71,
  'ffun:15:100000:28': 66.71,
  'ffun:15:100000:29': 66.71,
  'ffun:15:100000:30': 66.71,
  'ffun:15:100000:31': 83.88,
  'ffun:15:100000:32': 83.88,
  'ffun:15:100000:33': 83.88,
  'ffun:15:100000:34': 83.88,
  'ffun:15:100000:35': 83.88,
  'ffun:15:100000:36': 114.9,
  'ffun:15:100000:37': 114.9,
  'ffun:15:100000:38': 114.9,
  'ffun:15:100000:39': 114.9,
  'ffun:15:100000:40': 114.9,
  'ffun:15:100000:41': 179.02,
  'ffun:15:100000:42': 179.02,
  'ffun:15:100000:43': 179.02,
  'ffun:15:100000:44': 179.02,
  'ffun:15:100000:45': 179.02,
  'ffun:15:100000:46': 254.3,
  'ffun:15:100000:47': 254.3,
  'ffun:15:100000:48': 254.3,
  'ffun:15:100000:49': 254.3,
  'ffun:15:100000:50': 254.3,
  'ffun:15:100000:51': 419.82,
  'ffun:15:100000:52': 419.82,
  'ffun:15:100000:53': 419.82,
  'ffun:15:100000:54': 419.82,
  'ffun:15:100000:55': 419.82,
  'ffun:15:100000:56': 497.82,
  'ffun:15:100000:57': 497.82,
  'ffun:15:100000:58': 497.82,
  'ffun:15:100000:59': 497.82,
  'ffun:15:100000:60': 497.82,
  'ffun:15:100000:61': 607.09,
  'ffun:15:100000:62': 607.09,
  'ffun:15:100000:63': 607.09,
  'ffun:15:100000:64': 607.09,
  'ffun:15:100000:65': 607.09,
  'ffun:15:100000:66': 790.51,
  'ffun:15:100000:67': 790.51,
  'ffun:15:100000:68': 790.51,
  'ffun:15:100000:69': 790.51,
  'ffun:15:100000:70': 790.51,
  'ffun:15:100000:71': 1043.84,
  'ffun:15:100000:72': 1043.84,
  'ffun:15:100000:73': 1043.84,
  'ffun:15:100000:74': 1043.84,
  'ffun:15:100000:75': 1043.84,
  'ffun:15:100000:76': 1459.96,
  'ffun:15:100000:77': 1459.96,
  'ffun:15:100000:78': 1459.96,
  'ffun:15:100000:79': 1459.96,
  'ffun:15:100000:80': 1459.96,
  'ffun:15:100000:81': 2215.92,
  'ffun:15:100000:82': 2215.92,
  'ffun:15:100000:83': 2215.92,
  'ffun:15:100000:84': 2215.92,
  'ffun:15:100000:85': 2215.92,
  'ffun:15:100000:86': 3072.8,
  'ffun:15:100000:87': 3072.8,
  'ffun:15:100000:88': 3072.8,
  'ffun:15:100000:89': 3072.8,
  'ffun:15:100000:90': 3072.8,
  'ffun:15:100000:91': 4267.78,
  'ffun:15:100000:92': 4267.78,
  'ffun:15:100000:93': 4267.78,
  'ffun:15:100000:94': 4267.78,
  'ffun:15:100000:95': 4267.78,
  'ffun:15:100000:96': 6987.42,
  'ffun:15:100000:97': 6987.42,
  'ffun:15:100000:98': 6987.42,
  'ffun:15:100000:99': 6987.42,
  'ffun:15:100000:100': 6987.42,
  'ffun:15:120000:1': 73.36,
  'ffun:15:120000:2': 73.36,
  'ffun:15:120000:3': 73.36,
  'ffun:15:120000:4': 73.36,
  'ffun:15:120000:5': 73.36,
  'ffun:15:120000:6': 73.19,
  'ffun:15:120000:7': 73.19,
  'ffun:15:120000:8': 73.19,
  'ffun:15:120000:9': 73.19,
  'ffun:15:120000:10': 73.19,
  'ffun:15:120000:11': 73.34,
  'ffun:15:120000:12': 73.34,
  'ffun:15:120000:13': 73.34,
  'ffun:15:120000:14': 73.34,
  'ffun:15:120000:15': 73.34,
  'ffun:15:120000:16': 74.14,
  'ffun:15:120000:17': 74.14,
  'ffun:15:120000:18': 74.14,
  'ffun:15:120000:19': 74.14,
  'ffun:15:120000:20': 74.14,
  'ffun:15:120000:21': 76.62,
  'ffun:15:120000:22': 76.62,
  'ffun:15:120000:23': 76.62,
  'ffun:15:120000:24': 76.62,
  'ffun:15:120000:25': 76.62,
  'ffun:15:120000:26': 83.16,
  'ffun:15:120000:27': 83.16,
  'ffun:15:120000:28': 83.16,
  'ffun:15:120000:29': 83.16,
  'ffun:15:120000:30': 83.16,
  'ffun:15:120000:31': 104.2,
  'ffun:15:120000:32': 104.2,
  'ffun:15:120000:33': 104.2,
  'ffun:15:120000:34': 104.2,
  'ffun:15:120000:35': 104.2,
  'ffun:15:120000:36': 142.02,
  'ffun:15:120000:37': 142.02,
  'ffun:15:120000:38': 142.02,
  'ffun:15:120000:39': 142.02,
  'ffun:15:120000:40': 142.02,
  'ffun:15:120000:41': 220.35,
  'ffun:15:120000:42': 220.35,
  'ffun:15:120000:43': 220.35,
  'ffun:15:120000:44': 220.35,
  'ffun:15:120000:45': 220.35,
  'ffun:15:120000:46': 313.56,
  'ffun:15:120000:47': 313.56,
  'ffun:15:120000:48': 313.56,
  'ffun:15:120000:49': 313.56,
  'ffun:15:120000:50': 313.56,
  'ffun:15:120000:51': 519.17,
  'ffun:15:120000:52': 519.17,
  'ffun:15:120000:53': 519.17,
  'ffun:15:120000:54': 519.17,
  'ffun:15:120000:55': 519.17,
  'ffun:15:120000:56': 615.47,
  'ffun:15:120000:57': 615.47,
  'ffun:15:120000:58': 615.47,
  'ffun:15:120000:59': 615.47,
  'ffun:15:120000:60': 615.47,
  'ffun:15:120000:61': 750.45,
  'ffun:15:120000:62': 750.45,
  'ffun:15:120000:63': 750.45,
  'ffun:15:120000:64': 750.45,
  'ffun:15:120000:65': 750.45,
  'ffun:15:120000:66': 978.02,
  'ffun:15:120000:67': 978.02,
  'ffun:15:120000:68': 978.02,
  'ffun:15:120000:69': 978.02,
  'ffun:15:120000:70': 978.02,
  'ffun:15:120000:71': 1396.12,
  'ffun:15:120000:72': 1396.12,
  'ffun:15:120000:73': 1396.12,
  'ffun:15:120000:74': 1396.12,
  'ffun:15:120000:75': 1396.12,
  'ffun:15:120000:76': 1989.92,
  'ffun:15:120000:77': 1989.92,
  'ffun:15:120000:78': 1989.92,
  'ffun:15:120000:79': 1989.92,
  'ffun:15:120000:80': 1989.92,
  'ffun:15:120000:81': 2971.36,
  'ffun:15:120000:82': 2971.36,
  'ffun:15:120000:83': 2971.36,
  'ffun:15:120000:84': 2971.36,
  'ffun:15:120000:85': 2971.36,
  'ffun:15:120000:86': 4206.73,
  'ffun:15:120000:87': 4206.73,
  'ffun:15:120000:88': 4206.73,
  'ffun:15:120000:89': 4206.73,
  'ffun:15:120000:90': 4206.73,
  'ffun:15:120000:91': 5989.19,
  'ffun:15:120000:92': 5989.19,
  'ffun:15:120000:93': 5989.19,
  'ffun:15:120000:94': 5989.19,
  'ffun:15:120000:95': 5989.19,
  'ffun:15:120000:96': 10305.24,
  'ffun:15:120000:97': 10305.24,
  'ffun:15:120000:98': 10305.24,
  'ffun:15:120000:99': 10305.24,
  'ffun:15:120000:100': 10305.24,
  'ffun:15:140000:1': 81.42,
  'ffun:15:140000:2': 81.42,
  'ffun:15:140000:3': 81.42,
  'ffun:15:140000:4': 81.42,
  'ffun:15:140000:5': 81.42,
  'ffun:15:140000:6': 81.21,
  'ffun:15:140000:7': 81.21,
  'ffun:15:140000:8': 81.21,
  'ffun:15:140000:9': 81.21,
  'ffun:15:140000:10': 81.21,
  'ffun:15:140000:11': 81.39,
  'ffun:15:140000:12': 81.39,
  'ffun:15:140000:13': 81.39,
  'ffun:15:140000:14': 81.39,
  'ffun:15:140000:15': 81.39,
  'ffun:15:140000:16': 82.32,
  'ffun:15:140000:17': 82.32,
  'ffun:15:140000:18': 82.32,
  'ffun:15:140000:19': 82.32,
  'ffun:15:140000:20': 82.32,
  'ffun:15:140000:21': 85.21,
  'ffun:15:140000:22': 85.21,
  'ffun:15:140000:23': 85.21,
  'ffun:15:140000:24': 85.21,
  'ffun:15:140000:25': 85.21,
  'ffun:15:140000:26': 92.81,
  'ffun:15:140000:27': 92.81,
  'ffun:15:140000:28': 92.81,
  'ffun:15:140000:29': 92.81,
  'ffun:15:140000:30': 92.81,
  'ffun:15:140000:31': 117.11,
  'ffun:15:140000:32': 117.11,
  'ffun:15:140000:33': 117.11,
  'ffun:15:140000:34': 117.11,
  'ffun:15:140000:35': 117.11,
  'ffun:15:140000:36': 161.05,
  'ffun:15:140000:37': 161.05,
  'ffun:15:140000:38': 161.05,
  'ffun:15:140000:39': 161.05,
  'ffun:15:140000:40': 161.05,
  'ffun:15:140000:41': 251.97,
  'ffun:15:140000:42': 251.97,
  'ffun:15:140000:43': 251.97,
  'ffun:15:140000:44': 251.97,
  'ffun:15:140000:45': 251.97,
  'ffun:15:140000:46': 360.75,
  'ffun:15:140000:47': 360.75,
  'ffun:15:140000:48': 360.75,
  'ffun:15:140000:49': 360.75,
  'ffun:15:140000:50': 360.75,
  'ffun:15:140000:51': 599.78,
  'ffun:15:140000:52': 599.78,
  'ffun:15:140000:53': 599.78,
  'ffun:15:140000:54': 599.78,
  'ffun:15:140000:55': 599.78,
  'ffun:15:140000:56': 712.61,
  'ffun:15:140000:57': 712.61,
  'ffun:15:140000:58': 712.61,
  'ffun:15:140000:59': 712.61,
  'ffun:15:140000:60': 712.61,
  'ffun:15:140000:61': 870.54,
  'ffun:15:140000:62': 870.54,
  'ffun:15:140000:63': 870.54,
  'ffun:15:140000:64': 870.54,
  'ffun:15:140000:65': 870.54,
  'ffun:15:140000:66': 1136.44,
  'ffun:15:140000:67': 1136.44,
  'ffun:15:140000:68': 1136.44,
  'ffun:15:140000:69': 1136.44,
  'ffun:15:140000:70': 1136.44,
  'ffun:15:140000:71': 1625.67,
  'ffun:15:140000:72': 1625.67,
  'ffun:15:140000:73': 1625.67,
  'ffun:15:140000:74': 1625.67,
  'ffun:15:140000:75': 1625.67,
  'ffun:15:140000:76': 2318.65,
  'ffun:15:140000:77': 2318.65,
  'ffun:15:140000:78': 2318.65,
  'ffun:15:140000:79': 2318.65,
  'ffun:15:140000:80': 2318.65,
  'ffun:15:140000:81': 3462.44,
  'ffun:15:140000:82': 3462.44,
  'ffun:15:140000:83': 3462.44,
  'ffun:15:140000:84': 3462.44,
  'ffun:15:140000:85': 3462.44,
  'ffun:15:140000:86': 4904.73,
  'ffun:15:140000:87': 4904.73,
  'ffun:15:140000:88': 4904.73,
  'ffun:15:140000:89': 4904.73,
  'ffun:15:140000:90': 4904.73,
  'ffun:15:140000:91': 6988.41,
  'ffun:15:140000:92': 6988.41,
  'ffun:15:140000:93': 6988.41,
  'ffun:15:140000:94': 6988.41,
  'ffun:15:140000:95': 6988.41,
  'ffun:15:140000:96': 12020.31,
  'ffun:15:140000:97': 12020.31,
  'ffun:15:140000:98': 12020.31,
  'ffun:15:140000:99': 12020.31,
  'ffun:15:140000:100': 12020.31,
  'ffun:15:160000:1': 89.56,
  'ffun:15:160000:2': 89.56,
  'ffun:15:160000:3': 89.56,
  'ffun:15:160000:4': 89.56,
  'ffun:15:160000:5': 89.56,
  'ffun:15:160000:6': 89.32,
  'ffun:15:160000:7': 89.32,
  'ffun:15:160000:8': 89.32,
  'ffun:15:160000:9': 89.32,
  'ffun:15:160000:10': 89.32,
  'ffun:15:160000:11': 89.53,
  'ffun:15:160000:12': 89.53,
  'ffun:15:160000:13': 89.53,
  'ffun:15:160000:14': 89.53,
  'ffun:15:160000:15': 89.53,
  'ffun:15:160000:16': 90.59,
  'ffun:15:160000:17': 90.59,
  'ffun:15:160000:18': 90.59,
  'ffun:15:160000:19': 90.59,
  'ffun:15:160000:20': 90.59,
  'ffun:15:160000:21': 93.9,
  'ffun:15:160000:22': 93.9,
  'ffun:15:160000:23': 93.9,
  'ffun:15:160000:24': 93.9,
  'ffun:15:160000:25': 93.9,
  'ffun:15:160000:26': 102.57,
  'ffun:15:160000:27': 102.57,
  'ffun:15:160000:28': 102.57,
  'ffun:15:160000:29': 102.57,
  'ffun:15:160000:30': 102.57,
  'ffun:15:160000:31': 130.07,
  'ffun:15:160000:32': 130.07,
  'ffun:15:160000:33': 130.07,
  'ffun:15:160000:34': 130.07,
  'ffun:15:160000:35': 130.07,
  'ffun:15:160000:36': 179.97,
  'ffun:15:160000:37': 179.97,
  'ffun:15:160000:38': 179.97,
  'ffun:15:160000:39': 179.97,
  'ffun:15:160000:40': 179.97,
  'ffun:15:160000:41': 283.18,
  'ffun:15:160000:42': 283.18,
  'ffun:15:160000:43': 283.18,
  'ffun:15:160000:44': 283.18,
  'ffun:15:160000:45': 283.18,
  'ffun:15:160000:46': 407.73,
  'ffun:15:160000:47': 407.73,
  'ffun:15:160000:48': 407.73,
  'ffun:15:160000:49': 407.73,
  'ffun:15:160000:50': 407.73,
  'ffun:15:160000:51': 680.61,
  'ffun:15:160000:52': 680.61,
  'ffun:15:160000:53': 680.61,
  'ffun:15:160000:54': 680.61,
  'ffun:15:160000:55': 680.61,
  'ffun:15:160000:56': 810.04,
  'ffun:15:160000:57': 810.04,
  'ffun:15:160000:58': 810.04,
  'ffun:15:160000:59': 810.04,
  'ffun:15:160000:60': 810.04,
  'ffun:15:160000:61': 991.03,
  'ffun:15:160000:62': 991.03,
  'ffun:15:160000:63': 991.03,
  'ffun:15:160000:64': 991.03,
  'ffun:15:160000:65': 991.03,
  'ffun:15:160000:66': 1295.45,
  'ffun:15:160000:67': 1295.45,
  'ffun:15:160000:68': 1295.45,
  'ffun:15:160000:69': 1295.45,
  'ffun:15:160000:70': 1295.45,
  'ffun:15:160000:71': 1854.8,
  'ffun:15:160000:72': 1854.8,
  'ffun:15:160000:73': 1854.8,
  'ffun:15:160000:74': 1854.8,
  'ffun:15:160000:75': 1854.8,
  'ffun:15:160000:76': 2647.02,
  'ffun:15:160000:77': 2647.02,
  'ffun:15:160000:78': 2647.02,
  'ffun:15:160000:79': 2647.02,
  'ffun:15:160000:80': 2647.02,
  'ffun:15:160000:81': 3954.3,
  'ffun:15:160000:82': 3954.3,
  'ffun:15:160000:83': 3954.3,
  'ffun:15:160000:84': 3954.3,
  'ffun:15:160000:85': 3954.3,
  'ffun:15:160000:86': 5602.96,
  'ffun:15:160000:87': 5602.96,
  'ffun:15:160000:88': 5602.96,
  'ffun:15:160000:89': 5602.96,
  'ffun:15:160000:90': 5602.96,
  'ffun:15:160000:91': 7984.65,
  'ffun:15:160000:92': 7984.65,
  'ffun:15:160000:93': 7984.65,
  'ffun:15:160000:94': 7984.65,
  'ffun:15:160000:95': 7984.65,
  'ffun:15:160000:96': 13735.68,
  'ffun:15:160000:97': 13735.68,
  'ffun:15:160000:98': 13735.68,
  'ffun:15:160000:99': 13735.68,
  'ffun:15:160000:100': 13735.68,
  'ffun:15:180000:1': 97.7,
  'ffun:15:180000:2': 97.7,
  'ffun:15:180000:3': 97.7,
  'ffun:15:180000:4': 97.7,
  'ffun:15:180000:5': 97.7,
  'ffun:15:180000:6': 97.43,
  'ffun:15:180000:7': 97.43,
  'ffun:15:180000:8': 97.43,
  'ffun:15:180000:9': 97.43,
  'ffun:15:180000:10': 97.43,
  'ffun:15:180000:11': 97.66,
  'ffun:15:180000:12': 97.66,
  'ffun:15:180000:13': 97.66,
  'ffun:15:180000:14': 97.66,
  'ffun:15:180000:15': 97.66,
  'ffun:15:180000:16': 98.85,
  'ffun:15:180000:17': 98.85,
  'ffun:15:180000:18': 98.85,
  'ffun:15:180000:19': 98.85,
  'ffun:15:180000:20': 98.85,
  'ffun:15:180000:21': 102.58,
  'ffun:15:180000:22': 102.58,
  'ffun:15:180000:23': 102.58,
  'ffun:15:180000:24': 102.58,
  'ffun:15:180000:25': 102.58,
  'ffun:15:180000:26': 112.33,
  'ffun:15:180000:27': 112.33,
  'ffun:15:180000:28': 112.33,
  'ffun:15:180000:29': 112.33,
  'ffun:15:180000:30': 112.33,
  'ffun:15:180000:31': 143.03,
  'ffun:15:180000:32': 143.03,
  'ffun:15:180000:33': 143.03,
  'ffun:15:180000:34': 143.03,
  'ffun:15:180000:35': 143.03,
  'ffun:15:180000:36': 199.03,
  'ffun:15:180000:37': 199.03,
  'ffun:15:180000:38': 199.03,
  'ffun:15:180000:39': 199.03,
  'ffun:15:180000:40': 199.03,
  'ffun:15:180000:41': 314.94,
  'ffun:15:180000:42': 314.94,
  'ffun:15:180000:43': 314.94,
  'ffun:15:180000:44': 314.94,
  'ffun:15:180000:45': 314.94,
  'ffun:15:180000:46': 454.77,
  'ffun:15:180000:47': 454.77,
  'ffun:15:180000:48': 454.77,
  'ffun:15:180000:49': 454.77,
  'ffun:15:180000:50': 454.77,
  'ffun:15:180000:51': 760.43,
  'ffun:15:180000:52': 760.43,
  'ffun:15:180000:53': 760.43,
  'ffun:15:180000:54': 760.43,
  'ffun:15:180000:55': 760.43,
  'ffun:15:180000:56': 906.2,
  'ffun:15:180000:57': 906.2,
  'ffun:15:180000:58': 906.2,
  'ffun:15:180000:59': 906.2,
  'ffun:15:180000:60': 906.2,
  'ffun:15:180000:61': 1109.91,
  'ffun:15:180000:62': 1109.91,
  'ffun:15:180000:63': 1109.91,
  'ffun:15:180000:64': 1109.91,
  'ffun:15:180000:65': 1109.91,
  'ffun:15:180000:66': 1452.25,
  'ffun:15:180000:67': 1452.25,
  'ffun:15:180000:68': 1452.25,
  'ffun:15:180000:69': 1452.25,
  'ffun:15:180000:70': 1452.25,
  'ffun:15:180000:71': 2080.66,
  'ffun:15:180000:72': 2080.66,
  'ffun:15:180000:73': 2080.66,
  'ffun:15:180000:74': 2080.66,
  'ffun:15:180000:75': 2080.66,
  'ffun:15:180000:76': 2970.59,
  'ffun:15:180000:77': 2970.59,
  'ffun:15:180000:78': 2970.59,
  'ffun:15:180000:79': 2970.59,
  'ffun:15:180000:80': 2970.59,
  'ffun:15:180000:81': 4438.95,
  'ffun:15:180000:82': 4438.95,
  'ffun:15:180000:83': 4438.95,
  'ffun:15:180000:84': 4438.95,
  'ffun:15:180000:85': 4438.95,
  'ffun:15:180000:86': 6290.8,
  'ffun:15:180000:87': 6290.8,
  'ffun:15:180000:88': 6290.8,
  'ffun:15:180000:89': 6290.8,
  'ffun:15:180000:90': 6290.8,
  'ffun:15:180000:91': 8966.46,
  'ffun:15:180000:92': 8966.46,
  'ffun:15:180000:93': 8966.46,
  'ffun:15:180000:94': 8966.46,
  'ffun:15:180000:95': 8966.46,
  'ffun:15:180000:96': 15427.99,
  'ffun:15:180000:97': 15427.99,
  'ffun:15:180000:98': 15427.99,
  'ffun:15:180000:99': 15427.99,
  'ffun:15:180000:100': 15427.99,
  'ffun:15:200000:1': 105.84,
  'ffun:15:200000:2': 105.84,
  'ffun:15:200000:3': 105.84,
  'ffun:15:200000:4': 105.84,
  'ffun:15:200000:5': 105.84,
  'ffun:15:200000:6': 105.54,
  'ffun:15:200000:7': 105.54,
  'ffun:15:200000:8': 105.54,
  'ffun:15:200000:9': 105.54,
  'ffun:15:200000:10': 105.54,
  'ffun:15:200000:11': 105.8,
  'ffun:15:200000:12': 105.8,
  'ffun:15:200000:13': 105.8,
  'ffun:15:200000:14': 105.8,
  'ffun:15:200000:15': 105.8,
  'ffun:15:200000:16': 107.12,
  'ffun:15:200000:17': 107.12,
  'ffun:15:200000:18': 107.12,
  'ffun:15:200000:19': 107.12,
  'ffun:15:200000:20': 107.12,
  'ffun:15:200000:21': 111.26,
  'ffun:15:200000:22': 111.26,
  'ffun:15:200000:23': 111.26,
  'ffun:15:200000:24': 111.26,
  'ffun:15:200000:25': 111.26,
  'ffun:15:200000:26': 122.08,
  'ffun:15:200000:27': 122.08,
  'ffun:15:200000:28': 122.08,
  'ffun:15:200000:29': 122.08,
  'ffun:15:200000:30': 122.08,
  'ffun:15:200000:31': 155.85,
  'ffun:15:200000:32': 155.85,
  'ffun:15:200000:33': 155.85,
  'ffun:15:200000:34': 155.85,
  'ffun:15:200000:35': 155.85,
  'ffun:15:200000:36': 217.93,
  'ffun:15:200000:37': 217.93,
  'ffun:15:200000:38': 217.93,
  'ffun:15:200000:39': 217.93,
  'ffun:15:200000:40': 217.93,
  'ffun:15:200000:41': 346.64,
  'ffun:15:200000:42': 346.64,
  'ffun:15:200000:43': 346.64,
  'ffun:15:200000:44': 346.64,
  'ffun:15:200000:45': 346.64,
  'ffun:15:200000:46': 502.12,
  'ffun:15:200000:47': 502.12,
  'ffun:15:200000:48': 502.12,
  'ffun:15:200000:49': 502.12,
  'ffun:15:200000:50': 502.12,
  'ffun:15:200000:51': 841.32,
  'ffun:15:200000:52': 841.32,
  'ffun:15:200000:53': 841.32,
  'ffun:15:200000:54': 841.32,
  'ffun:15:200000:55': 841.32,
  'ffun:15:200000:56': 1003.7,
  'ffun:15:200000:57': 1003.7,
  'ffun:15:200000:58': 1003.7,
  'ffun:15:200000:59': 1003.7,
  'ffun:15:200000:60': 1003.7,
  'ffun:15:200000:61': 1230.48,
  'ffun:15:200000:62': 1230.48,
  'ffun:15:200000:63': 1230.48,
  'ffun:15:200000:64': 1230.48,
  'ffun:15:200000:65': 1230.48,
  'ffun:15:200000:66': 1611.35,
  'ffun:15:200000:67': 1611.35,
  'ffun:15:200000:68': 1611.35,
  'ffun:15:200000:69': 1611.35,
  'ffun:15:200000:70': 1611.35,
  'ffun:15:200000:71': 2309.89,
  'ffun:15:200000:72': 2309.89,
  'ffun:15:200000:73': 2309.89,
  'ffun:15:200000:74': 2309.89,
  'ffun:15:200000:75': 2309.89,
  'ffun:15:200000:76': 3299.11,
  'ffun:15:200000:77': 3299.11,
  'ffun:15:200000:78': 3299.11,
  'ffun:15:200000:79': 3299.11,
  'ffun:15:200000:80': 3299.11,
  'ffun:15:200000:81': 4931.06,
  'ffun:15:200000:82': 4931.06,
  'ffun:15:200000:83': 4931.06,
  'ffun:15:200000:84': 4931.06,
  'ffun:15:200000:85': 4931.06,
  'ffun:15:200000:86': 6989.5,
  'ffun:15:200000:87': 6989.5,
  'ffun:15:200000:88': 6989.5,
  'ffun:15:200000:89': 6989.5,
  'ffun:15:200000:90': 6989.5,
  'ffun:15:200000:91': 9963.61,
  'ffun:15:200000:92': 9963.61,
  'ffun:15:200000:93': 9963.61,
  'ffun:15:200000:94': 9963.61,
  'ffun:15:200000:95': 9963.61,
  'ffun:15:200000:96': 17146,
  'ffun:15:200000:97': 17146,
  'ffun:15:200000:98': 17146,
  'ffun:15:200000:99': 17146,
  'ffun:15:200000:100': 17146,
  'mem:15:5000:1': 1.2,
  'mem:15:5000:2': 1.2,
  'mem:15:5000:3': 1.2,
  'mem:15:5000:4': 1.2,
  'mem:15:5000:5': 1.2,
  'mem:15:5000:6': 1.2,
  'mem:15:5000:7': 1.2,
  'mem:15:5000:8': 1.2,
  'mem:15:5000:9': 1.2,
  'mem:15:5000:10': 1.2,
  'mem:15:5000:11': 1.2,
  'mem:15:5000:12': 1.2,
  'mem:15:5000:13': 1.2,
  'mem:15:5000:14': 1.2,
  'mem:15:5000:15': 1.2,
  'mem:15:5000:16': 1.2,
  'mem:15:5000:17': 1.2,
  'mem:15:5000:18': 1.2,
  'mem:15:5000:19': 1.2,
  'mem:15:5000:20': 1.2,
  'mem:15:5000:21': 1.2,
  'mem:15:5000:22': 1.2,
  'mem:15:5000:23': 1.2,
  'mem:15:5000:24': 1.2,
  'mem:15:5000:25': 1.2,
  'mem:15:5000:26': 2.4,
  'mem:15:5000:27': 2.4,
  'mem:15:5000:28': 2.4,
  'mem:15:5000:29': 2.4,
  'mem:15:5000:30': 2.4,
  'mem:15:5000:31': 2.4,
  'mem:15:5000:32': 2.4,
  'mem:15:5000:33': 2.4,
  'mem:15:5000:34': 2.4,
  'mem:15:5000:35': 2.4,
  'mem:15:5000:36': 3.6,
  'mem:15:5000:37': 3.6,
  'mem:15:5000:38': 3.6,
  'mem:15:5000:39': 3.6,
  'mem:15:5000:40': 3.6,
  'mem:15:5000:41': 4.8,
  'mem:15:5000:42': 4.8,
  'mem:15:5000:43': 4.8,
  'mem:15:5000:44': 4.8,
  'mem:15:5000:45': 4.8,
  'mem:15:5000:46': 8.4,
  'mem:15:5000:47': 8.4,
  'mem:15:5000:48': 8.4,
  'mem:15:5000:49': 8.4,
  'mem:15:5000:50': 8.4,
  'mem:15:5000:51': 12,
  'mem:15:5000:52': 12,
  'mem:15:5000:53': 12,
  'mem:15:5000:54': 12,
  'mem:15:5000:55': 12,
  'mem:15:5000:56': 13.2,
  'mem:15:5000:57': 13.2,
  'mem:15:5000:58': 13.2,
  'mem:15:5000:59': 13.2,
  'mem:15:5000:60': 13.2,
  'mem:15:5000:61': 14.4,
  'mem:15:5000:62': 14.4,
  'mem:15:5000:63': 14.4,
  'mem:15:5000:64': 14.4,
  'mem:15:5000:65': 14.4,
  'mem:15:5000:66': 20.4,
  'mem:15:5000:67': 20.4,
  'mem:15:5000:68': 20.4,
  'mem:15:5000:69': 20.4,
  'mem:15:5000:70': 20.4,
  'mem:15:5000:71': 27.6,
  'mem:15:5000:72': 27.6,
  'mem:15:5000:73': 27.6,
  'mem:15:5000:74': 27.6,
  'mem:15:5000:75': 27.6,
  'mem:15:5000:76': 37.2,
  'mem:15:5000:77': 37.2,
  'mem:15:5000:78': 37.2,
  'mem:15:5000:79': 37.2,
  'mem:15:5000:80': 37.2,
  'mem:15:5000:81': 52.14,
  'mem:15:5000:82': 52.14,
  'mem:15:5000:83': 52.14,
  'mem:15:5000:84': 52.14,
  'mem:15:5000:85': 52.14,
  'mem:15:5000:86': 72.54,
  'mem:15:5000:87': 72.54,
  'mem:15:5000:88': 72.54,
  'mem:15:5000:89': 72.54,
  'mem:15:5000:90': 72.54,
  'mem:15:5000:91': 100.99,
  'mem:15:5000:92': 100.99,
  'mem:15:5000:93': 100.99,
  'mem:15:5000:94': 100.99,
  'mem:15:5000:95': 100.99,
  'mem:15:5000:96': 165.64,
  'mem:15:5000:97': 165.64,
  'mem:15:5000:98': 165.64,
  'mem:15:5000:99': 165.64,
  'mem:15:5000:100': 165.64,
  'mem:15:7500:1': 2.4,
  'mem:15:7500:2': 2.4,
  'mem:15:7500:3': 2.4,
  'mem:15:7500:4': 2.4,
  'mem:15:7500:5': 2.4,
  'mem:15:7500:6': 2.4,
  'mem:15:7500:7': 2.4,
  'mem:15:7500:8': 2.4,
  'mem:15:7500:9': 2.4,
  'mem:15:7500:10': 2.4,
  'mem:15:7500:11': 2.4,
  'mem:15:7500:12': 2.4,
  'mem:15:7500:13': 2.4,
  'mem:15:7500:14': 2.4,
  'mem:15:7500:15': 2.4,
  'mem:15:7500:16': 2.4,
  'mem:15:7500:17': 2.4,
  'mem:15:7500:18': 2.4,
  'mem:15:7500:19': 2.4,
  'mem:15:7500:20': 2.4,
  'mem:15:7500:21': 2.4,
  'mem:15:7500:22': 2.4,
  'mem:15:7500:23': 2.4,
  'mem:15:7500:24': 2.4,
  'mem:15:7500:25': 2.4,
  'mem:15:7500:26': 2.4,
  'mem:15:7500:27': 2.4,
  'mem:15:7500:28': 2.4,
  'mem:15:7500:29': 2.4,
  'mem:15:7500:30': 2.4,
  'mem:15:7500:31': 3.6,
  'mem:15:7500:32': 3.6,
  'mem:15:7500:33': 3.6,
  'mem:15:7500:34': 3.6,
  'mem:15:7500:35': 3.6,
  'mem:15:7500:36': 4.8,
  'mem:15:7500:37': 4.8,
  'mem:15:7500:38': 4.8,
  'mem:15:7500:39': 4.8,
  'mem:15:7500:40': 4.8,
  'mem:15:7500:41': 7.2,
  'mem:15:7500:42': 7.2,
  'mem:15:7500:43': 7.2,
  'mem:15:7500:44': 7.2,
  'mem:15:7500:45': 7.2,
  'mem:15:7500:46': 12,
  'mem:15:7500:47': 12,
  'mem:15:7500:48': 12,
  'mem:15:7500:49': 12,
  'mem:15:7500:50': 12,
  'mem:15:7500:51': 16.8,
  'mem:15:7500:52': 16.8,
  'mem:15:7500:53': 16.8,
  'mem:15:7500:54': 16.8,
  'mem:15:7500:55': 16.8,
  'mem:15:7500:56': 19.2,
  'mem:15:7500:57': 19.2,
  'mem:15:7500:58': 19.2,
  'mem:15:7500:59': 19.2,
  'mem:15:7500:60': 19.2,
  'mem:15:7500:61': 20.4,
  'mem:15:7500:62': 20.4,
  'mem:15:7500:63': 20.4,
  'mem:15:7500:64': 20.4,
  'mem:15:7500:65': 20.4,
  'mem:15:7500:66': 30,
  'mem:15:7500:67': 30,
  'mem:15:7500:68': 30,
  'mem:15:7500:69': 30,
  'mem:15:7500:70': 30,
  'mem:15:7500:71': 40.8,
  'mem:15:7500:72': 40.8,
  'mem:15:7500:73': 40.8,
  'mem:15:7500:74': 40.8,
  'mem:15:7500:75': 40.8,
  'mem:15:7500:76': 55.2,
  'mem:15:7500:77': 55.2,
  'mem:15:7500:78': 55.2,
  'mem:15:7500:79': 55.2,
  'mem:15:7500:80': 55.2,
  'mem:15:7500:81': 78.25,
  'mem:15:7500:82': 78.25,
  'mem:15:7500:83': 78.25,
  'mem:15:7500:84': 78.25,
  'mem:15:7500:85': 78.25,
  'mem:15:7500:86': 108.83,
  'mem:15:7500:87': 108.83,
  'mem:15:7500:88': 108.83,
  'mem:15:7500:89': 108.83,
  'mem:15:7500:90': 108.83,
  'mem:15:7500:91': 151.45,
  'mem:15:7500:92': 151.45,
  'mem:15:7500:93': 151.45,
  'mem:15:7500:94': 151.45,
  'mem:15:7500:95': 151.45,
  'mem:15:7500:96': 248.38,
  'mem:15:7500:97': 248.38,
  'mem:15:7500:98': 248.38,
  'mem:15:7500:99': 248.38,
  'mem:15:7500:100': 248.38,
  'mem:15:10000:1': 2.4,
  'mem:15:10000:2': 2.4,
  'mem:15:10000:3': 2.4,
  'mem:15:10000:4': 2.4,
  'mem:15:10000:5': 2.4,
  'mem:15:10000:6': 2.4,
  'mem:15:10000:7': 2.4,
  'mem:15:10000:8': 2.4,
  'mem:15:10000:9': 2.4,
  'mem:15:10000:10': 2.4,
  'mem:15:10000:11': 2.4,
  'mem:15:10000:12': 2.4,
  'mem:15:10000:13': 2.4,
  'mem:15:10000:14': 2.4,
  'mem:15:10000:15': 2.4,
  'mem:15:10000:16': 2.4,
  'mem:15:10000:17': 2.4,
  'mem:15:10000:18': 2.4,
  'mem:15:10000:19': 2.4,
  'mem:15:10000:20': 2.4,
  'mem:15:10000:21': 2.4,
  'mem:15:10000:22': 2.4,
  'mem:15:10000:23': 2.4,
  'mem:15:10000:24': 2.4,
  'mem:15:10000:25': 2.4,
  'mem:15:10000:26': 3.6,
  'mem:15:10000:27': 3.6,
  'mem:15:10000:28': 3.6,
  'mem:15:10000:29': 3.6,
  'mem:15:10000:30': 3.6,
  'mem:15:10000:31': 4.8,
  'mem:15:10000:32': 4.8,
  'mem:15:10000:33': 4.8,
  'mem:15:10000:34': 4.8,
  'mem:15:10000:35': 4.8,
  'mem:15:10000:36': 6,
  'mem:15:10000:37': 6,
  'mem:15:10000:38': 6,
  'mem:15:10000:39': 6,
  'mem:15:10000:40': 6,
  'mem:15:10000:41': 9.6,
  'mem:15:10000:42': 9.6,
  'mem:15:10000:43': 9.6,
  'mem:15:10000:44': 9.6,
  'mem:15:10000:45': 9.6,
  'mem:15:10000:46': 15.6,
  'mem:15:10000:47': 15.6,
  'mem:15:10000:48': 15.6,
  'mem:15:10000:49': 15.6,
  'mem:15:10000:50': 15.6,
  'mem:15:10000:51': 22.8,
  'mem:15:10000:52': 22.8,
  'mem:15:10000:53': 22.8,
  'mem:15:10000:54': 22.8,
  'mem:15:10000:55': 22.8,
  'mem:15:10000:56': 25.2,
  'mem:15:10000:57': 25.2,
  'mem:15:10000:58': 25.2,
  'mem:15:10000:59': 25.2,
  'mem:15:10000:60': 25.2,
  'mem:15:10000:61': 27.6,
  'mem:15:10000:62': 27.6,
  'mem:15:10000:63': 27.6,
  'mem:15:10000:64': 27.6,
  'mem:15:10000:65': 27.6,
  'mem:15:10000:66': 39.6,
  'mem:15:10000:67': 39.6,
  'mem:15:10000:68': 39.6,
  'mem:15:10000:69': 39.6,
  'mem:15:10000:70': 39.6,
  'mem:15:10000:71': 54,
  'mem:15:10000:72': 54,
  'mem:15:10000:73': 54,
  'mem:15:10000:74': 54,
  'mem:15:10000:75': 54,
  'mem:15:10000:76': 74.4,
  'mem:15:10000:77': 74.4,
  'mem:15:10000:78': 74.4,
  'mem:15:10000:79': 74.4,
  'mem:15:10000:80': 74.4,
  'mem:15:10000:81': 104.31,
  'mem:15:10000:82': 104.31,
  'mem:15:10000:83': 104.31,
  'mem:15:10000:84': 104.31,
  'mem:15:10000:85': 104.31,
  'mem:15:10000:86': 145.08,
  'mem:15:10000:87': 145.08,
  'mem:15:10000:88': 145.08,
  'mem:15:10000:89': 145.08,
  'mem:15:10000:90': 145.08,
  'mem:15:10000:91': 201.9,
  'mem:15:10000:92': 201.9,
  'mem:15:10000:93': 201.9,
  'mem:15:10000:94': 201.9,
  'mem:15:10000:95': 201.9,
  'mem:15:10000:96': 331.13,
  'mem:15:10000:97': 331.13,
  'mem:15:10000:98': 331.13,
  'mem:15:10000:99': 331.13,
  'mem:15:10000:100': 331.13,
  'mem:15:15000:1': 3.6,
  'mem:15:15000:2': 3.6,
  'mem:15:15000:3': 3.6,
  'mem:15:15000:4': 3.6,
  'mem:15:15000:5': 3.6,
  'mem:15:15000:6': 3.6,
  'mem:15:15000:7': 3.6,
  'mem:15:15000:8': 3.6,
  'mem:15:15000:9': 3.6,
  'mem:15:15000:10': 3.6,
  'mem:15:15000:11': 3.6,
  'mem:15:15000:12': 3.6,
  'mem:15:15000:13': 3.6,
  'mem:15:15000:14': 3.6,
  'mem:15:15000:15': 3.6,
  'mem:15:15000:16': 3.6,
  'mem:15:15000:17': 3.6,
  'mem:15:15000:18': 3.6,
  'mem:15:15000:19': 3.6,
  'mem:15:15000:20': 3.6,
  'mem:15:15000:21': 3.6,
  'mem:15:15000:22': 3.6,
  'mem:15:15000:23': 3.6,
  'mem:15:15000:24': 3.6,
  'mem:15:15000:25': 3.6,
  'mem:15:15000:26': 4.8,
  'mem:15:15000:27': 4.8,
  'mem:15:15000:28': 4.8,
  'mem:15:15000:29': 4.8,
  'mem:15:15000:30': 4.8,
  'mem:15:15000:31': 6,
  'mem:15:15000:32': 6,
  'mem:15:15000:33': 6,
  'mem:15:15000:34': 6,
  'mem:15:15000:35': 6,
  'mem:15:15000:36': 9.6,
  'mem:15:15000:37': 9.6,
  'mem:15:15000:38': 9.6,
  'mem:15:15000:39': 9.6,
  'mem:15:15000:40': 9.6,
  'mem:15:15000:41': 14.4,
  'mem:15:15000:42': 14.4,
  'mem:15:15000:43': 14.4,
  'mem:15:15000:44': 14.4,
  'mem:15:15000:45': 14.4,
  'mem:15:15000:46': 22.8,
  'mem:15:15000:47': 22.8,
  'mem:15:15000:48': 22.8,
  'mem:15:15000:49': 22.8,
  'mem:15:15000:50': 22.8,
  'mem:15:15000:51': 33.6,
  'mem:15:15000:52': 33.6,
  'mem:15:15000:53': 33.6,
  'mem:15:15000:54': 33.6,
  'mem:15:15000:55': 33.6,
  'mem:15:15000:56': 37.2,
  'mem:15:15000:57': 37.2,
  'mem:15:15000:58': 37.2,
  'mem:15:15000:59': 37.2,
  'mem:15:15000:60': 37.2,
  'mem:15:15000:61': 40.8,
  'mem:15:15000:62': 40.8,
  'mem:15:15000:63': 40.8,
  'mem:15:15000:64': 40.8,
  'mem:15:15000:65': 40.8,
  'mem:15:15000:66': 58.8,
  'mem:15:15000:67': 58.8,
  'mem:15:15000:68': 58.8,
  'mem:15:15000:69': 58.8,
  'mem:15:15000:70': 58.8,
  'mem:15:15000:71': 80.4,
  'mem:15:15000:72': 80.4,
  'mem:15:15000:73': 80.4,
  'mem:15:15000:74': 80.4,
  'mem:15:15000:75': 80.4,
  'mem:15:15000:76': 110.4,
  'mem:15:15000:77': 110.4,
  'mem:15:15000:78': 110.4,
  'mem:15:15000:79': 110.4,
  'mem:15:15000:80': 110.4,
  'mem:15:15000:81': 156.5,
  'mem:15:15000:82': 156.5,
  'mem:15:15000:83': 156.5,
  'mem:15:15000:84': 156.5,
  'mem:15:15000:85': 156.5,
  'mem:15:15000:86': 217.65,
  'mem:15:15000:87': 217.65,
  'mem:15:15000:88': 217.65,
  'mem:15:15000:89': 217.65,
  'mem:15:15000:90': 217.65,
  'mem:15:15000:91': 302.89,
  'mem:15:15000:92': 302.89,
  'mem:15:15000:93': 302.89,
  'mem:15:15000:94': 302.89,
  'mem:15:15000:95': 302.89,
  'mem:15:15000:96': 496.76,
  'mem:15:15000:97': 496.76,
  'mem:15:15000:98': 496.76,
  'mem:15:15000:99': 496.76,
  'mem:15:15000:100': 496.76,
  'mem:15:20000:1': 4.8,
  'mem:15:20000:2': 4.8,
  'mem:15:20000:3': 4.8,
  'mem:15:20000:4': 4.8,
  'mem:15:20000:5': 4.8,
  'mem:15:20000:6': 4.8,
  'mem:15:20000:7': 4.8,
  'mem:15:20000:8': 4.8,
  'mem:15:20000:9': 4.8,
  'mem:15:20000:10': 4.8,
  'mem:15:20000:11': 4.8,
  'mem:15:20000:12': 4.8,
  'mem:15:20000:13': 4.8,
  'mem:15:20000:14': 4.8,
  'mem:15:20000:15': 4.8,
  'mem:15:20000:16': 4.8,
  'mem:15:20000:17': 4.8,
  'mem:15:20000:18': 4.8,
  'mem:15:20000:19': 4.8,
  'mem:15:20000:20': 4.8,
  'mem:15:20000:21': 4.8,
  'mem:15:20000:22': 4.8,
  'mem:15:20000:23': 4.8,
  'mem:15:20000:24': 4.8,
  'mem:15:20000:25': 4.8,
  'mem:15:20000:26': 6,
  'mem:15:20000:27': 6,
  'mem:15:20000:28': 6,
  'mem:15:20000:29': 6,
  'mem:15:20000:30': 6,
  'mem:15:20000:31': 8.4,
  'mem:15:20000:32': 8.4,
  'mem:15:20000:33': 8.4,
  'mem:15:20000:34': 8.4,
  'mem:15:20000:35': 8.4,
  'mem:15:20000:36': 12,
  'mem:15:20000:37': 12,
  'mem:15:20000:38': 12,
  'mem:15:20000:39': 12,
  'mem:15:20000:40': 12,
  'mem:15:20000:41': 19.2,
  'mem:15:20000:42': 19.2,
  'mem:15:20000:43': 19.2,
  'mem:15:20000:44': 19.2,
  'mem:15:20000:45': 19.2,
  'mem:15:20000:46': 30,
  'mem:15:20000:47': 30,
  'mem:15:20000:48': 30,
  'mem:15:20000:49': 30,
  'mem:15:20000:50': 30,
  'mem:15:20000:51': 44.4,
  'mem:15:20000:52': 44.4,
  'mem:15:20000:53': 44.4,
  'mem:15:20000:54': 44.4,
  'mem:15:20000:55': 44.4,
  'mem:15:20000:56': 49.2,
  'mem:15:20000:57': 49.2,
  'mem:15:20000:58': 49.2,
  'mem:15:20000:59': 49.2,
  'mem:15:20000:60': 49.2,
  'mem:15:20000:61': 54,
  'mem:15:20000:62': 54,
  'mem:15:20000:63': 54,
  'mem:15:20000:64': 54,
  'mem:15:20000:65': 54,
  'mem:15:20000:66': 78,
  'mem:15:20000:67': 78,
  'mem:15:20000:68': 78,
  'mem:15:20000:69': 78,
  'mem:15:20000:70': 78,
  'mem:15:20000:71': 106.8,
  'mem:15:20000:72': 106.8,
  'mem:15:20000:73': 106.8,
  'mem:15:20000:74': 106.8,
  'mem:15:20000:75': 106.8,
  'mem:15:20000:76': 147.6,
  'mem:15:20000:77': 147.6,
  'mem:15:20000:78': 147.6,
  'mem:15:20000:79': 147.6,
  'mem:15:20000:80': 147.6,
  'mem:15:20000:81': 208.62,
  'mem:15:20000:82': 208.62,
  'mem:15:20000:83': 208.62,
  'mem:15:20000:84': 208.62,
  'mem:15:20000:85': 208.62,
  'mem:15:20000:86': 290.15,
  'mem:15:20000:87': 290.15,
  'mem:15:20000:88': 290.15,
  'mem:15:20000:89': 290.15,
  'mem:15:20000:90': 290.15,
  'mem:15:20000:91': 403.79,
  'mem:15:20000:92': 403.79,
  'mem:15:20000:93': 403.79,
  'mem:15:20000:94': 403.79,
  'mem:15:20000:95': 403.79,
  'mem:15:20000:96': 662.25,
  'mem:15:20000:97': 662.25,
  'mem:15:20000:98': 662.25,
  'mem:15:20000:99': 662.25,
  'mem:15:20000:100': 662.25,
  'mem:15:25000:1': 6,
  'mem:15:25000:2': 6,
  'mem:15:25000:3': 6,
  'mem:15:25000:4': 6,
  'mem:15:25000:5': 6,
  'mem:15:25000:6': 6,
  'mem:15:25000:7': 6,
  'mem:15:25000:8': 6,
  'mem:15:25000:9': 6,
  'mem:15:25000:10': 6,
  'mem:15:25000:11': 6,
  'mem:15:25000:12': 6,
  'mem:15:25000:13': 6,
  'mem:15:25000:14': 6,
  'mem:15:25000:15': 6,
  'mem:15:25000:16': 6,
  'mem:15:25000:17': 6,
  'mem:15:25000:18': 6,
  'mem:15:25000:19': 6,
  'mem:15:25000:20': 6,
  'mem:15:25000:21': 6,
  'mem:15:25000:22': 6,
  'mem:15:25000:23': 6,
  'mem:15:25000:24': 6,
  'mem:15:25000:25': 6,
  'mem:15:25000:26': 7.2,
  'mem:15:25000:27': 7.2,
  'mem:15:25000:28': 7.2,
  'mem:15:25000:29': 7.2,
  'mem:15:25000:30': 7.2,
  'mem:15:25000:31': 10.8,
  'mem:15:25000:32': 10.8,
  'mem:15:25000:33': 10.8,
  'mem:15:25000:34': 10.8,
  'mem:15:25000:35': 10.8,
  'mem:15:25000:36': 15.6,
  'mem:15:25000:37': 15.6,
  'mem:15:25000:38': 15.6,
  'mem:15:25000:39': 15.6,
  'mem:15:25000:40': 15.6,
  'mem:15:25000:41': 24,
  'mem:15:25000:42': 24,
  'mem:15:25000:43': 24,
  'mem:15:25000:44': 24,
  'mem:15:25000:45': 24,
  'mem:15:25000:46': 37.2,
  'mem:15:25000:47': 37.2,
  'mem:15:25000:48': 37.2,
  'mem:15:25000:49': 37.2,
  'mem:15:25000:50': 37.2,
  'mem:15:25000:51': 55.2,
  'mem:15:25000:52': 55.2,
  'mem:15:25000:53': 55.2,
  'mem:15:25000:54': 55.2,
  'mem:15:25000:55': 55.2,
  'mem:15:25000:56': 61.2,
  'mem:15:25000:57': 61.2,
  'mem:15:25000:58': 61.2,
  'mem:15:25000:59': 61.2,
  'mem:15:25000:60': 61.2,
  'mem:15:25000:61': 67.2,
  'mem:15:25000:62': 67.2,
  'mem:15:25000:63': 67.2,
  'mem:15:25000:64': 67.2,
  'mem:15:25000:65': 67.2,
  'mem:15:25000:66': 97.2,
  'mem:15:25000:67': 97.2,
  'mem:15:25000:68': 97.2,
  'mem:15:25000:69': 97.2,
  'mem:15:25000:70': 97.2,
  'mem:15:25000:71': 134.4,
  'mem:15:25000:72': 134.4,
  'mem:15:25000:73': 134.4,
  'mem:15:25000:74': 134.4,
  'mem:15:25000:75': 134.4,
  'mem:15:25000:76': 183.6,
  'mem:15:25000:77': 183.6,
  'mem:15:25000:78': 183.6,
  'mem:15:25000:79': 183.6,
  'mem:15:25000:80': 183.6,
  'mem:15:25000:81': 260.86,
  'mem:15:25000:82': 260.86,
  'mem:15:25000:83': 260.86,
  'mem:15:25000:84': 260.86,
  'mem:15:25000:85': 260.86,
  'mem:15:25000:86': 362.79,
  'mem:15:25000:87': 362.79,
  'mem:15:25000:88': 362.79,
  'mem:15:25000:89': 362.79,
  'mem:15:25000:90': 362.79,
  'mem:15:25000:91': 504.87,
  'mem:15:25000:92': 504.87,
  'mem:15:25000:93': 504.87,
  'mem:15:25000:94': 504.87,
  'mem:15:25000:95': 504.87,
  'mem:15:25000:96': 828.02,
  'mem:15:25000:97': 828.02,
  'mem:15:25000:98': 828.02,
  'mem:15:25000:99': 828.02,
  'mem:15:25000:100': 828.02,
  'mem:15:30000:1': 6,
  'mem:15:30000:2': 6,
  'mem:15:30000:3': 6,
  'mem:15:30000:4': 6,
  'mem:15:30000:5': 6,
  'mem:15:30000:6': 6,
  'mem:15:30000:7': 6,
  'mem:15:30000:8': 6,
  'mem:15:30000:9': 6,
  'mem:15:30000:10': 6,
  'mem:15:30000:11': 7.2,
  'mem:15:30000:12': 7.2,
  'mem:15:30000:13': 7.2,
  'mem:15:30000:14': 7.2,
  'mem:15:30000:15': 7.2,
  'mem:15:30000:16': 7.2,
  'mem:15:30000:17': 7.2,
  'mem:15:30000:18': 7.2,
  'mem:15:30000:19': 7.2,
  'mem:15:30000:20': 7.2,
  'mem:15:30000:21': 7.2,
  'mem:15:30000:22': 7.2,
  'mem:15:30000:23': 7.2,
  'mem:15:30000:24': 7.2,
  'mem:15:30000:25': 7.2,
  'mem:15:30000:26': 9.6,
  'mem:15:30000:27': 9.6,
  'mem:15:30000:28': 9.6,
  'mem:15:30000:29': 9.6,
  'mem:15:30000:30': 9.6,
  'mem:15:30000:31': 12,
  'mem:15:30000:32': 12,
  'mem:15:30000:33': 12,
  'mem:15:30000:34': 12,
  'mem:15:30000:35': 12,
  'mem:15:30000:36': 18,
  'mem:15:30000:37': 18,
  'mem:15:30000:38': 18,
  'mem:15:30000:39': 18,
  'mem:15:30000:40': 18,
  'mem:15:30000:41': 28.8,
  'mem:15:30000:42': 28.8,
  'mem:15:30000:43': 28.8,
  'mem:15:30000:44': 28.8,
  'mem:15:30000:45': 28.8,
  'mem:15:30000:46': 43.2,
  'mem:15:30000:47': 43.2,
  'mem:15:30000:48': 43.2,
  'mem:15:30000:49': 43.2,
  'mem:15:30000:50': 43.2,
  'mem:15:30000:51': 66,
  'mem:15:30000:52': 66,
  'mem:15:30000:53': 66,
  'mem:15:30000:54': 66,
  'mem:15:30000:55': 66,
  'mem:15:30000:56': 72,
  'mem:15:30000:57': 72,
  'mem:15:30000:58': 72,
  'mem:15:30000:59': 72,
  'mem:15:30000:60': 72,
  'mem:15:30000:61': 80.4,
  'mem:15:30000:62': 80.4,
  'mem:15:30000:63': 80.4,
  'mem:15:30000:64': 80.4,
  'mem:15:30000:65': 80.4,
  'mem:15:30000:66': 116.4,
  'mem:15:30000:67': 116.4,
  'mem:15:30000:68': 116.4,
  'mem:15:30000:69': 116.4,
  'mem:15:30000:70': 116.4,
  'mem:15:30000:71': 160.8,
  'mem:15:30000:72': 160.8,
  'mem:15:30000:73': 160.8,
  'mem:15:30000:74': 160.8,
  'mem:15:30000:75': 160.8,
  'mem:15:30000:76': 220.8,
  'mem:15:30000:77': 220.8,
  'mem:15:30000:78': 220.8,
  'mem:15:30000:79': 220.8,
  'mem:15:30000:80': 220.8,
  'mem:15:30000:81': 312.71,
  'mem:15:30000:82': 312.71,
  'mem:15:30000:83': 312.71,
  'mem:15:30000:84': 312.71,
  'mem:15:30000:85': 312.71,
  'mem:15:30000:86': 434.94,
  'mem:15:30000:87': 434.94,
  'mem:15:30000:88': 434.94,
  'mem:15:30000:89': 434.94,
  'mem:15:30000:90': 434.94,
  'mem:15:30000:91': 605.29,
  'mem:15:30000:92': 605.29,
  'mem:15:30000:93': 605.29,
  'mem:15:30000:94': 605.29,
  'mem:15:30000:95': 605.29,
  'mem:15:30000:96': 992.76,
  'mem:15:30000:97': 992.76,
  'mem:15:30000:98': 992.76,
  'mem:15:30000:99': 992.76,
  'mem:15:30000:100': 992.76,
  'mem:15:40000:1': 8.4,
  'mem:15:40000:2': 8.4,
  'mem:15:40000:3': 8.4,
  'mem:15:40000:4': 8.4,
  'mem:15:40000:5': 8.4,
  'mem:15:40000:6': 8.4,
  'mem:15:40000:7': 8.4,
  'mem:15:40000:8': 8.4,
  'mem:15:40000:9': 8.4,
  'mem:15:40000:10': 8.4,
  'mem:15:40000:11': 8.4,
  'mem:15:40000:12': 8.4,
  'mem:15:40000:13': 8.4,
  'mem:15:40000:14': 8.4,
  'mem:15:40000:15': 8.4,
  'mem:15:40000:16': 9.6,
  'mem:15:40000:17': 9.6,
  'mem:15:40000:18': 9.6,
  'mem:15:40000:19': 9.6,
  'mem:15:40000:20': 9.6,
  'mem:15:40000:21': 9.6,
  'mem:15:40000:22': 9.6,
  'mem:15:40000:23': 9.6,
  'mem:15:40000:24': 9.6,
  'mem:15:40000:25': 9.6,
  'mem:15:40000:26': 12,
  'mem:15:40000:27': 12,
  'mem:15:40000:28': 12,
  'mem:15:40000:29': 12,
  'mem:15:40000:30': 12,
  'mem:15:40000:31': 16.8,
  'mem:15:40000:32': 16.8,
  'mem:15:40000:33': 16.8,
  'mem:15:40000:34': 16.8,
  'mem:15:40000:35': 16.8,
  'mem:15:40000:36': 24,
  'mem:15:40000:37': 24,
  'mem:15:40000:38': 24,
  'mem:15:40000:39': 24,
  'mem:15:40000:40': 24,
  'mem:15:40000:41': 38.4,
  'mem:15:40000:42': 38.4,
  'mem:15:40000:43': 38.4,
  'mem:15:40000:44': 38.4,
  'mem:15:40000:45': 38.4,
  'mem:15:40000:46': 58.8,
  'mem:15:40000:47': 58.8,
  'mem:15:40000:48': 58.8,
  'mem:15:40000:49': 58.8,
  'mem:15:40000:50': 58.8,
  'mem:15:40000:51': 87.6,
  'mem:15:40000:52': 87.6,
  'mem:15:40000:53': 87.6,
  'mem:15:40000:54': 87.6,
  'mem:15:40000:55': 87.6,
  'mem:15:40000:56': 97.2,
  'mem:15:40000:57': 97.2,
  'mem:15:40000:58': 97.2,
  'mem:15:40000:59': 97.2,
  'mem:15:40000:60': 97.2,
  'mem:15:40000:61': 106.8,
  'mem:15:40000:62': 106.8,
  'mem:15:40000:63': 106.8,
  'mem:15:40000:64': 106.8,
  'mem:15:40000:65': 106.8,
  'mem:15:40000:66': 154.8,
  'mem:15:40000:67': 154.8,
  'mem:15:40000:68': 154.8,
  'mem:15:40000:69': 154.8,
  'mem:15:40000:70': 154.8,
  'mem:15:40000:71': 213.6,
  'mem:15:40000:72': 213.6,
  'mem:15:40000:73': 213.6,
  'mem:15:40000:74': 213.6,
  'mem:15:40000:75': 213.6,
  'mem:15:40000:76': 294,
  'mem:15:40000:77': 294,
  'mem:15:40000:78': 294,
  'mem:15:40000:79': 294,
  'mem:15:40000:80': 294,
  'mem:15:40000:81': 417.24,
  'mem:15:40000:82': 417.24,
  'mem:15:40000:83': 417.24,
  'mem:15:40000:84': 417.24,
  'mem:15:40000:85': 417.24,
  'mem:15:40000:86': 580.3,
  'mem:15:40000:87': 580.3,
  'mem:15:40000:88': 580.3,
  'mem:15:40000:89': 580.3,
  'mem:15:40000:90': 580.3,
  'mem:15:40000:91': 807.58,
  'mem:15:40000:92': 807.58,
  'mem:15:40000:93': 807.58,
  'mem:15:40000:94': 807.58,
  'mem:15:40000:95': 807.58,
  'mem:15:40000:96': 1324.5,
  'mem:15:40000:97': 1324.5,
  'mem:15:40000:98': 1324.5,
  'mem:15:40000:99': 1324.5,
  'mem:15:40000:100': 1324.5,
  'mem:15:50000:1': 10.8,
  'mem:15:50000:2': 10.8,
  'mem:15:50000:3': 10.8,
  'mem:15:50000:4': 10.8,
  'mem:15:50000:5': 10.8,
  'mem:15:50000:6': 10.8,
  'mem:15:50000:7': 10.8,
  'mem:15:50000:8': 10.8,
  'mem:15:50000:9': 10.8,
  'mem:15:50000:10': 10.8,
  'mem:15:50000:11': 10.8,
  'mem:15:50000:12': 10.8,
  'mem:15:50000:13': 10.8,
  'mem:15:50000:14': 10.8,
  'mem:15:50000:15': 10.8,
  'mem:15:50000:16': 10.8,
  'mem:15:50000:17': 10.8,
  'mem:15:50000:18': 10.8,
  'mem:15:50000:19': 10.8,
  'mem:15:50000:20': 10.8,
  'mem:15:50000:21': 12,
  'mem:15:50000:22': 12,
  'mem:15:50000:23': 12,
  'mem:15:50000:24': 12,
  'mem:15:50000:25': 12,
  'mem:15:50000:26': 14.4,
  'mem:15:50000:27': 14.4,
  'mem:15:50000:28': 14.4,
  'mem:15:50000:29': 14.4,
  'mem:15:50000:30': 14.4,
  'mem:15:50000:31': 20.4,
  'mem:15:50000:32': 20.4,
  'mem:15:50000:33': 20.4,
  'mem:15:50000:34': 20.4,
  'mem:15:50000:35': 20.4,
  'mem:15:50000:36': 30,
  'mem:15:50000:37': 30,
  'mem:15:50000:38': 30,
  'mem:15:50000:39': 30,
  'mem:15:50000:40': 30,
  'mem:15:50000:41': 46.8,
  'mem:15:50000:42': 46.8,
  'mem:15:50000:43': 46.8,
  'mem:15:50000:44': 46.8,
  'mem:15:50000:45': 46.8,
  'mem:15:50000:46': 73.2,
  'mem:15:50000:47': 73.2,
  'mem:15:50000:48': 73.2,
  'mem:15:50000:49': 73.2,
  'mem:15:50000:50': 73.2,
  'mem:15:50000:51': 110.4,
  'mem:15:50000:52': 110.4,
  'mem:15:50000:53': 110.4,
  'mem:15:50000:54': 110.4,
  'mem:15:50000:55': 110.4,
  'mem:15:50000:56': 121.2,
  'mem:15:50000:57': 121.2,
  'mem:15:50000:58': 121.2,
  'mem:15:50000:59': 121.2,
  'mem:15:50000:60': 121.2,
  'mem:15:50000:61': 133.2,
  'mem:15:50000:62': 133.2,
  'mem:15:50000:63': 133.2,
  'mem:15:50000:64': 133.2,
  'mem:15:50000:65': 133.2,
  'mem:15:50000:66': 193.2,
  'mem:15:50000:67': 193.2,
  'mem:15:50000:68': 193.2,
  'mem:15:50000:69': 193.2,
  'mem:15:50000:70': 193.2,
  'mem:15:50000:71': 267.6,
  'mem:15:50000:72': 267.6,
  'mem:15:50000:73': 267.6,
  'mem:15:50000:74': 267.6,
  'mem:15:50000:75': 267.6,
  'mem:15:50000:76': 367.2,
  'mem:15:50000:77': 367.2,
  'mem:15:50000:78': 367.2,
  'mem:15:50000:79': 367.2,
  'mem:15:50000:80': 367.2,
  'mem:15:50000:81': 521.72,
  'mem:15:50000:82': 521.72,
  'mem:15:50000:83': 521.72,
  'mem:15:50000:84': 521.72,
  'mem:15:50000:85': 521.72,
  'mem:15:50000:86': 725.58,
  'mem:15:50000:87': 725.58,
  'mem:15:50000:88': 725.58,
  'mem:15:50000:89': 725.58,
  'mem:15:50000:90': 725.58,
  'mem:15:50000:91': 1009.74,
  'mem:15:50000:92': 1009.74,
  'mem:15:50000:93': 1009.74,
  'mem:15:50000:94': 1009.74,
  'mem:15:50000:95': 1009.74,
  'mem:15:50000:96': 1656.04,
  'mem:15:50000:97': 1656.04,
  'mem:15:50000:98': 1656.04,
  'mem:15:50000:99': 1656.04,
  'mem:15:50000:100': 1656.04,
  'mem:15:60000:1': 11.52,
  'mem:15:60000:2': 11.52,
  'mem:15:60000:3': 11.52,
  'mem:15:60000:4': 11.52,
  'mem:15:60000:5': 11.52,
  'mem:15:60000:6': 11.51,
  'mem:15:60000:7': 11.51,
  'mem:15:60000:8': 11.51,
  'mem:15:60000:9': 11.51,
  'mem:15:60000:10': 11.51,
  'mem:15:60000:11': 11.52,
  'mem:15:60000:12': 11.52,
  'mem:15:60000:13': 11.52,
  'mem:15:60000:14': 11.52,
  'mem:15:60000:15': 11.52,
  'mem:15:60000:16': 11.61,
  'mem:15:60000:17': 11.61,
  'mem:15:60000:18': 11.61,
  'mem:15:60000:19': 11.61,
  'mem:15:60000:20': 11.61,
  'mem:15:60000:21': 12.68,
  'mem:15:60000:22': 12.68,
  'mem:15:60000:23': 12.68,
  'mem:15:60000:24': 12.68,
  'mem:15:60000:25': 12.68,
  'mem:15:60000:26': 14.95,
  'mem:15:60000:27': 14.95,
  'mem:15:60000:28': 14.95,
  'mem:15:60000:29': 14.95,
  'mem:15:60000:30': 14.95,
  'mem:15:60000:31': 20.5,
  'mem:15:60000:32': 20.5,
  'mem:15:60000:33': 20.5,
  'mem:15:60000:34': 20.5,
  'mem:15:60000:35': 20.5,
  'mem:15:60000:36': 29.93,
  'mem:15:60000:37': 29.93,
  'mem:15:60000:38': 29.93,
  'mem:15:60000:39': 29.93,
  'mem:15:60000:40': 29.93,
  'mem:15:60000:41': 46.45,
  'mem:15:60000:42': 46.45,
  'mem:15:60000:43': 46.45,
  'mem:15:60000:44': 46.45,
  'mem:15:60000:45': 46.45,
  'mem:15:60000:46': 72.04,
  'mem:15:60000:47': 72.04,
  'mem:15:60000:48': 72.04,
  'mem:15:60000:49': 72.04,
  'mem:15:60000:50': 72.04,
  'mem:15:60000:51': 108.53,
  'mem:15:60000:52': 108.53,
  'mem:15:60000:53': 108.53,
  'mem:15:60000:54': 108.53,
  'mem:15:60000:55': 108.53,
  'mem:15:60000:56': 130.29,
  'mem:15:60000:57': 130.29,
  'mem:15:60000:58': 130.29,
  'mem:15:60000:59': 130.29,
  'mem:15:60000:60': 130.29,
  'mem:15:60000:61': 157.74,
  'mem:15:60000:62': 157.74,
  'mem:15:60000:63': 157.74,
  'mem:15:60000:64': 157.74,
  'mem:15:60000:65': 157.74,
  'mem:15:60000:66': 229.43,
  'mem:15:60000:67': 229.43,
  'mem:15:60000:68': 229.43,
  'mem:15:60000:69': 229.43,
  'mem:15:60000:70': 229.43,
  'mem:15:60000:71': 305.59,
  'mem:15:60000:72': 305.59,
  'mem:15:60000:73': 305.59,
  'mem:15:60000:74': 305.59,
  'mem:15:60000:75': 305.59,
  'mem:15:60000:76': 430.48,
  'mem:15:60000:77': 430.48,
  'mem:15:60000:78': 430.48,
  'mem:15:60000:79': 430.48,
  'mem:15:60000:80': 430.48,
  'mem:15:60000:81': 625.42,
  'mem:15:60000:82': 625.42,
  'mem:15:60000:83': 625.42,
  'mem:15:60000:84': 625.42,
  'mem:15:60000:85': 625.42,
  'mem:15:60000:86': 869.87,
  'mem:15:60000:87': 869.87,
  'mem:15:60000:88': 869.87,
  'mem:15:60000:89': 869.87,
  'mem:15:60000:90': 869.87,
  'mem:15:60000:91': 1210.59,
  'mem:15:60000:92': 1210.59,
  'mem:15:60000:93': 1210.59,
  'mem:15:60000:94': 1210.59,
  'mem:15:60000:95': 1210.59,
  'mem:15:60000:96': 1985.51,
  'mem:15:60000:97': 1985.51,
  'mem:15:60000:98': 1985.51,
  'mem:15:60000:99': 1985.51,
  'mem:15:60000:100': 1985.51,
  'mem:15:70000:1': 12.25,
  'mem:15:70000:2': 12.25,
  'mem:15:70000:3': 12.25,
  'mem:15:70000:4': 12.25,
  'mem:15:70000:5': 12.25,
  'mem:15:70000:6': 12.21,
  'mem:15:70000:7': 12.21,
  'mem:15:70000:8': 12.21,
  'mem:15:70000:9': 12.21,
  'mem:15:70000:10': 12.21,
  'mem:15:70000:11': 12.25,
  'mem:15:70000:12': 12.25,
  'mem:15:70000:13': 12.25,
  'mem:15:70000:14': 12.25,
  'mem:15:70000:15': 12.25,
  'mem:15:70000:16': 12.42,
  'mem:15:70000:17': 12.42,
  'mem:15:70000:18': 12.42,
  'mem:15:70000:19': 12.42,
  'mem:15:70000:20': 12.42,
  'mem:15:70000:21': 13.35,
  'mem:15:70000:22': 13.35,
  'mem:15:70000:23': 13.35,
  'mem:15:70000:24': 13.35,
  'mem:15:70000:25': 13.35,
  'mem:15:70000:26': 15.51,
  'mem:15:70000:27': 15.51,
  'mem:15:70000:28': 15.51,
  'mem:15:70000:29': 15.51,
  'mem:15:70000:30': 15.51,
  'mem:15:70000:31': 20.6,
  'mem:15:70000:32': 20.6,
  'mem:15:70000:33': 20.6,
  'mem:15:70000:34': 20.6,
  'mem:15:70000:35': 20.6,
  'mem:15:70000:36': 29.86,
  'mem:15:70000:37': 29.86,
  'mem:15:70000:38': 29.86,
  'mem:15:70000:39': 29.86,
  'mem:15:70000:40': 29.86,
  'mem:15:70000:41': 46.09,
  'mem:15:70000:42': 46.09,
  'mem:15:70000:43': 46.09,
  'mem:15:70000:44': 46.09,
  'mem:15:70000:45': 46.09,
  'mem:15:70000:46': 70.88,
  'mem:15:70000:47': 70.88,
  'mem:15:70000:48': 70.88,
  'mem:15:70000:49': 70.88,
  'mem:15:70000:50': 70.88,
  'mem:15:70000:51': 106.66,
  'mem:15:70000:52': 106.66,
  'mem:15:70000:53': 106.66,
  'mem:15:70000:54': 106.66,
  'mem:15:70000:55': 106.66,
  'mem:15:70000:56': 139.37,
  'mem:15:70000:57': 139.37,
  'mem:15:70000:58': 139.37,
  'mem:15:70000:59': 139.37,
  'mem:15:70000:60': 139.37,
  'mem:15:70000:61': 184.17,
  'mem:15:70000:62': 184.17,
  'mem:15:70000:63': 184.17,
  'mem:15:70000:64': 184.17,
  'mem:15:70000:65': 184.17,
  'mem:15:70000:66': 267.87,
  'mem:15:70000:67': 267.87,
  'mem:15:70000:68': 267.87,
  'mem:15:70000:69': 267.87,
  'mem:15:70000:70': 267.87,
  'mem:15:70000:71': 356.77,
  'mem:15:70000:72': 356.77,
  'mem:15:70000:73': 356.77,
  'mem:15:70000:74': 356.77,
  'mem:15:70000:75': 356.77,
  'mem:15:70000:76': 502.57,
  'mem:15:70000:77': 502.57,
  'mem:15:70000:78': 502.57,
  'mem:15:70000:79': 502.57,
  'mem:15:70000:80': 502.57,
  'mem:15:70000:81': 730.16,
  'mem:15:70000:82': 730.16,
  'mem:15:70000:83': 730.16,
  'mem:15:70000:84': 730.16,
  'mem:15:70000:85': 730.16,
  'mem:15:70000:86': 1015.5,
  'mem:15:70000:87': 1015.5,
  'mem:15:70000:88': 1015.5,
  'mem:15:70000:89': 1015.5,
  'mem:15:70000:90': 1015.5,
  'mem:15:70000:91': 1413.22,
  'mem:15:70000:92': 1413.22,
  'mem:15:70000:93': 1413.22,
  'mem:15:70000:94': 1413.22,
  'mem:15:70000:95': 1413.22,
  'mem:15:70000:96': 2317.79,
  'mem:15:70000:97': 2317.79,
  'mem:15:70000:98': 2317.79,
  'mem:15:70000:99': 2317.79,
  'mem:15:70000:100': 2317.79,
  'mem:15:80000:1': 12.97,
  'mem:15:80000:2': 12.97,
  'mem:15:80000:3': 12.97,
  'mem:15:80000:4': 12.97,
  'mem:15:80000:5': 12.97,
  'mem:15:80000:6': 12.92,
  'mem:15:80000:7': 12.92,
  'mem:15:80000:8': 12.92,
  'mem:15:80000:9': 12.92,
  'mem:15:80000:10': 12.92,
  'mem:15:80000:11': 12.97,
  'mem:15:80000:12': 12.97,
  'mem:15:80000:13': 12.97,
  'mem:15:80000:14': 12.97,
  'mem:15:80000:15': 12.97,
  'mem:15:80000:16': 13.23,
  'mem:15:80000:17': 13.23,
  'mem:15:80000:18': 13.23,
  'mem:15:80000:19': 13.23,
  'mem:15:80000:20': 13.23,
  'mem:15:80000:21': 14.03,
  'mem:15:80000:22': 14.03,
  'mem:15:80000:23': 14.03,
  'mem:15:80000:24': 14.03,
  'mem:15:80000:25': 14.03,
  'mem:15:80000:26': 16.06,
  'mem:15:80000:27': 16.06,
  'mem:15:80000:28': 16.06,
  'mem:15:80000:29': 16.06,
  'mem:15:80000:30': 16.06,
  'mem:15:80000:31': 20.7,
  'mem:15:80000:32': 20.7,
  'mem:15:80000:33': 20.7,
  'mem:15:80000:34': 20.7,
  'mem:15:80000:35': 20.7,
  'mem:15:80000:36': 29.79,
  'mem:15:80000:37': 29.79,
  'mem:15:80000:38': 29.79,
  'mem:15:80000:39': 29.79,
  'mem:15:80000:40': 29.79,
  'mem:15:80000:41': 45.74,
  'mem:15:80000:42': 45.74,
  'mem:15:80000:43': 45.74,
  'mem:15:80000:44': 45.74,
  'mem:15:80000:45': 45.74,
  'mem:15:80000:46': 69.72,
  'mem:15:80000:47': 69.72,
  'mem:15:80000:48': 69.72,
  'mem:15:80000:49': 69.72,
  'mem:15:80000:50': 69.72,
  'mem:15:80000:51': 104.79,
  'mem:15:80000:52': 104.79,
  'mem:15:80000:53': 104.79,
  'mem:15:80000:54': 104.79,
  'mem:15:80000:55': 104.79,
  'mem:15:80000:56': 148.46,
  'mem:15:80000:57': 148.46,
  'mem:15:80000:58': 148.46,
  'mem:15:80000:59': 148.46,
  'mem:15:80000:60': 148.46,
  'mem:15:80000:61': 210.54,
  'mem:15:80000:62': 210.54,
  'mem:15:80000:63': 210.54,
  'mem:15:80000:64': 210.54,
  'mem:15:80000:65': 210.54,
  'mem:15:80000:66': 306.23,
  'mem:15:80000:67': 306.23,
  'mem:15:80000:68': 306.23,
  'mem:15:80000:69': 306.23,
  'mem:15:80000:70': 306.23,
  'mem:15:80000:71': 407.85,
  'mem:15:80000:72': 407.85,
  'mem:15:80000:73': 407.85,
  'mem:15:80000:74': 407.85,
  'mem:15:80000:75': 407.85,
  'mem:15:80000:76': 574.53,
  'mem:15:80000:77': 574.53,
  'mem:15:80000:78': 574.53,
  'mem:15:80000:79': 574.53,
  'mem:15:80000:80': 574.53,
  'mem:15:80000:81': 834.71,
  'mem:15:80000:82': 834.71,
  'mem:15:80000:83': 834.71,
  'mem:15:80000:84': 834.71,
  'mem:15:80000:85': 834.71,
  'mem:15:80000:86': 1160.88,
  'mem:15:80000:87': 1160.88,
  'mem:15:80000:88': 1160.88,
  'mem:15:80000:89': 1160.88,
  'mem:15:80000:90': 1160.88,
  'mem:15:80000:91': 1615.51,
  'mem:15:80000:92': 1615.51,
  'mem:15:80000:93': 1615.51,
  'mem:15:80000:94': 1615.51,
  'mem:15:80000:95': 1615.51,
  'mem:15:80000:96': 2649.54,
  'mem:15:80000:97': 2649.54,
  'mem:15:80000:98': 2649.54,
  'mem:15:80000:99': 2649.54,
  'mem:15:80000:100': 2649.54,
  'mem:15:90000:1': 14.57,
  'mem:15:90000:2': 14.57,
  'mem:15:90000:3': 14.57,
  'mem:15:90000:4': 14.57,
  'mem:15:90000:5': 14.57,
  'mem:15:90000:6': 14.52,
  'mem:15:90000:7': 14.52,
  'mem:15:90000:8': 14.52,
  'mem:15:90000:9': 14.52,
  'mem:15:90000:10': 14.52,
  'mem:15:90000:11': 14.58,
  'mem:15:90000:12': 14.58,
  'mem:15:90000:13': 14.58,
  'mem:15:90000:14': 14.58,
  'mem:15:90000:15': 14.58,
  'mem:15:90000:16': 14.87,
  'mem:15:90000:17': 14.87,
  'mem:15:90000:18': 14.87,
  'mem:15:90000:19': 14.87,
  'mem:15:90000:20': 14.87,
  'mem:15:90000:21': 15.76,
  'mem:15:90000:22': 15.76,
  'mem:15:90000:23': 15.76,
  'mem:15:90000:24': 15.76,
  'mem:15:90000:25': 15.76,
  'mem:15:90000:26': 18.05,
  'mem:15:90000:27': 18.05,
  'mem:15:90000:28': 18.05,
  'mem:15:90000:29': 18.05,
  'mem:15:90000:30': 18.05,
  'mem:15:90000:31': 23.26,
  'mem:15:90000:32': 23.26,
  'mem:15:90000:33': 23.26,
  'mem:15:90000:34': 23.26,
  'mem:15:90000:35': 23.26,
  'mem:15:90000:36': 33.46,
  'mem:15:90000:37': 33.46,
  'mem:15:90000:38': 33.46,
  'mem:15:90000:39': 33.46,
  'mem:15:90000:40': 33.46,
  'mem:15:90000:41': 51.43,
  'mem:15:90000:42': 51.43,
  'mem:15:90000:43': 51.43,
  'mem:15:90000:44': 51.43,
  'mem:15:90000:45': 51.43,
  'mem:15:90000:46': 78.37,
  'mem:15:90000:47': 78.37,
  'mem:15:90000:48': 78.37,
  'mem:15:90000:49': 78.37,
  'mem:15:90000:50': 78.37,
  'mem:15:90000:51': 117.72,
  'mem:15:90000:52': 117.72,
  'mem:15:90000:53': 117.72,
  'mem:15:90000:54': 117.72,
  'mem:15:90000:55': 117.72,
  'mem:15:90000:56': 166.78,
  'mem:15:90000:57': 166.78,
  'mem:15:90000:58': 166.78,
  'mem:15:90000:59': 166.78,
  'mem:15:90000:60': 166.78,
  'mem:15:90000:61': 236.51,
  'mem:15:90000:62': 236.51,
  'mem:15:90000:63': 236.51,
  'mem:15:90000:64': 236.51,
  'mem:15:90000:65': 236.51,
  'mem:15:90000:66': 343.99,
  'mem:15:90000:67': 343.99,
  'mem:15:90000:68': 343.99,
  'mem:15:90000:69': 343.99,
  'mem:15:90000:70': 343.99,
  'mem:15:90000:71': 458.18,
  'mem:15:90000:72': 458.18,
  'mem:15:90000:73': 458.18,
  'mem:15:90000:74': 458.18,
  'mem:15:90000:75': 458.18,
  'mem:15:90000:76': 645.42,
  'mem:15:90000:77': 645.42,
  'mem:15:90000:78': 645.42,
  'mem:15:90000:79': 645.42,
  'mem:15:90000:80': 645.42,
  'mem:15:90000:81': 937.71,
  'mem:15:90000:82': 937.71,
  'mem:15:90000:83': 937.71,
  'mem:15:90000:84': 937.71,
  'mem:15:90000:85': 937.71,
  'mem:15:90000:86': 1304.2,
  'mem:15:90000:87': 1304.2,
  'mem:15:90000:88': 1304.2,
  'mem:15:90000:89': 1304.2,
  'mem:15:90000:90': 1304.2,
  'mem:15:90000:91': 1815.03,
  'mem:15:90000:92': 1815.03,
  'mem:15:90000:93': 1815.03,
  'mem:15:90000:94': 1815.03,
  'mem:15:90000:95': 1815.03,
  'mem:15:90000:96': 2976.86,
  'mem:15:90000:97': 2976.86,
  'mem:15:90000:98': 2976.86,
  'mem:15:90000:99': 2976.86,
  'mem:15:90000:100': 2976.86,
  'mem:15:100000:1': 16.2,
  'mem:15:100000:2': 16.2,
  'mem:15:100000:3': 16.2,
  'mem:15:100000:4': 16.2,
  'mem:15:100000:5': 16.2,
  'mem:15:100000:6': 16.14,
  'mem:15:100000:7': 16.14,
  'mem:15:100000:8': 16.14,
  'mem:15:100000:9': 16.14,
  'mem:15:100000:10': 16.14,
  'mem:15:100000:11': 16.2,
  'mem:15:100000:12': 16.2,
  'mem:15:100000:13': 16.2,
  'mem:15:100000:14': 16.2,
  'mem:15:100000:15': 16.2,
  'mem:15:100000:16': 16.53,
  'mem:15:100000:17': 16.53,
  'mem:15:100000:18': 16.53,
  'mem:15:100000:19': 16.53,
  'mem:15:100000:20': 16.53,
  'mem:15:100000:21': 17.52,
  'mem:15:100000:22': 17.52,
  'mem:15:100000:23': 17.52,
  'mem:15:100000:24': 17.52,
  'mem:15:100000:25': 17.52,
  'mem:15:100000:26': 20.06,
  'mem:15:100000:27': 20.06,
  'mem:15:100000:28': 20.06,
  'mem:15:100000:29': 20.06,
  'mem:15:100000:30': 20.06,
  'mem:15:100000:31': 25.86,
  'mem:15:100000:32': 25.86,
  'mem:15:100000:33': 25.86,
  'mem:15:100000:34': 25.86,
  'mem:15:100000:35': 25.86,
  'mem:15:100000:36': 37.2,
  'mem:15:100000:37': 37.2,
  'mem:15:100000:38': 37.2,
  'mem:15:100000:39': 37.2,
  'mem:15:100000:40': 37.2,
  'mem:15:100000:41': 57.15,
  'mem:15:100000:42': 57.15,
  'mem:15:100000:43': 57.15,
  'mem:15:100000:44': 57.15,
  'mem:15:100000:45': 57.15,
  'mem:15:100000:46': 87.11,
  'mem:15:100000:47': 87.11,
  'mem:15:100000:48': 87.11,
  'mem:15:100000:49': 87.11,
  'mem:15:100000:50': 87.11,
  'mem:15:100000:51': 130.86,
  'mem:15:100000:52': 130.86,
  'mem:15:100000:53': 130.86,
  'mem:15:100000:54': 130.86,
  'mem:15:100000:55': 130.86,
  'mem:15:100000:56': 185.39,
  'mem:15:100000:57': 185.39,
  'mem:15:100000:58': 185.39,
  'mem:15:100000:59': 185.39,
  'mem:15:100000:60': 185.39,
  'mem:15:100000:61': 262.92,
  'mem:15:100000:62': 262.92,
  'mem:15:100000:63': 262.92,
  'mem:15:100000:64': 262.92,
  'mem:15:100000:65': 262.92,
  'mem:15:100000:66': 382.38,
  'mem:15:100000:67': 382.38,
  'mem:15:100000:68': 382.38,
  'mem:15:100000:69': 382.38,
  'mem:15:100000:70': 382.38,
  'mem:15:100000:71': 509.33,
  'mem:15:100000:72': 509.33,
  'mem:15:100000:73': 509.33,
  'mem:15:100000:74': 509.33,
  'mem:15:100000:75': 509.33,
  'mem:15:100000:76': 717.49,
  'mem:15:100000:77': 717.49,
  'mem:15:100000:78': 717.49,
  'mem:15:100000:79': 717.49,
  'mem:15:100000:80': 717.49,
  'mem:15:100000:81': 1042.41,
  'mem:15:100000:82': 1042.41,
  'mem:15:100000:83': 1042.41,
  'mem:15:100000:84': 1042.41,
  'mem:15:100000:85': 1042.41,
  'mem:15:100000:86': 1449.84,
  'mem:15:100000:87': 1449.84,
  'mem:15:100000:88': 1449.84,
  'mem:15:100000:89': 1449.84,
  'mem:15:100000:90': 1449.84,
  'mem:15:100000:91': 2017.71,
  'mem:15:100000:92': 2017.71,
  'mem:15:100000:93': 2017.71,
  'mem:15:100000:94': 2017.71,
  'mem:15:100000:95': 2017.71,
  'mem:15:100000:96': 3309.27,
  'mem:15:100000:97': 3309.27,
  'mem:15:100000:98': 3309.27,
  'mem:15:100000:99': 3309.27,
  'mem:15:100000:100': 3309.27,
  'mem:15:120000:1': 19.44,
  'mem:15:120000:2': 19.44,
  'mem:15:120000:3': 19.44,
  'mem:15:120000:4': 19.44,
  'mem:15:120000:5': 19.44,
  'mem:15:120000:6': 19.36,
  'mem:15:120000:7': 19.36,
  'mem:15:120000:8': 19.36,
  'mem:15:120000:9': 19.36,
  'mem:15:120000:10': 19.36,
  'mem:15:120000:11': 19.44,
  'mem:15:120000:12': 19.44,
  'mem:15:120000:13': 19.44,
  'mem:15:120000:14': 19.44,
  'mem:15:120000:15': 19.44,
  'mem:15:120000:16': 19.83,
  'mem:15:120000:17': 19.83,
  'mem:15:120000:18': 19.83,
  'mem:15:120000:19': 19.83,
  'mem:15:120000:20': 19.83,
  'mem:15:120000:21': 21.02,
  'mem:15:120000:22': 21.02,
  'mem:15:120000:23': 21.02,
  'mem:15:120000:24': 21.02,
  'mem:15:120000:25': 21.02,
  'mem:15:120000:26': 24.07,
  'mem:15:120000:27': 24.07,
  'mem:15:120000:28': 24.07,
  'mem:15:120000:29': 24.07,
  'mem:15:120000:30': 24.07,
  'mem:15:120000:31': 31.02,
  'mem:15:120000:32': 31.02,
  'mem:15:120000:33': 31.02,
  'mem:15:120000:34': 31.02,
  'mem:15:120000:35': 31.02,
  'mem:15:120000:36': 44.63,
  'mem:15:120000:37': 44.63,
  'mem:15:120000:38': 44.63,
  'mem:15:120000:39': 44.63,
  'mem:15:120000:40': 44.63,
  'mem:15:120000:41': 68.51,
  'mem:15:120000:42': 68.51,
  'mem:15:120000:43': 68.51,
  'mem:15:120000:44': 68.51,
  'mem:15:120000:45': 68.51,
  'mem:15:120000:46': 104.45,
  'mem:15:120000:47': 104.45,
  'mem:15:120000:48': 104.45,
  'mem:15:120000:49': 104.45,
  'mem:15:120000:50': 104.45,
  'mem:15:120000:51': 157.02,
  'mem:15:120000:52': 157.02,
  'mem:15:120000:53': 157.02,
  'mem:15:120000:54': 157.02,
  'mem:15:120000:55': 157.02,
  'mem:15:120000:56': 222.45,
  'mem:15:120000:57': 222.45,
  'mem:15:120000:58': 222.45,
  'mem:15:120000:59': 222.45,
  'mem:15:120000:60': 222.45,
  'mem:15:120000:61': 315.47,
  'mem:15:120000:62': 315.47,
  'mem:15:120000:63': 315.47,
  'mem:15:120000:64': 315.47,
  'mem:15:120000:65': 315.47,
  'mem:15:120000:66': 458.84,
  'mem:15:120000:67': 458.84,
  'mem:15:120000:68': 458.84,
  'mem:15:120000:69': 458.84,
  'mem:15:120000:70': 458.84,
  'mem:15:120000:71': 611.16,
  'mem:15:120000:72': 611.16,
  'mem:15:120000:73': 611.16,
  'mem:15:120000:74': 611.16,
  'mem:15:120000:75': 611.16,
  'mem:15:120000:76': 860.93,
  'mem:15:120000:77': 860.93,
  'mem:15:120000:78': 860.93,
  'mem:15:120000:79': 860.93,
  'mem:15:120000:80': 860.93,
  'mem:15:120000:81': 1250.81,
  'mem:15:120000:82': 1250.81,
  'mem:15:120000:83': 1250.81,
  'mem:15:120000:84': 1250.81,
  'mem:15:120000:85': 1250.81,
  'mem:15:120000:86': 1739.69,
  'mem:15:120000:87': 1739.69,
  'mem:15:120000:88': 1739.69,
  'mem:15:120000:89': 1739.69,
  'mem:15:120000:90': 1739.69,
  'mem:15:120000:91': 2421.12,
  'mem:15:120000:92': 2421.12,
  'mem:15:120000:93': 2421.12,
  'mem:15:120000:94': 2421.12,
  'mem:15:120000:95': 2421.12,
  'mem:15:120000:96': 3970.93,
  'mem:15:120000:97': 3970.93,
  'mem:15:120000:98': 3970.93,
  'mem:15:120000:99': 3970.93,
  'mem:15:120000:100': 3970.93,
  'mem:15:140000:1': 22.7,
  'mem:15:140000:2': 22.7,
  'mem:15:140000:3': 22.7,
  'mem:15:140000:4': 22.7,
  'mem:15:140000:5': 22.7,
  'mem:15:140000:6': 22.61,
  'mem:15:140000:7': 22.61,
  'mem:15:140000:8': 22.61,
  'mem:15:140000:9': 22.61,
  'mem:15:140000:10': 22.61,
  'mem:15:140000:11': 22.7,
  'mem:15:140000:12': 22.7,
  'mem:15:140000:13': 22.7,
  'mem:15:140000:14': 22.7,
  'mem:15:140000:15': 22.7,
  'mem:15:140000:16': 23.15,
  'mem:15:140000:17': 23.15,
  'mem:15:140000:18': 23.15,
  'mem:15:140000:19': 23.15,
  'mem:15:140000:20': 23.15,
  'mem:15:140000:21': 24.54,
  'mem:15:140000:22': 24.54,
  'mem:15:140000:23': 24.54,
  'mem:15:140000:24': 24.54,
  'mem:15:140000:25': 24.54,
  'mem:15:140000:26': 28.1,
  'mem:15:140000:27': 28.1,
  'mem:15:140000:28': 28.1,
  'mem:15:140000:29': 28.1,
  'mem:15:140000:30': 28.1,
  'mem:15:140000:31': 36.22,
  'mem:15:140000:32': 36.22,
  'mem:15:140000:33': 36.22,
  'mem:15:140000:34': 36.22,
  'mem:15:140000:35': 36.22,
  'mem:15:140000:36': 52.11,
  'mem:15:140000:37': 52.11,
  'mem:15:140000:38': 52.11,
  'mem:15:140000:39': 52.11,
  'mem:15:140000:40': 52.11,
  'mem:15:140000:41': 80.01,
  'mem:15:140000:42': 80.01,
  'mem:15:140000:43': 80.01,
  'mem:15:140000:44': 80.01,
  'mem:15:140000:45': 80.01,
  'mem:15:140000:46': 121.97,
  'mem:15:140000:47': 121.97,
  'mem:15:140000:48': 121.97,
  'mem:15:140000:49': 121.97,
  'mem:15:140000:50': 121.97,
  'mem:15:140000:51': 183.33,
  'mem:15:140000:52': 183.33,
  'mem:15:140000:53': 183.33,
  'mem:15:140000:54': 183.33,
  'mem:15:140000:55': 183.33,
  'mem:15:140000:56': 259.72,
  'mem:15:140000:57': 259.72,
  'mem:15:140000:58': 259.72,
  'mem:15:140000:59': 259.72,
  'mem:15:140000:60': 259.72,
  'mem:15:140000:61': 368.33,
  'mem:15:140000:62': 368.33,
  'mem:15:140000:63': 368.33,
  'mem:15:140000:64': 368.33,
  'mem:15:140000:65': 368.33,
  'mem:15:140000:66': 535.73,
  'mem:15:140000:67': 535.73,
  'mem:15:140000:68': 535.73,
  'mem:15:140000:69': 535.73,
  'mem:15:140000:70': 535.73,
  'mem:15:140000:71': 713.54,
  'mem:15:140000:72': 713.54,
  'mem:15:140000:73': 713.54,
  'mem:15:140000:74': 713.54,
  'mem:15:140000:75': 713.54,
  'mem:15:140000:76': 1005.13,
  'mem:15:140000:77': 1005.13,
  'mem:15:140000:78': 1005.13,
  'mem:15:140000:79': 1005.13,
  'mem:15:140000:80': 1005.13,
  'mem:15:140000:81': 1460.31,
  'mem:15:140000:82': 1460.31,
  'mem:15:140000:83': 1460.31,
  'mem:15:140000:84': 1460.31,
  'mem:15:140000:85': 1460.31,
  'mem:15:140000:86': 2030.99,
  'mem:15:140000:87': 2030.99,
  'mem:15:140000:88': 2030.99,
  'mem:15:140000:89': 2030.99,
  'mem:15:140000:90': 2030.99,
  'mem:15:140000:91': 2826.43,
  'mem:15:140000:92': 2826.43,
  'mem:15:140000:93': 2826.43,
  'mem:15:140000:94': 2826.43,
  'mem:15:140000:95': 2826.43,
  'mem:15:140000:96': 4635.58,
  'mem:15:140000:97': 4635.58,
  'mem:15:140000:98': 4635.58,
  'mem:15:140000:99': 4635.58,
  'mem:15:140000:100': 4635.58,
  'mem:15:160000:1': 25.94,
  'mem:15:160000:2': 25.94,
  'mem:15:160000:3': 25.94,
  'mem:15:160000:4': 25.94,
  'mem:15:160000:5': 25.94,
  'mem:15:160000:6': 25.84,
  'mem:15:160000:7': 25.84,
  'mem:15:160000:8': 25.84,
  'mem:15:160000:9': 25.84,
  'mem:15:160000:10': 25.84,
  'mem:15:160000:11': 25.95,
  'mem:15:160000:12': 25.95,
  'mem:15:160000:13': 25.95,
  'mem:15:160000:14': 25.95,
  'mem:15:160000:15': 25.95,
  'mem:15:160000:16': 26.46,
  'mem:15:160000:17': 26.46,
  'mem:15:160000:18': 26.46,
  'mem:15:160000:19': 26.46,
  'mem:15:160000:20': 26.46,
  'mem:15:160000:21': 28.06,
  'mem:15:160000:22': 28.06,
  'mem:15:160000:23': 28.06,
  'mem:15:160000:24': 28.06,
  'mem:15:160000:25': 28.06,
  'mem:15:160000:26': 32.13,
  'mem:15:160000:27': 32.13,
  'mem:15:160000:28': 32.13,
  'mem:15:160000:29': 32.13,
  'mem:15:160000:30': 32.13,
  'mem:15:160000:31': 41.41,
  'mem:15:160000:32': 41.41,
  'mem:15:160000:33': 41.41,
  'mem:15:160000:34': 41.41,
  'mem:15:160000:35': 41.41,
  'mem:15:160000:36': 59.58,
  'mem:15:160000:37': 59.58,
  'mem:15:160000:38': 59.58,
  'mem:15:160000:39': 59.58,
  'mem:15:160000:40': 59.58,
  'mem:15:160000:41': 91.47,
  'mem:15:160000:42': 91.47,
  'mem:15:160000:43': 91.47,
  'mem:15:160000:44': 91.47,
  'mem:15:160000:45': 91.47,
  'mem:15:160000:46': 139.44,
  'mem:15:160000:47': 139.44,
  'mem:15:160000:48': 139.44,
  'mem:15:160000:49': 139.44,
  'mem:15:160000:50': 139.44,
  'mem:15:160000:51': 209.58,
  'mem:15:160000:52': 209.58,
  'mem:15:160000:53': 209.58,
  'mem:15:160000:54': 209.58,
  'mem:15:160000:55': 209.58,
  'mem:15:160000:56': 296.91,
  'mem:15:160000:57': 296.91,
  'mem:15:160000:58': 296.91,
  'mem:15:160000:59': 296.91,
  'mem:15:160000:60': 296.91,
  'mem:15:160000:61': 421.08,
  'mem:15:160000:62': 421.08,
  'mem:15:160000:63': 421.08,
  'mem:15:160000:64': 421.08,
  'mem:15:160000:65': 421.08,
  'mem:15:160000:66': 612.46,
  'mem:15:160000:67': 612.46,
  'mem:15:160000:68': 612.46,
  'mem:15:160000:69': 612.46,
  'mem:15:160000:70': 612.46,
  'mem:15:160000:71': 815.71,
  'mem:15:160000:72': 815.71,
  'mem:15:160000:73': 815.71,
  'mem:15:160000:74': 815.71,
  'mem:15:160000:75': 815.71,
  'mem:15:160000:76': 1149.06,
  'mem:15:160000:77': 1149.06,
  'mem:15:160000:78': 1149.06,
  'mem:15:160000:79': 1149.06,
  'mem:15:160000:80': 1149.06,
  'mem:15:160000:81': 1669.41,
  'mem:15:160000:82': 1669.41,
  'mem:15:160000:83': 1669.41,
  'mem:15:160000:84': 1669.41,
  'mem:15:160000:85': 1669.41,
  'mem:15:160000:86': 2321.76,
  'mem:15:160000:87': 2321.76,
  'mem:15:160000:88': 2321.76,
  'mem:15:160000:89': 2321.76,
  'mem:15:160000:90': 2321.76,
  'mem:15:160000:91': 3231.03,
  'mem:15:160000:92': 3231.03,
  'mem:15:160000:93': 3231.03,
  'mem:15:160000:94': 3231.03,
  'mem:15:160000:95': 3231.03,
  'mem:15:160000:96': 5299.08,
  'mem:15:160000:97': 5299.08,
  'mem:15:160000:98': 5299.08,
  'mem:15:160000:99': 5299.08,
  'mem:15:160000:100': 5299.08,
  'mem:15:180000:1': 29.15,
  'mem:15:180000:2': 29.15,
  'mem:15:180000:3': 29.15,
  'mem:15:180000:4': 29.15,
  'mem:15:180000:5': 29.15,
  'mem:15:180000:6': 29.04,
  'mem:15:180000:7': 29.04,
  'mem:15:180000:8': 29.04,
  'mem:15:180000:9': 29.04,
  'mem:15:180000:10': 29.04,
  'mem:15:180000:11': 29.15,
  'mem:15:180000:12': 29.15,
  'mem:15:180000:13': 29.15,
  'mem:15:180000:14': 29.15,
  'mem:15:180000:15': 29.15,
  'mem:15:180000:16': 29.73,
  'mem:15:180000:17': 29.73,
  'mem:15:180000:18': 29.73,
  'mem:15:180000:19': 29.73,
  'mem:15:180000:20': 29.73,
  'mem:15:180000:21': 31.52,
  'mem:15:180000:22': 31.52,
  'mem:15:180000:23': 31.52,
  'mem:15:180000:24': 31.52,
  'mem:15:180000:25': 31.52,
  'mem:15:180000:26': 36.09,
  'mem:15:180000:27': 36.09,
  'mem:15:180000:28': 36.09,
  'mem:15:180000:29': 36.09,
  'mem:15:180000:30': 36.09,
  'mem:15:180000:31': 46.52,
  'mem:15:180000:32': 46.52,
  'mem:15:180000:33': 46.52,
  'mem:15:180000:34': 46.52,
  'mem:15:180000:35': 46.52,
  'mem:15:180000:36': 66.93,
  'mem:15:180000:37': 66.93,
  'mem:15:180000:38': 66.93,
  'mem:15:180000:39': 66.93,
  'mem:15:180000:40': 66.93,
  'mem:15:180000:41': 102.85,
  'mem:15:180000:42': 102.85,
  'mem:15:180000:43': 102.85,
  'mem:15:180000:44': 102.85,
  'mem:15:180000:45': 102.85,
  'mem:15:180000:46': 156.75,
  'mem:15:180000:47': 156.75,
  'mem:15:180000:48': 156.75,
  'mem:15:180000:49': 156.75,
  'mem:15:180000:50': 156.75,
  'mem:15:180000:51': 235.45,
  'mem:15:180000:52': 235.45,
  'mem:15:180000:53': 235.45,
  'mem:15:180000:54': 235.45,
  'mem:15:180000:55': 235.45,
  'mem:15:180000:56': 333.55,
  'mem:15:180000:57': 333.55,
  'mem:15:180000:58': 333.55,
  'mem:15:180000:59': 333.55,
  'mem:15:180000:60': 333.55,
  'mem:15:180000:61': 473.03,
  'mem:15:180000:62': 473.03,
  'mem:15:180000:63': 473.03,
  'mem:15:180000:64': 473.03,
  'mem:15:180000:65': 473.03,
  'mem:15:180000:66': 687.98,
  'mem:15:180000:67': 687.98,
  'mem:15:180000:68': 687.98,
  'mem:15:180000:69': 687.98,
  'mem:15:180000:70': 687.98,
  'mem:15:180000:71': 916.35,
  'mem:15:180000:72': 916.35,
  'mem:15:180000:73': 916.35,
  'mem:15:180000:74': 916.35,
  'mem:15:180000:75': 916.35,
  'mem:15:180000:76': 1290.85,
  'mem:15:180000:77': 1290.85,
  'mem:15:180000:78': 1290.85,
  'mem:15:180000:79': 1290.85,
  'mem:15:180000:80': 1290.85,
  'mem:15:180000:81': 1875.42,
  'mem:15:180000:82': 1875.42,
  'mem:15:180000:83': 1875.42,
  'mem:15:180000:84': 1875.42,
  'mem:15:180000:85': 1875.42,
  'mem:15:180000:86': 2608.4,
  'mem:15:180000:87': 2608.4,
  'mem:15:180000:88': 2608.4,
  'mem:15:180000:89': 2608.4,
  'mem:15:180000:90': 2608.4,
  'mem:15:180000:91': 3630.07,
  'mem:15:180000:92': 3630.07,
  'mem:15:180000:93': 3630.07,
  'mem:15:180000:94': 3630.07,
  'mem:15:180000:95': 3630.07,
  'mem:15:180000:96': 5953.72,
  'mem:15:180000:97': 5953.72,
  'mem:15:180000:98': 5953.72,
  'mem:15:180000:99': 5953.72,
  'mem:15:180000:100': 5953.72,
  'mem:15:200000:1': 32.4,
  'mem:15:200000:2': 32.4,
  'mem:15:200000:3': 32.4,
  'mem:15:200000:4': 32.4,
  'mem:15:200000:5': 32.4,
  'mem:15:200000:6': 32.28,
  'mem:15:200000:7': 32.28,
  'mem:15:200000:8': 32.28,
  'mem:15:200000:9': 32.28,
  'mem:15:200000:10': 32.28,
  'mem:15:200000:11': 32.41,
  'mem:15:200000:12': 32.41,
  'mem:15:200000:13': 32.41,
  'mem:15:200000:14': 32.41,
  'mem:15:200000:15': 32.41,
  'mem:15:200000:16': 33.05,
  'mem:15:200000:17': 33.05,
  'mem:15:200000:18': 33.05,
  'mem:15:200000:19': 33.05,
  'mem:15:200000:20': 33.05,
  'mem:15:200000:21': 35.04,
  'mem:15:200000:22': 35.04,
  'mem:15:200000:23': 35.04,
  'mem:15:200000:24': 35.04,
  'mem:15:200000:25': 35.04,
  'mem:15:200000:26': 40.12,
  'mem:15:200000:27': 40.12,
  'mem:15:200000:28': 40.12,
  'mem:15:200000:29': 40.12,
  'mem:15:200000:30': 40.12,
  'mem:15:200000:31': 51.71,
  'mem:15:200000:32': 51.71,
  'mem:15:200000:33': 51.71,
  'mem:15:200000:34': 51.71,
  'mem:15:200000:35': 51.71,
  'mem:15:200000:36': 74.4,
  'mem:15:200000:37': 74.4,
  'mem:15:200000:38': 74.4,
  'mem:15:200000:39': 74.4,
  'mem:15:200000:40': 74.4,
  'mem:15:200000:41': 114.3,
  'mem:15:200000:42': 114.3,
  'mem:15:200000:43': 114.3,
  'mem:15:200000:44': 114.3,
  'mem:15:200000:45': 114.3,
  'mem:15:200000:46': 174.21,
  'mem:15:200000:47': 174.21,
  'mem:15:200000:48': 174.21,
  'mem:15:200000:49': 174.21,
  'mem:15:200000:50': 174.21,
  'mem:15:200000:51': 261.73,
  'mem:15:200000:52': 261.73,
  'mem:15:200000:53': 261.73,
  'mem:15:200000:54': 261.73,
  'mem:15:200000:55': 261.73,
  'mem:15:200000:56': 370.78,
  'mem:15:200000:57': 370.78,
  'mem:15:200000:58': 370.78,
  'mem:15:200000:59': 370.78,
  'mem:15:200000:60': 370.78,
  'mem:15:200000:61': 525.83,
  'mem:15:200000:62': 525.83,
  'mem:15:200000:63': 525.83,
  'mem:15:200000:64': 525.83,
  'mem:15:200000:65': 525.83,
  'mem:15:200000:66': 764.77,
  'mem:15:200000:67': 764.77,
  'mem:15:200000:68': 764.77,
  'mem:15:200000:69': 764.77,
  'mem:15:200000:70': 764.77,
  'mem:15:200000:71': 1018.65,
  'mem:15:200000:72': 1018.65,
  'mem:15:200000:73': 1018.65,
  'mem:15:200000:74': 1018.65,
  'mem:15:200000:75': 1018.65,
  'mem:15:200000:76': 1434.98,
  'mem:15:200000:77': 1434.98,
  'mem:15:200000:78': 1434.98,
  'mem:15:200000:79': 1434.98,
  'mem:15:200000:80': 1434.98,
  'mem:15:200000:81': 2084.81,
  'mem:15:200000:82': 2084.81,
  'mem:15:200000:83': 2084.81,
  'mem:15:200000:84': 2084.81,
  'mem:15:200000:85': 2084.81,
  'mem:15:200000:86': 2899.67,
  'mem:15:200000:87': 2899.67,
  'mem:15:200000:88': 2899.67,
  'mem:15:200000:89': 2899.67,
  'mem:15:200000:90': 2899.67,
  'mem:15:200000:91': 4035.43,
  'mem:15:200000:92': 4035.43,
  'mem:15:200000:93': 4035.43,
  'mem:15:200000:94': 4035.43,
  'mem:15:200000:95': 4035.43,
  'mem:15:200000:96': 6618.54,
  'mem:15:200000:97': 6618.54,
  'mem:15:200000:98': 6618.54,
  'mem:15:200000:99': 6618.54,
  'mem:15:200000:100': 6618.54,
  'mem_40:15:5000:1': 1.2,
  'mem_40:15:5000:2': 1.2,
  'mem_40:15:5000:3': 1.2,
  'mem_40:15:5000:4': 1.2,
  'mem_40:15:5000:5': 1.2,
  'mem_40:15:5000:6': 1.2,
  'mem_40:15:5000:7': 1.2,
  'mem_40:15:5000:8': 1.2,
  'mem_40:15:5000:9': 1.2,
  'mem_40:15:5000:10': 1.2,
  'mem_40:15:5000:11': 1.2,
  'mem_40:15:5000:12': 1.2,
  'mem_40:15:5000:13': 1.2,
  'mem_40:15:5000:14': 1.2,
  'mem_40:15:5000:15': 1.2,
  'mem_40:15:5000:16': 1.2,
  'mem_40:15:5000:17': 1.2,
  'mem_40:15:5000:18': 1.2,
  'mem_40:15:5000:19': 1.2,
  'mem_40:15:5000:20': 1.2,
  'mem_40:15:5000:21': 1.2,
  'mem_40:15:5000:22': 1.2,
  'mem_40:15:5000:23': 1.2,
  'mem_40:15:5000:24': 1.2,
  'mem_40:15:5000:25': 1.2,
  'mem_40:15:5000:26': 2.4,
  'mem_40:15:5000:27': 2.4,
  'mem_40:15:5000:28': 2.4,
  'mem_40:15:5000:29': 2.4,
  'mem_40:15:5000:30': 2.4,
  'mem_40:15:5000:31': 2.4,
  'mem_40:15:5000:32': 2.4,
  'mem_40:15:5000:33': 2.4,
  'mem_40:15:5000:34': 2.4,
  'mem_40:15:5000:35': 2.4,
  'mem_40:15:5000:36': 3.6,
  'mem_40:15:5000:37': 3.6,
  'mem_40:15:5000:38': 3.6,
  'mem_40:15:5000:39': 3.6,
  'mem_40:15:5000:40': 3.6,
  'mem_40:15:5000:41': 4.8,
  'mem_40:15:5000:42': 4.8,
  'mem_40:15:5000:43': 4.8,
  'mem_40:15:5000:44': 4.8,
  'mem_40:15:5000:45': 4.8,
  'mem_40:15:5000:46': 8.4,
  'mem_40:15:5000:47': 8.4,
  'mem_40:15:5000:48': 8.4,
  'mem_40:15:5000:49': 8.4,
  'mem_40:15:5000:50': 8.4,
  'mem_40:15:5000:51': 12,
  'mem_40:15:5000:52': 12,
  'mem_40:15:5000:53': 12,
  'mem_40:15:5000:54': 12,
  'mem_40:15:5000:55': 12,
  'mem_40:15:5000:56': 13.2,
  'mem_40:15:5000:57': 13.2,
  'mem_40:15:5000:58': 13.2,
  'mem_40:15:5000:59': 13.2,
  'mem_40:15:5000:60': 13.2,
  'mem_40:15:5000:61': 14.4,
  'mem_40:15:5000:62': 14.4,
  'mem_40:15:5000:63': 14.4,
  'mem_40:15:5000:64': 14.4,
  'mem_40:15:5000:65': 14.4,
  'mem_40:15:5000:66': 20.4,
  'mem_40:15:5000:67': 20.4,
  'mem_40:15:5000:68': 20.4,
  'mem_40:15:5000:69': 20.4,
  'mem_40:15:5000:70': 20.4,
  'mem_40:15:5000:71': 27.6,
  'mem_40:15:5000:72': 27.6,
  'mem_40:15:5000:73': 27.6,
  'mem_40:15:5000:74': 27.6,
  'mem_40:15:5000:75': 27.6,
  'mem_40:15:5000:76': 37.2,
  'mem_40:15:5000:77': 37.2,
  'mem_40:15:5000:78': 37.2,
  'mem_40:15:5000:79': 37.2,
  'mem_40:15:5000:80': 37.2,
  'mem_40:15:5000:81': 52.14,
  'mem_40:15:5000:82': 52.14,
  'mem_40:15:5000:83': 52.14,
  'mem_40:15:5000:84': 52.14,
  'mem_40:15:5000:85': 52.14,
  'mem_40:15:5000:86': 72.54,
  'mem_40:15:5000:87': 72.54,
  'mem_40:15:5000:88': 72.54,
  'mem_40:15:5000:89': 72.54,
  'mem_40:15:5000:90': 72.54,
  'mem_40:15:5000:91': 100.99,
  'mem_40:15:5000:92': 100.99,
  'mem_40:15:5000:93': 100.99,
  'mem_40:15:5000:94': 100.99,
  'mem_40:15:5000:95': 100.99,
  'mem_40:15:5000:96': 165.64,
  'mem_40:15:5000:97': 165.64,
  'mem_40:15:5000:98': 165.64,
  'mem_40:15:5000:99': 165.64,
  'mem_40:15:5000:100': 165.64,
  'mem_40:15:7500:1': 2.4,
  'mem_40:15:7500:2': 2.4,
  'mem_40:15:7500:3': 2.4,
  'mem_40:15:7500:4': 2.4,
  'mem_40:15:7500:5': 2.4,
  'mem_40:15:7500:6': 2.4,
  'mem_40:15:7500:7': 2.4,
  'mem_40:15:7500:8': 2.4,
  'mem_40:15:7500:9': 2.4,
  'mem_40:15:7500:10': 2.4,
  'mem_40:15:7500:11': 2.4,
  'mem_40:15:7500:12': 2.4,
  'mem_40:15:7500:13': 2.4,
  'mem_40:15:7500:14': 2.4,
  'mem_40:15:7500:15': 2.4,
  'mem_40:15:7500:16': 2.4,
  'mem_40:15:7500:17': 2.4,
  'mem_40:15:7500:18': 2.4,
  'mem_40:15:7500:19': 2.4,
  'mem_40:15:7500:20': 2.4,
  'mem_40:15:7500:21': 2.4,
  'mem_40:15:7500:22': 2.4,
  'mem_40:15:7500:23': 2.4,
  'mem_40:15:7500:24': 2.4,
  'mem_40:15:7500:25': 2.4,
  'mem_40:15:7500:26': 2.4,
  'mem_40:15:7500:27': 2.4,
  'mem_40:15:7500:28': 2.4,
  'mem_40:15:7500:29': 2.4,
  'mem_40:15:7500:30': 2.4,
  'mem_40:15:7500:31': 3.6,
  'mem_40:15:7500:32': 3.6,
  'mem_40:15:7500:33': 3.6,
  'mem_40:15:7500:34': 3.6,
  'mem_40:15:7500:35': 3.6,
  'mem_40:15:7500:36': 4.8,
  'mem_40:15:7500:37': 4.8,
  'mem_40:15:7500:38': 4.8,
  'mem_40:15:7500:39': 4.8,
  'mem_40:15:7500:40': 4.8,
  'mem_40:15:7500:41': 7.2,
  'mem_40:15:7500:42': 7.2,
  'mem_40:15:7500:43': 7.2,
  'mem_40:15:7500:44': 7.2,
  'mem_40:15:7500:45': 7.2,
  'mem_40:15:7500:46': 12,
  'mem_40:15:7500:47': 12,
  'mem_40:15:7500:48': 12,
  'mem_40:15:7500:49': 12,
  'mem_40:15:7500:50': 12,
  'mem_40:15:7500:51': 16.8,
  'mem_40:15:7500:52': 16.8,
  'mem_40:15:7500:53': 16.8,
  'mem_40:15:7500:54': 16.8,
  'mem_40:15:7500:55': 16.8,
  'mem_40:15:7500:56': 19.2,
  'mem_40:15:7500:57': 19.2,
  'mem_40:15:7500:58': 19.2,
  'mem_40:15:7500:59': 19.2,
  'mem_40:15:7500:60': 19.2,
  'mem_40:15:7500:61': 20.4,
  'mem_40:15:7500:62': 20.4,
  'mem_40:15:7500:63': 20.4,
  'mem_40:15:7500:64': 20.4,
  'mem_40:15:7500:65': 20.4,
  'mem_40:15:7500:66': 30,
  'mem_40:15:7500:67': 30,
  'mem_40:15:7500:68': 30,
  'mem_40:15:7500:69': 30,
  'mem_40:15:7500:70': 30,
  'mem_40:15:7500:71': 40.8,
  'mem_40:15:7500:72': 40.8,
  'mem_40:15:7500:73': 40.8,
  'mem_40:15:7500:74': 40.8,
  'mem_40:15:7500:75': 40.8,
  'mem_40:15:7500:76': 55.2,
  'mem_40:15:7500:77': 55.2,
  'mem_40:15:7500:78': 55.2,
  'mem_40:15:7500:79': 55.2,
  'mem_40:15:7500:80': 55.2,
  'mem_40:15:7500:81': 78.25,
  'mem_40:15:7500:82': 78.25,
  'mem_40:15:7500:83': 78.25,
  'mem_40:15:7500:84': 78.25,
  'mem_40:15:7500:85': 78.25,
  'mem_40:15:7500:86': 108.83,
  'mem_40:15:7500:87': 108.83,
  'mem_40:15:7500:88': 108.83,
  'mem_40:15:7500:89': 108.83,
  'mem_40:15:7500:90': 108.83,
  'mem_40:15:7500:91': 151.45,
  'mem_40:15:7500:92': 151.45,
  'mem_40:15:7500:93': 151.45,
  'mem_40:15:7500:94': 151.45,
  'mem_40:15:7500:95': 151.45,
  'mem_40:15:7500:96': 248.38,
  'mem_40:15:7500:97': 248.38,
  'mem_40:15:7500:98': 248.38,
  'mem_40:15:7500:99': 248.38,
  'mem_40:15:7500:100': 248.38,
  'mem_40:15:10000:1': 2.4,
  'mem_40:15:10000:2': 2.4,
  'mem_40:15:10000:3': 2.4,
  'mem_40:15:10000:4': 2.4,
  'mem_40:15:10000:5': 2.4,
  'mem_40:15:10000:6': 2.4,
  'mem_40:15:10000:7': 2.4,
  'mem_40:15:10000:8': 2.4,
  'mem_40:15:10000:9': 2.4,
  'mem_40:15:10000:10': 2.4,
  'mem_40:15:10000:11': 2.4,
  'mem_40:15:10000:12': 2.4,
  'mem_40:15:10000:13': 2.4,
  'mem_40:15:10000:14': 2.4,
  'mem_40:15:10000:15': 2.4,
  'mem_40:15:10000:16': 2.4,
  'mem_40:15:10000:17': 2.4,
  'mem_40:15:10000:18': 2.4,
  'mem_40:15:10000:19': 2.4,
  'mem_40:15:10000:20': 2.4,
  'mem_40:15:10000:21': 2.4,
  'mem_40:15:10000:22': 2.4,
  'mem_40:15:10000:23': 2.4,
  'mem_40:15:10000:24': 2.4,
  'mem_40:15:10000:25': 2.4,
  'mem_40:15:10000:26': 3.6,
  'mem_40:15:10000:27': 3.6,
  'mem_40:15:10000:28': 3.6,
  'mem_40:15:10000:29': 3.6,
  'mem_40:15:10000:30': 3.6,
  'mem_40:15:10000:31': 4.8,
  'mem_40:15:10000:32': 4.8,
  'mem_40:15:10000:33': 4.8,
  'mem_40:15:10000:34': 4.8,
  'mem_40:15:10000:35': 4.8,
  'mem_40:15:10000:36': 6,
  'mem_40:15:10000:37': 6,
  'mem_40:15:10000:38': 6,
  'mem_40:15:10000:39': 6,
  'mem_40:15:10000:40': 6,
  'mem_40:15:10000:41': 9.6,
  'mem_40:15:10000:42': 9.6,
  'mem_40:15:10000:43': 9.6,
  'mem_40:15:10000:44': 9.6,
  'mem_40:15:10000:45': 9.6,
  'mem_40:15:10000:46': 15.6,
  'mem_40:15:10000:47': 15.6,
  'mem_40:15:10000:48': 15.6,
  'mem_40:15:10000:49': 15.6,
  'mem_40:15:10000:50': 15.6,
  'mem_40:15:10000:51': 22.8,
  'mem_40:15:10000:52': 22.8,
  'mem_40:15:10000:53': 22.8,
  'mem_40:15:10000:54': 22.8,
  'mem_40:15:10000:55': 22.8,
  'mem_40:15:10000:56': 25.2,
  'mem_40:15:10000:57': 25.2,
  'mem_40:15:10000:58': 25.2,
  'mem_40:15:10000:59': 25.2,
  'mem_40:15:10000:60': 25.2,
  'mem_40:15:10000:61': 27.6,
  'mem_40:15:10000:62': 27.6,
  'mem_40:15:10000:63': 27.6,
  'mem_40:15:10000:64': 27.6,
  'mem_40:15:10000:65': 27.6,
  'mem_40:15:10000:66': 39.6,
  'mem_40:15:10000:67': 39.6,
  'mem_40:15:10000:68': 39.6,
  'mem_40:15:10000:69': 39.6,
  'mem_40:15:10000:70': 39.6,
  'mem_40:15:10000:71': 54,
  'mem_40:15:10000:72': 54,
  'mem_40:15:10000:73': 54,
  'mem_40:15:10000:74': 54,
  'mem_40:15:10000:75': 54,
  'mem_40:15:10000:76': 74.4,
  'mem_40:15:10000:77': 74.4,
  'mem_40:15:10000:78': 74.4,
  'mem_40:15:10000:79': 74.4,
  'mem_40:15:10000:80': 74.4,
  'mem_40:15:10000:81': 104.31,
  'mem_40:15:10000:82': 104.31,
  'mem_40:15:10000:83': 104.31,
  'mem_40:15:10000:84': 104.31,
  'mem_40:15:10000:85': 104.31,
  'mem_40:15:10000:86': 145.08,
  'mem_40:15:10000:87': 145.08,
  'mem_40:15:10000:88': 145.08,
  'mem_40:15:10000:89': 145.08,
  'mem_40:15:10000:90': 145.08,
  'mem_40:15:10000:91': 201.9,
  'mem_40:15:10000:92': 201.9,
  'mem_40:15:10000:93': 201.9,
  'mem_40:15:10000:94': 201.9,
  'mem_40:15:10000:95': 201.9,
  'mem_40:15:10000:96': 331.13,
  'mem_40:15:10000:97': 331.13,
  'mem_40:15:10000:98': 331.13,
  'mem_40:15:10000:99': 331.13,
  'mem_40:15:10000:100': 331.13,
  'mem_40:15:15000:1': 3.6,
  'mem_40:15:15000:2': 3.6,
  'mem_40:15:15000:3': 3.6,
  'mem_40:15:15000:4': 3.6,
  'mem_40:15:15000:5': 3.6,
  'mem_40:15:15000:6': 3.6,
  'mem_40:15:15000:7': 3.6,
  'mem_40:15:15000:8': 3.6,
  'mem_40:15:15000:9': 3.6,
  'mem_40:15:15000:10': 3.6,
  'mem_40:15:15000:11': 3.6,
  'mem_40:15:15000:12': 3.6,
  'mem_40:15:15000:13': 3.6,
  'mem_40:15:15000:14': 3.6,
  'mem_40:15:15000:15': 3.6,
  'mem_40:15:15000:16': 3.6,
  'mem_40:15:15000:17': 3.6,
  'mem_40:15:15000:18': 3.6,
  'mem_40:15:15000:19': 3.6,
  'mem_40:15:15000:20': 3.6,
  'mem_40:15:15000:21': 3.6,
  'mem_40:15:15000:22': 3.6,
  'mem_40:15:15000:23': 3.6,
  'mem_40:15:15000:24': 3.6,
  'mem_40:15:15000:25': 3.6,
  'mem_40:15:15000:26': 4.8,
  'mem_40:15:15000:27': 4.8,
  'mem_40:15:15000:28': 4.8,
  'mem_40:15:15000:29': 4.8,
  'mem_40:15:15000:30': 4.8,
  'mem_40:15:15000:31': 6,
  'mem_40:15:15000:32': 6,
  'mem_40:15:15000:33': 6,
  'mem_40:15:15000:34': 6,
  'mem_40:15:15000:35': 6,
  'mem_40:15:15000:36': 9.6,
  'mem_40:15:15000:37': 9.6,
  'mem_40:15:15000:38': 9.6,
  'mem_40:15:15000:39': 9.6,
  'mem_40:15:15000:40': 9.6,
  'mem_40:15:15000:41': 14.4,
  'mem_40:15:15000:42': 14.4,
  'mem_40:15:15000:43': 14.4,
  'mem_40:15:15000:44': 14.4,
  'mem_40:15:15000:45': 14.4,
  'mem_40:15:15000:46': 22.8,
  'mem_40:15:15000:47': 22.8,
  'mem_40:15:15000:48': 22.8,
  'mem_40:15:15000:49': 22.8,
  'mem_40:15:15000:50': 22.8,
  'mem_40:15:15000:51': 33.6,
  'mem_40:15:15000:52': 33.6,
  'mem_40:15:15000:53': 33.6,
  'mem_40:15:15000:54': 33.6,
  'mem_40:15:15000:55': 33.6,
  'mem_40:15:15000:56': 37.2,
  'mem_40:15:15000:57': 37.2,
  'mem_40:15:15000:58': 37.2,
  'mem_40:15:15000:59': 37.2,
  'mem_40:15:15000:60': 37.2,
  'mem_40:15:15000:61': 40.8,
  'mem_40:15:15000:62': 40.8,
  'mem_40:15:15000:63': 40.8,
  'mem_40:15:15000:64': 40.8,
  'mem_40:15:15000:65': 40.8,
  'mem_40:15:15000:66': 58.8,
  'mem_40:15:15000:67': 58.8,
  'mem_40:15:15000:68': 58.8,
  'mem_40:15:15000:69': 58.8,
  'mem_40:15:15000:70': 58.8,
  'mem_40:15:15000:71': 80.4,
  'mem_40:15:15000:72': 80.4,
  'mem_40:15:15000:73': 80.4,
  'mem_40:15:15000:74': 80.4,
  'mem_40:15:15000:75': 80.4,
  'mem_40:15:15000:76': 110.4,
  'mem_40:15:15000:77': 110.4,
  'mem_40:15:15000:78': 110.4,
  'mem_40:15:15000:79': 110.4,
  'mem_40:15:15000:80': 110.4,
  'mem_40:15:15000:81': 156.5,
  'mem_40:15:15000:82': 156.5,
  'mem_40:15:15000:83': 156.5,
  'mem_40:15:15000:84': 156.5,
  'mem_40:15:15000:85': 156.5,
  'mem_40:15:15000:86': 217.65,
  'mem_40:15:15000:87': 217.65,
  'mem_40:15:15000:88': 217.65,
  'mem_40:15:15000:89': 217.65,
  'mem_40:15:15000:90': 217.65,
  'mem_40:15:15000:91': 302.89,
  'mem_40:15:15000:92': 302.89,
  'mem_40:15:15000:93': 302.89,
  'mem_40:15:15000:94': 302.89,
  'mem_40:15:15000:95': 302.89,
  'mem_40:15:15000:96': 496.76,
  'mem_40:15:15000:97': 496.76,
  'mem_40:15:15000:98': 496.76,
  'mem_40:15:15000:99': 496.76,
  'mem_40:15:15000:100': 496.76,
  'mem_40:15:20000:1': 4.8,
  'mem_40:15:20000:2': 4.8,
  'mem_40:15:20000:3': 4.8,
  'mem_40:15:20000:4': 4.8,
  'mem_40:15:20000:5': 4.8,
  'mem_40:15:20000:6': 4.8,
  'mem_40:15:20000:7': 4.8,
  'mem_40:15:20000:8': 4.8,
  'mem_40:15:20000:9': 4.8,
  'mem_40:15:20000:10': 4.8,
  'mem_40:15:20000:11': 4.8,
  'mem_40:15:20000:12': 4.8,
  'mem_40:15:20000:13': 4.8,
  'mem_40:15:20000:14': 4.8,
  'mem_40:15:20000:15': 4.8,
  'mem_40:15:20000:16': 4.8,
  'mem_40:15:20000:17': 4.8,
  'mem_40:15:20000:18': 4.8,
  'mem_40:15:20000:19': 4.8,
  'mem_40:15:20000:20': 4.8,
  'mem_40:15:20000:21': 4.8,
  'mem_40:15:20000:22': 4.8,
  'mem_40:15:20000:23': 4.8,
  'mem_40:15:20000:24': 4.8,
  'mem_40:15:20000:25': 4.8,
  'mem_40:15:20000:26': 6,
  'mem_40:15:20000:27': 6,
  'mem_40:15:20000:28': 6,
  'mem_40:15:20000:29': 6,
  'mem_40:15:20000:30': 6,
  'mem_40:15:20000:31': 8.4,
  'mem_40:15:20000:32': 8.4,
  'mem_40:15:20000:33': 8.4,
  'mem_40:15:20000:34': 8.4,
  'mem_40:15:20000:35': 8.4,
  'mem_40:15:20000:36': 12,
  'mem_40:15:20000:37': 12,
  'mem_40:15:20000:38': 12,
  'mem_40:15:20000:39': 12,
  'mem_40:15:20000:40': 12,
  'mem_40:15:20000:41': 19.2,
  'mem_40:15:20000:42': 19.2,
  'mem_40:15:20000:43': 19.2,
  'mem_40:15:20000:44': 19.2,
  'mem_40:15:20000:45': 19.2,
  'mem_40:15:20000:46': 30,
  'mem_40:15:20000:47': 30,
  'mem_40:15:20000:48': 30,
  'mem_40:15:20000:49': 30,
  'mem_40:15:20000:50': 30,
  'mem_40:15:20000:51': 44.4,
  'mem_40:15:20000:52': 44.4,
  'mem_40:15:20000:53': 44.4,
  'mem_40:15:20000:54': 44.4,
  'mem_40:15:20000:55': 44.4,
  'mem_40:15:20000:56': 49.2,
  'mem_40:15:20000:57': 49.2,
  'mem_40:15:20000:58': 49.2,
  'mem_40:15:20000:59': 49.2,
  'mem_40:15:20000:60': 49.2,
  'mem_40:15:20000:61': 54,
  'mem_40:15:20000:62': 54,
  'mem_40:15:20000:63': 54,
  'mem_40:15:20000:64': 54,
  'mem_40:15:20000:65': 54,
  'mem_40:15:20000:66': 78,
  'mem_40:15:20000:67': 78,
  'mem_40:15:20000:68': 78,
  'mem_40:15:20000:69': 78,
  'mem_40:15:20000:70': 78,
  'mem_40:15:20000:71': 106.8,
  'mem_40:15:20000:72': 106.8,
  'mem_40:15:20000:73': 106.8,
  'mem_40:15:20000:74': 106.8,
  'mem_40:15:20000:75': 106.8,
  'mem_40:15:20000:76': 147.6,
  'mem_40:15:20000:77': 147.6,
  'mem_40:15:20000:78': 147.6,
  'mem_40:15:20000:79': 147.6,
  'mem_40:15:20000:80': 147.6,
  'mem_40:15:20000:81': 208.62,
  'mem_40:15:20000:82': 208.62,
  'mem_40:15:20000:83': 208.62,
  'mem_40:15:20000:84': 208.62,
  'mem_40:15:20000:85': 208.62,
  'mem_40:15:20000:86': 290.15,
  'mem_40:15:20000:87': 290.15,
  'mem_40:15:20000:88': 290.15,
  'mem_40:15:20000:89': 290.15,
  'mem_40:15:20000:90': 290.15,
  'mem_40:15:20000:91': 403.79,
  'mem_40:15:20000:92': 403.79,
  'mem_40:15:20000:93': 403.79,
  'mem_40:15:20000:94': 403.79,
  'mem_40:15:20000:95': 403.79,
  'mem_40:15:20000:96': 662.25,
  'mem_40:15:20000:97': 662.25,
  'mem_40:15:20000:98': 662.25,
  'mem_40:15:20000:99': 662.25,
  'mem_40:15:20000:100': 662.25,
  'mem_40:15:25000:1': 6,
  'mem_40:15:25000:2': 6,
  'mem_40:15:25000:3': 6,
  'mem_40:15:25000:4': 6,
  'mem_40:15:25000:5': 6,
  'mem_40:15:25000:6': 6,
  'mem_40:15:25000:7': 6,
  'mem_40:15:25000:8': 6,
  'mem_40:15:25000:9': 6,
  'mem_40:15:25000:10': 6,
  'mem_40:15:25000:11': 6,
  'mem_40:15:25000:12': 6,
  'mem_40:15:25000:13': 6,
  'mem_40:15:25000:14': 6,
  'mem_40:15:25000:15': 6,
  'mem_40:15:25000:16': 6,
  'mem_40:15:25000:17': 6,
  'mem_40:15:25000:18': 6,
  'mem_40:15:25000:19': 6,
  'mem_40:15:25000:20': 6,
  'mem_40:15:25000:21': 6,
  'mem_40:15:25000:22': 6,
  'mem_40:15:25000:23': 6,
  'mem_40:15:25000:24': 6,
  'mem_40:15:25000:25': 6,
  'mem_40:15:25000:26': 7.2,
  'mem_40:15:25000:27': 7.2,
  'mem_40:15:25000:28': 7.2,
  'mem_40:15:25000:29': 7.2,
  'mem_40:15:25000:30': 7.2,
  'mem_40:15:25000:31': 10.8,
  'mem_40:15:25000:32': 10.8,
  'mem_40:15:25000:33': 10.8,
  'mem_40:15:25000:34': 10.8,
  'mem_40:15:25000:35': 10.8,
  'mem_40:15:25000:36': 15.6,
  'mem_40:15:25000:37': 15.6,
  'mem_40:15:25000:38': 15.6,
  'mem_40:15:25000:39': 15.6,
  'mem_40:15:25000:40': 15.6,
  'mem_40:15:25000:41': 24,
  'mem_40:15:25000:42': 24,
  'mem_40:15:25000:43': 24,
  'mem_40:15:25000:44': 24,
  'mem_40:15:25000:45': 24,
  'mem_40:15:25000:46': 37.2,
  'mem_40:15:25000:47': 37.2,
  'mem_40:15:25000:48': 37.2,
  'mem_40:15:25000:49': 37.2,
  'mem_40:15:25000:50': 37.2,
  'mem_40:15:25000:51': 55.2,
  'mem_40:15:25000:52': 55.2,
  'mem_40:15:25000:53': 55.2,
  'mem_40:15:25000:54': 55.2,
  'mem_40:15:25000:55': 55.2,
  'mem_40:15:25000:56': 61.2,
  'mem_40:15:25000:57': 61.2,
  'mem_40:15:25000:58': 61.2,
  'mem_40:15:25000:59': 61.2,
  'mem_40:15:25000:60': 61.2,
  'mem_40:15:25000:61': 67.2,
  'mem_40:15:25000:62': 67.2,
  'mem_40:15:25000:63': 67.2,
  'mem_40:15:25000:64': 67.2,
  'mem_40:15:25000:65': 67.2,
  'mem_40:15:25000:66': 97.2,
  'mem_40:15:25000:67': 97.2,
  'mem_40:15:25000:68': 97.2,
  'mem_40:15:25000:69': 97.2,
  'mem_40:15:25000:70': 97.2,
  'mem_40:15:25000:71': 134.4,
  'mem_40:15:25000:72': 134.4,
  'mem_40:15:25000:73': 134.4,
  'mem_40:15:25000:74': 134.4,
  'mem_40:15:25000:75': 134.4,
  'mem_40:15:25000:76': 183.6,
  'mem_40:15:25000:77': 183.6,
  'mem_40:15:25000:78': 183.6,
  'mem_40:15:25000:79': 183.6,
  'mem_40:15:25000:80': 183.6,
  'mem_40:15:25000:81': 260.86,
  'mem_40:15:25000:82': 260.86,
  'mem_40:15:25000:83': 260.86,
  'mem_40:15:25000:84': 260.86,
  'mem_40:15:25000:85': 260.86,
  'mem_40:15:25000:86': 362.79,
  'mem_40:15:25000:87': 362.79,
  'mem_40:15:25000:88': 362.79,
  'mem_40:15:25000:89': 362.79,
  'mem_40:15:25000:90': 362.79,
  'mem_40:15:25000:91': 504.87,
  'mem_40:15:25000:92': 504.87,
  'mem_40:15:25000:93': 504.87,
  'mem_40:15:25000:94': 504.87,
  'mem_40:15:25000:95': 504.87,
  'mem_40:15:25000:96': 828.02,
  'mem_40:15:25000:97': 828.02,
  'mem_40:15:25000:98': 828.02,
  'mem_40:15:25000:99': 828.02,
  'mem_40:15:25000:100': 828.02,
  'mem_40:15:30000:1': 6,
  'mem_40:15:30000:2': 6,
  'mem_40:15:30000:3': 6,
  'mem_40:15:30000:4': 6,
  'mem_40:15:30000:5': 6,
  'mem_40:15:30000:6': 6,
  'mem_40:15:30000:7': 6,
  'mem_40:15:30000:8': 6,
  'mem_40:15:30000:9': 6,
  'mem_40:15:30000:10': 6,
  'mem_40:15:30000:11': 7.2,
  'mem_40:15:30000:12': 7.2,
  'mem_40:15:30000:13': 7.2,
  'mem_40:15:30000:14': 7.2,
  'mem_40:15:30000:15': 7.2,
  'mem_40:15:30000:16': 7.2,
  'mem_40:15:30000:17': 7.2,
  'mem_40:15:30000:18': 7.2,
  'mem_40:15:30000:19': 7.2,
  'mem_40:15:30000:20': 7.2,
  'mem_40:15:30000:21': 7.2,
  'mem_40:15:30000:22': 7.2,
  'mem_40:15:30000:23': 7.2,
  'mem_40:15:30000:24': 7.2,
  'mem_40:15:30000:25': 7.2,
  'mem_40:15:30000:26': 9.6,
  'mem_40:15:30000:27': 9.6,
  'mem_40:15:30000:28': 9.6,
  'mem_40:15:30000:29': 9.6,
  'mem_40:15:30000:30': 9.6,
  'mem_40:15:30000:31': 12,
  'mem_40:15:30000:32': 12,
  'mem_40:15:30000:33': 12,
  'mem_40:15:30000:34': 12,
  'mem_40:15:30000:35': 12,
  'mem_40:15:30000:36': 18,
  'mem_40:15:30000:37': 18,
  'mem_40:15:30000:38': 18,
  'mem_40:15:30000:39': 18,
  'mem_40:15:30000:40': 18,
  'mem_40:15:30000:41': 28.8,
  'mem_40:15:30000:42': 28.8,
  'mem_40:15:30000:43': 28.8,
  'mem_40:15:30000:44': 28.8,
  'mem_40:15:30000:45': 28.8,
  'mem_40:15:30000:46': 43.2,
  'mem_40:15:30000:47': 43.2,
  'mem_40:15:30000:48': 43.2,
  'mem_40:15:30000:49': 43.2,
  'mem_40:15:30000:50': 43.2,
  'mem_40:15:30000:51': 66,
  'mem_40:15:30000:52': 66,
  'mem_40:15:30000:53': 66,
  'mem_40:15:30000:54': 66,
  'mem_40:15:30000:55': 66,
  'mem_40:15:30000:56': 72,
  'mem_40:15:30000:57': 72,
  'mem_40:15:30000:58': 72,
  'mem_40:15:30000:59': 72,
  'mem_40:15:30000:60': 72,
  'mem_40:15:30000:61': 80.4,
  'mem_40:15:30000:62': 80.4,
  'mem_40:15:30000:63': 80.4,
  'mem_40:15:30000:64': 80.4,
  'mem_40:15:30000:65': 80.4,
  'mem_40:15:30000:66': 116.4,
  'mem_40:15:30000:67': 116.4,
  'mem_40:15:30000:68': 116.4,
  'mem_40:15:30000:69': 116.4,
  'mem_40:15:30000:70': 116.4,
  'mem_40:15:30000:71': 160.8,
  'mem_40:15:30000:72': 160.8,
  'mem_40:15:30000:73': 160.8,
  'mem_40:15:30000:74': 160.8,
  'mem_40:15:30000:75': 160.8,
  'mem_40:15:30000:76': 220.8,
  'mem_40:15:30000:77': 220.8,
  'mem_40:15:30000:78': 220.8,
  'mem_40:15:30000:79': 220.8,
  'mem_40:15:30000:80': 220.8,
  'mem_40:15:30000:81': 312.71,
  'mem_40:15:30000:82': 312.71,
  'mem_40:15:30000:83': 312.71,
  'mem_40:15:30000:84': 312.71,
  'mem_40:15:30000:85': 312.71,
  'mem_40:15:30000:86': 434.94,
  'mem_40:15:30000:87': 434.94,
  'mem_40:15:30000:88': 434.94,
  'mem_40:15:30000:89': 434.94,
  'mem_40:15:30000:90': 434.94,
  'mem_40:15:30000:91': 605.29,
  'mem_40:15:30000:92': 605.29,
  'mem_40:15:30000:93': 605.29,
  'mem_40:15:30000:94': 605.29,
  'mem_40:15:30000:95': 605.29,
  'mem_40:15:30000:96': 992.76,
  'mem_40:15:30000:97': 992.76,
  'mem_40:15:30000:98': 992.76,
  'mem_40:15:30000:99': 992.76,
  'mem_40:15:30000:100': 992.76,
  'mem_40:15:40000:1': 8.4,
  'mem_40:15:40000:2': 8.4,
  'mem_40:15:40000:3': 8.4,
  'mem_40:15:40000:4': 8.4,
  'mem_40:15:40000:5': 8.4,
  'mem_40:15:40000:6': 8.4,
  'mem_40:15:40000:7': 8.4,
  'mem_40:15:40000:8': 8.4,
  'mem_40:15:40000:9': 8.4,
  'mem_40:15:40000:10': 8.4,
  'mem_40:15:40000:11': 8.4,
  'mem_40:15:40000:12': 8.4,
  'mem_40:15:40000:13': 8.4,
  'mem_40:15:40000:14': 8.4,
  'mem_40:15:40000:15': 8.4,
  'mem_40:15:40000:16': 9.6,
  'mem_40:15:40000:17': 9.6,
  'mem_40:15:40000:18': 9.6,
  'mem_40:15:40000:19': 9.6,
  'mem_40:15:40000:20': 9.6,
  'mem_40:15:40000:21': 9.6,
  'mem_40:15:40000:22': 9.6,
  'mem_40:15:40000:23': 9.6,
  'mem_40:15:40000:24': 9.6,
  'mem_40:15:40000:25': 9.6,
  'mem_40:15:40000:26': 12,
  'mem_40:15:40000:27': 12,
  'mem_40:15:40000:28': 12,
  'mem_40:15:40000:29': 12,
  'mem_40:15:40000:30': 12,
  'mem_40:15:40000:31': 16.8,
  'mem_40:15:40000:32': 16.8,
  'mem_40:15:40000:33': 16.8,
  'mem_40:15:40000:34': 16.8,
  'mem_40:15:40000:35': 16.8,
  'mem_40:15:40000:36': 24,
  'mem_40:15:40000:37': 24,
  'mem_40:15:40000:38': 24,
  'mem_40:15:40000:39': 24,
  'mem_40:15:40000:40': 24,
  'mem_40:15:40000:41': 38.4,
  'mem_40:15:40000:42': 38.4,
  'mem_40:15:40000:43': 38.4,
  'mem_40:15:40000:44': 38.4,
  'mem_40:15:40000:45': 38.4,
  'mem_40:15:40000:46': 58.8,
  'mem_40:15:40000:47': 58.8,
  'mem_40:15:40000:48': 58.8,
  'mem_40:15:40000:49': 58.8,
  'mem_40:15:40000:50': 58.8,
  'mem_40:15:40000:51': 87.6,
  'mem_40:15:40000:52': 87.6,
  'mem_40:15:40000:53': 87.6,
  'mem_40:15:40000:54': 87.6,
  'mem_40:15:40000:55': 87.6,
  'mem_40:15:40000:56': 97.2,
  'mem_40:15:40000:57': 97.2,
  'mem_40:15:40000:58': 97.2,
  'mem_40:15:40000:59': 97.2,
  'mem_40:15:40000:60': 97.2,
  'mem_40:15:40000:61': 106.8,
  'mem_40:15:40000:62': 106.8,
  'mem_40:15:40000:63': 106.8,
  'mem_40:15:40000:64': 106.8,
  'mem_40:15:40000:65': 106.8,
  'mem_40:15:40000:66': 154.8,
  'mem_40:15:40000:67': 154.8,
  'mem_40:15:40000:68': 154.8,
  'mem_40:15:40000:69': 154.8,
  'mem_40:15:40000:70': 154.8,
  'mem_40:15:40000:71': 213.6,
  'mem_40:15:40000:72': 213.6,
  'mem_40:15:40000:73': 213.6,
  'mem_40:15:40000:74': 213.6,
  'mem_40:15:40000:75': 213.6,
  'mem_40:15:40000:76': 294,
  'mem_40:15:40000:77': 294,
  'mem_40:15:40000:78': 294,
  'mem_40:15:40000:79': 294,
  'mem_40:15:40000:80': 294,
  'mem_40:15:40000:81': 417.24,
  'mem_40:15:40000:82': 417.24,
  'mem_40:15:40000:83': 417.24,
  'mem_40:15:40000:84': 417.24,
  'mem_40:15:40000:85': 417.24,
  'mem_40:15:40000:86': 580.3,
  'mem_40:15:40000:87': 580.3,
  'mem_40:15:40000:88': 580.3,
  'mem_40:15:40000:89': 580.3,
  'mem_40:15:40000:90': 580.3,
  'mem_40:15:40000:91': 807.58,
  'mem_40:15:40000:92': 807.58,
  'mem_40:15:40000:93': 807.58,
  'mem_40:15:40000:94': 807.58,
  'mem_40:15:40000:95': 807.58,
  'mem_40:15:40000:96': 1324.5,
  'mem_40:15:40000:97': 1324.5,
  'mem_40:15:40000:98': 1324.5,
  'mem_40:15:40000:99': 1324.5,
  'mem_40:15:40000:100': 1324.5,
  'mem_40:15:50000:1': 10.8,
  'mem_40:15:50000:2': 10.8,
  'mem_40:15:50000:3': 10.8,
  'mem_40:15:50000:4': 10.8,
  'mem_40:15:50000:5': 10.8,
  'mem_40:15:50000:6': 10.8,
  'mem_40:15:50000:7': 10.8,
  'mem_40:15:50000:8': 10.8,
  'mem_40:15:50000:9': 10.8,
  'mem_40:15:50000:10': 10.8,
  'mem_40:15:50000:11': 10.8,
  'mem_40:15:50000:12': 10.8,
  'mem_40:15:50000:13': 10.8,
  'mem_40:15:50000:14': 10.8,
  'mem_40:15:50000:15': 10.8,
  'mem_40:15:50000:16': 10.8,
  'mem_40:15:50000:17': 10.8,
  'mem_40:15:50000:18': 10.8,
  'mem_40:15:50000:19': 10.8,
  'mem_40:15:50000:20': 10.8,
  'mem_40:15:50000:21': 12,
  'mem_40:15:50000:22': 12,
  'mem_40:15:50000:23': 12,
  'mem_40:15:50000:24': 12,
  'mem_40:15:50000:25': 12,
  'mem_40:15:50000:26': 14.4,
  'mem_40:15:50000:27': 14.4,
  'mem_40:15:50000:28': 14.4,
  'mem_40:15:50000:29': 14.4,
  'mem_40:15:50000:30': 14.4,
  'mem_40:15:50000:31': 20.4,
  'mem_40:15:50000:32': 20.4,
  'mem_40:15:50000:33': 20.4,
  'mem_40:15:50000:34': 20.4,
  'mem_40:15:50000:35': 20.4,
  'mem_40:15:50000:36': 30,
  'mem_40:15:50000:37': 30,
  'mem_40:15:50000:38': 30,
  'mem_40:15:50000:39': 30,
  'mem_40:15:50000:40': 30,
  'mem_40:15:50000:41': 46.8,
  'mem_40:15:50000:42': 46.8,
  'mem_40:15:50000:43': 46.8,
  'mem_40:15:50000:44': 46.8,
  'mem_40:15:50000:45': 46.8,
  'mem_40:15:50000:46': 73.2,
  'mem_40:15:50000:47': 73.2,
  'mem_40:15:50000:48': 73.2,
  'mem_40:15:50000:49': 73.2,
  'mem_40:15:50000:50': 73.2,
  'mem_40:15:50000:51': 110.4,
  'mem_40:15:50000:52': 110.4,
  'mem_40:15:50000:53': 110.4,
  'mem_40:15:50000:54': 110.4,
  'mem_40:15:50000:55': 110.4,
  'mem_40:15:50000:56': 121.2,
  'mem_40:15:50000:57': 121.2,
  'mem_40:15:50000:58': 121.2,
  'mem_40:15:50000:59': 121.2,
  'mem_40:15:50000:60': 121.2,
  'mem_40:15:50000:61': 133.2,
  'mem_40:15:50000:62': 133.2,
  'mem_40:15:50000:63': 133.2,
  'mem_40:15:50000:64': 133.2,
  'mem_40:15:50000:65': 133.2,
  'mem_40:15:50000:66': 193.2,
  'mem_40:15:50000:67': 193.2,
  'mem_40:15:50000:68': 193.2,
  'mem_40:15:50000:69': 193.2,
  'mem_40:15:50000:70': 193.2,
  'mem_40:15:50000:71': 267.6,
  'mem_40:15:50000:72': 267.6,
  'mem_40:15:50000:73': 267.6,
  'mem_40:15:50000:74': 267.6,
  'mem_40:15:50000:75': 267.6,
  'mem_40:15:50000:76': 367.2,
  'mem_40:15:50000:77': 367.2,
  'mem_40:15:50000:78': 367.2,
  'mem_40:15:50000:79': 367.2,
  'mem_40:15:50000:80': 367.2,
  'mem_40:15:50000:81': 521.72,
  'mem_40:15:50000:82': 521.72,
  'mem_40:15:50000:83': 521.72,
  'mem_40:15:50000:84': 521.72,
  'mem_40:15:50000:85': 521.72,
  'mem_40:15:50000:86': 725.58,
  'mem_40:15:50000:87': 725.58,
  'mem_40:15:50000:88': 725.58,
  'mem_40:15:50000:89': 725.58,
  'mem_40:15:50000:90': 725.58,
  'mem_40:15:50000:91': 1009.74,
  'mem_40:15:50000:92': 1009.74,
  'mem_40:15:50000:93': 1009.74,
  'mem_40:15:50000:94': 1009.74,
  'mem_40:15:50000:95': 1009.74,
  'mem_40:15:50000:96': 1656.04,
  'mem_40:15:50000:97': 1656.04,
  'mem_40:15:50000:98': 1656.04,
  'mem_40:15:50000:99': 1656.04,
  'mem_40:15:50000:100': 1656.04,
  'mem_40:15:60000:1': 11.52,
  'mem_40:15:60000:2': 11.52,
  'mem_40:15:60000:3': 11.52,
  'mem_40:15:60000:4': 11.52,
  'mem_40:15:60000:5': 11.52,
  'mem_40:15:60000:6': 11.51,
  'mem_40:15:60000:7': 11.51,
  'mem_40:15:60000:8': 11.51,
  'mem_40:15:60000:9': 11.51,
  'mem_40:15:60000:10': 11.51,
  'mem_40:15:60000:11': 11.52,
  'mem_40:15:60000:12': 11.52,
  'mem_40:15:60000:13': 11.52,
  'mem_40:15:60000:14': 11.52,
  'mem_40:15:60000:15': 11.52,
  'mem_40:15:60000:16': 11.61,
  'mem_40:15:60000:17': 11.61,
  'mem_40:15:60000:18': 11.61,
  'mem_40:15:60000:19': 11.61,
  'mem_40:15:60000:20': 11.61,
  'mem_40:15:60000:21': 12.68,
  'mem_40:15:60000:22': 12.68,
  'mem_40:15:60000:23': 12.68,
  'mem_40:15:60000:24': 12.68,
  'mem_40:15:60000:25': 12.68,
  'mem_40:15:60000:26': 14.95,
  'mem_40:15:60000:27': 14.95,
  'mem_40:15:60000:28': 14.95,
  'mem_40:15:60000:29': 14.95,
  'mem_40:15:60000:30': 14.95,
  'mem_40:15:60000:31': 20.5,
  'mem_40:15:60000:32': 20.5,
  'mem_40:15:60000:33': 20.5,
  'mem_40:15:60000:34': 20.5,
  'mem_40:15:60000:35': 20.5,
  'mem_40:15:60000:36': 29.93,
  'mem_40:15:60000:37': 29.93,
  'mem_40:15:60000:38': 29.93,
  'mem_40:15:60000:39': 29.93,
  'mem_40:15:60000:40': 29.93,
  'mem_40:15:60000:41': 46.45,
  'mem_40:15:60000:42': 46.45,
  'mem_40:15:60000:43': 46.45,
  'mem_40:15:60000:44': 46.45,
  'mem_40:15:60000:45': 46.45,
  'mem_40:15:60000:46': 72.04,
  'mem_40:15:60000:47': 72.04,
  'mem_40:15:60000:48': 72.04,
  'mem_40:15:60000:49': 72.04,
  'mem_40:15:60000:50': 72.04,
  'mem_40:15:60000:51': 108.53,
  'mem_40:15:60000:52': 108.53,
  'mem_40:15:60000:53': 108.53,
  'mem_40:15:60000:54': 108.53,
  'mem_40:15:60000:55': 108.53,
  'mem_40:15:60000:56': 130.29,
  'mem_40:15:60000:57': 130.29,
  'mem_40:15:60000:58': 130.29,
  'mem_40:15:60000:59': 130.29,
  'mem_40:15:60000:60': 130.29,
  'mem_40:15:60000:61': 157.74,
  'mem_40:15:60000:62': 157.74,
  'mem_40:15:60000:63': 157.74,
  'mem_40:15:60000:64': 157.74,
  'mem_40:15:60000:65': 157.74,
  'mem_40:15:60000:66': 229.43,
  'mem_40:15:60000:67': 229.43,
  'mem_40:15:60000:68': 229.43,
  'mem_40:15:60000:69': 229.43,
  'mem_40:15:60000:70': 229.43,
  'mem_40:15:60000:71': 305.59,
  'mem_40:15:60000:72': 305.59,
  'mem_40:15:60000:73': 305.59,
  'mem_40:15:60000:74': 305.59,
  'mem_40:15:60000:75': 305.59,
  'mem_40:15:60000:76': 430.48,
  'mem_40:15:60000:77': 430.48,
  'mem_40:15:60000:78': 430.48,
  'mem_40:15:60000:79': 430.48,
  'mem_40:15:60000:80': 430.48,
  'mem_40:15:60000:81': 625.42,
  'mem_40:15:60000:82': 625.42,
  'mem_40:15:60000:83': 625.42,
  'mem_40:15:60000:84': 625.42,
  'mem_40:15:60000:85': 625.42,
  'mem_40:15:60000:86': 869.87,
  'mem_40:15:60000:87': 869.87,
  'mem_40:15:60000:88': 869.87,
  'mem_40:15:60000:89': 869.87,
  'mem_40:15:60000:90': 869.87,
  'mem_40:15:60000:91': 1210.59,
  'mem_40:15:60000:92': 1210.59,
  'mem_40:15:60000:93': 1210.59,
  'mem_40:15:60000:94': 1210.59,
  'mem_40:15:60000:95': 1210.59,
  'mem_40:15:60000:96': 1985.51,
  'mem_40:15:60000:97': 1985.51,
  'mem_40:15:60000:98': 1985.51,
  'mem_40:15:60000:99': 1985.51,
  'mem_40:15:60000:100': 1985.51,
  'mem_40:15:70000:1': 12.25,
  'mem_40:15:70000:2': 12.25,
  'mem_40:15:70000:3': 12.25,
  'mem_40:15:70000:4': 12.25,
  'mem_40:15:70000:5': 12.25,
  'mem_40:15:70000:6': 12.21,
  'mem_40:15:70000:7': 12.21,
  'mem_40:15:70000:8': 12.21,
  'mem_40:15:70000:9': 12.21,
  'mem_40:15:70000:10': 12.21,
  'mem_40:15:70000:11': 12.25,
  'mem_40:15:70000:12': 12.25,
  'mem_40:15:70000:13': 12.25,
  'mem_40:15:70000:14': 12.25,
  'mem_40:15:70000:15': 12.25,
  'mem_40:15:70000:16': 12.42,
  'mem_40:15:70000:17': 12.42,
  'mem_40:15:70000:18': 12.42,
  'mem_40:15:70000:19': 12.42,
  'mem_40:15:70000:20': 12.42,
  'mem_40:15:70000:21': 13.35,
  'mem_40:15:70000:22': 13.35,
  'mem_40:15:70000:23': 13.35,
  'mem_40:15:70000:24': 13.35,
  'mem_40:15:70000:25': 13.35,
  'mem_40:15:70000:26': 15.51,
  'mem_40:15:70000:27': 15.51,
  'mem_40:15:70000:28': 15.51,
  'mem_40:15:70000:29': 15.51,
  'mem_40:15:70000:30': 15.51,
  'mem_40:15:70000:31': 20.6,
  'mem_40:15:70000:32': 20.6,
  'mem_40:15:70000:33': 20.6,
  'mem_40:15:70000:34': 20.6,
  'mem_40:15:70000:35': 20.6,
  'mem_40:15:70000:36': 29.86,
  'mem_40:15:70000:37': 29.86,
  'mem_40:15:70000:38': 29.86,
  'mem_40:15:70000:39': 29.86,
  'mem_40:15:70000:40': 29.86,
  'mem_40:15:70000:41': 46.09,
  'mem_40:15:70000:42': 46.09,
  'mem_40:15:70000:43': 46.09,
  'mem_40:15:70000:44': 46.09,
  'mem_40:15:70000:45': 46.09,
  'mem_40:15:70000:46': 70.88,
  'mem_40:15:70000:47': 70.88,
  'mem_40:15:70000:48': 70.88,
  'mem_40:15:70000:49': 70.88,
  'mem_40:15:70000:50': 70.88,
  'mem_40:15:70000:51': 106.66,
  'mem_40:15:70000:52': 106.66,
  'mem_40:15:70000:53': 106.66,
  'mem_40:15:70000:54': 106.66,
  'mem_40:15:70000:55': 106.66,
  'mem_40:15:70000:56': 139.37,
  'mem_40:15:70000:57': 139.37,
  'mem_40:15:70000:58': 139.37,
  'mem_40:15:70000:59': 139.37,
  'mem_40:15:70000:60': 139.37,
  'mem_40:15:70000:61': 184.17,
  'mem_40:15:70000:62': 184.17,
  'mem_40:15:70000:63': 184.17,
  'mem_40:15:70000:64': 184.17,
  'mem_40:15:70000:65': 184.17,
  'mem_40:15:70000:66': 267.87,
  'mem_40:15:70000:67': 267.87,
  'mem_40:15:70000:68': 267.87,
  'mem_40:15:70000:69': 267.87,
  'mem_40:15:70000:70': 267.87,
  'mem_40:15:70000:71': 356.77,
  'mem_40:15:70000:72': 356.77,
  'mem_40:15:70000:73': 356.77,
  'mem_40:15:70000:74': 356.77,
  'mem_40:15:70000:75': 356.77,
  'mem_40:15:70000:76': 502.57,
  'mem_40:15:70000:77': 502.57,
  'mem_40:15:70000:78': 502.57,
  'mem_40:15:70000:79': 502.57,
  'mem_40:15:70000:80': 502.57,
  'mem_40:15:70000:81': 730.16,
  'mem_40:15:70000:82': 730.16,
  'mem_40:15:70000:83': 730.16,
  'mem_40:15:70000:84': 730.16,
  'mem_40:15:70000:85': 730.16,
  'mem_40:15:70000:86': 1015.5,
  'mem_40:15:70000:87': 1015.5,
  'mem_40:15:70000:88': 1015.5,
  'mem_40:15:70000:89': 1015.5,
  'mem_40:15:70000:90': 1015.5,
  'mem_40:15:70000:91': 1413.22,
  'mem_40:15:70000:92': 1413.22,
  'mem_40:15:70000:93': 1413.22,
  'mem_40:15:70000:94': 1413.22,
  'mem_40:15:70000:95': 1413.22,
  'mem_40:15:70000:96': 2317.79,
  'mem_40:15:70000:97': 2317.79,
  'mem_40:15:70000:98': 2317.79,
  'mem_40:15:70000:99': 2317.79,
  'mem_40:15:70000:100': 2317.79,
  'mem_40:15:80000:1': 12.97,
  'mem_40:15:80000:2': 12.97,
  'mem_40:15:80000:3': 12.97,
  'mem_40:15:80000:4': 12.97,
  'mem_40:15:80000:5': 12.97,
  'mem_40:15:80000:6': 12.92,
  'mem_40:15:80000:7': 12.92,
  'mem_40:15:80000:8': 12.92,
  'mem_40:15:80000:9': 12.92,
  'mem_40:15:80000:10': 12.92,
  'mem_40:15:80000:11': 12.97,
  'mem_40:15:80000:12': 12.97,
  'mem_40:15:80000:13': 12.97,
  'mem_40:15:80000:14': 12.97,
  'mem_40:15:80000:15': 12.97,
  'mem_40:15:80000:16': 13.23,
  'mem_40:15:80000:17': 13.23,
  'mem_40:15:80000:18': 13.23,
  'mem_40:15:80000:19': 13.23,
  'mem_40:15:80000:20': 13.23,
  'mem_40:15:80000:21': 14.03,
  'mem_40:15:80000:22': 14.03,
  'mem_40:15:80000:23': 14.03,
  'mem_40:15:80000:24': 14.03,
  'mem_40:15:80000:25': 14.03,
  'mem_40:15:80000:26': 16.06,
  'mem_40:15:80000:27': 16.06,
  'mem_40:15:80000:28': 16.06,
  'mem_40:15:80000:29': 16.06,
  'mem_40:15:80000:30': 16.06,
  'mem_40:15:80000:31': 20.7,
  'mem_40:15:80000:32': 20.7,
  'mem_40:15:80000:33': 20.7,
  'mem_40:15:80000:34': 20.7,
  'mem_40:15:80000:35': 20.7,
  'mem_40:15:80000:36': 29.79,
  'mem_40:15:80000:37': 29.79,
  'mem_40:15:80000:38': 29.79,
  'mem_40:15:80000:39': 29.79,
  'mem_40:15:80000:40': 29.79,
  'mem_40:15:80000:41': 45.74,
  'mem_40:15:80000:42': 45.74,
  'mem_40:15:80000:43': 45.74,
  'mem_40:15:80000:44': 45.74,
  'mem_40:15:80000:45': 45.74,
  'mem_40:15:80000:46': 69.72,
  'mem_40:15:80000:47': 69.72,
  'mem_40:15:80000:48': 69.72,
  'mem_40:15:80000:49': 69.72,
  'mem_40:15:80000:50': 69.72,
  'mem_40:15:80000:51': 104.79,
  'mem_40:15:80000:52': 104.79,
  'mem_40:15:80000:53': 104.79,
  'mem_40:15:80000:54': 104.79,
  'mem_40:15:80000:55': 104.79,
  'mem_40:15:80000:56': 148.46,
  'mem_40:15:80000:57': 148.46,
  'mem_40:15:80000:58': 148.46,
  'mem_40:15:80000:59': 148.46,
  'mem_40:15:80000:60': 148.46,
  'mem_40:15:80000:61': 210.54,
  'mem_40:15:80000:62': 210.54,
  'mem_40:15:80000:63': 210.54,
  'mem_40:15:80000:64': 210.54,
  'mem_40:15:80000:65': 210.54,
  'mem_40:15:80000:66': 306.23,
  'mem_40:15:80000:67': 306.23,
  'mem_40:15:80000:68': 306.23,
  'mem_40:15:80000:69': 306.23,
  'mem_40:15:80000:70': 306.23,
  'mem_40:15:80000:71': 407.85,
  'mem_40:15:80000:72': 407.85,
  'mem_40:15:80000:73': 407.85,
  'mem_40:15:80000:74': 407.85,
  'mem_40:15:80000:75': 407.85,
  'mem_40:15:80000:76': 574.53,
  'mem_40:15:80000:77': 574.53,
  'mem_40:15:80000:78': 574.53,
  'mem_40:15:80000:79': 574.53,
  'mem_40:15:80000:80': 574.53,
  'mem_40:15:80000:81': 834.71,
  'mem_40:15:80000:82': 834.71,
  'mem_40:15:80000:83': 834.71,
  'mem_40:15:80000:84': 834.71,
  'mem_40:15:80000:85': 834.71,
  'mem_40:15:80000:86': 1160.88,
  'mem_40:15:80000:87': 1160.88,
  'mem_40:15:80000:88': 1160.88,
  'mem_40:15:80000:89': 1160.88,
  'mem_40:15:80000:90': 1160.88,
  'mem_40:15:80000:91': 1615.51,
  'mem_40:15:80000:92': 1615.51,
  'mem_40:15:80000:93': 1615.51,
  'mem_40:15:80000:94': 1615.51,
  'mem_40:15:80000:95': 1615.51,
  'mem_40:15:80000:96': 2649.54,
  'mem_40:15:80000:97': 2649.54,
  'mem_40:15:80000:98': 2649.54,
  'mem_40:15:80000:99': 2649.54,
  'mem_40:15:80000:100': 2649.54,
  'mem_40:15:90000:1': 14.57,
  'mem_40:15:90000:2': 14.57,
  'mem_40:15:90000:3': 14.57,
  'mem_40:15:90000:4': 14.57,
  'mem_40:15:90000:5': 14.57,
  'mem_40:15:90000:6': 14.52,
  'mem_40:15:90000:7': 14.52,
  'mem_40:15:90000:8': 14.52,
  'mem_40:15:90000:9': 14.52,
  'mem_40:15:90000:10': 14.52,
  'mem_40:15:90000:11': 14.58,
  'mem_40:15:90000:12': 14.58,
  'mem_40:15:90000:13': 14.58,
  'mem_40:15:90000:14': 14.58,
  'mem_40:15:90000:15': 14.58,
  'mem_40:15:90000:16': 14.87,
  'mem_40:15:90000:17': 14.87,
  'mem_40:15:90000:18': 14.87,
  'mem_40:15:90000:19': 14.87,
  'mem_40:15:90000:20': 14.87,
  'mem_40:15:90000:21': 15.76,
  'mem_40:15:90000:22': 15.76,
  'mem_40:15:90000:23': 15.76,
  'mem_40:15:90000:24': 15.76,
  'mem_40:15:90000:25': 15.76,
  'mem_40:15:90000:26': 18.05,
  'mem_40:15:90000:27': 18.05,
  'mem_40:15:90000:28': 18.05,
  'mem_40:15:90000:29': 18.05,
  'mem_40:15:90000:30': 18.05,
  'mem_40:15:90000:31': 23.26,
  'mem_40:15:90000:32': 23.26,
  'mem_40:15:90000:33': 23.26,
  'mem_40:15:90000:34': 23.26,
  'mem_40:15:90000:35': 23.26,
  'mem_40:15:90000:36': 33.46,
  'mem_40:15:90000:37': 33.46,
  'mem_40:15:90000:38': 33.46,
  'mem_40:15:90000:39': 33.46,
  'mem_40:15:90000:40': 33.46,
  'mem_40:15:90000:41': 51.43,
  'mem_40:15:90000:42': 51.43,
  'mem_40:15:90000:43': 51.43,
  'mem_40:15:90000:44': 51.43,
  'mem_40:15:90000:45': 51.43,
  'mem_40:15:90000:46': 78.37,
  'mem_40:15:90000:47': 78.37,
  'mem_40:15:90000:48': 78.37,
  'mem_40:15:90000:49': 78.37,
  'mem_40:15:90000:50': 78.37,
  'mem_40:15:90000:51': 117.72,
  'mem_40:15:90000:52': 117.72,
  'mem_40:15:90000:53': 117.72,
  'mem_40:15:90000:54': 117.72,
  'mem_40:15:90000:55': 117.72,
  'mem_40:15:90000:56': 166.78,
  'mem_40:15:90000:57': 166.78,
  'mem_40:15:90000:58': 166.78,
  'mem_40:15:90000:59': 166.78,
  'mem_40:15:90000:60': 166.78,
  'mem_40:15:90000:61': 236.51,
  'mem_40:15:90000:62': 236.51,
  'mem_40:15:90000:63': 236.51,
  'mem_40:15:90000:64': 236.51,
  'mem_40:15:90000:65': 236.51,
  'mem_40:15:90000:66': 343.99,
  'mem_40:15:90000:67': 343.99,
  'mem_40:15:90000:68': 343.99,
  'mem_40:15:90000:69': 343.99,
  'mem_40:15:90000:70': 343.99,
  'mem_40:15:90000:71': 458.18,
  'mem_40:15:90000:72': 458.18,
  'mem_40:15:90000:73': 458.18,
  'mem_40:15:90000:74': 458.18,
  'mem_40:15:90000:75': 458.18,
  'mem_40:15:90000:76': 645.42,
  'mem_40:15:90000:77': 645.42,
  'mem_40:15:90000:78': 645.42,
  'mem_40:15:90000:79': 645.42,
  'mem_40:15:90000:80': 645.42,
  'mem_40:15:90000:81': 937.71,
  'mem_40:15:90000:82': 937.71,
  'mem_40:15:90000:83': 937.71,
  'mem_40:15:90000:84': 937.71,
  'mem_40:15:90000:85': 937.71,
  'mem_40:15:90000:86': 1304.2,
  'mem_40:15:90000:87': 1304.2,
  'mem_40:15:90000:88': 1304.2,
  'mem_40:15:90000:89': 1304.2,
  'mem_40:15:90000:90': 1304.2,
  'mem_40:15:90000:91': 1815.03,
  'mem_40:15:90000:92': 1815.03,
  'mem_40:15:90000:93': 1815.03,
  'mem_40:15:90000:94': 1815.03,
  'mem_40:15:90000:95': 1815.03,
  'mem_40:15:90000:96': 2976.86,
  'mem_40:15:90000:97': 2976.86,
  'mem_40:15:90000:98': 2976.86,
  'mem_40:15:90000:99': 2976.86,
  'mem_40:15:90000:100': 2976.86,
  'mem_40:15:100000:1': 16.2,
  'mem_40:15:100000:2': 16.2,
  'mem_40:15:100000:3': 16.2,
  'mem_40:15:100000:4': 16.2,
  'mem_40:15:100000:5': 16.2,
  'mem_40:15:100000:6': 16.14,
  'mem_40:15:100000:7': 16.14,
  'mem_40:15:100000:8': 16.14,
  'mem_40:15:100000:9': 16.14,
  'mem_40:15:100000:10': 16.14,
  'mem_40:15:100000:11': 16.2,
  'mem_40:15:100000:12': 16.2,
  'mem_40:15:100000:13': 16.2,
  'mem_40:15:100000:14': 16.2,
  'mem_40:15:100000:15': 16.2,
  'mem_40:15:100000:16': 16.53,
  'mem_40:15:100000:17': 16.53,
  'mem_40:15:100000:18': 16.53,
  'mem_40:15:100000:19': 16.53,
  'mem_40:15:100000:20': 16.53,
  'mem_40:15:100000:21': 17.52,
  'mem_40:15:100000:22': 17.52,
  'mem_40:15:100000:23': 17.52,
  'mem_40:15:100000:24': 17.52,
  'mem_40:15:100000:25': 17.52,
  'mem_40:15:100000:26': 20.06,
  'mem_40:15:100000:27': 20.06,
  'mem_40:15:100000:28': 20.06,
  'mem_40:15:100000:29': 20.06,
  'mem_40:15:100000:30': 20.06,
  'mem_40:15:100000:31': 25.86,
  'mem_40:15:100000:32': 25.86,
  'mem_40:15:100000:33': 25.86,
  'mem_40:15:100000:34': 25.86,
  'mem_40:15:100000:35': 25.86,
  'mem_40:15:100000:36': 37.2,
  'mem_40:15:100000:37': 37.2,
  'mem_40:15:100000:38': 37.2,
  'mem_40:15:100000:39': 37.2,
  'mem_40:15:100000:40': 37.2,
  'mem_40:15:100000:41': 57.15,
  'mem_40:15:100000:42': 57.15,
  'mem_40:15:100000:43': 57.15,
  'mem_40:15:100000:44': 57.15,
  'mem_40:15:100000:45': 57.15,
  'mem_40:15:100000:46': 87.11,
  'mem_40:15:100000:47': 87.11,
  'mem_40:15:100000:48': 87.11,
  'mem_40:15:100000:49': 87.11,
  'mem_40:15:100000:50': 87.11,
  'mem_40:15:100000:51': 130.86,
  'mem_40:15:100000:52': 130.86,
  'mem_40:15:100000:53': 130.86,
  'mem_40:15:100000:54': 130.86,
  'mem_40:15:100000:55': 130.86,
  'mem_40:15:100000:56': 185.39,
  'mem_40:15:100000:57': 185.39,
  'mem_40:15:100000:58': 185.39,
  'mem_40:15:100000:59': 185.39,
  'mem_40:15:100000:60': 185.39,
  'mem_40:15:100000:61': 262.92,
  'mem_40:15:100000:62': 262.92,
  'mem_40:15:100000:63': 262.92,
  'mem_40:15:100000:64': 262.92,
  'mem_40:15:100000:65': 262.92,
  'mem_40:15:100000:66': 382.38,
  'mem_40:15:100000:67': 382.38,
  'mem_40:15:100000:68': 382.38,
  'mem_40:15:100000:69': 382.38,
  'mem_40:15:100000:70': 382.38,
  'mem_40:15:100000:71': 509.33,
  'mem_40:15:100000:72': 509.33,
  'mem_40:15:100000:73': 509.33,
  'mem_40:15:100000:74': 509.33,
  'mem_40:15:100000:75': 509.33,
  'mem_40:15:100000:76': 717.49,
  'mem_40:15:100000:77': 717.49,
  'mem_40:15:100000:78': 717.49,
  'mem_40:15:100000:79': 717.49,
  'mem_40:15:100000:80': 717.49,
  'mem_40:15:100000:81': 1042.41,
  'mem_40:15:100000:82': 1042.41,
  'mem_40:15:100000:83': 1042.41,
  'mem_40:15:100000:84': 1042.41,
  'mem_40:15:100000:85': 1042.41,
  'mem_40:15:100000:86': 1449.84,
  'mem_40:15:100000:87': 1449.84,
  'mem_40:15:100000:88': 1449.84,
  'mem_40:15:100000:89': 1449.84,
  'mem_40:15:100000:90': 1449.84,
  'mem_40:15:100000:91': 2017.71,
  'mem_40:15:100000:92': 2017.71,
  'mem_40:15:100000:93': 2017.71,
  'mem_40:15:100000:94': 2017.71,
  'mem_40:15:100000:95': 2017.71,
  'mem_40:15:100000:96': 3309.27,
  'mem_40:15:100000:97': 3309.27,
  'mem_40:15:100000:98': 3309.27,
  'mem_40:15:100000:99': 3309.27,
  'mem_40:15:100000:100': 3309.27,
  'mem_40:15:120000:1': 19.44,
  'mem_40:15:120000:2': 19.44,
  'mem_40:15:120000:3': 19.44,
  'mem_40:15:120000:4': 19.44,
  'mem_40:15:120000:5': 19.44,
  'mem_40:15:120000:6': 19.36,
  'mem_40:15:120000:7': 19.36,
  'mem_40:15:120000:8': 19.36,
  'mem_40:15:120000:9': 19.36,
  'mem_40:15:120000:10': 19.36,
  'mem_40:15:120000:11': 19.44,
  'mem_40:15:120000:12': 19.44,
  'mem_40:15:120000:13': 19.44,
  'mem_40:15:120000:14': 19.44,
  'mem_40:15:120000:15': 19.44,
  'mem_40:15:120000:16': 19.83,
  'mem_40:15:120000:17': 19.83,
  'mem_40:15:120000:18': 19.83,
  'mem_40:15:120000:19': 19.83,
  'mem_40:15:120000:20': 19.83,
  'mem_40:15:120000:21': 21.02,
  'mem_40:15:120000:22': 21.02,
  'mem_40:15:120000:23': 21.02,
  'mem_40:15:120000:24': 21.02,
  'mem_40:15:120000:25': 21.02,
  'mem_40:15:120000:26': 24.07,
  'mem_40:15:120000:27': 24.07,
  'mem_40:15:120000:28': 24.07,
  'mem_40:15:120000:29': 24.07,
  'mem_40:15:120000:30': 24.07,
  'mem_40:15:120000:31': 31.02,
  'mem_40:15:120000:32': 31.02,
  'mem_40:15:120000:33': 31.02,
  'mem_40:15:120000:34': 31.02,
  'mem_40:15:120000:35': 31.02,
  'mem_40:15:120000:36': 44.63,
  'mem_40:15:120000:37': 44.63,
  'mem_40:15:120000:38': 44.63,
  'mem_40:15:120000:39': 44.63,
  'mem_40:15:120000:40': 44.63,
  'mem_40:15:120000:41': 68.51,
  'mem_40:15:120000:42': 68.51,
  'mem_40:15:120000:43': 68.51,
  'mem_40:15:120000:44': 68.51,
  'mem_40:15:120000:45': 68.51,
  'mem_40:15:120000:46': 104.45,
  'mem_40:15:120000:47': 104.45,
  'mem_40:15:120000:48': 104.45,
  'mem_40:15:120000:49': 104.45,
  'mem_40:15:120000:50': 104.45,
  'mem_40:15:120000:51': 157.02,
  'mem_40:15:120000:52': 157.02,
  'mem_40:15:120000:53': 157.02,
  'mem_40:15:120000:54': 157.02,
  'mem_40:15:120000:55': 157.02,
  'mem_40:15:120000:56': 222.45,
  'mem_40:15:120000:57': 222.45,
  'mem_40:15:120000:58': 222.45,
  'mem_40:15:120000:59': 222.45,
  'mem_40:15:120000:60': 222.45,
  'mem_40:15:120000:61': 315.47,
  'mem_40:15:120000:62': 315.47,
  'mem_40:15:120000:63': 315.47,
  'mem_40:15:120000:64': 315.47,
  'mem_40:15:120000:65': 315.47,
  'mem_40:15:120000:66': 458.84,
  'mem_40:15:120000:67': 458.84,
  'mem_40:15:120000:68': 458.84,
  'mem_40:15:120000:69': 458.84,
  'mem_40:15:120000:70': 458.84,
  'mem_40:15:120000:71': 611.16,
  'mem_40:15:120000:72': 611.16,
  'mem_40:15:120000:73': 611.16,
  'mem_40:15:120000:74': 611.16,
  'mem_40:15:120000:75': 611.16,
  'mem_40:15:120000:76': 860.93,
  'mem_40:15:120000:77': 860.93,
  'mem_40:15:120000:78': 860.93,
  'mem_40:15:120000:79': 860.93,
  'mem_40:15:120000:80': 860.93,
  'mem_40:15:120000:81': 1250.81,
  'mem_40:15:120000:82': 1250.81,
  'mem_40:15:120000:83': 1250.81,
  'mem_40:15:120000:84': 1250.81,
  'mem_40:15:120000:85': 1250.81,
  'mem_40:15:120000:86': 1739.69,
  'mem_40:15:120000:87': 1739.69,
  'mem_40:15:120000:88': 1739.69,
  'mem_40:15:120000:89': 1739.69,
  'mem_40:15:120000:90': 1739.69,
  'mem_40:15:120000:91': 2421.12,
  'mem_40:15:120000:92': 2421.12,
  'mem_40:15:120000:93': 2421.12,
  'mem_40:15:120000:94': 2421.12,
  'mem_40:15:120000:95': 2421.12,
  'mem_40:15:120000:96': 3970.93,
  'mem_40:15:120000:97': 3970.93,
  'mem_40:15:120000:98': 3970.93,
  'mem_40:15:120000:99': 3970.93,
  'mem_40:15:120000:100': 3970.93,
  'mem_40:15:140000:1': 22.7,
  'mem_40:15:140000:2': 22.7,
  'mem_40:15:140000:3': 22.7,
  'mem_40:15:140000:4': 22.7,
  'mem_40:15:140000:5': 22.7,
  'mem_40:15:140000:6': 22.61,
  'mem_40:15:140000:7': 22.61,
  'mem_40:15:140000:8': 22.61,
  'mem_40:15:140000:9': 22.61,
  'mem_40:15:140000:10': 22.61,
  'mem_40:15:140000:11': 22.7,
  'mem_40:15:140000:12': 22.7,
  'mem_40:15:140000:13': 22.7,
  'mem_40:15:140000:14': 22.7,
  'mem_40:15:140000:15': 22.7,
  'mem_40:15:140000:16': 23.15,
  'mem_40:15:140000:17': 23.15,
  'mem_40:15:140000:18': 23.15,
  'mem_40:15:140000:19': 23.15,
  'mem_40:15:140000:20': 23.15,
  'mem_40:15:140000:21': 24.54,
  'mem_40:15:140000:22': 24.54,
  'mem_40:15:140000:23': 24.54,
  'mem_40:15:140000:24': 24.54,
  'mem_40:15:140000:25': 24.54,
  'mem_40:15:140000:26': 28.1,
  'mem_40:15:140000:27': 28.1,
  'mem_40:15:140000:28': 28.1,
  'mem_40:15:140000:29': 28.1,
  'mem_40:15:140000:30': 28.1,
  'mem_40:15:140000:31': 36.22,
  'mem_40:15:140000:32': 36.22,
  'mem_40:15:140000:33': 36.22,
  'mem_40:15:140000:34': 36.22,
  'mem_40:15:140000:35': 36.22,
  'mem_40:15:140000:36': 52.11,
  'mem_40:15:140000:37': 52.11,
  'mem_40:15:140000:38': 52.11,
  'mem_40:15:140000:39': 52.11,
  'mem_40:15:140000:40': 52.11,
  'mem_40:15:140000:41': 80.01,
  'mem_40:15:140000:42': 80.01,
  'mem_40:15:140000:43': 80.01,
  'mem_40:15:140000:44': 80.01,
  'mem_40:15:140000:45': 80.01,
  'mem_40:15:140000:46': 121.97,
  'mem_40:15:140000:47': 121.97,
  'mem_40:15:140000:48': 121.97,
  'mem_40:15:140000:49': 121.97,
  'mem_40:15:140000:50': 121.97,
  'mem_40:15:140000:51': 183.33,
  'mem_40:15:140000:52': 183.33,
  'mem_40:15:140000:53': 183.33,
  'mem_40:15:140000:54': 183.33,
  'mem_40:15:140000:55': 183.33,
  'mem_40:15:140000:56': 259.72,
  'mem_40:15:140000:57': 259.72,
  'mem_40:15:140000:58': 259.72,
  'mem_40:15:140000:59': 259.72,
  'mem_40:15:140000:60': 259.72,
  'mem_40:15:140000:61': 368.33,
  'mem_40:15:140000:62': 368.33,
  'mem_40:15:140000:63': 368.33,
  'mem_40:15:140000:64': 368.33,
  'mem_40:15:140000:65': 368.33,
  'mem_40:15:140000:66': 535.73,
  'mem_40:15:140000:67': 535.73,
  'mem_40:15:140000:68': 535.73,
  'mem_40:15:140000:69': 535.73,
  'mem_40:15:140000:70': 535.73,
  'mem_40:15:140000:71': 713.54,
  'mem_40:15:140000:72': 713.54,
  'mem_40:15:140000:73': 713.54,
  'mem_40:15:140000:74': 713.54,
  'mem_40:15:140000:75': 713.54,
  'mem_40:15:140000:76': 1005.13,
  'mem_40:15:140000:77': 1005.13,
  'mem_40:15:140000:78': 1005.13,
  'mem_40:15:140000:79': 1005.13,
  'mem_40:15:140000:80': 1005.13,
  'mem_40:15:140000:81': 1460.31,
  'mem_40:15:140000:82': 1460.31,
  'mem_40:15:140000:83': 1460.31,
  'mem_40:15:140000:84': 1460.31,
  'mem_40:15:140000:85': 1460.31,
  'mem_40:15:140000:86': 2030.99,
  'mem_40:15:140000:87': 2030.99,
  'mem_40:15:140000:88': 2030.99,
  'mem_40:15:140000:89': 2030.99,
  'mem_40:15:140000:90': 2030.99,
  'mem_40:15:140000:91': 2826.43,
  'mem_40:15:140000:92': 2826.43,
  'mem_40:15:140000:93': 2826.43,
  'mem_40:15:140000:94': 2826.43,
  'mem_40:15:140000:95': 2826.43,
  'mem_40:15:140000:96': 4635.58,
  'mem_40:15:140000:97': 4635.58,
  'mem_40:15:140000:98': 4635.58,
  'mem_40:15:140000:99': 4635.58,
  'mem_40:15:140000:100': 4635.58,
  'mem_40:15:160000:1': 25.94,
  'mem_40:15:160000:2': 25.94,
  'mem_40:15:160000:3': 25.94,
  'mem_40:15:160000:4': 25.94,
  'mem_40:15:160000:5': 25.94,
  'mem_40:15:160000:6': 25.84,
  'mem_40:15:160000:7': 25.84,
  'mem_40:15:160000:8': 25.84,
  'mem_40:15:160000:9': 25.84,
  'mem_40:15:160000:10': 25.84,
  'mem_40:15:160000:11': 25.95,
  'mem_40:15:160000:12': 25.95,
  'mem_40:15:160000:13': 25.95,
  'mem_40:15:160000:14': 25.95,
  'mem_40:15:160000:15': 25.95,
  'mem_40:15:160000:16': 26.46,
  'mem_40:15:160000:17': 26.46,
  'mem_40:15:160000:18': 26.46,
  'mem_40:15:160000:19': 26.46,
  'mem_40:15:160000:20': 26.46,
  'mem_40:15:160000:21': 28.06,
  'mem_40:15:160000:22': 28.06,
  'mem_40:15:160000:23': 28.06,
  'mem_40:15:160000:24': 28.06,
  'mem_40:15:160000:25': 28.06,
  'mem_40:15:160000:26': 32.13,
  'mem_40:15:160000:27': 32.13,
  'mem_40:15:160000:28': 32.13,
  'mem_40:15:160000:29': 32.13,
  'mem_40:15:160000:30': 32.13,
  'mem_40:15:160000:31': 41.41,
  'mem_40:15:160000:32': 41.41,
  'mem_40:15:160000:33': 41.41,
  'mem_40:15:160000:34': 41.41,
  'mem_40:15:160000:35': 41.41,
  'mem_40:15:160000:36': 59.58,
  'mem_40:15:160000:37': 59.58,
  'mem_40:15:160000:38': 59.58,
  'mem_40:15:160000:39': 59.58,
  'mem_40:15:160000:40': 59.58,
  'mem_40:15:160000:41': 91.47,
  'mem_40:15:160000:42': 91.47,
  'mem_40:15:160000:43': 91.47,
  'mem_40:15:160000:44': 91.47,
  'mem_40:15:160000:45': 91.47,
  'mem_40:15:160000:46': 139.44,
  'mem_40:15:160000:47': 139.44,
  'mem_40:15:160000:48': 139.44,
  'mem_40:15:160000:49': 139.44,
  'mem_40:15:160000:50': 139.44,
  'mem_40:15:160000:51': 209.58,
  'mem_40:15:160000:52': 209.58,
  'mem_40:15:160000:53': 209.58,
  'mem_40:15:160000:54': 209.58,
  'mem_40:15:160000:55': 209.58,
  'mem_40:15:160000:56': 296.91,
  'mem_40:15:160000:57': 296.91,
  'mem_40:15:160000:58': 296.91,
  'mem_40:15:160000:59': 296.91,
  'mem_40:15:160000:60': 296.91,
  'mem_40:15:160000:61': 421.08,
  'mem_40:15:160000:62': 421.08,
  'mem_40:15:160000:63': 421.08,
  'mem_40:15:160000:64': 421.08,
  'mem_40:15:160000:65': 421.08,
  'mem_40:15:160000:66': 612.46,
  'mem_40:15:160000:67': 612.46,
  'mem_40:15:160000:68': 612.46,
  'mem_40:15:160000:69': 612.46,
  'mem_40:15:160000:70': 612.46,
  'mem_40:15:160000:71': 815.71,
  'mem_40:15:160000:72': 815.71,
  'mem_40:15:160000:73': 815.71,
  'mem_40:15:160000:74': 815.71,
  'mem_40:15:160000:75': 815.71,
  'mem_40:15:160000:76': 1149.06,
  'mem_40:15:160000:77': 1149.06,
  'mem_40:15:160000:78': 1149.06,
  'mem_40:15:160000:79': 1149.06,
  'mem_40:15:160000:80': 1149.06,
  'mem_40:15:160000:81': 1669.41,
  'mem_40:15:160000:82': 1669.41,
  'mem_40:15:160000:83': 1669.41,
  'mem_40:15:160000:84': 1669.41,
  'mem_40:15:160000:85': 1669.41,
  'mem_40:15:160000:86': 2321.76,
  'mem_40:15:160000:87': 2321.76,
  'mem_40:15:160000:88': 2321.76,
  'mem_40:15:160000:89': 2321.76,
  'mem_40:15:160000:90': 2321.76,
  'mem_40:15:160000:91': 3231.03,
  'mem_40:15:160000:92': 3231.03,
  'mem_40:15:160000:93': 3231.03,
  'mem_40:15:160000:94': 3231.03,
  'mem_40:15:160000:95': 3231.03,
  'mem_40:15:160000:96': 5299.08,
  'mem_40:15:160000:97': 5299.08,
  'mem_40:15:160000:98': 5299.08,
  'mem_40:15:160000:99': 5299.08,
  'mem_40:15:160000:100': 5299.08,
  'mem_40:15:180000:1': 29.15,
  'mem_40:15:180000:2': 29.15,
  'mem_40:15:180000:3': 29.15,
  'mem_40:15:180000:4': 29.15,
  'mem_40:15:180000:5': 29.15,
  'mem_40:15:180000:6': 29.04,
  'mem_40:15:180000:7': 29.04,
  'mem_40:15:180000:8': 29.04,
  'mem_40:15:180000:9': 29.04,
  'mem_40:15:180000:10': 29.04,
  'mem_40:15:180000:11': 29.15,
  'mem_40:15:180000:12': 29.15,
  'mem_40:15:180000:13': 29.15,
  'mem_40:15:180000:14': 29.15,
  'mem_40:15:180000:15': 29.15,
  'mem_40:15:180000:16': 29.73,
  'mem_40:15:180000:17': 29.73,
  'mem_40:15:180000:18': 29.73,
  'mem_40:15:180000:19': 29.73,
  'mem_40:15:180000:20': 29.73,
  'mem_40:15:180000:21': 31.52,
  'mem_40:15:180000:22': 31.52,
  'mem_40:15:180000:23': 31.52,
  'mem_40:15:180000:24': 31.52,
  'mem_40:15:180000:25': 31.52,
  'mem_40:15:180000:26': 36.09,
  'mem_40:15:180000:27': 36.09,
  'mem_40:15:180000:28': 36.09,
  'mem_40:15:180000:29': 36.09,
  'mem_40:15:180000:30': 36.09,
  'mem_40:15:180000:31': 46.52,
  'mem_40:15:180000:32': 46.52,
  'mem_40:15:180000:33': 46.52,
  'mem_40:15:180000:34': 46.52,
  'mem_40:15:180000:35': 46.52,
  'mem_40:15:180000:36': 66.93,
  'mem_40:15:180000:37': 66.93,
  'mem_40:15:180000:38': 66.93,
  'mem_40:15:180000:39': 66.93,
  'mem_40:15:180000:40': 66.93,
  'mem_40:15:180000:41': 102.85,
  'mem_40:15:180000:42': 102.85,
  'mem_40:15:180000:43': 102.85,
  'mem_40:15:180000:44': 102.85,
  'mem_40:15:180000:45': 102.85,
  'mem_40:15:180000:46': 156.75,
  'mem_40:15:180000:47': 156.75,
  'mem_40:15:180000:48': 156.75,
  'mem_40:15:180000:49': 156.75,
  'mem_40:15:180000:50': 156.75,
  'mem_40:15:180000:51': 235.45,
  'mem_40:15:180000:52': 235.45,
  'mem_40:15:180000:53': 235.45,
  'mem_40:15:180000:54': 235.45,
  'mem_40:15:180000:55': 235.45,
  'mem_40:15:180000:56': 333.55,
  'mem_40:15:180000:57': 333.55,
  'mem_40:15:180000:58': 333.55,
  'mem_40:15:180000:59': 333.55,
  'mem_40:15:180000:60': 333.55,
  'mem_40:15:180000:61': 473.03,
  'mem_40:15:180000:62': 473.03,
  'mem_40:15:180000:63': 473.03,
  'mem_40:15:180000:64': 473.03,
  'mem_40:15:180000:65': 473.03,
  'mem_40:15:180000:66': 687.98,
  'mem_40:15:180000:67': 687.98,
  'mem_40:15:180000:68': 687.98,
  'mem_40:15:180000:69': 687.98,
  'mem_40:15:180000:70': 687.98,
  'mem_40:15:180000:71': 916.35,
  'mem_40:15:180000:72': 916.35,
  'mem_40:15:180000:73': 916.35,
  'mem_40:15:180000:74': 916.35,
  'mem_40:15:180000:75': 916.35,
  'mem_40:15:180000:76': 1290.85,
  'mem_40:15:180000:77': 1290.85,
  'mem_40:15:180000:78': 1290.85,
  'mem_40:15:180000:79': 1290.85,
  'mem_40:15:180000:80': 1290.85,
  'mem_40:15:180000:81': 1875.42,
  'mem_40:15:180000:82': 1875.42,
  'mem_40:15:180000:83': 1875.42,
  'mem_40:15:180000:84': 1875.42,
  'mem_40:15:180000:85': 1875.42,
  'mem_40:15:180000:86': 2608.4,
  'mem_40:15:180000:87': 2608.4,
  'mem_40:15:180000:88': 2608.4,
  'mem_40:15:180000:89': 2608.4,
  'mem_40:15:180000:90': 2608.4,
  'mem_40:15:180000:91': 3630.07,
  'mem_40:15:180000:92': 3630.07,
  'mem_40:15:180000:93': 3630.07,
  'mem_40:15:180000:94': 3630.07,
  'mem_40:15:180000:95': 3630.07,
  'mem_40:15:180000:96': 5953.72,
  'mem_40:15:180000:97': 5953.72,
  'mem_40:15:180000:98': 5953.72,
  'mem_40:15:180000:99': 5953.72,
  'mem_40:15:180000:100': 5953.72,
  'mem_40:15:200000:1': 32.4,
  'mem_40:15:200000:2': 32.4,
  'mem_40:15:200000:3': 32.4,
  'mem_40:15:200000:4': 32.4,
  'mem_40:15:200000:5': 32.4,
  'mem_40:15:200000:6': 32.28,
  'mem_40:15:200000:7': 32.28,
  'mem_40:15:200000:8': 32.28,
  'mem_40:15:200000:9': 32.28,
  'mem_40:15:200000:10': 32.28,
  'mem_40:15:200000:11': 32.41,
  'mem_40:15:200000:12': 32.41,
  'mem_40:15:200000:13': 32.41,
  'mem_40:15:200000:14': 32.41,
  'mem_40:15:200000:15': 32.41,
  'mem_40:15:200000:16': 33.05,
  'mem_40:15:200000:17': 33.05,
  'mem_40:15:200000:18': 33.05,
  'mem_40:15:200000:19': 33.05,
  'mem_40:15:200000:20': 33.05,
  'mem_40:15:200000:21': 35.04,
  'mem_40:15:200000:22': 35.04,
  'mem_40:15:200000:23': 35.04,
  'mem_40:15:200000:24': 35.04,
  'mem_40:15:200000:25': 35.04,
  'mem_40:15:200000:26': 40.12,
  'mem_40:15:200000:27': 40.12,
  'mem_40:15:200000:28': 40.12,
  'mem_40:15:200000:29': 40.12,
  'mem_40:15:200000:30': 40.12,
  'mem_40:15:200000:31': 51.71,
  'mem_40:15:200000:32': 51.71,
  'mem_40:15:200000:33': 51.71,
  'mem_40:15:200000:34': 51.71,
  'mem_40:15:200000:35': 51.71,
  'mem_40:15:200000:36': 74.4,
  'mem_40:15:200000:37': 74.4,
  'mem_40:15:200000:38': 74.4,
  'mem_40:15:200000:39': 74.4,
  'mem_40:15:200000:40': 74.4,
  'mem_40:15:200000:41': 114.3,
  'mem_40:15:200000:42': 114.3,
  'mem_40:15:200000:43': 114.3,
  'mem_40:15:200000:44': 114.3,
  'mem_40:15:200000:45': 114.3,
  'mem_40:15:200000:46': 174.21,
  'mem_40:15:200000:47': 174.21,
  'mem_40:15:200000:48': 174.21,
  'mem_40:15:200000:49': 174.21,
  'mem_40:15:200000:50': 174.21,
  'mem_40:15:200000:51': 261.73,
  'mem_40:15:200000:52': 261.73,
  'mem_40:15:200000:53': 261.73,
  'mem_40:15:200000:54': 261.73,
  'mem_40:15:200000:55': 261.73,
  'mem_40:15:200000:56': 370.78,
  'mem_40:15:200000:57': 370.78,
  'mem_40:15:200000:58': 370.78,
  'mem_40:15:200000:59': 370.78,
  'mem_40:15:200000:60': 370.78,
  'mem_40:15:200000:61': 525.83,
  'mem_40:15:200000:62': 525.83,
  'mem_40:15:200000:63': 525.83,
  'mem_40:15:200000:64': 525.83,
  'mem_40:15:200000:65': 525.83,
  'mem_40:15:200000:66': 764.77,
  'mem_40:15:200000:67': 764.77,
  'mem_40:15:200000:68': 764.77,
  'mem_40:15:200000:69': 764.77,
  'mem_40:15:200000:70': 764.77,
  'mem_40:15:200000:71': 1018.65,
  'mem_40:15:200000:72': 1018.65,
  'mem_40:15:200000:73': 1018.65,
  'mem_40:15:200000:74': 1018.65,
  'mem_40:15:200000:75': 1018.65,
  'mem_40:15:200000:76': 1434.98,
  'mem_40:15:200000:77': 1434.98,
  'mem_40:15:200000:78': 1434.98,
  'mem_40:15:200000:79': 1434.98,
  'mem_40:15:200000:80': 1434.98,
  'mem_40:15:200000:81': 2084.81,
  'mem_40:15:200000:82': 2084.81,
  'mem_40:15:200000:83': 2084.81,
  'mem_40:15:200000:84': 2084.81,
  'mem_40:15:200000:85': 2084.81,
  'mem_40:15:200000:86': 2899.67,
  'mem_40:15:200000:87': 2899.67,
  'mem_40:15:200000:88': 2899.67,
  'mem_40:15:200000:89': 2899.67,
  'mem_40:15:200000:90': 2899.67,
  'mem_40:15:200000:91': 4035.43,
  'mem_40:15:200000:92': 4035.43,
  'mem_40:15:200000:93': 4035.43,
  'mem_40:15:200000:94': 4035.43,
  'mem_40:15:200000:95': 4035.43,
  'mem_40:15:200000:96': 6618.54,
  'mem_40:15:200000:97': 6618.54,
  'mem_40:15:200000:98': 6618.54,
  'mem_40:15:200000:99': 6618.54,
  'mem_40:15:200000:100': 6618.54,
  'mem_7:15:5000:1': 1.2,
  'mem_7:15:5000:2': 1.2,
  'mem_7:15:5000:3': 1.2,
  'mem_7:15:5000:4': 1.2,
  'mem_7:15:5000:5': 1.2,
  'mem_7:15:5000:6': 1.2,
  'mem_7:15:5000:7': 1.2,
  'mem_7:15:5000:8': 1.2,
  'mem_7:15:5000:9': 1.2,
  'mem_7:15:5000:10': 1.2,
  'mem_7:15:5000:11': 1.2,
  'mem_7:15:5000:12': 1.2,
  'mem_7:15:5000:13': 1.2,
  'mem_7:15:5000:14': 1.2,
  'mem_7:15:5000:15': 1.2,
  'mem_7:15:5000:16': 1.2,
  'mem_7:15:5000:17': 1.2,
  'mem_7:15:5000:18': 1.2,
  'mem_7:15:5000:19': 1.2,
  'mem_7:15:5000:20': 1.2,
  'mem_7:15:5000:21': 1.2,
  'mem_7:15:5000:22': 1.2,
  'mem_7:15:5000:23': 1.2,
  'mem_7:15:5000:24': 1.2,
  'mem_7:15:5000:25': 1.2,
  'mem_7:15:5000:26': 1.2,
  'mem_7:15:5000:27': 1.2,
  'mem_7:15:5000:28': 1.2,
  'mem_7:15:5000:29': 1.2,
  'mem_7:15:5000:30': 1.2,
  'mem_7:15:5000:31': 1.2,
  'mem_7:15:5000:32': 1.2,
  'mem_7:15:5000:33': 1.2,
  'mem_7:15:5000:34': 1.2,
  'mem_7:15:5000:35': 1.2,
  'mem_7:15:5000:36': 2.4,
  'mem_7:15:5000:37': 2.4,
  'mem_7:15:5000:38': 2.4,
  'mem_7:15:5000:39': 2.4,
  'mem_7:15:5000:40': 2.4,
  'mem_7:15:5000:41': 3.6,
  'mem_7:15:5000:42': 3.6,
  'mem_7:15:5000:43': 3.6,
  'mem_7:15:5000:44': 3.6,
  'mem_7:15:5000:45': 3.6,
  'mem_7:15:5000:46': 4.8,
  'mem_7:15:5000:47': 4.8,
  'mem_7:15:5000:48': 4.8,
  'mem_7:15:5000:49': 4.8,
  'mem_7:15:5000:50': 4.8,
  'mem_7:15:5000:51': 7.2,
  'mem_7:15:5000:52': 7.2,
  'mem_7:15:5000:53': 7.2,
  'mem_7:15:5000:54': 7.2,
  'mem_7:15:5000:55': 7.2,
  'mem_7:15:5000:56': 8.4,
  'mem_7:15:5000:57': 8.4,
  'mem_7:15:5000:58': 8.4,
  'mem_7:15:5000:59': 8.4,
  'mem_7:15:5000:60': 8.4,
  'mem_7:15:5000:61': 8.4,
  'mem_7:15:5000:62': 8.4,
  'mem_7:15:5000:63': 8.4,
  'mem_7:15:5000:64': 8.4,
  'mem_7:15:5000:65': 8.4,
  'mem_7:15:5000:66': 12,
  'mem_7:15:5000:67': 12,
  'mem_7:15:5000:68': 12,
  'mem_7:15:5000:69': 12,
  'mem_7:15:5000:70': 12,
  'mem_7:15:5000:71': 18,
  'mem_7:15:5000:72': 18,
  'mem_7:15:5000:73': 18,
  'mem_7:15:5000:74': 18,
  'mem_7:15:5000:75': 18,
  'mem_7:15:5000:76': 24,
  'mem_7:15:5000:77': 24,
  'mem_7:15:5000:78': 24,
  'mem_7:15:5000:79': 24,
  'mem_7:15:5000:80': 24,
  'mem_7:15:5000:81': 31.32,
  'mem_7:15:5000:82': 31.32,
  'mem_7:15:5000:83': 31.32,
  'mem_7:15:5000:84': 31.32,
  'mem_7:15:5000:85': 31.32,
  'mem_7:15:5000:86': 43.56,
  'mem_7:15:5000:87': 43.56,
  'mem_7:15:5000:88': 43.56,
  'mem_7:15:5000:89': 43.56,
  'mem_7:15:5000:90': 43.56,
  'mem_7:15:5000:91': 60.62,
  'mem_7:15:5000:92': 60.62,
  'mem_7:15:5000:93': 60.62,
  'mem_7:15:5000:94': 60.62,
  'mem_7:15:5000:95': 60.62,
  'mem_7:15:5000:96': 99.35,
  'mem_7:15:5000:97': 99.35,
  'mem_7:15:5000:98': 99.35,
  'mem_7:15:5000:99': 99.35,
  'mem_7:15:5000:100': 99.35,
  'mem_7:15:7500:1': 1.2,
  'mem_7:15:7500:2': 1.2,
  'mem_7:15:7500:3': 1.2,
  'mem_7:15:7500:4': 1.2,
  'mem_7:15:7500:5': 1.2,
  'mem_7:15:7500:6': 1.2,
  'mem_7:15:7500:7': 1.2,
  'mem_7:15:7500:8': 1.2,
  'mem_7:15:7500:9': 1.2,
  'mem_7:15:7500:10': 1.2,
  'mem_7:15:7500:11': 1.2,
  'mem_7:15:7500:12': 1.2,
  'mem_7:15:7500:13': 1.2,
  'mem_7:15:7500:14': 1.2,
  'mem_7:15:7500:15': 1.2,
  'mem_7:15:7500:16': 1.2,
  'mem_7:15:7500:17': 1.2,
  'mem_7:15:7500:18': 1.2,
  'mem_7:15:7500:19': 1.2,
  'mem_7:15:7500:20': 1.2,
  'mem_7:15:7500:21': 1.2,
  'mem_7:15:7500:22': 1.2,
  'mem_7:15:7500:23': 1.2,
  'mem_7:15:7500:24': 1.2,
  'mem_7:15:7500:25': 1.2,
  'mem_7:15:7500:26': 2.4,
  'mem_7:15:7500:27': 2.4,
  'mem_7:15:7500:28': 2.4,
  'mem_7:15:7500:29': 2.4,
  'mem_7:15:7500:30': 2.4,
  'mem_7:15:7500:31': 2.4,
  'mem_7:15:7500:32': 2.4,
  'mem_7:15:7500:33': 2.4,
  'mem_7:15:7500:34': 2.4,
  'mem_7:15:7500:35': 2.4,
  'mem_7:15:7500:36': 3.6,
  'mem_7:15:7500:37': 3.6,
  'mem_7:15:7500:38': 3.6,
  'mem_7:15:7500:39': 3.6,
  'mem_7:15:7500:40': 3.6,
  'mem_7:15:7500:41': 4.8,
  'mem_7:15:7500:42': 4.8,
  'mem_7:15:7500:43': 4.8,
  'mem_7:15:7500:44': 4.8,
  'mem_7:15:7500:45': 4.8,
  'mem_7:15:7500:46': 7.2,
  'mem_7:15:7500:47': 7.2,
  'mem_7:15:7500:48': 7.2,
  'mem_7:15:7500:49': 7.2,
  'mem_7:15:7500:50': 7.2,
  'mem_7:15:7500:51': 10.8,
  'mem_7:15:7500:52': 10.8,
  'mem_7:15:7500:53': 10.8,
  'mem_7:15:7500:54': 10.8,
  'mem_7:15:7500:55': 10.8,
  'mem_7:15:7500:56': 12,
  'mem_7:15:7500:57': 12,
  'mem_7:15:7500:58': 12,
  'mem_7:15:7500:59': 12,
  'mem_7:15:7500:60': 12,
  'mem_7:15:7500:61': 12,
  'mem_7:15:7500:62': 12,
  'mem_7:15:7500:63': 12,
  'mem_7:15:7500:64': 12,
  'mem_7:15:7500:65': 12,
  'mem_7:15:7500:66': 18,
  'mem_7:15:7500:67': 18,
  'mem_7:15:7500:68': 18,
  'mem_7:15:7500:69': 18,
  'mem_7:15:7500:70': 18,
  'mem_7:15:7500:71': 26.4,
  'mem_7:15:7500:72': 26.4,
  'mem_7:15:7500:73': 26.4,
  'mem_7:15:7500:74': 26.4,
  'mem_7:15:7500:75': 26.4,
  'mem_7:15:7500:76': 36,
  'mem_7:15:7500:77': 36,
  'mem_7:15:7500:78': 36,
  'mem_7:15:7500:79': 36,
  'mem_7:15:7500:80': 36,
  'mem_7:15:7500:81': 46.95,
  'mem_7:15:7500:82': 46.95,
  'mem_7:15:7500:83': 46.95,
  'mem_7:15:7500:84': 46.95,
  'mem_7:15:7500:85': 46.95,
  'mem_7:15:7500:86': 65.3,
  'mem_7:15:7500:87': 65.3,
  'mem_7:15:7500:88': 65.3,
  'mem_7:15:7500:89': 65.3,
  'mem_7:15:7500:90': 65.3,
  'mem_7:15:7500:91': 90.87,
  'mem_7:15:7500:92': 90.87,
  'mem_7:15:7500:93': 90.87,
  'mem_7:15:7500:94': 90.87,
  'mem_7:15:7500:95': 90.87,
  'mem_7:15:7500:96': 149.03,
  'mem_7:15:7500:97': 149.03,
  'mem_7:15:7500:98': 149.03,
  'mem_7:15:7500:99': 149.03,
  'mem_7:15:7500:100': 149.03,
  'mem_7:15:10000:1': 1.2,
  'mem_7:15:10000:2': 1.2,
  'mem_7:15:10000:3': 1.2,
  'mem_7:15:10000:4': 1.2,
  'mem_7:15:10000:5': 1.2,
  'mem_7:15:10000:6': 1.2,
  'mem_7:15:10000:7': 1.2,
  'mem_7:15:10000:8': 1.2,
  'mem_7:15:10000:9': 1.2,
  'mem_7:15:10000:10': 1.2,
  'mem_7:15:10000:11': 2.4,
  'mem_7:15:10000:12': 2.4,
  'mem_7:15:10000:13': 2.4,
  'mem_7:15:10000:14': 2.4,
  'mem_7:15:10000:15': 2.4,
  'mem_7:15:10000:16': 2.4,
  'mem_7:15:10000:17': 2.4,
  'mem_7:15:10000:18': 2.4,
  'mem_7:15:10000:19': 2.4,
  'mem_7:15:10000:20': 2.4,
  'mem_7:15:10000:21': 2.4,
  'mem_7:15:10000:22': 2.4,
  'mem_7:15:10000:23': 2.4,
  'mem_7:15:10000:24': 2.4,
  'mem_7:15:10000:25': 2.4,
  'mem_7:15:10000:26': 2.4,
  'mem_7:15:10000:27': 2.4,
  'mem_7:15:10000:28': 2.4,
  'mem_7:15:10000:29': 2.4,
  'mem_7:15:10000:30': 2.4,
  'mem_7:15:10000:31': 2.4,
  'mem_7:15:10000:32': 2.4,
  'mem_7:15:10000:33': 2.4,
  'mem_7:15:10000:34': 2.4,
  'mem_7:15:10000:35': 2.4,
  'mem_7:15:10000:36': 3.6,
  'mem_7:15:10000:37': 3.6,
  'mem_7:15:10000:38': 3.6,
  'mem_7:15:10000:39': 3.6,
  'mem_7:15:10000:40': 3.6,
  'mem_7:15:10000:41': 6,
  'mem_7:15:10000:42': 6,
  'mem_7:15:10000:43': 6,
  'mem_7:15:10000:44': 6,
  'mem_7:15:10000:45': 6,
  'mem_7:15:10000:46': 9.6,
  'mem_7:15:10000:47': 9.6,
  'mem_7:15:10000:48': 9.6,
  'mem_7:15:10000:49': 9.6,
  'mem_7:15:10000:50': 9.6,
  'mem_7:15:10000:51': 13.2,
  'mem_7:15:10000:52': 13.2,
  'mem_7:15:10000:53': 13.2,
  'mem_7:15:10000:54': 13.2,
  'mem_7:15:10000:55': 13.2,
  'mem_7:15:10000:56': 15.6,
  'mem_7:15:10000:57': 15.6,
  'mem_7:15:10000:58': 15.6,
  'mem_7:15:10000:59': 15.6,
  'mem_7:15:10000:60': 15.6,
  'mem_7:15:10000:61': 16.8,
  'mem_7:15:10000:62': 16.8,
  'mem_7:15:10000:63': 16.8,
  'mem_7:15:10000:64': 16.8,
  'mem_7:15:10000:65': 16.8,
  'mem_7:15:10000:66': 24,
  'mem_7:15:10000:67': 24,
  'mem_7:15:10000:68': 24,
  'mem_7:15:10000:69': 24,
  'mem_7:15:10000:70': 24,
  'mem_7:15:10000:71': 36,
  'mem_7:15:10000:72': 36,
  'mem_7:15:10000:73': 36,
  'mem_7:15:10000:74': 36,
  'mem_7:15:10000:75': 36,
  'mem_7:15:10000:76': 48,
  'mem_7:15:10000:77': 48,
  'mem_7:15:10000:78': 48,
  'mem_7:15:10000:79': 48,
  'mem_7:15:10000:80': 48,
  'mem_7:15:10000:81': 62.59,
  'mem_7:15:10000:82': 62.59,
  'mem_7:15:10000:83': 62.59,
  'mem_7:15:10000:84': 62.59,
  'mem_7:15:10000:85': 62.59,
  'mem_7:15:10000:86': 87.05,
  'mem_7:15:10000:87': 87.05,
  'mem_7:15:10000:88': 87.05,
  'mem_7:15:10000:89': 87.05,
  'mem_7:15:10000:90': 87.05,
  'mem_7:15:10000:91': 121.14,
  'mem_7:15:10000:92': 121.14,
  'mem_7:15:10000:93': 121.14,
  'mem_7:15:10000:94': 121.14,
  'mem_7:15:10000:95': 121.14,
  'mem_7:15:10000:96': 198.68,
  'mem_7:15:10000:97': 198.68,
  'mem_7:15:10000:98': 198.68,
  'mem_7:15:10000:99': 198.68,
  'mem_7:15:10000:100': 198.68,
  'mem_7:15:15000:1': 2.4,
  'mem_7:15:15000:2': 2.4,
  'mem_7:15:15000:3': 2.4,
  'mem_7:15:15000:4': 2.4,
  'mem_7:15:15000:5': 2.4,
  'mem_7:15:15000:6': 2.4,
  'mem_7:15:15000:7': 2.4,
  'mem_7:15:15000:8': 2.4,
  'mem_7:15:15000:9': 2.4,
  'mem_7:15:15000:10': 2.4,
  'mem_7:15:15000:11': 2.4,
  'mem_7:15:15000:12': 2.4,
  'mem_7:15:15000:13': 2.4,
  'mem_7:15:15000:14': 2.4,
  'mem_7:15:15000:15': 2.4,
  'mem_7:15:15000:16': 2.4,
  'mem_7:15:15000:17': 2.4,
  'mem_7:15:15000:18': 2.4,
  'mem_7:15:15000:19': 2.4,
  'mem_7:15:15000:20': 2.4,
  'mem_7:15:15000:21': 2.4,
  'mem_7:15:15000:22': 2.4,
  'mem_7:15:15000:23': 2.4,
  'mem_7:15:15000:24': 2.4,
  'mem_7:15:15000:25': 2.4,
  'mem_7:15:15000:26': 3.6,
  'mem_7:15:15000:27': 3.6,
  'mem_7:15:15000:28': 3.6,
  'mem_7:15:15000:29': 3.6,
  'mem_7:15:15000:30': 3.6,
  'mem_7:15:15000:31': 3.6,
  'mem_7:15:15000:32': 3.6,
  'mem_7:15:15000:33': 3.6,
  'mem_7:15:15000:34': 3.6,
  'mem_7:15:15000:35': 3.6,
  'mem_7:15:15000:36': 6,
  'mem_7:15:15000:37': 6,
  'mem_7:15:15000:38': 6,
  'mem_7:15:15000:39': 6,
  'mem_7:15:15000:40': 6,
  'mem_7:15:15000:41': 9.6,
  'mem_7:15:15000:42': 9.6,
  'mem_7:15:15000:43': 9.6,
  'mem_7:15:15000:44': 9.6,
  'mem_7:15:15000:45': 9.6,
  'mem_7:15:15000:46': 13.2,
  'mem_7:15:15000:47': 13.2,
  'mem_7:15:15000:48': 13.2,
  'mem_7:15:15000:49': 13.2,
  'mem_7:15:15000:50': 13.2,
  'mem_7:15:15000:51': 20.4,
  'mem_7:15:15000:52': 20.4,
  'mem_7:15:15000:53': 20.4,
  'mem_7:15:15000:54': 20.4,
  'mem_7:15:15000:55': 20.4,
  'mem_7:15:15000:56': 22.8,
  'mem_7:15:15000:57': 22.8,
  'mem_7:15:15000:58': 22.8,
  'mem_7:15:15000:59': 22.8,
  'mem_7:15:15000:60': 22.8,
  'mem_7:15:15000:61': 24,
  'mem_7:15:15000:62': 24,
  'mem_7:15:15000:63': 24,
  'mem_7:15:15000:64': 24,
  'mem_7:15:15000:65': 24,
  'mem_7:15:15000:66': 34.8,
  'mem_7:15:15000:67': 34.8,
  'mem_7:15:15000:68': 34.8,
  'mem_7:15:15000:69': 34.8,
  'mem_7:15:15000:70': 34.8,
  'mem_7:15:15000:71': 52.8,
  'mem_7:15:15000:72': 52.8,
  'mem_7:15:15000:73': 52.8,
  'mem_7:15:15000:74': 52.8,
  'mem_7:15:15000:75': 52.8,
  'mem_7:15:15000:76': 70.8,
  'mem_7:15:15000:77': 70.8,
  'mem_7:15:15000:78': 70.8,
  'mem_7:15:15000:79': 70.8,
  'mem_7:15:15000:80': 70.8,
  'mem_7:15:15000:81': 93.9,
  'mem_7:15:15000:82': 93.9,
  'mem_7:15:15000:83': 93.9,
  'mem_7:15:15000:84': 93.9,
  'mem_7:15:15000:85': 93.9,
  'mem_7:15:15000:86': 130.59,
  'mem_7:15:15000:87': 130.59,
  'mem_7:15:15000:88': 130.59,
  'mem_7:15:15000:89': 130.59,
  'mem_7:15:15000:90': 130.59,
  'mem_7:15:15000:91': 181.74,
  'mem_7:15:15000:92': 181.74,
  'mem_7:15:15000:93': 181.74,
  'mem_7:15:15000:94': 181.74,
  'mem_7:15:15000:95': 181.74,
  'mem_7:15:15000:96': 298.06,
  'mem_7:15:15000:97': 298.06,
  'mem_7:15:15000:98': 298.06,
  'mem_7:15:15000:99': 298.06,
  'mem_7:15:15000:100': 298.06,
  'mem_7:15:20000:1': 2.4,
  'mem_7:15:20000:2': 2.4,
  'mem_7:15:20000:3': 2.4,
  'mem_7:15:20000:4': 2.4,
  'mem_7:15:20000:5': 2.4,
  'mem_7:15:20000:6': 2.4,
  'mem_7:15:20000:7': 2.4,
  'mem_7:15:20000:8': 2.4,
  'mem_7:15:20000:9': 2.4,
  'mem_7:15:20000:10': 2.4,
  'mem_7:15:20000:11': 3.6,
  'mem_7:15:20000:12': 3.6,
  'mem_7:15:20000:13': 3.6,
  'mem_7:15:20000:14': 3.6,
  'mem_7:15:20000:15': 3.6,
  'mem_7:15:20000:16': 3.6,
  'mem_7:15:20000:17': 3.6,
  'mem_7:15:20000:18': 3.6,
  'mem_7:15:20000:19': 3.6,
  'mem_7:15:20000:20': 3.6,
  'mem_7:15:20000:21': 3.6,
  'mem_7:15:20000:22': 3.6,
  'mem_7:15:20000:23': 3.6,
  'mem_7:15:20000:24': 3.6,
  'mem_7:15:20000:25': 3.6,
  'mem_7:15:20000:26': 3.6,
  'mem_7:15:20000:27': 3.6,
  'mem_7:15:20000:28': 3.6,
  'mem_7:15:20000:29': 3.6,
  'mem_7:15:20000:30': 3.6,
  'mem_7:15:20000:31': 4.8,
  'mem_7:15:20000:32': 4.8,
  'mem_7:15:20000:33': 4.8,
  'mem_7:15:20000:34': 4.8,
  'mem_7:15:20000:35': 4.8,
  'mem_7:15:20000:36': 7.2,
  'mem_7:15:20000:37': 7.2,
  'mem_7:15:20000:38': 7.2,
  'mem_7:15:20000:39': 7.2,
  'mem_7:15:20000:40': 7.2,
  'mem_7:15:20000:41': 12,
  'mem_7:15:20000:42': 12,
  'mem_7:15:20000:43': 12,
  'mem_7:15:20000:44': 12,
  'mem_7:15:20000:45': 12,
  'mem_7:15:20000:46': 18,
  'mem_7:15:20000:47': 18,
  'mem_7:15:20000:48': 18,
  'mem_7:15:20000:49': 18,
  'mem_7:15:20000:50': 18,
  'mem_7:15:20000:51': 26.4,
  'mem_7:15:20000:52': 26.4,
  'mem_7:15:20000:53': 26.4,
  'mem_7:15:20000:54': 26.4,
  'mem_7:15:20000:55': 26.4,
  'mem_7:15:20000:56': 30,
  'mem_7:15:20000:57': 30,
  'mem_7:15:20000:58': 30,
  'mem_7:15:20000:59': 30,
  'mem_7:15:20000:60': 30,
  'mem_7:15:20000:61': 32.4,
  'mem_7:15:20000:62': 32.4,
  'mem_7:15:20000:63': 32.4,
  'mem_7:15:20000:64': 32.4,
  'mem_7:15:20000:65': 32.4,
  'mem_7:15:20000:66': 46.8,
  'mem_7:15:20000:67': 46.8,
  'mem_7:15:20000:68': 46.8,
  'mem_7:15:20000:69': 46.8,
  'mem_7:15:20000:70': 46.8,
  'mem_7:15:20000:71': 70.8,
  'mem_7:15:20000:72': 70.8,
  'mem_7:15:20000:73': 70.8,
  'mem_7:15:20000:74': 70.8,
  'mem_7:15:20000:75': 70.8,
  'mem_7:15:20000:76': 94.8,
  'mem_7:15:20000:77': 94.8,
  'mem_7:15:20000:78': 94.8,
  'mem_7:15:20000:79': 94.8,
  'mem_7:15:20000:80': 94.8,
  'mem_7:15:20000:81': 125.17,
  'mem_7:15:20000:82': 125.17,
  'mem_7:15:20000:83': 125.17,
  'mem_7:15:20000:84': 125.17,
  'mem_7:15:20000:85': 125.17,
  'mem_7:15:20000:86': 174.09,
  'mem_7:15:20000:87': 174.09,
  'mem_7:15:20000:88': 174.09,
  'mem_7:15:20000:89': 174.09,
  'mem_7:15:20000:90': 174.09,
  'mem_7:15:20000:91': 242.28,
  'mem_7:15:20000:92': 242.28,
  'mem_7:15:20000:93': 242.28,
  'mem_7:15:20000:94': 242.28,
  'mem_7:15:20000:95': 242.28,
  'mem_7:15:20000:96': 397.35,
  'mem_7:15:20000:97': 397.35,
  'mem_7:15:20000:98': 397.35,
  'mem_7:15:20000:99': 397.35,
  'mem_7:15:20000:100': 397.35,
  'mem_7:15:25000:1': 3.6,
  'mem_7:15:25000:2': 3.6,
  'mem_7:15:25000:3': 3.6,
  'mem_7:15:25000:4': 3.6,
  'mem_7:15:25000:5': 3.6,
  'mem_7:15:25000:6': 3.6,
  'mem_7:15:25000:7': 3.6,
  'mem_7:15:25000:8': 3.6,
  'mem_7:15:25000:9': 3.6,
  'mem_7:15:25000:10': 3.6,
  'mem_7:15:25000:11': 3.6,
  'mem_7:15:25000:12': 3.6,
  'mem_7:15:25000:13': 3.6,
  'mem_7:15:25000:14': 3.6,
  'mem_7:15:25000:15': 3.6,
  'mem_7:15:25000:16': 3.6,
  'mem_7:15:25000:17': 3.6,
  'mem_7:15:25000:18': 3.6,
  'mem_7:15:25000:19': 3.6,
  'mem_7:15:25000:20': 3.6,
  'mem_7:15:25000:21': 3.6,
  'mem_7:15:25000:22': 3.6,
  'mem_7:15:25000:23': 3.6,
  'mem_7:15:25000:24': 3.6,
  'mem_7:15:25000:25': 3.6,
  'mem_7:15:25000:26': 4.8,
  'mem_7:15:25000:27': 4.8,
  'mem_7:15:25000:28': 4.8,
  'mem_7:15:25000:29': 4.8,
  'mem_7:15:25000:30': 4.8,
  'mem_7:15:25000:31': 6,
  'mem_7:15:25000:32': 6,
  'mem_7:15:25000:33': 6,
  'mem_7:15:25000:34': 6,
  'mem_7:15:25000:35': 6,
  'mem_7:15:25000:36': 9.6,
  'mem_7:15:25000:37': 9.6,
  'mem_7:15:25000:38': 9.6,
  'mem_7:15:25000:39': 9.6,
  'mem_7:15:25000:40': 9.6,
  'mem_7:15:25000:41': 14.4,
  'mem_7:15:25000:42': 14.4,
  'mem_7:15:25000:43': 14.4,
  'mem_7:15:25000:44': 14.4,
  'mem_7:15:25000:45': 14.4,
  'mem_7:15:25000:46': 22.8,
  'mem_7:15:25000:47': 22.8,
  'mem_7:15:25000:48': 22.8,
  'mem_7:15:25000:49': 22.8,
  'mem_7:15:25000:50': 22.8,
  'mem_7:15:25000:51': 33.6,
  'mem_7:15:25000:52': 33.6,
  'mem_7:15:25000:53': 33.6,
  'mem_7:15:25000:54': 33.6,
  'mem_7:15:25000:55': 33.6,
  'mem_7:15:25000:56': 37.2,
  'mem_7:15:25000:57': 37.2,
  'mem_7:15:25000:58': 37.2,
  'mem_7:15:25000:59': 37.2,
  'mem_7:15:25000:60': 37.2,
  'mem_7:15:25000:61': 40.8,
  'mem_7:15:25000:62': 40.8,
  'mem_7:15:25000:63': 40.8,
  'mem_7:15:25000:64': 40.8,
  'mem_7:15:25000:65': 40.8,
  'mem_7:15:25000:66': 58.8,
  'mem_7:15:25000:67': 58.8,
  'mem_7:15:25000:68': 58.8,
  'mem_7:15:25000:69': 58.8,
  'mem_7:15:25000:70': 58.8,
  'mem_7:15:25000:71': 87.6,
  'mem_7:15:25000:72': 87.6,
  'mem_7:15:25000:73': 87.6,
  'mem_7:15:25000:74': 87.6,
  'mem_7:15:25000:75': 87.6,
  'mem_7:15:25000:76': 118.8,
  'mem_7:15:25000:77': 118.8,
  'mem_7:15:25000:78': 118.8,
  'mem_7:15:25000:79': 118.8,
  'mem_7:15:25000:80': 118.8,
  'mem_7:15:25000:81': 156.52,
  'mem_7:15:25000:82': 156.52,
  'mem_7:15:25000:83': 156.52,
  'mem_7:15:25000:84': 156.52,
  'mem_7:15:25000:85': 156.52,
  'mem_7:15:25000:86': 217.68,
  'mem_7:15:25000:87': 217.68,
  'mem_7:15:25000:88': 217.68,
  'mem_7:15:25000:89': 217.68,
  'mem_7:15:25000:90': 217.68,
  'mem_7:15:25000:91': 302.92,
  'mem_7:15:25000:92': 302.92,
  'mem_7:15:25000:93': 302.92,
  'mem_7:15:25000:94': 302.92,
  'mem_7:15:25000:95': 302.92,
  'mem_7:15:25000:96': 496.81,
  'mem_7:15:25000:97': 496.81,
  'mem_7:15:25000:98': 496.81,
  'mem_7:15:25000:99': 496.81,
  'mem_7:15:25000:100': 496.81,
  'mem_7:15:30000:1': 3.6,
  'mem_7:15:30000:2': 3.6,
  'mem_7:15:30000:3': 3.6,
  'mem_7:15:30000:4': 3.6,
  'mem_7:15:30000:5': 3.6,
  'mem_7:15:30000:6': 3.6,
  'mem_7:15:30000:7': 3.6,
  'mem_7:15:30000:8': 3.6,
  'mem_7:15:30000:9': 3.6,
  'mem_7:15:30000:10': 3.6,
  'mem_7:15:30000:11': 4.8,
  'mem_7:15:30000:12': 4.8,
  'mem_7:15:30000:13': 4.8,
  'mem_7:15:30000:14': 4.8,
  'mem_7:15:30000:15': 4.8,
  'mem_7:15:30000:16': 4.8,
  'mem_7:15:30000:17': 4.8,
  'mem_7:15:30000:18': 4.8,
  'mem_7:15:30000:19': 4.8,
  'mem_7:15:30000:20': 4.8,
  'mem_7:15:30000:21': 4.8,
  'mem_7:15:30000:22': 4.8,
  'mem_7:15:30000:23': 4.8,
  'mem_7:15:30000:24': 4.8,
  'mem_7:15:30000:25': 4.8,
  'mem_7:15:30000:26': 6,
  'mem_7:15:30000:27': 6,
  'mem_7:15:30000:28': 6,
  'mem_7:15:30000:29': 6,
  'mem_7:15:30000:30': 6,
  'mem_7:15:30000:31': 7.2,
  'mem_7:15:30000:32': 7.2,
  'mem_7:15:30000:33': 7.2,
  'mem_7:15:30000:34': 7.2,
  'mem_7:15:30000:35': 7.2,
  'mem_7:15:30000:36': 10.8,
  'mem_7:15:30000:37': 10.8,
  'mem_7:15:30000:38': 10.8,
  'mem_7:15:30000:39': 10.8,
  'mem_7:15:30000:40': 10.8,
  'mem_7:15:30000:41': 16.8,
  'mem_7:15:30000:42': 16.8,
  'mem_7:15:30000:43': 16.8,
  'mem_7:15:30000:44': 16.8,
  'mem_7:15:30000:45': 16.8,
  'mem_7:15:30000:46': 26.4,
  'mem_7:15:30000:47': 26.4,
  'mem_7:15:30000:48': 26.4,
  'mem_7:15:30000:49': 26.4,
  'mem_7:15:30000:50': 26.4,
  'mem_7:15:30000:51': 39.6,
  'mem_7:15:30000:52': 39.6,
  'mem_7:15:30000:53': 39.6,
  'mem_7:15:30000:54': 39.6,
  'mem_7:15:30000:55': 39.6,
  'mem_7:15:30000:56': 43.2,
  'mem_7:15:30000:57': 43.2,
  'mem_7:15:30000:58': 43.2,
  'mem_7:15:30000:59': 43.2,
  'mem_7:15:30000:60': 43.2,
  'mem_7:15:30000:61': 48,
  'mem_7:15:30000:62': 48,
  'mem_7:15:30000:63': 48,
  'mem_7:15:30000:64': 48,
  'mem_7:15:30000:65': 48,
  'mem_7:15:30000:66': 69.6,
  'mem_7:15:30000:67': 69.6,
  'mem_7:15:30000:68': 69.6,
  'mem_7:15:30000:69': 69.6,
  'mem_7:15:30000:70': 69.6,
  'mem_7:15:30000:71': 104.4,
  'mem_7:15:30000:72': 104.4,
  'mem_7:15:30000:73': 104.4,
  'mem_7:15:30000:74': 104.4,
  'mem_7:15:30000:75': 104.4,
  'mem_7:15:30000:76': 141.6,
  'mem_7:15:30000:77': 141.6,
  'mem_7:15:30000:78': 141.6,
  'mem_7:15:30000:79': 141.6,
  'mem_7:15:30000:80': 141.6,
  'mem_7:15:30000:81': 187.63,
  'mem_7:15:30000:82': 187.63,
  'mem_7:15:30000:83': 187.63,
  'mem_7:15:30000:84': 187.63,
  'mem_7:15:30000:85': 187.63,
  'mem_7:15:30000:86': 260.96,
  'mem_7:15:30000:87': 260.96,
  'mem_7:15:30000:88': 260.96,
  'mem_7:15:30000:89': 260.96,
  'mem_7:15:30000:90': 260.96,
  'mem_7:15:30000:91': 363.18,
  'mem_7:15:30000:92': 363.18,
  'mem_7:15:30000:93': 363.18,
  'mem_7:15:30000:94': 363.18,
  'mem_7:15:30000:95': 363.18,
  'mem_7:15:30000:96': 595.65,
  'mem_7:15:30000:97': 595.65,
  'mem_7:15:30000:98': 595.65,
  'mem_7:15:30000:99': 595.65,
  'mem_7:15:30000:100': 595.65,
  'mem_7:15:40000:1': 4.8,
  'mem_7:15:40000:2': 4.8,
  'mem_7:15:40000:3': 4.8,
  'mem_7:15:40000:4': 4.8,
  'mem_7:15:40000:5': 4.8,
  'mem_7:15:40000:6': 4.8,
  'mem_7:15:40000:7': 4.8,
  'mem_7:15:40000:8': 4.8,
  'mem_7:15:40000:9': 4.8,
  'mem_7:15:40000:10': 4.8,
  'mem_7:15:40000:11': 6,
  'mem_7:15:40000:12': 6,
  'mem_7:15:40000:13': 6,
  'mem_7:15:40000:14': 6,
  'mem_7:15:40000:15': 6,
  'mem_7:15:40000:16': 6,
  'mem_7:15:40000:17': 6,
  'mem_7:15:40000:18': 6,
  'mem_7:15:40000:19': 6,
  'mem_7:15:40000:20': 6,
  'mem_7:15:40000:21': 6,
  'mem_7:15:40000:22': 6,
  'mem_7:15:40000:23': 6,
  'mem_7:15:40000:24': 6,
  'mem_7:15:40000:25': 6,
  'mem_7:15:40000:26': 7.2,
  'mem_7:15:40000:27': 7.2,
  'mem_7:15:40000:28': 7.2,
  'mem_7:15:40000:29': 7.2,
  'mem_7:15:40000:30': 7.2,
  'mem_7:15:40000:31': 9.6,
  'mem_7:15:40000:32': 9.6,
  'mem_7:15:40000:33': 9.6,
  'mem_7:15:40000:34': 9.6,
  'mem_7:15:40000:35': 9.6,
  'mem_7:15:40000:36': 14.4,
  'mem_7:15:40000:37': 14.4,
  'mem_7:15:40000:38': 14.4,
  'mem_7:15:40000:39': 14.4,
  'mem_7:15:40000:40': 14.4,
  'mem_7:15:40000:41': 22.8,
  'mem_7:15:40000:42': 22.8,
  'mem_7:15:40000:43': 22.8,
  'mem_7:15:40000:44': 22.8,
  'mem_7:15:40000:45': 22.8,
  'mem_7:15:40000:46': 34.8,
  'mem_7:15:40000:47': 34.8,
  'mem_7:15:40000:48': 34.8,
  'mem_7:15:40000:49': 34.8,
  'mem_7:15:40000:50': 34.8,
  'mem_7:15:40000:51': 52.8,
  'mem_7:15:40000:52': 52.8,
  'mem_7:15:40000:53': 52.8,
  'mem_7:15:40000:54': 52.8,
  'mem_7:15:40000:55': 52.8,
  'mem_7:15:40000:56': 58.8,
  'mem_7:15:40000:57': 58.8,
  'mem_7:15:40000:58': 58.8,
  'mem_7:15:40000:59': 58.8,
  'mem_7:15:40000:60': 58.8,
  'mem_7:15:40000:61': 64.8,
  'mem_7:15:40000:62': 64.8,
  'mem_7:15:40000:63': 64.8,
  'mem_7:15:40000:64': 64.8,
  'mem_7:15:40000:65': 64.8,
  'mem_7:15:40000:66': 93.6,
  'mem_7:15:40000:67': 93.6,
  'mem_7:15:40000:68': 93.6,
  'mem_7:15:40000:69': 93.6,
  'mem_7:15:40000:70': 93.6,
  'mem_7:15:40000:71': 140.4,
  'mem_7:15:40000:72': 140.4,
  'mem_7:15:40000:73': 140.4,
  'mem_7:15:40000:74': 140.4,
  'mem_7:15:40000:75': 140.4,
  'mem_7:15:40000:76': 188.4,
  'mem_7:15:40000:77': 188.4,
  'mem_7:15:40000:78': 188.4,
  'mem_7:15:40000:79': 188.4,
  'mem_7:15:40000:80': 188.4,
  'mem_7:15:40000:81': 250.35,
  'mem_7:15:40000:82': 250.35,
  'mem_7:15:40000:83': 250.35,
  'mem_7:15:40000:84': 250.35,
  'mem_7:15:40000:85': 250.35,
  'mem_7:15:40000:86': 348.18,
  'mem_7:15:40000:87': 348.18,
  'mem_7:15:40000:88': 348.18,
  'mem_7:15:40000:89': 348.18,
  'mem_7:15:40000:90': 348.18,
  'mem_7:15:40000:91': 484.55,
  'mem_7:15:40000:92': 484.55,
  'mem_7:15:40000:93': 484.55,
  'mem_7:15:40000:94': 484.55,
  'mem_7:15:40000:95': 484.55,
  'mem_7:15:40000:96': 794.7,
  'mem_7:15:40000:97': 794.7,
  'mem_7:15:40000:98': 794.7,
  'mem_7:15:40000:99': 794.7,
  'mem_7:15:40000:100': 794.7,
  'mem_7:15:50000:1': 6,
  'mem_7:15:50000:2': 6,
  'mem_7:15:50000:3': 6,
  'mem_7:15:50000:4': 6,
  'mem_7:15:50000:5': 6,
  'mem_7:15:50000:6': 6,
  'mem_7:15:50000:7': 6,
  'mem_7:15:50000:8': 6,
  'mem_7:15:50000:9': 6,
  'mem_7:15:50000:10': 6,
  'mem_7:15:50000:11': 7.2,
  'mem_7:15:50000:12': 7.2,
  'mem_7:15:50000:13': 7.2,
  'mem_7:15:50000:14': 7.2,
  'mem_7:15:50000:15': 7.2,
  'mem_7:15:50000:16': 7.2,
  'mem_7:15:50000:17': 7.2,
  'mem_7:15:50000:18': 7.2,
  'mem_7:15:50000:19': 7.2,
  'mem_7:15:50000:20': 7.2,
  'mem_7:15:50000:21': 7.2,
  'mem_7:15:50000:22': 7.2,
  'mem_7:15:50000:23': 7.2,
  'mem_7:15:50000:24': 7.2,
  'mem_7:15:50000:25': 7.2,
  'mem_7:15:50000:26': 9.6,
  'mem_7:15:50000:27': 9.6,
  'mem_7:15:50000:28': 9.6,
  'mem_7:15:50000:29': 9.6,
  'mem_7:15:50000:30': 9.6,
  'mem_7:15:50000:31': 12,
  'mem_7:15:50000:32': 12,
  'mem_7:15:50000:33': 12,
  'mem_7:15:50000:34': 12,
  'mem_7:15:50000:35': 12,
  'mem_7:15:50000:36': 18,
  'mem_7:15:50000:37': 18,
  'mem_7:15:50000:38': 18,
  'mem_7:15:50000:39': 18,
  'mem_7:15:50000:40': 18,
  'mem_7:15:50000:41': 28.8,
  'mem_7:15:50000:42': 28.8,
  'mem_7:15:50000:43': 28.8,
  'mem_7:15:50000:44': 28.8,
  'mem_7:15:50000:45': 28.8,
  'mem_7:15:50000:46': 44.4,
  'mem_7:15:50000:47': 44.4,
  'mem_7:15:50000:48': 44.4,
  'mem_7:15:50000:49': 44.4,
  'mem_7:15:50000:50': 44.4,
  'mem_7:15:50000:51': 66,
  'mem_7:15:50000:52': 66,
  'mem_7:15:50000:53': 66,
  'mem_7:15:50000:54': 66,
  'mem_7:15:50000:55': 66,
  'mem_7:15:50000:56': 73.2,
  'mem_7:15:50000:57': 73.2,
  'mem_7:15:50000:58': 73.2,
  'mem_7:15:50000:59': 73.2,
  'mem_7:15:50000:60': 73.2,
  'mem_7:15:50000:61': 80.4,
  'mem_7:15:50000:62': 80.4,
  'mem_7:15:50000:63': 80.4,
  'mem_7:15:50000:64': 80.4,
  'mem_7:15:50000:65': 80.4,
  'mem_7:15:50000:66': 116.4,
  'mem_7:15:50000:67': 116.4,
  'mem_7:15:50000:68': 116.4,
  'mem_7:15:50000:69': 116.4,
  'mem_7:15:50000:70': 116.4,
  'mem_7:15:50000:71': 175.2,
  'mem_7:15:50000:72': 175.2,
  'mem_7:15:50000:73': 175.2,
  'mem_7:15:50000:74': 175.2,
  'mem_7:15:50000:75': 175.2,
  'mem_7:15:50000:76': 236.4,
  'mem_7:15:50000:77': 236.4,
  'mem_7:15:50000:78': 236.4,
  'mem_7:15:50000:79': 236.4,
  'mem_7:15:50000:80': 236.4,
  'mem_7:15:50000:81': 313.03,
  'mem_7:15:50000:82': 313.03,
  'mem_7:15:50000:83': 313.03,
  'mem_7:15:50000:84': 313.03,
  'mem_7:15:50000:85': 313.03,
  'mem_7:15:50000:86': 435.35,
  'mem_7:15:50000:87': 435.35,
  'mem_7:15:50000:88': 435.35,
  'mem_7:15:50000:89': 435.35,
  'mem_7:15:50000:90': 435.35,
  'mem_7:15:50000:91': 605.85,
  'mem_7:15:50000:92': 605.85,
  'mem_7:15:50000:93': 605.85,
  'mem_7:15:50000:94': 605.85,
  'mem_7:15:50000:95': 605.85,
  'mem_7:15:50000:96': 993.62,
  'mem_7:15:50000:97': 993.62,
  'mem_7:15:50000:98': 993.62,
  'mem_7:15:50000:99': 993.62,
  'mem_7:15:50000:100': 993.62,
  'mem_7:15:60000:1': 7.09,
  'mem_7:15:60000:2': 7.09,
  'mem_7:15:60000:3': 7.09,
  'mem_7:15:60000:4': 7.09,
  'mem_7:15:60000:5': 7.09,
  'mem_7:15:60000:6': 7.08,
  'mem_7:15:60000:7': 7.08,
  'mem_7:15:60000:8': 7.08,
  'mem_7:15:60000:9': 7.08,
  'mem_7:15:60000:10': 7.08,
  'mem_7:15:60000:11': 8.12,
  'mem_7:15:60000:12': 8.12,
  'mem_7:15:60000:13': 8.12,
  'mem_7:15:60000:14': 8.12,
  'mem_7:15:60000:15': 8.12,
  'mem_7:15:60000:16': 8.16,
  'mem_7:15:60000:17': 8.16,
  'mem_7:15:60000:18': 8.16,
  'mem_7:15:60000:19': 8.16,
  'mem_7:15:60000:20': 8.16,
  'mem_7:15:60000:21': 8.28,
  'mem_7:15:60000:22': 8.28,
  'mem_7:15:60000:23': 8.28,
  'mem_7:15:60000:24': 8.28,
  'mem_7:15:60000:25': 8.28,
  'mem_7:15:60000:26': 10.64,
  'mem_7:15:60000:27': 10.64,
  'mem_7:15:60000:28': 10.64,
  'mem_7:15:60000:29': 10.64,
  'mem_7:15:60000:30': 10.64,
  'mem_7:15:60000:31': 13.39,
  'mem_7:15:60000:32': 13.39,
  'mem_7:15:60000:33': 13.39,
  'mem_7:15:60000:34': 13.39,
  'mem_7:15:60000:35': 13.39,
  'mem_7:15:60000:36': 19.9,
  'mem_7:15:60000:37': 19.9,
  'mem_7:15:60000:38': 19.9,
  'mem_7:15:60000:39': 19.9,
  'mem_7:15:60000:40': 19.9,
  'mem_7:15:60000:41': 31.54,
  'mem_7:15:60000:42': 31.54,
  'mem_7:15:60000:43': 31.54,
  'mem_7:15:60000:44': 31.54,
  'mem_7:15:60000:45': 31.54,
  'mem_7:15:60000:46': 48.51,
  'mem_7:15:60000:47': 48.51,
  'mem_7:15:60000:48': 48.51,
  'mem_7:15:60000:49': 48.51,
  'mem_7:15:60000:50': 48.51,
  'mem_7:15:60000:51': 72.29,
  'mem_7:15:60000:52': 72.29,
  'mem_7:15:60000:53': 72.29,
  'mem_7:15:60000:54': 72.29,
  'mem_7:15:60000:55': 72.29,
  'mem_7:15:60000:56': 85,
  'mem_7:15:60000:57': 85,
  'mem_7:15:60000:58': 85,
  'mem_7:15:60000:59': 85,
  'mem_7:15:60000:60': 85,
  'mem_7:15:60000:61': 100.49,
  'mem_7:15:60000:62': 100.49,
  'mem_7:15:60000:63': 100.49,
  'mem_7:15:60000:64': 100.49,
  'mem_7:15:60000:65': 100.49,
  'mem_7:15:60000:66': 145.69,
  'mem_7:15:60000:67': 145.69,
  'mem_7:15:60000:68': 145.69,
  'mem_7:15:60000:69': 145.69,
  'mem_7:15:60000:70': 145.69,
  'mem_7:15:60000:71': 211.33,
  'mem_7:15:60000:72': 211.33,
  'mem_7:15:60000:73': 211.33,
  'mem_7:15:60000:74': 211.33,
  'mem_7:15:60000:75': 211.33,
  'mem_7:15:60000:76': 288.78,
  'mem_7:15:60000:77': 288.78,
  'mem_7:15:60000:78': 288.78,
  'mem_7:15:60000:79': 288.78,
  'mem_7:15:60000:80': 288.78,
  'mem_7:15:60000:81': 393.48,
  'mem_7:15:60000:82': 393.48,
  'mem_7:15:60000:83': 393.48,
  'mem_7:15:60000:84': 393.48,
  'mem_7:15:60000:85': 393.48,
  'mem_7:15:60000:86': 547.24,
  'mem_7:15:60000:87': 547.24,
  'mem_7:15:60000:88': 547.24,
  'mem_7:15:60000:89': 547.24,
  'mem_7:15:60000:90': 547.24,
  'mem_7:15:60000:91': 761.56,
  'mem_7:15:60000:92': 761.56,
  'mem_7:15:60000:93': 761.56,
  'mem_7:15:60000:94': 761.56,
  'mem_7:15:60000:95': 761.56,
  'mem_7:15:60000:96': 1249.01,
  'mem_7:15:60000:97': 1249.01,
  'mem_7:15:60000:98': 1249.01,
  'mem_7:15:60000:99': 1249.01,
  'mem_7:15:60000:100': 1249.01,
  'mem_7:15:70000:1': 8.18,
  'mem_7:15:70000:2': 8.18,
  'mem_7:15:70000:3': 8.18,
  'mem_7:15:70000:4': 8.18,
  'mem_7:15:70000:5': 8.18,
  'mem_7:15:70000:6': 8.16,
  'mem_7:15:70000:7': 8.16,
  'mem_7:15:70000:8': 8.16,
  'mem_7:15:70000:9': 8.16,
  'mem_7:15:70000:10': 8.16,
  'mem_7:15:70000:11': 9.03,
  'mem_7:15:70000:12': 9.03,
  'mem_7:15:70000:13': 9.03,
  'mem_7:15:70000:14': 9.03,
  'mem_7:15:70000:15': 9.03,
  'mem_7:15:70000:16': 9.11,
  'mem_7:15:70000:17': 9.11,
  'mem_7:15:70000:18': 9.11,
  'mem_7:15:70000:19': 9.11,
  'mem_7:15:70000:20': 9.11,
  'mem_7:15:70000:21': 9.35,
  'mem_7:15:70000:22': 9.35,
  'mem_7:15:70000:23': 9.35,
  'mem_7:15:70000:24': 9.35,
  'mem_7:15:70000:25': 9.35,
  'mem_7:15:70000:26': 11.67,
  'mem_7:15:70000:27': 11.67,
  'mem_7:15:70000:28': 11.67,
  'mem_7:15:70000:29': 11.67,
  'mem_7:15:70000:30': 11.67,
  'mem_7:15:70000:31': 14.78,
  'mem_7:15:70000:32': 14.78,
  'mem_7:15:70000:33': 14.78,
  'mem_7:15:70000:34': 14.78,
  'mem_7:15:70000:35': 14.78,
  'mem_7:15:70000:36': 21.79,
  'mem_7:15:70000:37': 21.79,
  'mem_7:15:70000:38': 21.79,
  'mem_7:15:70000:39': 21.79,
  'mem_7:15:70000:40': 21.79,
  'mem_7:15:70000:41': 34.29,
  'mem_7:15:70000:42': 34.29,
  'mem_7:15:70000:43': 34.29,
  'mem_7:15:70000:44': 34.29,
  'mem_7:15:70000:45': 34.29,
  'mem_7:15:70000:46': 52.62,
  'mem_7:15:70000:47': 52.62,
  'mem_7:15:70000:48': 52.62,
  'mem_7:15:70000:49': 52.62,
  'mem_7:15:70000:50': 52.62,
  'mem_7:15:70000:51': 78.57,
  'mem_7:15:70000:52': 78.57,
  'mem_7:15:70000:53': 78.57,
  'mem_7:15:70000:54': 78.57,
  'mem_7:15:70000:55': 78.57,
  'mem_7:15:70000:56': 96.81,
  'mem_7:15:70000:57': 96.81,
  'mem_7:15:70000:58': 96.81,
  'mem_7:15:70000:59': 96.81,
  'mem_7:15:70000:60': 96.81,
  'mem_7:15:70000:61': 120.57,
  'mem_7:15:70000:62': 120.57,
  'mem_7:15:70000:63': 120.57,
  'mem_7:15:70000:64': 120.57,
  'mem_7:15:70000:65': 120.57,
  'mem_7:15:70000:66': 174.98,
  'mem_7:15:70000:67': 174.98,
  'mem_7:15:70000:68': 174.98,
  'mem_7:15:70000:69': 174.98,
  'mem_7:15:70000:70': 174.98,
  'mem_7:15:70000:71': 247.46,
  'mem_7:15:70000:72': 247.46,
  'mem_7:15:70000:73': 247.46,
  'mem_7:15:70000:74': 247.46,
  'mem_7:15:70000:75': 247.46,
  'mem_7:15:70000:76': 341.17,
  'mem_7:15:70000:77': 341.17,
  'mem_7:15:70000:78': 341.17,
  'mem_7:15:70000:79': 341.17,
  'mem_7:15:70000:80': 341.17,
  'mem_7:15:70000:81': 473.93,
  'mem_7:15:70000:82': 473.93,
  'mem_7:15:70000:83': 473.93,
  'mem_7:15:70000:84': 473.93,
  'mem_7:15:70000:85': 473.93,
  'mem_7:15:70000:86': 659.14,
  'mem_7:15:70000:87': 659.14,
  'mem_7:15:70000:88': 659.14,
  'mem_7:15:70000:89': 659.14,
  'mem_7:15:70000:90': 659.14,
  'mem_7:15:70000:91': 917.28,
  'mem_7:15:70000:92': 917.28,
  'mem_7:15:70000:93': 917.28,
  'mem_7:15:70000:94': 917.28,
  'mem_7:15:70000:95': 917.28,
  'mem_7:15:70000:96': 1504.4,
  'mem_7:15:70000:97': 1504.4,
  'mem_7:15:70000:98': 1504.4,
  'mem_7:15:70000:99': 1504.4,
  'mem_7:15:70000:100': 1504.4,
  'mem_7:15:80000:1': 9.26,
  'mem_7:15:80000:2': 9.26,
  'mem_7:15:80000:3': 9.26,
  'mem_7:15:80000:4': 9.26,
  'mem_7:15:80000:5': 9.26,
  'mem_7:15:80000:6': 9.24,
  'mem_7:15:80000:7': 9.24,
  'mem_7:15:80000:8': 9.24,
  'mem_7:15:80000:9': 9.24,
  'mem_7:15:80000:10': 9.24,
  'mem_7:15:80000:11': 9.95,
  'mem_7:15:80000:12': 9.95,
  'mem_7:15:80000:13': 9.95,
  'mem_7:15:80000:14': 9.95,
  'mem_7:15:80000:15': 9.95,
  'mem_7:15:80000:16': 10.07,
  'mem_7:15:80000:17': 10.07,
  'mem_7:15:80000:18': 10.07,
  'mem_7:15:80000:19': 10.07,
  'mem_7:15:80000:20': 10.07,
  'mem_7:15:80000:21': 10.43,
  'mem_7:15:80000:22': 10.43,
  'mem_7:15:80000:23': 10.43,
  'mem_7:15:80000:24': 10.43,
  'mem_7:15:80000:25': 10.43,
  'mem_7:15:80000:26': 12.71,
  'mem_7:15:80000:27': 12.71,
  'mem_7:15:80000:28': 12.71,
  'mem_7:15:80000:29': 12.71,
  'mem_7:15:80000:30': 12.71,
  'mem_7:15:80000:31': 16.17,
  'mem_7:15:80000:32': 16.17,
  'mem_7:15:80000:33': 16.17,
  'mem_7:15:80000:34': 16.17,
  'mem_7:15:80000:35': 16.17,
  'mem_7:15:80000:36': 23.69,
  'mem_7:15:80000:37': 23.69,
  'mem_7:15:80000:38': 23.69,
  'mem_7:15:80000:39': 23.69,
  'mem_7:15:80000:40': 23.69,
  'mem_7:15:80000:41': 37.03,
  'mem_7:15:80000:42': 37.03,
  'mem_7:15:80000:43': 37.03,
  'mem_7:15:80000:44': 37.03,
  'mem_7:15:80000:45': 37.03,
  'mem_7:15:80000:46': 56.73,
  'mem_7:15:80000:47': 56.73,
  'mem_7:15:80000:48': 56.73,
  'mem_7:15:80000:49': 56.73,
  'mem_7:15:80000:50': 56.73,
  'mem_7:15:80000:51': 84.86,
  'mem_7:15:80000:52': 84.86,
  'mem_7:15:80000:53': 84.86,
  'mem_7:15:80000:54': 84.86,
  'mem_7:15:80000:55': 84.86,
  'mem_7:15:80000:56': 108.61,
  'mem_7:15:80000:57': 108.61,
  'mem_7:15:80000:58': 108.61,
  'mem_7:15:80000:59': 108.61,
  'mem_7:15:80000:60': 108.61,
  'mem_7:15:80000:61': 140.66,
  'mem_7:15:80000:62': 140.66,
  'mem_7:15:80000:63': 140.66,
  'mem_7:15:80000:64': 140.66,
  'mem_7:15:80000:65': 140.66,
  'mem_7:15:80000:66': 204.27,
  'mem_7:15:80000:67': 204.27,
  'mem_7:15:80000:68': 204.27,
  'mem_7:15:80000:69': 204.27,
  'mem_7:15:80000:70': 204.27,
  'mem_7:15:80000:71': 283.6,
  'mem_7:15:80000:72': 283.6,
  'mem_7:15:80000:73': 283.6,
  'mem_7:15:80000:74': 283.6,
  'mem_7:15:80000:75': 283.6,
  'mem_7:15:80000:76': 393.55,
  'mem_7:15:80000:77': 393.55,
  'mem_7:15:80000:78': 393.55,
  'mem_7:15:80000:79': 393.55,
  'mem_7:15:80000:80': 393.55,
  'mem_7:15:80000:81': 554.38,
  'mem_7:15:80000:82': 554.38,
  'mem_7:15:80000:83': 554.38,
  'mem_7:15:80000:84': 554.38,
  'mem_7:15:80000:85': 554.38,
  'mem_7:15:80000:86': 771.03,
  'mem_7:15:80000:87': 771.03,
  'mem_7:15:80000:88': 771.03,
  'mem_7:15:80000:89': 771.03,
  'mem_7:15:80000:90': 771.03,
  'mem_7:15:80000:91': 1072.99,
  'mem_7:15:80000:92': 1072.99,
  'mem_7:15:80000:93': 1072.99,
  'mem_7:15:80000:94': 1072.99,
  'mem_7:15:80000:95': 1072.99,
  'mem_7:15:80000:96': 1759.79,
  'mem_7:15:80000:97': 1759.79,
  'mem_7:15:80000:98': 1759.79,
  'mem_7:15:80000:99': 1759.79,
  'mem_7:15:80000:100': 1759.79,
  'mem_7:15:90000:1': 10.35,
  'mem_7:15:90000:2': 10.35,
  'mem_7:15:90000:3': 10.35,
  'mem_7:15:90000:4': 10.35,
  'mem_7:15:90000:5': 10.35,
  'mem_7:15:90000:6': 10.32,
  'mem_7:15:90000:7': 10.32,
  'mem_7:15:90000:8': 10.32,
  'mem_7:15:90000:9': 10.32,
  'mem_7:15:90000:10': 10.32,
  'mem_7:15:90000:11': 10.87,
  'mem_7:15:90000:12': 10.87,
  'mem_7:15:90000:13': 10.87,
  'mem_7:15:90000:14': 10.87,
  'mem_7:15:90000:15': 10.87,
  'mem_7:15:90000:16': 11.02,
  'mem_7:15:90000:17': 11.02,
  'mem_7:15:90000:18': 11.02,
  'mem_7:15:90000:19': 11.02,
  'mem_7:15:90000:20': 11.02,
  'mem_7:15:90000:21': 11.5,
  'mem_7:15:90000:22': 11.5,
  'mem_7:15:90000:23': 11.5,
  'mem_7:15:90000:24': 11.5,
  'mem_7:15:90000:25': 11.5,
  'mem_7:15:90000:26': 13.75,
  'mem_7:15:90000:27': 13.75,
  'mem_7:15:90000:28': 13.75,
  'mem_7:15:90000:29': 13.75,
  'mem_7:15:90000:30': 13.75,
  'mem_7:15:90000:31': 17.56,
  'mem_7:15:90000:32': 17.56,
  'mem_7:15:90000:33': 17.56,
  'mem_7:15:90000:34': 17.56,
  'mem_7:15:90000:35': 17.56,
  'mem_7:15:90000:36': 25.58,
  'mem_7:15:90000:37': 25.58,
  'mem_7:15:90000:38': 25.58,
  'mem_7:15:90000:39': 25.58,
  'mem_7:15:90000:40': 25.58,
  'mem_7:15:90000:41': 39.77,
  'mem_7:15:90000:42': 39.77,
  'mem_7:15:90000:43': 39.77,
  'mem_7:15:90000:44': 39.77,
  'mem_7:15:90000:45': 39.77,
  'mem_7:15:90000:46': 60.85,
  'mem_7:15:90000:47': 60.85,
  'mem_7:15:90000:48': 60.85,
  'mem_7:15:90000:49': 60.85,
  'mem_7:15:90000:50': 60.85,
  'mem_7:15:90000:51': 91.14,
  'mem_7:15:90000:52': 91.14,
  'mem_7:15:90000:53': 91.14,
  'mem_7:15:90000:54': 91.14,
  'mem_7:15:90000:55': 91.14,
  'mem_7:15:90000:56': 120.42,
  'mem_7:15:90000:57': 120.42,
  'mem_7:15:90000:58': 120.42,
  'mem_7:15:90000:59': 120.42,
  'mem_7:15:90000:60': 120.42,
  'mem_7:15:90000:61': 160.74,
  'mem_7:15:90000:62': 160.74,
  'mem_7:15:90000:63': 160.74,
  'mem_7:15:90000:64': 160.74,
  'mem_7:15:90000:65': 160.74,
  'mem_7:15:90000:66': 233.56,
  'mem_7:15:90000:67': 233.56,
  'mem_7:15:90000:68': 233.56,
  'mem_7:15:90000:69': 233.56,
  'mem_7:15:90000:70': 233.56,
  'mem_7:15:90000:71': 319.73,
  'mem_7:15:90000:72': 319.73,
  'mem_7:15:90000:73': 319.73,
  'mem_7:15:90000:74': 319.73,
  'mem_7:15:90000:75': 319.73,
  'mem_7:15:90000:76': 445.93,
  'mem_7:15:90000:77': 445.93,
  'mem_7:15:90000:78': 445.93,
  'mem_7:15:90000:79': 445.93,
  'mem_7:15:90000:80': 445.93,
  'mem_7:15:90000:81': 634.83,
  'mem_7:15:90000:82': 634.83,
  'mem_7:15:90000:83': 634.83,
  'mem_7:15:90000:84': 634.83,
  'mem_7:15:90000:85': 634.83,
  'mem_7:15:90000:86': 882.92,
  'mem_7:15:90000:87': 882.92,
  'mem_7:15:90000:88': 882.92,
  'mem_7:15:90000:89': 882.92,
  'mem_7:15:90000:90': 882.92,
  'mem_7:15:90000:91': 1228.71,
  'mem_7:15:90000:92': 1228.71,
  'mem_7:15:90000:93': 1228.71,
  'mem_7:15:90000:94': 1228.71,
  'mem_7:15:90000:95': 1228.71,
  'mem_7:15:90000:96': 2015.18,
  'mem_7:15:90000:97': 2015.18,
  'mem_7:15:90000:98': 2015.18,
  'mem_7:15:90000:99': 2015.18,
  'mem_7:15:90000:100': 2015.18,
  'mem_7:15:100000:1': 11.44,
  'mem_7:15:100000:2': 11.44,
  'mem_7:15:100000:3': 11.44,
  'mem_7:15:100000:4': 11.44,
  'mem_7:15:100000:5': 11.44,
  'mem_7:15:100000:6': 11.4,
  'mem_7:15:100000:7': 11.4,
  'mem_7:15:100000:8': 11.4,
  'mem_7:15:100000:9': 11.4,
  'mem_7:15:100000:10': 11.4,
  'mem_7:15:100000:11': 11.78,
  'mem_7:15:100000:12': 11.78,
  'mem_7:15:100000:13': 11.78,
  'mem_7:15:100000:14': 11.78,
  'mem_7:15:100000:15': 11.78,
  'mem_7:15:100000:16': 11.98,
  'mem_7:15:100000:17': 11.98,
  'mem_7:15:100000:18': 11.98,
  'mem_7:15:100000:19': 11.98,
  'mem_7:15:100000:20': 11.98,
  'mem_7:15:100000:21': 12.58,
  'mem_7:15:100000:22': 12.58,
  'mem_7:15:100000:23': 12.58,
  'mem_7:15:100000:24': 12.58,
  'mem_7:15:100000:25': 12.58,
  'mem_7:15:100000:26': 14.79,
  'mem_7:15:100000:27': 14.79,
  'mem_7:15:100000:28': 14.79,
  'mem_7:15:100000:29': 14.79,
  'mem_7:15:100000:30': 14.79,
  'mem_7:15:100000:31': 18.95,
  'mem_7:15:100000:32': 18.95,
  'mem_7:15:100000:33': 18.95,
  'mem_7:15:100000:34': 18.95,
  'mem_7:15:100000:35': 18.95,
  'mem_7:15:100000:36': 27.48,
  'mem_7:15:100000:37': 27.48,
  'mem_7:15:100000:38': 27.48,
  'mem_7:15:100000:39': 27.48,
  'mem_7:15:100000:40': 27.48,
  'mem_7:15:100000:41': 42.52,
  'mem_7:15:100000:42': 42.52,
  'mem_7:15:100000:43': 42.52,
  'mem_7:15:100000:44': 42.52,
  'mem_7:15:100000:45': 42.52,
  'mem_7:15:100000:46': 64.96,
  'mem_7:15:100000:47': 64.96,
  'mem_7:15:100000:48': 64.96,
  'mem_7:15:100000:49': 64.96,
  'mem_7:15:100000:50': 64.96,
  'mem_7:15:100000:51': 97.43,
  'mem_7:15:100000:52': 97.43,
  'mem_7:15:100000:53': 97.43,
  'mem_7:15:100000:54': 97.43,
  'mem_7:15:100000:55': 97.43,
  'mem_7:15:100000:56': 132.22,
  'mem_7:15:100000:57': 132.22,
  'mem_7:15:100000:58': 132.22,
  'mem_7:15:100000:59': 132.22,
  'mem_7:15:100000:60': 132.22,
  'mem_7:15:100000:61': 180.83,
  'mem_7:15:100000:62': 180.83,
  'mem_7:15:100000:63': 180.83,
  'mem_7:15:100000:64': 180.83,
  'mem_7:15:100000:65': 180.83,
  'mem_7:15:100000:66': 262.86,
  'mem_7:15:100000:67': 262.86,
  'mem_7:15:100000:68': 262.86,
  'mem_7:15:100000:69': 262.86,
  'mem_7:15:100000:70': 262.86,
  'mem_7:15:100000:71': 355.86,
  'mem_7:15:100000:72': 355.86,
  'mem_7:15:100000:73': 355.86,
  'mem_7:15:100000:74': 355.86,
  'mem_7:15:100000:75': 355.86,
  'mem_7:15:100000:76': 498.31,
  'mem_7:15:100000:77': 498.31,
  'mem_7:15:100000:78': 498.31,
  'mem_7:15:100000:79': 498.31,
  'mem_7:15:100000:80': 498.31,
  'mem_7:15:100000:81': 715.29,
  'mem_7:15:100000:82': 715.29,
  'mem_7:15:100000:83': 715.29,
  'mem_7:15:100000:84': 715.29,
  'mem_7:15:100000:85': 715.29,
  'mem_7:15:100000:86': 994.81,
  'mem_7:15:100000:87': 994.81,
  'mem_7:15:100000:88': 994.81,
  'mem_7:15:100000:89': 994.81,
  'mem_7:15:100000:90': 994.81,
  'mem_7:15:100000:91': 1384.43,
  'mem_7:15:100000:92': 1384.43,
  'mem_7:15:100000:93': 1384.43,
  'mem_7:15:100000:94': 1384.43,
  'mem_7:15:100000:95': 1384.43,
  'mem_7:15:100000:96': 2270.57,
  'mem_7:15:100000:97': 2270.57,
  'mem_7:15:100000:98': 2270.57,
  'mem_7:15:100000:99': 2270.57,
  'mem_7:15:100000:100': 2270.57,
  'mem_7:15:120000:1': 12.53,
  'mem_7:15:120000:2': 12.53,
  'mem_7:15:120000:3': 12.53,
  'mem_7:15:120000:4': 12.53,
  'mem_7:15:120000:5': 12.53,
  'mem_7:15:120000:6': 12.48,
  'mem_7:15:120000:7': 12.48,
  'mem_7:15:120000:8': 12.48,
  'mem_7:15:120000:9': 12.48,
  'mem_7:15:120000:10': 12.48,
  'mem_7:15:120000:11': 12.7,
  'mem_7:15:120000:12': 12.7,
  'mem_7:15:120000:13': 12.7,
  'mem_7:15:120000:14': 12.7,
  'mem_7:15:120000:15': 12.7,
  'mem_7:15:120000:16': 12.93,
  'mem_7:15:120000:17': 12.93,
  'mem_7:15:120000:18': 12.93,
  'mem_7:15:120000:19': 12.93,
  'mem_7:15:120000:20': 12.93,
  'mem_7:15:120000:21': 13.65,
  'mem_7:15:120000:22': 13.65,
  'mem_7:15:120000:23': 13.65,
  'mem_7:15:120000:24': 13.65,
  'mem_7:15:120000:25': 13.65,
  'mem_7:15:120000:26': 15.82,
  'mem_7:15:120000:27': 15.82,
  'mem_7:15:120000:28': 15.82,
  'mem_7:15:120000:29': 15.82,
  'mem_7:15:120000:30': 15.82,
  'mem_7:15:120000:31': 20.34,
  'mem_7:15:120000:32': 20.34,
  'mem_7:15:120000:33': 20.34,
  'mem_7:15:120000:34': 20.34,
  'mem_7:15:120000:35': 20.34,
  'mem_7:15:120000:36': 29.37,
  'mem_7:15:120000:37': 29.37,
  'mem_7:15:120000:38': 29.37,
  'mem_7:15:120000:39': 29.37,
  'mem_7:15:120000:40': 29.37,
  'mem_7:15:120000:41': 45.26,
  'mem_7:15:120000:42': 45.26,
  'mem_7:15:120000:43': 45.26,
  'mem_7:15:120000:44': 45.26,
  'mem_7:15:120000:45': 45.26,
  'mem_7:15:120000:46': 69.07,
  'mem_7:15:120000:47': 69.07,
  'mem_7:15:120000:48': 69.07,
  'mem_7:15:120000:49': 69.07,
  'mem_7:15:120000:50': 69.07,
  'mem_7:15:120000:51': 103.71,
  'mem_7:15:120000:52': 103.71,
  'mem_7:15:120000:53': 103.71,
  'mem_7:15:120000:54': 103.71,
  'mem_7:15:120000:55': 103.71,
  'mem_7:15:120000:56': 144.03,
  'mem_7:15:120000:57': 144.03,
  'mem_7:15:120000:58': 144.03,
  'mem_7:15:120000:59': 144.03,
  'mem_7:15:120000:60': 144.03,
  'mem_7:15:120000:61': 200.91,
  'mem_7:15:120000:62': 200.91,
  'mem_7:15:120000:63': 200.91,
  'mem_7:15:120000:64': 200.91,
  'mem_7:15:120000:65': 200.91,
  'mem_7:15:120000:66': 292.15,
  'mem_7:15:120000:67': 292.15,
  'mem_7:15:120000:68': 292.15,
  'mem_7:15:120000:69': 292.15,
  'mem_7:15:120000:70': 292.15,
  'mem_7:15:120000:71': 391.99,
  'mem_7:15:120000:72': 391.99,
  'mem_7:15:120000:73': 391.99,
  'mem_7:15:120000:74': 391.99,
  'mem_7:15:120000:75': 391.99,
  'mem_7:15:120000:76': 550.7,
  'mem_7:15:120000:77': 550.7,
  'mem_7:15:120000:78': 550.7,
  'mem_7:15:120000:79': 550.7,
  'mem_7:15:120000:80': 550.7,
  'mem_7:15:120000:81': 795.74,
  'mem_7:15:120000:82': 795.74,
  'mem_7:15:120000:83': 795.74,
  'mem_7:15:120000:84': 795.74,
  'mem_7:15:120000:85': 795.74,
  'mem_7:15:120000:86': 1106.7,
  'mem_7:15:120000:87': 1106.7,
  'mem_7:15:120000:88': 1106.7,
  'mem_7:15:120000:89': 1106.7,
  'mem_7:15:120000:90': 1106.7,
  'mem_7:15:120000:91': 1540.14,
  'mem_7:15:120000:92': 1540.14,
  'mem_7:15:120000:93': 1540.14,
  'mem_7:15:120000:94': 1540.14,
  'mem_7:15:120000:95': 1540.14,
  'mem_7:15:120000:96': 2525.96,
  'mem_7:15:120000:97': 2525.96,
  'mem_7:15:120000:98': 2525.96,
  'mem_7:15:120000:99': 2525.96,
  'mem_7:15:120000:100': 2525.96,
  'mem_7:15:140000:1': 13.62,
  'mem_7:15:140000:2': 13.62,
  'mem_7:15:140000:3': 13.62,
  'mem_7:15:140000:4': 13.62,
  'mem_7:15:140000:5': 13.62,
  'mem_7:15:140000:6': 13.56,
  'mem_7:15:140000:7': 13.56,
  'mem_7:15:140000:8': 13.56,
  'mem_7:15:140000:9': 13.56,
  'mem_7:15:140000:10': 13.56,
  'mem_7:15:140000:11': 13.62,
  'mem_7:15:140000:12': 13.62,
  'mem_7:15:140000:13': 13.62,
  'mem_7:15:140000:14': 13.62,
  'mem_7:15:140000:15': 13.62,
  'mem_7:15:140000:16': 13.89,
  'mem_7:15:140000:17': 13.89,
  'mem_7:15:140000:18': 13.89,
  'mem_7:15:140000:19': 13.89,
  'mem_7:15:140000:20': 13.89,
  'mem_7:15:140000:21': 14.73,
  'mem_7:15:140000:22': 14.73,
  'mem_7:15:140000:23': 14.73,
  'mem_7:15:140000:24': 14.73,
  'mem_7:15:140000:25': 14.73,
  'mem_7:15:140000:26': 16.86,
  'mem_7:15:140000:27': 16.86,
  'mem_7:15:140000:28': 16.86,
  'mem_7:15:140000:29': 16.86,
  'mem_7:15:140000:30': 16.86,
  'mem_7:15:140000:31': 21.73,
  'mem_7:15:140000:32': 21.73,
  'mem_7:15:140000:33': 21.73,
  'mem_7:15:140000:34': 21.73,
  'mem_7:15:140000:35': 21.73,
  'mem_7:15:140000:36': 31.27,
  'mem_7:15:140000:37': 31.27,
  'mem_7:15:140000:38': 31.27,
  'mem_7:15:140000:39': 31.27,
  'mem_7:15:140000:40': 31.27,
  'mem_7:15:140000:41': 48,
  'mem_7:15:140000:42': 48,
  'mem_7:15:140000:43': 48,
  'mem_7:15:140000:44': 48,
  'mem_7:15:140000:45': 48,
  'mem_7:15:140000:46': 73.18,
  'mem_7:15:140000:47': 73.18,
  'mem_7:15:140000:48': 73.18,
  'mem_7:15:140000:49': 73.18,
  'mem_7:15:140000:50': 73.18,
  'mem_7:15:140000:51': 110,
  'mem_7:15:140000:52': 110,
  'mem_7:15:140000:53': 110,
  'mem_7:15:140000:54': 110,
  'mem_7:15:140000:55': 110,
  'mem_7:15:140000:56': 155.83,
  'mem_7:15:140000:57': 155.83,
  'mem_7:15:140000:58': 155.83,
  'mem_7:15:140000:59': 155.83,
  'mem_7:15:140000:60': 155.83,
  'mem_7:15:140000:61': 221,
  'mem_7:15:140000:62': 221,
  'mem_7:15:140000:63': 221,
  'mem_7:15:140000:64': 221,
  'mem_7:15:140000:65': 221,
  'mem_7:15:140000:66': 321.44,
  'mem_7:15:140000:67': 321.44,
  'mem_7:15:140000:68': 321.44,
  'mem_7:15:140000:69': 321.44,
  'mem_7:15:140000:70': 321.44,
  'mem_7:15:140000:71': 428.12,
  'mem_7:15:140000:72': 428.12,
  'mem_7:15:140000:73': 428.12,
  'mem_7:15:140000:74': 428.12,
  'mem_7:15:140000:75': 428.12,
  'mem_7:15:140000:76': 603.08,
  'mem_7:15:140000:77': 603.08,
  'mem_7:15:140000:78': 603.08,
  'mem_7:15:140000:79': 603.08,
  'mem_7:15:140000:80': 603.08,
  'mem_7:15:140000:81': 876.19,
  'mem_7:15:140000:82': 876.19,
  'mem_7:15:140000:83': 876.19,
  'mem_7:15:140000:84': 876.19,
  'mem_7:15:140000:85': 876.19,
  'mem_7:15:140000:86': 1218.6,
  'mem_7:15:140000:87': 1218.6,
  'mem_7:15:140000:88': 1218.6,
  'mem_7:15:140000:89': 1218.6,
  'mem_7:15:140000:90': 1218.6,
  'mem_7:15:140000:91': 1695.86,
  'mem_7:15:140000:92': 1695.86,
  'mem_7:15:140000:93': 1695.86,
  'mem_7:15:140000:94': 1695.86,
  'mem_7:15:140000:95': 1695.86,
  'mem_7:15:140000:96': 2781.35,
  'mem_7:15:140000:97': 2781.35,
  'mem_7:15:140000:98': 2781.35,
  'mem_7:15:140000:99': 2781.35,
  'mem_7:15:140000:100': 2781.35,
  'mem_7:15:160000:1': 15.57,
  'mem_7:15:160000:2': 15.57,
  'mem_7:15:160000:3': 15.57,
  'mem_7:15:160000:4': 15.57,
  'mem_7:15:160000:5': 15.57,
  'mem_7:15:160000:6': 15.51,
  'mem_7:15:160000:7': 15.51,
  'mem_7:15:160000:8': 15.51,
  'mem_7:15:160000:9': 15.51,
  'mem_7:15:160000:10': 15.51,
  'mem_7:15:160000:11': 15.57,
  'mem_7:15:160000:12': 15.57,
  'mem_7:15:160000:13': 15.57,
  'mem_7:15:160000:14': 15.57,
  'mem_7:15:160000:15': 15.57,
  'mem_7:15:160000:16': 15.88,
  'mem_7:15:160000:17': 15.88,
  'mem_7:15:160000:18': 15.88,
  'mem_7:15:160000:19': 15.88,
  'mem_7:15:160000:20': 15.88,
  'mem_7:15:160000:21': 16.83,
  'mem_7:15:160000:22': 16.83,
  'mem_7:15:160000:23': 16.83,
  'mem_7:15:160000:24': 16.83,
  'mem_7:15:160000:25': 16.83,
  'mem_7:15:160000:26': 19.28,
  'mem_7:15:160000:27': 19.28,
  'mem_7:15:160000:28': 19.28,
  'mem_7:15:160000:29': 19.28,
  'mem_7:15:160000:30': 19.28,
  'mem_7:15:160000:31': 24.85,
  'mem_7:15:160000:32': 24.85,
  'mem_7:15:160000:33': 24.85,
  'mem_7:15:160000:34': 24.85,
  'mem_7:15:160000:35': 24.85,
  'mem_7:15:160000:36': 35.75,
  'mem_7:15:160000:37': 35.75,
  'mem_7:15:160000:38': 35.75,
  'mem_7:15:160000:39': 35.75,
  'mem_7:15:160000:40': 35.75,
  'mem_7:15:160000:41': 54.88,
  'mem_7:15:160000:42': 54.88,
  'mem_7:15:160000:43': 54.88,
  'mem_7:15:160000:44': 54.88,
  'mem_7:15:160000:45': 54.88,
  'mem_7:15:160000:46': 83.67,
  'mem_7:15:160000:47': 83.67,
  'mem_7:15:160000:48': 83.67,
  'mem_7:15:160000:49': 83.67,
  'mem_7:15:160000:50': 83.67,
  'mem_7:15:160000:51': 125.75,
  'mem_7:15:160000:52': 125.75,
  'mem_7:15:160000:53': 125.75,
  'mem_7:15:160000:54': 125.75,
  'mem_7:15:160000:55': 125.75,
  'mem_7:15:160000:56': 178.15,
  'mem_7:15:160000:57': 178.15,
  'mem_7:15:160000:58': 178.15,
  'mem_7:15:160000:59': 178.15,
  'mem_7:15:160000:60': 178.15,
  'mem_7:15:160000:61': 252.65,
  'mem_7:15:160000:62': 252.65,
  'mem_7:15:160000:63': 252.65,
  'mem_7:15:160000:64': 252.65,
  'mem_7:15:160000:65': 252.65,
  'mem_7:15:160000:66': 367.47,
  'mem_7:15:160000:67': 367.47,
  'mem_7:15:160000:68': 367.47,
  'mem_7:15:160000:69': 367.47,
  'mem_7:15:160000:70': 367.47,
  'mem_7:15:160000:71': 489.42,
  'mem_7:15:160000:72': 489.42,
  'mem_7:15:160000:73': 489.42,
  'mem_7:15:160000:74': 489.42,
  'mem_7:15:160000:75': 489.42,
  'mem_7:15:160000:76': 689.43,
  'mem_7:15:160000:77': 689.43,
  'mem_7:15:160000:78': 689.43,
  'mem_7:15:160000:79': 689.43,
  'mem_7:15:160000:80': 689.43,
  'mem_7:15:160000:81': 1001.65,
  'mem_7:15:160000:82': 1001.65,
  'mem_7:15:160000:83': 1001.65,
  'mem_7:15:160000:84': 1001.65,
  'mem_7:15:160000:85': 1001.65,
  'mem_7:15:160000:86': 1393.06,
  'mem_7:15:160000:87': 1393.06,
  'mem_7:15:160000:88': 1393.06,
  'mem_7:15:160000:89': 1393.06,
  'mem_7:15:160000:90': 1393.06,
  'mem_7:15:160000:91': 1938.62,
  'mem_7:15:160000:92': 1938.62,
  'mem_7:15:160000:93': 1938.62,
  'mem_7:15:160000:94': 1938.62,
  'mem_7:15:160000:95': 1938.62,
  'mem_7:15:160000:96': 3179.45,
  'mem_7:15:160000:97': 3179.45,
  'mem_7:15:160000:98': 3179.45,
  'mem_7:15:160000:99': 3179.45,
  'mem_7:15:160000:100': 3179.45,
  'mem_7:15:180000:1': 17.49,
  'mem_7:15:180000:2': 17.49,
  'mem_7:15:180000:3': 17.49,
  'mem_7:15:180000:4': 17.49,
  'mem_7:15:180000:5': 17.49,
  'mem_7:15:180000:6': 17.42,
  'mem_7:15:180000:7': 17.42,
  'mem_7:15:180000:8': 17.42,
  'mem_7:15:180000:9': 17.42,
  'mem_7:15:180000:10': 17.42,
  'mem_7:15:180000:11': 17.49,
  'mem_7:15:180000:12': 17.49,
  'mem_7:15:180000:13': 17.49,
  'mem_7:15:180000:14': 17.49,
  'mem_7:15:180000:15': 17.49,
  'mem_7:15:180000:16': 17.84,
  'mem_7:15:180000:17': 17.84,
  'mem_7:15:180000:18': 17.84,
  'mem_7:15:180000:19': 17.84,
  'mem_7:15:180000:20': 17.84,
  'mem_7:15:180000:21': 18.91,
  'mem_7:15:180000:22': 18.91,
  'mem_7:15:180000:23': 18.91,
  'mem_7:15:180000:24': 18.91,
  'mem_7:15:180000:25': 18.91,
  'mem_7:15:180000:26': 21.66,
  'mem_7:15:180000:27': 21.66,
  'mem_7:15:180000:28': 21.66,
  'mem_7:15:180000:29': 21.66,
  'mem_7:15:180000:30': 21.66,
  'mem_7:15:180000:31': 27.91,
  'mem_7:15:180000:32': 27.91,
  'mem_7:15:180000:33': 27.91,
  'mem_7:15:180000:34': 27.91,
  'mem_7:15:180000:35': 27.91,
  'mem_7:15:180000:36': 40.16,
  'mem_7:15:180000:37': 40.16,
  'mem_7:15:180000:38': 40.16,
  'mem_7:15:180000:39': 40.16,
  'mem_7:15:180000:40': 40.16,
  'mem_7:15:180000:41': 61.71,
  'mem_7:15:180000:42': 61.71,
  'mem_7:15:180000:43': 61.71,
  'mem_7:15:180000:44': 61.71,
  'mem_7:15:180000:45': 61.71,
  'mem_7:15:180000:46': 94.05,
  'mem_7:15:180000:47': 94.05,
  'mem_7:15:180000:48': 94.05,
  'mem_7:15:180000:49': 94.05,
  'mem_7:15:180000:50': 94.05,
  'mem_7:15:180000:51': 141.27,
  'mem_7:15:180000:52': 141.27,
  'mem_7:15:180000:53': 141.27,
  'mem_7:15:180000:54': 141.27,
  'mem_7:15:180000:55': 141.27,
  'mem_7:15:180000:56': 200.13,
  'mem_7:15:180000:57': 200.13,
  'mem_7:15:180000:58': 200.13,
  'mem_7:15:180000:59': 200.13,
  'mem_7:15:180000:60': 200.13,
  'mem_7:15:180000:61': 283.82,
  'mem_7:15:180000:62': 283.82,
  'mem_7:15:180000:63': 283.82,
  'mem_7:15:180000:64': 283.82,
  'mem_7:15:180000:65': 283.82,
  'mem_7:15:180000:66': 412.79,
  'mem_7:15:180000:67': 412.79,
  'mem_7:15:180000:68': 412.79,
  'mem_7:15:180000:69': 412.79,
  'mem_7:15:180000:70': 412.79,
  'mem_7:15:180000:71': 549.81,
  'mem_7:15:180000:72': 549.81,
  'mem_7:15:180000:73': 549.81,
  'mem_7:15:180000:74': 549.81,
  'mem_7:15:180000:75': 549.81,
  'mem_7:15:180000:76': 774.51,
  'mem_7:15:180000:77': 774.51,
  'mem_7:15:180000:78': 774.51,
  'mem_7:15:180000:79': 774.51,
  'mem_7:15:180000:80': 774.51,
  'mem_7:15:180000:81': 1125.25,
  'mem_7:15:180000:82': 1125.25,
  'mem_7:15:180000:83': 1125.25,
  'mem_7:15:180000:84': 1125.25,
  'mem_7:15:180000:85': 1125.25,
  'mem_7:15:180000:86': 1565.04,
  'mem_7:15:180000:87': 1565.04,
  'mem_7:15:180000:88': 1565.04,
  'mem_7:15:180000:89': 1565.04,
  'mem_7:15:180000:90': 1565.04,
  'mem_7:15:180000:91': 2178.04,
  'mem_7:15:180000:92': 2178.04,
  'mem_7:15:180000:93': 2178.04,
  'mem_7:15:180000:94': 2178.04,
  'mem_7:15:180000:95': 2178.04,
  'mem_7:15:180000:96': 3572.23,
  'mem_7:15:180000:97': 3572.23,
  'mem_7:15:180000:98': 3572.23,
  'mem_7:15:180000:99': 3572.23,
  'mem_7:15:180000:100': 3572.23,
  'mem_7:15:200000:1': 19.44,
  'mem_7:15:200000:2': 19.44,
  'mem_7:15:200000:3': 19.44,
  'mem_7:15:200000:4': 19.44,
  'mem_7:15:200000:5': 19.44,
  'mem_7:15:200000:6': 19.37,
  'mem_7:15:200000:7': 19.37,
  'mem_7:15:200000:8': 19.37,
  'mem_7:15:200000:9': 19.37,
  'mem_7:15:200000:10': 19.37,
  'mem_7:15:200000:11': 19.44,
  'mem_7:15:200000:12': 19.44,
  'mem_7:15:200000:13': 19.44,
  'mem_7:15:200000:14': 19.44,
  'mem_7:15:200000:15': 19.44,
  'mem_7:15:200000:16': 19.83,
  'mem_7:15:200000:17': 19.83,
  'mem_7:15:200000:18': 19.83,
  'mem_7:15:200000:19': 19.83,
  'mem_7:15:200000:20': 19.83,
  'mem_7:15:200000:21': 21.02,
  'mem_7:15:200000:22': 21.02,
  'mem_7:15:200000:23': 21.02,
  'mem_7:15:200000:24': 21.02,
  'mem_7:15:200000:25': 21.02,
  'mem_7:15:200000:26': 24.07,
  'mem_7:15:200000:27': 24.07,
  'mem_7:15:200000:28': 24.07,
  'mem_7:15:200000:29': 24.07,
  'mem_7:15:200000:30': 24.07,
  'mem_7:15:200000:31': 31.03,
  'mem_7:15:200000:32': 31.03,
  'mem_7:15:200000:33': 31.03,
  'mem_7:15:200000:34': 31.03,
  'mem_7:15:200000:35': 31.03,
  'mem_7:15:200000:36': 44.64,
  'mem_7:15:200000:37': 44.64,
  'mem_7:15:200000:38': 44.64,
  'mem_7:15:200000:39': 44.64,
  'mem_7:15:200000:40': 44.64,
  'mem_7:15:200000:41': 68.58,
  'mem_7:15:200000:42': 68.58,
  'mem_7:15:200000:43': 68.58,
  'mem_7:15:200000:44': 68.58,
  'mem_7:15:200000:45': 68.58,
  'mem_7:15:200000:46': 104.53,
  'mem_7:15:200000:47': 104.53,
  'mem_7:15:200000:48': 104.53,
  'mem_7:15:200000:49': 104.53,
  'mem_7:15:200000:50': 104.53,
  'mem_7:15:200000:51': 157.04,
  'mem_7:15:200000:52': 157.04,
  'mem_7:15:200000:53': 157.04,
  'mem_7:15:200000:54': 157.04,
  'mem_7:15:200000:55': 157.04,
  'mem_7:15:200000:56': 222.47,
  'mem_7:15:200000:57': 222.47,
  'mem_7:15:200000:58': 222.47,
  'mem_7:15:200000:59': 222.47,
  'mem_7:15:200000:60': 222.47,
  'mem_7:15:200000:61': 315.5,
  'mem_7:15:200000:62': 315.5,
  'mem_7:15:200000:63': 315.5,
  'mem_7:15:200000:64': 315.5,
  'mem_7:15:200000:65': 315.5,
  'mem_7:15:200000:66': 458.86,
  'mem_7:15:200000:67': 458.86,
  'mem_7:15:200000:68': 458.86,
  'mem_7:15:200000:69': 458.86,
  'mem_7:15:200000:70': 458.86,
  'mem_7:15:200000:71': 611.19,
  'mem_7:15:200000:72': 611.19,
  'mem_7:15:200000:73': 611.19,
  'mem_7:15:200000:74': 611.19,
  'mem_7:15:200000:75': 611.19,
  'mem_7:15:200000:76': 860.99,
  'mem_7:15:200000:77': 860.99,
  'mem_7:15:200000:78': 860.99,
  'mem_7:15:200000:79': 860.99,
  'mem_7:15:200000:80': 860.99,
  'mem_7:15:200000:81': 1250.89,
  'mem_7:15:200000:82': 1250.89,
  'mem_7:15:200000:83': 1250.89,
  'mem_7:15:200000:84': 1250.89,
  'mem_7:15:200000:85': 1250.89,
  'mem_7:15:200000:86': 1739.8,
  'mem_7:15:200000:87': 1739.8,
  'mem_7:15:200000:88': 1739.8,
  'mem_7:15:200000:89': 1739.8,
  'mem_7:15:200000:90': 1739.8,
  'mem_7:15:200000:91': 2421.26,
  'mem_7:15:200000:92': 2421.26,
  'mem_7:15:200000:93': 2421.26,
  'mem_7:15:200000:94': 2421.26,
  'mem_7:15:200000:95': 2421.26,
  'mem_7:15:200000:96': 3971.12,
  'mem_7:15:200000:97': 3971.12,
  'mem_7:15:200000:98': 3971.12,
  'mem_7:15:200000:99': 3971.12,
  'mem_7:15:200000:100': 3971.12,
  'adb:15:5000:1': 3.6,
  'adb:15:5000:2': 3.6,
  'adb:15:5000:3': 3.6,
  'adb:15:5000:4': 3.6,
  'adb:15:5000:5': 3.6,
  'adb:15:5000:6': 3.6,
  'adb:15:5000:7': 3.6,
  'adb:15:5000:8': 3.6,
  'adb:15:5000:9': 3.6,
  'adb:15:5000:10': 3.6,
  'adb:15:5000:11': 3.6,
  'adb:15:5000:12': 3.6,
  'adb:15:5000:13': 3.6,
  'adb:15:5000:14': 3.6,
  'adb:15:5000:15': 3.6,
  'adb:15:5000:16': 3.6,
  'adb:15:5000:17': 3.6,
  'adb:15:5000:18': 3.6,
  'adb:15:5000:19': 3.6,
  'adb:15:5000:20': 3.6,
  'adb:15:5000:21': 3.6,
  'adb:15:5000:22': 3.6,
  'adb:15:5000:23': 3.6,
  'adb:15:5000:24': 3.6,
  'adb:15:5000:25': 3.6,
  'adb:15:5000:26': 3.6,
  'adb:15:5000:27': 3.6,
  'adb:15:5000:28': 3.6,
  'adb:15:5000:29': 3.6,
  'adb:15:5000:30': 3.6,
  'adb:15:5000:31': 4.8,
  'adb:15:5000:32': 4.8,
  'adb:15:5000:33': 4.8,
  'adb:15:5000:34': 4.8,
  'adb:15:5000:35': 4.8,
  'adb:15:5000:36': 4.8,
  'adb:15:5000:37': 4.8,
  'adb:15:5000:38': 4.8,
  'adb:15:5000:39': 4.8,
  'adb:15:5000:40': 4.8,
  'adb:15:5000:41': 6,
  'adb:15:5000:42': 6,
  'adb:15:5000:43': 6,
  'adb:15:5000:44': 6,
  'adb:15:5000:45': 6,
  'adb:15:5000:46': 8.4,
  'adb:15:5000:47': 8.4,
  'adb:15:5000:48': 8.4,
  'adb:15:5000:49': 8.4,
  'adb:15:5000:50': 8.4,
  'adb:15:5000:51': 12,
  'adb:15:5000:52': 12,
  'adb:15:5000:53': 12,
  'adb:15:5000:54': 12,
  'adb:15:5000:55': 12,
  'adb:15:5000:56': 8.4,
  'adb:15:5000:57': 8.4,
  'adb:15:5000:58': 8.4,
  'adb:15:5000:59': 8.4,
  'adb:15:5000:60': 8.4,
  'adb:15:5000:61': 2.4,
  'adb:15:5000:62': 2.4,
  'adb:15:5000:63': 2.4,
  'adb:15:5000:64': 2.4,
  'adb:15:5000:65': 2.4,
  'adb:15:5000:66': 2.4,
  'adb:15:5000:67': 2.4,
  'adb:15:5000:68': 2.4,
  'adb:15:5000:69': 2.4,
  'adb:15:5000:70': 2.4,
  'adb:15:5000:71': 6,
  'adb:15:5000:72': 6,
  'adb:15:5000:73': 6,
  'adb:15:5000:74': 6,
  'adb:15:5000:75': 6,
  'adb:15:5000:76': 10.8,
  'adb:15:5000:77': 10.8,
  'adb:15:5000:78': 10.8,
  'adb:15:5000:79': 10.8,
  'adb:15:5000:80': 10.8,
  'adb:15:5000:81': 16.8,
  'adb:15:5000:82': 16.8,
  'adb:15:5000:83': 16.8,
  'adb:15:5000:84': 16.8,
  'adb:15:5000:85': 16.8,
  'adb:15:5000:86': 25.2,
  'adb:15:5000:87': 25.2,
  'adb:15:5000:88': 25.2,
  'adb:15:5000:89': 25.2,
  'adb:15:5000:90': 25.2,
  'adb:15:5000:91': 37.2,
  'adb:15:5000:92': 37.2,
  'adb:15:5000:93': 37.2,
  'adb:15:5000:94': 37.2,
  'adb:15:5000:95': 37.2,
  'adb:15:5000:96': 70.8,
  'adb:15:5000:97': 70.8,
  'adb:15:5000:98': 70.8,
  'adb:15:5000:99': 70.8,
  'adb:15:5000:100': 70.8,
  'adb:15:7500:1': 4.8,
  'adb:15:7500:2': 4.8,
  'adb:15:7500:3': 4.8,
  'adb:15:7500:4': 4.8,
  'adb:15:7500:5': 4.8,
  'adb:15:7500:6': 4.8,
  'adb:15:7500:7': 4.8,
  'adb:15:7500:8': 4.8,
  'adb:15:7500:9': 4.8,
  'adb:15:7500:10': 4.8,
  'adb:15:7500:11': 4.8,
  'adb:15:7500:12': 4.8,
  'adb:15:7500:13': 4.8,
  'adb:15:7500:14': 4.8,
  'adb:15:7500:15': 4.8,
  'adb:15:7500:16': 4.8,
  'adb:15:7500:17': 4.8,
  'adb:15:7500:18': 4.8,
  'adb:15:7500:19': 4.8,
  'adb:15:7500:20': 4.8,
  'adb:15:7500:21': 4.8,
  'adb:15:7500:22': 4.8,
  'adb:15:7500:23': 4.8,
  'adb:15:7500:24': 4.8,
  'adb:15:7500:25': 4.8,
  'adb:15:7500:26': 4.8,
  'adb:15:7500:27': 4.8,
  'adb:15:7500:28': 4.8,
  'adb:15:7500:29': 4.8,
  'adb:15:7500:30': 4.8,
  'adb:15:7500:31': 6,
  'adb:15:7500:32': 6,
  'adb:15:7500:33': 6,
  'adb:15:7500:34': 6,
  'adb:15:7500:35': 6,
  'adb:15:7500:36': 7.2,
  'adb:15:7500:37': 7.2,
  'adb:15:7500:38': 7.2,
  'adb:15:7500:39': 7.2,
  'adb:15:7500:40': 7.2,
  'adb:15:7500:41': 9.6,
  'adb:15:7500:42': 9.6,
  'adb:15:7500:43': 9.6,
  'adb:15:7500:44': 9.6,
  'adb:15:7500:45': 9.6,
  'adb:15:7500:46': 12,
  'adb:15:7500:47': 12,
  'adb:15:7500:48': 12,
  'adb:15:7500:49': 12,
  'adb:15:7500:50': 12,
  'adb:15:7500:51': 16.8,
  'adb:15:7500:52': 16.8,
  'adb:15:7500:53': 16.8,
  'adb:15:7500:54': 16.8,
  'adb:15:7500:55': 16.8,
  'adb:15:7500:56': 12,
  'adb:15:7500:57': 12,
  'adb:15:7500:58': 12,
  'adb:15:7500:59': 12,
  'adb:15:7500:60': 12,
  'adb:15:7500:61': 3.6,
  'adb:15:7500:62': 3.6,
  'adb:15:7500:63': 3.6,
  'adb:15:7500:64': 3.6,
  'adb:15:7500:65': 3.6,
  'adb:15:7500:66': 3.6,
  'adb:15:7500:67': 3.6,
  'adb:15:7500:68': 3.6,
  'adb:15:7500:69': 3.6,
  'adb:15:7500:70': 3.6,
  'adb:15:7500:71': 8.4,
  'adb:15:7500:72': 8.4,
  'adb:15:7500:73': 8.4,
  'adb:15:7500:74': 8.4,
  'adb:15:7500:75': 8.4,
  'adb:15:7500:76': 16.8,
  'adb:15:7500:77': 16.8,
  'adb:15:7500:78': 16.8,
  'adb:15:7500:79': 16.8,
  'adb:15:7500:80': 16.8,
  'adb:15:7500:81': 24,
  'adb:15:7500:82': 24,
  'adb:15:7500:83': 24,
  'adb:15:7500:84': 24,
  'adb:15:7500:85': 24,
  'adb:15:7500:86': 37.2,
  'adb:15:7500:87': 37.2,
  'adb:15:7500:88': 37.2,
  'adb:15:7500:89': 37.2,
  'adb:15:7500:90': 37.2,
  'adb:15:7500:91': 56.4,
  'adb:15:7500:92': 56.4,
  'adb:15:7500:93': 56.4,
  'adb:15:7500:94': 56.4,
  'adb:15:7500:95': 56.4,
  'adb:15:7500:96': 106.8,
  'adb:15:7500:97': 106.8,
  'adb:15:7500:98': 106.8,
  'adb:15:7500:99': 106.8,
  'adb:15:7500:100': 106.8,
  'adb:15:10000:1': 6,
  'adb:15:10000:2': 6,
  'adb:15:10000:3': 6,
  'adb:15:10000:4': 6,
  'adb:15:10000:5': 6,
  'adb:15:10000:6': 6,
  'adb:15:10000:7': 6,
  'adb:15:10000:8': 6,
  'adb:15:10000:9': 6,
  'adb:15:10000:10': 6,
  'adb:15:10000:11': 6,
  'adb:15:10000:12': 6,
  'adb:15:10000:13': 6,
  'adb:15:10000:14': 6,
  'adb:15:10000:15': 6,
  'adb:15:10000:16': 6,
  'adb:15:10000:17': 6,
  'adb:15:10000:18': 6,
  'adb:15:10000:19': 6,
  'adb:15:10000:20': 6,
  'adb:15:10000:21': 6,
  'adb:15:10000:22': 6,
  'adb:15:10000:23': 6,
  'adb:15:10000:24': 6,
  'adb:15:10000:25': 6,
  'adb:15:10000:26': 7.2,
  'adb:15:10000:27': 7.2,
  'adb:15:10000:28': 7.2,
  'adb:15:10000:29': 7.2,
  'adb:15:10000:30': 7.2,
  'adb:15:10000:31': 8.4,
  'adb:15:10000:32': 8.4,
  'adb:15:10000:33': 8.4,
  'adb:15:10000:34': 8.4,
  'adb:15:10000:35': 8.4,
  'adb:15:10000:36': 9.6,
  'adb:15:10000:37': 9.6,
  'adb:15:10000:38': 9.6,
  'adb:15:10000:39': 9.6,
  'adb:15:10000:40': 9.6,
  'adb:15:10000:41': 12,
  'adb:15:10000:42': 12,
  'adb:15:10000:43': 12,
  'adb:15:10000:44': 12,
  'adb:15:10000:45': 12,
  'adb:15:10000:46': 15.6,
  'adb:15:10000:47': 15.6,
  'adb:15:10000:48': 15.6,
  'adb:15:10000:49': 15.6,
  'adb:15:10000:50': 15.6,
  'adb:15:10000:51': 22.8,
  'adb:15:10000:52': 22.8,
  'adb:15:10000:53': 22.8,
  'adb:15:10000:54': 22.8,
  'adb:15:10000:55': 22.8,
  'adb:15:10000:56': 15.6,
  'adb:15:10000:57': 15.6,
  'adb:15:10000:58': 15.6,
  'adb:15:10000:59': 15.6,
  'adb:15:10000:60': 15.6,
  'adb:15:10000:61': 4.8,
  'adb:15:10000:62': 4.8,
  'adb:15:10000:63': 4.8,
  'adb:15:10000:64': 4.8,
  'adb:15:10000:65': 4.8,
  'adb:15:10000:66': 4.8,
  'adb:15:10000:67': 4.8,
  'adb:15:10000:68': 4.8,
  'adb:15:10000:69': 4.8,
  'adb:15:10000:70': 4.8,
  'adb:15:10000:71': 12,
  'adb:15:10000:72': 12,
  'adb:15:10000:73': 12,
  'adb:15:10000:74': 12,
  'adb:15:10000:75': 12,
  'adb:15:10000:76': 21.6,
  'adb:15:10000:77': 21.6,
  'adb:15:10000:78': 21.6,
  'adb:15:10000:79': 21.6,
  'adb:15:10000:80': 21.6,
  'adb:15:10000:81': 32.4,
  'adb:15:10000:82': 32.4,
  'adb:15:10000:83': 32.4,
  'adb:15:10000:84': 32.4,
  'adb:15:10000:85': 32.4,
  'adb:15:10000:86': 49.2,
  'adb:15:10000:87': 49.2,
  'adb:15:10000:88': 49.2,
  'adb:15:10000:89': 49.2,
  'adb:15:10000:90': 49.2,
  'adb:15:10000:91': 74.4,
  'adb:15:10000:92': 74.4,
  'adb:15:10000:93': 74.4,
  'adb:15:10000:94': 74.4,
  'adb:15:10000:95': 74.4,
  'adb:15:10000:96': 141.6,
  'adb:15:10000:97': 141.6,
  'adb:15:10000:98': 141.6,
  'adb:15:10000:99': 141.6,
  'adb:15:10000:100': 141.6,
  'adb:15:15000:1': 9.6,
  'adb:15:15000:2': 9.6,
  'adb:15:15000:3': 9.6,
  'adb:15:15000:4': 9.6,
  'adb:15:15000:5': 9.6,
  'adb:15:15000:6': 9.6,
  'adb:15:15000:7': 9.6,
  'adb:15:15000:8': 9.6,
  'adb:15:15000:9': 9.6,
  'adb:15:15000:10': 9.6,
  'adb:15:15000:11': 9.6,
  'adb:15:15000:12': 9.6,
  'adb:15:15000:13': 9.6,
  'adb:15:15000:14': 9.6,
  'adb:15:15000:15': 9.6,
  'adb:15:15000:16': 9.6,
  'adb:15:15000:17': 9.6,
  'adb:15:15000:18': 9.6,
  'adb:15:15000:19': 9.6,
  'adb:15:15000:20': 9.6,
  'adb:15:15000:21': 9.6,
  'adb:15:15000:22': 9.6,
  'adb:15:15000:23': 9.6,
  'adb:15:15000:24': 9.6,
  'adb:15:15000:25': 9.6,
  'adb:15:15000:26': 9.6,
  'adb:15:15000:27': 9.6,
  'adb:15:15000:28': 9.6,
  'adb:15:15000:29': 9.6,
  'adb:15:15000:30': 9.6,
  'adb:15:15000:31': 12,
  'adb:15:15000:32': 12,
  'adb:15:15000:33': 12,
  'adb:15:15000:34': 12,
  'adb:15:15000:35': 12,
  'adb:15:15000:36': 13.2,
  'adb:15:15000:37': 13.2,
  'adb:15:15000:38': 13.2,
  'adb:15:15000:39': 13.2,
  'adb:15:15000:40': 13.2,
  'adb:15:15000:41': 18,
  'adb:15:15000:42': 18,
  'adb:15:15000:43': 18,
  'adb:15:15000:44': 18,
  'adb:15:15000:45': 18,
  'adb:15:15000:46': 24,
  'adb:15:15000:47': 24,
  'adb:15:15000:48': 24,
  'adb:15:15000:49': 24,
  'adb:15:15000:50': 24,
  'adb:15:15000:51': 33.6,
  'adb:15:15000:52': 33.6,
  'adb:15:15000:53': 33.6,
  'adb:15:15000:54': 33.6,
  'adb:15:15000:55': 33.6,
  'adb:15:15000:56': 22.8,
  'adb:15:15000:57': 22.8,
  'adb:15:15000:58': 22.8,
  'adb:15:15000:59': 22.8,
  'adb:15:15000:60': 22.8,
  'adb:15:15000:61': 7.2,
  'adb:15:15000:62': 7.2,
  'adb:15:15000:63': 7.2,
  'adb:15:15000:64': 7.2,
  'adb:15:15000:65': 7.2,
  'adb:15:15000:66': 7.2,
  'adb:15:15000:67': 7.2,
  'adb:15:15000:68': 7.2,
  'adb:15:15000:69': 7.2,
  'adb:15:15000:70': 7.2,
  'adb:15:15000:71': 16.8,
  'adb:15:15000:72': 16.8,
  'adb:15:15000:73': 16.8,
  'adb:15:15000:74': 16.8,
  'adb:15:15000:75': 16.8,
  'adb:15:15000:76': 32.4,
  'adb:15:15000:77': 32.4,
  'adb:15:15000:78': 32.4,
  'adb:15:15000:79': 32.4,
  'adb:15:15000:80': 32.4,
  'adb:15:15000:81': 48,
  'adb:15:15000:82': 48,
  'adb:15:15000:83': 48,
  'adb:15:15000:84': 48,
  'adb:15:15000:85': 48,
  'adb:15:15000:86': 73.2,
  'adb:15:15000:87': 73.2,
  'adb:15:15000:88': 73.2,
  'adb:15:15000:89': 73.2,
  'adb:15:15000:90': 73.2,
  'adb:15:15000:91': 111.6,
  'adb:15:15000:92': 111.6,
  'adb:15:15000:93': 111.6,
  'adb:15:15000:94': 111.6,
  'adb:15:15000:95': 111.6,
  'adb:15:15000:96': 212.4,
  'adb:15:15000:97': 212.4,
  'adb:15:15000:98': 212.4,
  'adb:15:15000:99': 212.4,
  'adb:15:15000:100': 212.4,
  'adb:15:20000:1': 12,
  'adb:15:20000:2': 12,
  'adb:15:20000:3': 12,
  'adb:15:20000:4': 12,
  'adb:15:20000:5': 12,
  'adb:15:20000:6': 12,
  'adb:15:20000:7': 12,
  'adb:15:20000:8': 12,
  'adb:15:20000:9': 12,
  'adb:15:20000:10': 12,
  'adb:15:20000:11': 12,
  'adb:15:20000:12': 12,
  'adb:15:20000:13': 12,
  'adb:15:20000:14': 12,
  'adb:15:20000:15': 12,
  'adb:15:20000:16': 12,
  'adb:15:20000:17': 12,
  'adb:15:20000:18': 12,
  'adb:15:20000:19': 12,
  'adb:15:20000:20': 12,
  'adb:15:20000:21': 12,
  'adb:15:20000:22': 12,
  'adb:15:20000:23': 12,
  'adb:15:20000:24': 12,
  'adb:15:20000:25': 12,
  'adb:15:20000:26': 13.2,
  'adb:15:20000:27': 13.2,
  'adb:15:20000:28': 13.2,
  'adb:15:20000:29': 13.2,
  'adb:15:20000:30': 13.2,
  'adb:15:20000:31': 15.6,
  'adb:15:20000:32': 15.6,
  'adb:15:20000:33': 15.6,
  'adb:15:20000:34': 15.6,
  'adb:15:20000:35': 15.6,
  'adb:15:20000:36': 18,
  'adb:15:20000:37': 18,
  'adb:15:20000:38': 18,
  'adb:15:20000:39': 18,
  'adb:15:20000:40': 18,
  'adb:15:20000:41': 22.8,
  'adb:15:20000:42': 22.8,
  'adb:15:20000:43': 22.8,
  'adb:15:20000:44': 22.8,
  'adb:15:20000:45': 22.8,
  'adb:15:20000:46': 31.2,
  'adb:15:20000:47': 31.2,
  'adb:15:20000:48': 31.2,
  'adb:15:20000:49': 31.2,
  'adb:15:20000:50': 31.2,
  'adb:15:20000:51': 44.4,
  'adb:15:20000:52': 44.4,
  'adb:15:20000:53': 44.4,
  'adb:15:20000:54': 44.4,
  'adb:15:20000:55': 44.4,
  'adb:15:20000:56': 30,
  'adb:15:20000:57': 30,
  'adb:15:20000:58': 30,
  'adb:15:20000:59': 30,
  'adb:15:20000:60': 30,
  'adb:15:20000:61': 9.6,
  'adb:15:20000:62': 9.6,
  'adb:15:20000:63': 9.6,
  'adb:15:20000:64': 9.6,
  'adb:15:20000:65': 9.6,
  'adb:15:20000:66': 9.6,
  'adb:15:20000:67': 9.6,
  'adb:15:20000:68': 9.6,
  'adb:15:20000:69': 9.6,
  'adb:15:20000:70': 9.6,
  'adb:15:20000:71': 22.8,
  'adb:15:20000:72': 22.8,
  'adb:15:20000:73': 22.8,
  'adb:15:20000:74': 22.8,
  'adb:15:20000:75': 22.8,
  'adb:15:20000:76': 43.2,
  'adb:15:20000:77': 43.2,
  'adb:15:20000:78': 43.2,
  'adb:15:20000:79': 43.2,
  'adb:15:20000:80': 43.2,
  'adb:15:20000:81': 63.6,
  'adb:15:20000:82': 63.6,
  'adb:15:20000:83': 63.6,
  'adb:15:20000:84': 63.6,
  'adb:15:20000:85': 63.6,
  'adb:15:20000:86': 97.2,
  'adb:15:20000:87': 97.2,
  'adb:15:20000:88': 97.2,
  'adb:15:20000:89': 97.2,
  'adb:15:20000:90': 97.2,
  'adb:15:20000:91': 148.8,
  'adb:15:20000:92': 148.8,
  'adb:15:20000:93': 148.8,
  'adb:15:20000:94': 148.8,
  'adb:15:20000:95': 148.8,
  'adb:15:20000:96': 282,
  'adb:15:20000:97': 282,
  'adb:15:20000:98': 282,
  'adb:15:20000:99': 282,
  'adb:15:20000:100': 282,
  'adb:15:25000:1': 14.4,
  'adb:15:25000:2': 14.4,
  'adb:15:25000:3': 14.4,
  'adb:15:25000:4': 14.4,
  'adb:15:25000:5': 14.4,
  'adb:15:25000:6': 14.4,
  'adb:15:25000:7': 14.4,
  'adb:15:25000:8': 14.4,
  'adb:15:25000:9': 14.4,
  'adb:15:25000:10': 14.4,
  'adb:15:25000:11': 14.4,
  'adb:15:25000:12': 14.4,
  'adb:15:25000:13': 14.4,
  'adb:15:25000:14': 14.4,
  'adb:15:25000:15': 14.4,
  'adb:15:25000:16': 14.4,
  'adb:15:25000:17': 14.4,
  'adb:15:25000:18': 14.4,
  'adb:15:25000:19': 14.4,
  'adb:15:25000:20': 14.4,
  'adb:15:25000:21': 15.6,
  'adb:15:25000:22': 15.6,
  'adb:15:25000:23': 15.6,
  'adb:15:25000:24': 15.6,
  'adb:15:25000:25': 15.6,
  'adb:15:25000:26': 16.8,
  'adb:15:25000:27': 16.8,
  'adb:15:25000:28': 16.8,
  'adb:15:25000:29': 16.8,
  'adb:15:25000:30': 16.8,
  'adb:15:25000:31': 19.2,
  'adb:15:25000:32': 19.2,
  'adb:15:25000:33': 19.2,
  'adb:15:25000:34': 19.2,
  'adb:15:25000:35': 19.2,
  'adb:15:25000:36': 22.8,
  'adb:15:25000:37': 22.8,
  'adb:15:25000:38': 22.8,
  'adb:15:25000:39': 22.8,
  'adb:15:25000:40': 22.8,
  'adb:15:25000:41': 28.8,
  'adb:15:25000:42': 28.8,
  'adb:15:25000:43': 28.8,
  'adb:15:25000:44': 28.8,
  'adb:15:25000:45': 28.8,
  'adb:15:25000:46': 39.6,
  'adb:15:25000:47': 39.6,
  'adb:15:25000:48': 39.6,
  'adb:15:25000:49': 39.6,
  'adb:15:25000:50': 39.6,
  'adb:15:25000:51': 55.2,
  'adb:15:25000:52': 55.2,
  'adb:15:25000:53': 55.2,
  'adb:15:25000:54': 55.2,
  'adb:15:25000:55': 55.2,
  'adb:15:25000:56': 37.2,
  'adb:15:25000:57': 37.2,
  'adb:15:25000:58': 37.2,
  'adb:15:25000:59': 37.2,
  'adb:15:25000:60': 37.2,
  'adb:15:25000:61': 12,
  'adb:15:25000:62': 12,
  'adb:15:25000:63': 12,
  'adb:15:25000:64': 12,
  'adb:15:25000:65': 12,
  'adb:15:25000:66': 12,
  'adb:15:25000:67': 12,
  'adb:15:25000:68': 12,
  'adb:15:25000:69': 12,
  'adb:15:25000:70': 12,
  'adb:15:25000:71': 28.8,
  'adb:15:25000:72': 28.8,
  'adb:15:25000:73': 28.8,
  'adb:15:25000:74': 28.8,
  'adb:15:25000:75': 28.8,
  'adb:15:25000:76': 54,
  'adb:15:25000:77': 54,
  'adb:15:25000:78': 54,
  'adb:15:25000:79': 54,
  'adb:15:25000:80': 54,
  'adb:15:25000:81': 80.4,
  'adb:15:25000:82': 80.4,
  'adb:15:25000:83': 80.4,
  'adb:15:25000:84': 80.4,
  'adb:15:25000:85': 80.4,
  'adb:15:25000:86': 121.2,
  'adb:15:25000:87': 121.2,
  'adb:15:25000:88': 121.2,
  'adb:15:25000:89': 121.2,
  'adb:15:25000:90': 121.2,
  'adb:15:25000:91': 186,
  'adb:15:25000:92': 186,
  'adb:15:25000:93': 186,
  'adb:15:25000:94': 186,
  'adb:15:25000:95': 186,
  'adb:15:25000:96': 352.8,
  'adb:15:25000:97': 352.8,
  'adb:15:25000:98': 352.8,
  'adb:15:25000:99': 352.8,
  'adb:15:25000:100': 352.8,
  'adb:15:30000:1': 18,
  'adb:15:30000:2': 18,
  'adb:15:30000:3': 18,
  'adb:15:30000:4': 18,
  'adb:15:30000:5': 18,
  'adb:15:30000:6': 18,
  'adb:15:30000:7': 18,
  'adb:15:30000:8': 18,
  'adb:15:30000:9': 18,
  'adb:15:30000:10': 18,
  'adb:15:30000:11': 18,
  'adb:15:30000:12': 18,
  'adb:15:30000:13': 18,
  'adb:15:30000:14': 18,
  'adb:15:30000:15': 18,
  'adb:15:30000:16': 18,
  'adb:15:30000:17': 18,
  'adb:15:30000:18': 18,
  'adb:15:30000:19': 18,
  'adb:15:30000:20': 18,
  'adb:15:30000:21': 18,
  'adb:15:30000:22': 18,
  'adb:15:30000:23': 18,
  'adb:15:30000:24': 18,
  'adb:15:30000:25': 18,
  'adb:15:30000:26': 19.2,
  'adb:15:30000:27': 19.2,
  'adb:15:30000:28': 19.2,
  'adb:15:30000:29': 19.2,
  'adb:15:30000:30': 19.2,
  'adb:15:30000:31': 22.8,
  'adb:15:30000:32': 22.8,
  'adb:15:30000:33': 22.8,
  'adb:15:30000:34': 22.8,
  'adb:15:30000:35': 22.8,
  'adb:15:30000:36': 26.4,
  'adb:15:30000:37': 26.4,
  'adb:15:30000:38': 26.4,
  'adb:15:30000:39': 26.4,
  'adb:15:30000:40': 26.4,
  'adb:15:30000:41': 34.8,
  'adb:15:30000:42': 34.8,
  'adb:15:30000:43': 34.8,
  'adb:15:30000:44': 34.8,
  'adb:15:30000:45': 34.8,
  'adb:15:30000:46': 46.8,
  'adb:15:30000:47': 46.8,
  'adb:15:30000:48': 46.8,
  'adb:15:30000:49': 46.8,
  'adb:15:30000:50': 46.8,
  'adb:15:30000:51': 66,
  'adb:15:30000:52': 66,
  'adb:15:30000:53': 66,
  'adb:15:30000:54': 66,
  'adb:15:30000:55': 66,
  'adb:15:30000:56': 45.6,
  'adb:15:30000:57': 45.6,
  'adb:15:30000:58': 45.6,
  'adb:15:30000:59': 45.6,
  'adb:15:30000:60': 45.6,
  'adb:15:30000:61': 14.4,
  'adb:15:30000:62': 14.4,
  'adb:15:30000:63': 14.4,
  'adb:15:30000:64': 14.4,
  'adb:15:30000:65': 14.4,
  'adb:15:30000:66': 14.4,
  'adb:15:30000:67': 14.4,
  'adb:15:30000:68': 14.4,
  'adb:15:30000:69': 14.4,
  'adb:15:30000:70': 14.4,
  'adb:15:30000:71': 33.6,
  'adb:15:30000:72': 33.6,
  'adb:15:30000:73': 33.6,
  'adb:15:30000:74': 33.6,
  'adb:15:30000:75': 33.6,
  'adb:15:30000:76': 64.8,
  'adb:15:30000:77': 64.8,
  'adb:15:30000:78': 64.8,
  'adb:15:30000:79': 64.8,
  'adb:15:30000:80': 64.8,
  'adb:15:30000:81': 96,
  'adb:15:30000:82': 96,
  'adb:15:30000:83': 96,
  'adb:15:30000:84': 96,
  'adb:15:30000:85': 96,
  'adb:15:30000:86': 145.2,
  'adb:15:30000:87': 145.2,
  'adb:15:30000:88': 145.2,
  'adb:15:30000:89': 145.2,
  'adb:15:30000:90': 145.2,
  'adb:15:30000:91': 223.2,
  'adb:15:30000:92': 223.2,
  'adb:15:30000:93': 223.2,
  'adb:15:30000:94': 223.2,
  'adb:15:30000:95': 223.2,
  'adb:15:30000:96': 423.6,
  'adb:15:30000:97': 423.6,
  'adb:15:30000:98': 423.6,
  'adb:15:30000:99': 423.6,
  'adb:15:30000:100': 423.6,
  'adb:15:40000:1': 22.8,
  'adb:15:40000:2': 22.8,
  'adb:15:40000:3': 22.8,
  'adb:15:40000:4': 22.8,
  'adb:15:40000:5': 22.8,
  'adb:15:40000:6': 22.8,
  'adb:15:40000:7': 22.8,
  'adb:15:40000:8': 22.8,
  'adb:15:40000:9': 22.8,
  'adb:15:40000:10': 22.8,
  'adb:15:40000:11': 22.8,
  'adb:15:40000:12': 22.8,
  'adb:15:40000:13': 22.8,
  'adb:15:40000:14': 22.8,
  'adb:15:40000:15': 22.8,
  'adb:15:40000:16': 22.8,
  'adb:15:40000:17': 22.8,
  'adb:15:40000:18': 22.8,
  'adb:15:40000:19': 22.8,
  'adb:15:40000:20': 22.8,
  'adb:15:40000:21': 24,
  'adb:15:40000:22': 24,
  'adb:15:40000:23': 24,
  'adb:15:40000:24': 24,
  'adb:15:40000:25': 24,
  'adb:15:40000:26': 26.4,
  'adb:15:40000:27': 26.4,
  'adb:15:40000:28': 26.4,
  'adb:15:40000:29': 26.4,
  'adb:15:40000:30': 26.4,
  'adb:15:40000:31': 30,
  'adb:15:40000:32': 30,
  'adb:15:40000:33': 30,
  'adb:15:40000:34': 30,
  'adb:15:40000:35': 30,
  'adb:15:40000:36': 36,
  'adb:15:40000:37': 36,
  'adb:15:40000:38': 36,
  'adb:15:40000:39': 36,
  'adb:15:40000:40': 36,
  'adb:15:40000:41': 45.6,
  'adb:15:40000:42': 45.6,
  'adb:15:40000:43': 45.6,
  'adb:15:40000:44': 45.6,
  'adb:15:40000:45': 45.6,
  'adb:15:40000:46': 62.4,
  'adb:15:40000:47': 62.4,
  'adb:15:40000:48': 62.4,
  'adb:15:40000:49': 62.4,
  'adb:15:40000:50': 62.4,
  'adb:15:40000:51': 87.6,
  'adb:15:40000:52': 87.6,
  'adb:15:40000:53': 87.6,
  'adb:15:40000:54': 87.6,
  'adb:15:40000:55': 87.6,
  'adb:15:40000:56': 60,
  'adb:15:40000:57': 60,
  'adb:15:40000:58': 60,
  'adb:15:40000:59': 60,
  'adb:15:40000:60': 60,
  'adb:15:40000:61': 19.2,
  'adb:15:40000:62': 19.2,
  'adb:15:40000:63': 19.2,
  'adb:15:40000:64': 19.2,
  'adb:15:40000:65': 19.2,
  'adb:15:40000:66': 19.2,
  'adb:15:40000:67': 19.2,
  'adb:15:40000:68': 19.2,
  'adb:15:40000:69': 19.2,
  'adb:15:40000:70': 19.2,
  'adb:15:40000:71': 44.4,
  'adb:15:40000:72': 44.4,
  'adb:15:40000:73': 44.4,
  'adb:15:40000:74': 44.4,
  'adb:15:40000:75': 44.4,
  'adb:15:40000:76': 86.4,
  'adb:15:40000:77': 86.4,
  'adb:15:40000:78': 86.4,
  'adb:15:40000:79': 86.4,
  'adb:15:40000:80': 86.4,
  'adb:15:40000:81': 127.2,
  'adb:15:40000:82': 127.2,
  'adb:15:40000:83': 127.2,
  'adb:15:40000:84': 127.2,
  'adb:15:40000:85': 127.2,
  'adb:15:40000:86': 193.2,
  'adb:15:40000:87': 193.2,
  'adb:15:40000:88': 193.2,
  'adb:15:40000:89': 193.2,
  'adb:15:40000:90': 193.2,
  'adb:15:40000:91': 297.6,
  'adb:15:40000:92': 297.6,
  'adb:15:40000:93': 297.6,
  'adb:15:40000:94': 297.6,
  'adb:15:40000:95': 297.6,
  'adb:15:40000:96': 564,
  'adb:15:40000:97': 564,
  'adb:15:40000:98': 564,
  'adb:15:40000:99': 564,
  'adb:15:40000:100': 564,
  'adb:15:50000:1': 28.8,
  'adb:15:50000:2': 28.8,
  'adb:15:50000:3': 28.8,
  'adb:15:50000:4': 28.8,
  'adb:15:50000:5': 28.8,
  'adb:15:50000:6': 28.8,
  'adb:15:50000:7': 28.8,
  'adb:15:50000:8': 28.8,
  'adb:15:50000:9': 28.8,
  'adb:15:50000:10': 28.8,
  'adb:15:50000:11': 28.8,
  'adb:15:50000:12': 28.8,
  'adb:15:50000:13': 28.8,
  'adb:15:50000:14': 28.8,
  'adb:15:50000:15': 28.8,
  'adb:15:50000:16': 28.8,
  'adb:15:50000:17': 28.8,
  'adb:15:50000:18': 28.8,
  'adb:15:50000:19': 28.8,
  'adb:15:50000:20': 28.8,
  'adb:15:50000:21': 30,
  'adb:15:50000:22': 30,
  'adb:15:50000:23': 30,
  'adb:15:50000:24': 30,
  'adb:15:50000:25': 30,
  'adb:15:50000:26': 32.4,
  'adb:15:50000:27': 32.4,
  'adb:15:50000:28': 32.4,
  'adb:15:50000:29': 32.4,
  'adb:15:50000:30': 32.4,
  'adb:15:50000:31': 37.2,
  'adb:15:50000:32': 37.2,
  'adb:15:50000:33': 37.2,
  'adb:15:50000:34': 37.2,
  'adb:15:50000:35': 37.2,
  'adb:15:50000:36': 44.4,
  'adb:15:50000:37': 44.4,
  'adb:15:50000:38': 44.4,
  'adb:15:50000:39': 44.4,
  'adb:15:50000:40': 44.4,
  'adb:15:50000:41': 57.6,
  'adb:15:50000:42': 57.6,
  'adb:15:50000:43': 57.6,
  'adb:15:50000:44': 57.6,
  'adb:15:50000:45': 57.6,
  'adb:15:50000:46': 78,
  'adb:15:50000:47': 78,
  'adb:15:50000:48': 78,
  'adb:15:50000:49': 78,
  'adb:15:50000:50': 78,
  'adb:15:50000:51': 109.2,
  'adb:15:50000:52': 109.2,
  'adb:15:50000:53': 109.2,
  'adb:15:50000:54': 109.2,
  'adb:15:50000:55': 109.2,
  'adb:15:50000:56': 74.4,
  'adb:15:50000:57': 74.4,
  'adb:15:50000:58': 74.4,
  'adb:15:50000:59': 74.4,
  'adb:15:50000:60': 74.4,
  'adb:15:50000:61': 22.8,
  'adb:15:50000:62': 22.8,
  'adb:15:50000:63': 22.8,
  'adb:15:50000:64': 22.8,
  'adb:15:50000:65': 22.8,
  'adb:15:50000:66': 22.8,
  'adb:15:50000:67': 22.8,
  'adb:15:50000:68': 22.8,
  'adb:15:50000:69': 22.8,
  'adb:15:50000:70': 22.8,
  'adb:15:50000:71': 56.4,
  'adb:15:50000:72': 56.4,
  'adb:15:50000:73': 56.4,
  'adb:15:50000:74': 56.4,
  'adb:15:50000:75': 56.4,
  'adb:15:50000:76': 108,
  'adb:15:50000:77': 108,
  'adb:15:50000:78': 108,
  'adb:15:50000:79': 108,
  'adb:15:50000:80': 108,
  'adb:15:50000:81': 159.6,
  'adb:15:50000:82': 159.6,
  'adb:15:50000:83': 159.6,
  'adb:15:50000:84': 159.6,
  'adb:15:50000:85': 159.6,
  'adb:15:50000:86': 241.2,
  'adb:15:50000:87': 241.2,
  'adb:15:50000:88': 241.2,
  'adb:15:50000:89': 241.2,
  'adb:15:50000:90': 241.2,
  'adb:15:50000:91': 372,
  'adb:15:50000:92': 372,
  'adb:15:50000:93': 372,
  'adb:15:50000:94': 372,
  'adb:15:50000:95': 372,
  'adb:15:50000:96': 705.6,
  'adb:15:50000:97': 705.6,
  'adb:15:50000:98': 705.6,
  'adb:15:50000:99': 705.6,
  'adb:15:50000:100': 705.6,
  'adb:15:60000:1': 34.56,
  'adb:15:60000:2': 34.56,
  'adb:15:60000:3': 34.56,
  'adb:15:60000:4': 34.56,
  'adb:15:60000:5': 34.56,
  'adb:15:60000:6': 34.56,
  'adb:15:60000:7': 34.56,
  'adb:15:60000:8': 34.56,
  'adb:15:60000:9': 34.56,
  'adb:15:60000:10': 34.56,
  'adb:15:60000:11': 34.56,
  'adb:15:60000:12': 34.56,
  'adb:15:60000:13': 34.56,
  'adb:15:60000:14': 34.56,
  'adb:15:60000:15': 34.56,
  'adb:15:60000:16': 34.56,
  'adb:15:60000:17': 34.56,
  'adb:15:60000:18': 34.56,
  'adb:15:60000:19': 34.56,
  'adb:15:60000:20': 34.56,
  'adb:15:60000:21': 36,
  'adb:15:60000:22': 36,
  'adb:15:60000:23': 36,
  'adb:15:60000:24': 36,
  'adb:15:60000:25': 36,
  'adb:15:60000:26': 38.88,
  'adb:15:60000:27': 38.88,
  'adb:15:60000:28': 38.88,
  'adb:15:60000:29': 38.88,
  'adb:15:60000:30': 38.88,
  'adb:15:60000:31': 44.64,
  'adb:15:60000:32': 44.64,
  'adb:15:60000:33': 44.64,
  'adb:15:60000:34': 44.64,
  'adb:15:60000:35': 44.64,
  'adb:15:60000:36': 53.28,
  'adb:15:60000:37': 53.28,
  'adb:15:60000:38': 53.28,
  'adb:15:60000:39': 53.28,
  'adb:15:60000:40': 53.28,
  'adb:15:60000:41': 69.12,
  'adb:15:60000:42': 69.12,
  'adb:15:60000:43': 69.12,
  'adb:15:60000:44': 69.12,
  'adb:15:60000:45': 69.12,
  'adb:15:60000:46': 93.6,
  'adb:15:60000:47': 93.6,
  'adb:15:60000:48': 93.6,
  'adb:15:60000:49': 93.6,
  'adb:15:60000:50': 93.6,
  'adb:15:60000:51': 131.04,
  'adb:15:60000:52': 131.04,
  'adb:15:60000:53': 131.04,
  'adb:15:60000:54': 131.04,
  'adb:15:60000:55': 131.04,
  'adb:15:60000:56': 89.28,
  'adb:15:60000:57': 89.28,
  'adb:15:60000:58': 89.28,
  'adb:15:60000:59': 89.28,
  'adb:15:60000:60': 89.28,
  'adb:15:60000:61': 27.36,
  'adb:15:60000:62': 27.36,
  'adb:15:60000:63': 27.36,
  'adb:15:60000:64': 27.36,
  'adb:15:60000:65': 27.36,
  'adb:15:60000:66': 27.36,
  'adb:15:60000:67': 27.36,
  'adb:15:60000:68': 27.36,
  'adb:15:60000:69': 27.36,
  'adb:15:60000:70': 27.36,
  'adb:15:60000:71': 67.68,
  'adb:15:60000:72': 67.68,
  'adb:15:60000:73': 67.68,
  'adb:15:60000:74': 67.68,
  'adb:15:60000:75': 67.68,
  'adb:15:60000:76': 129.6,
  'adb:15:60000:77': 129.6,
  'adb:15:60000:78': 129.6,
  'adb:15:60000:79': 129.6,
  'adb:15:60000:80': 129.6,
  'adb:15:60000:81': 191.52,
  'adb:15:60000:82': 191.52,
  'adb:15:60000:83': 191.52,
  'adb:15:60000:84': 191.52,
  'adb:15:60000:85': 191.52,
  'adb:15:60000:86': 289.44,
  'adb:15:60000:87': 289.44,
  'adb:15:60000:88': 289.44,
  'adb:15:60000:89': 289.44,
  'adb:15:60000:90': 289.44,
  'adb:15:60000:91': 446.4,
  'adb:15:60000:92': 446.4,
  'adb:15:60000:93': 446.4,
  'adb:15:60000:94': 446.4,
  'adb:15:60000:95': 446.4,
  'adb:15:60000:96': 846.72,
  'adb:15:60000:97': 846.72,
  'adb:15:60000:98': 846.72,
  'adb:15:60000:99': 846.72,
  'adb:15:60000:100': 846.72,
  'adb:15:70000:1': 40.32,
  'adb:15:70000:2': 40.32,
  'adb:15:70000:3': 40.32,
  'adb:15:70000:4': 40.32,
  'adb:15:70000:5': 40.32,
  'adb:15:70000:6': 40.32,
  'adb:15:70000:7': 40.32,
  'adb:15:70000:8': 40.32,
  'adb:15:70000:9': 40.32,
  'adb:15:70000:10': 40.32,
  'adb:15:70000:11': 40.32,
  'adb:15:70000:12': 40.32,
  'adb:15:70000:13': 40.32,
  'adb:15:70000:14': 40.32,
  'adb:15:70000:15': 40.32,
  'adb:15:70000:16': 40.32,
  'adb:15:70000:17': 40.32,
  'adb:15:70000:18': 40.32,
  'adb:15:70000:19': 40.32,
  'adb:15:70000:20': 40.32,
  'adb:15:70000:21': 42,
  'adb:15:70000:22': 42,
  'adb:15:70000:23': 42,
  'adb:15:70000:24': 42,
  'adb:15:70000:25': 42,
  'adb:15:70000:26': 45.36,
  'adb:15:70000:27': 45.36,
  'adb:15:70000:28': 45.36,
  'adb:15:70000:29': 45.36,
  'adb:15:70000:30': 45.36,
  'adb:15:70000:31': 52.08,
  'adb:15:70000:32': 52.08,
  'adb:15:70000:33': 52.08,
  'adb:15:70000:34': 52.08,
  'adb:15:70000:35': 52.08,
  'adb:15:70000:36': 62.16,
  'adb:15:70000:37': 62.16,
  'adb:15:70000:38': 62.16,
  'adb:15:70000:39': 62.16,
  'adb:15:70000:40': 62.16,
  'adb:15:70000:41': 80.64,
  'adb:15:70000:42': 80.64,
  'adb:15:70000:43': 80.64,
  'adb:15:70000:44': 80.64,
  'adb:15:70000:45': 80.64,
  'adb:15:70000:46': 109.2,
  'adb:15:70000:47': 109.2,
  'adb:15:70000:48': 109.2,
  'adb:15:70000:49': 109.2,
  'adb:15:70000:50': 109.2,
  'adb:15:70000:51': 152.88,
  'adb:15:70000:52': 152.88,
  'adb:15:70000:53': 152.88,
  'adb:15:70000:54': 152.88,
  'adb:15:70000:55': 152.88,
  'adb:15:70000:56': 104.16,
  'adb:15:70000:57': 104.16,
  'adb:15:70000:58': 104.16,
  'adb:15:70000:59': 104.16,
  'adb:15:70000:60': 104.16,
  'adb:15:70000:61': 31.92,
  'adb:15:70000:62': 31.92,
  'adb:15:70000:63': 31.92,
  'adb:15:70000:64': 31.92,
  'adb:15:70000:65': 31.92,
  'adb:15:70000:66': 31.92,
  'adb:15:70000:67': 31.92,
  'adb:15:70000:68': 31.92,
  'adb:15:70000:69': 31.92,
  'adb:15:70000:70': 31.92,
  'adb:15:70000:71': 78.96,
  'adb:15:70000:72': 78.96,
  'adb:15:70000:73': 78.96,
  'adb:15:70000:74': 78.96,
  'adb:15:70000:75': 78.96,
  'adb:15:70000:76': 151.2,
  'adb:15:70000:77': 151.2,
  'adb:15:70000:78': 151.2,
  'adb:15:70000:79': 151.2,
  'adb:15:70000:80': 151.2,
  'adb:15:70000:81': 223.44,
  'adb:15:70000:82': 223.44,
  'adb:15:70000:83': 223.44,
  'adb:15:70000:84': 223.44,
  'adb:15:70000:85': 223.44,
  'adb:15:70000:86': 337.68,
  'adb:15:70000:87': 337.68,
  'adb:15:70000:88': 337.68,
  'adb:15:70000:89': 337.68,
  'adb:15:70000:90': 337.68,
  'adb:15:70000:91': 520.8,
  'adb:15:70000:92': 520.8,
  'adb:15:70000:93': 520.8,
  'adb:15:70000:94': 520.8,
  'adb:15:70000:95': 520.8,
  'adb:15:70000:96': 987.84,
  'adb:15:70000:97': 987.84,
  'adb:15:70000:98': 987.84,
  'adb:15:70000:99': 987.84,
  'adb:15:70000:100': 987.84,
  'adb:15:80000:1': 46.08,
  'adb:15:80000:2': 46.08,
  'adb:15:80000:3': 46.08,
  'adb:15:80000:4': 46.08,
  'adb:15:80000:5': 46.08,
  'adb:15:80000:6': 46.08,
  'adb:15:80000:7': 46.08,
  'adb:15:80000:8': 46.08,
  'adb:15:80000:9': 46.08,
  'adb:15:80000:10': 46.08,
  'adb:15:80000:11': 46.08,
  'adb:15:80000:12': 46.08,
  'adb:15:80000:13': 46.08,
  'adb:15:80000:14': 46.08,
  'adb:15:80000:15': 46.08,
  'adb:15:80000:16': 46.08,
  'adb:15:80000:17': 46.08,
  'adb:15:80000:18': 46.08,
  'adb:15:80000:19': 46.08,
  'adb:15:80000:20': 46.08,
  'adb:15:80000:21': 48,
  'adb:15:80000:22': 48,
  'adb:15:80000:23': 48,
  'adb:15:80000:24': 48,
  'adb:15:80000:25': 48,
  'adb:15:80000:26': 51.84,
  'adb:15:80000:27': 51.84,
  'adb:15:80000:28': 51.84,
  'adb:15:80000:29': 51.84,
  'adb:15:80000:30': 51.84,
  'adb:15:80000:31': 59.52,
  'adb:15:80000:32': 59.52,
  'adb:15:80000:33': 59.52,
  'adb:15:80000:34': 59.52,
  'adb:15:80000:35': 59.52,
  'adb:15:80000:36': 71.04,
  'adb:15:80000:37': 71.04,
  'adb:15:80000:38': 71.04,
  'adb:15:80000:39': 71.04,
  'adb:15:80000:40': 71.04,
  'adb:15:80000:41': 92.16,
  'adb:15:80000:42': 92.16,
  'adb:15:80000:43': 92.16,
  'adb:15:80000:44': 92.16,
  'adb:15:80000:45': 92.16,
  'adb:15:80000:46': 124.8,
  'adb:15:80000:47': 124.8,
  'adb:15:80000:48': 124.8,
  'adb:15:80000:49': 124.8,
  'adb:15:80000:50': 124.8,
  'adb:15:80000:51': 174.72,
  'adb:15:80000:52': 174.72,
  'adb:15:80000:53': 174.72,
  'adb:15:80000:54': 174.72,
  'adb:15:80000:55': 174.72,
  'adb:15:80000:56': 119.04,
  'adb:15:80000:57': 119.04,
  'adb:15:80000:58': 119.04,
  'adb:15:80000:59': 119.04,
  'adb:15:80000:60': 119.04,
  'adb:15:80000:61': 36.48,
  'adb:15:80000:62': 36.48,
  'adb:15:80000:63': 36.48,
  'adb:15:80000:64': 36.48,
  'adb:15:80000:65': 36.48,
  'adb:15:80000:66': 36.48,
  'adb:15:80000:67': 36.48,
  'adb:15:80000:68': 36.48,
  'adb:15:80000:69': 36.48,
  'adb:15:80000:70': 36.48,
  'adb:15:80000:71': 90.24,
  'adb:15:80000:72': 90.24,
  'adb:15:80000:73': 90.24,
  'adb:15:80000:74': 90.24,
  'adb:15:80000:75': 90.24,
  'adb:15:80000:76': 172.8,
  'adb:15:80000:77': 172.8,
  'adb:15:80000:78': 172.8,
  'adb:15:80000:79': 172.8,
  'adb:15:80000:80': 172.8,
  'adb:15:80000:81': 255.36,
  'adb:15:80000:82': 255.36,
  'adb:15:80000:83': 255.36,
  'adb:15:80000:84': 255.36,
  'adb:15:80000:85': 255.36,
  'adb:15:80000:86': 385.92,
  'adb:15:80000:87': 385.92,
  'adb:15:80000:88': 385.92,
  'adb:15:80000:89': 385.92,
  'adb:15:80000:90': 385.92,
  'adb:15:80000:91': 595.2,
  'adb:15:80000:92': 595.2,
  'adb:15:80000:93': 595.2,
  'adb:15:80000:94': 595.2,
  'adb:15:80000:95': 595.2,
  'adb:15:80000:96': 1128.96,
  'adb:15:80000:97': 1128.96,
  'adb:15:80000:98': 1128.96,
  'adb:15:80000:99': 1128.96,
  'adb:15:80000:100': 1128.96,
  'adb:15:90000:1': 51.84,
  'adb:15:90000:2': 51.84,
  'adb:15:90000:3': 51.84,
  'adb:15:90000:4': 51.84,
  'adb:15:90000:5': 51.84,
  'adb:15:90000:6': 51.84,
  'adb:15:90000:7': 51.84,
  'adb:15:90000:8': 51.84,
  'adb:15:90000:9': 51.84,
  'adb:15:90000:10': 51.84,
  'adb:15:90000:11': 51.84,
  'adb:15:90000:12': 51.84,
  'adb:15:90000:13': 51.84,
  'adb:15:90000:14': 51.84,
  'adb:15:90000:15': 51.84,
  'adb:15:90000:16': 51.84,
  'adb:15:90000:17': 51.84,
  'adb:15:90000:18': 51.84,
  'adb:15:90000:19': 51.84,
  'adb:15:90000:20': 51.84,
  'adb:15:90000:21': 54,
  'adb:15:90000:22': 54,
  'adb:15:90000:23': 54,
  'adb:15:90000:24': 54,
  'adb:15:90000:25': 54,
  'adb:15:90000:26': 58.32,
  'adb:15:90000:27': 58.32,
  'adb:15:90000:28': 58.32,
  'adb:15:90000:29': 58.32,
  'adb:15:90000:30': 58.32,
  'adb:15:90000:31': 66.96,
  'adb:15:90000:32': 66.96,
  'adb:15:90000:33': 66.96,
  'adb:15:90000:34': 66.96,
  'adb:15:90000:35': 66.96,
  'adb:15:90000:36': 79.92,
  'adb:15:90000:37': 79.92,
  'adb:15:90000:38': 79.92,
  'adb:15:90000:39': 79.92,
  'adb:15:90000:40': 79.92,
  'adb:15:90000:41': 103.68,
  'adb:15:90000:42': 103.68,
  'adb:15:90000:43': 103.68,
  'adb:15:90000:44': 103.68,
  'adb:15:90000:45': 103.68,
  'adb:15:90000:46': 140.4,
  'adb:15:90000:47': 140.4,
  'adb:15:90000:48': 140.4,
  'adb:15:90000:49': 140.4,
  'adb:15:90000:50': 140.4,
  'adb:15:90000:51': 196.56,
  'adb:15:90000:52': 196.56,
  'adb:15:90000:53': 196.56,
  'adb:15:90000:54': 196.56,
  'adb:15:90000:55': 196.56,
  'adb:15:90000:56': 133.92,
  'adb:15:90000:57': 133.92,
  'adb:15:90000:58': 133.92,
  'adb:15:90000:59': 133.92,
  'adb:15:90000:60': 133.92,
  'adb:15:90000:61': 41.04,
  'adb:15:90000:62': 41.04,
  'adb:15:90000:63': 41.04,
  'adb:15:90000:64': 41.04,
  'adb:15:90000:65': 41.04,
  'adb:15:90000:66': 41.04,
  'adb:15:90000:67': 41.04,
  'adb:15:90000:68': 41.04,
  'adb:15:90000:69': 41.04,
  'adb:15:90000:70': 41.04,
  'adb:15:90000:71': 101.52,
  'adb:15:90000:72': 101.52,
  'adb:15:90000:73': 101.52,
  'adb:15:90000:74': 101.52,
  'adb:15:90000:75': 101.52,
  'adb:15:90000:76': 194.4,
  'adb:15:90000:77': 194.4,
  'adb:15:90000:78': 194.4,
  'adb:15:90000:79': 194.4,
  'adb:15:90000:80': 194.4,
  'adb:15:90000:81': 287.28,
  'adb:15:90000:82': 287.28,
  'adb:15:90000:83': 287.28,
  'adb:15:90000:84': 287.28,
  'adb:15:90000:85': 287.28,
  'adb:15:90000:86': 434.16,
  'adb:15:90000:87': 434.16,
  'adb:15:90000:88': 434.16,
  'adb:15:90000:89': 434.16,
  'adb:15:90000:90': 434.16,
  'adb:15:90000:91': 669.6,
  'adb:15:90000:92': 669.6,
  'adb:15:90000:93': 669.6,
  'adb:15:90000:94': 669.6,
  'adb:15:90000:95': 669.6,
  'adb:15:90000:96': 1270.08,
  'adb:15:90000:97': 1270.08,
  'adb:15:90000:98': 1270.08,
  'adb:15:90000:99': 1270.08,
  'adb:15:90000:100': 1270.08,
  'adb:15:100000:1': 57.6,
  'adb:15:100000:2': 57.6,
  'adb:15:100000:3': 57.6,
  'adb:15:100000:4': 57.6,
  'adb:15:100000:5': 57.6,
  'adb:15:100000:6': 57.6,
  'adb:15:100000:7': 57.6,
  'adb:15:100000:8': 57.6,
  'adb:15:100000:9': 57.6,
  'adb:15:100000:10': 57.6,
  'adb:15:100000:11': 57.6,
  'adb:15:100000:12': 57.6,
  'adb:15:100000:13': 57.6,
  'adb:15:100000:14': 57.6,
  'adb:15:100000:15': 57.6,
  'adb:15:100000:16': 57.6,
  'adb:15:100000:17': 57.6,
  'adb:15:100000:18': 57.6,
  'adb:15:100000:19': 57.6,
  'adb:15:100000:20': 57.6,
  'adb:15:100000:21': 60,
  'adb:15:100000:22': 60,
  'adb:15:100000:23': 60,
  'adb:15:100000:24': 60,
  'adb:15:100000:25': 60,
  'adb:15:100000:26': 64.8,
  'adb:15:100000:27': 64.8,
  'adb:15:100000:28': 64.8,
  'adb:15:100000:29': 64.8,
  'adb:15:100000:30': 64.8,
  'adb:15:100000:31': 74.4,
  'adb:15:100000:32': 74.4,
  'adb:15:100000:33': 74.4,
  'adb:15:100000:34': 74.4,
  'adb:15:100000:35': 74.4,
  'adb:15:100000:36': 88.8,
  'adb:15:100000:37': 88.8,
  'adb:15:100000:38': 88.8,
  'adb:15:100000:39': 88.8,
  'adb:15:100000:40': 88.8,
  'adb:15:100000:41': 115.2,
  'adb:15:100000:42': 115.2,
  'adb:15:100000:43': 115.2,
  'adb:15:100000:44': 115.2,
  'adb:15:100000:45': 115.2,
  'adb:15:100000:46': 156,
  'adb:15:100000:47': 156,
  'adb:15:100000:48': 156,
  'adb:15:100000:49': 156,
  'adb:15:100000:50': 156,
  'adb:15:100000:51': 218.4,
  'adb:15:100000:52': 218.4,
  'adb:15:100000:53': 218.4,
  'adb:15:100000:54': 218.4,
  'adb:15:100000:55': 218.4,
  'adb:15:100000:56': 148.8,
  'adb:15:100000:57': 148.8,
  'adb:15:100000:58': 148.8,
  'adb:15:100000:59': 148.8,
  'adb:15:100000:60': 148.8,
  'adb:15:100000:61': 45.6,
  'adb:15:100000:62': 45.6,
  'adb:15:100000:63': 45.6,
  'adb:15:100000:64': 45.6,
  'adb:15:100000:65': 45.6,
  'adb:15:100000:66': 45.6,
  'adb:15:100000:67': 45.6,
  'adb:15:100000:68': 45.6,
  'adb:15:100000:69': 45.6,
  'adb:15:100000:70': 45.6,
  'adb:15:100000:71': 112.8,
  'adb:15:100000:72': 112.8,
  'adb:15:100000:73': 112.8,
  'adb:15:100000:74': 112.8,
  'adb:15:100000:75': 112.8,
  'adb:15:100000:76': 216,
  'adb:15:100000:77': 216,
  'adb:15:100000:78': 216,
  'adb:15:100000:79': 216,
  'adb:15:100000:80': 216,
  'adb:15:100000:81': 319.2,
  'adb:15:100000:82': 319.2,
  'adb:15:100000:83': 319.2,
  'adb:15:100000:84': 319.2,
  'adb:15:100000:85': 319.2,
  'adb:15:100000:86': 482.4,
  'adb:15:100000:87': 482.4,
  'adb:15:100000:88': 482.4,
  'adb:15:100000:89': 482.4,
  'adb:15:100000:90': 482.4,
  'adb:15:100000:91': 744,
  'adb:15:100000:92': 744,
  'adb:15:100000:93': 744,
  'adb:15:100000:94': 744,
  'adb:15:100000:95': 744,
  'adb:15:100000:96': 1411.2,
  'adb:15:100000:97': 1411.2,
  'adb:15:100000:98': 1411.2,
  'adb:15:100000:99': 1411.2,
  'adb:15:100000:100': 1411.2,
  'adb:15:120000:1': 69.12,
  'adb:15:120000:2': 69.12,
  'adb:15:120000:3': 69.12,
  'adb:15:120000:4': 69.12,
  'adb:15:120000:5': 69.12,
  'adb:15:120000:6': 69.12,
  'adb:15:120000:7': 69.12,
  'adb:15:120000:8': 69.12,
  'adb:15:120000:9': 69.12,
  'adb:15:120000:10': 69.12,
  'adb:15:120000:11': 69.12,
  'adb:15:120000:12': 69.12,
  'adb:15:120000:13': 69.12,
  'adb:15:120000:14': 69.12,
  'adb:15:120000:15': 69.12,
  'adb:15:120000:16': 69.12,
  'adb:15:120000:17': 69.12,
  'adb:15:120000:18': 69.12,
  'adb:15:120000:19': 69.12,
  'adb:15:120000:20': 69.12,
  'adb:15:120000:21': 72,
  'adb:15:120000:22': 72,
  'adb:15:120000:23': 72,
  'adb:15:120000:24': 72,
  'adb:15:120000:25': 72,
  'adb:15:120000:26': 77.76,
  'adb:15:120000:27': 77.76,
  'adb:15:120000:28': 77.76,
  'adb:15:120000:29': 77.76,
  'adb:15:120000:30': 77.76,
  'adb:15:120000:31': 89.28,
  'adb:15:120000:32': 89.28,
  'adb:15:120000:33': 89.28,
  'adb:15:120000:34': 89.28,
  'adb:15:120000:35': 89.28,
  'adb:15:120000:36': 106.56,
  'adb:15:120000:37': 106.56,
  'adb:15:120000:38': 106.56,
  'adb:15:120000:39': 106.56,
  'adb:15:120000:40': 106.56,
  'adb:15:120000:41': 138.24,
  'adb:15:120000:42': 138.24,
  'adb:15:120000:43': 138.24,
  'adb:15:120000:44': 138.24,
  'adb:15:120000:45': 138.24,
  'adb:15:120000:46': 187.2,
  'adb:15:120000:47': 187.2,
  'adb:15:120000:48': 187.2,
  'adb:15:120000:49': 187.2,
  'adb:15:120000:50': 187.2,
  'adb:15:120000:51': 262.08,
  'adb:15:120000:52': 262.08,
  'adb:15:120000:53': 262.08,
  'adb:15:120000:54': 262.08,
  'adb:15:120000:55': 262.08,
  'adb:15:120000:56': 178.56,
  'adb:15:120000:57': 178.56,
  'adb:15:120000:58': 178.56,
  'adb:15:120000:59': 178.56,
  'adb:15:120000:60': 178.56,
  'adb:15:120000:61': 54.72,
  'adb:15:120000:62': 54.72,
  'adb:15:120000:63': 54.72,
  'adb:15:120000:64': 54.72,
  'adb:15:120000:65': 54.72,
  'adb:15:120000:66': 54.72,
  'adb:15:120000:67': 54.72,
  'adb:15:120000:68': 54.72,
  'adb:15:120000:69': 54.72,
  'adb:15:120000:70': 54.72,
  'adb:15:120000:71': 135.36,
  'adb:15:120000:72': 135.36,
  'adb:15:120000:73': 135.36,
  'adb:15:120000:74': 135.36,
  'adb:15:120000:75': 135.36,
  'adb:15:120000:76': 259.2,
  'adb:15:120000:77': 259.2,
  'adb:15:120000:78': 259.2,
  'adb:15:120000:79': 259.2,
  'adb:15:120000:80': 259.2,
  'adb:15:120000:81': 383.04,
  'adb:15:120000:82': 383.04,
  'adb:15:120000:83': 383.04,
  'adb:15:120000:84': 383.04,
  'adb:15:120000:85': 383.04,
  'adb:15:120000:86': 578.88,
  'adb:15:120000:87': 578.88,
  'adb:15:120000:88': 578.88,
  'adb:15:120000:89': 578.88,
  'adb:15:120000:90': 578.88,
  'adb:15:120000:91': 892.8,
  'adb:15:120000:92': 892.8,
  'adb:15:120000:93': 892.8,
  'adb:15:120000:94': 892.8,
  'adb:15:120000:95': 892.8,
  'adb:15:120000:96': 1693.44,
  'adb:15:120000:97': 1693.44,
  'adb:15:120000:98': 1693.44,
  'adb:15:120000:99': 1693.44,
  'adb:15:120000:100': 1693.44,
  'adb:15:140000:1': 80.64,
  'adb:15:140000:2': 80.64,
  'adb:15:140000:3': 80.64,
  'adb:15:140000:4': 80.64,
  'adb:15:140000:5': 80.64,
  'adb:15:140000:6': 80.64,
  'adb:15:140000:7': 80.64,
  'adb:15:140000:8': 80.64,
  'adb:15:140000:9': 80.64,
  'adb:15:140000:10': 80.64,
  'adb:15:140000:11': 80.64,
  'adb:15:140000:12': 80.64,
  'adb:15:140000:13': 80.64,
  'adb:15:140000:14': 80.64,
  'adb:15:140000:15': 80.64,
  'adb:15:140000:16': 80.64,
  'adb:15:140000:17': 80.64,
  'adb:15:140000:18': 80.64,
  'adb:15:140000:19': 80.64,
  'adb:15:140000:20': 80.64,
  'adb:15:140000:21': 84,
  'adb:15:140000:22': 84,
  'adb:15:140000:23': 84,
  'adb:15:140000:24': 84,
  'adb:15:140000:25': 84,
  'adb:15:140000:26': 90.72,
  'adb:15:140000:27': 90.72,
  'adb:15:140000:28': 90.72,
  'adb:15:140000:29': 90.72,
  'adb:15:140000:30': 90.72,
  'adb:15:140000:31': 104.16,
  'adb:15:140000:32': 104.16,
  'adb:15:140000:33': 104.16,
  'adb:15:140000:34': 104.16,
  'adb:15:140000:35': 104.16,
  'adb:15:140000:36': 124.32,
  'adb:15:140000:37': 124.32,
  'adb:15:140000:38': 124.32,
  'adb:15:140000:39': 124.32,
  'adb:15:140000:40': 124.32,
  'adb:15:140000:41': 161.28,
  'adb:15:140000:42': 161.28,
  'adb:15:140000:43': 161.28,
  'adb:15:140000:44': 161.28,
  'adb:15:140000:45': 161.28,
  'adb:15:140000:46': 218.4,
  'adb:15:140000:47': 218.4,
  'adb:15:140000:48': 218.4,
  'adb:15:140000:49': 218.4,
  'adb:15:140000:50': 218.4,
  'adb:15:140000:51': 305.76,
  'adb:15:140000:52': 305.76,
  'adb:15:140000:53': 305.76,
  'adb:15:140000:54': 305.76,
  'adb:15:140000:55': 305.76,
  'adb:15:140000:56': 208.32,
  'adb:15:140000:57': 208.32,
  'adb:15:140000:58': 208.32,
  'adb:15:140000:59': 208.32,
  'adb:15:140000:60': 208.32,
  'adb:15:140000:61': 63.84,
  'adb:15:140000:62': 63.84,
  'adb:15:140000:63': 63.84,
  'adb:15:140000:64': 63.84,
  'adb:15:140000:65': 63.84,
  'adb:15:140000:66': 63.84,
  'adb:15:140000:67': 63.84,
  'adb:15:140000:68': 63.84,
  'adb:15:140000:69': 63.84,
  'adb:15:140000:70': 63.84,
  'adb:15:140000:71': 157.92,
  'adb:15:140000:72': 157.92,
  'adb:15:140000:73': 157.92,
  'adb:15:140000:74': 157.92,
  'adb:15:140000:75': 157.92,
  'adb:15:140000:76': 302.4,
  'adb:15:140000:77': 302.4,
  'adb:15:140000:78': 302.4,
  'adb:15:140000:79': 302.4,
  'adb:15:140000:80': 302.4,
  'adb:15:140000:81': 446.88,
  'adb:15:140000:82': 446.88,
  'adb:15:140000:83': 446.88,
  'adb:15:140000:84': 446.88,
  'adb:15:140000:85': 446.88,
  'adb:15:140000:86': 675.36,
  'adb:15:140000:87': 675.36,
  'adb:15:140000:88': 675.36,
  'adb:15:140000:89': 675.36,
  'adb:15:140000:90': 675.36,
  'adb:15:140000:91': 1041.6,
  'adb:15:140000:92': 1041.6,
  'adb:15:140000:93': 1041.6,
  'adb:15:140000:94': 1041.6,
  'adb:15:140000:95': 1041.6,
  'adb:15:140000:96': 1975.68,
  'adb:15:140000:97': 1975.68,
  'adb:15:140000:98': 1975.68,
  'adb:15:140000:99': 1975.68,
  'adb:15:140000:100': 1975.68,
  'adb:15:160000:1': 92.16,
  'adb:15:160000:2': 92.16,
  'adb:15:160000:3': 92.16,
  'adb:15:160000:4': 92.16,
  'adb:15:160000:5': 92.16,
  'adb:15:160000:6': 92.16,
  'adb:15:160000:7': 92.16,
  'adb:15:160000:8': 92.16,
  'adb:15:160000:9': 92.16,
  'adb:15:160000:10': 92.16,
  'adb:15:160000:11': 92.16,
  'adb:15:160000:12': 92.16,
  'adb:15:160000:13': 92.16,
  'adb:15:160000:14': 92.16,
  'adb:15:160000:15': 92.16,
  'adb:15:160000:16': 92.16,
  'adb:15:160000:17': 92.16,
  'adb:15:160000:18': 92.16,
  'adb:15:160000:19': 92.16,
  'adb:15:160000:20': 92.16,
  'adb:15:160000:21': 96,
  'adb:15:160000:22': 96,
  'adb:15:160000:23': 96,
  'adb:15:160000:24': 96,
  'adb:15:160000:25': 96,
  'adb:15:160000:26': 103.68,
  'adb:15:160000:27': 103.68,
  'adb:15:160000:28': 103.68,
  'adb:15:160000:29': 103.68,
  'adb:15:160000:30': 103.68,
  'adb:15:160000:31': 119.04,
  'adb:15:160000:32': 119.04,
  'adb:15:160000:33': 119.04,
  'adb:15:160000:34': 119.04,
  'adb:15:160000:35': 119.04,
  'adb:15:160000:36': 142.08,
  'adb:15:160000:37': 142.08,
  'adb:15:160000:38': 142.08,
  'adb:15:160000:39': 142.08,
  'adb:15:160000:40': 142.08,
  'adb:15:160000:41': 184.32,
  'adb:15:160000:42': 184.32,
  'adb:15:160000:43': 184.32,
  'adb:15:160000:44': 184.32,
  'adb:15:160000:45': 184.32,
  'adb:15:160000:46': 249.6,
  'adb:15:160000:47': 249.6,
  'adb:15:160000:48': 249.6,
  'adb:15:160000:49': 249.6,
  'adb:15:160000:50': 249.6,
  'adb:15:160000:51': 349.44,
  'adb:15:160000:52': 349.44,
  'adb:15:160000:53': 349.44,
  'adb:15:160000:54': 349.44,
  'adb:15:160000:55': 349.44,
  'adb:15:160000:56': 238.08,
  'adb:15:160000:57': 238.08,
  'adb:15:160000:58': 238.08,
  'adb:15:160000:59': 238.08,
  'adb:15:160000:60': 238.08,
  'adb:15:160000:61': 72.96,
  'adb:15:160000:62': 72.96,
  'adb:15:160000:63': 72.96,
  'adb:15:160000:64': 72.96,
  'adb:15:160000:65': 72.96,
  'adb:15:160000:66': 72.96,
  'adb:15:160000:67': 72.96,
  'adb:15:160000:68': 72.96,
  'adb:15:160000:69': 72.96,
  'adb:15:160000:70': 72.96,
  'adb:15:160000:71': 180.48,
  'adb:15:160000:72': 180.48,
  'adb:15:160000:73': 180.48,
  'adb:15:160000:74': 180.48,
  'adb:15:160000:75': 180.48,
  'adb:15:160000:76': 345.6,
  'adb:15:160000:77': 345.6,
  'adb:15:160000:78': 345.6,
  'adb:15:160000:79': 345.6,
  'adb:15:160000:80': 345.6,
  'adb:15:160000:81': 510.72,
  'adb:15:160000:82': 510.72,
  'adb:15:160000:83': 510.72,
  'adb:15:160000:84': 510.72,
  'adb:15:160000:85': 510.72,
  'adb:15:160000:86': 771.84,
  'adb:15:160000:87': 771.84,
  'adb:15:160000:88': 771.84,
  'adb:15:160000:89': 771.84,
  'adb:15:160000:90': 771.84,
  'adb:15:160000:91': 1190.4,
  'adb:15:160000:92': 1190.4,
  'adb:15:160000:93': 1190.4,
  'adb:15:160000:94': 1190.4,
  'adb:15:160000:95': 1190.4,
  'adb:15:160000:96': 2257.92,
  'adb:15:160000:97': 2257.92,
  'adb:15:160000:98': 2257.92,
  'adb:15:160000:99': 2257.92,
  'adb:15:160000:100': 2257.92,
  'adb:15:180000:1': 103.68,
  'adb:15:180000:2': 103.68,
  'adb:15:180000:3': 103.68,
  'adb:15:180000:4': 103.68,
  'adb:15:180000:5': 103.68,
  'adb:15:180000:6': 103.68,
  'adb:15:180000:7': 103.68,
  'adb:15:180000:8': 103.68,
  'adb:15:180000:9': 103.68,
  'adb:15:180000:10': 103.68,
  'adb:15:180000:11': 103.68,
  'adb:15:180000:12': 103.68,
  'adb:15:180000:13': 103.68,
  'adb:15:180000:14': 103.68,
  'adb:15:180000:15': 103.68,
  'adb:15:180000:16': 103.68,
  'adb:15:180000:17': 103.68,
  'adb:15:180000:18': 103.68,
  'adb:15:180000:19': 103.68,
  'adb:15:180000:20': 103.68,
  'adb:15:180000:21': 108,
  'adb:15:180000:22': 108,
  'adb:15:180000:23': 108,
  'adb:15:180000:24': 108,
  'adb:15:180000:25': 108,
  'adb:15:180000:26': 116.64,
  'adb:15:180000:27': 116.64,
  'adb:15:180000:28': 116.64,
  'adb:15:180000:29': 116.64,
  'adb:15:180000:30': 116.64,
  'adb:15:180000:31': 133.92,
  'adb:15:180000:32': 133.92,
  'adb:15:180000:33': 133.92,
  'adb:15:180000:34': 133.92,
  'adb:15:180000:35': 133.92,
  'adb:15:180000:36': 159.84,
  'adb:15:180000:37': 159.84,
  'adb:15:180000:38': 159.84,
  'adb:15:180000:39': 159.84,
  'adb:15:180000:40': 159.84,
  'adb:15:180000:41': 207.36,
  'adb:15:180000:42': 207.36,
  'adb:15:180000:43': 207.36,
  'adb:15:180000:44': 207.36,
  'adb:15:180000:45': 207.36,
  'adb:15:180000:46': 280.8,
  'adb:15:180000:47': 280.8,
  'adb:15:180000:48': 280.8,
  'adb:15:180000:49': 280.8,
  'adb:15:180000:50': 280.8,
  'adb:15:180000:51': 393.12,
  'adb:15:180000:52': 393.12,
  'adb:15:180000:53': 393.12,
  'adb:15:180000:54': 393.12,
  'adb:15:180000:55': 393.12,
  'adb:15:180000:56': 267.84,
  'adb:15:180000:57': 267.84,
  'adb:15:180000:58': 267.84,
  'adb:15:180000:59': 267.84,
  'adb:15:180000:60': 267.84,
  'adb:15:180000:61': 82.08,
  'adb:15:180000:62': 82.08,
  'adb:15:180000:63': 82.08,
  'adb:15:180000:64': 82.08,
  'adb:15:180000:65': 82.08,
  'adb:15:180000:66': 82.08,
  'adb:15:180000:67': 82.08,
  'adb:15:180000:68': 82.08,
  'adb:15:180000:69': 82.08,
  'adb:15:180000:70': 82.08,
  'adb:15:180000:71': 203.04,
  'adb:15:180000:72': 203.04,
  'adb:15:180000:73': 203.04,
  'adb:15:180000:74': 203.04,
  'adb:15:180000:75': 203.04,
  'adb:15:180000:76': 388.8,
  'adb:15:180000:77': 388.8,
  'adb:15:180000:78': 388.8,
  'adb:15:180000:79': 388.8,
  'adb:15:180000:80': 388.8,
  'adb:15:180000:81': 574.56,
  'adb:15:180000:82': 574.56,
  'adb:15:180000:83': 574.56,
  'adb:15:180000:84': 574.56,
  'adb:15:180000:85': 574.56,
  'adb:15:180000:86': 868.32,
  'adb:15:180000:87': 868.32,
  'adb:15:180000:88': 868.32,
  'adb:15:180000:89': 868.32,
  'adb:15:180000:90': 868.32,
  'adb:15:180000:91': 1339.2,
  'adb:15:180000:92': 1339.2,
  'adb:15:180000:93': 1339.2,
  'adb:15:180000:94': 1339.2,
  'adb:15:180000:95': 1339.2,
  'adb:15:180000:96': 2540.16,
  'adb:15:180000:97': 2540.16,
  'adb:15:180000:98': 2540.16,
  'adb:15:180000:99': 2540.16,
  'adb:15:180000:100': 2540.16,
  'adb:15:200000:1': 115.2,
  'adb:15:200000:2': 115.2,
  'adb:15:200000:3': 115.2,
  'adb:15:200000:4': 115.2,
  'adb:15:200000:5': 115.2,
  'adb:15:200000:6': 115.2,
  'adb:15:200000:7': 115.2,
  'adb:15:200000:8': 115.2,
  'adb:15:200000:9': 115.2,
  'adb:15:200000:10': 115.2,
  'adb:15:200000:11': 115.2,
  'adb:15:200000:12': 115.2,
  'adb:15:200000:13': 115.2,
  'adb:15:200000:14': 115.2,
  'adb:15:200000:15': 115.2,
  'adb:15:200000:16': 115.2,
  'adb:15:200000:17': 115.2,
  'adb:15:200000:18': 115.2,
  'adb:15:200000:19': 115.2,
  'adb:15:200000:20': 115.2,
  'adb:15:200000:21': 120,
  'adb:15:200000:22': 120,
  'adb:15:200000:23': 120,
  'adb:15:200000:24': 120,
  'adb:15:200000:25': 120,
  'adb:15:200000:26': 129.6,
  'adb:15:200000:27': 129.6,
  'adb:15:200000:28': 129.6,
  'adb:15:200000:29': 129.6,
  'adb:15:200000:30': 129.6,
  'adb:15:200000:31': 148.8,
  'adb:15:200000:32': 148.8,
  'adb:15:200000:33': 148.8,
  'adb:15:200000:34': 148.8,
  'adb:15:200000:35': 148.8,
  'adb:15:200000:36': 177.6,
  'adb:15:200000:37': 177.6,
  'adb:15:200000:38': 177.6,
  'adb:15:200000:39': 177.6,
  'adb:15:200000:40': 177.6,
  'adb:15:200000:41': 230.4,
  'adb:15:200000:42': 230.4,
  'adb:15:200000:43': 230.4,
  'adb:15:200000:44': 230.4,
  'adb:15:200000:45': 230.4,
  'adb:15:200000:46': 312,
  'adb:15:200000:47': 312,
  'adb:15:200000:48': 312,
  'adb:15:200000:49': 312,
  'adb:15:200000:50': 312,
  'adb:15:200000:51': 436.8,
  'adb:15:200000:52': 436.8,
  'adb:15:200000:53': 436.8,
  'adb:15:200000:54': 436.8,
  'adb:15:200000:55': 436.8,
  'adb:15:200000:56': 297.6,
  'adb:15:200000:57': 297.6,
  'adb:15:200000:58': 297.6,
  'adb:15:200000:59': 297.6,
  'adb:15:200000:60': 297.6,
  'adb:15:200000:61': 91.2,
  'adb:15:200000:62': 91.2,
  'adb:15:200000:63': 91.2,
  'adb:15:200000:64': 91.2,
  'adb:15:200000:65': 91.2,
  'adb:15:200000:66': 91.2,
  'adb:15:200000:67': 91.2,
  'adb:15:200000:68': 91.2,
  'adb:15:200000:69': 91.2,
  'adb:15:200000:70': 91.2,
  'adb:15:200000:71': 225.6,
  'adb:15:200000:72': 225.6,
  'adb:15:200000:73': 225.6,
  'adb:15:200000:74': 225.6,
  'adb:15:200000:75': 225.6,
  'adb:15:200000:76': 432,
  'adb:15:200000:77': 432,
  'adb:15:200000:78': 432,
  'adb:15:200000:79': 432,
  'adb:15:200000:80': 432,
  'adb:15:200000:81': 638.4,
  'adb:15:200000:82': 638.4,
  'adb:15:200000:83': 638.4,
  'adb:15:200000:84': 638.4,
  'adb:15:200000:85': 638.4,
  'adb:15:200000:86': 964.8,
  'adb:15:200000:87': 964.8,
  'adb:15:200000:88': 964.8,
  'adb:15:200000:89': 964.8,
  'adb:15:200000:90': 964.8,
  'adb:15:200000:91': 1488,
  'adb:15:200000:92': 1488,
  'adb:15:200000:93': 1488,
  'adb:15:200000:94': 1488,
  'adb:15:200000:95': 1488,
  'adb:15:200000:96': 2822.4,
  'adb:15:200000:97': 2822.4,
  'adb:15:200000:98': 2822.4,
  'adb:15:200000:99': 2822.4,
  'adb:15:200000:100': 2822.4,
  'lsb:15:5000:1': 0.14,
  'lsb:15:5000:2': 0.14,
  'lsb:15:5000:3': 0.14,
  'lsb:15:5000:4': 0.14,
  'lsb:15:5000:5': 0.14,
  'lsb:15:5000:5': 0.14,
  'lsb:15:5000:6': 0.14,
  'lsb:15:5000:7': 0.14,
  'lsb:15:5000:8': 0.14,
  'lsb:15:5000:9': 0.14,
  'lsb:15:5000:10': 0.14,
  'lsb:15:5000:10': 0.14,
  'lsb:15:5000:11': 0.14,
  'lsb:15:5000:12': 0.14,
  'lsb:15:5000:13': 0.14,
  'lsb:15:5000:14': 0.14,
  'lsb:15:5000:15': 0.14,
  'lsb:15:5000:15': 0.16,
  'lsb:15:5000:16': 0.16,
  'lsb:15:5000:17': 0.16,
  'lsb:15:5000:18': 0.16,
  'lsb:15:5000:19': 0.16,
  'lsb:15:5000:20': 0.16,
  'lsb:15:5000:20': 0.19,
  'lsb:15:5000:21': 0.19,
  'lsb:15:5000:22': 0.19,
  'lsb:15:5000:23': 0.19,
  'lsb:15:5000:24': 0.19,
  'lsb:15:5000:25': 0.19,
  'lsb:15:5000:25': 0.26,
  'lsb:15:5000:26': 0.26,
  'lsb:15:5000:27': 0.26,
  'lsb:15:5000:28': 0.26,
  'lsb:15:5000:29': 0.26,
  'lsb:15:5000:30': 0.26,
  'lsb:15:5000:30': 0.37,
  'lsb:15:5000:31': 0.37,
  'lsb:15:5000:32': 0.37,
  'lsb:15:5000:33': 0.37,
  'lsb:15:5000:34': 0.37,
  'lsb:15:5000:35': 0.37,
  'lsb:15:5000:35': 0.57,
  'lsb:15:5000:36': 0.57,
  'lsb:15:5000:37': 0.57,
  'lsb:15:5000:38': 0.57,
  'lsb:15:5000:39': 0.57,
  'lsb:15:5000:40': 0.57,
  'lsb:15:5000:40': 0.9,
  'lsb:15:5000:41': 0.9,
  'lsb:15:5000:42': 0.9,
  'lsb:15:5000:43': 0.9,
  'lsb:15:5000:44': 0.9,
  'lsb:15:5000:45': 0.9,
  'lsb:15:5000:45': 1.43,
  'lsb:15:5000:46': 1.43,
  'lsb:15:5000:47': 1.43,
  'lsb:15:5000:48': 1.43,
  'lsb:15:5000:49': 1.43,
  'lsb:15:5000:50': 1.43,
  'lsb:15:5000:50': 2.23,
  'lsb:15:5000:51': 2.23,
  'lsb:15:5000:52': 2.23,
  'lsb:15:5000:53': 2.23,
  'lsb:15:5000:54': 2.23,
  'lsb:15:5000:55': 2.23,
  'lsb:15:5000:55': 3.31,
  'lsb:15:5000:56': 3.31,
  'lsb:15:5000:57': 3.31,
  'lsb:15:5000:58': 3.31,
  'lsb:15:5000:59': 3.31,
  'lsb:15:5000:60': 3.31,
  'lsb:15:5000:60': 4.87,
  'lsb:15:5000:61': 4.87,
  'lsb:15:5000:62': 4.87,
  'lsb:15:5000:63': 4.87,
  'lsb:15:5000:64': 4.87,
  'lsb:15:5000:65': 4.87,
  'lsb:15:7500:1': 0.2,
  'lsb:15:7500:2': 0.2,
  'lsb:15:7500:3': 0.2,
  'lsb:15:7500:4': 0.2,
  'lsb:15:7500:5': 0.2,
  'lsb:15:7500:5': 0.21,
  'lsb:15:7500:6': 0.21,
  'lsb:15:7500:7': 0.21,
  'lsb:15:7500:8': 0.21,
  'lsb:15:7500:9': 0.21,
  'lsb:15:7500:10': 0.21,
  'lsb:15:7500:10': 0.22,
  'lsb:15:7500:11': 0.22,
  'lsb:15:7500:12': 0.22,
  'lsb:15:7500:13': 0.22,
  'lsb:15:7500:14': 0.22,
  'lsb:15:7500:15': 0.22,
  'lsb:15:7500:15': 0.24,
  'lsb:15:7500:16': 0.24,
  'lsb:15:7500:17': 0.24,
  'lsb:15:7500:18': 0.24,
  'lsb:15:7500:19': 0.24,
  'lsb:15:7500:20': 0.24,
  'lsb:15:7500:20': 0.29,
  'lsb:15:7500:21': 0.29,
  'lsb:15:7500:22': 0.29,
  'lsb:15:7500:23': 0.29,
  'lsb:15:7500:24': 0.29,
  'lsb:15:7500:25': 0.29,
  'lsb:15:7500:25': 0.39,
  'lsb:15:7500:26': 0.39,
  'lsb:15:7500:27': 0.39,
  'lsb:15:7500:28': 0.39,
  'lsb:15:7500:29': 0.39,
  'lsb:15:7500:30': 0.39,
  'lsb:15:7500:30': 0.56,
  'lsb:15:7500:31': 0.56,
  'lsb:15:7500:32': 0.56,
  'lsb:15:7500:33': 0.56,
  'lsb:15:7500:34': 0.56,
  'lsb:15:7500:35': 0.56,
  'lsb:15:7500:35': 0.85,
  'lsb:15:7500:36': 0.85,
  'lsb:15:7500:37': 0.85,
  'lsb:15:7500:38': 0.85,
  'lsb:15:7500:39': 0.85,
  'lsb:15:7500:40': 0.85,
  'lsb:15:7500:40': 1.35,
  'lsb:15:7500:41': 1.35,
  'lsb:15:7500:42': 1.35,
  'lsb:15:7500:43': 1.35,
  'lsb:15:7500:44': 1.35,
  'lsb:15:7500:45': 1.35,
  'lsb:15:7500:45': 2.15,
  'lsb:15:7500:46': 2.15,
  'lsb:15:7500:47': 2.15,
  'lsb:15:7500:48': 2.15,
  'lsb:15:7500:49': 2.15,
  'lsb:15:7500:50': 2.15,
  'lsb:15:7500:50': 3.34,
  'lsb:15:7500:51': 3.34,
  'lsb:15:7500:52': 3.34,
  'lsb:15:7500:53': 3.34,
  'lsb:15:7500:54': 3.34,
  'lsb:15:7500:55': 3.34,
  'lsb:15:7500:55': 4.97,
  'lsb:15:7500:56': 4.97,
  'lsb:15:7500:57': 4.97,
  'lsb:15:7500:58': 4.97,
  'lsb:15:7500:59': 4.97,
  'lsb:15:7500:60': 4.97,
  'lsb:15:7500:60': 7.31,
  'lsb:15:7500:61': 7.31,
  'lsb:15:7500:62': 7.31,
  'lsb:15:7500:63': 7.31,
  'lsb:15:7500:64': 7.31,
  'lsb:15:7500:65': 7.31,
  'lsb:15:10000:1': 0.27,
  'lsb:15:10000:2': 0.27,
  'lsb:15:10000:3': 0.27,
  'lsb:15:10000:4': 0.27,
  'lsb:15:10000:5': 0.27,
  'lsb:15:10000:5': 0.27,
  'lsb:15:10000:6': 0.27,
  'lsb:15:10000:7': 0.27,
  'lsb:15:10000:8': 0.27,
  'lsb:15:10000:9': 0.27,
  'lsb:15:10000:10': 0.27,
  'lsb:15:10000:10': 0.29,
  'lsb:15:10000:11': 0.29,
  'lsb:15:10000:12': 0.29,
  'lsb:15:10000:13': 0.29,
  'lsb:15:10000:14': 0.29,
  'lsb:15:10000:15': 0.29,
  'lsb:15:10000:15': 0.32,
  'lsb:15:10000:16': 0.32,
  'lsb:15:10000:17': 0.32,
  'lsb:15:10000:18': 0.32,
  'lsb:15:10000:19': 0.32,
  'lsb:15:10000:20': 0.32,
  'lsb:15:10000:20': 0.39,
  'lsb:15:10000:21': 0.39,
  'lsb:15:10000:22': 0.39,
  'lsb:15:10000:23': 0.39,
  'lsb:15:10000:24': 0.39,
  'lsb:15:10000:25': 0.39,
  'lsb:15:10000:25': 0.52,
  'lsb:15:10000:26': 0.52,
  'lsb:15:10000:27': 0.52,
  'lsb:15:10000:28': 0.52,
  'lsb:15:10000:29': 0.52,
  'lsb:15:10000:30': 0.52,
  'lsb:15:10000:30': 0.74,
  'lsb:15:10000:31': 0.74,
  'lsb:15:10000:32': 0.74,
  'lsb:15:10000:33': 0.74,
  'lsb:15:10000:34': 0.74,
  'lsb:15:10000:35': 0.74,
  'lsb:15:10000:35': 1.13,
  'lsb:15:10000:36': 1.13,
  'lsb:15:10000:37': 1.13,
  'lsb:15:10000:38': 1.13,
  'lsb:15:10000:39': 1.13,
  'lsb:15:10000:40': 1.13,
  'lsb:15:10000:40': 1.8,
  'lsb:15:10000:41': 1.8,
  'lsb:15:10000:42': 1.8,
  'lsb:15:10000:43': 1.8,
  'lsb:15:10000:44': 1.8,
  'lsb:15:10000:45': 1.8,
  'lsb:15:10000:45': 2.87,
  'lsb:15:10000:46': 2.87,
  'lsb:15:10000:47': 2.87,
  'lsb:15:10000:48': 2.87,
  'lsb:15:10000:49': 2.87,
  'lsb:15:10000:50': 2.87,
  'lsb:15:10000:50': 4.46,
  'lsb:15:10000:51': 4.46,
  'lsb:15:10000:52': 4.46,
  'lsb:15:10000:53': 4.46,
  'lsb:15:10000:54': 4.46,
  'lsb:15:10000:55': 4.46,
  'lsb:15:10000:55': 6.62,
  'lsb:15:10000:56': 6.62,
  'lsb:15:10000:57': 6.62,
  'lsb:15:10000:58': 6.62,
  'lsb:15:10000:59': 6.62,
  'lsb:15:10000:60': 6.62,
  'lsb:15:10000:60': 9.74,
  'lsb:15:10000:61': 9.74,
  'lsb:15:10000:62': 9.74,
  'lsb:15:10000:63': 9.74,
  'lsb:15:10000:64': 9.74,
  'lsb:15:10000:65': 9.74,
  'lsb:15:15000:1': 0.41,
  'lsb:15:15000:2': 0.41,
  'lsb:15:15000:3': 0.41,
  'lsb:15:15000:4': 0.41,
  'lsb:15:15000:5': 0.41,
  'lsb:15:15000:5': 0.41,
  'lsb:15:15000:6': 0.41,
  'lsb:15:15000:7': 0.41,
  'lsb:15:15000:8': 0.41,
  'lsb:15:15000:9': 0.41,
  'lsb:15:15000:10': 0.41,
  'lsb:15:15000:10': 0.43,
  'lsb:15:15000:11': 0.43,
  'lsb:15:15000:12': 0.43,
  'lsb:15:15000:13': 0.43,
  'lsb:15:15000:14': 0.43,
  'lsb:15:15000:15': 0.43,
  'lsb:15:15000:15': 0.48,
  'lsb:15:15000:16': 0.48,
  'lsb:15:15000:17': 0.48,
  'lsb:15:15000:18': 0.48,
  'lsb:15:15000:19': 0.48,
  'lsb:15:15000:20': 0.48,
  'lsb:15:15000:20': 0.58,
  'lsb:15:15000:21': 0.58,
  'lsb:15:15000:22': 0.58,
  'lsb:15:15000:23': 0.58,
  'lsb:15:15000:24': 0.58,
  'lsb:15:15000:25': 0.58,
  'lsb:15:15000:25': 0.78,
  'lsb:15:15000:26': 0.78,
  'lsb:15:15000:27': 0.78,
  'lsb:15:15000:28': 0.78,
  'lsb:15:15000:29': 0.78,
  'lsb:15:15000:30': 0.78,
  'lsb:15:15000:30': 1.11,
  'lsb:15:15000:31': 1.11,
  'lsb:15:15000:32': 1.11,
  'lsb:15:15000:33': 1.11,
  'lsb:15:15000:34': 1.11,
  'lsb:15:15000:35': 1.11,
  'lsb:15:15000:35': 1.7,
  'lsb:15:15000:36': 1.7,
  'lsb:15:15000:37': 1.7,
  'lsb:15:15000:38': 1.7,
  'lsb:15:15000:39': 1.7,
  'lsb:15:15000:40': 1.7,
  'lsb:15:15000:40': 2.7,
  'lsb:15:15000:41': 2.7,
  'lsb:15:15000:42': 2.7,
  'lsb:15:15000:43': 2.7,
  'lsb:15:15000:44': 2.7,
  'lsb:15:15000:45': 2.7,
  'lsb:15:15000:45': 4.3,
  'lsb:15:15000:46': 4.3,
  'lsb:15:15000:47': 4.3,
  'lsb:15:15000:48': 4.3,
  'lsb:15:15000:49': 4.3,
  'lsb:15:15000:50': 4.3,
  'lsb:15:15000:50': 6.69,
  'lsb:15:15000:51': 6.69,
  'lsb:15:15000:52': 6.69,
  'lsb:15:15000:53': 6.69,
  'lsb:15:15000:54': 6.69,
  'lsb:15:15000:55': 6.69,
  'lsb:15:15000:55': 9.93,
  'lsb:15:15000:56': 9.93,
  'lsb:15:15000:57': 9.93,
  'lsb:15:15000:58': 9.93,
  'lsb:15:15000:59': 9.93,
  'lsb:15:15000:60': 9.93,
  'lsb:15:15000:60': 14.61,
  'lsb:15:15000:61': 14.61,
  'lsb:15:15000:62': 14.61,
  'lsb:15:15000:63': 14.61,
  'lsb:15:15000:64': 14.61,
  'lsb:15:15000:65': 14.61,
  'lsb:15:20000:1': 0.54,
  'lsb:15:20000:2': 0.54,
  'lsb:15:20000:3': 0.54,
  'lsb:15:20000:4': 0.54,
  'lsb:15:20000:5': 0.54,
  'lsb:15:20000:5': 0.55,
  'lsb:15:20000:6': 0.55,
  'lsb:15:20000:7': 0.55,
  'lsb:15:20000:8': 0.55,
  'lsb:15:20000:9': 0.55,
  'lsb:15:20000:10': 0.55,
  'lsb:15:20000:10': 0.57,
  'lsb:15:20000:11': 0.57,
  'lsb:15:20000:12': 0.57,
  'lsb:15:20000:13': 0.57,
  'lsb:15:20000:14': 0.57,
  'lsb:15:20000:15': 0.57,
  'lsb:15:20000:15': 0.64,
  'lsb:15:20000:16': 0.64,
  'lsb:15:20000:17': 0.64,
  'lsb:15:20000:18': 0.64,
  'lsb:15:20000:19': 0.64,
  'lsb:15:20000:20': 0.64,
  'lsb:15:20000:20': 0.78,
  'lsb:15:20000:21': 0.78,
  'lsb:15:20000:22': 0.78,
  'lsb:15:20000:23': 0.78,
  'lsb:15:20000:24': 0.78,
  'lsb:15:20000:25': 0.78,
  'lsb:15:20000:25': 1.03,
  'lsb:15:20000:26': 1.03,
  'lsb:15:20000:27': 1.03,
  'lsb:15:20000:28': 1.03,
  'lsb:15:20000:29': 1.03,
  'lsb:15:20000:30': 1.03,
  'lsb:15:20000:30': 1.48,
  'lsb:15:20000:31': 1.48,
  'lsb:15:20000:32': 1.48,
  'lsb:15:20000:33': 1.48,
  'lsb:15:20000:34': 1.48,
  'lsb:15:20000:35': 1.48,
  'lsb:15:20000:35': 2.27,
  'lsb:15:20000:36': 2.27,
  'lsb:15:20000:37': 2.27,
  'lsb:15:20000:38': 2.27,
  'lsb:15:20000:39': 2.27,
  'lsb:15:20000:40': 2.27,
  'lsb:15:20000:40': 3.6,
  'lsb:15:20000:41': 3.6,
  'lsb:15:20000:42': 3.6,
  'lsb:15:20000:43': 3.6,
  'lsb:15:20000:44': 3.6,
  'lsb:15:20000:45': 3.6,
  'lsb:15:20000:45': 5.73,
  'lsb:15:20000:46': 5.73,
  'lsb:15:20000:47': 5.73,
  'lsb:15:20000:48': 5.73,
  'lsb:15:20000:49': 5.73,
  'lsb:15:20000:50': 5.73,
  'lsb:15:20000:50': 8.92,
  'lsb:15:20000:51': 8.92,
  'lsb:15:20000:52': 8.92,
  'lsb:15:20000:53': 8.92,
  'lsb:15:20000:54': 8.92,
  'lsb:15:20000:55': 8.92,
  'lsb:15:20000:55': 13.24,
  'lsb:15:20000:56': 13.24,
  'lsb:15:20000:57': 13.24,
  'lsb:15:20000:58': 13.24,
  'lsb:15:20000:59': 13.24,
  'lsb:15:20000:60': 13.24,
  'lsb:15:20000:60': 19.48,
  'lsb:15:20000:61': 19.48,
  'lsb:15:20000:62': 19.48,
  'lsb:15:20000:63': 19.48,
  'lsb:15:20000:64': 19.48,
  'lsb:15:20000:65': 19.48,
  'lsb:15:25000:1': 0.68,
  'lsb:15:25000:2': 0.68,
  'lsb:15:25000:3': 0.68,
  'lsb:15:25000:4': 0.68,
  'lsb:15:25000:5': 0.68,
  'lsb:15:25000:5': 0.69,
  'lsb:15:25000:6': 0.69,
  'lsb:15:25000:7': 0.69,
  'lsb:15:25000:8': 0.69,
  'lsb:15:25000:9': 0.69,
  'lsb:15:25000:10': 0.69,
  'lsb:15:25000:10': 0.72,
  'lsb:15:25000:11': 0.72,
  'lsb:15:25000:12': 0.72,
  'lsb:15:25000:13': 0.72,
  'lsb:15:25000:14': 0.72,
  'lsb:15:25000:15': 0.72,
  'lsb:15:25000:15': 0.8,
  'lsb:15:25000:16': 0.8,
  'lsb:15:25000:17': 0.8,
  'lsb:15:25000:18': 0.8,
  'lsb:15:25000:19': 0.8,
  'lsb:15:25000:20': 0.8,
  'lsb:15:25000:20': 0.97,
  'lsb:15:25000:21': 0.97,
  'lsb:15:25000:22': 0.97,
  'lsb:15:25000:23': 0.97,
  'lsb:15:25000:24': 0.97,
  'lsb:15:25000:25': 0.97,
  'lsb:15:25000:25': 1.29,
  'lsb:15:25000:26': 1.29,
  'lsb:15:25000:27': 1.29,
  'lsb:15:25000:28': 1.29,
  'lsb:15:25000:29': 1.29,
  'lsb:15:25000:30': 1.29,
  'lsb:15:25000:30': 1.86,
  'lsb:15:25000:31': 1.86,
  'lsb:15:25000:32': 1.86,
  'lsb:15:25000:33': 1.86,
  'lsb:15:25000:34': 1.86,
  'lsb:15:25000:35': 1.86,
  'lsb:15:25000:35': 2.84,
  'lsb:15:25000:36': 2.84,
  'lsb:15:25000:37': 2.84,
  'lsb:15:25000:38': 2.84,
  'lsb:15:25000:39': 2.84,
  'lsb:15:25000:40': 2.84,
  'lsb:15:25000:40': 4.51,
  'lsb:15:25000:41': 4.51,
  'lsb:15:25000:42': 4.51,
  'lsb:15:25000:43': 4.51,
  'lsb:15:25000:44': 4.51,
  'lsb:15:25000:45': 4.51,
  'lsb:15:25000:45': 7.17,
  'lsb:15:25000:46': 7.17,
  'lsb:15:25000:47': 7.17,
  'lsb:15:25000:48': 7.17,
  'lsb:15:25000:49': 7.17,
  'lsb:15:25000:50': 7.17,
  'lsb:15:25000:50': 11.15,
  'lsb:15:25000:51': 11.15,
  'lsb:15:25000:52': 11.15,
  'lsb:15:25000:53': 11.15,
  'lsb:15:25000:54': 11.15,
  'lsb:15:25000:55': 11.15,
  'lsb:15:25000:55': 16.55,
  'lsb:15:25000:56': 16.55,
  'lsb:15:25000:57': 16.55,
  'lsb:15:25000:58': 16.55,
  'lsb:15:25000:59': 16.55,
  'lsb:15:25000:60': 16.55,
  'lsb:15:25000:60': 24.36,
  'lsb:15:25000:61': 24.36,
  'lsb:15:25000:62': 24.36,
  'lsb:15:25000:63': 24.36,
  'lsb:15:25000:64': 24.36,
  'lsb:15:25000:65': 24.36,
  'lsb:15:30000:1': 0.81,
  'lsb:15:30000:2': 0.81,
  'lsb:15:30000:3': 0.81,
  'lsb:15:30000:4': 0.81,
  'lsb:15:30000:5': 0.81,
  'lsb:15:30000:5': 0.82,
  'lsb:15:30000:6': 0.82,
  'lsb:15:30000:7': 0.82,
  'lsb:15:30000:8': 0.82,
  'lsb:15:30000:9': 0.82,
  'lsb:15:30000:10': 0.82,
  'lsb:15:30000:10': 0.86,
  'lsb:15:30000:11': 0.86,
  'lsb:15:30000:12': 0.86,
  'lsb:15:30000:13': 0.86,
  'lsb:15:30000:14': 0.86,
  'lsb:15:30000:15': 0.86,
  'lsb:15:30000:15': 0.96,
  'lsb:15:30000:16': 0.96,
  'lsb:15:30000:17': 0.96,
  'lsb:15:30000:18': 0.96,
  'lsb:15:30000:19': 0.96,
  'lsb:15:30000:20': 0.96,
  'lsb:15:30000:20': 1.16,
  'lsb:15:30000:21': 1.16,
  'lsb:15:30000:22': 1.16,
  'lsb:15:30000:23': 1.16,
  'lsb:15:30000:24': 1.16,
  'lsb:15:30000:25': 1.16,
  'lsb:15:30000:25': 1.55,
  'lsb:15:30000:26': 1.55,
  'lsb:15:30000:27': 1.55,
  'lsb:15:30000:28': 1.55,
  'lsb:15:30000:29': 1.55,
  'lsb:15:30000:30': 1.55,
  'lsb:15:30000:30': 2.22,
  'lsb:15:30000:31': 2.22,
  'lsb:15:30000:32': 2.22,
  'lsb:15:30000:33': 2.22,
  'lsb:15:30000:34': 2.22,
  'lsb:15:30000:35': 2.22,
  'lsb:15:30000:35': 3.4,
  'lsb:15:30000:36': 3.4,
  'lsb:15:30000:37': 3.4,
  'lsb:15:30000:38': 3.4,
  'lsb:15:30000:39': 3.4,
  'lsb:15:30000:40': 3.4,
  'lsb:15:30000:40': 5.4,
  'lsb:15:30000:41': 5.4,
  'lsb:15:30000:42': 5.4,
  'lsb:15:30000:43': 5.4,
  'lsb:15:30000:44': 5.4,
  'lsb:15:30000:45': 5.4,
  'lsb:15:30000:45': 8.6,
  'lsb:15:30000:46': 8.6,
  'lsb:15:30000:47': 8.6,
  'lsb:15:30000:48': 8.6,
  'lsb:15:30000:49': 8.6,
  'lsb:15:30000:50': 8.6,
  'lsb:15:30000:50': 13.36,
  'lsb:15:30000:51': 13.36,
  'lsb:15:30000:52': 13.36,
  'lsb:15:30000:53': 13.36,
  'lsb:15:30000:54': 13.36,
  'lsb:15:30000:55': 13.36,
  'lsb:15:30000:55': 19.84,
  'lsb:15:30000:56': 19.84,
  'lsb:15:30000:57': 19.84,
  'lsb:15:30000:58': 19.84,
  'lsb:15:30000:59': 19.84,
  'lsb:15:30000:60': 19.84,
  'lsb:15:30000:60': 29.19,
  'lsb:15:30000:61': 29.19,
  'lsb:15:30000:62': 29.19,
  'lsb:15:30000:63': 29.19,
  'lsb:15:30000:64': 29.19,
  'lsb:15:30000:65': 29.19,
  'lsb:15:40000:1': 1.08,
  'lsb:15:40000:2': 1.08,
  'lsb:15:40000:3': 1.08,
  'lsb:15:40000:4': 1.08,
  'lsb:15:40000:5': 1.08,
  'lsb:15:40000:5': 1.1,
  'lsb:15:40000:6': 1.1,
  'lsb:15:40000:7': 1.1,
  'lsb:15:40000:8': 1.1,
  'lsb:15:40000:9': 1.1,
  'lsb:15:40000:10': 1.1,
  'lsb:15:40000:10': 1.15,
  'lsb:15:40000:11': 1.15,
  'lsb:15:40000:12': 1.15,
  'lsb:15:40000:13': 1.15,
  'lsb:15:40000:14': 1.15,
  'lsb:15:40000:15': 1.15,
  'lsb:15:40000:15': 1.27,
  'lsb:15:40000:16': 1.27,
  'lsb:15:40000:17': 1.27,
  'lsb:15:40000:18': 1.27,
  'lsb:15:40000:19': 1.27,
  'lsb:15:40000:20': 1.27,
  'lsb:15:40000:20': 1.55,
  'lsb:15:40000:21': 1.55,
  'lsb:15:40000:22': 1.55,
  'lsb:15:40000:23': 1.55,
  'lsb:15:40000:24': 1.55,
  'lsb:15:40000:25': 1.55,
  'lsb:15:40000:25': 2.07,
  'lsb:15:40000:26': 2.07,
  'lsb:15:40000:27': 2.07,
  'lsb:15:40000:28': 2.07,
  'lsb:15:40000:29': 2.07,
  'lsb:15:40000:30': 2.07,
  'lsb:15:40000:30': 2.97,
  'lsb:15:40000:31': 2.97,
  'lsb:15:40000:32': 2.97,
  'lsb:15:40000:33': 2.97,
  'lsb:15:40000:34': 2.97,
  'lsb:15:40000:35': 2.97,
  'lsb:15:40000:35': 4.54,
  'lsb:15:40000:36': 4.54,
  'lsb:15:40000:37': 4.54,
  'lsb:15:40000:38': 4.54,
  'lsb:15:40000:39': 4.54,
  'lsb:15:40000:40': 4.54,
  'lsb:15:40000:40': 7.21,
  'lsb:15:40000:41': 7.21,
  'lsb:15:40000:42': 7.21,
  'lsb:15:40000:43': 7.21,
  'lsb:15:40000:44': 7.21,
  'lsb:15:40000:45': 7.21,
  'lsb:15:40000:45': 11.47,
  'lsb:15:40000:46': 11.47,
  'lsb:15:40000:47': 11.47,
  'lsb:15:40000:48': 11.47,
  'lsb:15:40000:49': 11.47,
  'lsb:15:40000:50': 11.47,
  'lsb:15:40000:50': 17.83,
  'lsb:15:40000:51': 17.83,
  'lsb:15:40000:52': 17.83,
  'lsb:15:40000:53': 17.83,
  'lsb:15:40000:54': 17.83,
  'lsb:15:40000:55': 17.83,
  'lsb:15:40000:55': 26.48,
  'lsb:15:40000:56': 26.48,
  'lsb:15:40000:57': 26.48,
  'lsb:15:40000:58': 26.48,
  'lsb:15:40000:59': 26.48,
  'lsb:15:40000:60': 26.48,
  'lsb:15:40000:60': 38.96,
  'lsb:15:40000:61': 38.96,
  'lsb:15:40000:62': 38.96,
  'lsb:15:40000:63': 38.96,
  'lsb:15:40000:64': 38.96,
  'lsb:15:40000:65': 38.96,
  'lsb:15:50000:1': 1.35,
  'lsb:15:50000:2': 1.35,
  'lsb:15:50000:3': 1.35,
  'lsb:15:50000:4': 1.35,
  'lsb:15:50000:5': 1.35,
  'lsb:15:50000:5': 1.37,
  'lsb:15:50000:6': 1.37,
  'lsb:15:50000:7': 1.37,
  'lsb:15:50000:8': 1.37,
  'lsb:15:50000:9': 1.37,
  'lsb:15:50000:10': 1.37,
  'lsb:15:50000:10': 1.43,
  'lsb:15:50000:11': 1.43,
  'lsb:15:50000:12': 1.43,
  'lsb:15:50000:13': 1.43,
  'lsb:15:50000:14': 1.43,
  'lsb:15:50000:15': 1.43,
  'lsb:15:50000:15': 1.59,
  'lsb:15:50000:16': 1.59,
  'lsb:15:50000:17': 1.59,
  'lsb:15:50000:18': 1.59,
  'lsb:15:50000:19': 1.59,
  'lsb:15:50000:20': 1.59,
  'lsb:15:50000:20': 1.94,
  'lsb:15:50000:21': 1.94,
  'lsb:15:50000:22': 1.94,
  'lsb:15:50000:23': 1.94,
  'lsb:15:50000:24': 1.94,
  'lsb:15:50000:25': 1.94,
  'lsb:15:50000:25': 2.59,
  'lsb:15:50000:26': 2.59,
  'lsb:15:50000:27': 2.59,
  'lsb:15:50000:28': 2.59,
  'lsb:15:50000:29': 2.59,
  'lsb:15:50000:30': 2.59,
  'lsb:15:50000:30': 3.71,
  'lsb:15:50000:31': 3.71,
  'lsb:15:50000:32': 3.71,
  'lsb:15:50000:33': 3.71,
  'lsb:15:50000:34': 3.71,
  'lsb:15:50000:35': 3.71,
  'lsb:15:50000:35': 5.67,
  'lsb:15:50000:36': 5.67,
  'lsb:15:50000:37': 5.67,
  'lsb:15:50000:38': 5.67,
  'lsb:15:50000:39': 5.67,
  'lsb:15:50000:40': 5.67,
  'lsb:15:50000:40': 9.01,
  'lsb:15:50000:41': 9.01,
  'lsb:15:50000:42': 9.01,
  'lsb:15:50000:43': 9.01,
  'lsb:15:50000:44': 9.01,
  'lsb:15:50000:45': 9.01,
  'lsb:15:50000:45': 14.34,
  'lsb:15:50000:46': 14.34,
  'lsb:15:50000:47': 14.34,
  'lsb:15:50000:48': 14.34,
  'lsb:15:50000:49': 14.34,
  'lsb:15:50000:50': 14.34,
  'lsb:15:50000:50': 22.3,
  'lsb:15:50000:51': 22.3,
  'lsb:15:50000:52': 22.3,
  'lsb:15:50000:53': 22.3,
  'lsb:15:50000:54': 22.3,
  'lsb:15:50000:55': 22.3,
  'lsb:15:50000:55': 33.11,
  'lsb:15:50000:56': 33.11,
  'lsb:15:50000:57': 33.11,
  'lsb:15:50000:58': 33.11,
  'lsb:15:50000:59': 33.11,
  'lsb:15:50000:60': 33.11,
  'lsb:15:50000:60': 48.72,
  'lsb:15:50000:61': 48.72,
  'lsb:15:50000:62': 48.72,
  'lsb:15:50000:63': 48.72,
  'lsb:15:50000:64': 48.72,
  'lsb:15:50000:65': 48.72,
  'lsb:15:60000:1': 1.62,
  'lsb:15:60000:2': 1.62,
  'lsb:15:60000:3': 1.62,
  'lsb:15:60000:4': 1.62,
  'lsb:15:60000:5': 1.62,
  'lsb:15:60000:5': 1.64,
  'lsb:15:60000:6': 1.64,
  'lsb:15:60000:7': 1.64,
  'lsb:15:60000:8': 1.64,
  'lsb:15:60000:9': 1.64,
  'lsb:15:60000:10': 1.64,
  'lsb:15:60000:10': 1.72,
  'lsb:15:60000:11': 1.72,
  'lsb:15:60000:12': 1.72,
  'lsb:15:60000:13': 1.72,
  'lsb:15:60000:14': 1.72,
  'lsb:15:60000:15': 1.72,
  'lsb:15:60000:15': 1.91,
  'lsb:15:60000:16': 1.91,
  'lsb:15:60000:17': 1.91,
  'lsb:15:60000:18': 1.91,
  'lsb:15:60000:19': 1.91,
  'lsb:15:60000:20': 1.91,
  'lsb:15:60000:20': 2.33,
  'lsb:15:60000:21': 2.33,
  'lsb:15:60000:22': 2.33,
  'lsb:15:60000:23': 2.33,
  'lsb:15:60000:24': 2.33,
  'lsb:15:60000:25': 2.33,
  'lsb:15:60000:25': 3.1,
  'lsb:15:60000:26': 3.1,
  'lsb:15:60000:27': 3.1,
  'lsb:15:60000:28': 3.1,
  'lsb:15:60000:29': 3.1,
  'lsb:15:60000:30': 3.1,
  'lsb:15:60000:30': 4.45,
  'lsb:15:60000:31': 4.45,
  'lsb:15:60000:32': 4.45,
  'lsb:15:60000:33': 4.45,
  'lsb:15:60000:34': 4.45,
  'lsb:15:60000:35': 4.45,
  'lsb:15:60000:35': 6.8,
  'lsb:15:60000:36': 6.8,
  'lsb:15:60000:37': 6.8,
  'lsb:15:60000:38': 6.8,
  'lsb:15:60000:39': 6.8,
  'lsb:15:60000:40': 6.8,
  'lsb:15:60000:40': 10.8,
  'lsb:15:60000:41': 10.8,
  'lsb:15:60000:42': 10.8,
  'lsb:15:60000:43': 10.8,
  'lsb:15:60000:44': 10.8,
  'lsb:15:60000:45': 10.8,
  'lsb:15:60000:45': 17.19,
  'lsb:15:60000:46': 17.19,
  'lsb:15:60000:47': 17.19,
  'lsb:15:60000:48': 17.19,
  'lsb:15:60000:49': 17.19,
  'lsb:15:60000:50': 17.19,
  'lsb:15:60000:50': 26.72,
  'lsb:15:60000:51': 26.72,
  'lsb:15:60000:52': 26.72,
  'lsb:15:60000:53': 26.72,
  'lsb:15:60000:54': 26.72,
  'lsb:15:60000:55': 26.72,
  'lsb:15:60000:55': 39.69,
  'lsb:15:60000:56': 39.69,
  'lsb:15:60000:57': 39.69,
  'lsb:15:60000:58': 39.69,
  'lsb:15:60000:59': 39.69,
  'lsb:15:60000:60': 39.69,
  'lsb:15:60000:60': 58.39,
  'lsb:15:60000:61': 58.39,
  'lsb:15:60000:62': 58.39,
  'lsb:15:60000:63': 58.39,
  'lsb:15:60000:64': 58.39,
  'lsb:15:60000:65': 58.39,
  'lsb:15:70000:1': 1.89,
  'lsb:15:70000:2': 1.89,
  'lsb:15:70000:3': 1.89,
  'lsb:15:70000:4': 1.89,
  'lsb:15:70000:5': 1.89,
  'lsb:15:70000:5': 1.92,
  'lsb:15:70000:6': 1.92,
  'lsb:15:70000:7': 1.92,
  'lsb:15:70000:8': 1.92,
  'lsb:15:70000:9': 1.92,
  'lsb:15:70000:10': 1.92,
  'lsb:15:70000:10': 2.01,
  'lsb:15:70000:11': 2.01,
  'lsb:15:70000:12': 2.01,
  'lsb:15:70000:13': 2.01,
  'lsb:15:70000:14': 2.01,
  'lsb:15:70000:15': 2.01,
  'lsb:15:70000:15': 2.23,
  'lsb:15:70000:16': 2.23,
  'lsb:15:70000:17': 2.23,
  'lsb:15:70000:18': 2.23,
  'lsb:15:70000:19': 2.23,
  'lsb:15:70000:20': 2.23,
  'lsb:15:70000:20': 2.72,
  'lsb:15:70000:21': 2.72,
  'lsb:15:70000:22': 2.72,
  'lsb:15:70000:23': 2.72,
  'lsb:15:70000:24': 2.72,
  'lsb:15:70000:25': 2.72,
  'lsb:15:70000:25': 3.62,
  'lsb:15:70000:26': 3.62,
  'lsb:15:70000:27': 3.62,
  'lsb:15:70000:28': 3.62,
  'lsb:15:70000:29': 3.62,
  'lsb:15:70000:30': 3.62,
  'lsb:15:70000:30': 5.19,
  'lsb:15:70000:31': 5.19,
  'lsb:15:70000:32': 5.19,
  'lsb:15:70000:33': 5.19,
  'lsb:15:70000:34': 5.19,
  'lsb:15:70000:35': 5.19,
  'lsb:15:70000:35': 7.94,
  'lsb:15:70000:36': 7.94,
  'lsb:15:70000:37': 7.94,
  'lsb:15:70000:38': 7.94,
  'lsb:15:70000:39': 7.94,
  'lsb:15:70000:40': 7.94,
  'lsb:15:70000:40': 12.61,
  'lsb:15:70000:41': 12.61,
  'lsb:15:70000:42': 12.61,
  'lsb:15:70000:43': 12.61,
  'lsb:15:70000:44': 12.61,
  'lsb:15:70000:45': 12.61,
  'lsb:15:70000:45': 20.07,
  'lsb:15:70000:46': 20.07,
  'lsb:15:70000:47': 20.07,
  'lsb:15:70000:48': 20.07,
  'lsb:15:70000:49': 20.07,
  'lsb:15:70000:50': 20.07,
  'lsb:15:70000:50': 31.2,
  'lsb:15:70000:51': 31.2,
  'lsb:15:70000:52': 31.2,
  'lsb:15:70000:53': 31.2,
  'lsb:15:70000:54': 31.2,
  'lsb:15:70000:55': 31.2,
  'lsb:15:70000:55': 46.34,
  'lsb:15:70000:56': 46.34,
  'lsb:15:70000:57': 46.34,
  'lsb:15:70000:58': 46.34,
  'lsb:15:70000:59': 46.34,
  'lsb:15:70000:60': 46.34,
  'lsb:15:70000:60': 68.18,
  'lsb:15:70000:61': 68.18,
  'lsb:15:70000:62': 68.18,
  'lsb:15:70000:63': 68.18,
  'lsb:15:70000:64': 68.18,
  'lsb:15:70000:65': 68.18,
  'lsb:15:80000:1': 2.16,
  'lsb:15:80000:2': 2.16,
  'lsb:15:80000:3': 2.16,
  'lsb:15:80000:4': 2.16,
  'lsb:15:80000:5': 2.16,
  'lsb:15:80000:5': 2.2,
  'lsb:15:80000:6': 2.2,
  'lsb:15:80000:7': 2.2,
  'lsb:15:80000:8': 2.2,
  'lsb:15:80000:9': 2.2,
  'lsb:15:80000:10': 2.2,
  'lsb:15:80000:10': 2.3,
  'lsb:15:80000:11': 2.3,
  'lsb:15:80000:12': 2.3,
  'lsb:15:80000:13': 2.3,
  'lsb:15:80000:14': 2.3,
  'lsb:15:80000:15': 2.3,
  'lsb:15:80000:15': 2.55,
  'lsb:15:80000:16': 2.55,
  'lsb:15:80000:17': 2.55,
  'lsb:15:80000:18': 2.55,
  'lsb:15:80000:19': 2.55,
  'lsb:15:80000:20': 2.55,
  'lsb:15:80000:20': 3.11,
  'lsb:15:80000:21': 3.11,
  'lsb:15:80000:22': 3.11,
  'lsb:15:80000:23': 3.11,
  'lsb:15:80000:24': 3.11,
  'lsb:15:80000:25': 3.11,
  'lsb:15:80000:25': 4.14,
  'lsb:15:80000:26': 4.14,
  'lsb:15:80000:27': 4.14,
  'lsb:15:80000:28': 4.14,
  'lsb:15:80000:29': 4.14,
  'lsb:15:80000:30': 4.14,
  'lsb:15:80000:30': 5.94,
  'lsb:15:80000:31': 5.94,
  'lsb:15:80000:32': 5.94,
  'lsb:15:80000:33': 5.94,
  'lsb:15:80000:34': 5.94,
  'lsb:15:80000:35': 5.94,
  'lsb:15:80000:35': 9.08,
  'lsb:15:80000:36': 9.08,
  'lsb:15:80000:37': 9.08,
  'lsb:15:80000:38': 9.08,
  'lsb:15:80000:39': 9.08,
  'lsb:15:80000:40': 9.08,
  'lsb:15:80000:40': 14.42,
  'lsb:15:80000:41': 14.42,
  'lsb:15:80000:42': 14.42,
  'lsb:15:80000:43': 14.42,
  'lsb:15:80000:44': 14.42,
  'lsb:15:80000:45': 14.42,
  'lsb:15:80000:45': 22.94,
  'lsb:15:80000:46': 22.94,
  'lsb:15:80000:47': 22.94,
  'lsb:15:80000:48': 22.94,
  'lsb:15:80000:49': 22.94,
  'lsb:15:80000:50': 22.94,
  'lsb:15:80000:50': 35.67,
  'lsb:15:80000:51': 35.67,
  'lsb:15:80000:52': 35.67,
  'lsb:15:80000:53': 35.67,
  'lsb:15:80000:54': 35.67,
  'lsb:15:80000:55': 35.67,
  'lsb:15:80000:55': 52.97,
  'lsb:15:80000:56': 52.97,
  'lsb:15:80000:57': 52.97,
  'lsb:15:80000:58': 52.97,
  'lsb:15:80000:59': 52.97,
  'lsb:15:80000:60': 52.97,
  'lsb:15:80000:60': 77.94,
  'lsb:15:80000:61': 77.94,
  'lsb:15:80000:62': 77.94,
  'lsb:15:80000:63': 77.94,
  'lsb:15:80000:64': 77.94,
  'lsb:15:80000:65': 77.94,
  'lsb:15:90000:1': 2.43,
  'lsb:15:90000:2': 2.43,
  'lsb:15:90000:3': 2.43,
  'lsb:15:90000:4': 2.43,
  'lsb:15:90000:5': 2.43,
  'lsb:15:90000:5': 2.47,
  'lsb:15:90000:6': 2.47,
  'lsb:15:90000:7': 2.47,
  'lsb:15:90000:8': 2.47,
  'lsb:15:90000:9': 2.47,
  'lsb:15:90000:10': 2.47,
  'lsb:15:90000:10': 2.58,
  'lsb:15:90000:11': 2.58,
  'lsb:15:90000:12': 2.58,
  'lsb:15:90000:13': 2.58,
  'lsb:15:90000:14': 2.58,
  'lsb:15:90000:15': 2.58,
  'lsb:15:90000:15': 2.87,
  'lsb:15:90000:16': 2.87,
  'lsb:15:90000:17': 2.87,
  'lsb:15:90000:18': 2.87,
  'lsb:15:90000:19': 2.87,
  'lsb:15:90000:20': 2.87,
  'lsb:15:90000:20': 3.5,
  'lsb:15:90000:21': 3.5,
  'lsb:15:90000:22': 3.5,
  'lsb:15:90000:23': 3.5,
  'lsb:15:90000:24': 3.5,
  'lsb:15:90000:25': 3.5,
  'lsb:15:90000:25': 4.66,
  'lsb:15:90000:26': 4.66,
  'lsb:15:90000:27': 4.66,
  'lsb:15:90000:28': 4.66,
  'lsb:15:90000:29': 4.66,
  'lsb:15:90000:30': 4.66,
  'lsb:15:90000:30': 6.68,
  'lsb:15:90000:31': 6.68,
  'lsb:15:90000:32': 6.68,
  'lsb:15:90000:33': 6.68,
  'lsb:15:90000:34': 6.68,
  'lsb:15:90000:35': 6.68,
  'lsb:15:90000:35': 10.21,
  'lsb:15:90000:36': 10.21,
  'lsb:15:90000:37': 10.21,
  'lsb:15:90000:38': 10.21,
  'lsb:15:90000:39': 10.21,
  'lsb:15:90000:40': 10.21,
  'lsb:15:90000:40': 16.23,
  'lsb:15:90000:41': 16.23,
  'lsb:15:90000:42': 16.23,
  'lsb:15:90000:43': 16.23,
  'lsb:15:90000:44': 16.23,
  'lsb:15:90000:45': 16.23,
  'lsb:15:90000:45': 25.82,
  'lsb:15:90000:46': 25.82,
  'lsb:15:90000:47': 25.82,
  'lsb:15:90000:48': 25.82,
  'lsb:15:90000:49': 25.82,
  'lsb:15:90000:50': 25.82,
  'lsb:15:90000:50': 40.13,
  'lsb:15:90000:51': 40.13,
  'lsb:15:90000:52': 40.13,
  'lsb:15:90000:53': 40.13,
  'lsb:15:90000:54': 40.13,
  'lsb:15:90000:55': 40.13,
  'lsb:15:90000:55': 59.6,
  'lsb:15:90000:56': 59.6,
  'lsb:15:90000:57': 59.6,
  'lsb:15:90000:58': 59.6,
  'lsb:15:90000:59': 59.6,
  'lsb:15:90000:60': 59.6,
  'lsb:15:90000:60': 87.69,
  'lsb:15:90000:61': 87.69,
  'lsb:15:90000:62': 87.69,
  'lsb:15:90000:63': 87.69,
  'lsb:15:90000:64': 87.69,
  'lsb:15:90000:65': 87.69,
  'lsb:15:100000:1': 2.7,
  'lsb:15:100000:2': 2.7,
  'lsb:15:100000:3': 2.7,
  'lsb:15:100000:4': 2.7,
  'lsb:15:100000:5': 2.7,
  'lsb:15:100000:5': 2.74,
  'lsb:15:100000:6': 2.74,
  'lsb:15:100000:7': 2.74,
  'lsb:15:100000:8': 2.74,
  'lsb:15:100000:9': 2.74,
  'lsb:15:100000:10': 2.74,
  'lsb:15:100000:10': 2.87,
  'lsb:15:100000:11': 2.87,
  'lsb:15:100000:12': 2.87,
  'lsb:15:100000:13': 2.87,
  'lsb:15:100000:14': 2.87,
  'lsb:15:100000:15': 2.87,
  'lsb:15:100000:15': 3.18,
  'lsb:15:100000:16': 3.18,
  'lsb:15:100000:17': 3.18,
  'lsb:15:100000:18': 3.18,
  'lsb:15:100000:19': 3.18,
  'lsb:15:100000:20': 3.18,
  'lsb:15:100000:20': 3.88,
  'lsb:15:100000:21': 3.88,
  'lsb:15:100000:22': 3.88,
  'lsb:15:100000:23': 3.88,
  'lsb:15:100000:24': 3.88,
  'lsb:15:100000:25': 3.88,
  'lsb:15:100000:25': 5.17,
  'lsb:15:100000:26': 5.17,
  'lsb:15:100000:27': 5.17,
  'lsb:15:100000:28': 5.17,
  'lsb:15:100000:29': 5.17,
  'lsb:15:100000:30': 5.17,
  'lsb:15:100000:30': 7.41,
  'lsb:15:100000:31': 7.41,
  'lsb:15:100000:32': 7.41,
  'lsb:15:100000:33': 7.41,
  'lsb:15:100000:34': 7.41,
  'lsb:15:100000:35': 7.41,
  'lsb:15:100000:35': 11.33,
  'lsb:15:100000:36': 11.33,
  'lsb:15:100000:37': 11.33,
  'lsb:15:100000:38': 11.33,
  'lsb:15:100000:39': 11.33,
  'lsb:15:100000:40': 11.33,
  'lsb:15:100000:40': 18.01,
  'lsb:15:100000:41': 18.01,
  'lsb:15:100000:42': 18.01,
  'lsb:15:100000:43': 18.01,
  'lsb:15:100000:44': 18.01,
  'lsb:15:100000:45': 18.01,
  'lsb:15:100000:45': 28.65,
  'lsb:15:100000:46': 28.65,
  'lsb:15:100000:47': 28.65,
  'lsb:15:100000:48': 28.65,
  'lsb:15:100000:49': 28.65,
  'lsb:15:100000:50': 28.65,
  'lsb:15:100000:50': 44.54,
  'lsb:15:100000:51': 44.54,
  'lsb:15:100000:52': 44.54,
  'lsb:15:100000:53': 44.54,
  'lsb:15:100000:54': 44.54,
  'lsb:15:100000:55': 44.54,
  'lsb:15:100000:55': 66.15,
  'lsb:15:100000:56': 66.15,
  'lsb:15:100000:57': 66.15,
  'lsb:15:100000:58': 66.15,
  'lsb:15:100000:59': 66.15,
  'lsb:15:100000:60': 66.15,
  'lsb:15:100000:60': 97.32,
  'lsb:15:100000:61': 97.32,
  'lsb:15:100000:62': 97.32,
  'lsb:15:100000:63': 97.32,
  'lsb:15:100000:64': 97.32,
  'lsb:15:100000:65': 97.32,
  'lsb:15:120000:1': 3.24,
  'lsb:15:120000:2': 3.24,
  'lsb:15:120000:3': 3.24,
  'lsb:15:120000:4': 3.24,
  'lsb:15:120000:5': 3.24,
  'lsb:15:120000:5': 3.29,
  'lsb:15:120000:6': 3.29,
  'lsb:15:120000:7': 3.29,
  'lsb:15:120000:8': 3.29,
  'lsb:15:120000:9': 3.29,
  'lsb:15:120000:10': 3.29,
  'lsb:15:120000:10': 3.44,
  'lsb:15:120000:11': 3.44,
  'lsb:15:120000:12': 3.44,
  'lsb:15:120000:13': 3.44,
  'lsb:15:120000:14': 3.44,
  'lsb:15:120000:15': 3.44,
  'lsb:15:120000:15': 3.82,
  'lsb:15:120000:16': 3.82,
  'lsb:15:120000:17': 3.82,
  'lsb:15:120000:18': 3.82,
  'lsb:15:120000:19': 3.82,
  'lsb:15:120000:20': 3.82,
  'lsb:15:120000:20': 4.66,
  'lsb:15:120000:21': 4.66,
  'lsb:15:120000:22': 4.66,
  'lsb:15:120000:23': 4.66,
  'lsb:15:120000:24': 4.66,
  'lsb:15:120000:25': 4.66,
  'lsb:15:120000:25': 6.2,
  'lsb:15:120000:26': 6.2,
  'lsb:15:120000:27': 6.2,
  'lsb:15:120000:28': 6.2,
  'lsb:15:120000:29': 6.2,
  'lsb:15:120000:30': 6.2,
  'lsb:15:120000:30': 8.9,
  'lsb:15:120000:31': 8.9,
  'lsb:15:120000:32': 8.9,
  'lsb:15:120000:33': 8.9,
  'lsb:15:120000:34': 8.9,
  'lsb:15:120000:35': 8.9,
  'lsb:15:120000:35': 13.6,
  'lsb:15:120000:36': 13.6,
  'lsb:15:120000:37': 13.6,
  'lsb:15:120000:38': 13.6,
  'lsb:15:120000:39': 13.6,
  'lsb:15:120000:40': 13.6,
  'lsb:15:120000:40': 21.61,
  'lsb:15:120000:41': 21.61,
  'lsb:15:120000:42': 21.61,
  'lsb:15:120000:43': 21.61,
  'lsb:15:120000:44': 21.61,
  'lsb:15:120000:45': 21.61,
  'lsb:15:120000:45': 34.38,
  'lsb:15:120000:46': 34.38,
  'lsb:15:120000:47': 34.38,
  'lsb:15:120000:48': 34.38,
  'lsb:15:120000:49': 34.38,
  'lsb:15:120000:50': 34.38,
  'lsb:15:120000:50': 53.45,
  'lsb:15:120000:51': 53.45,
  'lsb:15:120000:52': 53.45,
  'lsb:15:120000:53': 53.45,
  'lsb:15:120000:54': 53.45,
  'lsb:15:120000:55': 53.45,
  'lsb:15:120000:55': 79.37,
  'lsb:15:120000:56': 79.37,
  'lsb:15:120000:57': 79.37,
  'lsb:15:120000:58': 79.37,
  'lsb:15:120000:59': 79.37,
  'lsb:15:120000:60': 79.37,
  'lsb:15:120000:60': 116.77,
  'lsb:15:120000:61': 116.77,
  'lsb:15:120000:62': 116.77,
  'lsb:15:120000:63': 116.77,
  'lsb:15:120000:64': 116.77,
  'lsb:15:120000:65': 116.77,
  'lsb:15:140000:1': 3.78,
  'lsb:15:140000:2': 3.78,
  'lsb:15:140000:3': 3.78,
  'lsb:15:140000:4': 3.78,
  'lsb:15:140000:5': 3.78,
  'lsb:15:140000:5': 3.84,
  'lsb:15:140000:6': 3.84,
  'lsb:15:140000:7': 3.84,
  'lsb:15:140000:8': 3.84,
  'lsb:15:140000:9': 3.84,
  'lsb:15:140000:10': 3.84,
  'lsb:15:140000:10': 4.02,
  'lsb:15:140000:11': 4.02,
  'lsb:15:140000:12': 4.02,
  'lsb:15:140000:13': 4.02,
  'lsb:15:140000:14': 4.02,
  'lsb:15:140000:15': 4.02,
  'lsb:15:140000:15': 4.46,
  'lsb:15:140000:16': 4.46,
  'lsb:15:140000:17': 4.46,
  'lsb:15:140000:18': 4.46,
  'lsb:15:140000:19': 4.46,
  'lsb:15:140000:20': 4.46,
  'lsb:15:140000:20': 5.44,
  'lsb:15:140000:21': 5.44,
  'lsb:15:140000:22': 5.44,
  'lsb:15:140000:23': 5.44,
  'lsb:15:140000:24': 5.44,
  'lsb:15:140000:25': 5.44,
  'lsb:15:140000:25': 7.24,
  'lsb:15:140000:26': 7.24,
  'lsb:15:140000:27': 7.24,
  'lsb:15:140000:28': 7.24,
  'lsb:15:140000:29': 7.24,
  'lsb:15:140000:30': 7.24,
  'lsb:15:140000:30': 10.39,
  'lsb:15:140000:31': 10.39,
  'lsb:15:140000:32': 10.39,
  'lsb:15:140000:33': 10.39,
  'lsb:15:140000:34': 10.39,
  'lsb:15:140000:35': 10.39,
  'lsb:15:140000:35': 15.88,
  'lsb:15:140000:36': 15.88,
  'lsb:15:140000:37': 15.88,
  'lsb:15:140000:38': 15.88,
  'lsb:15:140000:39': 15.88,
  'lsb:15:140000:40': 15.88,
  'lsb:15:140000:40': 25.23,
  'lsb:15:140000:41': 25.23,
  'lsb:15:140000:42': 25.23,
  'lsb:15:140000:43': 25.23,
  'lsb:15:140000:44': 25.23,
  'lsb:15:140000:45': 25.23,
  'lsb:15:140000:45': 40.14,
  'lsb:15:140000:46': 40.14,
  'lsb:15:140000:47': 40.14,
  'lsb:15:140000:48': 40.14,
  'lsb:15:140000:49': 40.14,
  'lsb:15:140000:50': 40.14,
  'lsb:15:140000:50': 62.4,
  'lsb:15:140000:51': 62.4,
  'lsb:15:140000:52': 62.4,
  'lsb:15:140000:53': 62.4,
  'lsb:15:140000:54': 62.4,
  'lsb:15:140000:55': 62.4,
  'lsb:15:140000:55': 92.67,
  'lsb:15:140000:56': 92.67,
  'lsb:15:140000:57': 92.67,
  'lsb:15:140000:58': 92.67,
  'lsb:15:140000:59': 92.67,
  'lsb:15:140000:60': 92.67,
  'lsb:15:140000:60': 136.35,
  'lsb:15:140000:61': 136.35,
  'lsb:15:140000:62': 136.35,
  'lsb:15:140000:63': 136.35,
  'lsb:15:140000:64': 136.35,
  'lsb:15:140000:65': 136.35,
  'lsb:15:160000:1': 4.33,
  'lsb:15:160000:2': 4.33,
  'lsb:15:160000:3': 4.33,
  'lsb:15:160000:4': 4.33,
  'lsb:15:160000:5': 4.33,
  'lsb:15:160000:5': 4.39,
  'lsb:15:160000:6': 4.39,
  'lsb:15:160000:7': 4.39,
  'lsb:15:160000:8': 4.39,
  'lsb:15:160000:9': 4.39,
  'lsb:15:160000:10': 4.39,
  'lsb:15:160000:10': 4.59,
  'lsb:15:160000:11': 4.59,
  'lsb:15:160000:12': 4.59,
  'lsb:15:160000:13': 4.59,
  'lsb:15:160000:14': 4.59,
  'lsb:15:160000:15': 4.59,
  'lsb:15:160000:15': 5.1,
  'lsb:15:160000:16': 5.1,
  'lsb:15:160000:17': 5.1,
  'lsb:15:160000:18': 5.1,
  'lsb:15:160000:19': 5.1,
  'lsb:15:160000:20': 5.1,
  'lsb:15:160000:20': 6.22,
  'lsb:15:160000:21': 6.22,
  'lsb:15:160000:22': 6.22,
  'lsb:15:160000:23': 6.22,
  'lsb:15:160000:24': 6.22,
  'lsb:15:160000:25': 6.22,
  'lsb:15:160000:25': 8.28,
  'lsb:15:160000:26': 8.28,
  'lsb:15:160000:27': 8.28,
  'lsb:15:160000:28': 8.28,
  'lsb:15:160000:29': 8.28,
  'lsb:15:160000:30': 8.28,
  'lsb:15:160000:30': 11.87,
  'lsb:15:160000:31': 11.87,
  'lsb:15:160000:32': 11.87,
  'lsb:15:160000:33': 11.87,
  'lsb:15:160000:34': 11.87,
  'lsb:15:160000:35': 11.87,
  'lsb:15:160000:35': 18.15,
  'lsb:15:160000:36': 18.15,
  'lsb:15:160000:37': 18.15,
  'lsb:15:160000:38': 18.15,
  'lsb:15:160000:39': 18.15,
  'lsb:15:160000:40': 18.15,
  'lsb:15:160000:40': 28.84,
  'lsb:15:160000:41': 28.84,
  'lsb:15:160000:42': 28.84,
  'lsb:15:160000:43': 28.84,
  'lsb:15:160000:44': 28.84,
  'lsb:15:160000:45': 28.84,
  'lsb:15:160000:45': 45.89,
  'lsb:15:160000:46': 45.89,
  'lsb:15:160000:47': 45.89,
  'lsb:15:160000:48': 45.89,
  'lsb:15:160000:49': 45.89,
  'lsb:15:160000:50': 45.89,
  'lsb:15:160000:50': 71.34,
  'lsb:15:160000:51': 71.34,
  'lsb:15:160000:52': 71.34,
  'lsb:15:160000:53': 71.34,
  'lsb:15:160000:54': 71.34,
  'lsb:15:160000:55': 71.34,
  'lsb:15:160000:55': 105.95,
  'lsb:15:160000:56': 105.95,
  'lsb:15:160000:57': 105.95,
  'lsb:15:160000:58': 105.95,
  'lsb:15:160000:59': 105.95,
  'lsb:15:160000:60': 105.95,
  'lsb:15:160000:60': 155.88,
  'lsb:15:160000:61': 155.88,
  'lsb:15:160000:62': 155.88,
  'lsb:15:160000:63': 155.88,
  'lsb:15:160000:64': 155.88,
  'lsb:15:160000:65': 155.88,
  'lsb:15:180000:1': 4.87,
  'lsb:15:180000:2': 4.87,
  'lsb:15:180000:3': 4.87,
  'lsb:15:180000:4': 4.87,
  'lsb:15:180000:5': 4.87,
  'lsb:15:180000:5': 4.94,
  'lsb:15:180000:6': 4.94,
  'lsb:15:180000:7': 4.94,
  'lsb:15:180000:8': 4.94,
  'lsb:15:180000:9': 4.94,
  'lsb:15:180000:10': 4.94,
  'lsb:15:180000:10': 5.17,
  'lsb:15:180000:11': 5.17,
  'lsb:15:180000:12': 5.17,
  'lsb:15:180000:13': 5.17,
  'lsb:15:180000:14': 5.17,
  'lsb:15:180000:15': 5.17,
  'lsb:15:180000:15': 5.74,
  'lsb:15:180000:16': 5.74,
  'lsb:15:180000:17': 5.74,
  'lsb:15:180000:18': 5.74,
  'lsb:15:180000:19': 5.74,
  'lsb:15:180000:20': 5.74,
  'lsb:15:180000:20': 7,
  'lsb:15:180000:21': 7,
  'lsb:15:180000:22': 7,
  'lsb:15:180000:23': 7,
  'lsb:15:180000:24': 7,
  'lsb:15:180000:25': 7,
  'lsb:15:180000:25': 9.31,
  'lsb:15:180000:26': 9.31,
  'lsb:15:180000:27': 9.31,
  'lsb:15:180000:28': 9.31,
  'lsb:15:180000:29': 9.31,
  'lsb:15:180000:30': 9.31,
  'lsb:15:180000:30': 13.36,
  'lsb:15:180000:31': 13.36,
  'lsb:15:180000:32': 13.36,
  'lsb:15:180000:33': 13.36,
  'lsb:15:180000:34': 13.36,
  'lsb:15:180000:35': 13.36,
  'lsb:15:180000:35': 20.42,
  'lsb:15:180000:36': 20.42,
  'lsb:15:180000:37': 20.42,
  'lsb:15:180000:38': 20.42,
  'lsb:15:180000:39': 20.42,
  'lsb:15:180000:40': 20.42,
  'lsb:15:180000:40': 32.45,
  'lsb:15:180000:41': 32.45,
  'lsb:15:180000:42': 32.45,
  'lsb:15:180000:43': 32.45,
  'lsb:15:180000:44': 32.45,
  'lsb:15:180000:45': 32.45,
  'lsb:15:180000:45': 51.63,
  'lsb:15:180000:46': 51.63,
  'lsb:15:180000:47': 51.63,
  'lsb:15:180000:48': 51.63,
  'lsb:15:180000:49': 51.63,
  'lsb:15:180000:50': 51.63,
  'lsb:15:180000:50': 80.27,
  'lsb:15:180000:51': 80.27,
  'lsb:15:180000:52': 80.27,
  'lsb:15:180000:53': 80.27,
  'lsb:15:180000:54': 80.27,
  'lsb:15:180000:55': 80.27,
  'lsb:15:180000:55': 119.2,
  'lsb:15:180000:56': 119.2,
  'lsb:15:180000:57': 119.2,
  'lsb:15:180000:58': 119.2,
  'lsb:15:180000:59': 119.2,
  'lsb:15:180000:60': 119.2,
  'lsb:15:180000:60': 175.39,
  'lsb:15:180000:61': 175.39,
  'lsb:15:180000:62': 175.39,
  'lsb:15:180000:63': 175.39,
  'lsb:15:180000:64': 175.39,
  'lsb:15:180000:65': 175.39,
  'lsb:15:200000:1': 5.4,
  'lsb:15:200000:2': 5.4,
  'lsb:15:200000:3': 5.4,
  'lsb:15:200000:4': 5.4,
  'lsb:15:200000:5': 5.4,
  'lsb:15:200000:5': 5.48,
  'lsb:15:200000:6': 5.48,
  'lsb:15:200000:7': 5.48,
  'lsb:15:200000:8': 5.48,
  'lsb:15:200000:9': 5.48,
  'lsb:15:200000:10': 5.48,
  'lsb:15:200000:10': 5.73,
  'lsb:15:200000:11': 5.73,
  'lsb:15:200000:12': 5.73,
  'lsb:15:200000:13': 5.73,
  'lsb:15:200000:14': 5.73,
  'lsb:15:200000:15': 5.73,
  'lsb:15:200000:15': 6.37,
  'lsb:15:200000:16': 6.37,
  'lsb:15:200000:17': 6.37,
  'lsb:15:200000:18': 6.37,
  'lsb:15:200000:19': 6.37,
  'lsb:15:200000:20': 6.37,
  'lsb:15:200000:20': 7.77,
  'lsb:15:200000:21': 7.77,
  'lsb:15:200000:22': 7.77,
  'lsb:15:200000:23': 7.77,
  'lsb:15:200000:24': 7.77,
  'lsb:15:200000:25': 7.77,
  'lsb:15:200000:25': 10.34,
  'lsb:15:200000:26': 10.34,
  'lsb:15:200000:27': 10.34,
  'lsb:15:200000:28': 10.34,
  'lsb:15:200000:29': 10.34,
  'lsb:15:200000:30': 10.34,
  'lsb:15:200000:30': 14.83,
  'lsb:15:200000:31': 14.83,
  'lsb:15:200000:32': 14.83,
  'lsb:15:200000:33': 14.83,
  'lsb:15:200000:34': 14.83,
  'lsb:15:200000:35': 14.83,
  'lsb:15:200000:35': 22.67,
  'lsb:15:200000:36': 22.67,
  'lsb:15:200000:37': 22.67,
  'lsb:15:200000:38': 22.67,
  'lsb:15:200000:39': 22.67,
  'lsb:15:200000:40': 22.67,
  'lsb:15:200000:40': 36.02,
  'lsb:15:200000:41': 36.02,
  'lsb:15:200000:42': 36.02,
  'lsb:15:200000:43': 36.02,
  'lsb:15:200000:44': 36.02,
  'lsb:15:200000:45': 36.02,
  'lsb:15:200000:45': 57.3,
  'lsb:15:200000:46': 57.3,
  'lsb:15:200000:47': 57.3,
  'lsb:15:200000:48': 57.3,
  'lsb:15:200000:49': 57.3,
  'lsb:15:200000:50': 57.3,
  'lsb:15:200000:50': 89.09,
  'lsb:15:200000:51': 89.09,
  'lsb:15:200000:52': 89.09,
  'lsb:15:200000:53': 89.09,
  'lsb:15:200000:54': 89.09,
  'lsb:15:200000:55': 89.09,
  'lsb:15:200000:55': 132.29,
  'lsb:15:200000:56': 132.29,
  'lsb:15:200000:57': 132.29,
  'lsb:15:200000:58': 132.29,
  'lsb:15:200000:59': 132.29,
  'lsb:15:200000:60': 132.29,
  'lsb:15:200000:60': 194.63,
  'lsb:15:200000:61': 194.63,
  'lsb:15:200000:62': 194.63,
  'lsb:15:200000:63': 194.63,
  'lsb:15:200000:64': 194.63,
  'lsb:15:200000:65': 194.63,
  'pab:15:10000:18': 0.17,
  'pab:15:10000:19': 0.17,
  'pab:15:10000:20': 0.17,
  'pab:15:10000:21': 0.17,
  'pab:15:10000:22': 0.17,
  'pab:15:10000:23': 0.17,
  'pab:15:10000:24': 0.17,
  'pab:15:10000:25': 0.17,
  'pab:15:10000:26': 0.22,
  'pab:15:10000:27': 0.22,
  'pab:15:10000:28': 0.22,
  'pab:15:10000:29': 0.22,
  'pab:15:10000:30': 0.22,
  'pab:15:10000:31': 0.23,
  'pab:15:10000:32': 0.23,
  'pab:15:10000:33': 0.23,
  'pab:15:10000:34': 0.23,
  'pab:15:10000:35': 0.23,
  'pab:15:10000:36': 0.25,
  'pab:15:10000:37': 0.25,
  'pab:15:10000:38': 0.25,
  'pab:15:10000:39': 0.25,
  'pab:15:10000:40': 0.25,
  'pab:15:10000:41': 0.32,
  'pab:15:10000:42': 0.32,
  'pab:15:10000:43': 0.32,
  'pab:15:10000:44': 0.32,
  'pab:15:10000:45': 0.32,
  'pab:15:10000:46': 0.43,
  'pab:15:10000:47': 0.43,
  'pab:15:10000:48': 0.43,
  'pab:15:10000:49': 0.43,
  'pab:15:10000:50': 0.43,
  'pab:15:10000:51': 0.64,
  'pab:15:10000:52': 0.64,
  'pab:15:10000:53': 0.64,
  'pab:15:10000:54': 0.64,
  'pab:15:10000:55': 0.64,
  'pab:15:10000:56': 0.94,
  'pab:15:10000:57': 0.94,
  'pab:15:10000:58': 0.94,
  'pab:15:10000:59': 0.94,
  'pab:15:20000:18': 0.35,
  'pab:15:20000:19': 0.35,
  'pab:15:20000:20': 0.35,
  'pab:15:20000:21': 0.35,
  'pab:15:20000:22': 0.35,
  'pab:15:20000:23': 0.35,
  'pab:15:20000:24': 0.35,
  'pab:15:20000:25': 0.35,
  'pab:15:20000:26': 0.43,
  'pab:15:20000:27': 0.43,
  'pab:15:20000:28': 0.43,
  'pab:15:20000:29': 0.43,
  'pab:15:20000:30': 0.43,
  'pab:15:20000:31': 0.46,
  'pab:15:20000:32': 0.46,
  'pab:15:20000:33': 0.46,
  'pab:15:20000:34': 0.46,
  'pab:15:20000:35': 0.46,
  'pab:15:20000:36': 0.5,
  'pab:15:20000:37': 0.5,
  'pab:15:20000:38': 0.5,
  'pab:15:20000:39': 0.5,
  'pab:15:20000:40': 0.5,
  'pab:15:20000:41': 0.63,
  'pab:15:20000:42': 0.63,
  'pab:15:20000:43': 0.63,
  'pab:15:20000:44': 0.63,
  'pab:15:20000:45': 0.63,
  'pab:15:20000:46': 0.86,
  'pab:15:20000:47': 0.86,
  'pab:15:20000:48': 0.86,
  'pab:15:20000:49': 0.86,
  'pab:15:20000:50': 0.86,
  'pab:15:20000:51': 1.27,
  'pab:15:20000:52': 1.27,
  'pab:15:20000:53': 1.27,
  'pab:15:20000:54': 1.27,
  'pab:15:20000:55': 1.27,
  'pab:15:20000:56': 1.89,
  'pab:15:20000:57': 1.89,
  'pab:15:20000:58': 1.89,
  'pab:15:20000:59': 1.89,
  'pab:15:30000:18': 0.52,
  'pab:15:30000:19': 0.52,
  'pab:15:30000:20': 0.52,
  'pab:15:30000:21': 0.52,
  'pab:15:30000:22': 0.52,
  'pab:15:30000:23': 0.52,
  'pab:15:30000:24': 0.52,
  'pab:15:30000:25': 0.52,
  'pab:15:30000:26': 0.65,
  'pab:15:30000:27': 0.65,
  'pab:15:30000:28': 0.65,
  'pab:15:30000:29': 0.65,
  'pab:15:30000:30': 0.65,
  'pab:15:30000:31': 0.69,
  'pab:15:30000:32': 0.69,
  'pab:15:30000:33': 0.69,
  'pab:15:30000:34': 0.69,
  'pab:15:30000:35': 0.69,
  'pab:15:30000:36': 0.75,
  'pab:15:30000:37': 0.75,
  'pab:15:30000:38': 0.75,
  'pab:15:30000:39': 0.75,
  'pab:15:30000:40': 0.75,
  'pab:15:30000:41': 0.94,
  'pab:15:30000:42': 0.94,
  'pab:15:30000:43': 0.94,
  'pab:15:30000:44': 0.94,
  'pab:15:30000:45': 0.94,
  'pab:15:30000:46': 1.29,
  'pab:15:30000:47': 1.29,
  'pab:15:30000:48': 1.29,
  'pab:15:30000:49': 1.29,
  'pab:15:30000:50': 1.29,
  'pab:15:30000:51': 1.91,
  'pab:15:30000:52': 1.91,
  'pab:15:30000:53': 1.91,
  'pab:15:30000:54': 1.91,
  'pab:15:30000:55': 1.91,
  'pab:15:30000:56': 2.83,
  'pab:15:30000:57': 2.83,
  'pab:15:30000:58': 2.83,
  'pab:15:30000:59': 2.83,
  'pab:15:40000:18': 0.69,
  'pab:15:40000:19': 0.69,
  'pab:15:40000:20': 0.69,
  'pab:15:40000:21': 0.69,
  'pab:15:40000:22': 0.69,
  'pab:15:40000:23': 0.69,
  'pab:15:40000:24': 0.69,
  'pab:15:40000:25': 0.69,
  'pab:15:40000:26': 0.86,
  'pab:15:40000:27': 0.86,
  'pab:15:40000:28': 0.86,
  'pab:15:40000:29': 0.86,
  'pab:15:40000:30': 0.86,
  'pab:15:40000:31': 0.92,
  'pab:15:40000:32': 0.92,
  'pab:15:40000:33': 0.92,
  'pab:15:40000:34': 0.92,
  'pab:15:40000:35': 0.92,
  'pab:15:40000:36': 1,
  'pab:15:40000:37': 1,
  'pab:15:40000:38': 1,
  'pab:15:40000:39': 1,
  'pab:15:40000:40': 1,
  'pab:15:40000:41': 1.26,
  'pab:15:40000:42': 1.26,
  'pab:15:40000:43': 1.26,
  'pab:15:40000:44': 1.26,
  'pab:15:40000:45': 1.26,
  'pab:15:40000:46': 1.72,
  'pab:15:40000:47': 1.72,
  'pab:15:40000:48': 1.72,
  'pab:15:40000:49': 1.72,
  'pab:15:40000:50': 1.72,
  'pab:15:40000:51': 2.54,
  'pab:15:40000:52': 2.54,
  'pab:15:40000:53': 2.54,
  'pab:15:40000:54': 2.54,
  'pab:15:40000:55': 2.54,
  'pab:15:40000:56': 3.78,
  'pab:15:40000:57': 3.78,
  'pab:15:40000:58': 3.78,
  'pab:15:40000:59': 3.78,
  'pab:15:50000:18': 0.86,
  'pab:15:50000:19': 0.86,
  'pab:15:50000:20': 0.86,
  'pab:15:50000:21': 0.86,
  'pab:15:50000:22': 0.86,
  'pab:15:50000:23': 0.86,
  'pab:15:50000:24': 0.86,
  'pab:15:50000:25': 0.86,
  'pab:15:50000:26': 1.08,
  'pab:15:50000:27': 1.08,
  'pab:15:50000:28': 1.08,
  'pab:15:50000:29': 1.08,
  'pab:15:50000:30': 1.08,
  'pab:15:50000:31': 1.15,
  'pab:15:50000:32': 1.15,
  'pab:15:50000:33': 1.15,
  'pab:15:50000:34': 1.15,
  'pab:15:50000:35': 1.15,
  'pab:15:50000:36': 1.25,
  'pab:15:50000:37': 1.25,
  'pab:15:50000:38': 1.25,
  'pab:15:50000:39': 1.25,
  'pab:15:50000:40': 1.25,
  'pab:15:50000:41': 1.57,
  'pab:15:50000:42': 1.57,
  'pab:15:50000:43': 1.57,
  'pab:15:50000:44': 1.57,
  'pab:15:50000:45': 1.57,
  'pab:15:50000:46': 2.15,
  'pab:15:50000:47': 2.15,
  'pab:15:50000:48': 2.15,
  'pab:15:50000:49': 2.15,
  'pab:15:50000:50': 2.15,
  'pab:15:50000:51': 3.18,
  'pab:15:50000:52': 3.18,
  'pab:15:50000:53': 3.18,
  'pab:15:50000:54': 3.18,
  'pab:15:50000:55': 3.18,
  'pab:15:50000:56': 4.72,
  'pab:15:50000:57': 4.72,
  'pab:15:50000:58': 4.72,
  'pab:15:50000:59': 4.72,
}
